
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8V2Yz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "CmdbObjecV2ViewOld", () => $cef47f788c6af7ff$export$27d913c1886c58c1);
$parcel$export(module.exports, "CmdbObjecV2View", () => $cef47f788c6af7ff$export$e126c18036dd177d);
$parcel$export(module.exports, "ConditionalRedirectOrRouteView", () => $cef47f788c6af7ff$export$8f126bd42a3e2335);
$parcel$export(module.exports, "default", () => $cef47f788c6af7ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bzlbR = parcelRequire("bzlbR");

var $e9YVH = parcelRequire("e9YVH");

var $aROOn = parcelRequire("aROOn");

var $5EeMY = parcelRequire("5EeMY");

var $5Ny9E = parcelRequire("5Ny9E");

var $blEB6 = parcelRequire("blEB6");

var $6GLlD = parcelRequire("6GLlD");

var $ivzw9 = parcelRequire("ivzw9");

var $l8ruj = parcelRequire("l8ruj");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");
var $doZTA = parcelRequire("doZTA");

var $6vorJ = parcelRequire("6vorJ");

var $9OmMD = parcelRequire("9OmMD");
const $cef47f788c6af7ff$export$27d913c1886c58c1 = ()=>{
    const noop = ()=>undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "cmdb-object"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GLlD.default), {
        appName: (0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_VIEW
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivzw9.InsightAppBaseV2), null, ({ workspaceId: workspaceId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OmMD.FullPageObjectViewWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6vorJ.InsightObjectViewPageContainer), null, ({ prefetchData: prefetchData, objectId: objectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5EeMY.default), {
                context: (0, $aROOn.ObjectDetailsRenderingContext).Page,
                objectId: objectId,
                workspaceId: workspaceId,
                initialObjectDetailsData: prefetchData,
                redirectOnDelete: true,
                onUpdate: noop,
                onDelete: noop,
                onClone: noop
            }))))));
};
const $cef47f788c6af7ff$export$e126c18036dd177d = ()=>{
    const noop = ()=>undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "cmdb-object"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GLlD.default), {
        appName: (0, $e9YVH.APP_NAMES).INSIGHT_OBJECT_VIEW
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivzw9.InsightAppBaseV2), null, ({ workspaceId: workspaceId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OmMD.FullPageObjectViewWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6vorJ.InsightObjectViewPageContainer), null, ({ prefetchData: prefetchData, objectId: objectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bzlbR.CmdbAsyncActionsContainer), {
                workspaceId: workspaceId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5EeMY.default), {
                context: (0, $aROOn.ObjectDetailsRenderingContext).Page,
                objectId: objectId,
                workspaceId: workspaceId,
                initialObjectDetailsData: prefetchData,
                redirectOnDelete: true,
                onUpdate: noop,
                onDelete: noop,
                onClone: noop
            })))))));
};
const $cef47f788c6af7ff$export$8f126bd42a3e2335 = ()=>{
    const [objectId] = (0, $bmKPg.usePathParam)('objectId');
    const [{ location: location, route: route }] = (0, $doZTA.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if ((0, $blEB6.isInsightRoute)(location.pathname) && objectId) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
            action: 'redirected',
            actionSubject: 'routeView'
        }), 'jsmCmdbAssetsRouteRedirect object', {
            redirectedFrom: route.path,
            redirectedTo: `${(0, $blEB6.getRootPath)()}/object/:objectId`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: (0, $blEB6.createObjectDetailUrl)((0, $5Ny9E.toCmdbObjectId)(objectId))
        });
    }
    return (0, $4R6GH.fg)('assets_rearch_async_actions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cef47f788c6af7ff$export$e126c18036dd177d, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cef47f788c6af7ff$export$27d913c1886c58c1, null);
};
var $cef47f788c6af7ff$export$2e2bcd8739ae039 = $cef47f788c6af7ff$export$8f126bd42a3e2335;

});
parcelRegister("bzlbR", function(module, exports) {

$parcel$export(module.exports, "CmdbAsyncActionsContainer", () => $258ba00e46975356$export$43fcf5148d300a7a);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $fAfhm = parcelRequire("fAfhm");
const $258ba00e46975356$export$43fcf5148d300a7a = ({ workspaceId: workspaceId, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "CmdbAsyncActions",
        packageName: "jiraServicedeskCmdbAsyncActions",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fAfhm.CmdbAsyncActionsStoreContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent,
        showFlag: showFlag,
        dismissFlag: dismissFlag,
        formatMessage: formatMessage
    }, children));
};

});
parcelRegister("fAfhm", function(module, exports) {

$parcel$export(module.exports, "CmdbAsyncActionsStoreContainer", () => $3a5792d3cb9ea101$export$e6bd8f42407e77f7);
$parcel$export(module.exports, "useCmdbAsyncBulkEdit", () => $3a5792d3cb9ea101$export$95dcd216f519a772);
$parcel$export(module.exports, "useCmdbAsyncBulkQrCode", () => $3a5792d3cb9ea101$export$e5e9cc568fb5dd9);
$parcel$export(module.exports, "useCmdbAsyncActions", () => $3a5792d3cb9ea101$export$b7f849aee72f4fd6);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $eOSXz = parcelRequire("eOSXz");

var $564bj = parcelRequire("564bj");

var $2xnjS = parcelRequire("2xnjS");
const $3a5792d3cb9ea101$export$d4c72bab9d6cc13a = {
    isPolling: false,
    // Stores reference to the reject function of the polling promise so we can cancel it externally
    pollingReject: undefined,
    pollingTimeoutIds: undefined,
    tasks: undefined,
    bulkDelete: {
        isSubmitting: false
    },
    bulkEdit: {
        isSubmitting: false
    },
    bulkExport: {
        isSubmitting: false
    },
    bulkQrCode: {
        isSubmitting: false
    },
    isDismissing: []
};
const $3a5792d3cb9ea101$var$store = (0, $iXqE5.createStore)({
    initialState: $3a5792d3cb9ea101$export$d4c72bab9d6cc13a,
    actions: $eOSXz.actions
});
const $3a5792d3cb9ea101$export$e6bd8f42407e77f7 = (0, $gg7kZ.createContainer)($3a5792d3cb9ea101$var$store, {
    onInit: (0, $2xnjS.fetchInitialTasks),
    onCleanup: (0, $564bj.cancelPolling)
});
const $3a5792d3cb9ea101$export$e6aa8ccef89c70b4 = (0, $3sQ5x.createHook)($3a5792d3cb9ea101$var$store);
const $3a5792d3cb9ea101$export$eab033628dba127a = (0, $3sQ5x.createHook)($3a5792d3cb9ea101$var$store, {
    selector: ({ bulkDelete: bulkDelete })=>bulkDelete
});
const $3a5792d3cb9ea101$export$95dcd216f519a772 = (0, $3sQ5x.createHook)($3a5792d3cb9ea101$var$store, {
    selector: ({ bulkEdit: bulkEdit })=>bulkEdit
});
const $3a5792d3cb9ea101$export$77f3a7125c3728e0 = (0, $3sQ5x.createHook)($3a5792d3cb9ea101$var$store, {
    selector: ({ bulkExport: bulkExport })=>bulkExport
});
const $3a5792d3cb9ea101$export$e5e9cc568fb5dd9 = (0, $3sQ5x.createHook)($3a5792d3cb9ea101$var$store, {
    selector: ({ bulkQrCode: bulkQrCode })=>bulkQrCode
});
const $3a5792d3cb9ea101$export$b7f849aee72f4fd6 = (0, $3sQ5x.createActionsHook)($3a5792d3cb9ea101$var$store);

});
parcelRegister("eOSXz", function(module, exports) {

$parcel$export(module.exports, "actions", () => $6017372c86063979$export$e324594224ef24da);

var $5C9BP = parcelRequire("5C9BP");

var $cw6qU = parcelRequire("cw6qU");

var $2yc90 = parcelRequire("2yc90");

var $iZKRA = parcelRequire("iZKRA");
const $6017372c86063979$export$e324594224ef24da = {
    submitBulkExportTask: $2yc90.submitBulkExportTask,
    submitBulkQrCodeTask: $iZKRA.submitBulkQrCodeTask,
    submitBulkDeleteTask: $5C9BP.submitBulkDeleteTask,
    submitBulkEditTask: $cw6qU.submitBulkEditTask
};

});
parcelRegister("5C9BP", function(module, exports) {

$parcel$export(module.exports, "submitBulkDeleteTask", () => $53175569f6f3e8c7$export$d381dd6d470705e9);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $iRdzc = parcelRequire("iRdzc");

var $fmoqT = parcelRequire("fmoqT");

var $gpISd = parcelRequire("gpISd");

var $lNC72 = parcelRequire("lNC72");

var $kYIR2 = parcelRequire("kYIR2");

var $fTrfQ = parcelRequire("fTrfQ");
const $53175569f6f3e8c7$export$d381dd6d470705e9 = ({ objectCount: objectCount, ...body })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().bulkDelete.isSubmitting) return;
        setState({
            bulkDelete: {
                isSubmitting: true
            }
        });
        try {
            const { taskId: taskId } = await (0, $gpISd.createAsyncBulkDeleteTask)(workspaceId, {
                ...body
            });
            setState({
                tasks: (0, $fmoqT.mergeTasks)(getState().tasks, [
                    {
                        taskId: taskId,
                        operationType: (0, $iRdzc.OPERATION_TYPE_BULK_DELETE),
                        status: (0, $iRdzc.STATUS_QUEUED)
                    }
                ]),
                bulkDelete: {
                    isSubmitting: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'submitAsyncBulkDeleteTask succeeded');
            dispatch((0, $kYIR2.showSuccessFlag)({
                id: taskId,
                objectCount: objectCount,
                action: (0, $iRdzc.OPERATION_TYPE_BULK_DELETE)
            }));
            dispatch((0, $fTrfQ.startTaskPolling)());
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'submitAsyncBulkDeleteTask',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
            setState({
                bulkDelete: {
                    isSubmitting: false
                }
            });
            dispatch((0, $lNC72.showErrorFlag)({
                action: (0, $iRdzc.OPERATION_TYPE_BULK_DELETE),
                objectCount: objectCount
            }));
            throw error;
        }
    };

});
parcelRegister("iRdzc", function(module, exports) {

$parcel$export(module.exports, "OPERATION_TYPE_BULK_EDIT", () => $1ee808f0bfcaa90a$export$c4a0fd6df07697e9);
$parcel$export(module.exports, "OPERATION_TYPE_BULK_DELETE", () => $1ee808f0bfcaa90a$export$940d318e182226db);
$parcel$export(module.exports, "OPERATION_TYPE_BULK_EXPORT", () => $1ee808f0bfcaa90a$export$c331466741bc25dd);
$parcel$export(module.exports, "OPERATION_TYPE_BULK_QR_CODE", () => $1ee808f0bfcaa90a$export$ac103f1dc164db47);
$parcel$export(module.exports, "STATUS_QUEUED", () => $1ee808f0bfcaa90a$export$5151c63487c6074a);
$parcel$export(module.exports, "STATUS_COMPLETED", () => $1ee808f0bfcaa90a$export$81f34347d5a84d5f);
const $1ee808f0bfcaa90a$export$c4a0fd6df07697e9 = 'BulkEdit';
const $1ee808f0bfcaa90a$export$940d318e182226db = 'BulkDelete';
const $1ee808f0bfcaa90a$export$c331466741bc25dd = 'BulkExport';
const $1ee808f0bfcaa90a$export$ac103f1dc164db47 = 'QrCode';
const $1ee808f0bfcaa90a$export$5151c63487c6074a = 'Queued';
const $1ee808f0bfcaa90a$export$f1c7e78b7edcac86 = 'InProgress';
const $1ee808f0bfcaa90a$export$81f34347d5a84d5f = 'Completed';
const $1ee808f0bfcaa90a$export$d4ce95d919eced6d = 'Archived';
const $1ee808f0bfcaa90a$export$7ee58d019dd6dcbe = (id)=>id;

});

parcelRegister("fmoqT", function(module, exports) {

$parcel$export(module.exports, "mergeTasks", () => $9809f166e6f25c7e$export$e574549178e429d1);
const $9809f166e6f25c7e$export$e574549178e429d1 = (existingTasks, newTasks)=>{
    const taskMap = new Map();
    (existingTasks ?? []).forEach((item)=>taskMap.set(item.taskId, item));
    (newTasks ?? []).forEach((item)=>taskMap.set(item.taskId, {
            ...taskMap.get(item.taskId),
            ...item
        }));
    return Array.from(taskMap.values());
};

});

parcelRegister("gpISd", function(module, exports) {

$parcel$export(module.exports, "createAsyncBulkDeleteTask", () => $89badbed27fd1383$export$bc219e67a7d1e34);

var $4VpwK = parcelRequire("4VpwK");

var $eJOOa = parcelRequire("eJOOa");
const $89badbed27fd1383$export$bc219e67a7d1e34 = (workspaceId, params)=>(0, $4VpwK.performCmdbPostRequest)((0, $eJOOa.getCmdbAsyncBulkDeleteUrl)(workspaceId), {
        body: JSON.stringify(params)
    });

});

parcelRegister("lNC72", function(module, exports) {

$parcel$export(module.exports, "showErrorFlag", () => $7b3e1e8e73749b52$export$dfa2148cdb92917d);

var $24ov5 = parcelRequire("24ov5");

var $lASGq = parcelRequire("lASGq");
const $7b3e1e8e73749b52$export$dfa2148cdb92917d = ({ objectCount: objectCount, action: action })=>async (_, { showFlag: showFlag, formatMessage: formatMessage })=>{
        showFlag({
            type: 'error',
            title: formatMessage((0, $24ov5.matchTaskOperationType)(action, {
                BulkExport: ()=>(0, $lASGq.default).submitErrorFlagTitleBulkExport,
                QrCode: ()=>(0, $lASGq.default).submitErrorFlagTitleBulkQrCode,
                BulkEdit: ()=>(0, $lASGq.default).submitErrorFlagTitleBulkEdit,
                BulkDelete: ()=>(0, $lASGq.default).submitErrorFlagTitleBulkDelete
            }), {
                objectCount: objectCount
            }),
            description: formatMessage((0, $lASGq.default).submitErrorFlagDescription)
        });
    };

});
parcelRegister("24ov5", function(module, exports) {

$parcel$export(module.exports, "matchTaskByOperationType", () => $78b76af4281c1cd8$export$510ebc46a739e819);
$parcel$export(module.exports, "matchTaskOperationType", () => $78b76af4281c1cd8$export$cf557b9c27a92ef6);
$parcel$export(module.exports, "matchResultsModalTaskByOperationType", () => $78b76af4281c1cd8$export$2f361ae89fd2f09);

var $iRdzc = parcelRequire("iRdzc");
const $78b76af4281c1cd8$var$throwUnknownOperationType = (operationType)=>{
    throw new Error(`Unknown operation type: ${operationType}`);
};
const $78b76af4281c1cd8$export$510ebc46a739e819 = (task, handlers)=>{
    const operationType = task.operationType;
    switch(operationType){
        case 0, $iRdzc.OPERATION_TYPE_BULK_EDIT:
            // Unfortunately typescript doesn't support narrowing on generics, but this is valid as T extends Task
            // @ts-expect-error - TS2345 - Argument of type 'T' is not assignable to parameter of type 'Extract<T, { operationType: "BulkEdit"; }>'. Type 'Task' is not assignable to type 'Extract<T, { operationType: "BulkEdit"; }>'. Type 'BaseTask & { operationType: "BulkEdit"; } & { status: "Queued" | "InProgress"; }' is not assignable to type 'Extract<T, { operationType: "BulkEdit"; }>'
            return handlers.BulkEdit(task);
        case 0, $iRdzc.OPERATION_TYPE_BULK_DELETE:
            // Unfortunately typescript doesn't support narrowing on generics, but this is valid as T extends Task
            // @ts-expect-error - TS2345 - Argument of type 'T' is not assignable to parameter of type 'Extract<T, { operationType: "BulkDelete"; }>'. Type 'Task' is not assignable to type 'Extract<T, { operationType: "BulkDelete"; }>'. Type 'BaseTask & { operationType: "BulkDelete"; } & { status: "Queued" | "InProgress"; }' is not assignable to type 'Extract<T, { operationType: "BulkDelete"; }>'
            return handlers.BulkDelete(task);
        case 0, $iRdzc.OPERATION_TYPE_BULK_EXPORT:
            // Unfortunately typescript doesn't support narrowing on generics, but this is valid as T extends Task
            // @ts-expect-error - TS2345 - Argument of type 'T' is not assignable to parameter of type 'Extract<T, { operationType: "BulkExport"; }>'. Type 'Task' is not assignable to type 'Extract<T, { operationType: "BulkExport"; }>'. Type 'BaseTask & { operationType: "BulkExport"; } & { status: "Queued" | "InProgress"; }' is not assignable to type 'Extract<T, { operationType: "BulkExport"; }>'
            return handlers.BulkExport(task);
        case 0, $iRdzc.OPERATION_TYPE_BULK_QR_CODE:
            // Unfortunately typescript doesn't support narrowing on generics, but this is valid as T extends Task
            // @ts-expect-error - TS2345 - Argument of type 'T' is not assignable to parameter of type 'Extract<T, { operationType: "QrCode"; }>'. Type 'Task' is not assignable to type 'Extract<T, { operationType: "QrCode"; }>'. Type 'BaseTask & { operationType: "QrCode"; } & { status: "Queued" | "InProgress"; }' is not assignable to type 'Extract<T, { operationType: "QrCode"; }>'
            return handlers.QrCode(task);
        default:
            return $78b76af4281c1cd8$var$throwUnknownOperationType(operationType);
    }
};
const $78b76af4281c1cd8$export$cf557b9c27a92ef6 = (operationType, handlers)=>{
    switch(operationType){
        case 0, $iRdzc.OPERATION_TYPE_BULK_EDIT:
            return handlers.BulkEdit();
        case 0, $iRdzc.OPERATION_TYPE_BULK_DELETE:
            return handlers.BulkDelete();
        case 0, $iRdzc.OPERATION_TYPE_BULK_EXPORT:
            return handlers.BulkExport();
        case 0, $iRdzc.OPERATION_TYPE_BULK_QR_CODE:
            return handlers.QrCode();
        default:
            return $78b76af4281c1cd8$var$throwUnknownOperationType(operationType);
    }
};
const $78b76af4281c1cd8$export$2f361ae89fd2f09 = (task, handlers)=>{
    const operationType = task.operationType;
    switch(operationType){
        case 0, $iRdzc.OPERATION_TYPE_BULK_EDIT:
            // Unfortunately typescript doesn't support narrowing on generics, but this is valid as T extends Task
            // @ts-expect-error - TS2345 - Argument of type 'T' is not assignable to parameter of type 'Extract<T, { operationType: "BulkDelete"; }>'. Type 'ResultsModalTask' is not assignable to type 'Extract<T, { operationType: "BulkDelete"; }>'. Type 'BaseTask & OperationType<"BulkDelete"> & Status<"Completed"> & ResultPayload<ObjectResultPayload>' is not assignable to type 'Extract<T, { operationType: "BulkDelete"; }>'.
            return handlers.BulkEdit(task);
        case 0, $iRdzc.OPERATION_TYPE_BULK_DELETE:
            // Unfortunately typescript doesn't support narrowing on generics, but this is valid as T extends Task
            // @ts-expect-error - TS2345 - Argument of type 'T' is not assignable to parameter of type 'Extract<T, { operationType: "BulkDelete"; }>'. Type 'ResultsModalTask' is not assignable to type 'Extract<T, { operationType: "BulkDelete"; }>'. Type 'BaseTask & OperationType<"BulkDelete"> & Status<"Completed"> & ResultPayload<ObjectResultPayload>' is not assignable to type 'Extract<T, { operationType: "BulkDelete"; }>'.
            return handlers.BulkDelete(task);
        default:
            return $78b76af4281c1cd8$var$throwUnknownOperationType(operationType);
    }
};

});

parcelRegister("lASGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7c66f7d510213b1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e7c66f7d510213b1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    submitSuccessFlagTitleBulkExport: {
        "id": "servicedesk-cmdb-async-actions.common.submit-success-flag-title-bulk-export",
        "defaultMessage": "Action started: Export {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitSuccessFlagTitleBulkQrCode: {
        "id": "servicedesk-cmdb-async-actions.common.submit-success-flag-title-bulk-qr-code",
        "defaultMessage": "Action started: Print QR code for {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitSuccessFlagTitleBulkDelete: {
        "id": "servicedesk-cmdb-async-actions.common.submit-success-flag-title-bulk-delete",
        "defaultMessage": "Action started: Delete {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitSuccessFlagTitleBulkEdit: {
        "id": "servicedesk-cmdb-async-actions.common.submit-success-flag-title-bulk-edit",
        "defaultMessage": "Action started: Edit {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitSuccessFlagDescription: {
        "id": "servicedesk-cmdb-async-actions.common.submit-success-flag-description",
        "defaultMessage": "This action may take a while. You will receive a notification once the work is complete."
    },
    submitErrorFlagTitleBulkExport: {
        "id": "servicedesk-cmdb-async-actions.common.submit-error-flag-title-bulk-export",
        "defaultMessage": "Action failed: Export {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitErrorFlagTitleBulkQrCode: {
        "id": "servicedesk-cmdb-async-actions.common.submit-error-flag-title-bulk-qr-code",
        "defaultMessage": "Action failed: Print QR code for {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitErrorFlagTitleBulkDelete: {
        "id": "servicedesk-cmdb-async-actions.common.submit-error-flag-title-bulk-delete",
        "defaultMessage": "Action failed: Delete {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitErrorFlagTitleBulkEdit: {
        "id": "servicedesk-cmdb-async-actions.common.submit-error-flag-title-bulk-edit",
        "defaultMessage": "Action failed: Edit {objectCount, plural, one{{objectCount} object} other{{objectCount} objects}}"
    },
    submitErrorFlagDescription: {
        "id": "servicedesk-cmdb-async-actions.common.submit-error-flag-description",
        "defaultMessage": "Please check your network and try again"
    }
});

});


parcelRegister("kYIR2", function(module, exports) {

$parcel$export(module.exports, "showSuccessFlag", () => $0fccdcf8dec0c533$export$fef8478a2c810f18);

var $5uXOq = parcelRequire("5uXOq");

var $75Jbm = parcelRequire("75Jbm");

var $24ov5 = parcelRequire("24ov5");

var $lASGq = parcelRequire("lASGq");
const $0fccdcf8dec0c533$export$fef8478a2c810f18 = ({ id: id, objectCount: objectCount, action: action })=>async (_, { showFlag: showFlag, formatMessage: formatMessage })=>{
        showFlag({
            id: id,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($75Jbm))), {
                label: ""
            }),
            type: 'info',
            title: formatMessage((0, $24ov5.matchTaskOperationType)(action, {
                BulkExport: ()=>(0, $lASGq.default).submitSuccessFlagTitleBulkExport,
                QrCode: ()=>(0, $lASGq.default).submitSuccessFlagTitleBulkQrCode,
                BulkEdit: ()=>(0, $lASGq.default).submitSuccessFlagTitleBulkEdit,
                BulkDelete: ()=>(0, $lASGq.default).submitSuccessFlagTitleBulkDelete
            }), {
                objectCount: objectCount
            }),
            description: formatMessage((0, $lASGq.default).submitSuccessFlagDescription)
        });
    };

});
parcelRegister("75Jbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $529c0c456318696f$var$_react = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $529c0c456318696f$var$_refresh = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("gPelT")));
function $529c0c456318696f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $529c0c456318696f$var$RefreshIcon = (props)=>/*#__PURE__*/ $529c0c456318696f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $529c0c456318696f$var$_refresh.default
    }));
$529c0c456318696f$var$RefreshIcon.displayName = 'RefreshIcon';
var $529c0c456318696f$var$_default = module.exports.default = $529c0c456318696f$var$RefreshIcon;

});
parcelRegister("gPelT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f34e41ee33b1e524435b178556b66735>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3fc8ad083e2745c$var$_react = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c3fc8ad083e2745c$var$_baseNew = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c3fc8ad083e2745c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3fc8ad083e2745c$var$RefreshIcon = (props)=>/*#__PURE__*/ $c3fc8ad083e2745c$var$_react.default.createElement($c3fc8ad083e2745c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$c3fc8ad083e2745c$var$RefreshIcon.displayName = 'RefreshIcon';
var $c3fc8ad083e2745c$var$_default = module.exports.default = $c3fc8ad083e2745c$var$RefreshIcon;

});



parcelRegister("fTrfQ", function(module, exports) {

$parcel$export(module.exports, "startTaskPolling", () => $08b85901855d7f32$export$2888c4840b025e2a);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $iRdzc = parcelRequire("iRdzc");


var $dhudo = parcelRequire("dhudo");

var $4oSvI = parcelRequire("4oSvI");

var $fmoqT = parcelRequire("fmoqT");

var $g9wgy = parcelRequire("g9wgy");

var $80E7L = parcelRequire("80E7L");
const $08b85901855d7f32$export$126d20606b8a2eb9 = 6;
const $08b85901855d7f32$export$2888c4840b025e2a = ()=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().isPolling) return;
        try {
            setState({
                isPolling: true
            });
            await new Promise((resolve, reject)=>{
                // Store the reject function to be able to call it later to cancel polling
                setState({
                    pollingReject: reject
                });
                $08b85901855d7f32$export$bd8e6abf001160db({
                    consecutiveErrors: 0,
                    getState: getState,
                    setState: setState,
                    dispatch: dispatch,
                    workspaceId: workspaceId,
                    createAnalyticsEvent: createAnalyticsEvent,
                    resolve: resolve,
                    reject: reject
                });
            });
        } catch (error) {
            if (error instanceof (0, $dhudo.ConsecutivePollingError)) (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'consecutivePollTasks',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
        } finally{
            setState({
                isPolling: false,
                pollingReject: undefined,
                pollingTimeoutIds: undefined
            });
        }
    };
const $08b85901855d7f32$export$bd8e6abf001160db = async ({ consecutiveErrors: consecutiveErrors, getState: getState, setState: setState, dispatch: dispatch, workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent, resolve: resolve, reject: reject })=>{
    try {
        const newTasks = (await (0, $g9wgy.getAllTasks)(workspaceId)).tasks;
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'pollTasks succeeded');
        // If polling has been cancelled, do not update the state and show flags
        if (getState().isPolling) {
            const newCompletedTasks = (0, $4oSvI.getCompletedTasks)(getState().tasks, newTasks);
            const mergedTasks = (0, $fmoqT.mergeTasks)(getState().tasks, newTasks);
            if (newCompletedTasks.length) dispatch((0, $80E7L.showCompletedFlags)(newCompletedTasks));
            setState({
                tasks: mergedTasks
            });
            // Cancel polling if all tasks are completed or not present
            if (mergedTasks.every((task)=>task.status === (0, $iRdzc.STATUS_COMPLETED))) {
                resolve();
                return;
            }
            const timeoutId = setTimeout(()=>{
                $08b85901855d7f32$export$bd8e6abf001160db({
                    consecutiveErrors: 0,
                    getState: getState,
                    setState: setState,
                    dispatch: dispatch,
                    workspaceId: workspaceId,
                    createAnalyticsEvent: createAnalyticsEvent,
                    resolve: resolve,
                    reject: reject
                });
            }, (0, $3cdf5122ac1304e2$export$e5c3b75cb29e562d));
            setState({
                pollingTimeoutIds: [
                    ...getState().pollingTimeoutIds ?? [],
                    timeoutId
                ]
            });
        }
    } catch (error) {
        (0, $xJtdX.fireCmdbErrorAnalytics)({
            error: error instanceof Error ? error : undefined,
            meta: {
                id: 'pollTasks',
                packageName: 'jiraServicedeskCmdbAsyncActions',
                teamName: 'falcons'
            }
        });
        if (getState().isPolling) {
            if (consecutiveErrors + 1 === $08b85901855d7f32$export$126d20606b8a2eb9) {
                reject(new (0, $dhudo.ConsecutivePollingError)('Task polling failed due to consecutive errors'));
                return;
            }
            const timeoutId = setTimeout(()=>{
                $08b85901855d7f32$export$bd8e6abf001160db({
                    consecutiveErrors: consecutiveErrors + 1,
                    getState: getState,
                    setState: setState,
                    dispatch: dispatch,
                    workspaceId: workspaceId,
                    createAnalyticsEvent: createAnalyticsEvent,
                    resolve: resolve,
                    reject: reject
                });
            }, (0, $3cdf5122ac1304e2$export$e5c3b75cb29e562d));
            setState({
                pollingTimeoutIds: [
                    ...getState().pollingTimeoutIds ?? [],
                    timeoutId
                ]
            });
        }
    }
};

});
const $3cdf5122ac1304e2$export$e5c3b75cb29e562d = 10000;

parcelRegister("dhudo", function(module, exports) {

$parcel$export(module.exports, "CancelledPollingError", () => $a23797195308bdd9$export$82a97abb9eef9574);
$parcel$export(module.exports, "ConsecutivePollingError", () => $a23797195308bdd9$export$c7929430af8a16ba);
/* eslint-disable max-classes-per-file */ class $a23797195308bdd9$export$82a97abb9eef9574 extends Error {
    constructor(message){
        super(message);
        this.name = 'CancelledPollingError';
    }
}
class $a23797195308bdd9$export$c7929430af8a16ba extends Error {
    constructor(message){
        super(message);
        this.name = 'ConsecutivePollingError';
    }
}

});

parcelRegister("4oSvI", function(module, exports) {

$parcel$export(module.exports, "getCompletedTasks", () => $9caceb354a87562d$export$7a201e616c9e1a4d);

var $iRdzc = parcelRequire("iRdzc");
const $9caceb354a87562d$export$7a201e616c9e1a4d = (existingTasks, newTasks)=>{
    const existingTaskMap = new Map();
    (existingTasks ?? []).forEach((task)=>existingTaskMap.set(task.taskId, task));
    const newCompletedTasks = (newTasks ?? []).filter((task)=>task.status === (0, $iRdzc.STATUS_COMPLETED));
    const tasksToUpdate = [];
    newCompletedTasks.forEach((completedTask)=>{
        const existingTask = existingTaskMap.get(completedTask.taskId);
        if (!existingTask) // Task completed but didn't exist in state
        tasksToUpdate.push(completedTask);
        else if (existingTask.status !== (0, $iRdzc.STATUS_COMPLETED)) // Task in state was not completed but is now completed server side
        tasksToUpdate.push(completedTask);
    });
    return tasksToUpdate;
};

});

parcelRegister("g9wgy", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $13b6c8fcbc536816$export$d1f442602a91e7cc);

var $4VpwK = parcelRequire("4VpwK");

var $hvoOI = parcelRequire("hvoOI");
const $13b6c8fcbc536816$export$d1f442602a91e7cc = (workspaceId)=>{
    return (0, $4VpwK.performCmdbGetRequest)((0, $hvoOI.getCmdbTasksUrl)(workspaceId));
};

});
parcelRegister("hvoOI", function(module, exports) {

$parcel$export(module.exports, "getCmdbTasksUrl", () => $aaeff6dccddba8db$export$6194ab06c369c51d);

var $klJ8b = parcelRequire("klJ8b");
const $aaeff6dccddba8db$export$6194ab06c369c51d = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/tasks`;

});


parcelRegister("80E7L", function(module, exports) {

$parcel$export(module.exports, "showCompletedFlags", () => $b0cb25f9dc0f198b$export$c9bfd2f84e843224);

var $jbxCC = parcelRequire("jbxCC");

var $24ov5 = parcelRequire("24ov5");

var $lL4fC = parcelRequire("lL4fC");

var $abhRB = parcelRequire("abhRB");

var $dtiLn = parcelRequire("dtiLn");

var $SRLhP = parcelRequire("SRLhP");

var $5OGKb = parcelRequire("5OGKb");
const $b0cb25f9dc0f198b$export$c9bfd2f84e843224 = (completedTasks)=>({ dispatch: dispatch }, { workspaceId: workspaceId, showFlag: showFlag, dismissFlag: dismissFlag })=>{
        completedTasks.forEach((task)=>{
            // Dismiss "Action started" flag if still present
            dismissFlag(task.taskId);
            // Pass the dismiss action to the flag component
            const onDismissed = ()=>{
                // Dismiss the flag from the UI
                dismissFlag(task.taskId);
                // Dismiss the task on the server
                dispatch((0, $5OGKb.dismissTask)({
                    taskId: task.taskId
                }));
            };
            const taskUrl = (0, $jbxCC.getCmdbTaskByIdUrl)(workspaceId, task.taskId);
            showFlag((0, $24ov5.matchTaskByOperationType)(task, {
                BulkEdit: (bulkEditTask)=>(0, $abhRB.bulkEditFlagHandler)({
                        task: bulkEditTask,
                        taskUrl: taskUrl,
                        onDismissed: onDismissed
                    }),
                BulkDelete: (bulkDeleteTask)=>(0, $lL4fC.bulkDeleteFlagHandler)({
                        task: bulkDeleteTask,
                        taskUrl: taskUrl,
                        onDismissed: onDismissed
                    }),
                BulkExport: (bulkExportTask)=>(0, $dtiLn.bulkExportFlagHandler)({
                        task: bulkExportTask,
                        taskUrl: taskUrl,
                        onDismissed: onDismissed
                    }),
                QrCode: (qrCodeTask)=>(0, $SRLhP.qrCodeFlagHandler)({
                        task: qrCodeTask,
                        taskUrl: taskUrl,
                        onDismissed: onDismissed
                    })
            }));
        });
    };

});
parcelRegister("jbxCC", function(module, exports) {

$parcel$export(module.exports, "getCmdbTaskByIdUrl", () => $f9b7843d5897ebfb$export$4d71337e7d7c3627);
$parcel$export(module.exports, "getCmdbTaskArchiveUrl", () => $f9b7843d5897ebfb$export$7107cbf1ad1ef8d8);

var $klJ8b = parcelRequire("klJ8b");
const $f9b7843d5897ebfb$export$4d71337e7d7c3627 = (workspaceId, taskId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/task/${taskId}`;
const $f9b7843d5897ebfb$export$7107cbf1ad1ef8d8 = (workspaceId, taskId)=>`${$f9b7843d5897ebfb$export$4d71337e7d7c3627(workspaceId, taskId)}/archive`;

});

parcelRegister("lL4fC", function(module, exports) {

$parcel$export(module.exports, "bulkDeleteFlagHandler", () => $8ca1f05a762491a1$export$2b35d0037205a79d);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $82H85 = parcelRequire("82H85");

var $505aW = parcelRequire("505aW");

var $j2LMc = parcelRequire("j2LMc");
const $8ca1f05a762491a1$export$9ea91b3916eea06b = ({ task: task, flagProps: flagProps, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const objectsProcessed = task.resultPayload.objectsProcessed;
    const flagActions = (0, $5uXOq.useMemo)(()=>[
            {
                content: formatMessage((0, $505aW.default).completedFlagViewReport)
            }
        ], [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...flagProps,
        title: formatMessage((0, $j2LMc.default).flagTitle, {
            objectsProcessed: objectsProcessed
        }),
        id: task.taskId,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $82H85.CompletedFlagDescription), {
            task: task
        }, !task.resultPayload.hasError ? formatMessage((0, $505aW.default).completedFlagDescription) : formatMessage((0, $505aW.default).completedFlagErrorDescription)),
        actions: task.resultPayload.hasError ? flagActions : undefined,
        onDismissed: onDismissed,
        testId: "servicedesk-cmdb-async-actions.common.ui.flags.completed-flag-bulk-delete"
    });
};
const $8ca1f05a762491a1$export$2b35d0037205a79d = (props)=>({
        id: props.task.taskId,
        render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca1f05a762491a1$export$9ea91b3916eea06b, {
                ...props,
                flagProps: flagProps
            })
    });

});
parcelRegister("82H85", function(module, exports) {

$parcel$export(module.exports, "CompletedFlagDescription", () => $2908669a8b53b329$export$cabe46edefed4c59);

var $5uXOq = parcelRequire("5uXOq");

var $34Rrn = parcelRequire("34Rrn");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $koVbs = parcelRequire("koVbs");

var $dMwN8 = parcelRequire("dMwN8");
const $2908669a8b53b329$export$915e9e7bd4f0f96d = ({ errorCount: errorCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        testId: "servicedesk-cmdb-async-actions.common.ui.flags.completed-flag-description.error-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
        label: formatMessage((0, $dMwN8.default).warningIcon),
        color: "var(--ds-icon-warning, #E56910)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "medium",
        color: "color.text.warning"
    }, formatMessage((0, $dMwN8.default).errorsEncountered, {
        errorCount: errorCount
    })));
};
const $2908669a8b53b329$export$cabe46edefed4c59 = ({ task: task, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, task.resultPayload.hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2908669a8b53b329$export$915e9e7bd4f0f96d, {
        errorCount: task.resultPayload.objectsEncounteredError
    }), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "servicedesk-cmdb-async-actions.common.ui.flags.completed-flag-description.children-wrapper"
    }, children));
};

});
parcelRegister("dMwN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b68cb409d814c2de$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b68cb409d814c2de$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    warningIcon: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-description.warning-icon",
        "defaultMessage": "Warning"
    },
    errorsEncountered: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-description.errors-encountered",
        "defaultMessage": "{errorCount, plural,\n    \t\t=0 {Error encountered}\n    \t\tone {{errorCount} error encountered}\n    \t\tother {{errorCount} errors encountered}\n\t\t}"
    }
});

});


parcelRegister("505aW", function(module, exports) {

$parcel$export(module.exports, "default", () => $de74901bbd56c305$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $de74901bbd56c305$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    completedFlagDescription: {
        "id": "servicedesk-cmdb-async-actions.common.completed-flag-description",
        "defaultMessage": "This action was completed successfully"
    },
    completedFlagErrorDescription: {
        "id": "servicedesk-cmdb-async-actions.common.completed-flag-error-description",
        "defaultMessage": "Use the link below to check the outcome of your bulk action and view the objects that encountered an error"
    },
    completedFlagViewReport: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-view-report",
        "defaultMessage": "View report"
    }
});

});

parcelRegister("j2LMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dbc88d3bf821a2c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7dbc88d3bf821a2c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-bulk-delete.flag-title",
        "defaultMessage": "{objectsProcessed, plural,\n    \t\t=0 {Action complete: Delete}\n    \t\tone {Action complete: Delete {objectsProcessed} object}\n    \t\tother {Action complete: Delete {objectsProcessed} objects}\n\t\t}"
    }
});

});


parcelRegister("abhRB", function(module, exports) {

$parcel$export(module.exports, "bulkEditFlagHandler", () => $2481ae240d91a5ed$export$baf8c2432df5f1d1);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $2KAtx = parcelRequire("2KAtx");

var $lEb4X = parcelRequire("lEb4X");

var $82H85 = parcelRequire("82H85");

var $69r4m = parcelRequire("69r4m");

var $505aW = parcelRequire("505aW");

var $5PDbS = parcelRequire("5PDbS");

var $02kdu = parcelRequire("02kdu");
const $2481ae240d91a5ed$export$860f6c8e73756062 = ({ task: task, flagProps: flagProps, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const objectsProcessed = task.resultPayload.objectsProcessed;
    const flagActions = (0, $5uXOq.useMemo)(()=>[
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
                    entryPoint: (0, $lEb4X.cmdbAsyncActionsResultsEntryPoint),
                    modalProps: (0, $69r4m.cmdbAsyncActionsResultsEntrypointModalProps),
                    entryPointProps: (0, $5PDbS.getCmdbAsyncActionsResultsModalEntrypointProps)(task),
                    interactionName: "cmdb-async-actions-results-modal",
                    useInternalModal: true
                }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                        ref: ref
                    }, formatMessage((0, $505aW.default).completedFlagViewReport))),
                onClick: ()=>onDismissed(task.taskId)
            }
        ], [
        formatMessage,
        onDismissed,
        task
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...flagProps,
        title: formatMessage((0, $02kdu.default).flagTitle, {
            objectsProcessed: objectsProcessed
        }),
        id: task.taskId,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $82H85.CompletedFlagDescription), {
            task: task
        }, !task.resultPayload.hasError ? formatMessage((0, $505aW.default).completedFlagDescription) : formatMessage((0, $505aW.default).completedFlagErrorDescription)),
        actions: task.resultPayload.hasError ? flagActions : undefined,
        onDismissed: onDismissed,
        testId: "servicedesk-cmdb-async-actions.common.ui.flags.completed-flag-bulk-edit"
    });
};
const $2481ae240d91a5ed$export$baf8c2432df5f1d1 = (props)=>({
        id: props.task.taskId,
        render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2481ae240d91a5ed$export$860f6c8e73756062, {
                ...props,
                flagProps: flagProps
            })
    });

});
parcelRegister("lEb4X", function(module, exports) {

$parcel$export(module.exports, "cmdbAsyncActionsResultsEntryPoint", () => $b7514736b1fa1422$export$f293eb996a7b28cc);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $b7514736b1fa1422$export$f293eb996a7b28cc = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eH6o9")).then(({ CmdbAsyncActionsResultsModal: CmdbAsyncActionsResultsModal })=>CmdbAsyncActionsResultsModal), {
        moduleId: "d84134e3"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eH6o9", function(module, exports) {

let $ab2a0976e2429b69$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ab2a0976e2429b69$var$load("2Ovoy").then(()=>parcelRequire('3Xr6z'));

});


parcelRegister("69r4m", function(module, exports) {

$parcel$export(module.exports, "cmdbAsyncActionsResultsEntrypointModalProps", () => $2cbd51ffdd52f0c8$export$18e02f180fe877f8);

var $9q9kr = parcelRequire("9q9kr");
const $2cbd51ffdd52f0c8$export$18e02f180fe877f8 = {
    width: (0, $9q9kr.RESULTS_MODAL_WIDTH)
};

});
parcelRegister("9q9kr", function(module, exports) {

$parcel$export(module.exports, "RESULTS_MODAL_WIDTH", () => $683a14d5ad251158$export$c8747c4f4579143a);
$parcel$export(module.exports, "BULK_EDIT_COLUMNS", () => $683a14d5ad251158$export$f5444868038df03);

var $l9N2z = parcelRequire("l9N2z");
const $683a14d5ad251158$export$c8747c4f4579143a = 'x-large';
const $683a14d5ad251158$export$f5444868038df03 = [
    (0, $l9N2z.default).affectedObjectsHeader,
    (0, $l9N2z.default).attributesEditedHeader,
    (0, $l9N2z.default).actionPerformedHeader,
    (0, $l9N2z.default).errorsHeader
];

});
parcelRegister("l9N2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $5473615085c8106e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5473615085c8106e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    affectedObjectsHeader: {
        "id": "servicedesk-cmdb-async-actions-results-modal.common.affected-objects-header",
        "defaultMessage": "Affected object"
    },
    attributesEditedHeader: {
        "id": "servicedesk-cmdb-async-actions-results-modal.common.attribute-edited-header",
        "defaultMessage": "Attribute edited"
    },
    actionPerformedHeader: {
        "id": "servicedesk-cmdb-async-actions-results-modal.common.action-performed-header",
        "defaultMessage": "Action performed"
    },
    errorsHeader: {
        "id": "servicedesk-cmdb-async-actions-results-modal.common.errors-header",
        "defaultMessage": "Error"
    }
});

});



parcelRegister("5PDbS", function(module, exports) {

$parcel$export(module.exports, "getCmdbAsyncActionsResultsModalEntrypointProps", () => $d37d7e869379ce35$export$982b6b582222d38e);
const $d37d7e869379ce35$export$982b6b582222d38e = ({ taskId: taskId })=>({
        taskId: taskId
    });

});

parcelRegister("02kdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4090163772689ba1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4090163772689ba1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-bulk-edit.flag-title",
        "defaultMessage": "{objectsProcessed, plural,\n    \t\t=0 {Action complete: Edit}\n    \t\tone {Action complete: Edit {objectsProcessed} object}\n    \t\tother {Action complete: Edit {objectsProcessed} objects}\n\t\t}"
    }
});

});


parcelRegister("dtiLn", function(module, exports) {

$parcel$export(module.exports, "bulkExportFlagHandler", () => $d2126e87e2a0b397$export$18187318bf1df780);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $82H85 = parcelRequire("82H85");

var $505aW = parcelRequire("505aW");

var $lGMpb = parcelRequire("lGMpb");
const $d2126e87e2a0b397$export$9a516da0426837b3 = ({ task: task, taskUrl: taskUrl, flagProps: flagProps, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const objectsProcessed = task.resultPayload.objectsProcessed;
    const flagActions = (0, $5uXOq.useMemo)(()=>[
            {
                content: formatMessage((0, $lGMpb.default).downloadExport),
                href: taskUrl,
                download: true
            }
        ], [
        formatMessage,
        taskUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...flagProps,
        title: formatMessage((0, $lGMpb.default).flagTitle, {
            objectsProcessed: objectsProcessed
        }),
        id: task.taskId,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $82H85.CompletedFlagDescription), {
            task: task
        }, !task.resultPayload.hasError ? formatMessage((0, $505aW.default).completedFlagDescription) : undefined),
        actions: !task.resultPayload.hasError ? flagActions : undefined,
        onDismissed: onDismissed,
        testId: "servicedesk-cmdb-async-actions.common.ui.flags.completed-flag-bulk-export"
    });
};
const $d2126e87e2a0b397$export$18187318bf1df780 = (props)=>({
        id: props.task.taskId,
        render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d2126e87e2a0b397$export$9a516da0426837b3, {
                ...props,
                flagProps: flagProps
            })
    });

});
parcelRegister("lGMpb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec6281d74d714d22$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ec6281d74d714d22$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-bulk-export.flag-title",
        "defaultMessage": "{objectsProcessed, plural,\n    \t\t=0 {Action complete: Export}\n    \t\tone {Action complete: Export {objectsProcessed} object}\n    \t\tother {Action complete: Export {objectsProcessed} objects}\n\t\t}"
    },
    downloadExport: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-bulk-export-flag.download-export",
        "defaultMessage": "Download object export"
    }
});

});


parcelRegister("SRLhP", function(module, exports) {

$parcel$export(module.exports, "qrCodeFlagHandler", () => $d6afe4ea9a1edf51$export$c7457667617d9d08);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $82H85 = parcelRequire("82H85");

var $505aW = parcelRequire("505aW");

var $fu3V7 = parcelRequire("fu3V7");
const $d6afe4ea9a1edf51$export$1698fbb007856211 = ({ task: task, taskUrl: taskUrl, flagProps: flagProps, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const objectsProcessed = task.resultPayload.objectsProcessed;
    const flagActions = (0, $5uXOq.useMemo)(()=>[
            {
                content: formatMessage((0, $fu3V7.default).downloadPdf),
                href: taskUrl,
                download: true
            }
        ], [
        formatMessage,
        taskUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessFlag), {
        ...flagProps,
        title: formatMessage((0, $fu3V7.default).flagTitle, {
            objectsProcessed: objectsProcessed
        }),
        id: task.taskId,
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $82H85.CompletedFlagDescription), {
            task: task
        }, !task.resultPayload.hasError ? formatMessage((0, $505aW.default).completedFlagDescription) : undefined),
        actions: !task.resultPayload.hasError ? flagActions : undefined,
        onDismissed: onDismissed,
        testId: "servicedesk-cmdb-async-actions.common.ui.flags.completed-flag-qr-code"
    });
};
const $d6afe4ea9a1edf51$export$c7457667617d9d08 = (props)=>({
        id: props.task.taskId,
        render: (flagProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d6afe4ea9a1edf51$export$1698fbb007856211, {
                ...props,
                flagProps: flagProps
            })
    });

});
parcelRegister("fu3V7", function(module, exports) {

$parcel$export(module.exports, "default", () => $431376789140fbac$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $431376789140fbac$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-flag-qr-code.flag-title",
        "defaultMessage": "{objectsProcessed, plural,\n    \t\t=0 {Action complete: Print QR code}\n    \t\tone {Action complete: Print QR code for {objectsProcessed} object}\n    \t\tother {Action complete: Print QR code for {objectsProcessed} objects}\n\t\t}"
    },
    downloadPdf: {
        "id": "servicedesk-cmdb-async-actions.common.flags.completed-qr-code-flag.download-pdf",
        "defaultMessage": "Download QR Codes"
    }
});

});


parcelRegister("5OGKb", function(module, exports) {

$parcel$export(module.exports, "dismissTask", () => $20a8c52758575002$export$a478448c6707d080);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $lSsXb = parcelRequire("lSsXb");
const $20a8c52758575002$export$a478448c6707d080 = ({ taskId: taskId })=>async ({ getState: getState, setState: setState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        // This is just to prevent multiple dismiss requests for the same task, won't ever be shown in the UI
        if (getState().isDismissing.includes(taskId)) return;
        setState({
            isDismissing: [
                ...getState().isDismissing,
                taskId
            ]
        });
        try {
            await (0, $lSsXb.dismissTaskById)(workspaceId, taskId);
            setState({
                tasks: [
                    ...(getState().tasks ?? [])?.filter((task)=>task.taskId !== taskId)
                ],
                isDismissing: [
                    ...getState().isDismissing.filter((existingTaskId)=>existingTaskId !== taskId)
                ]
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'dismissTask succeeded');
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'dismissTask',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
            setState({
                isDismissing: [
                    ...getState().isDismissing.filter((existingTaskId)=>existingTaskId !== taskId)
                ]
            });
        // We are intentionally swallowing the error here as we don't want a failure to be a blocking action and should be hidden from the user
        }
    };

});
parcelRegister("lSsXb", function(module, exports) {

$parcel$export(module.exports, "dismissTaskById", () => $7803b2e41f8e6fff$export$70a045fc9df8a39d);

var $4VpwK = parcelRequire("4VpwK");

var $jbxCC = parcelRequire("jbxCC");
const $7803b2e41f8e6fff$export$70a045fc9df8a39d = (workspaceId, taskId)=>{
    return (0, $4VpwK.performCmdbPostRequest)((0, $jbxCC.getCmdbTaskArchiveUrl)(workspaceId, taskId), {
        body: JSON.stringify({
            dismissed: true
        })
    });
};

});





parcelRegister("cw6qU", function(module, exports) {

$parcel$export(module.exports, "submitBulkEditTask", () => $e44a5ccf98105b79$export$327e6e4fb0736756);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $iRdzc = parcelRequire("iRdzc");

var $fmoqT = parcelRequire("fmoqT");

var $bDlPY = parcelRequire("bDlPY");

var $lNC72 = parcelRequire("lNC72");

var $kYIR2 = parcelRequire("kYIR2");

var $fTrfQ = parcelRequire("fTrfQ");
const $e44a5ccf98105b79$export$327e6e4fb0736756 = ({ objectCount: objectCount, ...body })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().bulkEdit.isSubmitting) return;
        setState({
            bulkEdit: {
                isSubmitting: true
            }
        });
        try {
            const { taskId: taskId } = await (0, $bDlPY.createAsyncBulkEditTask)(workspaceId, {
                ...body
            });
            setState({
                tasks: (0, $fmoqT.mergeTasks)(getState().tasks, [
                    {
                        taskId: taskId,
                        operationType: (0, $iRdzc.OPERATION_TYPE_BULK_EDIT),
                        status: (0, $iRdzc.STATUS_QUEUED)
                    }
                ]),
                bulkEdit: {
                    isSubmitting: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'submitAsyncBulkEditTask succeeded');
            dispatch((0, $kYIR2.showSuccessFlag)({
                id: taskId,
                objectCount: objectCount,
                action: (0, $iRdzc.OPERATION_TYPE_BULK_EDIT)
            }));
            dispatch((0, $fTrfQ.startTaskPolling)());
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'submitAsyncBulkEditTask',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
            setState({
                bulkEdit: {
                    isSubmitting: false
                }
            });
            dispatch((0, $lNC72.showErrorFlag)({
                action: (0, $iRdzc.OPERATION_TYPE_BULK_EDIT),
                objectCount: objectCount
            }));
            throw error;
        }
    };

});
parcelRegister("bDlPY", function(module, exports) {

$parcel$export(module.exports, "createAsyncBulkEditTask", () => $733a14596ca44221$export$78ce27891c7c0411);

var $4VpwK = parcelRequire("4VpwK");

var $eJOOa = parcelRequire("eJOOa");
const $733a14596ca44221$export$78ce27891c7c0411 = (workspaceId, params)=>(0, $4VpwK.performCmdbPostRequest)((0, $eJOOa.getCmdbAsyncBulkEditUrl)(workspaceId), {
        body: JSON.stringify({
            objectEntry: {
                objectTypeId: params.filters.objectTypeId,
                attributes: params.attributeOperations
            },
            filters: params.filters
        })
    });

});


parcelRegister("2yc90", function(module, exports) {

$parcel$export(module.exports, "submitBulkExportTask", () => $5d0567a5ed6d26f1$export$afec378dd533375d);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $iRdzc = parcelRequire("iRdzc");

var $fmoqT = parcelRequire("fmoqT");

var $kRDs3 = parcelRequire("kRDs3");

var $lNC72 = parcelRequire("lNC72");

var $kYIR2 = parcelRequire("kYIR2");

var $fTrfQ = parcelRequire("fTrfQ");
const $5d0567a5ed6d26f1$export$afec378dd533375d = ({ objectCount: objectCount, ...body })=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().bulkExport.isSubmitting) return;
        setState({
            bulkExport: {
                isSubmitting: true
            }
        });
        try {
            const { taskId: taskId } = await (0, $kRDs3.createAsyncBulkExportTask)(workspaceId, {
                ...body
            });
            setState({
                tasks: (0, $fmoqT.mergeTasks)(getState().tasks, [
                    {
                        taskId: taskId,
                        operationType: (0, $iRdzc.OPERATION_TYPE_BULK_EXPORT),
                        status: (0, $iRdzc.STATUS_QUEUED)
                    }
                ]),
                bulkExport: {
                    isSubmitting: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'submitAsyncBulkExportTask succeeded');
            dispatch((0, $kYIR2.showSuccessFlag)({
                id: taskId,
                objectCount: objectCount,
                action: (0, $iRdzc.OPERATION_TYPE_BULK_EXPORT)
            }));
            dispatch((0, $fTrfQ.startTaskPolling)());
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'submitAsyncBulkExportTask',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
            setState({
                bulkExport: {
                    isSubmitting: false
                }
            });
            dispatch((0, $lNC72.showErrorFlag)({
                action: (0, $iRdzc.OPERATION_TYPE_BULK_EXPORT),
                objectCount: objectCount
            }));
            throw error;
        }
    };

});
parcelRegister("kRDs3", function(module, exports) {

$parcel$export(module.exports, "createAsyncBulkExportTask", () => $3f1ab51cf6df367a$export$9a27b34ed9dfe3bb);

var $4VpwK = parcelRequire("4VpwK");

var $eJOOa = parcelRequire("eJOOa");
const $3f1ab51cf6df367a$export$9a27b34ed9dfe3bb = (workspaceId, params)=>(0, $4VpwK.performCmdbPostRequest)((0, $eJOOa.getCmdbAsyncObjectExportUrl)(workspaceId), {
        body: JSON.stringify(params)
    });

});


parcelRegister("iZKRA", function(module, exports) {

$parcel$export(module.exports, "submitBulkQrCodeTask", () => $0751d58d278d45b9$export$22f6482695c3c60c);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $iRdzc = parcelRequire("iRdzc");

var $fmoqT = parcelRequire("fmoqT");

var $39rUH = parcelRequire("39rUH");

var $lNC72 = parcelRequire("lNC72");

var $kYIR2 = parcelRequire("kYIR2");

var $fTrfQ = parcelRequire("fTrfQ");
const $0751d58d278d45b9$export$22f6482695c3c60c = ({ objectCount: objectCount, size: size, ...body })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().bulkQrCode.isSubmitting) return;
        setState({
            bulkQrCode: {
                isSubmitting: true
            }
        });
        try {
            const { taskId: taskId } = await (0, $39rUH.createAsyncBulkQrCodeTask)(workspaceId, size, {
                ...body
            });
            setState({
                tasks: (0, $fmoqT.mergeTasks)(getState().tasks, [
                    {
                        taskId: taskId,
                        operationType: (0, $iRdzc.OPERATION_TYPE_BULK_QR_CODE),
                        status: (0, $iRdzc.STATUS_QUEUED)
                    }
                ]),
                bulkQrCode: {
                    isSubmitting: false
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'submitAsyncBulkQrCodeTask succeeded');
            dispatch((0, $kYIR2.showSuccessFlag)({
                id: taskId,
                objectCount: objectCount,
                action: (0, $iRdzc.OPERATION_TYPE_BULK_QR_CODE)
            }));
            dispatch((0, $fTrfQ.startTaskPolling)());
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error instanceof Error ? error : undefined,
                meta: {
                    id: 'submitAsyncBulkQrCodeTask',
                    packageName: 'jiraServicedeskCmdbAsyncActions',
                    teamName: 'falcons'
                }
            });
            setState({
                bulkQrCode: {
                    isSubmitting: false
                }
            });
            dispatch((0, $lNC72.showErrorFlag)({
                action: (0, $iRdzc.OPERATION_TYPE_BULK_QR_CODE),
                objectCount: objectCount
            }));
            throw error;
        }
    };

});
parcelRegister("39rUH", function(module, exports) {

$parcel$export(module.exports, "createAsyncBulkQrCodeTask", () => $d5487158ffdb326f$export$2ed432cc0e33a12d);

var $4VpwK = parcelRequire("4VpwK");

var $eJOOa = parcelRequire("eJOOa");
const $d5487158ffdb326f$export$2ed432cc0e33a12d = (workspaceId, size, params)=>(0, $4VpwK.performCmdbPostRequest)((0, $eJOOa.getCmdbAsyncBulkQrCodeUrl)(workspaceId, {
        size: size
    }), {
        body: JSON.stringify(params)
    });

});



parcelRegister("564bj", function(module, exports) {

$parcel$export(module.exports, "cancelPolling", () => $5e44861368590d82$export$1a7da92a8e07d110);

var $dhudo = parcelRequire("dhudo");
const $5e44861368590d82$export$cfd66e6c9491ee05 = new (0, $dhudo.CancelledPollingError)('Polling cancelled');
const $5e44861368590d82$export$1a7da92a8e07d110 = ()=>async ({ getState: getState, setState: setState })=>{
        if (getState().isPolling) {
            getState().pollingTimeoutIds?.forEach((timeoutId)=>{
                clearTimeout(timeoutId);
            });
            setState({
                isPolling: false
            });
            getState().pollingReject?.($5e44861368590d82$export$cfd66e6c9491ee05);
        }
    };

});

parcelRegister("2xnjS", function(module, exports) {

$parcel$export(module.exports, "fetchInitialTasks", () => $3b6f085711badec0$export$cf59b8673dd061d2);


var $fTrfQ = parcelRequire("fTrfQ");
const $3b6f085711badec0$export$cf59b8673dd061d2 = ()=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const timeoutId = setTimeout(()=>{
            if (!getState().isPolling && !getState().tasks) dispatch((0, $fTrfQ.startTaskPolling)());
        }, (0, $3cdf5122ac1304e2$export$e5c3b75cb29e562d));
        setState({
            pollingTimeoutIds: [
                ...getState().pollingTimeoutIds ?? [],
                timeoutId
            ]
        });
    };

});



parcelRegister("aROOn", function(module, exports) {

$parcel$export(module.exports, "ObjectDetailsRenderingContext", () => $dc326cf85c2fa59c$export$8455be6f0fe4b2f9);
const $dc326cf85c2fa59c$export$8455be6f0fe4b2f9 = {
    Page: 'Page',
    Component: 'Component'
};

});

parcelRegister("5EeMY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2e19f05d67203f2b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $auKUN = parcelRequire("auKUN");

var $9IbpA = parcelRequire("9IbpA");
const $2e19f05d67203f2b$var$ObjectView = (props)=>{
    const { workspaceId: workspaceId, objectId: objectId, initialObjectDetailsData: initialObjectDetailsData, backButton: backButton, context: context, onClone: onClone, onDelete: onDelete, onUpdate: onUpdate, redirectOnDelete: redirectOnDelete, showFullBreadcrumbTrail: showFullBreadcrumbTrail, onFinishLoading: onFinishLoading } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $auKUN.ObjectViewContainer), {
        objectId: objectId,
        workspaceId: workspaceId,
        initialObjectDetailsData: initialObjectDetailsData,
        createAnalyticsEvent: createAnalyticsEvent,
        onUpdate: onUpdate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9IbpA.InsightObjectView), {
        context: context,
        backButton: backButton,
        onClone: onClone,
        onDelete: onDelete,
        onFinishLoading: onFinishLoading,
        redirectOnDelete: redirectOnDelete,
        showFullBreadcrumbTrail: showFullBreadcrumbTrail
    }));
};
var $2e19f05d67203f2b$export$2e2bcd8739ae039 = $2e19f05d67203f2b$var$ObjectView;

});
parcelRegister("auKUN", function(module, exports) {

$parcel$export(module.exports, "ObjectViewContainer", () => $8c18948db671bfc3$export$9267b2240e1e9093);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $1CRGB = parcelRequire("1CRGB");

var $9le7J = parcelRequire("9le7J");

var $iN6n9 = parcelRequire("iN6n9");

var $5Ny9E = parcelRequire("5Ny9E");

var $8pMQX = parcelRequire("8pMQX");

var $cPB2u = parcelRequire("cPB2u");

var $1AZST = parcelRequire("1AZST");

var $kfAYm = parcelRequire("kfAYm");
const $8c18948db671bfc3$export$9267b2240e1e9093 = (props)=>{
    const { workspaceId: workspaceId, objectId: objectId, initialObjectDetailsData: initialObjectDetailsData, createAnalyticsEvent: createAnalyticsEvent, children: children, onUpdate: onUpdate } = props;
    const { data: fetchData, error: fetchError, loading: fetchLoading, fetchObjectDetails: fetchObjectDetailsRequest } = (0, $kfAYm.useFetchObjectDetails)(workspaceId, createAnalyticsEvent);
    // Remove below code during 'fix_duplicate_object_fetch_call' FF cleanup
    const request = (0, $5uXOq.useCallback)(async ()=>{
        try {
            const response = await (0, $4VpwK.performCmdbGetRequest)((0, $iN6n9.getObjectDetailsUrl)(workspaceId, objectId));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchObjectDetails succeeded');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'fetchObjectDetails',
                    packageName: 'jiraServicedeskInsightObjectView'
                }
            });
            throw error;
        }
    }, [
        workspaceId,
        objectId,
        createAnalyticsEvent
    ]);
    const { error: error, fetch: fetchObjectDetails } = (0, $ld2hZ.useService)(request);
    const objectDetails = fetchData ?? initialObjectDetailsData;
    (0, $5uXOq.useEffect)(()=>{
        // auto fetch the initial object details if initialObjectDetailsData is not provided or on object change
        if (!fetchLoading) {
            if (!objectDetails || objectDetails.id !== objectId) fetchObjectDetailsRequest(objectId);
        }
    }, [
        fetchLoading,
        fetchObjectDetails,
        fetchObjectDetailsRequest,
        objectDetails,
        objectId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (fetchError) (0, $1AZST.GlobalPageLoadExperience).failure({
            force: true
        });
    }, [
        error,
        fetchError
    ]);
    if (fetchLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPB2u.InsightObjectViewSkeleton), null);
    if (fetchError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null);
    return objectDetails != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9le7J.ObjectDetailsContainer), {
        scope: objectId,
        objectId: (0, $5Ny9E.toCmdbObjectId)(objectId),
        workspaceId: workspaceId,
        initialObjectDetailsData: objectDetails,
        createAnalyticsEvent: createAnalyticsEvent,
        onUpdate: onUpdate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1CRGB.ObjectActivityTimelineContainer), {
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent,
        objectId: (0, $5Ny9E.toCmdbObjectId)(objectId)
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPB2u.InsightObjectViewSkeleton), null);
};

});
parcelRegister("1CRGB", function(module, exports) {

$parcel$export(module.exports, "useTimelineActions", () => $d91ad8254dfc4fd7$export$48c4689ff03dbcf5);
$parcel$export(module.exports, "useIsAddingNewComment", () => $d91ad8254dfc4fd7$export$8452f16e503f468e);
$parcel$export(module.exports, "useIsEditingComment", () => $d91ad8254dfc4fd7$export$6e2e175d45c5cc7f);
$parcel$export(module.exports, "useTimelineLoadingState", () => $d91ad8254dfc4fd7$export$93f7c7f5a296bd81);
$parcel$export(module.exports, "useTimelineEvents", () => $d91ad8254dfc4fd7$export$749c55d852d95023);
$parcel$export(module.exports, "useFilteredByEventTypes", () => $d91ad8254dfc4fd7$export$f8fa1241c0d269d5);
$parcel$export(module.exports, "useAllowRelativeTimestamp", () => $d91ad8254dfc4fd7$export$a16a5165d23415f3);
$parcel$export(module.exports, "ObjectActivityTimelineContainer", () => $d91ad8254dfc4fd7$export$ee7f3708bc8d05b);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $6SgbN = parcelRequire("6SgbN");
const $d91ad8254dfc4fd7$var$initialState = {
    timelineEvents: null,
    loading: false,
    error: null,
    page: {
        current: 0,
        isLast: false
    },
    filteredByEventTypes: [],
    allowRelativeTimestamp: true,
    commentBeingEdited: null
};
const $d91ad8254dfc4fd7$var$Store = (0, $iXqE5.createStore)({
    initialState: $d91ad8254dfc4fd7$var$initialState,
    actions: $6SgbN,
    name: 'object-timeline-activity-store'
});
const $d91ad8254dfc4fd7$var$_useObjectTimelineActivityState = (0, $3sQ5x.createHook)($d91ad8254dfc4fd7$var$Store);
const $d91ad8254dfc4fd7$var$getTimelineEvents = ({ timelineEvents: timelineEvents, loading: loading, error: error, page: page })=>({
        timelineEvents: timelineEvents,
        loading: loading,
        error: error,
        page: page
    });
const $d91ad8254dfc4fd7$export$48c4689ff03dbcf5 = (0, $3sQ5x.createActionsHook)($d91ad8254dfc4fd7$var$Store);
const $d91ad8254dfc4fd7$export$8452f16e503f468e = (0, $3sQ5x.createHook)($d91ad8254dfc4fd7$var$Store, {
    selector: (state)=>state.commentBeingEdited === 'NEW'
});
const $d91ad8254dfc4fd7$export$6e2e175d45c5cc7f = (0, $3sQ5x.createHook)($d91ad8254dfc4fd7$var$Store, {
    selector: (state, props)=>state.commentBeingEdited === props.commentId
});
const $d91ad8254dfc4fd7$export$93f7c7f5a296bd81 = (0, $3sQ5x.createHook)($d91ad8254dfc4fd7$var$Store, {
    selector: (state)=>state.loading
});
const $d91ad8254dfc4fd7$export$749c55d852d95023 = (0, $3sQ5x.createHook)($d91ad8254dfc4fd7$var$Store, {
    selector: $d91ad8254dfc4fd7$var$getTimelineEvents
});
const $d91ad8254dfc4fd7$var$getFilteredByEventTypes = ({ filteredByEventTypes: filteredByEventTypes })=>filteredByEventTypes;
const $d91ad8254dfc4fd7$export$f8fa1241c0d269d5 = (0, $3sQ5x.createHook)($d91ad8254dfc4fd7$var$Store, {
    selector: $d91ad8254dfc4fd7$var$getFilteredByEventTypes
});
const $d91ad8254dfc4fd7$var$getAllowRelativeTimestamp = ({ allowRelativeTimestamp: allowRelativeTimestamp })=>Boolean(allowRelativeTimestamp);
const $d91ad8254dfc4fd7$export$a16a5165d23415f3 = (0, $3sQ5x.createHook)($d91ad8254dfc4fd7$var$Store, {
    selector: $d91ad8254dfc4fd7$var$getAllowRelativeTimestamp
});
const $d91ad8254dfc4fd7$export$ee7f3708bc8d05b = (0, $gg7kZ.createContainer)($d91ad8254dfc4fd7$var$Store, {});

});
parcelRegister("6SgbN", function(module, exports) {

$parcel$export(module.exports, "setIsAddingNewComment", () => $def082dfa0cfe371$export$78f35245417339f);
$parcel$export(module.exports, "setIsEditingComment", () => $def082dfa0cfe371$export$62e9e121892a915f);
$parcel$export(module.exports, "setIsNoCommentBeingEdited", () => $def082dfa0cfe371$export$1dc16b52c44e4150);
$parcel$export(module.exports, "setFilteredByEventTypes", () => $def082dfa0cfe371$export$fab890fff7ae06ce);
$parcel$export(module.exports, "setAllowRelativeTimestamp", () => $def082dfa0cfe371$export$d9ccc0b57cc0e17a);
$parcel$export(module.exports, "toggleAllowRelativeTimestamp", () => $def082dfa0cfe371$export$a4ad27b6b66eb61d);
$parcel$export(module.exports, "fetchObjectActivity", () => (parcelRequire("l359B")).fetchObjectActivity);
$parcel$export(module.exports, "fetchChangesAndIncidentsNextPage", () => (parcelRequire("a8rNj")).fetchChangesAndIncidentsNextPage);
$parcel$export(module.exports, "addObjectComment", () => (parcelRequire("b7Dzp")).addObjectComment);
$parcel$export(module.exports, "deleteObjectComment", () => (parcelRequire("7KrN9")).deleteObjectComment);
$parcel$export(module.exports, "updateObjectComment", () => (parcelRequire("5Pzed")).updateObjectComment);

var $l359B = parcelRequire("l359B");

var $a8rNj = parcelRequire("a8rNj");

var $b7Dzp = parcelRequire("b7Dzp");

var $7KrN9 = parcelRequire("7KrN9");

var $5Pzed = parcelRequire("5Pzed");
const $def082dfa0cfe371$export$78f35245417339f = ()=>({ setState: setState })=>{
        setState({
            commentBeingEdited: 'NEW'
        });
    };
const $def082dfa0cfe371$export$62e9e121892a915f = (commentId)=>({ setState: setState })=>{
        setState({
            commentBeingEdited: commentId
        });
    };
const $def082dfa0cfe371$export$1dc16b52c44e4150 = ()=>({ setState: setState })=>{
        setState({
            commentBeingEdited: null
        });
    };
const $def082dfa0cfe371$export$fab890fff7ae06ce = (filteredByEventTypes)=>({ setState: setState, dispatch: dispatch })=>{
        setState({
            filteredByEventTypes: filteredByEventTypes,
            timelineEvents: []
        });
        dispatch((0, $l359B.fetchObjectActivity)());
    };
const $def082dfa0cfe371$export$d9ccc0b57cc0e17a = (allowRelativeTimestamp)=>({ setState: setState })=>{
        setState({
            allowRelativeTimestamp: allowRelativeTimestamp
        });
    };
const $def082dfa0cfe371$export$a4ad27b6b66eb61d = ()=>({ setState: setState, getState: getState })=>{
        setState({
            allowRelativeTimestamp: !getState().allowRelativeTimestamp
        });
    };

});
parcelRegister("l359B", function(module, exports) {

$parcel$export(module.exports, "fetchObjectActivity", () => $c167664ef9756a0b$export$6b7eefaef6a2c44d);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $vkpPS = parcelRequire("vkpPS");

var $2NPEB = parcelRequire("2NPEB");

var $fOkMl = parcelRequire("fOkMl");

var $cGxHq = parcelRequire("cGxHq");

var $4aQG9 = parcelRequire("4aQG9");
const $c167664ef9756a0b$export$8ec3d08588d2eeda = 25;
const $c167664ef9756a0b$var$defaultPayload = {
    fetchNextPage: false
};
const $c167664ef9756a0b$export$6b7eefaef6a2c44d = ({ fetchNextPage: fetchNextPage } = $c167664ef9756a0b$var$defaultPayload)=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, objectId: objectId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const existingState = getState();
        if (existingState.loading) return;
        if (fetchNextPage && existingState.page.isLast) return;
        setState({
            loading: true
        });
        try {
            const serviceResponse = await (0, $fOkMl.fetchObjectActivity)({
                workspaceId: workspaceId,
                objectId: objectId,
                activityTypes: existingState.filteredByEventTypes.map((type)=>(0, $4aQG9.getServiceEventNameByStoreEvent)(type)).filter((objType)=>!!objType),
                orderAsc: false,
                startAt: fetchNextPage ? existingState.page.current * $c167664ef9756a0b$export$8ec3d08588d2eeda : 0,
                maxResults: $c167664ef9756a0b$export$8ec3d08588d2eeda
            });
            const timelineEvents = (0, $cGxHq.transformResponse)(serviceResponse);
            const newEvents = fetchNextPage ? [
                ...existingState.timelineEvents ?? [],
                ...timelineEvents
            ] : timelineEvents;
            setState({
                loading: false,
                timelineEvents: newEvents,
                page: {
                    current: (fetchNextPage ? existingState.page.current : 0) + 1,
                    isLast: serviceResponse.isLast
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchObjectHistory succeeded', {
                isFirstPage: !fetchNextPage
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.name === 'AbortError') return;
            const handledError = (0, $2NPEB.handleTimelineNetworkError)(error, (0, $fOkMl.LOGGER_LOCATION_FETCH_ACTIVITY));
            setState({
                error: (0, $vkpPS.toTimelineEventsServiceError)(handledError.error),
                loading: false
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: handledError.rawError,
                meta: {
                    id: 'fetchObjectHistory',
                    packageName: 'jiraServicedeskInsightObjectActivityTimelineStore',
                    teamName: 'falcons'
                },
                attributes: {
                    errorType: handledError.error,
                    errorMessage: handledError.rawError.message,
                    isFirstPage: !fetchNextPage
                }
            });
        }
    };

});
parcelRegister("vkpPS", function(module, exports) {

$parcel$export(module.exports, "CHANGE_EVENT", () => $b6c953c5c1ae0dde$export$ea22ff43725970d9);
$parcel$export(module.exports, "INCIDENT_EVENT", () => $b6c953c5c1ae0dde$export$11262187081407f7);
$parcel$export(module.exports, "OBJECT_UPDATE_EVENT", () => $b6c953c5c1ae0dde$export$4806411c9736475);
$parcel$export(module.exports, "OBJECT_COMMENT_EVENT", () => $b6c953c5c1ae0dde$export$adea1d0dd67042e5);
$parcel$export(module.exports, "toTimelineEventsServiceError", () => $b6c953c5c1ae0dde$export$d0e47955bd1b7d5f);
$parcel$export(module.exports, "isTimelineEventsServiceResponseData", () => $b6c953c5c1ae0dde$export$70b88df7161007a4);
$parcel$export(module.exports, "isUpdateObjectCommentServiceResponseData", () => $b6c953c5c1ae0dde$export$42cfbc582537eeea);
$parcel$export(module.exports, "isAddObjectCommentServiceResponseData", () => $b6c953c5c1ae0dde$export$322d53a2c1efc243);
$parcel$export(module.exports, "isTimelineEventsServiceResponseError", () => $b6c953c5c1ae0dde$export$6f1efc56587ea2fb);
const $b6c953c5c1ae0dde$export$ea22ff43725970d9 = 'CHANGE_EVENT';
const $b6c953c5c1ae0dde$export$11262187081407f7 = 'INCIDENT_EVENT';
const $b6c953c5c1ae0dde$export$4806411c9736475 = 'OBJECT_UPDATE_EVENT';
const $b6c953c5c1ae0dde$export$adea1d0dd67042e5 = 'OBJECT_COMMENT_EVENT';
const $b6c953c5c1ae0dde$export$969be307248e0453 = [
    $b6c953c5c1ae0dde$export$ea22ff43725970d9,
    $b6c953c5c1ae0dde$export$11262187081407f7,
    $b6c953c5c1ae0dde$export$4806411c9736475,
    $b6c953c5c1ae0dde$export$adea1d0dd67042e5
];
const $b6c953c5c1ae0dde$export$d0e47955bd1b7d5f = (error)=>{
    switch(error){
        case 'INTERNAL_ERROR':
            return 'INTERNAL_ERROR';
        case 'VALIDATION_ERROR':
            return 'VALIDATION_ERROR';
        case 'INVALID_RESPONSE':
            return 'INVALID_RESPONSE';
        case 'CLIENT_FETCH_ERROR':
            return 'CLIENT_FETCH_ERROR';
        default:
            return null;
    }
};
const $b6c953c5c1ae0dde$export$70b88df7161007a4 = (serviceResponse)=>typeof serviceResponse === 'object' && serviceResponse != null && 'data' in serviceResponse;
const $b6c953c5c1ae0dde$export$42cfbc582537eeea = (serviceResponse)=>typeof serviceResponse === 'object' && serviceResponse != null && 'data' in serviceResponse;
const $b6c953c5c1ae0dde$export$322d53a2c1efc243 = (serviceResponse)=>typeof serviceResponse === 'object' && serviceResponse != null && 'data' in serviceResponse;
const $b6c953c5c1ae0dde$export$6f1efc56587ea2fb = (serviceResponse)=>typeof serviceResponse === 'object' && serviceResponse != null && 'error' in serviceResponse;

});

parcelRegister("2NPEB", function(module, exports) {

$parcel$export(module.exports, "handleTimelineNetworkError", () => $b44a4ddcab8a4169$export$bb9531f6a3a98171);

var $dJl1T = parcelRequire("dJl1T");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");
const $b44a4ddcab8a4169$export$bb9531f6a3a98171 = (error, loggerLocation)=>{
    if (error instanceof (0, $jJZqs.default) && error.statusCode) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData(loggerLocation, `Endpoint returned unexpected status code ${error.statusCode}`);
        return {
            error: 'INTERNAL_ERROR',
            rawError: error
        };
    }
    if ((0, $fZneA.isClientFetchError)(error)) return {
        error: 'CLIENT_FETCH_ERROR',
        rawError: error
    };
    (0, $dJl1T.default).unsafeErrorWithCustomerData(loggerLocation, `Endpoint returned unexpected response: ${error.message}`);
    return {
        error: 'VALIDATION_ERROR',
        rawError: error
    };
};

});

parcelRegister("fOkMl", function(module, exports) {

$parcel$export(module.exports, "LOGGER_LOCATION_FETCH_ACTIVITY", () => $a979320228ed8cdf$export$ee4791a5492db442);
$parcel$export(module.exports, "fetchObjectActivity", () => $a979320228ed8cdf$export$6b7eefaef6a2c44d);
$parcel$export(module.exports, "addObjectComment", () => $a979320228ed8cdf$export$f6dfa4000218ad1d);
$parcel$export(module.exports, "editObjectComment", () => $a979320228ed8cdf$export$7d1b391ee8485f05);
$parcel$export(module.exports, "deleteObjectComment", () => $a979320228ed8cdf$export$2cb12c45752cbc87);

var $4VpwK = parcelRequire("4VpwK");

var $5wuEd = parcelRequire("5wuEd");

var $7H1Zx = parcelRequire("7H1Zx");

var $eJOOa = parcelRequire("eJOOa");

var $2NPEB = parcelRequire("2NPEB");

var $cGxHq = parcelRequire("cGxHq");
const $a979320228ed8cdf$export$ee4791a5492db442 = 'insight-object.object-timeline.fetchObjectActivity';
const $a979320228ed8cdf$export$e91a8ecf890eba3f = 'insight-object.object-timeline.storeObjectComment';
const $a979320228ed8cdf$export$dec9bcd2bec0b393 = 'insight-object.object-timeline.updateObjectComment';
const $a979320228ed8cdf$export$8aa0fd36cbb7f0ba = 'insight-object.object-timeline.deleteObjectComment';
const $a979320228ed8cdf$export$6b7eefaef6a2c44d = async ({ workspaceId: workspaceId, objectId: objectId, activityTypes: activityTypes, orderAsc: orderAsc, startAt: startAt, maxResults: maxResults, abortRequestEvent: abortRequestEvent })=>{
    const abortController = new AbortController();
    const abortRequestEventHandler = ()=>{
        abortController.abort();
    };
    if (abortRequestEvent !== undefined) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener(abortRequestEvent.type, abortRequestEventHandler);
    try {
        const queryParams = {
            asc: orderAsc,
            types: activityTypes?.join(',') || undefined,
            startAt: startAt,
            maxResults: maxResults
        };
        const url = (0, $eJOOa.getCmdbObjectByIdActivityUrl)(workspaceId, objectId, queryParams);
        const response = await (0, $4VpwK.performCmdbGetRequest)(url, {
            signal: abortController.signal
        });
        return response;
    } finally{
        if (abortRequestEvent !== undefined) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener(abortRequestEvent.type, abortRequestEventHandler);
    }
};
const $a979320228ed8cdf$export$f6dfa4000218ad1d = async ({ workspaceId: workspaceId, objectId: objectId, role: role, comment: comment })=>{
    try {
        const response = await (0, $4VpwK.performCmdbPostRequest)((0, $7H1Zx.getCmdbObjectCommentUrl)(workspaceId), {
            body: JSON.stringify({
                objectId: objectId,
                role: (0, $cGxHq.getRoleTypeNumber)(role),
                body: comment
            })
        });
        return (0, $cGxHq.transformAddObjectCommentResponse)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return (0, $2NPEB.handleTimelineNetworkError)(error, $a979320228ed8cdf$export$e91a8ecf890eba3f);
    }
};
const $a979320228ed8cdf$export$7d1b391ee8485f05 = async ({ workspaceId: workspaceId, objectId: objectId, role: role, commentId: commentId, comment: comment })=>{
    try {
        const response = await (0, $4VpwK.performCmdbPutRequest)((0, $7H1Zx.getCmdbObjectCommentByIdUrl)(workspaceId, commentId), {
            body: JSON.stringify({
                objectId: objectId,
                role: (0, $cGxHq.getRoleTypeNumber)(role),
                body: comment
            })
        });
        return {
            data: (0, $cGxHq.transformObjectCommentResponse)(response)
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return (0, $2NPEB.handleTimelineNetworkError)(error, $a979320228ed8cdf$export$dec9bcd2bec0b393);
    }
};
const $a979320228ed8cdf$export$2cb12c45752cbc87 = async ({ workspaceId: workspaceId, commentId: commentId })=>{
    try {
        const response = await (0, $4VpwK.performCmdbDeleteRequest)((0, $5wuEd.getCmdbCommentByIdUrl)(workspaceId, commentId));
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return (0, $2NPEB.handleTimelineNetworkError)(error, $a979320228ed8cdf$export$8aa0fd36cbb7f0ba);
    }
};

});
parcelRegister("5wuEd", function(module, exports) {

$parcel$export(module.exports, "getCmdbCommentByIdUrl", () => $fc379b2fd0d3a00f$export$e12a35fe686de11f);

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/comment
 */ const $fc379b2fd0d3a00f$var$getCmdbCommentUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/comment`;
const $fc379b2fd0d3a00f$export$e12a35fe686de11f = (workspaceId, commentId)=>`${$fc379b2fd0d3a00f$var$getCmdbCommentUrl(workspaceId)}/${commentId}`;

});

parcelRegister("7H1Zx", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectCommentUrl", () => $2124073013f04a42$export$362090ff74b0272a);
$parcel$export(module.exports, "getCmdbObjectCommentByIdUrl", () => $2124073013f04a42$export$5ea791df201129d0);

var $klJ8b = parcelRequire("klJ8b");
const $2124073013f04a42$export$362090ff74b0272a = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objectcomment`;
const $2124073013f04a42$export$5ea791df201129d0 = (workspaceId, commentId)=>`${$2124073013f04a42$export$362090ff74b0272a(workspaceId)}/${commentId}`;

});

parcelRegister("cGxHq", function(module, exports) {

$parcel$export(module.exports, "getRoleTypeNumber", () => $93a770d92eb378cc$export$81527d400374fe37);
$parcel$export(module.exports, "transformObjectCommentResponse", () => $93a770d92eb378cc$export$9baafd860eadd7d2);
$parcel$export(module.exports, "transformAddObjectCommentResponse", () => $93a770d92eb378cc$export$67cb00a991a9bc42);
$parcel$export(module.exports, "transformResponse", () => $93a770d92eb378cc$export$3361e9be8093ddcc);

var $vkpPS = parcelRequire("vkpPS");
const $93a770d92eb378cc$var$USER_ATTRIBUTE_HISTORY_EVENTS = {
    TYPE_ADDED_USER: 9,
    TYPE_CHANGED_USER: 10,
    TYPE_DELETED_USER: 11
};
// We need to identify user attribute changes so we can render the profile card
const $93a770d92eb378cc$var$USER_ATTRIBUTE_CHANGE_TYPES = Object.values($93a770d92eb378cc$var$USER_ATTRIBUTE_HISTORY_EVENTS);
// The Insight backend sends a specific numbered type for each type of attribute update CRUD action
// here we group all of these under the "attribute-updated" type and transform the remaining types
// that don't send back a old / new value or attribute name so we can display a custom message instead
const $93a770d92eb378cc$var$getChangeType = (updateType)=>{
    switch(updateType){
        case 0:
            return 'object-created';
        case 7:
            return 'added-attachment';
        case 8:
            return 'deleted-attachment';
        case 24:
            return 'object-type-updated';
        case 25:
            return 'added-avatar';
        case 26:
            return 'changed-avatar';
        case 27:
            return 'deleted-avatar';
        default:
            return 'attribute-updated';
    }
};
const $93a770d92eb378cc$var$commentRoleMapping = Object.freeze({
    '0': 'users',
    '1': 'managers',
    '2': 'administrators',
    '3': 'developers'
});
const $93a770d92eb378cc$var$getRoleType = (roleTypeNumber)=>{
    const roleType = $93a770d92eb378cc$var$commentRoleMapping[`${roleTypeNumber}`];
    if (roleType) return roleType;
    return 'unknown';
};
const $93a770d92eb378cc$export$81527d400374fe37 = (roleType)=>{
    const roleTypeNumber = Object.keys($93a770d92eb378cc$var$commentRoleMapping).find((number)=>$93a770d92eb378cc$var$commentRoleMapping[`${number}`] === roleType);
    if (roleTypeNumber) {
        const roleTypeNumberAsInt = Number.parseInt(roleTypeNumber, 10);
        if (Number.isNaN(roleTypeNumberAsInt) === false) return roleTypeNumberAsInt;
    }
    return undefined;
};
const $93a770d92eb378cc$export$9baafd860eadd7d2 = (response)=>({
        type: (0, $vkpPS.OBJECT_COMMENT_EVENT),
        timestamp: Date.parse(response.created),
        data: {
            id: response.id,
            actor: response.actor,
            comment: response.body,
            role: $93a770d92eb378cc$var$getRoleType(response.role),
            canDelete: response.canDelete,
            canEdit: response.canEdit,
            isEdited: response.updated !== response.created,
            editedTimestamp: Date.parse(response.updated)
        }
    });
const $93a770d92eb378cc$export$67cb00a991a9bc42 = (response)=>({
        data: $93a770d92eb378cc$export$9baafd860eadd7d2(response)
    });
const $93a770d92eb378cc$export$3361e9be8093ddcc = (response)=>{
    if (!response) return [];
    const data = response.values.map((objectActivity)=>{
        switch(objectActivity.activityType){
            case 'comment':
                return $93a770d92eb378cc$export$9baafd860eadd7d2(objectActivity.activity);
            case 'history':
                {
                    const objectHistory = objectActivity.activity;
                    const objectChangeType = $93a770d92eb378cc$var$getChangeType(objectHistory.type);
                    const isUserAttributeChange = $93a770d92eb378cc$var$USER_ATTRIBUTE_CHANGE_TYPES.includes(objectHistory.type);
                    return {
                        type: (0, $vkpPS.OBJECT_UPDATE_EVENT),
                        timestamp: Date.parse(objectHistory.created),
                        data: {
                            id: objectHistory.id,
                            changeType: objectChangeType,
                            actor: objectHistory.actor,
                            attributeName: objectHistory.affectedAttribute,
                            isUserAttribute: isUserAttributeChange ?? false,
                            oldValue: objectHistory.oldValue,
                            newValue: objectHistory.newValue
                        }
                    };
                }
            default:
                // Do nothing with unknown event types
                return null;
        }
    })// Filter out 'null' values
    .filter((timelineEvent)=>!!timelineEvent);
    return data;
};

});


parcelRegister("4aQG9", function(module, exports) {

$parcel$export(module.exports, "getServiceEventNameByStoreEvent", () => $0e15ddbc8a7b6fae$export$f85bb8a7abde8cc4);

var $vkpPS = parcelRequire("vkpPS");

const $0e15ddbc8a7b6fae$export$f85bb8a7abde8cc4 = (storeEvent)=>{
    switch(storeEvent){
        case 0, $vkpPS.OBJECT_COMMENT_EVENT:
            return 0, $768a12ddedd85d8c$export$48a1bcb19cf33333;
        case 0, $vkpPS.OBJECT_UPDATE_EVENT:
            return 0, $768a12ddedd85d8c$export$a470afcd605edb16;
        default:
            return undefined;
    }
};

});
const $768a12ddedd85d8c$export$48a1bcb19cf33333 = 'comment';
const $768a12ddedd85d8c$export$a470afcd605edb16 = 'history';



parcelRegister("a8rNj", function(module, exports) {

$parcel$export(module.exports, "fetchChangesAndIncidentsNextPage", () => $888be67f3e6af6c5$export$628f7ef171dedfda);

var $xJtdX = parcelRequire("xJtdX");

var $vkpPS = parcelRequire("vkpPS");

var $6MCGd = parcelRequire("6MCGd");
const $888be67f3e6af6c5$export$8ec3d08588d2eeda = 50;
const $888be67f3e6af6c5$export$628f7ef171dedfda = ({ affectedServicesFieldId: affectedServicesFieldId, requestTypeFieldId: requestTypeFieldId, serviceId: serviceId })=>async ({ getState: getState, setState: setState })=>{
        if (affectedServicesFieldId == null || requestTypeFieldId == null || serviceId == null) return;
        const existingState = getState();
        if (existingState.loading || existingState.page.isLast) return;
        setState({
            ...existingState,
            loading: true,
            error: null
        });
        const start = existingState.page.current * $888be67f3e6af6c5$export$8ec3d08588d2eeda;
        const serviceResponse = await (0, $6MCGd.fetchChangesAndIncidents)(affectedServicesFieldId, requestTypeFieldId, serviceId, start, $888be67f3e6af6c5$export$8ec3d08588d2eeda);
        if ((0, $vkpPS.isTimelineEventsServiceResponseData)(serviceResponse)) setState({
            ...existingState,
            timelineEvents: (existingState.timelineEvents ?? []).concat(serviceResponse.data),
            loading: false,
            error: null,
            page: {
                current: existingState.page.current + 1,
                isLast: serviceResponse.data.length < $888be67f3e6af6c5$export$8ec3d08588d2eeda
            }
        });
        else if ((0, $vkpPS.isTimelineEventsServiceResponseError)(serviceResponse)) {
            setState({
                ...existingState,
                loading: false,
                error: serviceResponse.error
            });
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchTimelineEventsNextPage',
                    packageName: 'jiraServicedeskInsightObjectActivityTimelineStore'
                },
                attributes: {
                    errorType: serviceResponse.error
                }
            });
        }
    };

});
parcelRegister("6MCGd", function(module, exports) {

$parcel$export(module.exports, "fetchChangesAndIncidents", () => $7d4025df4d046187$export$4990327a6f9a38ad);

var $4VpwK = parcelRequire("4VpwK");

var $bmGkm = parcelRequire("bmGkm");

var $oCMSG = parcelRequire("oCMSG");

var $vkpPS = parcelRequire("vkpPS");

var $2NPEB = parcelRequire("2NPEB");
const $7d4025df4d046187$var$LOGGER_LOCATION = 'insight-object.object-timeline.fetchChangesAndIncidents';
const $7d4025df4d046187$export$48314f791897fe3f = '/rest/api/3/search';
const $7d4025df4d046187$var$getQuery = (affectedServicesJQLFieldName, serviceId)=>`("Ticket category" = Changes OR "Ticket category" = Incidents) AND ${affectedServicesJQLFieldName} = "${serviceId}" ORDER BY created DESC`;
const $7d4025df4d046187$var$transformIssueSearchResponse = (jiraApiResponse, affectedServicesFieldId, requestTypeFieldId)=>{
    const getChangeEvent = ({ id: id, key: key, fields: fields })=>({
            type: (0, $vkpPS.CHANGE_EVENT),
            timestamp: Date.parse(fields.created),
            location: `/browse/${key}`,
            data: {
                id: id,
                statusCategoryId: fields.status.statusCategory.id,
                statusCategory: fields.status.statusCategory.name,
                issueSummary: fields.summary,
                issueStatus: fields.status.name,
                issueKey: key,
                issuePriorityUrl: fields.priority?.iconUrl,
                issuePriorityName: fields.priority?.name,
                issueTypeIconUrl: fields.issuetype.iconUrl
            }
        });
    const getIncidentEvent = ({ id: id, key: key, fields: fields })=>({
            type: (0, $vkpPS.INCIDENT_EVENT),
            timestamp: Date.parse(fields.created),
            location: `/browse/${key}`,
            data: {
                id: id,
                statusCategoryId: fields.status.statusCategory.id,
                statusCategory: fields.status.statusCategory.name,
                issueSummary: fields.summary,
                issueStatus: fields.status.name,
                issueKey: key,
                issuePriorityUrl: fields.priority?.iconUrl,
                issuePriorityName: fields.priority?.name,
                issueTypeIconUrl: fields.issuetype.iconUrl
            }
        });
    if (jiraApiResponse.issues) return {
        data: jiraApiResponse.issues.filter((issue)=>[
                (0, $oCMSG.CHANGES),
                (0, $oCMSG.INCIDENTS)
            ].includes(issue.fields[requestTypeFieldId]?.requestType?.practice)).map((issue)=>issue.fields[requestTypeFieldId].requestType.practice === (0, $oCMSG.CHANGES) ? getChangeEvent(issue) : getIncidentEvent(issue))
    };
    return {
        data: []
    };
};
const $7d4025df4d046187$export$4990327a6f9a38ad = async (affectedServicesFieldId, requestTypeFieldId, serviceId, start = 0, maxResults = 50)=>{
    try {
        const affectedServicesJQLAlias = (0, $bmGkm.getFieldNameForJql)(affectedServicesFieldId);
        const response = await (0, $4VpwK.performCmdbPostRequest)($7d4025df4d046187$export$48314f791897fe3f, {
            body: JSON.stringify({
                jql: $7d4025df4d046187$var$getQuery(affectedServicesJQLAlias, serviceId),
                expand: [
                    'renderedFields',
                    `${requestTypeFieldId}.requestTypePractice`
                ],
                startAt: start,
                maxResults: maxResults
            })
        });
        return $7d4025df4d046187$var$transformIssueSearchResponse(response, affectedServicesFieldId, requestTypeFieldId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return (0, $2NPEB.handleTimelineNetworkError)(error, $7d4025df4d046187$var$LOGGER_LOCATION);
    }
};

});
parcelRegister("bmGkm", function(module, exports) {

$parcel$export(module.exports, "CF_SEPARATOR", () => $491aa897da8c675b$export$a3c7258f137a756c);
$parcel$export(module.exports, "emptyServicesWithActiveIncidentsObject", () => $491aa897da8c675b$export$a0b24f075062292d);
$parcel$export(module.exports, "mapJiraSearchApiIssueToRelatedRequestedIssue", () => $491aa897da8c675b$export$ac2f076b1102f25a);
$parcel$export(module.exports, "mapIssuesToServicesWithActiveIncidents", () => $491aa897da8c675b$export$b06c80bd5e8a80f9);
$parcel$export(module.exports, "getFieldNameForJql", () => $491aa897da8c675b$export$f958f2fd5423f7cc);
const $491aa897da8c675b$export$a3c7258f137a756c = 'customfield_';
const $491aa897da8c675b$export$a0b24f075062292d = (serviceids)=>{
    const serviceIdIssues = {};
    return serviceids.reduce((accServiceIdIssues, serviceId)=>({
            [serviceId]: [],
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...accServiceIdIssues
        }), serviceIdIssues);
};
const $491aa897da8c675b$export$ac2f076b1102f25a = (issue, affectedServicesFieldId, plannedStartTimeFieldId, plannedEndTimeFieldId)=>{
    const issueUrl = `/browse/${issue.key}`;
    return {
        id: issue.id,
        issueKey: issue.key,
        issueSummary: issue.fields.summary,
        issueTypeIconUrl: issue.fields.issuetype.iconUrl,
        issueLink: issueUrl,
        issueTypeName: issue.fields.issuetype.name,
        issuePriorityUrl: issue.fields.priority?.iconUrl,
        issuePriorityName: issue.fields.priority?.name,
        statusCategory: issue.fields.status.statusCategory.name,
        statusCategoryId: issue.fields.status.statusCategory.id,
        statusId: issue.fields.status.id,
        statusName: issue.fields.status.name,
        assigneeUrl: issue.fields.assignee?.avatarUrls['48x48'],
        assigneeDisplayName: issue.fields.assignee?.displayName,
        created: Date.parse(issue.fields.created),
        isResolved: !!issue.fields.resolution,
        resolutiondate: issue.fields.resolutiondate !== undefined ? Date.parse(issue.fields.resolutiondate) : undefined,
        services: issue.renderedFields ? issue.renderedFields[affectedServicesFieldId] : [],
        plannedStartTime: typeof plannedStartTimeFieldId === 'string' && issue.fields ? issue.fields[plannedStartTimeFieldId] : undefined,
        plannedEndTime: typeof plannedEndTimeFieldId === 'string' && issue.fields ? issue.fields[plannedEndTimeFieldId] : undefined
    };
};
const $491aa897da8c675b$export$b06c80bd5e8a80f9 = (issues, serviceIds, affectedServicesFieldId)=>issues.reduce((accServiceIdIssues, issue)=>{
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        const currentServiceIdIssues = {
            ...accServiceIdIssues
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        issue.fields[affectedServicesFieldId]?.forEach((issueAssociatedService)=>{
            if (currentServiceIdIssues[issueAssociatedService.id]) currentServiceIdIssues[issueAssociatedService.id].push($491aa897da8c675b$export$ac2f076b1102f25a(issue, affectedServicesFieldId));
        });
        return currentServiceIdIssues;
    }, $491aa897da8c675b$export$a0b24f075062292d(serviceIds));
const $491aa897da8c675b$export$f958f2fd5423f7cc = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    const customFieldId = fieldName.split($491aa897da8c675b$export$a3c7258f137a756c)[1];
    return `cf[${customFieldId}]`;
};

});



parcelRegister("b7Dzp", function(module, exports) {

$parcel$export(module.exports, "addObjectComment", () => $2021b525b8973220$export$f6dfa4000218ad1d);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $vkpPS = parcelRequire("vkpPS");

var $fOkMl = parcelRequire("fOkMl");
const $2021b525b8973220$export$f6dfa4000218ad1d = ({ role: role, comment: comment, actor: actor, onFailure: onFailure })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, objectId: objectId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const timestamp = Date.now();
        const optimisticServiceResponse = {
            data: {
                data: {
                    id: `optimistic-id-${timestamp}`,
                    actor: actor,
                    comment: comment,
                    role: role,
                    canEdit: false,
                    canDelete: false,
                    isSaving: true,
                    isEdited: false,
                    editedTimestamp: timestamp
                },
                timestamp: timestamp,
                type: (0, $vkpPS.OBJECT_COMMENT_EVENT)
            }
        };
        setState({
            timelineEvents: [
                optimisticServiceResponse.data,
                ...getState().timelineEvents ?? []
            ]
        });
        const serviceResponse = await (0, $fOkMl.addObjectComment)({
            workspaceId: workspaceId,
            objectId: objectId,
            role: role,
            comment: comment
        });
        const latestTimelineEvents = getState().timelineEvents ?? [];
        const latestTimelineEventsWithoutOptimistic = latestTimelineEvents.filter((timeLineEvent)=>timeLineEvent.data.id !== optimisticServiceResponse.data.data.id);
        if ((0, $vkpPS.isAddObjectCommentServiceResponseData)(serviceResponse)) {
            setState({
                timelineEvents: [
                    serviceResponse.data,
                    ...latestTimelineEventsWithoutOptimistic
                ]
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'storeObjectComment succeeded');
        } else if (serviceResponse.error) {
            // Revert the optimistic resposone
            setState({
                timelineEvents: latestTimelineEventsWithoutOptimistic
            });
            onFailure(serviceResponse.error);
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: serviceResponse.rawError,
                meta: {
                    id: 'storeObjectComment',
                    packageName: 'jiraServicedeskInsightObjectActivityTimelineStore',
                    teamName: 'falcons'
                },
                attributes: {
                    errorType: serviceResponse.error,
                    errorMessage: serviceResponse.rawError.message
                }
            });
        }
    };

});

parcelRegister("7KrN9", function(module, exports) {

$parcel$export(module.exports, "deleteObjectComment", () => $5520073c680fb862$export$2cb12c45752cbc87);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $fOkMl = parcelRequire("fOkMl");
const $5520073c680fb862$export$2cb12c45752cbc87 = ({ commentId: commentId, onSuccess: onSuccess, onFailure: onFailure })=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        const serviceResponse = await (0, $fOkMl.deleteObjectComment)({
            workspaceId: workspaceId,
            commentId: commentId
        });
        // An empty response indicates the delete request was successful
        if (serviceResponse == null) {
            const latestTimelineEvents = getState().timelineEvents ?? [];
            setState({
                timelineEvents: [
                    ...latestTimelineEvents.filter((timelineEvent)=>timelineEvent.data.id !== commentId)
                ]
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'deleteObjectComment succeeded');
            onSuccess();
        } else {
            onFailure(serviceResponse.error);
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: serviceResponse.rawError,
                meta: {
                    id: 'deleteObjectComment',
                    packageName: 'jiraServicedeskInsightObjectActivityTimelineStore',
                    teamName: 'falcons'
                },
                attributes: {
                    errorType: serviceResponse.error,
                    errorMessage: serviceResponse.rawError.message
                }
            });
        }
    };

});

parcelRegister("5Pzed", function(module, exports) {

$parcel$export(module.exports, "updateObjectComment", () => $94d7cf5e24d7145d$export$5732eba4a86a3a7);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $vkpPS = parcelRequire("vkpPS");

var $fOkMl = parcelRequire("fOkMl");

var $9jrNx = parcelRequire("9jrNx");
const $94d7cf5e24d7145d$var$getCommentById = (commentId, storeState)=>{
    const comment = (storeState.timelineEvents ?? []).find((e)=>e.type === (0, $vkpPS.OBJECT_COMMENT_EVENT) && e.data.id === commentId);
    // Have to check `.type` again, otherwise flow complains
    if (!comment || comment.type !== (0, $vkpPS.OBJECT_COMMENT_EVENT)) throw new Error("Attempting to update comment that doesn't exist");
    return comment;
};
const $94d7cf5e24d7145d$export$5732eba4a86a3a7 = ({ role: role, comment: comment, onFailure: onFailure, commentId: commentId })=>async ({ dispatch: dispatch, getState: getState }, { workspaceId: workspaceId, objectId: objectId, createAnalyticsEvent: createAnalyticsEvent })=>{
        try {
            // Store the original comment in case of error
            const originalComment = $94d7cf5e24d7145d$var$getCommentById(commentId, getState());
            // Optimistically update the existing comment in the store
            dispatch((0, $9jrNx.updateCommentStateById)(commentId, {
                isSaving: true,
                comment: comment,
                role: role
            }));
            const serviceResponse = await (0, $fOkMl.editObjectComment)({
                workspaceId: workspaceId,
                objectId: objectId,
                role: role,
                commentId: commentId,
                comment: comment
            });
            if ((0, $vkpPS.isUpdateObjectCommentServiceResponseData)(serviceResponse)) {
                const { data: data } = serviceResponse.data;
                // Overwrite the optimistic comment with the server response
                dispatch((0, $9jrNx.updateCommentStateById)(commentId, {
                    ...data,
                    isSaving: false
                }));
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateObjectComment succeeded');
            } else if (serviceResponse.error) {
                // Overwrite the optimistically updated comment with the original unedited comment
                dispatch((0, $9jrNx.updateCommentStateById)(commentId, {
                    ...originalComment.data,
                    isSaving: false
                }));
                throw serviceResponse.rawError;
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onFailure();
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'updateObjectComment',
                    packageName: 'jiraServicedeskInsightObjectActivityTimelineStore',
                    teamName: 'falcons'
                },
                attributes: {
                    errorMessage: error.message
                }
            });
        }
    };

});
parcelRegister("9jrNx", function(module, exports) {

$parcel$export(module.exports, "updateCommentStateById", () => $b7db79e733e3c517$export$3360a32fbb434f87);

var $vkpPS = parcelRequire("vkpPS");
const $b7db79e733e3c517$export$3360a32fbb434f87 = (commentId, updatedCommentData)=>async ({ setState: setState, getState: getState })=>{
        const existingEvents = getState().timelineEvents ?? [];
        setState({
            timelineEvents: [
                ...existingEvents.map((event)=>{
                    if (event.type === (0, $vkpPS.OBJECT_COMMENT_EVENT) && event.data.id === commentId) return {
                        ...event,
                        data: {
                            ...event.data,
                            ...updatedCommentData
                        }
                    };
                    return event;
                })
            ]
        });
    };

});




parcelRegister("9le7J", function(module, exports) {

$parcel$export(module.exports, "ObjectDetailsContainer", () => $15a2d43e9a51b9a6$export$f443e8de0fbd653);

var $cE4vK = parcelRequire("cE4vK");

var $gg7kZ = parcelRequire("gg7kZ");

var $7rHNv = parcelRequire("7rHNv");

var $66Vf6 = parcelRequire("66Vf6");

var $2zr8Q = parcelRequire("2zr8Q");
const $15a2d43e9a51b9a6$export$f443e8de0fbd653 = (0, $gg7kZ.createContainer)((0, $66Vf6.Store), {
    onInit: ()=>({ setState: setState, dispatch: dispatch }, { initialObjectDetailsData: initialObjectDetailsData })=>{
            setState({
                objectDetails: {
                    ...(0, $cE4vK.normalizeObjectDetailsResponse)(initialObjectDetailsData),
                    editableAttributeTypes: undefined
                },
                hideEmptyAttributes: (0, $2zr8Q.getHideEmptyAttributes)(initialObjectDetailsData.objectType.id)
            });
            dispatch((0, $7rHNv.fetchObjectViewInitialData)());
        }
});

});
parcelRegister("cE4vK", function(module, exports) {

$parcel$export(module.exports, "toAttributeType", () => $e5a3cb1273e2bd0d$export$720a7caa078a04b0);
$parcel$export(module.exports, "normalizeAttributeTypeResponse", () => $e5a3cb1273e2bd0d$export$c5f92fa9faff4a5e);
$parcel$export(module.exports, "normalizeAttributeTypesResponse", () => $e5a3cb1273e2bd0d$export$d6675b3ab298ac1f);
$parcel$export(module.exports, "normalizeObjectAttributeResponse", () => $e5a3cb1273e2bd0d$export$ab549e9cd750448c);
$parcel$export(module.exports, "normalizeObjectDetailsResponse", () => $e5a3cb1273e2bd0d$export$1ac2dbbd05bc2ac7);

var $xJtdX = parcelRequire("xJtdX");

var $5Ny9E = parcelRequire("5Ny9E");

var $3kCov = parcelRequire("3kCov");

var $kCYNT = parcelRequire("kCYNT");
const $e5a3cb1273e2bd0d$export$720a7caa078a04b0 = (attributeTypeAsNumber)=>{
    switch(attributeTypeAsNumber){
        case (0, $3kCov.AttributeTypeNumbers).default:
            return 'default';
        case (0, $3kCov.AttributeTypeNumbers).object:
            return 'object';
        case (0, $3kCov.AttributeTypeNumbers).user:
            return 'user';
        case (0, $3kCov.AttributeTypeNumbers).group:
            return 'group';
        case (0, $3kCov.AttributeTypeNumbers).project:
            return 'project';
        case (0, $3kCov.AttributeTypeNumbers).status:
            return 'status';
        case (0, $3kCov.AttributeTypeNumbers).bitbucketRepo:
            return 'bitbucketRepo';
        case (0, $3kCov.AttributeTypeNumbers).opsgenieTeam:
            return 'opsgenieTeam';
        default:
            {
                const attributeTypeAsNumberExhaustive = attributeTypeAsNumber;
                const error = new Error(`Invalid attribute type provided from Insight service found: ${attributeTypeAsNumberExhaustive}`);
                (0, $xJtdX.fireCmdbErrorAnalytics)({
                    meta: {
                        id: 'invalid.attribute.type',
                        packageName: 'jiraServicedeskInsightObjectTypes',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
    }
};
const $e5a3cb1273e2bd0d$var$assertDefined = (value)=>{
    if (value != null) return value;
    (0, $xJtdX.fireCmdbErrorAnalytics)({
        meta: {
            id: 'missing.property.from.insight.service',
            packageName: 'jiraServicedeskInsightObjectTypes'
        }
    });
    throw new Error('Expected value from Insight service is null or undefined');
};
const $e5a3cb1273e2bd0d$export$c5f92fa9faff4a5e = ({ type: type, defaultType: defaultType, suffix: suffix, regexValidation: regexValidation, referenceType: referenceType, referenceObjectType: referenceObjectType, ...attributeType })=>(0, $kCYNT.matchAttributeType)($e5a3cb1273e2bd0d$export$720a7caa078a04b0(type), {
        default: ()=>({
                ...attributeType,
                defaultType: $e5a3cb1273e2bd0d$var$assertDefined(defaultType),
                suffix: suffix,
                regexValidation: regexValidation,
                type: 'default'
            }),
        object: ()=>({
                ...attributeType,
                referenceType: $e5a3cb1273e2bd0d$var$assertDefined(referenceType),
                referenceObjectType: $e5a3cb1273e2bd0d$var$assertDefined(referenceObjectType),
                type: 'object'
            }),
        user: ()=>({
                ...attributeType,
                type: 'user'
            }),
        group: ()=>({
                ...attributeType,
                type: 'group'
            }),
        project: ()=>({
                ...attributeType,
                type: 'project'
            }),
        status: ()=>({
                ...attributeType,
                type: 'status'
            }),
        bitbucketRepo: ()=>({
                ...attributeType,
                type: 'bitbucketRepo'
            }),
        opsgenieTeam: ()=>({
                ...attributeType,
                type: 'opsgenieTeam'
            })
    });
const $e5a3cb1273e2bd0d$export$d6675b3ab298ac1f = (attributeTypes)=>attributeTypes.map((objectTypeAttributeResponse)=>$e5a3cb1273e2bd0d$export$c5f92fa9faff4a5e(objectTypeAttributeResponse));
const $e5a3cb1273e2bd0d$export$ab549e9cd750448c = (attributeResponse)=>{
    const { objectId: objectId, workspaceId: workspaceId, ...rest } = attributeResponse;
    const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute, objectAttributeValues: objectAttributeValues } = rest;
    const attributeCommon = {
        objectTypeAttributeId: (0, $5Ny9E.toObjectTypeAttributeId)(objectTypeAttributeId)
    };
    return (0, $kCYNT.matchAttributeType)($e5a3cb1273e2bd0d$export$720a7caa078a04b0(attributeResponse.objectTypeAttribute.type), {
        default: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'default',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'default',
                    defaultType: $e5a3cb1273e2bd0d$var$assertDefined(objectTypeAttribute.defaultType)
                },
                defaultTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, group: group, project: project, user: user, status: status, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        value: attrValue.value
                    };
                })
            };
        },
        object: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'object',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'object',
                    referenceType: $e5a3cb1273e2bd0d$var$assertDefined(objectTypeAttribute.referenceType),
                    referenceObjectType: $e5a3cb1273e2bd0d$var$assertDefined(objectTypeAttribute.referenceObjectType)
                },
                objectTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { bitbucketRepo: bitbucketRepo, group: group, project: project, user: user, status: status, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        referencedObject: $e5a3cb1273e2bd0d$var$assertDefined(attrValue.referencedObject)
                    };
                })
            };
        },
        user: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'user',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'user'
                },
                userTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { bitbucketRepo: bitbucketRepo, referencedObject: referencedObject, project: project, group: group, status: status, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        user: $e5a3cb1273e2bd0d$var$assertDefined(attrValue.user)
                    };
                })
            };
        },
        group: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'group',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'group'
                },
                groupTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { bitbucketRepo: bitbucketRepo, referencedObject: referencedObject, project: project, user: user, status: status, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        group: $e5a3cb1273e2bd0d$var$assertDefined(attrValue.group)
                    };
                })
            };
        },
        project: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'project',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'project'
                },
                projectTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { bitbucketRepo: bitbucketRepo, referencedObject: referencedObject, user: user, group: group, status: status, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        project: $e5a3cb1273e2bd0d$var$assertDefined(attrValue.project)
                    };
                })
            };
        },
        status: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'status',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'status'
                },
                statusTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { bitbucketRepo: bitbucketRepo, referencedObject: referencedObject, user: user, group: group, project: project, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        status: $e5a3cb1273e2bd0d$var$assertDefined(attrValue.status)
                    };
                })
            };
        },
        bitbucketRepo: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'bitbucketRepo',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'bitbucketRepo'
                },
                bitbucketRepoTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, user: user, group: group, project: project, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        bitbucketRepo: $e5a3cb1273e2bd0d$var$assertDefined(attrValue.bitbucketRepo)
                    };
                })
            };
        },
        opsgenieTeam: ()=>{
            const { type: type, ...withoutNumberType } = objectTypeAttribute;
            return {
                ...attributeCommon,
                type: 'opsgenieTeam',
                objectTypeAttribute: {
                    ...withoutNumberType,
                    type: 'opsgenieTeam'
                },
                opsgenieTeamTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, user: user, group: group, project: project, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        opsgenieTeam: $e5a3cb1273e2bd0d$var$assertDefined(attrValue.opsgenieTeam)
                    };
                })
            };
        }
    });
};
const $e5a3cb1273e2bd0d$export$1ac2dbbd05bc2ac7 = (objectDetails)=>{
    const normalisedAttributes = objectDetails.attributes.map((attributeResponse)=>$e5a3cb1273e2bd0d$export$ab549e9cd750448c(attributeResponse));
    return {
        ...objectDetails,
        attributes: normalisedAttributes
    };
};

});
parcelRegister("3kCov", function(module, exports) {

$parcel$export(module.exports, "AttributeTypeNumbers", () => $7f9dd07c61ce5341$export$537905fc88c8f191);
const $7f9dd07c61ce5341$export$537905fc88c8f191 = {
    default: 0,
    object: 1,
    user: 2,
    group: 4,
    project: 6,
    status: 7,
    bitbucketRepo: 8,
    opsgenieTeam: 9
};

});

parcelRegister("kCYNT", function(module, exports) {

$parcel$export(module.exports, "defaultTypesById", () => $7613862d09cb6470$export$ed8b555acc54193b);
$parcel$export(module.exports, "matchAttributeType", () => $7613862d09cb6470$export$69224db698d1c3c3);
$parcel$export(module.exports, "matchInsightObjectAttributeType", () => $7613862d09cb6470$export$6499e045f2464672);
$parcel$export(module.exports, "matchInsightObjectAttribute", () => $7613862d09cb6470$export$b8b765eb52fe9337);
$parcel$export(module.exports, "matchDefaultAttributeSubType", () => $7613862d09cb6470$export$be874703ff226e1);
$parcel$export(module.exports, "matchDefaultAttribute", () => $7613862d09cb6470$export$f7a928b702c26457);

var $xJtdX = parcelRequire("xJtdX");
const $7613862d09cb6470$export$ed8b555acc54193b = {
    0: 'text',
    1: 'integer',
    2: 'boolean',
    3: 'float',
    4: 'date',
    6: 'datetime',
    7: 'url',
    8: 'email',
    9: 'textarea',
    10: 'select',
    11: 'ip address'
};
const $7613862d09cb6470$export$69224db698d1c3c3 = (attributeType, handlers)=>{
    switch(attributeType){
        case 'default':
            return handlers.default();
        case 'object':
            return handlers.object();
        case 'user':
            return handlers.user();
        case 'group':
            return handlers.group();
        case 'project':
            return handlers.project();
        case 'status':
            return handlers.status();
        case 'bitbucketRepo':
            return handlers.bitbucketRepo();
        case 'opsgenieTeam':
            return handlers.opsgenieTeam();
        default:
            {
                const error = new Error(`Unknown attribute type: ${attributeType}`);
                (0, $xJtdX.fireCmdbErrorAnalytics)({
                    meta: {
                        id: 'type-matcher.invalid.attribute.type',
                        packageName: 'jiraServicedeskInsightObjectTypes',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
    }
};
const $7613862d09cb6470$export$6499e045f2464672 = (attributeType, handlers)=>{
    switch(attributeType.type){
        case 'default':
            return handlers.default(attributeType);
        case 'object':
            return handlers.object(attributeType);
        case 'user':
            return handlers.user(attributeType);
        case 'group':
            return handlers.group(attributeType);
        case 'project':
            return handlers.project(attributeType);
        case 'status':
            return handlers.status(attributeType);
        case 'bitbucketRepo':
            return handlers.bitbucketRepo(attributeType);
        case 'opsgenieTeam':
            return handlers.opsgenieTeam(attributeType);
        default:
            {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const error = new Error(`Unknown attribute type: ${attributeType.type}`);
                (0, $xJtdX.fireCmdbErrorAnalytics)({
                    meta: {
                        id: 'type-matcher.invalid.insight.object.attribute.type',
                        packageName: 'jiraServicedeskInsightObjectTypes',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
    }
};
const $7613862d09cb6470$export$b8b765eb52fe9337 = (attribute, handlers)=>{
    switch(attribute.type){
        case 'default':
            return handlers.default(attribute);
        case 'object':
            return handlers.object(attribute);
        case 'user':
            return handlers.user(attribute);
        case 'group':
            return handlers.group(attribute);
        case 'project':
            return handlers.project(attribute);
        case 'status':
            return handlers.status(attribute);
        case 'bitbucketRepo':
            return handlers.bitbucketRepo(attribute);
        case 'opsgenieTeam':
            return handlers.opsgenieTeam(attribute);
        default:
            {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const error = new Error(`Unknown attribute type: ${attribute.type}`);
                (0, $xJtdX.fireCmdbErrorAnalytics)({
                    meta: {
                        id: 'type-matcher.invalid.insight.object.attribute',
                        packageName: 'jiraServicedeskInsightObjectTypes',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
    }
};
const $7613862d09cb6470$export$be874703ff226e1 = (defaultType, handlers)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const defaultSubType = $7613862d09cb6470$export$ed8b555acc54193b[defaultType.id];
    switch(defaultSubType){
        case 'url':
            return handlers.url();
        case 'email':
            return handlers.email();
        case 'float':
            return handlers.float();
        case 'integer':
            return handlers.integer();
        case 'ip address':
            return handlers.ipAddress();
        case 'text':
            return handlers.text();
        case 'textarea':
            return handlers.textarea();
        case 'select':
            return handlers.select();
        case 'boolean':
            return handlers.boolean();
        case 'date':
            return handlers.date();
        case 'datetime':
            return handlers.datetime();
        default:
            {
                const error = new Error(`Unknown default attribute type id: ${defaultType.id}`);
                (0, $xJtdX.fireCmdbErrorAnalytics)({
                    meta: {
                        id: 'type-matcher.invalid.default..attribute.subtype',
                        packageName: 'jiraServicedeskInsightObjectTypes',
                        teamName: 'falcons'
                    },
                    error: error
                });
                throw error;
            }
    }
};
const $7613862d09cb6470$var$firstItemOrNull = (values)=>{
    const [first = null] = values;
    return first;
};
const $7613862d09cb6470$var$filterEmptyOrNullValues = (values)=>values.filter((value)=>value != null && value !== '');
const $7613862d09cb6470$export$f7a928b702c26457 = (defaultAttribute, handlers)=>{
    const values = defaultAttribute.defaultTypeValues.map(({ value: value })=>value);
    const nonNullValues = $7613862d09cb6470$var$filterEmptyOrNullValues(values);
    const firstValue = $7613862d09cb6470$var$firstItemOrNull(values);
    return $7613862d09cb6470$export$be874703ff226e1(defaultAttribute.objectTypeAttribute.defaultType, {
        url: ()=>handlers.url(nonNullValues),
        email: ()=>handlers.email(nonNullValues),
        float: ()=>handlers.float(firstValue),
        integer: ()=>handlers.integer(firstValue),
        ipAddress: ()=>handlers.ipAddress(firstValue),
        text: ()=>handlers.text(firstValue),
        textarea: ()=>handlers.textarea(firstValue),
        select: ()=>handlers.select(values),
        boolean: ()=>handlers.boolean(firstValue !== null ? firstValue === 'true' : null),
        date: ()=>handlers.date(firstValue),
        datetime: ()=>handlers.datetime(firstValue)
    });
};

});


parcelRegister("7rHNv", function(module, exports) {

$parcel$export(module.exports, "fetchObjectViewInitialData", () => $37449263f51e30da$export$f2b708174b8e320a);

var $9WS7a = parcelRequire("9WS7a");

var $f0mE9 = parcelRequire("f0mE9");
const $37449263f51e30da$export$f2b708174b8e320a = ()=>async ({ setState: setState, dispatch: dispatch })=>{
        setState({
            loading: true
        });
        const objectConfigRequest = dispatch((0, $f0mE9.fetchObjectConfiguration)());
        const editableAttributeTypesRequest = dispatch((0, $9WS7a.fetchEditableAttributeTypes)());
        try {
            await Promise.all([
                objectConfigRequest,
                editableAttributeTypesRequest
            ]);
        } finally{
            setState({
                loading: false
            });
        }
    };

});
parcelRegister("9WS7a", function(module, exports) {

$parcel$export(module.exports, "fetchEditableAttributeTypes", () => $6407bf5090752dec$export$dc5992157a053332);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $7T5mH = parcelRequire("7T5mH");

var $cE4vK = parcelRequire("cE4vK");

var $bOHaD = parcelRequire("bOHaD");
const $6407bf5090752dec$export$dc5992157a053332 = ()=>async ({ getState: getState, setState: setState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        try {
            const { objectDetails: objectDetails } = getState();
            if (objectDetails) {
                const { objectType: objectType } = objectDetails;
                const { id: objectTypeId } = objectType;
                const attributeTypes = await (0, $4VpwK.performCmdbGetRequest)((0, $7T5mH.getCmdbObjectTypeByIdAttributesUrl)(workspaceId, objectTypeId, {
                    onlyValueEditable: true
                }));
                setState({
                    objectDetails: {
                        ...objectDetails,
                        // @ts-expect-error - TS7006 - Parameter 'attributeType' implicitly has an 'any' type.
                        editableAttributeTypes: attributeTypes.map((attributeType)=>{
                            const { type: type, ...rest } = attributeType;
                            return {
                                ...rest,
                                type: (0, $cE4vK.toAttributeType)(type)
                            };
                        })
                    }
                });
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchEditableAttributeTypes succeeded');
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                error: error
            });
            if ((0, $bOHaD.isSignal)(error)) (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchEditableAttributeTypes',
                    packageName: 'jiraServicedeskInsightObjectDetailsStore',
                    teamName: 'falcons'
                },
                error: error
            });
        }
    };

});
parcelRegister("7T5mH", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectTypeByIdUrl", () => $102a0eb1d1d95dbf$export$6f3a42f18d151e67);
$parcel$export(module.exports, "getCmdbObjectTypeByIdAttributesUrl", () => $102a0eb1d1d95dbf$export$3af2a99fe1215c98);
$parcel$export(module.exports, "getCmdbObjectTypeByIdDeleteObjectsUrl", () => $102a0eb1d1d95dbf$export$2ff51a9674e9ef8e);
$parcel$export(module.exports, "getCmdbObjectTypeByIdObjectsUrl", () => $102a0eb1d1d95dbf$export$cc2331466d0bc62a);
$parcel$export(module.exports, "getCmdbObjectTypeByIdPositionUrl", () => $102a0eb1d1d95dbf$export$a636cbbc1532dae1);
$parcel$export(module.exports, "getCmdbObjectTypeCopyUrl", () => $102a0eb1d1d95dbf$export$f57e47ec92312ade);
$parcel$export(module.exports, "getCmdbObjectTypeCreateUrl", () => $102a0eb1d1d95dbf$export$95f3087e511a1510);
$parcel$export(module.exports, "getCmdbObjectTypeBulkEditUrl", () => $102a0eb1d1d95dbf$export$64aa1993d4a6b92c);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objecttype
 */ const $102a0eb1d1d95dbf$var$getCmdbObjectTypeUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objecttype`;
const $102a0eb1d1d95dbf$export$6f3a42f18d151e67 = (workspaceId, objectTypeId)=>`${$102a0eb1d1d95dbf$var$getCmdbObjectTypeUrl(workspaceId)}/${objectTypeId}`;
const $102a0eb1d1d95dbf$export$3af2a99fe1215c98 = (workspaceId, objectTypeId, queryParams)=>`${$102a0eb1d1d95dbf$export$6f3a42f18d151e67(workspaceId, objectTypeId)}/attributes?${(0, $ebyGx.stringify)(queryParams)}`;
const $102a0eb1d1d95dbf$export$2ff51a9674e9ef8e = (workspaceId, objectTypeId)=>`${$102a0eb1d1d95dbf$export$6f3a42f18d151e67(workspaceId, objectTypeId)}/delete/objects`;
const $102a0eb1d1d95dbf$export$cc2331466d0bc62a = (workspaceId, objectTypeId)=>`${$102a0eb1d1d95dbf$export$6f3a42f18d151e67(workspaceId, objectTypeId)}/objects`;
const $102a0eb1d1d95dbf$export$a636cbbc1532dae1 = (workspaceId, objectTypeId)=>`${$102a0eb1d1d95dbf$export$6f3a42f18d151e67(workspaceId, objectTypeId)}/position`;
const $102a0eb1d1d95dbf$export$f57e47ec92312ade = (workspaceId)=>`${$102a0eb1d1d95dbf$var$getCmdbObjectTypeUrl(workspaceId)}/copy`;
const $102a0eb1d1d95dbf$export$95f3087e511a1510 = (workspaceId)=>`${$102a0eb1d1d95dbf$var$getCmdbObjectTypeUrl(workspaceId)}/create`;
const $102a0eb1d1d95dbf$export$64aa1993d4a6b92c = (workspaceId)=>`${$102a0eb1d1d95dbf$var$getCmdbObjectTypeUrl(workspaceId)}/bulkedit`;

});

parcelRegister("bOHaD", function(module, exports) {

$parcel$export(module.exports, "isUnexpectedFetchError", () => $d01969acb3765ff6$export$cd70b8b287611e8f);
$parcel$export(module.exports, "isSignal", () => $d01969acb3765ff6$export$a9a36f4641f8c6f0);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");
const $d01969acb3765ff6$export$bc9678df7c38e24d = [
    503
];
const $d01969acb3765ff6$export$cd70b8b287611e8f = (error, errorStatusCodeGroups = [
    '5xx'
], excludeStatusCodes)=>{
    if (!error || !(error instanceof (0, $jJZqs.default))) return false;
    // If excludeStatusCodes defined, check first before proceeding to check group
    if (excludeStatusCodes && excludeStatusCodes.length) {
        const { statusCode: statusCode } = error;
        if (excludeStatusCodes.includes(statusCode)) return false;
    }
    const statusCodeGroup = (0, $jcw0u.getStatusCodeGroup)(error);
    return errorStatusCodeGroups.includes(statusCodeGroup);
};
const $d01969acb3765ff6$export$a9a36f4641f8c6f0 = (error, errorStatusCodeGroups = [
    '4xx',
    '5xx'
])=>$d01969acb3765ff6$export$cd70b8b287611e8f(error, errorStatusCodeGroups, $d01969acb3765ff6$export$bc9678df7c38e24d);

});


parcelRegister("f0mE9", function(module, exports) {

$parcel$export(module.exports, "fetchObjectConfiguration", () => $5e6fc76ec99a77cb$export$a642a1bd3c619524);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $juXmc = parcelRequire("juXmc");

var $bOHaD = parcelRequire("bOHaD");
const $5e6fc76ec99a77cb$export$a642a1bd3c619524 = ()=>async ({ getState: getState, setState: setState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        try {
            const { objectDetails: objectDetails } = getState();
            const { objectType: objectType } = objectDetails ?? {};
            const { objectSchemaId: objectSchemaId, id: objectTypeId } = objectType ?? {};
            if (objectSchemaId && objectTypeId) {
                const objectConfiguration = await (0, $4VpwK.performCmdbGetRequest)((0, $juXmc.getCmdbGlobalConfigObjectUrl)(workspaceId, {
                    objectschemaid: objectSchemaId,
                    objecttypeid: objectTypeId
                }));
                setState({
                    objectConfiguration: objectConfiguration
                });
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchInsightObjectConfiguration succeeded');
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                error: error
            });
            if ((0, $bOHaD.isSignal)(error)) (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'fetchInsightObjectConfiguration',
                    packageName: 'jiraServicedeskInsightObjectDetailsStore',
                    teamName: 'falcons'
                },
                error: error
            });
        }
    };

});


parcelRegister("66Vf6", function(module, exports) {

$parcel$export(module.exports, "Store", () => $3e9a3f53f3594ac0$export$390f32400eaf98c9);
$parcel$export(module.exports, "useObjectStoreState", () => $3e9a3f53f3594ac0$export$7b14840a1814325e);
$parcel$export(module.exports, "useObjectActions", () => $3e9a3f53f3594ac0$export$31f9c7f1c9d15b30);
$parcel$export(module.exports, "useObjectDetails", () => $3e9a3f53f3594ac0$export$f3b90684c53a8e21);
$parcel$export(module.exports, "useObjectId", () => $3e9a3f53f3594ac0$export$766e685db081abfd);
$parcel$export(module.exports, "useObjectTypeId", () => $3e9a3f53f3594ac0$export$4b084de5afc26fa8);
$parcel$export(module.exports, "useObjectSchemaId", () => $3e9a3f53f3594ac0$export$e52bb7ff34d39484);
$parcel$export(module.exports, "useObjectSchemaName", () => $3e9a3f53f3594ac0$export$439f1ae966026319);
$parcel$export(module.exports, "useCanEditObject", () => $3e9a3f53f3594ac0$export$44e35a0ec5cc3c29);
$parcel$export(module.exports, "useCanDeleteObject", () => $3e9a3f53f3594ac0$export$2b2b72c63a81e55f);
$parcel$export(module.exports, "useLabelAttribute", () => $3e9a3f53f3594ac0$export$76144e5f0312112);
$parcel$export(module.exports, "useEditableAttributeTypes", () => $3e9a3f53f3594ac0$export$6929f5be345724fb);
$parcel$export(module.exports, "useAttribute", () => $3e9a3f53f3594ac0$export$801cfa237314d03d);
$parcel$export(module.exports, "useAttributes", () => $3e9a3f53f3594ac0$export$c2035740d67c030c);
$parcel$export(module.exports, "useIsRestrictedSchema", () => $3e9a3f53f3594ac0$export$d07372ba961b2bc5);
$parcel$export(module.exports, "useCmdbAnalyticAttributes", () => $3e9a3f53f3594ac0$export$25c930d28fd08aaa);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $gZ9wG = parcelRequire("gZ9wG");

var $dKxjD = parcelRequire("dKxjD");
const $3e9a3f53f3594ac0$var$initialState = {
    objectDetails: null,
    objectConfiguration: null,
    loading: false,
    error: null,
    isCompact: false,
    hideEmptyAttributes: false
};
const $3e9a3f53f3594ac0$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $3e9a3f53f3594ac0$var$initialState,
    actions: $gZ9wG,
    name: 'object-details'
});
const $3e9a3f53f3594ac0$export$7b14840a1814325e = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9);
const $3e9a3f53f3594ac0$export$31f9c7f1c9d15b30 = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: null
});
const $3e9a3f53f3594ac0$export$f3b90684c53a8e21 = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getObjectDetails)
});
const $3e9a3f53f3594ac0$export$766e685db081abfd = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getObjectId)
});
const $3e9a3f53f3594ac0$export$4b084de5afc26fa8 = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getObjectTypeId)
});
const $3e9a3f53f3594ac0$export$a0da207255524fb3 = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getObjectConfiguration)
});
const $3e9a3f53f3594ac0$export$e52bb7ff34d39484 = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getObjectSchemaId)
});
const $3e9a3f53f3594ac0$export$439f1ae966026319 = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getObjectSchemaName)
});
const $3e9a3f53f3594ac0$export$44e35a0ec5cc3c29 = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getHasDeveloperRoleForObjectType)
});
const $3e9a3f53f3594ac0$export$2b2b72c63a81e55f = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getHasManagerRoleForObjectType)
});
const $3e9a3f53f3594ac0$export$76144e5f0312112 = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getLabelAttribute)
});
const $3e9a3f53f3594ac0$export$6929f5be345724fb = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getEditableAttributesTypes)
});
const $3e9a3f53f3594ac0$export$801cfa237314d03d = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getAttribute)
});
const $3e9a3f53f3594ac0$export$c2035740d67c030c = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getAttributes)
});
const $3e9a3f53f3594ac0$export$d07372ba961b2bc5 = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getIsRestrictedSchema)
});
const $3e9a3f53f3594ac0$export$25c930d28fd08aaa = (0, $3sQ5x.createHook)($3e9a3f53f3594ac0$export$390f32400eaf98c9, {
    selector: (0, $dKxjD.getCmdbAnalyticAttributes)
});

});
parcelRegister("gZ9wG", function(module, exports) {

$parcel$export(module.exports, "fetchObjectConfiguration", () => (parcelRequire("f0mE9")).fetchObjectConfiguration);
$parcel$export(module.exports, "updateAttribute", () => (parcelRequire("dFJJ8")).updateAttribute);
$parcel$export(module.exports, "deleteObjectAvatar", () => (parcelRequire("kQGXw")).deleteObjectAvatar);
$parcel$export(module.exports, "updateObjectAvatar", () => (parcelRequire("4FpOb")).updateObjectAvatar);
$parcel$export(module.exports, "fetchEditableAttributeTypes", () => (parcelRequire("9WS7a")).fetchEditableAttributeTypes);
$parcel$export(module.exports, "fetchObjectViewInitialData", () => (parcelRequire("7rHNv")).fetchObjectViewInitialData);
$parcel$export(module.exports, "updateObjectState", () => (parcelRequire("39dlz")).updateObjectState);
$parcel$export(module.exports, "setIsCompact", () => (parcelRequire("5fKjs")).setIsCompact);
$parcel$export(module.exports, "setHideEmptyAttributesState", () => (parcelRequire("6adHJ")).setHideEmptyAttributesState);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $f0mE9 = parcelRequire("f0mE9");

var $dFJJ8 = parcelRequire("dFJJ8");

var $kQGXw = parcelRequire("kQGXw");

var $4FpOb = parcelRequire("4FpOb");

var $9WS7a = parcelRequire("9WS7a");

var $7rHNv = parcelRequire("7rHNv");

var $39dlz = parcelRequire("39dlz");

var $5fKjs = parcelRequire("5fKjs");

var $6adHJ = parcelRequire("6adHJ");

});
parcelRegister("dFJJ8", function(module, exports) {

$parcel$export(module.exports, "updateAttribute", () => $43abeccc7074d77b$export$1176bbd018bf6f73);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $9KkIb = parcelRequire("9KkIb");

var $8WrnW = parcelRequire("8WrnW");

var $39dlz = parcelRequire("39dlz");
const $43abeccc7074d77b$var$updateAttributeImplementation = ({ objectTypeAttributeId: objectTypeAttributeId, updatedValues: updatedValues, onLoad: onLoad, onError: onError, onSuccess: onSuccess })=>async ({ getState: getState, dispatch: dispatch }, { workspaceId: workspaceId, objectId: objectId, createAnalyticsEvent: createAnalyticsEvent, onUpdate: onUpdate })=>{
        const { objectDetails: objectDetails } = getState();
        const { editableAttributeTypes: editableAttributeTypes } = objectDetails ?? {};
        try {
            if (objectDetails && editableAttributeTypes) {
                onLoad?.();
                const { attributes: attributes } = objectDetails;
                const fireSuccessAnalytics = ()=>{
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateInsightObjectAttribute succeeded', {
                        attributeType: attributes.find((attribute)=>attribute.objectTypeAttributeId === objectTypeAttributeId)?.type
                    });
                };
                // un-setting an attribute's value triggers a delete of that attribute in the backend
                const isDeletingAttribute = updatedValues.every((update)=>update.value == null || update.value === '');
                if (isDeletingAttribute) {
                    await (0, $8WrnW.ObjectAttributeService).deleteAttribute({
                        workspaceId: workspaceId,
                        objectId: objectId,
                        objectTypeAttributeId: objectTypeAttributeId
                    });
                    const updatedAttributes = attributes.filter((attribute)=>attribute.objectTypeAttributeId !== objectTypeAttributeId);
                    dispatch((0, $39dlz.updateObjectState)({
                        attributes: updatedAttributes
                    }));
                    onSuccess?.();
                    onUpdate();
                    fireSuccessAnalytics();
                } else {
                    const body = {
                        objectId: objectId,
                        objectTypeAttributeId: objectTypeAttributeId,
                        objectAttributeValues: updatedValues
                    };
                    // if no attributes with a matching objectTypeAttributeId exist we're creating a new attribute
                    const isCreatingAttribute = !attributes.some((attribute)=>attribute.objectTypeAttributeId === objectTypeAttributeId);
                    const attributeValuesResponse = isCreatingAttribute ? await (0, $8WrnW.ObjectAttributeService).createAttribute({
                        workspaceId: workspaceId,
                        body: body
                    }) : await (0, $8WrnW.ObjectAttributeService).updateAttribute({
                        workspaceId: workspaceId,
                        body: body
                    });
                    const updatedAttributes = isCreatingAttribute ? (0, $9KkIb.getUpdatedAttributesAfterCreating)(editableAttributeTypes, attributes, attributeValuesResponse) : attributes.map((attribute)=>attribute.objectTypeAttributeId === objectTypeAttributeId ? (0, $9KkIb.normalizeObjectAttributeResponse)(attribute, attributeValuesResponse.objectAttributeValues) : attribute);
                    // @ts-expect-error - TS2322 - Type 'readonly [...InsightObjectAttribute[], InsightObjectAttribute] | (InsightObjectAttribute | ObjectAttributeResponse)[]' is not assignable to type '(ObjectAttributeResponse[] & InsightObjectAttribute[]) | undefined'.
                    dispatch((0, $39dlz.updateObjectState)({
                        attributes: updatedAttributes
                    }));
                    fireSuccessAnalytics();
                    onSuccess?.(updatedAttributes.find((a)=>a.objectTypeAttributeId === objectTypeAttributeId));
                    onUpdate();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateInsightObjectAttribute',
                    packageName: 'jiraServicedeskInsightObjectDetailsStore',
                    teamName: 'falcons'
                },
                error: error
            });
            if (onError) onError(error);
        }
    };
const $43abeccc7074d77b$export$1176bbd018bf6f73 = ({ objectTypeAttributeId: objectTypeAttributeId, updatedValues: updatedValues, onLoad: onLoad, onError: onError, onSuccess: onSuccess })=>$43abeccc7074d77b$var$updateAttributeImplementation({
        objectTypeAttributeId: objectTypeAttributeId,
        updatedValues: updatedValues,
        onLoad: onLoad,
        onError: onError,
        onSuccess: onSuccess
    });

});
parcelRegister("9KkIb", function(module, exports) {

$parcel$export(module.exports, "normalizeObjectAttributeResponse", () => $90eef7290dfcbda1$export$ab549e9cd750448c);
$parcel$export(module.exports, "getUpdatedAttributesAfterCreating", () => $90eef7290dfcbda1$export$a612d07523d589ac);

var $xJtdX = parcelRequire("xJtdX");
const $90eef7290dfcbda1$export$9b7692f0c207a7cd = (value)=>{
    if (value != null) return value;
    (0, $xJtdX.fireCmdbErrorAnalytics)({
        meta: {
            id: 'missing.property.from.insight.service',
            packageName: 'jiraServicedeskInsightObjectDetailsStore'
        }
    });
    throw new Error('Expected value from Insight service is null or undefined');
};
const $90eef7290dfcbda1$export$ab549e9cd750448c = (attribute, objectAttributeValues)=>{
    switch(attribute.type){
        case 'default':
            return {
                ...attribute,
                defaultTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, group: group, project: project, user: user, status: status, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        value: attrValue.value
                    };
                })
            };
        case 'object':
            return {
                ...attribute,
                objectTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { group: group, project: project, user: user, status: status, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        referencedObject: $90eef7290dfcbda1$export$9b7692f0c207a7cd(attrValue.referencedObject)
                    };
                })
            };
        case 'user':
            return {
                ...attribute,
                userTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, group: group, project: project, status: status, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        user: $90eef7290dfcbda1$export$9b7692f0c207a7cd(attrValue.user)
                    };
                })
            };
        case 'group':
            return {
                ...attribute,
                groupTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, project: project, user: user, status: status, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        group: $90eef7290dfcbda1$export$9b7692f0c207a7cd(attrValue.group)
                    };
                })
            };
        case 'project':
            return {
                ...attribute,
                projectTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, user: user, group: group, status: status, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        project: $90eef7290dfcbda1$export$9b7692f0c207a7cd(attrValue.project)
                    };
                })
            };
        case 'status':
            return {
                ...attribute,
                statusTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, user: user, group: group, project: project, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        status: $90eef7290dfcbda1$export$9b7692f0c207a7cd(attrValue.status)
                    };
                })
            };
        case 'bitbucketRepo':
            return {
                ...attribute,
                bitbucketRepoTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, user: user, group: group, project: project, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        bitbucketRepo: $90eef7290dfcbda1$export$9b7692f0c207a7cd(attrValue.bitbucketRepo)
                    };
                })
            };
        case 'opsgenieTeam':
            return {
                ...attribute,
                opsgenieTeamTypeValues: objectAttributeValues.map((attributeValue)=>{
                    const { referencedObject: referencedObject, user: user, group: group, project: project, value: value, ...attrValue } = attributeValue;
                    return {
                        ...attrValue,
                        opsgenieTeam: $90eef7290dfcbda1$export$9b7692f0c207a7cd(attrValue.opsgenieTeam)
                    };
                })
            };
        default:
            {
                // Because `attribute` will only be typed as 'never' when our switch
                // statement is exhaustive, we can use the following line as a way
                // to enforce it *before* runtime. So if there's a TS error on the
                // following line, it means we need to add a new case to the switch
                // statement to handle a new attribute.type.
                const assertSwitchIsExhaustive = attribute;
                (0, $xJtdX.fireCmdbErrorAnalytics)({
                    meta: {
                        id: 'invalid.attribute.type',
                        packageName: 'jiraServicedeskInsightObjectDetailsStore'
                    }
                });
                throw new Error(`Invalid attribute type provided from Insight service found: ${JSON.stringify(assertSwitchIsExhaustive)}`);
            }
    }
};
const $90eef7290dfcbda1$export$a612d07523d589ac = (attributeTypes, attributes, attributeResponse)=>{
    const { objectTypeAttributeId: objectTypeAttributeId, objectAttributeValues: objectAttributeValues } = attributeResponse;
    const attributeType = attributeTypes.find((at)=>at.id === objectTypeAttributeId);
    if (!attributeType) throw new Error('Expected attribute type to exist but none was found');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const partialAttribute = {
        objectTypeAttributeId: objectTypeAttributeId,
        objectTypeAttribute: attributeType,
        type: attributeType.type
    };
    const newAttribute = $90eef7290dfcbda1$export$ab549e9cd750448c(partialAttribute, objectAttributeValues);
    return [
        ...attributes,
        newAttribute
    ];
};

});

parcelRegister("8WrnW", function(module, exports) {

$parcel$export(module.exports, "ObjectAttributeService", () => $b3270935a3f69afa$export$f9ea1c4abbac6bc9);

var $4VpwK = parcelRequire("4VpwK");

var $9wvX4 = parcelRequire("9wvX4");
const $b3270935a3f69afa$export$f9ea1c4abbac6bc9 = {
    createAttribute: ({ workspaceId: workspaceId, body: body })=>(0, $4VpwK.performCmdbPostRequest)((0, $9wvX4.getCmdbObjectAttributeByObjectTypeAttributeIdCreateUrl)(workspaceId, body.objectId, body.objectTypeAttributeId), {
            body: JSON.stringify(body)
        }).then((response)=>{
            const { workspaceId: wsid, ...attribute } = response;
            return attribute;
        }),
    updateAttribute: ({ workspaceId: workspaceId, body: body })=>(0, $4VpwK.performCmdbPutRequest)((0, $9wvX4.getCmdbObjectAttributeByObjectTypeAttributeIdUrl)(workspaceId, body.objectId, body.objectTypeAttributeId), {
            body: JSON.stringify(body)
        }),
    deleteAttribute: ({ workspaceId: workspaceId, objectId: objectId, objectTypeAttributeId: objectTypeAttributeId })=>(0, $4VpwK.performCmdbDeleteRequest)((0, $9wvX4.getCmdbObjectAttributeByObjectTypeAttributeIdUrl)(workspaceId, objectId, objectTypeAttributeId))
};

});
parcelRegister("9wvX4", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectAttributeByObjectTypeAttributeIdUrl", () => $852729cc16820941$export$a5401b58749d3522);
$parcel$export(module.exports, "getCmdbObjectAttributeByObjectTypeAttributeIdCreateUrl", () => $852729cc16820941$export$704144a3c95916d0);

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectattribute
 */ const $852729cc16820941$var$getCmdbObjectAttributeUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objectattribute`;
const $852729cc16820941$export$a5401b58749d3522 = (workspaceId, objectId, objectTypeAttributeId)=>`${$852729cc16820941$var$getCmdbObjectAttributeUrl(workspaceId)}/${objectId}/attribute/${objectTypeAttributeId}`;
const $852729cc16820941$export$704144a3c95916d0 = (workspaceId, objectId, objectTypeAttributeId)=>`${$852729cc16820941$export$a5401b58749d3522(workspaceId, objectId, objectTypeAttributeId)}/create`;

});


parcelRegister("39dlz", function(module, exports) {

$parcel$export(module.exports, "updateObjectState", () => $fcc79555ce69979c$export$ad55b6cba2dc2f5a);
const $fcc79555ce69979c$export$ad55b6cba2dc2f5a = (updatedProperties, setUpdatedTime = true)=>({ getState: getState, setState: setState })=>{
        const { objectDetails: objectDetails } = getState();
        if (!objectDetails) return;
        const updatedTime = setUpdatedTime ? new Date().toISOString() : objectDetails.updated;
        setState({
            objectDetails: {
                ...objectDetails,
                // Manually set the 'updated' property to 'now' as the endpoint
                // used to update an attribute doesn't return this information.
                // Depending on network conditions, this should be accurate to
                // within a few seconds.
                updated: updatedTime,
                // Update remaining properties after 'updated' so it can be
                // overriden (in case of full object fetch)
                ...updatedProperties
            }
        });
    };

});


parcelRegister("kQGXw", function(module, exports) {

$parcel$export(module.exports, "deleteObjectAvatar", () => $2271ae01ebba1d00$export$7f4ebf7f2e3e05dc);

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $8KOIi = parcelRequire("8KOIi");
const $2271ae01ebba1d00$export$7f4ebf7f2e3e05dc = ({ onSuccess: onSuccess, onFailure: onFailure } = {})=>async ({ getState: getState, setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, workspaceId: workspaceId })=>{
        const object = getState().objectDetails;
        if (!object) throw new Error('Object did not exist in store');
        try {
            await (0, $8KOIi.ObjectAvatarService).detachObjectAvatar({
                workspaceId: workspaceId,
                objectId: object.id
            });
            const objectTypeIcon = object.objectType.icon.url48;
            setState({
                objectDetails: {
                    ...object,
                    hasAvatar: false,
                    avatar: {
                        ...object.avatar,
                        url16: objectTypeIcon,
                        url48: objectTypeIcon,
                        url72: objectTypeIcon,
                        url144: objectTypeIcon,
                        url288: objectTypeIcon
                    }
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'detachObjectAvatar succeeded');
            onSuccess?.();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'detachObjectAvatar',
                    packageName: 'jiraServicedeskInsightObjectDetailsStore',
                    teamName: 'falcons'
                }
            });
            onFailure?.(error);
        }
    };

});
parcelRegister("8KOIi", function(module, exports) {

$parcel$export(module.exports, "ObjectAvatarService", () => $7ab8f93a82366a43$export$bbeb8470c26b3804);

var $4VpwK = parcelRequire("4VpwK");

var $eusud = parcelRequire("eusud");

var $dzgN9 = parcelRequire("dzgN9");

var $eJOOa = parcelRequire("eJOOa");
const $7ab8f93a82366a43$export$bbeb8470c26b3804 = {
    // The default headers apply `Content-Type': 'application/json' which is not appropriate for file upload
    // We cannot simultaneously set the X-Request-Source header and clear the headers
    // So we call the generic performPostRequest function with an empty headers object
    uploadAvatar: ({ workspaceId: workspaceId, body: body })=>(0, $eusud.performPostRequest)((0, $dzgN9.getCmdbAvatarUploadUrl)(workspaceId), {
            headers: {},
            body: body
        }),
    attachObjectAvatar: ({ workspaceId: workspaceId, objectId: objectId, avatarUUID: avatarUUID })=>(0, $4VpwK.performCmdbPutRequest)((0, $eJOOa.getCmdbObjectByIdAvatarUrl)(workspaceId, objectId), {
            body: JSON.stringify({
                avatarUUID: avatarUUID
            })
        }),
    detachObjectAvatar: ({ workspaceId: workspaceId, objectId: objectId })=>(0, $4VpwK.performCmdbDeleteRequest)((0, $eJOOa.getCmdbObjectByIdAvatarUrl)(workspaceId, objectId)),
    createTempObjectAvatar: ({ workspaceId: workspaceId, objectKey: objectKey })=>(0, $4VpwK.performCmdbPostRequest)((0, $dzgN9.getCmdbAvatarCreateTmpFilesUrl)(workspaceId), {
            body: JSON.stringify({
                objectKey: objectKey
            })
        }),
    deleteObjectAvatar: ({ workspaceId: workspaceId, avatarUUID: avatarUUID, objectTypeId: objectTypeId })=>(0, $4VpwK.performCmdbDeleteRequest)((0, $dzgN9.getCmdbAvatarDeleteUrl)(workspaceId, avatarUUID, {
            objectTypeId: objectTypeId
        }))
};

});
parcelRegister("dzgN9", function(module, exports) {

$parcel$export(module.exports, "getCmdbAvatarCreateTmpFilesUrl", () => $45f66fafc319a20d$export$e188bd1c629458e3);
$parcel$export(module.exports, "getCmdbAvatarDeleteUrl", () => $45f66fafc319a20d$export$755da160799853d7);
$parcel$export(module.exports, "getCmdbAvatarUploadUrl", () => $45f66fafc319a20d$export$c95e479ad84f1d9e);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/avatar
 */ const $45f66fafc319a20d$var$getCmdbAvatarUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/avatar`;
const $45f66fafc319a20d$export$e188bd1c629458e3 = (workspaceId)=>`${$45f66fafc319a20d$var$getCmdbAvatarUrl(workspaceId)}/createtmpfiles`;
const $45f66fafc319a20d$export$755da160799853d7 = (workspaceId, avatarUUID, queryParams)=>`${$45f66fafc319a20d$var$getCmdbAvatarUrl(workspaceId)}/delete/${avatarUUID}?${(0, $ebyGx.stringify)(queryParams)}`;
const $45f66fafc319a20d$export$c95e479ad84f1d9e = (workspaceId)=>`${$45f66fafc319a20d$var$getCmdbAvatarUrl(workspaceId)}/upload`;

});



parcelRegister("4FpOb", function(module, exports) {

$parcel$export(module.exports, "updateObjectAvatar", () => $1b0c3d735d48ecf6$export$82e15dabd19b5b74);

var $7Jxgt = parcelRequire("7Jxgt");

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $8KOIi = parcelRequire("8KOIi");

var $39dlz = parcelRequire("39dlz");
const $1b0c3d735d48ecf6$export$82e15dabd19b5b74 = ({ selectedImageFile: selectedImageFile, onSuccess: onSuccess, onError: onError, objectTypeId: objectTypeId })=>async ({ getState: getState, dispatch: dispatch }, { workspaceId: workspaceId, onUpdate: onUpdate, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { objectDetails: objectDetails } = getState();
        const { editableAttributeTypes: editableAttributeTypes } = objectDetails ?? {};
        if (objectDetails && editableAttributeTypes) try {
            const { id: objectId } = objectDetails;
            const formData = new FormData();
            formData.append('avatarUUID', (0, $7Jxgt.v4)());
            formData.append('rlabs-insight-object-avatar', selectedImageFile);
            formData.append('objectTypeId', objectTypeId);
            const { avatarUUID: avatarUUID } = await (0, $8KOIi.ObjectAvatarService).uploadAvatar({
                workspaceId: workspaceId,
                body: formData
            });
            const attachedObjectAvatar = await (0, $8KOIi.ObjectAvatarService).attachObjectAvatar({
                workspaceId: workspaceId,
                objectId: objectId,
                avatarUUID: avatarUUID
            });
            dispatch((0, $39dlz.updateObjectState)({
                avatar: attachedObjectAvatar,
                hasAvatar: true
            }));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'updateObjectIcon succeeded');
            onSuccess?.();
            onUpdate();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'updateObjectIcon',
                    packageName: 'jiraServicedeskInsightObjectDetailsStore',
                    teamName: 'falcons'
                },
                error: error
            });
            if (onError) onError(error);
        }
    };

});

parcelRegister("5fKjs", function(module, exports) {

$parcel$export(module.exports, "setIsCompact", () => $43063ab2693bc773$export$aacabc9577cdcdd7);
const $43063ab2693bc773$export$aacabc9577cdcdd7 = (isCompact)=>async ({ setState: setState })=>{
        setState({
            isCompact: isCompact
        });
    };

});

parcelRegister("6adHJ", function(module, exports) {

$parcel$export(module.exports, "setHideEmptyAttributesState", () => $18032836705192a5$export$4d21a43e0d5ade5);

var $8zOmE = parcelRequire("8zOmE");

var $2zr8Q = parcelRequire("2zr8Q");
const $18032836705192a5$export$4d21a43e0d5ade5 = (hideEmptyAttributes)=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent })=>{
        const { objectDetails: objectDetails } = getState();
        if (objectDetails != null) (0, $2zr8Q.setHideEmptyAttributes)(hideEmptyAttributes, objectDetails.objectType.id);
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'hideEmptyCmdbObjectAttributes toggled', {
            shouldHide: hideEmptyAttributes
        });
        setState({
            hideEmptyAttributes: hideEmptyAttributes
        });
    };

});
parcelRegister("2zr8Q", function(module, exports) {

$parcel$export(module.exports, "setHideEmptyAttributes", () => $490e0c6799cf5b9e$export$25934bec26e90b94);
$parcel$export(module.exports, "getHideEmptyAttributes", () => $490e0c6799cf5b9e$export$a665034e53df945d);

var $bSSG7 = parcelRequire("bSSG7");
const $490e0c6799cf5b9e$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('cmdb-object-hide-empty-attributes');
const $490e0c6799cf5b9e$export$25934bec26e90b94 = (shouldHide, objectTypeId)=>{
    $490e0c6799cf5b9e$export$c2ed3351cac403d1.set(`hideEmptyAttributes_${objectTypeId}`, shouldHide);
};
const $490e0c6799cf5b9e$export$a665034e53df945d = (objectTypeId)=>$490e0c6799cf5b9e$export$c2ed3351cac403d1.get(`hideEmptyAttributes_${objectTypeId}`) || false;

});



parcelRegister("dKxjD", function(module, exports) {

$parcel$export(module.exports, "getObjectDetails", () => $b6fd3c35532dbed5$export$b3429f935add6623);
$parcel$export(module.exports, "getObjectTypeId", () => $b6fd3c35532dbed5$export$fa11e6f407f5a10c);
$parcel$export(module.exports, "getObjectId", () => $b6fd3c35532dbed5$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectConfiguration", () => $b6fd3c35532dbed5$export$102ab9ec3b21091d);
$parcel$export(module.exports, "getObjectSchemaId", () => $b6fd3c35532dbed5$export$342065e741ab9f7e);
$parcel$export(module.exports, "getObjectSchemaName", () => $b6fd3c35532dbed5$export$438ecbe0fad62fa1);
$parcel$export(module.exports, "getHasDeveloperRoleForObjectType", () => $b6fd3c35532dbed5$export$46aae32c1b8ee78c);
$parcel$export(module.exports, "getHasManagerRoleForObjectType", () => $b6fd3c35532dbed5$export$bd58d98a2c4544bb);
$parcel$export(module.exports, "getAttributes", () => $b6fd3c35532dbed5$export$fe94072fee8a6976);
$parcel$export(module.exports, "getLabelAttribute", () => $b6fd3c35532dbed5$export$ecba67f94820a19f);
$parcel$export(module.exports, "getEditableAttributesTypes", () => $b6fd3c35532dbed5$export$4e480604f927c2a0);
$parcel$export(module.exports, "getAttribute", () => $b6fd3c35532dbed5$export$735ee1799fd02602);
$parcel$export(module.exports, "getIsRestrictedSchema", () => $b6fd3c35532dbed5$export$ad8b050700764b4b);
$parcel$export(module.exports, "getCmdbAnalyticAttributes", () => $b6fd3c35532dbed5$export$75e4f2b71b650410);

var $dJl1T = parcelRequire("dJl1T");

var $5Ny9E = parcelRequire("5Ny9E");

var $6u2pX = parcelRequire("6u2pX");

var $6dDSs = parcelRequire("6dDSs");
const $b6fd3c35532dbed5$export$b3429f935add6623 = (state)=>state.objectDetails;
const $b6fd3c35532dbed5$export$fa11e6f407f5a10c = (state)=>$b6fd3c35532dbed5$export$b3429f935add6623(state)?.objectType?.id ?? '';
const $b6fd3c35532dbed5$export$fa986b91291934c7 = (state)=>$b6fd3c35532dbed5$export$b3429f935add6623(state)?.id ?? (0, $5Ny9E.toCmdbObjectId)('');
const $b6fd3c35532dbed5$export$102ab9ec3b21091d = (state)=>state.objectConfiguration;
const $b6fd3c35532dbed5$export$342065e741ab9f7e = (state)=>$b6fd3c35532dbed5$export$102ab9ec3b21091d(state)?.objectSchema.id;
const $b6fd3c35532dbed5$export$438ecbe0fad62fa1 = (state)=>$b6fd3c35532dbed5$export$102ab9ec3b21091d(state)?.objectSchema.name;
const $b6fd3c35532dbed5$export$46aae32c1b8ee78c = (state)=>$b6fd3c35532dbed5$export$102ab9ec3b21091d(state)?.insightDeveloperForObjectType ?? false;
const $b6fd3c35532dbed5$export$bd58d98a2c4544bb = (state)=>$b6fd3c35532dbed5$export$102ab9ec3b21091d(state)?.insightManagerForObjectType ?? false;
const $b6fd3c35532dbed5$export$fe94072fee8a6976 = (state)=>$b6fd3c35532dbed5$export$b3429f935add6623(state)?.attributes ?? [];
const $b6fd3c35532dbed5$export$ecba67f94820a19f = (0, $6dDSs.createSelector)((state)=>$b6fd3c35532dbed5$export$fe94072fee8a6976(state), (attributes)=>{
    const labelAttribute = attributes.find((attr)=>attr.objectTypeAttribute.label === true);
    if (labelAttribute && labelAttribute.type === 'default') return labelAttribute;
    // https://hello.jira.atlassian.cloud/browse/FLY-1716
    // Temporarily putting this here to better understand why the label is sometimes missing.
    (0, $dJl1T.default).safeErrorWithoutCustomerData('servicedesk.insight-object.object-details-store.selectors.missing-label-attribute', `attributesLength: ${attributes.length}, labelSet: ${!!labelAttribute}, labelAttributeType: ${labelAttribute?.type}`);
    throw new Error('Label should be always be a default text attribute');
});
const $b6fd3c35532dbed5$export$4e480604f927c2a0 = (state)=>$b6fd3c35532dbed5$export$b3429f935add6623(state)?.editableAttributeTypes ?? [];
const $b6fd3c35532dbed5$export$735ee1799fd02602 = (0, $6dDSs.createSelector)((state, objectTypeAttributeId)=>{
    const attributes = $b6fd3c35532dbed5$export$fe94072fee8a6976(state);
    return attributes.find((attr)=>attr.objectTypeAttribute.id === objectTypeAttributeId);
}, (attribute)=>attribute);
const $b6fd3c35532dbed5$export$ad8b050700764b4b = (state)=>$b6fd3c35532dbed5$export$102ab9ec3b21091d(state)?.restrictedObjectSchemaIds.includes(Number($b6fd3c35532dbed5$export$342065e741ab9f7e(state))) ?? false;
const $b6fd3c35532dbed5$export$75e4f2b71b650410 = (state)=>{
    const objectConfiguration = $b6fd3c35532dbed5$export$102ab9ec3b21091d(state);
    if (!objectConfiguration) // We shouldn't return analytics attributes if no object configuration
    return null;
    return (0, $6u2pX.getCmdbAnalyticAttributesFromSchema)(objectConfiguration.objectSchema);
};

});



parcelRegister("iN6n9", function(module, exports) {

$parcel$export(module.exports, "getObjectDetailsUrl", () => $9b9253a679474190$export$fc01f82f5493edda);
$parcel$export(module.exports, "getEditableAttributeTypesUrl", () => $9b9253a679474190$export$9155c371d7993c05);
$parcel$export(module.exports, "getObjectTypesUrl", () => $9b9253a679474190$export$a9260b331252f36a);
$parcel$export(module.exports, "getObjectSchemaPropertyUrl", () => $9b9253a679474190$export$d4234a7e4577aed6);

var $juXmc = parcelRequire("juXmc");

var $2loaL = parcelRequire("2loaL");

var $7T5mH = parcelRequire("7T5mH");

var $eJOOa = parcelRequire("eJOOa");
const $9b9253a679474190$export$fc01f82f5493edda = (workspaceId, objectId)=>(0, $eJOOa.getCmdbObjectByIdUrl)(workspaceId, objectId);
const $9b9253a679474190$export$9155c371d7993c05 = (workspaceId, objectTypeId)=>(0, $7T5mH.getCmdbObjectTypeByIdAttributesUrl)(workspaceId, objectTypeId, {
        onlyValueEditable: true
    });
const $9b9253a679474190$export$a9260b331252f36a = (workspaceId, objectSchemaId)=>(0, $2loaL.getCmdbObjectSchemaByIdObjectTypesUrl)(workspaceId, objectSchemaId, {
        excludeAbstract: true
    });
const $9b9253a679474190$export$d4234a7e4577aed6 = (workspaceId, objectSchemaId)=>(0, $juXmc.getCmdbGlobalConfigObjectSchemaByIdPropertyUrl)(workspaceId, objectSchemaId);

});
parcelRegister("2loaL", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectSchemaByIdUrl", () => $ef2507ddcf3d945c$export$7a8f746315e81598);
$parcel$export(module.exports, "getCmdbObjectSchemaByIdObjectTypesUrl", () => $ef2507ddcf3d945c$export$40fed922a68615f0);
$parcel$export(module.exports, "getCmdbObjectSchemaByIdObjectTypesFlatUrl", () => $ef2507ddcf3d945c$export$ba2d9684559c6a7);
$parcel$export(module.exports, "getCmdbObjectSchemaAllObjectTypesFlatUrl", () => $ef2507ddcf3d945c$export$5feed0fbe07a00c4);
$parcel$export(module.exports, "getCmdbObjectSchemaCreateUrl", () => $ef2507ddcf3d945c$export$f3ba592db0974a77);
$parcel$export(module.exports, "getCmdbObjectSchemaListUrl", () => $ef2507ddcf3d945c$export$e92eb77a52cdaa41);
$parcel$export(module.exports, "getCmdbFindAllAttributesUrl", () => $ef2507ddcf3d945c$export$6ffa97ba17b941e9);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectschema
 */ const $ef2507ddcf3d945c$var$getCmdbObjectSchemaUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objectschema`;
const $ef2507ddcf3d945c$export$7a8f746315e81598 = (workspaceId, schemaId)=>`${$ef2507ddcf3d945c$var$getCmdbObjectSchemaUrl(workspaceId)}/${schemaId}`;
const $ef2507ddcf3d945c$export$40fed922a68615f0 = (workspaceId, schemaId, queryParams)=>`${$ef2507ddcf3d945c$export$7a8f746315e81598(workspaceId, schemaId)}/objecttypes?${(0, $ebyGx.stringify)(queryParams)}`;
const $ef2507ddcf3d945c$export$ba2d9684559c6a7 = (workspaceId, schemaId, queryParams)=>`${$ef2507ddcf3d945c$export$7a8f746315e81598(workspaceId, schemaId)}/objecttypes/flat${queryParams ? `?${(0, $ebyGx.stringify)(queryParams)}` : ''}`;
const $ef2507ddcf3d945c$export$5feed0fbe07a00c4 = (workspaceId, schemaId, queryParams)=>`${$ef2507ddcf3d945c$var$getCmdbObjectSchemaUrl(workspaceId)}/all/${schemaId}/objecttypes/flat?${(0, $ebyGx.stringify)(queryParams)}`;
const $ef2507ddcf3d945c$export$f3ba592db0974a77 = (workspaceId)=>`${$ef2507ddcf3d945c$var$getCmdbObjectSchemaUrl(workspaceId)}/create`;
const $ef2507ddcf3d945c$export$e92eb77a52cdaa41 = (workspaceId, queryParams)=>`${$ef2507ddcf3d945c$var$getCmdbObjectSchemaUrl(workspaceId)}/list?${(0, $ebyGx.stringify)(queryParams)}`;
const $ef2507ddcf3d945c$export$6ffa97ba17b941e9 = (workspaceId, schemaId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objectschema/${schemaId}/attributes?${(0, $ebyGx.stringify)({
        extended: true
    })}`;

});


parcelRegister("8pMQX", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $951f6bd200bf8b89$export$849d319c342682a2);
$parcel$export(module.exports, "ServiceHubNotFound", () => $951f6bd200bf8b89$export$1fbf518ac538659c);
$parcel$export(module.exports, "GenericError", () => $951f6bd200bf8b89$export$7d465be8efa67280);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $tcn7E = parcelRequire("tcn7E");

var $lVQn8 = parcelRequire("lVQn8");

var $id7K0 = parcelRequire("id7K0");

var $bTyOW = parcelRequire("bTyOW");

var $fC09Q = parcelRequire("fC09Q");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $hDzhb = parcelRequire("hDzhb");

var $4R6GH = parcelRequire("4R6GH");

var $4AdE6 = parcelRequire("4AdE6");
const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).notFoundTitle),
        description: formatMessage((0, $4AdE6.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).notFoundAction))
    }));
};
const $951f6bd200bf8b89$export$1fbf518ac538659c = ()=>{
    const projectsPath = '/jira/projects';
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).serviceHubNotFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fC09Q.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).serviceHubNotFoundTitle),
        description: formatMessage((0, $4AdE6.default).serviceHubNotFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hDzhb.default), {
            to: projectsPath
        }, formatMessage((0, $4AdE6.default).serviceHubNotFoundAction))
    }));
};
const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
    const interactionId = (0, $5uXOq.useContext)((0, $1u4q7.default)).current;
    const labelStack = (0, $5uXOq.useContext)((0, $1tcYS.default))?.labelStack;
    const traceId = (0, $5uXOq.useMemo)(()=>{
        const traceContext = (0, $tcn7E.getActiveTrace)();
        return traceContext?.traceId;
    }, []);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let description = formatMessage((0, $4AdE6.default).genericErrorDescription);
    if (traceId) {
        const error = new Error('An error occurred while loading this page');
        description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $951f6bd200bf8b89$var$styles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVQn8.ErrorHashAndTraceId), {
            error: error,
            traceId: traceId
        })));
        if ((0, $4R6GH.fg)('add_ufo_error_in_service_desk_genericerror')) {
            const name = 'serviceDeskGenericError';
            if (interactionId) {
                (0, $bFU4G.addError)(interactionId, name, labelStack ?? null, error.name, error.message, error.stack);
                // NOTE: to account for awaiting BM3 TTI in UFO code, however we don't need to wait for BM3 TTI when there is an error
                // https://atlassian.slack.com/archives/C01AY8132S3/p1736380314352749?thread_ts=1736377740.484469&cid=C01AY8132S3
                const activeInteraction = (0, $bFU4G.getActiveInteraction)();
                activeInteraction?.holdActive.forEach((_, holdId)=>{
                    (0, $bFU4G.removeHoldByID)(activeInteraction.id, holdId);
                });
            } else (0, $bFU4G.addErrorToAll)(name, labelStack ?? null, error.name, error.message, error.stack);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4AdE6.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $4AdE6.default).genericErrorTitle),
        description: description
    }));
};
const $951f6bd200bf8b89$var$styles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("lVQn8", function(module, exports) {

$parcel$export(module.exports, "ErrorHashAndTraceId", () => $6bb63dde5e44a95e$export$61354a7dde2c2d3c);

var $5uXOq = parcelRequire("5uXOq");

var $5oFIy = parcelRequire("5oFIy");

var $kobfu = parcelRequire("kobfu");

var $hurrh = parcelRequire("hurrh");
const $6bb63dde5e44a95e$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
    const errorHash = (0, $kobfu.getErrorHash)(error);
    const source = `Hash ${errorHash}\nTrace ${traceId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHashAndTraceId",
        attributes: {
            errorHash: errorHash,
            traceId: traceId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hurrh.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHashAndTraceId"
    })));
};

});
parcelRegister("hurrh", function(module, exports) {

$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $e48150d967598599$export$ced1fc74d907d387);

var $5uXOq = parcelRequire("5uXOq");

var $b8Qxt = parcelRequire("b8Qxt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $irzxp = parcelRequire("irzxp");
const $e48150d967598599$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e48150d967598599$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.ActionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.CopyAction), {
        source: source,
        actionSubjectId: copyCodeActionSubjectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b8Qxt.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
const $e48150d967598599$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    position: 'relative'
});

});
parcelRegister("b8Qxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fd53c1f9dbca185$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $e4VnT = parcelRequire("e4VnT");

var $1HkQx = parcelRequire("1HkQx");

var $eCBnN = parcelRequire("eCBnN");

var $9Xp6L = parcelRequire("9Xp6L");
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $4fd53c1f9dbca185$var$CodeBlock = /*#__PURE__*/ (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const theme = (0, $5uXOq.useMemo)(()=>(0, $1HkQx.getCodeBlockTheme)(numLines), [
        numLines
    ]);
    const getStyles = (0, $5uXOq.useMemo)(()=>(0, $1HkQx.getCodeBlockStyles)(theme), [
        theme
    ]);
    const styles = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
        highlightedStartText,
        highlightedEndText,
        showLineNumbers,
        shouldWrapLongLines,
        getStyles
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $e4VnT.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $5uXOq.useMemo)(()=>(0, $eCBnN.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Xp6L.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        css: styles,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text
    });
});
$4fd53c1f9dbca185$var$CodeBlock.displayName = 'CodeBlock';
var $4fd53c1f9dbca185$export$2e2bcd8739ae039 = $4fd53c1f9dbca185$var$CodeBlock;

});
parcelRegister("e4VnT", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $a32b74c088f4b53f$export$84415a200bdf33ed);

var $5uXOq = parcelRequire("5uXOq");
const $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $a32b74c088f4b53f$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $a32b74c088f4b53f$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $5uXOq.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("1HkQx", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $a9c1aabaca189fa1$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $a9c1aabaca189fa1$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $a9c1aabaca189fa1$export$57a2d4b573afd64a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lBXbx = parcelRequire("lBXbx");

var $8CJbG = parcelRequire("8CJbG");
const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $a9c1aabaca189fa1$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $lBXbx.SPACING}px !important`,
        paddingLeft: (0, $lBXbx.SPACING),
        marginRight: (0, $lBXbx.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $a9c1aabaca189fa1$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: "var(--ds-font-weight-bold, 700)"
            }
        }
    });
/**
 * Styles applied at the root element level, common across code/codeblock
 */ const $a9c1aabaca189fa1$var$getBaseCodeStyles = (theme)=>({
        fontSize: (0, $lBXbx.CODE_FONT_SIZE),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: theme.fontFamily,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(${0, $lBXbx.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $a9c1aabaca189fa1$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $lBXbx.SPACING}px 0` : (0, $lBXbx.SPACING),
                tabSize: 4
            },
            display: 'flex',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $lBXbx.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$a9c1aabaca189fa1$var$getBaseCodeStyles(theme),
            ...$a9c1aabaca189fa1$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $a9c1aabaca189fa1$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $lBXbx.SPACING}px !important`,
                marginRight: `-${0, $lBXbx.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $lBXbx.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $lBXbx.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $lBXbx.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $lBXbx.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $lBXbx.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $lBXbx.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $lBXbx.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $lBXbx.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $a9c1aabaca189fa1$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $8CJbG.getBaseTheme)();
    const baseStyles = $a9c1aabaca189fa1$var$getBaseCodeStyles(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $a9c1aabaca189fa1$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $8CJbG.getBaseTheme)(),
        ...(0, $8CJbG.getColorPalette)(),
        lineNumberWidth: maxLines ? $a9c1aabaca189fa1$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("lBXbx", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $6ec31795911692d1$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $6ec31795911692d1$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $6ec31795911692d1$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $6ec31795911692d1$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $6ec31795911692d1$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $6ec31795911692d1$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $6ec31795911692d1$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $6ec31795911692d1$export$431ac46d758d98c8 = 12;
const $6ec31795911692d1$export$8e3c04032121c606 = '20px';
const $6ec31795911692d1$export$c8b5dc30e9f2b86e = '4px';
const $6ec31795911692d1$export$82ea42e772d49e5b = (0, $k5uoT.gridSize)();
const $6ec31795911692d1$export$eeeea0ff98e06fff = $6ec31795911692d1$export$82ea42e772d49e5b * 2;
const $6ec31795911692d1$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $6ec31795911692d1$export$1758fda69688282e = '--ds--code--bg-color';
const $6ec31795911692d1$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("8CJbG", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $eac5fe855702cfc1$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $eac5fe855702cfc1$export$fe2a6478976e8b17);

var $8QpSo = parcelRequire("8QpSo");


var $kTHGn = parcelRequire("kTHGn");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $eac5fe855702cfc1$var$T800 = '#067384';
const $eac5fe855702cfc1$var$Y1100 = '#7A5D1A';
const $eac5fe855702cfc1$export$4464aa303b3e4fda = ()=>({
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $kTHGn.default)('font.family.code')}`,
        backgroundColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        textColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
    });
const $eac5fe855702cfc1$export$fe2a6478976e8b17 = (0, $8QpSo.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$829f609a65d26a98$export$215b7063051591f1})`,
        substringColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        keywordColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        attributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        builtInColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        literalColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        bulletColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        codeColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        regexpColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        sectionColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        commentColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        metaColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        functionColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        numberColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        prologColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        cdataColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        punctuationColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        propertyColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
        constantColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        charColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        insertedColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        deletedColor: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
        operatorColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        atruleColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        importantColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`
    };
});
const $eac5fe855702cfc1$var$getTheme = ()=>({
        ...$eac5fe855702cfc1$export$4464aa303b3e4fda(),
        ...$eac5fe855702cfc1$export$fe2a6478976e8b17()
    });
var $eac5fe855702cfc1$export$2e2bcd8739ae039 = $eac5fe855702cfc1$var$getTheme;

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';



parcelRegister("eCBnN", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $d00516a0f8207944$export$f38728011c178796);

var $8QpSo = parcelRequire("8QpSo");

var $8Y2ZY = parcelRequire("8Y2ZY");
const $d00516a0f8207944$export$f38728011c178796 = (0, $8QpSo.default)((language)=>{
    if (!language) return '';
    const match = (0, $8Y2ZY.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("8Y2ZY", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $012a854d92762508$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $012a854d92762508$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'sql'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    }
];

});


parcelRegister("9Xp6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $e296c4d390ff4a21$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $c8FD2 = parcelRequire("c8FD2");
var $e296c4d390ff4a21$export$2e2bcd8739ae039 = (0, $c8FD2.default);

});
parcelRegister("c8FD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $64df4f4e00539958$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lp89O = parcelRequire("lp89O");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $64df4f4e00539958$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $lp89O.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $64df4f4e00539958$var$asyncGenerator = $64df4f4e00539958$var$generator({
    loader: ()=>(parcelRequire("7t3wc")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $64df4f4e00539958$export$2e2bcd8739ae039 = $64df4f4e00539958$var$asyncGenerator;

});
parcelRegister("lp89O", function(module, exports) {

$parcel$export(module.exports, "default", () => $a813ccd1d5fae376$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iQkqt = parcelRequire("iQkqt");

var $jVB7m = parcelRequire("jVB7m");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $a813ccd1d5fae376$var$Highlight = /*#__PURE__*/ (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $iQkqt.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $jVB7m.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $a813ccd1d5fae376$export$2e2bcd8739ae039 = $a813ccd1d5fae376$var$Highlight;

});
parcelRegister("iQkqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $55dc1424d34091d6$export$2e2bcd8739ae039);

var $eJUOt = parcelRequire("eJUOt");

var $eTMIA = parcelRequire("eTMIA");

var $8bliZ = parcelRequire("8bliZ");

var $g6MVu = parcelRequire("g6MVu");
const $55dc1424d34091d6$var$newLineRegex = /\n/g;
function $55dc1424d34091d6$var$getNewLines(str) {
    return str.match($55dc1424d34091d6$var$newLineRegex);
}
function $55dc1424d34091d6$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $g6MVu.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $eJUOt.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $8bliZ.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $55dc1424d34091d6$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $eTMIA.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $eTMIA.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("eJUOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ccdbf71436a137$export$2e2bcd8739ae039);

var $eTMIA = parcelRequire("eTMIA");

var $5FOwT = parcelRequire("5FOwT");
function $b9ccdbf71436a137$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $eTMIA.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $5FOwT.default)(lineNumber));
            return children;
        }
    };
}
var $b9ccdbf71436a137$export$2e2bcd8739ae039 = $b9ccdbf71436a137$var$createLineGenerator;

});
parcelRegister("eTMIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6df5b208b9d23752$export$2e2bcd8739ae039);

var $5FOwT = parcelRequire("5FOwT");
function $6df5b208b9d23752$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $5FOwT.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $5FOwT.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("5FOwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6257c3f70e94feb$export$2e2bcd8739ae039);
function $c6257c3f70e94feb$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("8bliZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9f6debfd276481a$export$2e2bcd8739ae039);

var $eTMIA = parcelRequire("eTMIA");
function $c9f6debfd276481a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $eTMIA.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $c9f6debfd276481a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("g6MVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8213b6c690eefe35$export$2e2bcd8739ae039);
function $8213b6c690eefe35$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("jVB7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98c01cbb865d4c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fBvqm = parcelRequire("fBvqm");
function $b98c01cbb865d4c1$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $fBvqm.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", containerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("code", codeTagProps, renderedRows));
}

});
parcelRegister("fBvqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fdda3a2c4411588$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lrHA4 = parcelRequire("lrHA4");

var $31cgS = parcelRequire("31cgS");

var $d3zI6 = parcelRequire("d3zI6");
function $2fdda3a2c4411588$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $2fdda3a2c4411588$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $31cgS.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lrHA4.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $d3zI6.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $2fdda3a2c4411588$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("lrHA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6443bd1dfeaac7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $abxiq = parcelRequire("abxiq");
function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter);
}
const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});

});
parcelRegister("abxiq", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $59fdc1b7b0ae96c9$export$a592b67c93d52467);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $jldZL = parcelRequire("jldZL");
const $59fdc1b7b0ae96c9$var$decoration = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $59fdc1b7b0ae96c9$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jldZL.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("mark", null, bidiCharacterCode)));
}
function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("31cgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16562bd8c2aca9b$export$2e2bcd8739ae039);
const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("d3zI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbc4a00f80b5d8f$export$2e2bcd8739ae039);

var $fBvqm = parcelRequire("fBvqm");
function $dcbc4a00f80b5d8f$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $fBvqm.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("7t3wc", function(module, exports) {

let $56fdf880767119f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56fdf880767119f7$var$load("as9qs").then(()=>parcelRequire('5zvIl'));

});




parcelRegister("irzxp", function(module, exports) {

$parcel$export(module.exports, "CopyAction", () => $64e12044af483692$export$958df07cbf9735fc);
$parcel$export(module.exports, "ActionContainer", () => $64e12044af483692$export$37ab3bdebc286ca);

var $5uXOq = parcelRequire("5uXOq");

var $ldJSL = parcelRequire("ldJSL");

var $3Fq5M = parcelRequire("3Fq5M");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8zOmE = parcelRequire("8zOmE");

var $fEogx = parcelRequire("fEogx");
const $64e12044af483692$export$2ce9877c9c1aa16 = {
    PROMPT: 'Copy',
    SUCCESS: 'Copied!',
    FAILURE: 'Copy to clipboard failed'
};
const $64e12044af483692$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    const handleSuccess = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.SUCCESS);
    }, [
        setTooltipMessage
    ]);
    const handleError = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.FAILURE);
    }, [
        setTooltipMessage
    ]);
    const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        actionSubjectId && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(source).then(handleSuccess, handleError);
    }, [
        source,
        handleSuccess,
        handleError,
        actionSubjectId
    ]);
    const resetMessage = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    }, [
        setTooltipMessage
    ]);
    function shouldRender() {
        if (typeof document !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return Boolean(navigator?.clipboard?.writeText);
    }
    return shouldRender() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fEogx.Action), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))),
        label: tooltipMessage,
        onClick: writeToClipboard,
        onMouseOver: resetMessage,
        onFocus: resetMessage,
        "aria-live": "assertive",
        "aria-atomic": "true",
        name: "Copy"
    }) : null;
};
const $64e12044af483692$var$stopPropagation = (event)=>event.stopPropagation();
const $64e12044af483692$export$37ab3bdebc286ca = ({ children: children })=>/**
	 * This element uses an `onMouseDown` to block event propagation
	 * to its parent but is not itself interactive.
	 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $64e12044af483692$var$absolutePositionWrapperStyles,
        onMouseDown: $64e12044af483692$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), {
        label: "actions"
    }, children));
const $64e12044af483692$var$absolutePositionWrapperStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});

});
parcelRegister("fEogx", function(module, exports) {

$parcel$export(module.exports, "Action", () => $e6da05ade6347218$export$e19cd5f9376f8cee);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $3bDjY = parcelRequire("3bDjY");
const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
    const updateTooltip = (0, $5uXOq.useRef)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel || label;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        isLoading: isLoading,
        appearance: "subtle",
        icon: icon,
        label: label,
        spacing: "compact",
        ...buttonProps
    }));
};

});




parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("bTyOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073396748f92b4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $5073396748f92b4e$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5I4tL")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("h8kvT")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $dCLgq = parcelRequire("dCLgq");

var $h8kvT = parcelRequire("h8kvT");

var $5I4tL = parcelRequire("5I4tL");
const $5073396748f92b4e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5I4tL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($h8kvT))
});
var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
// for advanced use only
const $5073396748f92b4e$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("h8kvT", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("5I4tL", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("fC09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb376757c4acc5ab$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3pGSh")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $dCLgq = parcelRequire("dCLgq");

var $3pGSh = parcelRequire("3pGSh");
const $bb376757c4acc5ab$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3pGSh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3pGSh))
});
var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
// for advanced use only
const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("3pGSh", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("4AdE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $135a9e70a6f11b3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    },
    serviceHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-document-title-jsm",
        "defaultMessage": "Service hub not found - Service project"
    },
    serviceHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-title",
        "defaultMessage": "This service hub isn't available"
    },
    serviceHubNotFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    serviceHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-action",
        "defaultMessage": "View a list of all service hubs"
    }
});

});


parcelRegister("cPB2u", function(module, exports) {

$parcel$export(module.exports, "InsightObjectViewSkeleton", () => $94934010d83fafeb$export$4318a5dd76ab9b69);
$parcel$export(module.exports, "InsightObjectViewHeaderSkeleton", () => $94934010d83fafeb$export$8adbf5d0ad204f0d);
$parcel$export(module.exports, "InsightObjectViewAttributesSkeleton", () => $94934010d83fafeb$export$fd4d1c10d8bf3e15);
$parcel$export(module.exports, "InsightObjectViewLinkedObjectsSkeleton", () => $94934010d83fafeb$export$92d9f62d25f4209e);
$parcel$export(module.exports, "InsightObjectViewPanelSkeleton", () => $94934010d83fafeb$export$e84eb014f3325b25);
/* InsightObjectViewSkeleton.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hCy6k = parcelRequire("hCy6k");

var $5Vj5i = parcelRequire("5Vj5i");

var $idbcr = parcelRequire("idbcr");

var $6jPox = parcelRequire("6jPox");

var $3Yv1j = parcelRequire("3Yv1j");

var $5gUVp = parcelRequire("5gUVp");
const $94934010d83fafeb$var$skeletonCssStyles = null;
const $94934010d83fafeb$export$4318a5dd76ab9b69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($94934010d83fafeb$var$ObjectViewWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5gUVp))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
const $94934010d83fafeb$export$8adbf5d0ad204f0d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($94934010d83fafeb$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($idbcr))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
const $94934010d83fafeb$export$fd4d1c10d8bf3e15 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($94934010d83fafeb$var$AttributesWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5Vj5i))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
const $94934010d83fafeb$export$92d9f62d25f4209e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($94934010d83fafeb$var$LinkedObjectsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6jPox))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
const $94934010d83fafeb$export$e84eb014f3325b25 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($94934010d83fafeb$var$PanelWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3Yv1j))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94934010d83fafeb$var$ObjectViewWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71l1jgf _18m915vq",
            __cmplp.className
        ])
    });
});
const $94934010d83fafeb$var$HeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71l1nlq",
            __cmplp.className
        ])
    });
});
const $94934010d83fafeb$var$AttributesWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71ldgin",
            __cmplp.className
        ])
    });
});
const $94934010d83fafeb$var$LinkedObjectsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71lhcro _18m915vq",
            __cmplp.className
        ])
    });
});
const $94934010d83fafeb$var$PanelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71l8ved _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Vj5i", function(module, exports) {
module.exports = new URL("insight-object-view-attributes-skeleton.tpl.2ad800bb.svg", import.meta.url).toString();

});

parcelRegister("idbcr", function(module, exports) {
module.exports = new URL("insight-object-view-header-skeleton.tpl.16b423cc.svg", import.meta.url).toString();

});

parcelRegister("6jPox", function(module, exports) {
module.exports = new URL("insight-object-view-linked-objects-skeleton.tpl.ba10f51b.svg", import.meta.url).toString();

});

parcelRegister("3Yv1j", function(module, exports) {
module.exports = new URL("insight-object-view-panel-skeleton.tpl.b6b0e1b0.svg", import.meta.url).toString();

});

parcelRegister("5gUVp", function(module, exports) {
module.exports = new URL("insight-object-view-skeleton.tpl.ec17eb0a.svg", import.meta.url).toString();

});


parcelRegister("kfAYm", function(module, exports) {

$parcel$export(module.exports, "useFetchObjectDetails", () => $6798e4e91317cd12$export$b37a506962399e6);

var $5uXOq = parcelRequire("5uXOq");

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $iN6n9 = parcelRequire("iN6n9");
const $6798e4e91317cd12$export$b37a506962399e6 = (workspaceId, createAnalyticsEvent)=>{
    const requestSignal = (0, $5uXOq.useRef)();
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [data, setData] = (0, $5uXOq.useState)();
    const [error, setError] = (0, $5uXOq.useState)();
    const request = (0, $5uXOq.useCallback)(async (objectId)=>{
        setLoading(true);
        setError(undefined);
        if (requestSignal.current) requestSignal.current.abort();
        try {
            requestSignal.current = new AbortController();
            const response = await (0, $4VpwK.performCmdbGetRequest)((0, $iN6n9.getObjectDetailsUrl)(workspaceId, objectId), {
                signal: requestSignal.current.signal
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchObjectDetails succeeded');
            setData(response);
            setLoading(false);
            return response;
        } catch (err) {
            const typesafeError = err instanceof Error ? err : new Error('Unknown error');
            if (typesafeError && typesafeError.name === 'AbortError') return undefined;
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: typesafeError,
                meta: {
                    id: 'fetchObjectDetails',
                    packageName: 'jiraServicedeskInsightObjectView'
                }
            });
            setLoading(false);
            setError(typesafeError);
            return undefined;
        }
    }, [
        createAnalyticsEvent,
        workspaceId
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        fetchObjectDetails: request
    };
};

});


parcelRegister("9IbpA", function(module, exports) {

$parcel$export(module.exports, "InsightObjectView", () => $d42d9f0e996fa625$export$32e01462335325cc);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $iXVV6 = parcelRequire("iXVV6");

var $1eAGE = parcelRequire("1eAGE");

var $63xWe = parcelRequire("63xWe");

var $gYjAy = parcelRequire("gYjAy");

var $7Vbhp = parcelRequire("7Vbhp");

var $hQW29 = parcelRequire("hQW29");

var $66Vf6 = parcelRequire("66Vf6");

var $62ZHK = parcelRequire("62ZHK");

var $24qlo = parcelRequire("24qlo");

var $absV2 = parcelRequire("absV2");

var $5Ny9E = parcelRequire("5Ny9E");

var $e0RrL = parcelRequire("e0RrL");

var $8pMQX = parcelRequire("8pMQX");

var $cPB2u = parcelRequire("cPB2u");

var $cNd4s = parcelRequire("cNd4s");

var $lEF8G = parcelRequire("lEF8G");

var $3WieA = parcelRequire("3WieA");

var $as7ha = parcelRequire("as7ha");
const $d42d9f0e996fa625$export$9bef6f86ab04559 = (props)=>{
    const [{ objectDetails: objectDetails, objectConfiguration: objectConfiguration, loading: loading, error: error }, { setIsCompact: setIsCompact }] = (0, $66Vf6.useObjectStoreState)();
    const [canEdit] = (0, $66Vf6.useCanEditObject)();
    const [canDelete] = (0, $66Vf6.useCanDeleteObject)();
    const [cmdbUiAnalyticAttributes] = (0, $66Vf6.useCmdbAnalyticAttributes)();
    const [isObjectGraphOpen, setIsObjectGraphOpen] = (0, $5uXOq.useState)(false);
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { backButton: backButton, context: context, onClone: onClone, onDelete: onDelete, redirectOnDelete: redirectOnDelete, showFullBreadcrumbTrail: showFullBreadcrumbTrail, onFinishLoading: onFinishLoading } = props;
    (0, $5uXOq.useEffect)(()=>{
        if (!loading && objectDetails && onFinishLoading !== undefined) onFinishLoading();
    }, [
        loading,
        objectDetails,
        onFinishLoading
    ]);
    if (!objectDetails || loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPB2u.InsightObjectViewSkeleton), null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            ...cmdbUiAnalyticAttributes ?? undefined,
            isSiteAdmin: isSiteAdmin
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $absV2.InsightObjectViewLayout), {
        renderHeader: (isMultiColumn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WieA.ObjectViewHeader), {
                canEdit: canEdit,
                canDelete: canDelete,
                backButton: backButton,
                isMultiColumn: isMultiColumn,
                onClone: onClone,
                onDelete: onDelete,
                redirectOnDelete: redirectOnDelete,
                showFullBreadcrumbTrail: showFullBreadcrumbTrail
            }),
        renderPrimary: (isMultiColumn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $62ZHK.ObjectDetails), {
                context: context,
                isMultiColumn: isMultiColumn
            }),
        renderSecondary: (isCompact)=>{
            setIsCompact(isCompact);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d42d9f0e996fa625$var$SecondaryContent, null, objectDetails.hasAvatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lEF8G.AvatarPanel), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Vbhp.AsyncLinkedObjectsPanel), {
                onOpenObjectGraph: ()=>{
                    setIsObjectGraphOpen(true);
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYjAy.AsyncLinkedIssuesPanel), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hQW29.AsyncObjectAttachmentsPanel), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $as7ha.ObjectDates), null));
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $24qlo.InsightObjectGraphModal), {
        objectId: (0, $5Ny9E.toCmdbObjectId)(objectDetails.id),
        objectTypeId: (0, $5Ny9E.toCmdbObjectTypeId)(objectDetails.objectType.id),
        source: "insight",
        onClose: ()=>{
            setIsObjectGraphOpen(false);
        },
        isObjectGraphOpen: isObjectGraphOpen
    }), objectDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0RrL.TrackObjectView), {
        id: (0, $5Ny9E.toCmdbObjectId)(objectDetails.id)
    }));
    if ((0, $4R6GH.fg)('jsm_assets_cbp_limits_and_notifications')) {
        // When cleaning up this feature flag jsm_assets_cbp_limits_and_notifications combine this check `!objectConfiguration`
        // with the existing `!objectDetails || loading` check above
        if (!objectConfiguration) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPB2u.InsightObjectViewHeaderSkeleton), null);
        const { insightAdministrator: insightAdministrator, limitInfo: { objectCount: objectCount, objectLimit: objectLimit, billingCycle: billingCycle, limitState: limitState = 'disabled' } } = objectConfiguration;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $63xWe.ObjectUsageProvider), {
            isJiraAdmin: insightAdministrator,
            objectCount: objectCount,
            objectLimit: objectLimit,
            billingPeriod: billingCycle === 'annual' ? 'annual' : 'monthly',
            limitState: limitState
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, context === 'Page' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eAGE.LimitsBanner), {
            isObjectView: true
        }) : null, content));
    }
    return content;
};
const $d42d9f0e996fa625$export$32e01462335325cc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "ObjectView",
        packageName: "jiraServicedeskInsightObjectView",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d42d9f0e996fa625$export$9bef6f86ab04559, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d42d9f0e996fa625$var$SecondaryContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1ejb _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1eAGE", function(module, exports) {

$parcel$export(module.exports, "LimitsBanner", () => $51c8e3f5c87490d6$export$276b2f7a0e2a1206);

var $5uXOq = parcelRequire("5uXOq");

var $lkmWu = parcelRequire("lkmWu");

var $42CjB = parcelRequire("42CjB");

var $84THj = parcelRequire("84THj");

var $dD7Zc = parcelRequire("dD7Zc");

var $bU3PY = parcelRequire("bU3PY");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");


var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $blEB6 = parcelRequire("blEB6");

var $63xWe = parcelRequire("63xWe");

var $jvhnv = parcelRequire("jvhnv");
const $51c8e3f5c87490d6$export$276b2f7a0e2a1206 = ({ displayWithOffset: displayWithOffset, isObjectView: isObjectView = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onDismiss = (0, $63xWe.useObjectUsageDismiss)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const objectUsageInfo = (0, $63xWe.useObjectUsageInfo)('limits-banner');
    if (objectUsageInfo.type === 'none') return null;
    let appearance = 'announcement';
    const { userRole: userRole, billingPeriod: billingPeriod, type: type } = objectUsageInfo;
    const isAdmin = userRole === 'admin';
    let content = null;
    const getFilteredMessageContent = (contentToFormat, url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...contentToFormat,
            values: {
                p: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, msg),
                a: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                        appearance: "inverse",
                        href: url,
                        onClick: ()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'cmdbConsumptionBasedPricingNotification')
                    }, msg),
                b: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        weight: "bold"
                    }, msg)
            }
        });
    const increaseUsageUrl = (0, $blEB6.getFeatureUsagePageUrl)({
        showChangeLimitModal: true
    });
    const getMonthlyContent = ()=>{
        switch(type){
            case '80-percent':
                content = isAdmin ? getFilteredMessageContent((0, $jvhnv.messages).admin80PercentMonthly, increaseUsageUrl) : null;
                break;
            case '90-percent':
                appearance = 'warning';
                content = isAdmin ? getFilteredMessageContent((0, $jvhnv.messages).admin90PercentMonthly, increaseUsageUrl) : getFilteredMessageContent((0, $jvhnv.messages).agent90PercentMonthly, '');
                break;
            case 'limit-reached':
                appearance = 'error';
                content = isAdmin ? getFilteredMessageContent((0, $jvhnv.messages).adminLimitReachedMonthly, increaseUsageUrl) : getFilteredMessageContent((0, $jvhnv.messages).agentLimitReachedMonthly, '');
                break;
            default:
                return null;
        }
    };
    const getYearlyContent = ()=>{
        switch(type){
            case '80-percent':
                content = isAdmin ? getFilteredMessageContent((0, $jvhnv.messages).admin80PercentYearly, increaseUsageUrl) : null;
                break;
            case '90-percent':
                appearance = 'warning';
                content = isAdmin ? getFilteredMessageContent((0, $jvhnv.messages).admin90PercentYearly, increaseUsageUrl) : getFilteredMessageContent((0, $jvhnv.messages).agent90PercentYearly, '');
                break;
            case 'limit-reached':
                appearance = 'error';
                content = isAdmin ? getFilteredMessageContent((0, $jvhnv.messages).adminLimitReachedYearly, increaseUsageUrl) : getFilteredMessageContent((0, $jvhnv.messages).agentLimitReachedYearly, '');
                break;
            default:
                return null;
        }
    };
    const getBannerIcon = ()=>{
        if (type === '90-percent') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
            color: "currentColor",
            LEGACY_secondaryColor: "inherit",
            label: formatMessage((0, $jvhnv.messages).warningIcon),
            spacing: "spacious"
        });
        if (type === 'limit-reached') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            color: "currentColor",
            LEGACY_secondaryColor: "inherit",
            label: formatMessage((0, $jvhnv.messages).errorIcon),
            spacing: "spacious"
        });
        return undefined;
    };
    switch(billingPeriod){
        case 'monthly':
            getMonthlyContent();
            break;
        case 'annual':
            getYearlyContent();
            break;
        default:
            return null;
    }
    const getBannerContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$238d30785c4bca84),
            sourceName: "cmdbConsumptionBasedPricingNotification"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $51c8e3f5c87490d6$var$outerBannerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkmWu.default), {
            appearance: appearance,
            icon: getBannerIcon(),
            testId: "servicedesk-cmdb-object-usage-messaging.ui.limits-banner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $51c8e3f5c87490d6$var$bannerContentWrapper
        }, content), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $51c8e3f5c87490d6$var$bannerCloseWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            appearance: "subtle",
            onClick: ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'cmdbConsumptionBasedPricingNotification');
                onDismiss();
            },
            spacing: "compact",
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
                    ...iconProps,
                    LEGACY_size: "medium",
                    color: type === '90-percent' ? `var(--ds-text-warning-inverse, ${0, $829f609a65d26a98$export$7d61b15e0da132af})` : `var(--ds-text-inverse, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                    spacing: "spacious"
                }),
            label: formatMessage((0, $jvhnv.messages).dismissBanner)
        })))));
    if (isObjectView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51c8e3f5c87490d6$var$objectViewOffsetWrapper,
        testId: "servicedesk-cmdb-object-usage-messaging.ui.limits-banner.limits-banner-object-view-offset-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51c8e3f5c87490d6$var$layoutOffsetInner
    }, getBannerContent()));
    return displayWithOffset ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51c8e3f5c87490d6$var$layoutOffsetWrapper,
        testId: "servicedesk-cmdb-object-usage-messaging.ui.limits-banner.limits-banner-layout-offset-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51c8e3f5c87490d6$var$layoutOffsetInner
    }, getBannerContent())) : getBannerContent();
};
const $51c8e3f5c87490d6$var$bannerCloseWrapper = (0, $8CUq3.xcss)({
    position: 'absolute',
    right: 'space.150',
    top: '50%',
    transform: 'translateY(-50%)'
});
const $51c8e3f5c87490d6$var$outerBannerWrapper = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $51c8e3f5c87490d6$var$bannerContentWrapper = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingRight: 'space.400',
    [(0, $h9kUS.media).above.sm]: {
        paddingRight: 'space.500'
    }
});
// nested wrappers due to no space.negative.500, maximum 400.
const $51c8e3f5c87490d6$var$layoutOffsetWrapper = (0, $8CUq3.xcss)({
    marginBottom: 'space.0',
    marginLeft: 'space.negative.400',
    marginRight: 'space.negative.400'
});
// nested wrappers due to no space.negative.500, maximum 400.
const $51c8e3f5c87490d6$var$objectViewOffsetWrapper = (0, $8CUq3.xcss)({
    marginTop: 'space.negative.200',
    marginLeft: 'space.negative.400',
    marginRight: 'space.negative.400',
    marginBottom: 'space.300'
});
const $51c8e3f5c87490d6$var$layoutOffsetInner = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100'
});

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("63xWe", function(module, exports) {

$parcel$export(module.exports, "useObjectUsageDismiss", () => $a711c016e8269a5a$export$488ff4bad70ebd64);
$parcel$export(module.exports, "useObjectUsageRefreshObjectCount", () => $a711c016e8269a5a$export$555b8f9a7e864563);
$parcel$export(module.exports, "useObjectUsageInfo", () => $a711c016e8269a5a$export$4adfcc0459dd98ca);
$parcel$export(module.exports, "useBillingPeriod", () => $a711c016e8269a5a$export$65fa1dba3c6d4da1);
$parcel$export(module.exports, "useLimitState", () => $a711c016e8269a5a$export$c52f3408141b34f0);
$parcel$export(module.exports, "ObjectUsageProvider", () => $a711c016e8269a5a$export$dcd40a00452817a6);

var $5uXOq = parcelRequire("5uXOq");

var $7DxXA = parcelRequire("7DxXA");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $5vvVt = parcelRequire("5vvVt");

var $bGnUR = parcelRequire("bGnUR");

var $2oKkj = parcelRequire("2oKkj");
const $a711c016e8269a5a$var$Store = (0, $iXqE5.createStore)({
    initialState: $5vvVt.initialState,
    actions: $2oKkj.actions
});
const $a711c016e8269a5a$var$useActions = (0, $3sQ5x.createActionsHook)($a711c016e8269a5a$var$Store);
const $a711c016e8269a5a$export$488ff4bad70ebd64 = ()=>{
    const { dismissMessage: dismissMessage } = $a711c016e8269a5a$var$useActions();
    return dismissMessage;
};
const $a711c016e8269a5a$export$555b8f9a7e864563 = ()=>{
    const { refreshObjectCount: refreshObjectCount } = $a711c016e8269a5a$var$useActions();
    return (createAnalyticsEvent)=>refreshObjectCount(createAnalyticsEvent);
};
const $a711c016e8269a5a$export$4adfcc0459dd98ca = (0, $3sQ5x.createStateHook)($a711c016e8269a5a$var$Store, {
    selector: (0, $bGnUR.getObjectUsageInfo)
});
const $a711c016e8269a5a$export$65fa1dba3c6d4da1 = (0, $3sQ5x.createStateHook)($a711c016e8269a5a$var$Store, {
    selector: ({ billingPeriod: billingPeriod })=>billingPeriod
});
const $a711c016e8269a5a$export$c52f3408141b34f0 = (0, $3sQ5x.createStateHook)($a711c016e8269a5a$var$Store, {
    selector: ({ limitState: limitState })=>limitState
});
const $a711c016e8269a5a$var$dispatchInitialState = ()=>({ dispatch: dispatch }, { isJiraAdmin: isJiraAdmin, objectCount: objectCount, objectLimit: objectLimit, billingPeriod: billingPeriod, limitState: limitState, workspaceId: workspaceId })=>{
        dispatch((0, $2oKkj.actions).setInitialData({
            isJiraAdmin: isJiraAdmin,
            objectCount: objectCount,
            objectLimit: objectLimit,
            billingPeriod: billingPeriod,
            limitState: limitState,
            workspaceId: workspaceId
        }));
    };
const $a711c016e8269a5a$var$ObjectUsageStoreContainer = (0, $gg7kZ.createContainer)($a711c016e8269a5a$var$Store, {
    onInit: $a711c016e8269a5a$var$dispatchInitialState,
    onUpdate: $a711c016e8269a5a$var$dispatchInitialState,
    displayName: 'JsmCmdbObjectUsageStoreContainer'
});
const $a711c016e8269a5a$export$dcd40a00452817a6 = ({ children: children, isJiraAdmin: isJiraAdmin, objectCount: objectCount, objectLimit: objectLimit, billingPeriod: billingPeriod, limitState: limitState })=>{
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    if (!workspaceId) throw new Error('workspaceId not defined');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a711c016e8269a5a$var$ObjectUsageStoreContainer, {
        isJiraAdmin: isJiraAdmin,
        objectCount: objectCount,
        objectLimit: objectLimit,
        billingPeriod: billingPeriod,
        limitState: limitState,
        workspaceId: workspaceId,
        isGlobal: true
    }, children);
};

});
parcelRegister("5vvVt", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE", () => $c9dc651325ead5e5$export$c6a7366241a86d6d);
$parcel$export(module.exports, "DISMISSED_FOR_THRESHOLD_TYPE_KEY", () => $c9dc651325ead5e5$export$98e7ecfcc5c7cd3e);
$parcel$export(module.exports, "NONE", () => $c9dc651325ead5e5$export$c53d0f541b41b88e);
$parcel$export(module.exports, "initialState", () => $c9dc651325ead5e5$export$d4c72bab9d6cc13a);

var $bSSG7 = parcelRequire("bSSG7");
const $c9dc651325ead5e5$export$c6a7366241a86d6d = (0, $bSSG7.createLocalStorageProvider)('jsm-assets-object-usage-info');
const $c9dc651325ead5e5$export$98e7ecfcc5c7cd3e = 'dismissed';
const $c9dc651325ead5e5$export$c53d0f541b41b88e = {
    type: 'none'
};
const $c9dc651325ead5e5$export$d4c72bab9d6cc13a = {
    userRole: 'agent',
    billingPeriod: 'monthly',
    objectCount: 0,
    objectLimit: Number.MAX_SAFE_INTEGER,
    isDismissed: false,
    limitState: 'disabled',
    workspaceId: ''
};

});

parcelRegister("bGnUR", function(module, exports) {

$parcel$export(module.exports, "getObjectUsageInfo", () => $8f4665ac37150861$export$deea34ac3e790cc5);

var $5vvVt = parcelRequire("5vvVt");

var $lKvGx = parcelRequire("lKvGx");
const $8f4665ac37150861$export$deea34ac3e790cc5 = (state, location)=>{
    const { objectCount: objectCount, objectLimit: objectLimit, limitState: limitState, userRole: userRole, billingPeriod: billingPeriod, isDismissed: isDismissed } = state;
    if (limitState === 'disabled') return 0, $5vvVt.NONE;
    return (0, $lKvGx.determineObjectUsageInfo)({
        isJiraAdmin: userRole === 'admin',
        objectCount: objectCount,
        objectLimit: objectLimit,
        billingPeriod: billingPeriod,
        location: location,
        limitState: limitState,
        isDismissed: isDismissed
    });
};

});
parcelRegister("lKvGx", function(module, exports) {

$parcel$export(module.exports, "determineThreshold", () => $4198127f7bc6f02f$export$d2c1acdb7ab100ba);
$parcel$export(module.exports, "determineObjectUsageInfo", () => $4198127f7bc6f02f$export$6fe2fd277c274d8);

var $4R6GH = parcelRequire("4R6GH");

var $5vvVt = parcelRequire("5vvVt");
const $4198127f7bc6f02f$export$d2c1acdb7ab100ba = ({ objectCount: objectCount, objectLimit: objectLimit })=>{
    if (objectCount >= objectLimit) return 'limit-reached';
    if (objectCount >= objectLimit * 0.9) return '90-percent';
    if (objectCount >= objectLimit * 0.8) return '80-percent';
    return 'none';
};
const $4198127f7bc6f02f$export$6fe2fd277c274d8 = ({ isJiraAdmin: isJiraAdmin, objectCount: objectCount, objectLimit: objectLimit, billingPeriod: billingPeriod, location: location, limitState: limitState, isDismissed: isDismissed })=>{
    if (!(0, $4R6GH.fg)('jsm_assets_cbp_limits_and_notifications')) return 0, $5vvVt.NONE;
    const userRole = isJiraAdmin ? 'admin' : 'agent';
    const objectsRemaining = Math.max(objectLimit - objectCount, 0);
    const threshold = $4198127f7bc6f02f$export$d2c1acdb7ab100ba({
        objectCount: objectCount,
        objectLimit: objectLimit
    });
    const limitReachedUsageInfo = {
        type: threshold,
        userRole: userRole,
        billingPeriod: billingPeriod,
        objectsRemaining: objectsRemaining
    };
    switch(threshold){
        case 'limit-reached':
            switch(location){
                case 'create-object':
                    if (limitState === 'notify-only') return 0, $5vvVt.NONE;
                    return limitReachedUsageInfo;
                case 'import-data-modal':
                    return limitReachedUsageInfo;
                case 'assets-feature-usage-dashboard':
                case 'limits-banner':
                default:
                    if (isDismissed) return 0, $5vvVt.NONE;
                    return limitReachedUsageInfo;
            }
        case '90-percent':
            switch(location){
                case 'import-data-modal':
                    return limitReachedUsageInfo;
                case 'assets-feature-usage-dashboard':
                case 'limits-banner':
                case 'create-object':
                default:
                    if (isDismissed) return 0, $5vvVt.NONE;
                    return limitReachedUsageInfo;
            }
        case '80-percent':
            if (isDismissed) return 0, $5vvVt.NONE;
            switch(location){
                case 'assets-feature-usage-dashboard':
                case 'limits-banner':
                case 'create-object':
                    if (userRole === 'agent') // 80% not shown for agents in object create + limits-banner
                    return 0, $5vvVt.NONE;
                    return limitReachedUsageInfo;
                case 'import-data-modal':
                    // 80% not shown for any userRole in import data modal
                    return 0, $5vvVt.NONE;
                default:
                    return 0, $5vvVt.NONE;
            }
        case 'none':
            return 0, $5vvVt.NONE;
        default:
            return 0, $5vvVt.NONE;
    }
};

});


parcelRegister("2oKkj", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5f1d81c2e9b9cee2$export$e324594224ef24da);

var $1Yo63 = parcelRequire("1Yo63");

var $kN2r5 = parcelRequire("kN2r5");

var $bZQIa = parcelRequire("bZQIa");
const $5f1d81c2e9b9cee2$export$e324594224ef24da = {
    setInitialData: $bZQIa.setInitialData,
    dismissMessage: $1Yo63.dismissMessage,
    refreshObjectCount: $kN2r5.refreshObjectCount
};

});
parcelRegister("1Yo63", function(module, exports) {

$parcel$export(module.exports, "dismissMessage", () => $c7b2c9c8b2a86057$export$ce591ff86214e2a8);

var $5vvVt = parcelRequire("5vvVt");

var $lKvGx = parcelRequire("lKvGx");
const $c7b2c9c8b2a86057$export$ce591ff86214e2a8 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { objectCount: objectCount, objectLimit: objectLimit } = currentState;
        const threshold = (0, $lKvGx.determineThreshold)({
            objectCount: objectCount,
            objectLimit: objectLimit
        });
        const isDismissed = (0, $5vvVt.LOCAL_STORAGE).get((0, $5vvVt.DISMISSED_FOR_THRESHOLD_TYPE_KEY)) === threshold;
        if (!isDismissed) {
            (0, $5vvVt.LOCAL_STORAGE).set((0, $5vvVt.DISMISSED_FOR_THRESHOLD_TYPE_KEY), threshold);
            setState({
                ...currentState,
                isDismissed: true
            });
        }
    };

});

parcelRegister("kN2r5", function(module, exports) {

$parcel$export(module.exports, "refreshObjectCount", () => $c92dbd207d8fd580$export$457582db067330de);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $juXmc = parcelRequire("juXmc");

var $5vvVt = parcelRequire("5vvVt");

var $lKvGx = parcelRequire("lKvGx");
const $c92dbd207d8fd580$export$457582db067330de = ({ createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState })=>{
        try {
            const currentState = getState();
            const { workspaceId: workspaceId } = currentState;
            const response = await (0, $4VpwK.performCmdbGetRequest)((0, $juXmc.getCmdbGlobalConfigUrl)(workspaceId));
            const { limitInfo: limitInfo } = response;
            const { limitState: limitState = 'disabled', objectCount: objectCount, objectLimit: objectLimit } = limitInfo;
            const updatedState = {
                ...currentState,
                limitState: limitState,
                objectCount: objectCount,
                objectLimit: objectLimit
            };
            if ($c92dbd207d8fd580$var$isStoredIsDismissedValueStale({
                objectCount: objectCount,
                objectLimit: objectLimit
            })) {
                (0, $5vvVt.LOCAL_STORAGE).remove((0, $5vvVt.DISMISSED_FOR_THRESHOLD_TYPE_KEY));
                setState({
                    ...updatedState,
                    isDismissed: false
                });
            } else setState(updatedState);
            if (createAnalyticsEvent) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'refreshObjectCount succeeded');
        } catch (untypedError) {
            const error = untypedError instanceof Error ? untypedError : undefined;
            (0, $jcw0u.default)({
                meta: {
                    id: 'refreshObjectCount',
                    packageName: 'jiraServicedeskCmdbObjectUsageMessaging',
                    teamName: 'krispy-krew'
                },
                error: error
            });
        }
    };
const $c92dbd207d8fd580$var$isStoredIsDismissedValueStale = ({ objectCount: objectCount, objectLimit: objectLimit })=>{
    const threshold = (0, $lKvGx.determineThreshold)({
        objectCount: objectCount,
        objectLimit: objectLimit
    });
    const dismissState = (0, $5vvVt.LOCAL_STORAGE).get((0, $5vvVt.DISMISSED_FOR_THRESHOLD_TYPE_KEY));
    return dismissState && dismissState !== threshold && threshold !== 'none';
};

});

parcelRegister("bZQIa", function(module, exports) {

$parcel$export(module.exports, "setInitialData", () => $7c62df8eb847bfd1$export$e493baf433de729b);

var $5vvVt = parcelRequire("5vvVt");

var $lKvGx = parcelRequire("lKvGx");
const $7c62df8eb847bfd1$export$e493baf433de729b = ({ isJiraAdmin: isJiraAdmin, objectCount: objectCount, objectLimit: objectLimit, billingPeriod: billingPeriod, limitState: limitState, workspaceId: workspaceId })=>async ({ setState: setState })=>{
        const threshold = (0, $lKvGx.determineThreshold)({
            objectCount: objectCount,
            objectLimit: objectLimit
        });
        const dismissState = (0, $5vvVt.LOCAL_STORAGE).get((0, $5vvVt.DISMISSED_FOR_THRESHOLD_TYPE_KEY));
        const userRole = isJiraAdmin ? 'admin' : 'agent';
        if (dismissState && dismissState !== threshold && threshold !== 'none' && limitState !== 'disabled') (0, $5vvVt.LOCAL_STORAGE).remove((0, $5vvVt.DISMISSED_FOR_THRESHOLD_TYPE_KEY));
        setState({
            userRole: userRole,
            billingPeriod: billingPeriod,
            objectCount: objectCount,
            objectLimit: objectLimit,
            isDismissed: dismissState === threshold,
            limitState: limitState,
            workspaceId: workspaceId
        });
    };

});



parcelRegister("jvhnv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40d8afc302cd5904$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $40d8afc302cd5904$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    admin80PercentMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-80-percent-monthly",
        "defaultMessage": "<b>You're running out of available Assets objects (< 20%).</b> Delete objects or <a>increase usage limit</a>."
    },
    admin90PercentMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-90-percent-monthly",
        "defaultMessage": "<b>You're nearly out of available Assets objects (< 10%).</b> Delete objects or <a>increase usage limit</a>."
    },
    adminLimitReachedMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-limit-reached-monthly",
        "defaultMessage": "<b>You're out of available Assets objects.</b> Delete objects or <a>increase usage limit</a> to add more objects."
    },
    admin80PercentYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-80-percent-yearly",
        "defaultMessage": "<b>You're running out of available Assets objects (< 20%).</b> Delete objects or <a>get extra objects</a>."
    },
    admin90PercentYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-90-percent-yearly",
        "defaultMessage": "<b>You\u2019re nearly out of available Assets objects (< 10%).</b> Delete objects or <a>get extra objects</a>."
    },
    adminLimitReachedYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.admin-limit-reached-yearly",
        "defaultMessage": "<b>You\u2019re out of available Assets objects.</b> Delete objects or <a>get extra objects</a> to add more objects."
    },
    agent90PercentMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.agent-90-percent-monthly",
        "defaultMessage": "<b>You\u2019re nearly out of available Assets objects (< 10%).</b> Contact your admin to increase the usage limit."
    },
    agentLimitReachedMonthly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.agent-limit-reached-monthly",
        "defaultMessage": "<b>You\u2019re out of available Assets objects.</b> Contact your admin to increase the usage limit."
    },
    agent90PercentYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.agent-90-percent-yearly",
        "defaultMessage": "<b>You\u2019re nearly out of available Assets objects (< 10%).</b> Contact your admin to increase the usage limit."
    },
    agentLimitReachedYearly: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.agent-limit-reached-yearly",
        "defaultMessage": "<b>You\u2019re out of available Assets objects.</b> Contact your admin to increase the usage limit."
    },
    warningIcon: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.warning-icon",
        "defaultMessage": "Warning icon"
    },
    errorIcon: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.error-icon",
        "defaultMessage": "Error icon"
    },
    dismissBanner: {
        "id": "servicedesk-cmdb-object-usage-messaging.limits-banner.dismiss-banner",
        "defaultMessage": "Dismiss banner"
    }
});

});


parcelRegister("gYjAy", function(module, exports) {

$parcel$export(module.exports, "AsyncLinkedIssuesPanel", () => $a0cd19d9825b549d$export$328a737524f62180);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $cPB2u = parcelRequire("cPB2u");

var $kxZPA = parcelRequire("kxZPA");

const $a0cd19d9825b549d$var$LazyLinkedIssuesPanel = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9wtNb")), {
    moduleId: "./src/packages/servicedesk/insight-object/linked-issues-panel/src/ui/index.tsx"
});
const $a0cd19d9825b549d$export$328a737524f62180 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "insight-linked-issues-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPB2u.InsightObjectViewPanelSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0cd19d9825b549d$var$LazyLinkedIssuesPanel, null));

});
parcelRegister("9wtNb", function(module, exports) {

let $6eee36558b77a7d4$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("aMHR6"))((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve("gNqXp"), 4)),
    $6eee36558b77a7d4$var$load("g100A")
]).then(()=>parcelRequire('b1Ot1'));

});
parcelRegister("aMHR6", function(module, exports) {
"use strict";

var $g1Pp8 = parcelRequire("g1Pp8");
module.exports = $g1Pp8(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("g1Pp8", function(module, exports) {
"use strict";
var $bab49d2fea43af49$var$cachedBundles = {};
var $bab49d2fea43af49$var$cachedPreloads = {};
var $bab49d2fea43af49$var$cachedPrefetches = {};
function $bab49d2fea43af49$var$getCache(type) {
    switch(type){
        case 'preload':
            return $bab49d2fea43af49$var$cachedPreloads;
        case 'prefetch':
            return $bab49d2fea43af49$var$cachedPrefetches;
        default:
            return $bab49d2fea43af49$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $bab49d2fea43af49$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("7Vbhp", function(module, exports) {

$parcel$export(module.exports, "AsyncLinkedObjectsPanel", () => $5333820fddb83139$export$e3d21380432d05ea);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $cPB2u = parcelRequire("cPB2u");

var $kxZPA = parcelRequire("kxZPA");

const $5333820fddb83139$var$LazyLinkedObjectsPanel = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("9fEu8")), {
    moduleId: "./src/packages/servicedesk/insight-object/linked-objects-panel/src/ui/index.tsx"
});
const $5333820fddb83139$export$e3d21380432d05ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "insight-linked-objects-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPB2u.InsightObjectViewLinkedObjectsSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5333820fddb83139$var$LazyLinkedObjectsPanel, props));

});
parcelRegister("9fEu8", function(module, exports) {

let $6bc4eb4648ee4b9d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6bc4eb4648ee4b9d$var$load("cZq3n").then(()=>parcelRequire('ki1w4'));

});


parcelRegister("hQW29", function(module, exports) {

$parcel$export(module.exports, "AsyncObjectAttachmentsPanel", () => $34ac0d364a085387$export$6286706d0779d808);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $cPB2u = parcelRequire("cPB2u");

var $kxZPA = parcelRequire("kxZPA");

const $34ac0d364a085387$var$LazyObjectAttachmentsPanel = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8tFwz")), {
    moduleId: "./src/packages/servicedesk/insight-object/object-attachments-panel/src/ui/index.tsx"
});
const $34ac0d364a085387$export$6286706d0779d808 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "insight-object-attachments-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPB2u.InsightObjectViewPanelSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34ac0d364a085387$var$LazyObjectAttachmentsPanel, null));

});
parcelRegister("8tFwz", function(module, exports) {

let $62c13e0176595f47$var$load = (parcelRequire("28QjX"))(4);
module.exports = $62c13e0176595f47$var$load("bh9rG").then(()=>parcelRequire('a0nWX'));

});


parcelRegister("62ZHK", function(module, exports) {

$parcel$export(module.exports, "ObjectDetails", () => $24d53dfc1f78531c$export$eb822877bbd03071);
/* main.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");

var $fphHl = parcelRequire("fphHl");
var $jxIT3 = parcelRequire("jxIT3");
var $cte3m = parcelRequire("cte3m");
var $8TQB5 = parcelRequire("8TQB5");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3TpKp = parcelRequire("3TpKp");

var $b0lZs = parcelRequire("b0lZs");

var $kEqrP = parcelRequire("kEqrP");

var $66Vf6 = parcelRequire("66Vf6");

var $9BNuU = parcelRequire("9BNuU");

var $cPB2u = parcelRequire("cPB2u");

var $ce4pa = parcelRequire("ce4pa");

var $4IbhP = parcelRequire("4IbhP");

var $aROOn = parcelRequire("aROOn");
const $24d53dfc1f78531c$export$eb822877bbd03071 = (props)=>{
    const { context: context, isMultiColumn: isMultiColumn } = props;
    const [attributeTypes] = (0, $66Vf6.useEditableAttributeTypes)();
    const [selectedTab, setSelectedTab] = (0, $5uXOq.useState)(0);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const tabItems = (0, $5uXOq.useMemo)(()=>[
            {
                label: formatMessage((0, $4IbhP.default).detailsTabTitle),
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($24d53dfc1f78531c$var$TabContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b0lZs.default), {
                    attributeTypes: attributeTypes,
                    isMultiColumn: isMultiColumn
                }), attributeTypes.length > 0 && context === (0, $aROOn.ObjectDetailsRenderingContext).Page && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                    sourceName: "cmdbObjectDetails",
                    sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TpKp.JsmPageInteractiveEvent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)), attributeTypes.length > 0 && context === (0, $aROOn.ObjectDetailsRenderingContext).Component && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ce4pa.ExperienceSuccess), {
                    experience: (0, $kEqrP.loadObjectDetailExperience)
                })),
                testId: 'servicedesk-insight-object-details.ui.object-details-tabs.attributes'
            },
            {
                label: formatMessage((0, $4IbhP.default).activityTabTitle),
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($24d53dfc1f78531c$var$TabContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9BNuU.AsyncInsightObjectTimeline), null)),
                testId: 'servicedesk-insight-object-details.ui.object-details-tabs.activity'
            }
        ], [
        attributeTypes,
        context,
        formatMessage,
        isMultiColumn
    ]);
    const onSelectTab = (0, $5uXOq.useCallback)((_, index)=>{
        if (index === 0) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightObjectDetailsTab');
        if (index === 1) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightObjectActivityTimelineTab');
        setSelectedTab(index);
    }, [
        setSelectedTab,
        createAnalyticsEvent
    ]);
    const handleChange = (index)=>{
        onSelectTab({}, index);
    };
    if (attributeTypes.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPB2u.InsightObjectViewAttributesSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fphHl.default), {
        selected: selectedTab,
        onChange: handleChange,
        id: "object-details-panel-tabs",
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cte3m.default), null, tabItems.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxIT3.default), {
            testId: tab.testId,
            key: index
        }, tab.label))), tabItems.map((tab, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TQB5.default), {
            key: index
        }, tab.content))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $24d53dfc1f78531c$var$TabContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1ejb _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fphHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4810d6c8b7d5c95d$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $dWD6q = parcelRequire("dWD6q");
const $4810d6c8b7d5c95d$var$baseStyles = null;
const $4810d6c8b7d5c95d$var$tabsStyles = null;
const $4810d6c8b7d5c95d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ $5uXOq.createElement((0, $dWD6q.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $5uXOq.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $5uXOq.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$4810d6c8b7d5c95d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dWD6q.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), null, tabPanelsWithContext));
};
var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;

});
parcelRegister("dWD6q", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $b47499898157cfdc$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $b47499898157cfdc$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $b47499898157cfdc$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5uXOq = parcelRequire("5uXOq");
const $b47499898157cfdc$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$2054129d247c3102 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("jxIT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a23bdf24c904bdb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $dS3PR = parcelRequire("dS3PR");

var $eQ4wW = parcelRequire("eQ4wW");
/**
 * __Tab__
 *
 * Tab represents an indivudal Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $5a23bdf24c904bdb$var$Tab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $eQ4wW.useTab)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhVLw.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children)));
});
var $5a23bdf24c904bdb$export$2e2bcd8739ae039 = $5a23bdf24c904bdb$var$Tab;

});
parcelRegister("eQ4wW", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $4d8616502e4de6b0$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $4d8616502e4de6b0$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $4d8616502e4de6b0$export$fae0121b5afe572d);

var $5uXOq = parcelRequire("5uXOq");

var $dWD6q = parcelRequire("dWD6q");
const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $5uXOq.useContext)((0, $dWD6q.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $5uXOq.useContext)((0, $dWD6q.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $5uXOq.useContext)((0, $dWD6q.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("cte3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15f9538b451f314$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $eQ4wW = parcelRequire("eQ4wW");

var $dWD6q = parcelRequire("dWD6q");
const $e15f9538b451f314$var$baseStyles = null;
const $e15f9538b451f314$var$tabListStyles = null;
const $e15f9538b451f314$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $e15f9538b451f314$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $eQ4wW.useTabList)();
    const ref = /*#__PURE__*/ (0, $5uXOq.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ $5uXOq.createElement((0, $dWD6q.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        className: (0, $bwpsq.default)([
            "_1yt4ze3t _1e0c1txw _kqswh2mm",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _13xael4l _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8zxi _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8zxi _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmz174y _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _13xael4l _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hygqwt _1lzu1eqa _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jakgqwt _1b8d1eqa _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ugqwt _rsmz1gcm _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3gqwt _1mp41kw7 _kfgt1bk5 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ])
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        })));
};
var $e15f9538b451f314$export$2e2bcd8739ae039 = $e15f9538b451f314$var$TabList;

});

parcelRegister("8TQB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca06f45af60382a8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jhVLw = parcelRequire("jhVLw");

var $eQ4wW = parcelRequire("eQ4wW");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $ca06f45af60382a8$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $eQ4wW.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhVLw.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, children)));
};
var $ca06f45af60382a8$export$2e2bcd8739ae039 = $ca06f45af60382a8$var$TabPanel;

});

parcelRegister("3TpKp", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $bbb7386cf97044f2$export$c4ba40c380ee9a11);

var $5uXOq = parcelRequire("5uXOq");

var $5rqex = parcelRequire("5rqex");
const $bbb7386cf97044f2$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), args);
$bbb7386cf97044f2$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$bbb7386cf97044f2$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("b0lZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $4886fd630740ad96$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $841Rq = parcelRequire("841Rq");
const $4886fd630740ad96$var$EditableAttributeList = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightEditableAttributesList",
        packageName: "jiraServicedeskInsightEditableAttributesList",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $841Rq.EditableAttributeList), props));
var $4886fd630740ad96$export$2e2bcd8739ae039 = $4886fd630740ad96$var$EditableAttributeList;

});
parcelRegister("841Rq", function(module, exports) {

$parcel$export(module.exports, "EditableAttributeList", () => $e80c359bc6006b11$export$682dfd0930f6eb44);
/* main.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bB6uF = parcelRequire("bB6uF");

var $7reJE = parcelRequire("7reJE");

var $fnYbX = parcelRequire("fnYbX");

var $47wQS = parcelRequire("47wQS");

var $3hJsw = parcelRequire("3hJsw");

var $g7MYF = parcelRequire("g7MYF");

var $96xYc = parcelRequire("96xYc");

var $7eNFP = parcelRequire("7eNFP");

var $ee0Zu = parcelRequire("ee0Zu");

var $jjGxH = parcelRequire("jjGxH");

var $llEjP = parcelRequire("llEjP");

var $4DfBb = parcelRequire("4DfBb");

var $aC7yQ = parcelRequire("aC7yQ");

var $gQHjy = parcelRequire("gQHjy");

var $66Vf6 = parcelRequire("66Vf6");

var $4fIgT = parcelRequire("4fIgT");

var $kCYNT = parcelRequire("kCYNT");

var $5Ny9E = parcelRequire("5Ny9E");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $jn7Xc = parcelRequire("jn7Xc");

var $jHpBb = parcelRequire("jHpBb");

var $5D95s = parcelRequire("5D95s");

var $9wsAH = parcelRequire("9wsAH");

var $9DpdN = parcelRequire("9DpdN");
// The number of "system attributes" that are always present (Key, Created, Updated) but not displayed in the attributes list
const $e80c359bc6006b11$var$NUM_SYSTEM_ATTRIBUTES = 3;
const $e80c359bc6006b11$export$682dfd0930f6eb44 = (props)=>{
    const { attributeTypes: attributeTypes } = props;
    const [canEdit] = (0, $66Vf6.useCanEditObject)();
    const [{ objectDetails: objectDetails, hideEmptyAttributes: hideEmptyAttributes }] = (0, $66Vf6.useObjectStoreState)();
    const [isRestrictedSchema] = (0, $66Vf6.useIsRestrictedSchema)();
    const { objectType: objectType, attributes: attributes = [] } = objectDetails ?? {};
    const { objectSchemaId: objectSchemaId } = objectType ?? {};
    const [propertyState] = (0, $4fIgT.useObjectSchemaPropertyService)({
        objectSchemaId: (0, $5Ny9E.toSchemaId)(`${objectSchemaId}`)
    });
    const numHiddenAttributes = hideEmptyAttributes ? attributeTypes.length - attributes.length + $e80c359bc6006b11$var$NUM_SYSTEM_ATTRIBUTES : 0;
    if (attributeTypes.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9wsAH.AttributesSkeleton), null);
    const renderDefaultAttributeType = (defaultAT)=>{
        const renderTextAttribute = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aC7yQ.TextEditableAttribute), {
                attributeType: defaultAT,
                isEditable: canEdit
            });
        return (0, $kCYNT.matchDefaultAttributeSubType)(defaultAT.defaultType, {
            url: renderTextAttribute,
            email: renderTextAttribute,
            float: renderTextAttribute,
            integer: renderTextAttribute,
            ipAddress: renderTextAttribute,
            text: renderTextAttribute,
            textarea: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4DfBb.TextAreaEditableAttribute), {
                    attributeType: defaultAT,
                    isEditable: canEdit
                }),
            select: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjGxH.SelectEditableAttribute), {
                    attributeType: defaultAT,
                    isEditable: canEdit
                }),
            boolean: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fnYbX.BooleanEditableAttribute), {
                    attributeType: defaultAT,
                    isEditable: canEdit
                }),
            date: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47wQS.DateEditableAttribute), {
                    attributeType: defaultAT,
                    isEditable: canEdit
                }),
            datetime: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3hJsw.DateTimeEditableAttribute), {
                    attributeType: defaultAT,
                    isEditable: canEdit
                })
        });
    };
    const renderInlineEditableAttribute = (attributeType)=>(0, $kCYNT.matchInsightObjectAttributeType)(attributeType, {
            default: renderDefaultAttributeType,
            object: (objectAT)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ee0Zu.ObjectEditableAttribute), {
                    attributeType: objectAT,
                    isEditable: canEdit,
                    quickCreateObjects: propertyState.data?.quickCreateObjects
                }),
            user: (userAT)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gQHjy.UserEditableAttribute), {
                    attributeType: userAT,
                    isEditable: canEdit
                }),
            group: (groupAT)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g7MYF.GroupEditableAttribute), {
                    attributeType: groupAT,
                    isEditable: canEdit
                }),
            project: (projectAT)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eNFP.ProjectEditableAttribute), {
                    attributeType: projectAT,
                    isEditable: canEdit
                }),
            status: (statusAT)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $llEjP.StatusEditableAttribute), {
                    attributeType: statusAT,
                    isEditable: canEdit
                }),
            bitbucketRepo: (bitbucketRepoAT)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7reJE.BitbucketRepoEditableAttribute), {
                    attributeType: bitbucketRepoAT,
                    isEditable: canEdit
                }),
            opsgenieTeam: (opsgenieTeamAT)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96xYc.OpsgenieTeamsAttribute), {
                    attributeType: opsgenieTeamAT,
                    isEditable: false
                })
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e80c359bc6006b11$var$Container, {
        "data-testid": "servicedesk-insight-editable-attribute-list.ui.attributes-list"
    }, isRestrictedSchema && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5D95s.RestrictedSchemaEditingInformation), null), hideEmptyAttributes && numHiddenAttributes > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jHpBb.EmptyAttributesInformation), {
        numHiddenAttributes: numHiddenAttributes
    }), attributeTypes.map((attributeType)=>{
        const attributeLabel = attributeType.name;
        const isObjectLabel = attributeType.label === true;
        const isMultiSelect = (0, $9DpdN.isMultiSelectAttribute)(attributeType);
        const isColumn = (0, $9DpdN.isTextAreaAttribute)(attributeType) || !props.isMultiColumn;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jn7Xc.EditableAttribute), {
            key: attributeLabel,
            label: attributeLabel,
            icon: isObjectLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bB6uF))), {
                spacing: "spacious",
                label: ""
            }) : null,
            isColumn: isColumn,
            isMultiSelect: isMultiSelect,
            attributeTypeId: attributeType.id
        }, renderInlineEditableAttribute(attributeType));
    }));
};
const $e80c359bc6006b11$var$ContainerDl = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "dl",
        xcss: $e80c359bc6006b11$var$containerStyles,
        testId: "servicedesk-insight-editable-attribute-list.ui.attributes-list"
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e80c359bc6006b11$var$ContainerDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1wug",
            __cmplp.className
        ])
    });
});
const $e80c359bc6006b11$var$Container = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('assets-a11y-fix'), $e80c359bc6006b11$var$ContainerDl, $e80c359bc6006b11$var$ContainerDiv);
const $e80c359bc6006b11$var$containerStyles = (0, $8CUq3.xcss)({
    width: 'auto',
    marginLeft: '0',
    paddingLeft: '0'
});

});
parcelRegister("7reJE", function(module, exports) {

$parcel$export(module.exports, "BitbucketRepoEditableAttribute", () => $a2df6b7b1720e1d9$export$9fb672ffa7617263);

var $5uXOq = parcelRequire("5uXOq");

var $j8mgt = parcelRequire("j8mgt");

var $1Bhsf = parcelRequire("1Bhsf");

var $kseo9 = parcelRequire("kseo9");

var $9ng36 = parcelRequire("9ng36");

var $581BZ = parcelRequire("581BZ");

var $8AFAN = parcelRequire("8AFAN");

var $e08Fw = parcelRequire("e08Fw");

var $ghTXd = parcelRequire("ghTXd");
const $a2df6b7b1720e1d9$export$9fb672ffa7617263 = (props)=>{
    const { attributeType: attributeType } = props;
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const [value, setValue] = (0, $9ng36.useBBRepoValue)(attribute);
    const storedValue = (0, $ghTXd.toFieldValue)((0, $9ng36.getBBRepoValues)(attribute));
    const setBBRepoValue = (0, $5uXOq.useCallback)((repos)=>{
        setValue(repos.filter(({ name: name })=>name != null));
    }, [
        setValue
    ]);
    const resetValue = (0, $5uXOq.useCallback)(()=>setValue((0, $9ng36.getBBRepoValues)(attribute)), [
        attribute,
        setValue
    ]);
    const isMultiRepoPicker = attributeType.maximumCardinality !== 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.bitbucket-repo-attribute",
        value: (0, $ghTXd.toFieldValue)(value),
        onChange: setBBRepoValue,
        storedValue: storedValue,
        attributeType: props.attributeType,
        isEditable: props.isEditable,
        attributeValuesInfo: {
            type: 'bitbucket',
            attributeValues: value
        },
        scalingEnabled: true,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Bhsf.BitbucketReposReadView), {
                bitbucketRepos: value,
                showPlaceholderIfEmpty: true
            })),
        renderEditView: ({ hasValidationError: hasValidationError, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8AFAN.EditViewSpacers).BitbucketRepoPicker, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kseo9.BitbucketRepoPicker), {
                defaultMenuIsOpen: true,
                ...fieldProps,
                autoFocus: true,
                value: value,
                isMulti: isMultiRepoPicker,
                validationState: hasValidationError ? 'error' : 'default',
                classNamePrefix: "insight-object-attribute-bitbucket-repo-select"
            })),
        onResetValue: resetValue
    });
};

});
parcelRegister("j8mgt", function(module, exports) {

$parcel$export(module.exports, "ObjectDetailsSpacer", () => $410f96bc2353d4f7$export$b8f1b5c1e5f43c5c);
$parcel$export(module.exports, "ReadViewContainer", () => $410f96bc2353d4f7$export$ebb3489b83262b26);
$parcel$export(module.exports, "RoleList", () => $410f96bc2353d4f7$export$f28593264fbf36da);
$parcel$export(module.exports, "RoleContainer", () => $410f96bc2353d4f7$export$e5989493d486ab26);
$parcel$export(module.exports, "RoleDisplayName", () => $410f96bc2353d4f7$export$a57fa052c6fb1799);
$parcel$export(module.exports, "AvatarWrapper", () => $410f96bc2353d4f7$export$f7513421c53ce141);
$parcel$export(module.exports, "PlaceholderSpacer", () => $410f96bc2353d4f7$export$e5d47ed31c76a9c0);
/* styled.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");
const $410f96bc2353d4f7$export$b8f1b5c1e5f43c5c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f312x7 _n3tdu2gc _19bv12x7",
            __cmplp.className
        ])
    });
});
const $410f96bc2353d4f7$var$readViewContainerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    lineHeight: `${(0, $gwIPs.gridSize) * 2.5}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    minHeight: `${(0, $gwIPs.gridSize) * 2.25}px`,
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    flexFlow: 'wrap'
});
const $410f96bc2353d4f7$var$readViewContainerPlaceholderStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    wordBreak: 'break-word',
    overflowWrap: 'break-word'
});
const $410f96bc2353d4f7$var$readViewContainerNonPlaceholderStyles = (0, $8CUq3.xcss)({
    wordBreak: 'break-all'
});
const $410f96bc2353d4f7$export$ebb3489b83262b26 = ({ children: children, isPlaceholder: isPlaceholder })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        xcss: [
            $410f96bc2353d4f7$var$readViewContainerStyles,
            isPlaceholder ? $410f96bc2353d4f7$var$readViewContainerPlaceholderStyles : $410f96bc2353d4f7$var$readViewContainerNonPlaceholderStyles
        ]
    }, children);
const $410f96bc2353d4f7$export$f28593264fbf36da = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $410f96bc2353d4f7$export$e5989493d486ab26 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko7vkz _1e0c1txw _4cvr1h6o _bfhk1s4m _ca0qv77o _u5f3u2gc _n3tdv77o _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $410f96bc2353d4f7$export$a57fa052c6fb1799 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $410f96bc2353d4f7$export$f7513421c53ce141 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0r5cr _1aayyfq0",
            __cmplp.className
        ])
    });
});
const $410f96bc2353d4f7$export$e5d47ed31c76a9c0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1Bhsf", function(module, exports) {

$parcel$export(module.exports, "BitbucketRepoReadView", () => $4f8e0c9ad119dc5c$export$acf1d176a599bd06);
$parcel$export(module.exports, "BitbucketReposReadView", () => $4f8e0c9ad119dc5c$export$a88683ce920266bd);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $ujWmd = parcelRequire("ujWmd");


var $koVbs = parcelRequire("koVbs");

var $hDzhb = parcelRequire("hDzhb");

var $j8mgt = parcelRequire("j8mgt");

var $6JT4n = parcelRequire("6JT4n");
const $4f8e0c9ad119dc5c$export$acf1d176a599bd06 = ({ name: name, avatarUrl: avatarUrl, url: url })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f8e0c9ad119dc5c$var$BitbucketRepoContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "xsmall",
        src: avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f8e0c9ad119dc5c$var$NeutralLink, {
        href: url
    }, name));
const $4f8e0c9ad119dc5c$export$a88683ce920266bd = ({ bitbucketRepos: bitbucketRepos, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (bitbucketRepos.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.PlaceholderSpacer), null, showPlaceholderIfEmpty ? formatMessage((0, $6JT4n.messages).placeholder) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f8e0c9ad119dc5c$var$BitbucketRepoList, null, bitbucketRepos.map(({ uuid: uuid, name: name, url: url, avatarUrl: avatarUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f8e0c9ad119dc5c$export$acf1d176a599bd06, {
            key: uuid,
            uuid: uuid,
            name: name,
            url: url,
            avatarUrl: avatarUrl
        }))));
};
const $4f8e0c9ad119dc5c$var$NeutralLink = /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
(0, $47bDC.default)((0, $hDzhb.default)).withConfig({
    componentId: "dnjt16-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N800})`,
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N800})`
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f8e0c9ad119dc5c$var$BitbucketRepoList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $4f8e0c9ad119dc5c$var$BitbucketRepoContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _2rko1l7b _1e0c1txw _4cvr1h6o _bfhk1yrq _ca0qv77o _u5f3u2gc _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6JT4n", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9d5bb23ca8931aa6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9d5bb23ca8931aa6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "servicedesk-insight-attribute-views.bitbucket-repo.placeholder",
        "defaultMessage": "No Bitbucket repositories selected"
    }
});

});


parcelRegister("kseo9", function(module, exports) {

$parcel$export(module.exports, "BitbucketRepoPicker", () => $c1302f903156b8b6$export$37a7a413a5b35fe1);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $d7FF4 = parcelRequire("d7FF4");
var $bChGW = parcelRequire("bChGW");

var $pa9q9 = parcelRequire("pa9q9");

var $f3O7j = parcelRequire("f3O7j");

var $gP9lO = parcelRequire("gP9lO");

var $aBd7C = parcelRequire("aBd7C");

var $XKD1X = parcelRequire("XKD1X");
const $c1302f903156b8b6$export$37a7a413a5b35fe1 = (props)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [{ error: error }, { searchBitbucketRepos: searchBitbucketRepos }] = (0, $gP9lO.useBitbucketReposSearch)();
    (0, $5uXOq.useEffect)(()=>{
        if (error) showFlag({
            type: 'error',
            title: (0, $XKD1X.default).errorFlagTitle,
            description: (0, $XKD1X.default).errorFlagDescription
        });
    }, [
        error,
        showFlag
    ]);
    const loadOptions = (0, $5uXOq.useCallback)(async (query, cb)=>{
        searchBitbucketRepos(query).then((detailedBitbucketRepos)=>{
            const results = detailedBitbucketRepos?.values?.map(({ uuid: uuid, name: name, avatarUrl: avatarUrl })=>({
                    uuid: uuid,
                    name: name,
                    avatarUrl: avatarUrl
                })) ?? [];
            /**
				 * using promises in current version of async select is buggy
				 * therefore following react-select's approach
				 * {@link https://react-select.com/async}
				 */ cb(results);
        });
    }, [
        searchBitbucketRepos
    ]);
    const debouncedLoadOptions = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(loadOptions, 300), [
        loadOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        classNamePrefix: "cmdb-bitbucket-repo-picker",
        ...props,
        ...(0, $f3O7j.selectInAModalStyleFixProps),
        defaultOptions: true,
        controlShouldRenderValue: props.shouldInputRenderValue,
        isClearable: props.isClearable,
        isMulti: props.isMulti,
        loadOptions: debouncedLoadOptions,
        getOptionLabel: (bitbucketRepoOption)=>bitbucketRepoOption.name,
        getOptionValue: (bitbucketRepoOption)=>bitbucketRepoOption.uuid,
        value: props.value,
        validationState: props.validationState,
        onChange: (bitbucketRepoOptions)=>{
            // bitbucketRepo options can be null when clearing a value/s from the bitbucketRepo picker
            if (bitbucketRepoOptions == null) props.onChange([]);
            else {
                const selectedOptions = Array.isArray(bitbucketRepoOptions) ? bitbucketRepoOptions : [
                    bitbucketRepoOptions
                ];
                props.onChange(selectedOptions);
            }
        },
        components: {
            Option: (componentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, componentProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aBd7C.SingleBitbucketRepoOption), {
                    value: componentProps.data
                })),
            SingleValue: (componentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, componentProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aBd7C.SingleBitbucketRepoOption), {
                    value: componentProps.data
                })),
            MultiValue: (componentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MultiValue, componentProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aBd7C.MultiBitbucketRepoOption), {
                    value: componentProps.data
                }))
        }
    });
};
$c1302f903156b8b6$export$37a7a413a5b35fe1.defaultProps = {
    isMulti: true,
    validationState: 'default',
    autoFocus: false,
    shouldInputRenderValue: true,
    isClearable: true
};

});
parcelRegister("f3O7j", function(module, exports) {

$parcel$export(module.exports, "selectInAModalStyleFixProps", () => $4060e6e3fae2ba06$export$8ecda98d52dbbeed);
$parcel$export(module.exports, "textAreaAttributeProps", () => $4060e6e3fae2ba06$export$cd0081a7c532f4ba);

var $gwIPs = parcelRequire("gwIPs");
const $4060e6e3fae2ba06$export$8ecda98d52dbbeed = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    styles: {
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, $gwIPs.layers).modal + 1
            })
    },
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    menuPortalTarget: document.body
};
const $4060e6e3fae2ba06$export$cd0081a7c532f4ba = {
    minimumRows: 4,
    maxHeight: '400px'
};

});

parcelRegister("gP9lO", function(module, exports) {

$parcel$export(module.exports, "useBitbucketReposSearch", () => $19d0d27859f5423f$export$d53733b5739f5b9f);

var $ebyGx = parcelRequire("ebyGx");

var $2NMNM = parcelRequire("2NMNM");

var $ld2hZ = parcelRequire("ld2hZ");

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $aUKCo = parcelRequire("aUKCo");
const $19d0d27859f5423f$export$d53733b5739f5b9f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const restBaseUrl = (0, $aUKCo.useCmdbRestBaseUrl)();
    const searchBitbucketRepos = async (query)=>{
        try {
            const url = `${restBaseUrl}/bitbucket/repositories?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify({
                query: query
            })}`;
            const projects = await (0, $4VpwK.performCmdbGetRequest)(url);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'insightSearchBitbucketRepos succeeded');
            return projects;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'insightSearchBitbucketRepos',
                    teamName: 'falcons',
                    packageName: 'jiraServicedeskInsightBitbucketRepoPicker'
                }
            });
            throw error;
        }
    };
    const { data: data, loading: loading, error: error, fetch: fetch } = (0, $ld2hZ.useService)(searchBitbucketRepos);
    return [
        {
            data: data,
            loading: loading,
            error: error
        },
        {
            searchBitbucketRepos: fetch
        }
    ];
};

});
parcelRegister("aUKCo", function(module, exports) {

$parcel$export(module.exports, "useCmdbRestBaseUrl", () => $d294af0d5b936635$export$3e408e710560fdbd);

var $klJ8b = parcelRequire("klJ8b");

var $7DxXA = parcelRequire("7DxXA");
const $d294af0d5b936635$export$3e408e710560fdbd = ()=>{
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    return (0, $klJ8b.getCmdbRestBaseUrl)(String(workspaceId));
};

});


parcelRegister("aBd7C", function(module, exports) {

$parcel$export(module.exports, "SingleBitbucketRepoOption", () => $4a10018f44b2dfa6$export$a3270e8e0a1592f0);
$parcel$export(module.exports, "MultiBitbucketRepoOption", () => $4a10018f44b2dfa6$export$5b8d4fd2c4cd2560);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");
const $4a10018f44b2dfa6$export$a3270e8e0a1592f0 = ({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a10018f44b2dfa6$var$SingleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: value.avatarUrl,
        size: "small",
        appearance: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, value.name));
const $4a10018f44b2dfa6$export$5b8d4fd2c4cd2560 = ({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4a10018f44b2dfa6$var$MultiWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: value.avatarUrl,
        size: "xsmall",
        appearance: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, value.name));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a10018f44b2dfa6$var$SingleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4a10018f44b2dfa6$var$MultiWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("XKD1X", function(module, exports) {

$parcel$export(module.exports, "default", () => $245c5252d470ad51$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $245c5252d470ad51$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "servicedesk-insight-bitbucket-repo-picker.error-flag-title",
        "defaultMessage": "We couldn\u2019t load your Bitbucket repositories"
    },
    errorFlagDescription: {
        "id": "servicedesk-insight-bitbucket-repo-picker.error-flag-description",
        "defaultMessage": "Please check your network and try again"
    }
});

});


parcelRegister("9ng36", function(module, exports) {

$parcel$export(module.exports, "getBBRepoValuesFromCmdbObjectAttribute", () => $f4b708cddd441972$export$a75dcd2bf197afa6);
$parcel$export(module.exports, "getBBRepoValues", () => $f4b708cddd441972$export$65fc4a6392a158be);
$parcel$export(module.exports, "useBBRepoValue", () => $f4b708cddd441972$export$9e2c1e26b30782be);

var $5uXOq = parcelRequire("5uXOq");

var $e5pww = parcelRequire("e5pww");
const $f4b708cddd441972$export$a75dcd2bf197afa6 = (attribute)=>{
    if (attribute && attribute.type === (0, $e5pww.AttributeTypeMap).BitbucketRepo) return attribute.objectAttributeValues.map(({ bitbucketRepo: { uuid: uuid, name: name, avatarUrl: avatarUrl, url: url } })=>({
            uuid: uuid,
            name: name,
            avatarUrl: avatarUrl,
            url: url
        }));
    return [];
};
const $f4b708cddd441972$export$65fc4a6392a158be = (attribute)=>{
    if (attribute && attribute.type === 'bitbucketRepo') return attribute.bitbucketRepoTypeValues.map(({ bitbucketRepo: { uuid: uuid, name: name, avatarUrl: avatarUrl, url: url } })=>({
            uuid: uuid,
            name: name,
            avatarUrl: avatarUrl,
            url: url
        }));
    return [];
};
const $f4b708cddd441972$export$9e2c1e26b30782be = (attribute)=>{
    const repos = $f4b708cddd441972$export$65fc4a6392a158be(attribute);
    const [value, setValue] = (0, $5uXOq.useState)(repos);
    (0, $5uXOq.useEffect)(()=>{
        setValue(()=>$f4b708cddd441972$export$65fc4a6392a158be(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};

});
parcelRegister("e5pww", function(module, exports) {

$parcel$export(module.exports, "AttributeTypeMap", () => $25738ba6e9f2a2c0$export$e2adf49b6d954f74);
$parcel$export(module.exports, "DefaultAttributeSubtypeMap", () => $25738ba6e9f2a2c0$export$3cb06cb40b82bd9d);
const $25738ba6e9f2a2c0$export$e2adf49b6d954f74 = {
    Default: 0,
    Object: 1,
    User: 2,
    Group: 4,
    Project: 6,
    Status: 7,
    BitbucketRepo: 8,
    OpsgenieTeam: 9
};
const $25738ba6e9f2a2c0$export$3cb06cb40b82bd9d = {
    Text: '0',
    Integer: '1',
    Boolean: '2',
    Double: '3',
    Date: '4',
    Time: '5',
    DateTime: '6',
    URL: '7',
    Email: '8',
    Textarea: '9',
    Select: '10',
    IPAddress: '11'
};

});


parcelRegister("581BZ", function(module, exports) {

$parcel$export(module.exports, "useEditableAttribute", () => $ae5c98727fe44933$export$16b6486a5a3fa133);

var $5uXOq = parcelRequire("5uXOq");

var $5Ny9E = parcelRequire("5Ny9E");

var $66Vf6 = parcelRequire("66Vf6");
const $ae5c98727fe44933$export$16b6486a5a3fa133 = (attributeType)=>{
    const [attribute, { updateAttribute: updateAttribute }] = (0, $66Vf6.useAttribute)((0, $5Ny9E.toObjectTypeAttributeId)(attributeType.id));
    const [error, setError] = (0, $5uXOq.useState)();
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const update = (0, $5uXOq.useCallback)(({ updatedValues: updatedValues, onSuccess: onSuccessCb, onError: onErrorCb })=>{
        const { id: objectTypeAttributeId } = attributeType;
        updateAttribute({
            objectTypeAttributeId: objectTypeAttributeId,
            updatedValues: updatedValues,
            onLoad: ()=>{
                setLoading(true);
            },
            onSuccess: ()=>{
                onSuccessCb?.();
                setLoading(false);
            },
            onError: (err)=>{
                onErrorCb?.(err);
                setError(err);
                setLoading(false);
            }
        });
    }, [
        attributeType,
        updateAttribute
    ]);
    const clearError = (0, $5uXOq.useCallback)(()=>{
        setError(undefined);
    }, [
        setError
    ]);
    return [
        {
            attribute: attribute,
            loading: loading,
            error: error
        },
        {
            update: update,
            clearError: clearError
        }
    ];
};

});

parcelRegister("8AFAN", function(module, exports) {

$parcel$export(module.exports, "EditViewSpacers", () => $0b7736b485aa9314$export$1b6cb89ef3aee44a);
/* styled.tsx generated by @compiled/babel-plugin v0.35.0 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0b7736b485aa9314$var$BooleanSelectEditViewSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk19bv _2hwxidpf _otyrv77o _18u0idpf",
            __cmplp.className
        ])
    });
});
const $0b7736b485aa9314$var$DatePickerEditViewSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1b66 _2hwxidpf _otyr1b66 _18u0idpf",
            __cmplp.className
        ])
    });
});
const $0b7736b485aa9314$var$GroupPickerEditViewSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkutpp _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $0b7736b485aa9314$var$ProjectPickerEditViewSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkutpp _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $0b7736b485aa9314$var$ReferencedObjectPickerEditViewSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkutpp _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $0b7736b485aa9314$var$SelectEditViewSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkutpp _2hwxidpf _otyr1b66 _18u0idpf",
            __cmplp.className
        ])
    });
});
const $0b7736b485aa9314$var$BitbucketRepoPickerEditViewSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkutpp _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $0b7736b485aa9314$var$StatusPickerEditViewSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkutpp _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $0b7736b485aa9314$export$1b6cb89ef3aee44a = {
    BooleanSelect: $0b7736b485aa9314$var$BooleanSelectEditViewSpacer,
    DatePicker: $0b7736b485aa9314$var$DatePickerEditViewSpacer,
    GroupPicker: $0b7736b485aa9314$var$GroupPickerEditViewSpacer,
    ProjectPicker: $0b7736b485aa9314$var$ProjectPickerEditViewSpacer,
    ReferencedObjectPicker: $0b7736b485aa9314$var$ReferencedObjectPickerEditViewSpacer,
    Select: $0b7736b485aa9314$var$SelectEditViewSpacer,
    BitbucketRepoPicker: $0b7736b485aa9314$var$BitbucketRepoPickerEditViewSpacer,
    StatusPicker: $0b7736b485aa9314$var$StatusPickerEditViewSpacer
};

});

parcelRegister("e08Fw", function(module, exports) {

$parcel$export(module.exports, "InlineValidationErrorID", () => $9f3b28f9a4ae6757$export$2c6b352a414fa801);
$parcel$export(module.exports, "InlineEditableAttribute", () => $9f3b28f9a4ae6757$export$86a729a44788a74c);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3NMrl = parcelRequire("3NMrl");

var $gtreQ = parcelRequire("gtreQ");

var $ctg8C = parcelRequire("ctg8C");

var $bopR4 = parcelRequire("bopR4");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $jJZqs = parcelRequire("jJZqs");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $j8mgt = parcelRequire("j8mgt");

var $1qjEp = parcelRequire("1qjEp");

var $kEqrP = parcelRequire("kEqrP");


var $581BZ = parcelRequire("581BZ");

var $ewpCb = parcelRequire("ewpCb");

var $284aD = parcelRequire("284aD");

var $f05qh = parcelRequire("f05qh");
const $9f3b28f9a4ae6757$export$2c6b352a414fa801 = 'servicedesk-insight-inline-editable-attributes.ui.editable-attribute.error';
const $9f3b28f9a4ae6757$export$baca24d4560c81fa = ({ errorMessage: errorMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f3b28f9a4ae6757$var$Container, {
        id: $9f3b28f9a4ae6757$export$2c6b352a414fa801
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9f3b28f9a4ae6757$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))), {
        label: "",
        primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y400})`
    })), errorMessage);
const $9f3b28f9a4ae6757$var$hasValueChanged = (previousValue, currentValue)=>JSON.stringify(previousValue) !== JSON.stringify(currentValue);
const $9f3b28f9a4ae6757$export$86a729a44788a74c = (props)=>{
    const { attributeType: attributeType, isEditable: isEditable, value: value, onChange: onChange, storedValue: storedValue, onValidate: onValidate, renderReadView: renderReadView, renderEditView: renderEditView, onResetValue: onResetValue, hideActionButtons: hideActionButtons, readViewFitContainerWidth: readViewFitContainerWidth, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur, isEditingByDefault: isEditingByDefault, testId: testId, attributeValuesInfo: attributeValuesInfo, scalingEnabled: scalingEnabled = false } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isScaledAttribute = storedValue && storedValue.length > (0, $ff24525054a08710$export$13bee158954a3882) && scalingEnabled;
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [{ loading: loading, error: error }, { update: update, clearError: clearError }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const { getFirstValidationErrorMessage: getFirstValidationErrorMessage } = (0, $284aD.useCmdbErrorTranslation)();
    const [isEditing, setEditing] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isEditableAttributeModalOpen, setIsEditableAttributeModalOpen] = (0, $5uXOq.useState)(false);
    const onConfirmChange = (0, $5uXOq.useCallback)((values)=>{
        // We want to capture this regardless it's been made any changes to the value
        // since what we measure is the transition from edit to read mode
        (0, $kEqrP.objectViewInlineEditSwitchFromEditToReadModeExperience).start();
        setEditing(false);
        if ($9f3b28f9a4ae6757$var$hasValueChanged(storedValue, values) === false) return;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'inlineEdit confirmed', 'updateInsightObject', {
            attributeType: attributeType.type,
            isLabel: attributeType.label
        });
        const updatedValues = Array.isArray(values) ? values : [
            values
        ];
        update({
            updatedValues: updatedValues.map((v)=>({
                    value: v != null ? v : null
                })),
            onSuccess: ()=>setIsEditableAttributeModalOpen(false),
            onError: (err)=>{
                if (err instanceof (0, $jJZqs.ValidationError)) {
                    // show validation error for modal in an error flag
                    if (isEditableAttributeModalOpen) showFlag({
                        type: 'error',
                        title: (0, $f05qh.default).errorFlagTitle,
                        description: err.errors[0].error
                    });
                    else // after optimistically updating we re-open the inline edit showing inline validation error message whenever we receive a validation error from the requested update
                    setEditing(true);
                } else {
                    showFlag({
                        type: 'error',
                        title: (0, $f05qh.default).errorFlagTitle,
                        description: (0, $f05qh.default).errorFlagDescription
                    });
                    onResetValue();
                }
            }
        });
    }, [
        storedValue,
        createAnalyticsEvent,
        attributeType.type,
        attributeType.label,
        update,
        isEditableAttributeModalOpen,
        showFlag,
        onResetValue
    ]);
    const onValueChange = (0, $5uXOq.useCallback)((val)=>{
        if (error !== undefined) clearError();
        onChange(val);
    }, [
        clearError,
        error,
        onChange
    ]);
    const getIsDirtyState = ()=>{
        let storedValues = [];
        let currentValue = [];
        if (storedValue) storedValues = Array.isArray(storedValue) ? storedValue : [
            storedValue
        ];
        if (value) currentValue = Array.isArray(value) ? value : [
            value
        ];
        return $9f3b28f9a4ae6757$var$hasValueChanged(storedValues.sort(), currentValue.sort());
    };
    if (isScaledAttribute && attributeValuesInfo && !isEditing) {
        const editableProps = isEditable ? {
            isEditable: isEditable,
            isSaving: loading,
            renderPicker: ()=>renderEditView({
                    onChange: onValueChange,
                    shouldInputRenderValue: false,
                    isClearable: false
                }),
            isDirty: getIsDirtyState(),
            onValueChange: onValueChange,
            storedValue: storedValue,
            onSave: ()=>{
                onConfirmChange(value || []);
            }
        } : {
            isEditable: isEditable
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f3b28f9a4ae6757$var$ReadOnlyViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ewpCb.MultiValueLozenge), {
            attributeValueType: attributeValuesInfo.type,
            count: storedValue.length,
            onClick: ()=>{
                setIsEditableAttributeModalOpen(true);
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qjEp.AsyncEditableAttributeModal), {
            isOpen: isEditableAttributeModalOpen,
            onClose: ()=>{
                setIsEditableAttributeModalOpen(false);
                onResetValue();
            },
            attributeName: attributeType.name,
            attributeValuesInfo: attributeValuesInfo,
            ...editableProps
        }));
    }
    if (isEditable === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f3b28f9a4ae6757$var$ReadOnlyViewContainer, {
        "data-testid": `${testId}.read-view`
    }, renderReadView());
    const experienceSuccessMetaData = {
        attributeTypeConfig: {
            ...(0, (/*@__PURE__*/$parcel$interopDefault($3NMrl)))(attributeType, [
                'type',
                'defaultType',
                'additionalValue',
                'indexed',
                'includeChildObjectTypes',
                'typeValueMulti',
                'minimumCardinality',
                'maximumCardinality'
            ])
        }
    }; // FIXME: Falcons - fix this by extracting memoed component
    // eslint-disable-next-line react/no-unstable-nested-components
    const ReadViewExperienceSuccess = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
        (0, $5uXOq.useLayoutEffect)(()=>{
            (0, $kEqrP.objectViewInlineEditSwitchFromEditToReadModeExperience).success({
                // @ts-expect-error - TS2322: Type 'string[]' is not assignable to type 'CustomData'. Index signature for type 'string' is missing in type 'string[]'.
                metadata: experienceSuccessMetaData
            });
        }, []);
        return null;
    });
    const EditViewExperienceSuccess = ()=>{
        (0, $5uXOq.useLayoutEffect)(()=>{
            (0, $kEqrP.objectViewInlineEditSwitchFromReadToEditModeExperience).success({
                // @ts-expect-error - TS2322: Type 'string[]' is not assignable to type 'CustomData'. Index signature for type 'string' is missing in type 'string[]'.
                metadata: experienceSuccessMetaData
            });
        }, []);
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        hideActionButtons: hideActionButtons,
        keepEditViewOpenOnBlur: // when an attribute has a validation error we prevent them from re-submitting on blur
        // this prevents a rare edge case of quickly submitting another attribute which could also get a validation error
        // with the user getting in a cycle of submitting onBlur and getting errors ping ponging between attributes
        keepEditViewOpenOnBlur || error !== undefined && error instanceof (0, $jJZqs.ValidationError),
        readViewFitContainerWidth: readViewFitContainerWidth,
        defaultValue: value,
        // in those cases we provide an option to keep the editable attribute component in edit mode to provide an escape hatch for attributes that need extra flexibility
        isEditing: isEditing || isEditingByDefault,
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": `${testId}.read-view`
            }, renderReadView()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ReadViewExperienceSuccess, null)),
        editButtonLabel: formatMessage((0, $f05qh.default).editButtonLabel, {
            attributeTypeName: attributeType.name
        }),
        editView: (fieldProps)=>{
            const validationError = // eslint-disable-next-line no-nested-ternary
            fieldProps.errorMessage != null ? fieldProps.errorMessage : error && error instanceof (0, $jJZqs.ValidationError) ? getFirstValidationErrorMessage(error) : undefined;
            const hasError = !!validationError;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": `${testId}.edit-view`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), {
                placement: "right",
                isOpen: isEditing && hasError,
                content: validationError !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f3b28f9a4ae6757$export$baca24d4560c81fa, {
                    errorMessage: validationError
                })
            }, renderEditView({
                ...fieldProps,
                onConfirmChange: onConfirmChange,
                onChange: onValueChange,
                hasValidationError: hasError
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EditViewExperienceSuccess, null));
        },
        onConfirm: onConfirmChange,
        validate: onValidate,
        onCancel: ()=>{
            (0, $kEqrP.objectViewInlineEditSwitchFromEditToReadModeExperience).start();
            if (error !== undefined) clearError();
            setEditing(false);
            onResetValue();
        },
        onEdit: ()=>{
            (0, $kEqrP.objectViewInlineEditSwitchFromReadToEditModeExperience).start();
            setEditing(true);
        }
    });
};
$9f3b28f9a4ae6757$export$86a729a44788a74c.defaultProps = {
    // defaults to null as some attributes call onConfirm change directly exposed through props passed to renderEditView
    value: null,
    storedValue: null,
    hideActionButtons: true,
    readViewFitContainerWidth: true,
    isEditingByDefault: false,
    keepEditViewOpenOnBlur: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    testId: 'servicedesk-insight-inline-editable-attributes.common.ui.editable-attribute'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f3b28f9a4ae6757$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $9f3b28f9a4ae6757$var$iconContainerStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f3b28f9a4ae6757$var$ReadOnlyViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bopR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb3572edb783a8f$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $7O4UO = parcelRequire("7O4UO");

var $efXp3 = parcelRequire("efXp3");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");

var $jldZL = parcelRequire("jldZL");

var $1PDuf = parcelRequire("1PDuf");

var $pZGLJ = parcelRequire("pZGLJ");

var $6LLMl = parcelRequire("6LLMl");
const $9fb3572edb783a8f$var$fieldStyles = null;
const $9fb3572edb783a8f$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $9fb3572edb783a8f$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const timerRef = (0, $5uXOq.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $pZGLJ.default)(isEditing, isEditingState);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$9fb3572edb783a8f$var$analyticsAttributes
    });
    const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6LLMl.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit)
    }, ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", {
            /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
            onKeyDown: (e)=>{
                onKeyDown(e);
                if (e.key === 'Esc' || e.key === 'Escape') {
                    if ((0, $VSDnB.fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                    onCancel();
                }
            },
            onSubmit: onSubmit,
            ref: formRef
        }, shouldBeEditing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view" // used for reset to default value
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                onBlur: (e)=>{
                    if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                },
                onFocus: onEditViewWrapperFocus,
                className: (0, $bwpsq.default)([
                    "_p12f1osq _kqswh2mm"
                ])
            }, editView({
                ...fieldProps,
                errorMessage: error
            }, editViewRef), !hideActionButtons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PDuf.default), {
                testId: testId,
                cancelButtonLabel: cancelButtonLabel,
                confirmButtonLabel: confirmButtonLabel,
                onMouseDown: ()=>{
                    /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                },
                onCancelClick: (e)=>{
                    reset();
                    onCancelClick(e);
                }
            }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Lty3.default), {
                hidden: true,
                type: "submit"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, "Submit")))) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: "",
            isRequired: isRequired,
            key: "read-view" // used for reset to default value
        }, renderReadView)));
};
const $9fb3572edb783a8f$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9fb3572edb783a8f$var$InnerInlineEdit, props);
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9fb3572edb783a8f$export$2e2bcd8739ae039 = $9fb3572edb783a8f$var$InlineEdit;

});
parcelRegister("3Lty3", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eb08f4038c94d3$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $6wxJn = parcelRequire("6wxJn");

var $a1dy0 = parcelRequire("a1dy0");
const $70eb08f4038c94d3$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $70eb08f4038c94d3$var$Pressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $eGmKJ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ $5uXOq.createElement((0, $a1dy0.default // @ts-expect-error we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- TODO: Properly type this and allow pass-through if we can determine the type
        ,
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $DEWI6.cx)($70eb08f4038c94d3$var$styles.root, isDisabled && $70eb08f4038c94d3$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }, children);
});
var $70eb08f4038c94d3$export$2e2bcd8739ae039 = $70eb08f4038c94d3$var$Pressable;

});

parcelRegister("1PDuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d92d54fb10d87e$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.35.0 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $kbxJz = parcelRequire("kbxJz");

var $lLLkM = parcelRequire("lLLkM");
const $55d92d54fb10d87e$var$buttonsContainerStyles = null;
const $55d92d54fb10d87e$var$buttonWrapperBaseStyles = null;
const $55d92d54fb10d87e$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        tabIndex: -1,
        className: (0, $bwpsq.default)([
            "_2rko1sit _11c81oud _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $42CjB.default), {
        type: "submit",
        icon: (iconProps)=>/*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kbxJz))), {
                ...iconProps,
                size: "small"
            }),
        onMouseDown: onMouseDown,
        label: confirmButtonLabel,
        testId: testId && `${testId}--confirm`
    })), /*#__PURE__*/ $5uXOq.createElement("div", {
        tabIndex: -1,
        className: (0, $bwpsq.default)([
            "_2rko1sit _11c81oud _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $42CjB.default), {
        icon: (iconProps)=>/*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))), {
                ...iconProps,
                size: "small"
            }),
        label: cancelButtonLabel,
        onClick: onCancelClick,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}--cancel`
    })));
};
var $55d92d54fb10d87e$export$2e2bcd8739ae039 = $55d92d54fb10d87e$var$Buttons;

});
parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6349e25a79f10f7ca6cae195737423f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});



parcelRegister("pZGLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5aa752dd00081f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $d5aa752dd00081f6$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $d5aa752dd00081f6$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const editViewRef = (0, $5uXOq.useRef)();
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $d5aa752dd00081f6$var$usePrevious(shouldBeEditing);
    (0, $5uXOq.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $d5aa752dd00081f6$export$2e2bcd8739ae039 = $d5aa752dd00081f6$var$useButtonFocusHook;

});

parcelRegister("6LLMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba9adf9a6463766$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3Lty3 = parcelRequire("3Lty3");
const $1ba9adf9a6463766$var$readViewContainerStyles = null;
const $1ba9adf9a6463766$var$editButtonStyles = {
    root: "_18s8ze3t _1yt4ze3t _12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $1ba9adf9a6463766$var$readViewWrapperStyles = null;
const $1ba9adf9a6463766$var$readViewFitContainerWidthStyles = null;
const $1ba9adf9a6463766$var$DRAG_THRESHOLD = 5;
const $1ba9adf9a6463766$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_vwz4kb7n"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Lty3.default), {
        xcss: $1ba9adf9a6463766$var$editButtonStyles.root,
        onClick: onEditRequested,
        ref: editButtonRef,
        testId: testId && `${testId}--edit-button`,
        "aria-label": editButtonLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
        onClick: onReadViewClick,
        onMouseDown: (e)=>{
            startX.current = e.clientX;
            startY.current = e.clientY;
        },
        "data-read-view-fit-container-width": readViewFitContainerWidth,
        className: (0, $bwpsq.default)([
            "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
            readViewFitContainerWidth && "_1bsb1osq"
        ])
    }, readView()));
};
var $1ba9adf9a6463766$export$2e2bcd8739ae039 = $1ba9adf9a6463766$var$ReadView;

});


parcelRegister("1qjEp", function(module, exports) {

$parcel$export(module.exports, "AsyncEditableAttributeModal", () => $acd360207fe4df0f$export$25cdbd874970f250);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $acd360207fe4df0f$var$LazyEditableAttributeModal = (0, $kxZPA.lazy)(()=>(parcelRequire("awyIZ")), {
    moduleId: "./src/packages/servicedesk/insight-object/object-attributes/editable-attribute-modal/src/ui/main.tsx"
});
const $acd360207fe4df0f$export$25cdbd874970f250 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "editable-attribute-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($acd360207fe4df0f$var$LazyEditableAttributeModal, props));

});
parcelRegister("awyIZ", function(module, exports) {

let $7a97d41df7579673$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7a97d41df7579673$var$load("h2MrD"),
    $7a97d41df7579673$var$load("bYT2S"),
    $7a97d41df7579673$var$load("8x9eg")
]).then(()=>parcelRequire('HINJR'));

});


parcelRegister("kEqrP", function(module, exports) {

$parcel$export(module.exports, "graphModalExperience", () => $92ce1ce82a42bb8a$export$1b179afadba799dc);
$parcel$export(module.exports, "rapidSearchExperience", () => $92ce1ce82a42bb8a$export$1a90deecc86e78f8);
$parcel$export(module.exports, "autocompleteInsightFieldExperience", () => $92ce1ce82a42bb8a$export$94337fa170a193d2);
$parcel$export(module.exports, "fetchAffectedServicesExperience", () => $92ce1ce82a42bb8a$export$ce8d2a860f4e0316);
$parcel$export(module.exports, "objectDetailsViewExperience", () => $92ce1ce82a42bb8a$export$8e0a16d0fc0feba3);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromReadToEditModeExperience", () => $92ce1ce82a42bb8a$export$5ae0e1bbe443c52b);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromEditToReadModeExperience", () => $92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4);
$parcel$export(module.exports, "createObjectTypeExperience", () => $92ce1ce82a42bb8a$export$15a29f6e079c9b3d);
$parcel$export(module.exports, "createObjectExperience", () => $92ce1ce82a42bb8a$export$aaf507c87c29ab22);
$parcel$export(module.exports, "loadSchemaObjectListExperience", () => $92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f);
$parcel$export(module.exports, "loadAttributesConfigurationExperience", () => $92ce1ce82a42bb8a$export$8f63f06b0486e498);
$parcel$export(module.exports, "updateObjectFilterExperience", () => $92ce1ce82a42bb8a$export$967859e6be8e6f4b);
$parcel$export(module.exports, "getUpdateGlobalConfigInlineEditExperience", () => $92ce1ce82a42bb8a$export$e4deb66475dfa46b);
$parcel$export(module.exports, "loadObjectDetailExperience", () => $92ce1ce82a42bb8a$export$3f1da23c065671d2);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $92ce1ce82a42bb8a$export$1b179afadba799dc = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.display-graph-modal', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$1a90deecc86e78f8 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.display-rapid-search-results', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$94337fa170a193d2 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.autocomplete-search-insight-field', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience,
    featureFlags: [
        'jsm-insight-field-performance-improvements_fplgq'
    ]
});
const $92ce1ce82a42bb8a$export$ce8d2a860f4e0316 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.fetch-affected-services', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$8e0a16d0fc0feba3 = new (0, $duUGa.UFOExperience)('jsm-cmdb-object-details-view', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$5ae0e1bbe443c52b = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-read-to-edit-mode', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-edit-to-read-mode', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$15a29f6e079c9b3d = new (0, $duUGa.UFOExperience)('jsm-cmdb-create-object-type', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'created-on-server',
            endMark: 'object-type-created-on-server'
        }
    ]
});
const $92ce1ce82a42bb8a$export$aaf507c87c29ab22 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.create-object', {
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
    type: (0, $atdLB.ExperienceTypes).Experience
});
const $92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f = new (0, $duUGa.UFOExperience)('jsm-cmdb-load-object-list', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$8f63f06b0486e498 = new (0, $duUGa.UFOExperience)('jsm-cmdb-load-attributes-tab', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $92ce1ce82a42bb8a$export$967859e6be8e6f4b = new (0, $duUGa.UFOExperience)('jsm-cmdb-object-filter', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'response-received',
            endMark: 'server-response-received'
        },
        {
            key: 'object-table-rendered',
            endMark: 'object-table-rendered'
        },
        {
            key: 'object-list-rendered',
            endMark: 'object-list-rendered'
        },
        {
            key: 'no-filter-results-rendered',
            endMark: 'no-filter-results-rendered'
        }
    ]
});
const $92ce1ce82a42bb8a$export$e4deb66475dfa46b = ()=>new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.global-config-inline-edit.update', {
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
        type: (0, $atdLB.ExperienceTypes).Experience
    });
const $92ce1ce82a42bb8a$export$3f1da23c065671d2 = new (0, $duUGa.UFOExperience)('service-management.insight-cmdb.embedded-object-details-view', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});

});

const $ff24525054a08710$export$13bee158954a3882 = 20;

parcelRegister("ewpCb", function(module, exports) {

$parcel$export(module.exports, "MultiValueLozenge", () => $cb123781342a7b01$export$1c8065d4dd09d460);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $16T6Y = parcelRequire("16T6Y");

var $6Ingq = parcelRequire("6Ingq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $jKD49 = parcelRequire("jKD49");
const $cb123781342a7b01$export$1c8065d4dd09d460 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ count: count, attributeValueType: attributeValueType, ...restProps }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const labelMessage = {
        object: {
            buttonLabel: formatMessage((0, $jKD49.default).objectsLabel),
            tooltipLabel: formatMessage((0, $jKD49.default).showAllObjects)
        },
        user: {
            buttonLabel: formatMessage((0, $jKD49.default).usersLabel),
            tooltipLabel: formatMessage((0, $jKD49.default).showAllUsers)
        },
        group: {
            buttonLabel: formatMessage((0, $jKD49.default).groupsLabel),
            tooltipLabel: formatMessage((0, $jKD49.default).showAllGroups)
        },
        project: {
            buttonLabel: formatMessage((0, $jKD49.default).projectsLabel),
            tooltipLabel: formatMessage((0, $jKD49.default).showAllProjects)
        },
        opsgenieTeam: {
            buttonLabel: formatMessage((0, $jKD49.default).opsgenieTeamsLabel),
            tooltipLabel: formatMessage((0, $jKD49.default).showAllOpsgenieTeams)
        },
        bitbucket: {
            buttonLabel: formatMessage((0, $jKD49.default).bitbucketRepositoriesLabel),
            tooltipLabel: formatMessage((0, $jKD49.default).showAllBbRepos)
        },
        select: {
            buttonLabel: formatMessage((0, $jKD49.default).optionsLabel),
            tooltipLabel: formatMessage((0, $jKD49.default).showAllOptions)
        }
    };
    const label = labelMessage[attributeValueType].buttonLabel;
    const tooltipContent = labelMessage[attributeValueType].tooltipLabel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb123781342a7b01$var$LozengeButton, {
        innerRef: ref,
        ...restProps,
        testId: "servicedesk-insight-shared-ui.ui.multi-value-lozenge.lozenge-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb123781342a7b01$var$LozengeLabel, null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb123781342a7b01$var$Count, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        max: false
    }, count)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb123781342a7b01$var$ExpandIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))), {
        label: ""
    }))));
});
const $cb123781342a7b01$var$lozengeStyles = null; // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb123781342a7b01$var$LozengeButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _19itglyw _16qs1bpa _1e0c116y _4cvr1h6o _1bsb1wug _vchhusvi _4t3i1tcg _19pkidpf _2hwxidpf _otyr1b66 _18u0idpf _ca0qidpf _u5f31b66 _n3tdv77o _19bv1b66 _80omtlke _p12f11dc _bfhkhp5a _syaz1fxt _1a3b18uv _9oik18uv _4fprglyw _1bnxglyw _5goinqa1 _jf4cnqa1 _jomrdpjp _irr3dpjp _f8pj1fxt _30l31fxt _1di6q29e",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb123781342a7b01$var$Count = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb123781342a7b01$var$ExpandIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pfkmyb0 _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb123781342a7b01$var$LozengeLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jKD49", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c13bcf2d6212563$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c13bcf2d6212563$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showAllObjects: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-objects",
        "defaultMessage": "Show all objects"
    },
    showAllGroups: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-groups",
        "defaultMessage": "Show all groups"
    },
    showAllUsers: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-users",
        "defaultMessage": "Show all users"
    },
    showAllOptions: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-options",
        "defaultMessage": "Show all options"
    },
    showAllBbRepos: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-bb-repos",
        "defaultMessage": "Show all Bitbucket repositories"
    },
    showAllItems: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-items",
        "defaultMessage": "Show all items"
    },
    showAllOpsgenieTeams: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-opsgenie-teams",
        "defaultMessage": "Show all Opsgenie teams"
    },
    showAllProjects: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.show-all-projects",
        "defaultMessage": "Show all projects"
    },
    bitbucketRepositoriesLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.bitbucket-repositories-label",
        "defaultMessage": "Bitbucket repositories"
    },
    groupsLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.groups-label",
        "defaultMessage": "Groups"
    },
    opsgenieTeamsLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.opsgenie-teams-label",
        "defaultMessage": "Opsgenie teams"
    },
    objectsLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.objects-label",
        "defaultMessage": "Objects"
    },
    optionsLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.options-label",
        "defaultMessage": "Options"
    },
    usersLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.users-label",
        "defaultMessage": "Users"
    },
    defaultLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.default-label",
        "defaultMessage": "Items"
    },
    projectsLabel: {
        "id": "servicedesk-insight-shared-ui.multi-value-lozenge.projects-label",
        "defaultMessage": "Projects"
    }
});

});


parcelRegister("284aD", function(module, exports) {

$parcel$export(module.exports, "useCmdbErrorTranslation", () => $e5dd6054dae4bef2$export$9f894fa32adff3f4);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $johYW = parcelRequire("johYW");

var $gRt7E = parcelRequire("gRt7E");

var $iMQgS = parcelRequire("iMQgS");

var $4atFd = parcelRequire("4atFd");

var $a0IY2 = parcelRequire("a0IY2");
const $e5dd6054dae4bef2$var$rlabsInsightMessageLookup = {
    'rlabs.insight.i18n.constraint.violation.ReferenceTypeBean.Size.name': (0, $a0IY2.messages).constraintViolationReferenceTypeBeanSizeName,
    'rlabs.insight.i18n.constraint.violation.StatusTypeBean.NotNull.name': (0, $a0IY2.messages).constraintViolationStatusTypeBeanNotNullName,
    'rlabs.insight.i18n.constraint.violation.StatusTypeBean.Size.name': (0, $a0IY2.messages).constraintViolationStatusTypeBeanSizeName,
    'rlabs.insight.i18n.constraint.violation.StatusTypeBean.Size.description': (0, $a0IY2.messages).constraintViolationStatusTypeBeanSizeDescription,
    'rlabs.insight.i18n.constraint.violation.StatusTypeBean.Used': (0, $a0IY2.messages).constraintViolationStatusTypeBeanUsed,
    'rlabs.insight.i18n.constraint.violation.ObjectSchemaBean.Size.name': (0, $a0IY2.messages).constraintViolationObjectSchemaBeanSizeName,
    'rlabs.insight.i18n.constraint.violation.ObjectTypeBean.Size.name': (0, $a0IY2.messages).constraintViolationObjectTypeBeanSizeName,
    'rlabs.insight.i18n.constraint.violation.ObjectTypeBean.Size.description': (0, $a0IY2.messages).constraintViolationObjectTypeBeanSizeDescription,
    'rlabs.insight.i18n.constraint.violation.ObjectSchemaBean.Size.description': (0, $a0IY2.messages).constraintViolationObjectSchemaBeanSizeDescription,
    'rlabs.insight.i18n.constraint.violation.VariablesEntry.Size.name': (0, $a0IY2.messages).constraintViolationVariablesEntrySizeName,
    'rlabs.insight.i18n.constraint.violation.VariablesEntry.Pattern.objectSchemaKey': (0, $a0IY2.messages).constraintViolationVariablesEntryPatternObjectSchemaKey,
    'rlabs.insight.i18n.constraint.violation.VariablesEntry.Size.description': (0, $a0IY2.messages).constraintViolationVariablesEntrySizeDescription,
    'rlabs.insight.i18n.import.validation.name.duplicate': (0, $a0IY2.messages).errorDuplicateName
};
const $e5dd6054dae4bef2$var$i18nMessageLookup = {
    'i18n.constraint.violation.ReferenceTypeBean.Size.name': (0, $a0IY2.messages).constraintViolationReferenceTypeBeanSizeName,
    'i18n.constraint.violation.StatusTypeBean.NotNull.name': (0, $a0IY2.messages).constraintViolationStatusTypeBeanNotNullName,
    'i18n.constraint.violation.StatusTypeBean.Size.name': (0, $a0IY2.messages).constraintViolationStatusTypeBeanSizeName,
    'i18n.constraint.violation.StatusTypeBean.Size.description': (0, $a0IY2.messages).constraintViolationStatusTypeBeanSizeDescription,
    'i18n.constraint.violation.StatusTypeBean.Used': (0, $a0IY2.messages).constraintViolationStatusTypeBeanUsed,
    'i18n.constraint.violation.ObjectSchemaBean.Size.name': (0, $a0IY2.messages).constraintViolationObjectSchemaBeanSizeName,
    'i18n.constraint.violation.ObjectTypeBean.Size.name': (0, $a0IY2.messages).constraintViolationObjectTypeBeanSizeName,
    'i18n.constraint.violation.ObjectTypeBean.Size.description': (0, $a0IY2.messages).constraintViolationObjectTypeBeanSizeDescription,
    'i18n.constraint.violation.ObjectSchemaBean.Size.description': (0, $a0IY2.messages).constraintViolationObjectSchemaBeanSizeDescription,
    'i18n.constraint.violation.VariablesEntry.Size.name': (0, $a0IY2.messages).constraintViolationVariablesEntrySizeName,
    'i18n.constraint.violation.VariablesEntry.Pattern.objectSchemaKey': (0, $a0IY2.messages).constraintViolationVariablesEntryPatternObjectSchemaKey,
    'i18n.constraint.violation.VariablesEntry.Size.description': (0, $a0IY2.messages).constraintViolationVariablesEntrySizeDescription,
    'i18n.import.validation.name.duplicate': (0, $a0IY2.messages).errorDuplicateName
};
const $e5dd6054dae4bef2$var$messageLookup = {
    ...$e5dd6054dae4bef2$var$rlabsInsightMessageLookup,
    ...$e5dd6054dae4bef2$var$i18nMessageLookup
};
const $e5dd6054dae4bef2$var$useTranslateError = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $5uXOq.useCallback)((maybeAnI18nKey)=>{
        const messageDescriptor = $e5dd6054dae4bef2$var$messageLookup[maybeAnI18nKey];
        if (messageDescriptor) return formatMessage(messageDescriptor);
        return maybeAnI18nKey;
    }, [
        formatMessage
    ]);
};
const $e5dd6054dae4bef2$export$9f894fa32adff3f4 = ()=>{
    const translateError = $e5dd6054dae4bef2$var$useTranslateError();
    return (0, $5uXOq.useMemo)(()=>({
            transformToInlineErrors: (validationError)=>{
                const inlineErrors = (0, $4atFd.transformToInlineErrors)(validationError);
                return Object.fromEntries(Object.entries(inlineErrors).map(([field, errorMessageMaybeAnI18nKey])=>[
                        field,
                        (0, $iMQgS.formatHelpError)(translateError(errorMessageMaybeAnI18nKey))
                    ]));
            },
            getFirstValidationErrorMessage: (validationError)=>{
                const firstError = (0, $gRt7E.getFirstValidationErrorMessage)(validationError);
                return firstError ? (0, $iMQgS.formatHelpError)(translateError(firstError)) : undefined;
            },
            translateErrorString: (errorString)=>(0, $iMQgS.formatHelpError)(translateError(errorString)),
            transformToGlobalErrors: (validationError)=>validationError.errors // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                .filter((e)=>(0, $johYW.globalErrorContexts).includes(e.field)).map(({ field: field, error: errorMessage })=>({
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        errorContext: field,
                        errorMessage: errorMessage
                    }))
        }), [
        translateError
    ]);
};

});
parcelRegister("johYW", function(module, exports) {

$parcel$export(module.exports, "ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS", () => $0761f987dd69a755$export$3d2246e48d9cfed3);
$parcel$export(module.exports, "DATE_VALUE_FORMAT", () => $0761f987dd69a755$export$d1fb6689cfa66d9b);
$parcel$export(module.exports, "TIME_VALUE_FORMAT", () => $0761f987dd69a755$export$5f2ab89513b5926a);
$parcel$export(module.exports, "ZONE_VALUE_FORMAT", () => $0761f987dd69a755$export$5c2d6de3ca9adcbe);
$parcel$export(module.exports, "GENERAL_DATE_TIME_FORMAT", () => $0761f987dd69a755$export$defafc11b2455f78);
$parcel$export(module.exports, "SCREEN_READER_DATE_TIME_FORMAT", () => $0761f987dd69a755$export$f61f3fa9ed38719a);
$parcel$export(module.exports, "globalErrorContexts", () => $0761f987dd69a755$export$b896d7bac8b72b0);
$parcel$export(module.exports, "MAX_OBJECT_COUNT_CUTOFF", () => $0761f987dd69a755$export$89b103afe26b1ad0);
/**
 * When there is a `textarea` type attribute on an object, the user can enter rich text that
 * is saved and transferred as raw HTML. Because of this, we need to sanitize the input
 * before rendering it to prevent XSS. The below is the allowlist of HTML tags we're expecting
 * to receieve from the editor. All other tags will be stripped out before rendering.
 */ const $0761f987dd69a755$export$3d2246e48d9cfed3 = [
    'p',
    'u',
    'a',
    'em',
    'strong',
    'span',
    'ol',
    'ul',
    'li',
    'pre',
    'code',
    'h2',
    'h3',
    'h4',
    'hr',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td'
];
const $0761f987dd69a755$export$d1fb6689cfa66d9b = 'yyyy-MM-dd';
const $0761f987dd69a755$export$5f2ab89513b5926a = 'HH:mm';
const $0761f987dd69a755$export$5c2d6de3ca9adcbe = 'XXX';
const $0761f987dd69a755$export$defafc11b2455f78 = 'dd/MMM/yy h:mm a';
const $0761f987dd69a755$export$f61f3fa9ed38719a = 'do MMMM Y h:mm a';
const $0761f987dd69a755$export$b896d7bac8b72b0 = [
    'objectsLimit',
    'objectTypeAttributesLimit',
    'objectSchemaLimit'
];
const $0761f987dd69a755$export$89b103afe26b1ad0 = 1000;

});

parcelRegister("gRt7E", function(module, exports) {

$parcel$export(module.exports, "getFirstValidationErrorMessage", () => $0ff2ce2075218060$export$5db4eaa45879c891);

var $jJZqs = parcelRequire("jJZqs");
const $0ff2ce2075218060$export$5db4eaa45879c891 = (error)=>{
    if (error instanceof (0, $jJZqs.ValidationError)) {
        const { errors: errors } = error;
        if (!errors || !errors.length) return undefined;
        const [{ error: validationErrorMessage }] = errors;
        return validationErrorMessage;
    }
    return undefined;
};

});

parcelRegister("iMQgS", function(module, exports) {

$parcel$export(module.exports, "formatHelpError", () => $5c1e43d2f45c701d$export$c34aa33ba71e7bce);
/* There can only ever be one instance of wrapped help text appearing at the end of the string:
Expected format: "some text{help}message inside help text{/help}"
com.riadalabs.jira.plugins.insight.services.util.ErrorMessageTranslatorImpl in jsm-cmdb-monolith */ const $5c1e43d2f45c701d$var$wrappedHelpRegex = /{help}(.*?){\/help}/;
const $5c1e43d2f45c701d$var$transformHelpError = (textWithWrappedHelp, match)=>{
    if (!match || match.length < 2) return textWithWrappedHelp;
    return textWithWrappedHelp.replace(match[0], (match?.index ?? 0) > 0 ? `. ${match[1]}` : match[1]);
};
const $5c1e43d2f45c701d$export$1264aeb584212337 = (possiblyHasWrappedHelpText)=>possiblyHasWrappedHelpText.match($5c1e43d2f45c701d$var$wrappedHelpRegex);
const $5c1e43d2f45c701d$export$c34aa33ba71e7bce = (possiblyHasWrappedHelpText)=>{
    const matchedHelpText = $5c1e43d2f45c701d$export$1264aeb584212337(possiblyHasWrappedHelpText);
    if (matchedHelpText) return $5c1e43d2f45c701d$var$transformHelpError(possiblyHasWrappedHelpText, matchedHelpText);
    return possiblyHasWrappedHelpText;
};

});

parcelRegister("4atFd", function(module, exports) {

$parcel$export(module.exports, "transformToInlineErrors", () => $be7f0c7b191a9472$export$5ec68665df6cf42);
const $be7f0c7b191a9472$export$5ec68665df6cf42 = (error)=>error.errors.reduce((total, current)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...total,
            [current.field]: current.error
        }), {});

});

parcelRegister("a0IY2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $19f9d2f993b7a03e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $19f9d2f993b7a03e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    // The following messages were copied from src/main/resources/cmdb-legacy-ui/js/i18n.js in the Jira monolith.
    // They are being progressively added or removed usages are fully tracked down in following PR's.
    // externalImport: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.external-import',
    //     defaultMessage: 'External Import',
    //     description: 'Refers to importing data from an external system',
    // },
    // importDataFromAnExternalApp: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-data-from-an-external-app',
    //     defaultMessage: 'Import data from an external app into Assets',
    //     description: 'Refers to importing data from an external app into the Assets product',
    // },
    // importModuleExternalName: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-external-name',
    //     defaultMessage: 'External Import',
    //     description: '',
    // },
    // importModuleExternalDescription: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-external-description',
    //     defaultMessage: 'Import data from an external app into Insight',
    //     description: '',
    // },
    // importModuleCsvName: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-csv-name',
    //     defaultMessage: 'CSV Import',
    //     description: '',
    // },
    // importModuleCsvDescription: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-csv-description',
    //     defaultMessage: 'Import a CSV file into Insight',
    //     description: '',
    // },
    // importModuleDiscoveryName: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-discovery-name',
    //     defaultMessage: 'Discovery Import',
    //     description: '',
    // },
    // importModuleDiscoveryDescription: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-discovery-description',
    //     defaultMessage: 'Import discovery data into Insight',
    //     description: '',
    // },
    // importModuleJsonName: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-json-name',
    //     defaultMessage: 'JSON Import',
    //     description: '',
    // },
    // importModuleJsonDescription: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-json-description',
    //     defaultMessage: 'Import a JSON file into Insight',
    //     description: '',
    // },
    // importFileName: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-file-name',
    //     defaultMessage: 'File',
    //     description: '',
    // },
    // importFileNameDesc: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-file-name-desc',
    //     defaultMessage: 'Select a file to import.',
    //     description: '',
    // },
    // importDelimiter: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-delimiter',
    //     defaultMessage: 'Delimiter',
    //     description: '',
    // },
    // importDelimiterDesc: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-delimiter-desc',
    //     defaultMessage:
    //         'The delimiter used in the file. One character is allowed except for "Tab" where you would enter \\t',
    //     description: '',
    // },
    // importEncoding: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-encoding',
    //     defaultMessage: 'Encoding',
    //     description: '',
    // },
    // importEncodingDesc: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-encoding-desc',
    //     defaultMessage: 'The encoding used in the file.',
    //     description: '',
    // },
    // configInfoName: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.config-info-name',
    //     defaultMessage: 'Name',
    //     description: '',
    // },
    // importNameDesc: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-name-desc',
    //     defaultMessage: 'The name for the configuration',
    //     description: '',
    // },
    // importValidationNameDuplicate: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-validation-name-duplicate',
    //     defaultMessage: 'There is already an import configuration with this name',
    //     description: '',
    // },
    // rlabsInsightHeaderDescription: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.rlabs-insight-header-description',
    //     defaultMessage: 'Description',
    //     description: '',
    // },
    // importDescriptionDesc: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-description-desc',
    //     defaultMessage: 'The description for the configuration',
    //     description: '',
    // },
    // importConcatinator: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-concatinator',
    //     defaultMessage: 'Concatenator',
    //     description: '',
    // },
    // importConcatinatorDesc: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-concatinator-desc',
    //     defaultMessage:
    //         'When joining multiple data locators into one Insight attribute, this will be the default concatenator. Enter \\s for space-concatenated.',
    //     description: '',
    // },
    // importRemove: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-remove',
    //     defaultMessage: 'Remove',
    //     description: '',
    // },
    // importIgnore: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-ignore',
    //     defaultMessage: 'Ignore',
    //     description: '',
    // },
    // importAdd: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-add',
    //     defaultMessage: 'Add',
    //     description: '',
    // },
    // importDatalocatorEmptyvalue: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-datalocator-emptyvalue',
    //     defaultMessage: 'Empty Values',
    //     description: '',
    // },
    // importDatalocatorEmptyvalueDesc: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-datalocator-emptyvalue-desc',
    //     defaultMessage: 'Specify if the import should remove or ignore empty values',
    //     description: '',
    // },
    // importDatalocatorUnknownvalue: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-datalocator-unknownvalue',
    //     defaultMessage: 'Unknown Values',
    //     description: '',
    // },
    // importDatalocatorUnknownvalueDesc: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-datalocator-unknownvalue-desc',
    //     defaultMessage:
    //         'Specify if the import should try to add unknown values to Insight configuration or just ignore them. This is applied on Status and Select attribute types.',
    //     description: '',
    // },
    // importDateformat: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-dateformat',
    //     defaultMessage: 'Date Format',
    //     description: '',
    // },
    // importDateformatDesc: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-dateformat-desc',
    //     defaultMessage:
    //         'Optional date format to convert dates into Insight. Insight will automatically try to find correct format if no one provided.',
    //     description: '',
    // },
    // importDatetimeformat: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-datetimeformat',
    //     defaultMessage: 'Date/Time Format',
    //     description: '',
    // },
    // importDatetimeformatDesc: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-datetimeformat-desc',
    //     defaultMessage:
    //         'The date/time format to convert dates with time into Insight. Insight will automatically try to find correct format if no one provided',
    //     description: '',
    // },
    constraintViolationReferenceTypeBeanSizeName: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-reference-type-bean-size-name",
        "defaultMessage": "Name must contain at least 2 and max 30 characters"
    },
    constraintViolationStatusTypeBeanNotNullName: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-status-type-bean-not-null-name",
        "defaultMessage": "Name has to be entered"
    },
    constraintViolationStatusTypeBeanSizeName: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-status-type-bean-size-name",
        "defaultMessage": "Name must contain at least 2 and max 30 characters"
    },
    constraintViolationStatusTypeBeanSizeDescription: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-status-type-bean-size-description",
        "defaultMessage": "Description must contain max 255 characters"
    },
    constraintViolationStatusTypeBeanUsed: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-status-type-bean-used",
        "defaultMessage": "Can't delete status type since it's used by one or more object types."
    },
    // importModuleValidationInvalidFile: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-module-validation-invalid-file',
    //     defaultMessage: 'Invalid file!',
    //     description: '',
    // },
    // importValidationObjecttypeattributeRequired: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.import-validation-objecttypeattribute-required',
    //     defaultMessage: 'The mapping to an Insight Object Types attribute is required.',
    //     description: '',
    // },
    constraintViolationObjectSchemaBeanSizeName: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-object-schema-bean-size-name",
        "defaultMessage": "Name must contain at least 2 and max 50 characters"
    },
    constraintViolationObjectTypeBeanSizeName: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-object-type-bean-size-name",
        "defaultMessage": "Name must contain at least 2 and max 50 characters"
    },
    constraintViolationObjectTypeBeanSizeDescription: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-object-type-bean-size-description",
        "defaultMessage": "Description must contain max 70 characters"
    },
    constraintViolationObjectSchemaBeanSizeDescription: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-object-schema-bean-size-description",
        "defaultMessage": "Description must contain max 80 characters"
    },
    // userPickerAjaxDesc: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.user-picker-ajax-desc',
    //     defaultMessage: 'Start typing to get a list of possible matches.',
    //     description: '',
    // },
    // objectschemaImportAnalyzeFailed: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.objectschema-import-analyze-failed',
    //     defaultMessage: 'Failed to analyze the specified file!',
    //     description: '',
    // },
    // objectschemaImportAnalyzeFailedCompression: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.objectschema-import-analyze-failed-compression',
    //     defaultMessage: 'Unknown file compression!',
    //     description: '',
    // },
    // objectschemaImportAnalyzeFailedChecksum: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.objectschema-import-analyze-failed-checksum',
    //     defaultMessage: 'File integrity violation',
    //     description: '',
    // },
    // objectschemaImportAnalyzeFailedArchive: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.objectschema-import-analyze-failed-archive',
    //     defaultMessage: 'File archive error',
    //     description: '',
    // },
    // objectschemaImportAnalyzeFailedArchiveContentInvalid: {
    //     id: 'servicedesk-insight-shared-utils.common.utils.validation-error-translation.objectschema-import-analyze-failed-archive-content-invalid',
    //     defaultMessage: 'Invalid file content',
    //     description: '',
    // },
    constraintViolationVariablesEntrySizeName: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-variables-entry-size-name",
        "defaultMessage": "Name must contain at least 2 and max 50 characters"
    },
    constraintViolationVariablesEntryPatternObjectSchemaKey: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-variables-entry-pattern-object-schema-key",
        "defaultMessage": "Key must contain only alphabetic letters and digits and be 2-10 characters long."
    },
    constraintViolationVariablesEntrySizeDescription: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.constraint-violation-variables-entry-size-description",
        "defaultMessage": "Description must contain max 80 characters"
    },
    errorDuplicateName: {
        "id": "servicedesk-insight-shared-utils.common.utils.validation-error-translation.error-duplicate-name",
        "defaultMessage": "There is already an import configuration with this name"
    }
});

});


parcelRegister("f05qh", function(module, exports) {

$parcel$export(module.exports, "default", () => $157a4c7695d9e855$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $157a4c7695d9e855$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "servicedesk-insight-inline-editable-attributes.common.editable-attribute.error-flag-title",
        "defaultMessage": "We couldn't update your attribute"
    },
    errorFlagDescription: {
        "id": "servicedesk-insight-inline-editable-attributes.common.editable-attribute.error-flag-description",
        "defaultMessage": "Please refresh and try again"
    },
    editButtonLabel: {
        "id": "servicedesk-insight-inline-editable-attributes.common.editable-attribute.edit-button-label",
        "defaultMessage": "Edit {attributeTypeName}"
    }
});

});


parcelRegister("ghTXd", function(module, exports) {

$parcel$export(module.exports, "toFieldValue", () => $7a5405494f88182a$export$cf91ca817cb32469);
const $7a5405494f88182a$export$cf91ca817cb32469 = (repos)=>repos.map(({ uuid: uuid })=>uuid);

});


parcelRegister("fnYbX", function(module, exports) {

$parcel$export(module.exports, "BooleanEditableAttribute", () => $c8952b35daab9f91$export$a17a4fdf8b177191);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $j8mgt = parcelRequire("j8mgt");

var $2e6sm = parcelRequire("2e6sm");

var $jiKTg = parcelRequire("jiKTg");

var $2QgAn = parcelRequire("2QgAn");

var $581BZ = parcelRequire("581BZ");

var $8AFAN = parcelRequire("8AFAN");

var $e08Fw = parcelRequire("e08Fw");
const $c8952b35daab9f91$var$BooleanAttribute = (props)=>{
    const { attributeType: attributeType, isEditable: isEditable } = props;
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const [value, setValue] = (0, $2QgAn.useBooleanValue)(attribute);
    const onValueChange = (0, $5uXOq.useCallback)(({ value: updatedValue })=>{
        setValue(updatedValue);
    }, [
        setValue
    ]);
    const resetValue = (0, $5uXOq.useCallback)(()=>setValue((0, $2QgAn.getBooleanAttributeValue)(attribute)), [
        attribute,
        setValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.boolean-attribute",
        value: value === null ? null : String(value),
        onChange: onValueChange,
        storedValue: (0, $2QgAn.getBooleanAttributeValue)(attribute) === null ? null : String((0, $2QgAn.getBooleanAttributeValue)(attribute)),
        isEditable: isEditable,
        attributeType: attributeType,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2e6sm.BooleanReadView), {
                value: value
            })),
        renderEditView: ({ hasValidationError: hasValidationError, onChange: onChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8AFAN.EditViewSpacers).BooleanSelect, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiKTg.BooleanSelect), {
                autoFocus: true,
                defaultMenuIsOpen: true,
                value: value,
                validationState: hasValidationError ? 'error' : 'default',
                onChange: onChange
            })),
        onResetValue: resetValue
    });
};
const $c8952b35daab9f91$export$a17a4fdf8b177191 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightInlineEditableBooleanAttribute",
        packageName: "jiraServicedeskInsightEditableBooleanAttribute",
        teamName: "falcons",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8952b35daab9f91$var$BooleanAttribute, props));

});
parcelRegister("2e6sm", function(module, exports) {

$parcel$export(module.exports, "BooleanReadView", () => $b8439c3078bc3329$export$dbbcef15b3e9a21c);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $btivG = parcelRequire("btivG");

var $d5Zn3 = parcelRequire("d5Zn3");


var $koVbs = parcelRequire("koVbs");

var $j8mgt = parcelRequire("j8mgt");

var $izv8K = parcelRequire("izv8K");
const $b8439c3078bc3329$var$True = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8439c3078bc3329$var$Container, {
        "data-testid": "servicedesk-insight-attribute-views.ui.boolean.value-true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8439c3078bc3329$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($btivG))), {
        label: formatMessage((0, $izv8K.default).true),
        primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G400})`
    })), formatMessage((0, $izv8K.default).true));
};
const $b8439c3078bc3329$var$False = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8439c3078bc3329$var$Container, {
        "data-testid": "servicedesk-insight-attribute-views.ui.boolean.value-false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8439c3078bc3329$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d5Zn3))), {
        label: formatMessage((0, $izv8K.default).false),
        primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R400})`
    })), formatMessage((0, $izv8K.default).false));
};
const $b8439c3078bc3329$var$None = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8439c3078bc3329$var$Container, {
        "data-testid": "servicedesk-insight-attribute-views.ui.boolean.value-none"
    }, formatMessage((0, $izv8K.default).none));
};
const $b8439c3078bc3329$export$dbbcef15b3e9a21c = ({ value: value })=>{
    let dropdownChild;
    switch(value){
        case true:
            dropdownChild = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8439c3078bc3329$var$True, null);
            break;
        case false:
            dropdownChild = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8439c3078bc3329$var$False, null);
            break;
        case null:
            dropdownChild = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8439c3078bc3329$var$None, null);
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: value === null
    }, dropdownChild);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8439c3078bc3329$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1n261g80 _1tke1tcg",
            __cmplp.className
        ])
    });
});
const $b8439c3078bc3329$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_15tynkob",
            __cmplp.className
        ])
    });
});

});
parcelRegister("izv8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $e749969cdd0992c1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e749969cdd0992c1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    true: {
        "id": "servicedesk-insight-attribute-views.boolean.true",
        "defaultMessage": "True"
    },
    false: {
        "id": "servicedesk-insight-attribute-views.boolean.false",
        "defaultMessage": "False"
    },
    none: {
        "id": "servicedesk-insight-attribute-views.boolean.none",
        "defaultMessage": "None"
    }
});

});


parcelRegister("jiKTg", function(module, exports) {

$parcel$export(module.exports, "BooleanSelect", () => $2b6ad3c35014fb77$export$5a963e56a57b8633);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $koVbs = parcelRequire("koVbs");

var $2e6sm = parcelRequire("2e6sm");

var $f3O7j = parcelRequire("f3O7j");

var $kkKWW = parcelRequire("kkKWW");
const $2b6ad3c35014fb77$var$formatOptionLabel = ({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2e6sm.BooleanReadView), {
        value: value
    });
const $2b6ad3c35014fb77$export$5a963e56a57b8633 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { value: value, onChange: onChange, validationState: validationState, defaultMenuIsOpen: defaultMenuIsOpen, autoFocus: autoFocus } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        isDisabled: props.isDisabled,
        isSearchable: false,
        autoFocus: autoFocus,
        defaultMenuIsOpen: defaultMenuIsOpen,
        value: {
            // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
            // @ts-expect-error([Part of upgrade 4.9-5.4]) - Object literal may only specify known properties, and 'label' does not exist in type '{ value: boolean | null; } | MultiValue<{ value: boolean | null; }>'.
            label: '',
            value: value
        },
        options: [
            {
                label: formatMessage((0, $kkKWW.default).true),
                value: true
            },
            {
                label: formatMessage((0, $kkKWW.default).false),
                value: false
            },
            {
                label: formatMessage((0, $kkKWW.default).none),
                value: null
            }
        ],
        formatOptionLabel: $2b6ad3c35014fb77$var$formatOptionLabel,
        validationState: validationState,
        // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Type '(change: OnChangeValue) => void' is not assignable to type '(newValue: SingleValue<{ value: boolean | null; }>, actionMeta: ActionMeta<{ value: boolean | null; }>) => void'.
        onChange: (change)=>{
            if (change && change.label) onChange(change);
        },
        classNamePrefix: "insight-object-attribute-boolean-select",
        menuPortalTarget: (0, $f3O7j.selectInAModalStyleFixProps).menuPortalTarget,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
        styles: {
            ...(0, $f3O7j.selectInAModalStyleFixProps).styles,
            valueContainer: (base)=>({
                    ...base,
                    // We need to adjust the left padding on the atlaskit parent, so that the value lines up with the read view
                    paddingLeft: "var(--ds-space-050, 4px)"
                })
        }
    });
};
$2b6ad3c35014fb77$export$5a963e56a57b8633.defaultProps = {
    validationState: 'default'
};

});
parcelRegister("kkKWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $21e5866755599cdf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $21e5866755599cdf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    true: {
        "id": "servicedesk-insight-boolean-select.true",
        "defaultMessage": "True"
    },
    false: {
        "id": "servicedesk-insight-boolean-select.false",
        "defaultMessage": "False"
    },
    none: {
        "id": "servicedesk-insight-boolean-select.none",
        "defaultMessage": "None"
    }
});

});


parcelRegister("2QgAn", function(module, exports) {

$parcel$export(module.exports, "getDefaultAttributeValue", () => $75d118c00714d18f$export$4e98ca3cdec5ea01);
$parcel$export(module.exports, "getDefaultAttributeDateValue", () => $75d118c00714d18f$export$290fdb90eecc7ddd);
$parcel$export(module.exports, "useDefaultAttributeValue", () => $75d118c00714d18f$export$9726152c665eb93d);
$parcel$export(module.exports, "useDefaultAttributeDateValue", () => $75d118c00714d18f$export$f8aa3daba94a8fad);
$parcel$export(module.exports, "getDefaultAttributeArrayValue", () => $75d118c00714d18f$export$d97f60a719553752);
$parcel$export(module.exports, "getDefaultAttributeArrayValueFromCmdbObjectAttribute", () => $75d118c00714d18f$export$6c6273ccb0a37e6b);
$parcel$export(module.exports, "useDefaultAttributeArrayValue", () => $75d118c00714d18f$export$5306abdbc015828);
$parcel$export(module.exports, "getDefaultMultipleAttributeValuesAsString", () => $75d118c00714d18f$export$6af279cafcf0ee60);
$parcel$export(module.exports, "useDefaultMultipleAttributeValuesAsString", () => $75d118c00714d18f$export$78ea80c1afdcdae7);
$parcel$export(module.exports, "getBooleanAttributeValue", () => $75d118c00714d18f$export$e9bd635e5d8abeb0);
$parcel$export(module.exports, "useBooleanValue", () => $75d118c00714d18f$export$779b38db25d966d);

var $5uXOq = parcelRequire("5uXOq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $e5pww = parcelRequire("e5pww");
const $75d118c00714d18f$export$4e98ca3cdec5ea01 = (attribute)=>{
    if (attribute && attribute.type === 'default') {
        const [defaultValue] = attribute.defaultTypeValues.map(({ value: value })=>value ?? '');
        return defaultValue;
    }
    return '';
};
const $75d118c00714d18f$export$290fdb90eecc7ddd = (attribute)=>{
    const defaultValue = $75d118c00714d18f$export$4e98ca3cdec5ea01(attribute);
    // checks if it is a valid date / datetime value
    if ((0, $jovBr.default)((0, $eZDAP.default)(defaultValue))) return defaultValue;
    return '';
};
const $75d118c00714d18f$export$9726152c665eb93d = (attribute)=>{
    const [value, setValue] = (0, $5uXOq.useState)($75d118c00714d18f$export$4e98ca3cdec5ea01(attribute));
    (0, $5uXOq.useEffect)(()=>{
        setValue($75d118c00714d18f$export$4e98ca3cdec5ea01(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};
const $75d118c00714d18f$export$f8aa3daba94a8fad = (attribute)=>{
    const [value, setValue] = (0, $5uXOq.useState)($75d118c00714d18f$export$290fdb90eecc7ddd(attribute));
    (0, $5uXOq.useEffect)(()=>{
        setValue($75d118c00714d18f$export$290fdb90eecc7ddd(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};
const $75d118c00714d18f$export$d97f60a719553752 = (attribute)=>{
    if (attribute && attribute.type === 'default') return attribute.defaultTypeValues.map(({ value: value })=>value ?? '');
    return [];
};
const $75d118c00714d18f$export$6c6273ccb0a37e6b = (attribute)=>{
    if (attribute && attribute.type === (0, $e5pww.AttributeTypeMap).Default) return attribute.objectAttributeValues.map(({ value: value })=>value ?? '');
    return [];
};
const $75d118c00714d18f$export$5306abdbc015828 = (attribute)=>{
    const [value, setValue] = (0, $5uXOq.useState)($75d118c00714d18f$export$d97f60a719553752(attribute));
    (0, $5uXOq.useEffect)(()=>{
        setValue($75d118c00714d18f$export$d97f60a719553752(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};
const $75d118c00714d18f$export$6af279cafcf0ee60 = (attribute)=>{
    if (attribute && attribute.type === 'default') return attribute.defaultTypeValues.map(({ value: value })=>value ?? '').join(' ');
    return '';
};
const $75d118c00714d18f$export$78ea80c1afdcdae7 = (attribute)=>{
    const [value, setValue] = (0, $5uXOq.useState)($75d118c00714d18f$export$6af279cafcf0ee60(attribute));
    (0, $5uXOq.useEffect)(()=>{
        setValue($75d118c00714d18f$export$6af279cafcf0ee60(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};
const $75d118c00714d18f$export$e9bd635e5d8abeb0 = (attribute)=>{
    if (attribute && attribute.type === 'default') {
        const [{ value: value }] = attribute.defaultTypeValues;
        if (value === 'true') return true;
        if (value === 'false') return false;
    }
    // Will arrive here if attribute value is 'None'
    return null;
};
const $75d118c00714d18f$export$779b38db25d966d = (attribute)=>{
    const [value, setValue] = (0, $5uXOq.useState)($75d118c00714d18f$export$e9bd635e5d8abeb0(attribute));
    (0, $5uXOq.useEffect)(()=>{
        setValue($75d118c00714d18f$export$e9bd635e5d8abeb0(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};

});


parcelRegister("47wQS", function(module, exports) {

$parcel$export(module.exports, "DateEditableAttribute", () => $7e0aefaf12ac4f27$export$81c4a30deb51ccb5);

var $5uXOq = parcelRequire("5uXOq");

var $cHapz = parcelRequire("cHapz");

var $7CMCs = parcelRequire("7CMCs");

var $6yeNV = parcelRequire("6yeNV");

var $j8mgt = parcelRequire("j8mgt");

var $jLwXE = parcelRequire("jLwXE");

var $2QgAn = parcelRequire("2QgAn");

var $581BZ = parcelRequire("581BZ");

var $DVljb = parcelRequire("DVljb");

var $8AFAN = parcelRequire("8AFAN");

var $e08Fw = parcelRequire("e08Fw");
const $7e0aefaf12ac4f27$var$DateAttribute = (props)=>{
    const { attributeType: attributeType, isEditable: isEditable } = props;
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const [value, setValue] = (0, $2QgAn.useDefaultAttributeDateValue)(attribute);
    const onValueChange = (0, $5uXOq.useCallback)((val)=>{
        setValue(val);
    }, [
        setValue
    ]);
    const resetValue = (0, $5uXOq.useCallback)(()=>setValue((0, $2QgAn.getDefaultAttributeDateValue)(attribute)), [
        attribute,
        setValue
    ]);
    const locale = (0, $DVljb.useLocale)();
    const standardizedLocale = (0, $6yeNV.standardizeLocale)(locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.date-attribute",
        value: value,
        onChange: onValueChange,
        storedValue: (0, $2QgAn.getDefaultAttributeDateValue)(attribute),
        isEditable: isEditable,
        attributeType: attributeType,
        hideActionButtons: false,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jLwXE.DateReadView), {
                value: value
            })),
        renderEditView: ({ hasValidationError: hasValidationError, onChange: onChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8AFAN.EditViewSpacers).DatePicker, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHapz.default), {
                testId: "servicedesk-insight-inline-editable-attributes.ui.date-attribute.date-picker",
                autoFocus: true,
                locale: standardizedLocale,
                value: value,
                onChange: onChange,
                isInvalid: hasValidationError
            })),
        onResetValue: resetValue
    });
};
const $7e0aefaf12ac4f27$export$81c4a30deb51ccb5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightInlineEditableDateAttribute",
        packageName: "jiraServicedeskInsightEditableDateAttribute",
        teamName: "falcons",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e0aefaf12ac4f27$var$DateAttribute, props));

});
parcelRegister("cHapz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a844b50b385d50f7$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cKsfY = parcelRequire("cKsfY");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");
const $a844b50b385d50f7$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a844b50b385d50f7$export$2e2bcd8739ae039 = $a844b50b385d50f7$var$DatePicker;

});
parcelRegister("cKsfY", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $8f027f90da2b6bac$export$6e8ea24b15199873);

var $5uXOq = parcelRequire("5uXOq");
function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("2TI0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $19201d0a1f7d7d54$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $cTemL = parcelRequire("cTemL");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
function $19201d0a1f7d7d54$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
const $19201d0a1f7d7d54$var$dropdownIndicatorStyles = (0, $8CUq3.xcss)({
    minWidth: "var(--ds-space-300, 24px)",
    minHeight: "var(--ds-space-300, 24px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{}
};
const $19201d0a1f7d7d54$var$pickerContainerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $19201d0a1f7d7d54$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '100%',
    position: 'absolute',
    alignItems: 'center',
    flexBasis: 'inherit',
    color: 'color.text.subtlest',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    transition: `color 150ms`,
    ':hover': {
        color: 'color.text.subtle'
    }
});
const $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.400'
});
const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.050'
});
const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.025'
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.CalendarIcon = (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? (0, (/*@__PURE__*/$parcel$interopDefault($acknU))) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($cTemL))), // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $5RLF6.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso);
            // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $5RLF6.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                });
                // Only try to set the date if we have month & day
                if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $6AqCE.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase();
            // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
            // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        }, // This event handler is triggered from both keydown and click. It's weird.
        this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                });
                // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        }, // `unknown` is used because `value` is unused so it does not matter.
        this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date()),
            l10n: (0, $7qZ1x.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $7qZ1x.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = this.CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: $19201d0a1f7d7d54$var$dropdownIndicatorStyles
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, props));
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $dBs4v.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iaQLg.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gtijU.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $jHBnA.EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
        };
        // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $5RLF6.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null;
        // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return(// These event handlers must be on this element because the events come
        // from different child elements.
        // Until innerProps is removed, it must remain a div rather than a primitive component.
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ...innerProps,
            css: $19201d0a1f7d7d54$var$pickerContainerStyles,
            // Since the onclick, onfocus are passed down, adding role="presentation" prevents typecheck errors.
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7K5PP.default), {
            appearance: this.props.appearance,
            "aria-describedby": ariaDescribedBy,
            label: label || undefined,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            closeMenuOnSelect: true,
            // FOr some reason, this and the below `styles` type error _only_ show
            // up when you alter some of the properties in the `selectComponents`
            // object. These errors are still present, and I suspect have always
            // been present, without changing the unrelated code. Ignoring as the
            // component still works as expected despite this error. And also
            // because the select refresh team may solve it later.
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: menuIsOpen,
            onBlur: this.onSelectBlur,
            onChange: this.onSelectChange,
            onFocus: this.onSelectFocus,
            onInputChange: this.handleSelectInputChange,
            placeholder: (0, $5RLF6.getPlaceholder)({
                placeholder: this.props.placeholder,
                l10n: this.state.l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            // These are below the spread because I don't know what is in
            // selectProps or not and what wil be overwritten
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            // These aren't part of `Select`'s API, but we're using them here.
            // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarRef: calendarProps.calendarRef,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        }), shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9KnKW.IdProvider), {
            prefix: "open-calendar-label--"
        }, ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
                xcss: [
                    $19201d0a1f7d7d54$var$iconContainerStyles,
                    value && !hideIcon ? $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles : // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                    (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew : $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles
                ]
            }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
                appearance: "subtle",
                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                id: openCalendarLabelId,
                icon: (iconProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)(this.CalendarIcon, {
                        ...iconProps,
                        ...(0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? {
                            color: "var(--ds-icon, #44546F)"
                        } : {
                            primaryColor: "var(--ds-icon, #44546F)"
                        }
                    }),
                onClick: this.onCalendarButtonClick,
                onKeyDown: this.onCalendarButtonKeyDown,
                ref: this.calendarButtonRef,
                testId: testId && `${testId}--open-calendar-button`
            }))) : null));
    }
}
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $19201d0a1f7d7d54$var$DatePicker = (0, $994MI.default)({
    componentName: 'datePicker',
    packageName: $19201d0a1f7d7d54$var$packageName,
    packageVersion: $19201d0a1f7d7d54$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $19201d0a1f7d7d54$var$packageName,
            packageVersion: $19201d0a1f7d7d54$var$packageVersion
        }
    })
})($19201d0a1f7d7d54$export$df43d21f5faca9f7));
var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;

});
parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab6a74d5dbe2e66f9a6df60fb0887ec0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3c6678ca49b47a08391fd96c442f9a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $is0Fy.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $3wYKB = parcelRequire("3wYKB");

var $lCAti = parcelRequire("lCAti");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("jHBnA", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $91948b176ea23188$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $91948b176ea23188$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $91948b176ea23188$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $91948b176ea23188$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $91948b176ea23188$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $91948b176ea23188$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $91948b176ea23188$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $91948b176ea23188$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("5RLF6", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $e0db4b6edb7dbfac$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $e0db4b6edb7dbfac$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $e0db4b6edb7dbfac$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $e0db4b6edb7dbfac$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $k7m40 = parcelRequire("k7m40");
var $5I2ju = parcelRequire("5I2ju");
var $eZDAP = parcelRequire("eZDAP");

var $2ucUe = parcelRequire("2ucUe");

var $jHBnA = parcelRequire("jHBnA");
const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $5I2ju.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(parsedDate)}`;
    return newIso;
};
const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $jHBnA.defaultDateFormat));
    return l10n.parseDate(date);
};
const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $jHBnA.defaultDateFormat));
    const date = (0, $eZDAP.default)(value);
    return dateFormat ? (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $jHBnA.placeholderDatetime));
};

});
parcelRegister("2ucUe", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca6f20a476eda5dc$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca6f20a476eda5dc$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("iaQLg", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $d73476b891de3e0c$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bChGW = parcelRequire("bChGW");
function $d73476b891de3e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d73476b891de3e0c$var$calendarButtonInclusionStyles = {
    name: "i3e4rp",
    styles: "margin-inline-start:var(--ds-space-400, 32px)"
};
const $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles = {
    name: "19a3ait",
    styles: "margin-inline-start:var(--ds-space-300, 24px)"
};
const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: showClearIndicator ? $d73476b891de3e0c$var$calendarButtonInclusionStyles : $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).IndicatorsContainer, rest));

});

parcelRegister("gtijU", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e800a879ee1613fc$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $1f0Hs = parcelRequire("1f0Hs");

var $9MHPe = parcelRequire("9MHPe");


var $k5uoT = parcelRequire("k5uoT");

var $avHVh = parcelRequire("avHVh");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $e800a879ee1613fc$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $eZDAP.default)(iso);
        return (0, $jovBr.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $e800a879ee1613fc$var$menuStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zIndex: (0, $k5uoT.layers).dialog(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    overflow: 'hidden'
});
const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
    const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9MHPe.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $avHVh.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: // The mousedown event is required for a date selection to work when
        // the menu is opened via the calendar button. The reason why is
        // because there is a mousedown event on the menu inside of
        // `react-select` that will stop the calendar select event from
        // firing. This is passed in via the `innerProps`. Therefore, we must
        // pass it in *after* the `innerProps` spread.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $e800a879ee1613fc$var$menuStyles,
            ...innerProps,
            onMouseDown: onMenuMouseDown
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1f0Hs.default), {
            day: day,
            month: month,
            year: year,
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            ref: selectProps.calendarRef,
            selected: [
                selectProps.calendarValue
            ],
            shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        })),
        testId: selectProps.testId
    }));
};

});
parcelRegister("1f0Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $16abbcd9b9109722$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $ePz3p = parcelRequire("ePz3p");

var $lJWdi = parcelRequire("lJWdi");

var $avO9B = parcelRequire("avO9B");

var $iioJV = parcelRequire("iioJV");

var $jihAA = parcelRequire("jihAA");

var $bbnGB = parcelRequire("bbnGB");

var $hbcve = parcelRequire("hbcve");

var $2TGJ3 = parcelRequire("2TGJ3");

var $f9D1v = parcelRequire("f9D1v");

var $9efze = parcelRequire("9efze");
const $16abbcd9b9109722$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $16abbcd9b9109722$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $16abbcd9b9109722$var$InnerCalendar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $iioJV.blankStringArray), defaultSelected: defaultSelected = (0, $iioJV.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $eGmKJ.default), onChange: onChange = (0, $eGmKJ.default), onFocus: onFocus = (0, $eGmKJ.default), onSelect: onSelect = (0, $eGmKJ.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $jihAA.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2TGJ3.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $f9D1v.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $bbnGB.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $9efze.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $hbcve.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $9KnKW.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ $5uXOq.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        xcss: $16abbcd9b9109722$var$styles.box,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ $5uXOq.createElement((0, $414Wj.default), {
        space: "space.150"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ePz3p.default // The month number needs to be translated to index in the month
    ), {
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextMonthHeading: getNextMonthHeading(),
        nextYearHeading: getNextYearHeading(),
        previousMonthHeading: getPreviousMonthHeading(),
        previousYearHeading: getPreviousYearHeading(),
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ $5uXOq.createElement((0, $avO9B.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ $5uXOq.createElement((0, $lJWdi.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    }))))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $16abbcd9b9109722$var$Calendar = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ $5uXOq.createElement($16abbcd9b9109722$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;

});
parcelRegister("414Wj", function(module, exports) {

$parcel$export(module.exports, "default", () => $452354e10b30c8d8$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $452354e10b30c8d8$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $452354e10b30c8d8$var$Stack = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $bUmQV.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $452354e10b30c8d8$var$styles.hug, grow === 'fill' && $452354e10b30c8d8$var$styles.fill, // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- TODO: We need to handle pass-through `xcss` => `xcss` here.
        xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$452354e10b30c8d8$var$Stack.displayName = 'Stack';
var $452354e10b30c8d8$export$2e2bcd8739ae039 = $452354e10b30c8d8$var$Stack;

});
parcelRegister("bUmQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ccb72b8ddc20b7$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0ccb72b8ddc20b7$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $d0ccb72b8ddc20b7$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $d0ccb72b8ddc20b7$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $d0ccb72b8ddc20b7$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $d0ccb72b8ddc20b7$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $d0ccb72b8ddc20b7$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $d0ccb72b8ddc20b7$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $d0ccb72b8ddc20b7$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement(Component, {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            $d0ccb72b8ddc20b7$var$styles.root,
            gap && $d0ccb72b8ddc20b7$var$columnGapMap[gap],
            columnGap && $d0ccb72b8ddc20b7$var$columnGapMap[columnGap],
            gap && $d0ccb72b8ddc20b7$var$rowGapMap[gap],
            rowGap && $d0ccb72b8ddc20b7$var$rowGapMap[rowGap],
            alignItems && $d0ccb72b8ddc20b7$var$alignItemsMap[alignItems],
            direction && $d0ccb72b8ddc20b7$var$flexDirectionMap[direction],
            justifyContent && $d0ccb72b8ddc20b7$var$justifyContentMap[justifyContent],
            wrap && $d0ccb72b8ddc20b7$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$d0ccb72b8ddc20b7$var$Flex.displayName = 'Flex';
var $d0ccb72b8ddc20b7$export$2e2bcd8739ae039 = $d0ccb72b8ddc20b7$var$Flex;

});


parcelRegister("ePz3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $995afee12cb828f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $l1N8i = parcelRequire("l1N8i");

var $iPF0X = parcelRequire("iPF0X");

var $dq6Kz = parcelRequire("dq6Kz");

var $lRheX = parcelRequire("lRheX");

var $3dGN0 = parcelRequire("3dGN0");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $995afee12cb828f6$var$Header = /*#__PURE__*/ (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $9KnKW.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $5uXOq.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, (0, $VSDnB.fg)('dst-a11y-add-year-buttons-to-calendar') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevYearInteraction,
        testId: testId && `${testId}--previous-year`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iPF0X))),
        label: `${previousYearLabel}, ${previousYearHeading}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lRheX))),
        label: `${previousMonthLabel}, ${previousMonthHeading}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))),
        label: `${previousMonthLabel}, ${previousMonthHeading}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), (0, $VSDnB.fg)('dst-a11y-add-year-buttons-to-calendar') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.100",
        alignBlock: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))),
        label: `${nextMonthLabel}, ${nextMonthHeading}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextYearInteraction,
        testId: testId && `${testId}--next-year`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dq6Kz))),
        label: `${nextYearLabel}, ${nextYearHeading}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6s76W))),
        label: `${nextMonthLabel}, ${nextMonthHeading}`
    })));
});
$995afee12cb828f6$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;

});
parcelRegister("iPF0X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e9bde9ffb1901db299d24420ed3d13>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db5cce05fac9743f$var$_react = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $db5cce05fac9743f$var$_baseNew = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $db5cce05fac9743f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDoubleLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db5cce05fac9743f$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $db5cce05fac9743f$var$_react.default.createElement($db5cce05fac9743f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 10.5 6 6l4.5-4.5m-4.75 9L1.25 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$db5cce05fac9743f$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $db5cce05fac9743f$var$_default = module.exports.default = $db5cce05fac9743f$var$ChevronDoubleLeftIcon;

});

parcelRegister("dq6Kz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71b79966080ec94bc04e328878ca72a7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c52f081c61754ba$var$_react = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c52f081c61754ba$var$_baseNew = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9c52f081c61754ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDoubleRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c52f081c61754ba$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $9c52f081c61754ba$var$_react.default.createElement($9c52f081c61754ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.5 10.5 6 6 1.5 1.5m4.75 9 4.5-4.5-4.5-4.5"/>`,
        type: 'utility'
    }, props));
$9c52f081c61754ba$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $9c52f081c61754ba$var$_default = module.exports.default = $9c52f081c61754ba$var$ChevronDoubleRightIcon;

});

parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6122da5228d1f3e4cce8be42702737a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("c0aEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed572e62fc5b1cd0$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $ed572e62fc5b1cd0$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $ed572e62fc5b1cd0$var$Separator = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            $ed572e62fc5b1cd0$var$styles.separator
        ])
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $ed572e62fc5b1cd0$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $5uXOq.createElement($ed572e62fc5b1cd0$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $5uXOq.createElement((0, $bUmQV.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $ed572e62fc5b1cd0$var$styles.hug, grow === 'fill' && $ed572e62fc5b1cd0$var$styles.fill, // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- TODO: We need to handle pass-through `xcss` => `xcss` here.
        xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$ed572e62fc5b1cd0$var$Inline.displayName = 'Inline';
var $ed572e62fc5b1cd0$export$2e2bcd8739ae039 = $ed572e62fc5b1cd0$var$Inline;

});


parcelRegister("lJWdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f22a52ec309eeb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $1q4y8 = parcelRequire("1q4y8");

var $h581D = parcelRequire("h581D");
const $43f22a52ec309eeb$var$WeekDays = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h581D.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1q4y8.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;

});
parcelRegister("1q4y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b02566a310b79$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");

var $joKkQ = parcelRequire("joKkQ");
const $d70b02566a310b79$var$dateCellSiblingStyle = null;
const $d70b02566a310b79$var$dateCellTodayStyle = null;
const $d70b02566a310b79$var$dateCellPrevSelectedStyle = null;
const $d70b02566a310b79$var$dateCellSelectedStyle = null;
const $d70b02566a310b79$var$dateCellDisabledStyle = null;
const $d70b02566a310b79$var$dateCellStyles = null;
const $d70b02566a310b79$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $eGmKJ.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $5uXOq.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $joKkQ.default), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ $5uXOq.createElement("button", {
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
        className: (0, $bwpsq.default)([
            "_kkk2n7od _1yt41qfp _2rko1l7b _11c81oud _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
            isSibling && "_syaz1wmz _30l31wmz",
            isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
            isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
            isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
            isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
        ])
    }, day));
}));
$d70b02566a310b79$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ $5uXOq.createElement(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- TODO: Allow pass-through from `props.xcss`
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});


parcelRegister("h581D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8aba25f4ae00ff$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $joKkQ = parcelRequire("joKkQ");
const $5c8aba25f4ae00ff$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joKkQ.default), {
        testId: testId,
        xcss: $5c8aba25f4ae00ff$var$styles.templateColumns,
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;

});


parcelRegister("avO9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29b1b1295ce3a84$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $h581D = parcelRequire("h581D");
const $f29b1b1295ce3a84$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $f29b1b1295ce3a84$var$WeekHeader = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ $5uXOq.createElement((0, $h581D.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ $5uXOq.createElement((0, $MHKc7.default), {
            padding: "space.100",
            xcss: $f29b1b1295ce3a84$var$styles.columnHeader,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ $5uXOq.createElement((0, $dS3PR.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;

});

parcelRegister("iioJV", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $85c2ac8e9452c4bf$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $85c2ac8e9452c4bf$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];

});

parcelRegister("jihAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $654a69afe715a212$export$2e2bcd8739ae039);

var $33etG = parcelRequire("33etG");

var $f8qry = parcelRequire("f8qry");

var $3EtUb = parcelRequire("3EtUb");
function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $f8qry.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $33etG.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $33etG.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $33etG.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $33etG.default)(today, ()=>today || `${thisYear}-${(0, $3EtUb.default)(thisMonth)}-${(0, $3EtUb.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $33etG.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $33etG.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("3EtUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd804e1790f6d755$export$2e2bcd8739ae039);
function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("bbnGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccb38b64bb63461$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("hbcve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe53b5f3382c02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $5wbTt = parcelRequire("5wbTt");
function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $5uXOq.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $iioJV.daysPerWeek) : 0;
            return (0, $5wbTt.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $iioJV.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $5uXOq.useMemo)(()=>(0, $5wbTt.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $eZDAP.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $eZDAP.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $5uXOq.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $6ASl9.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $eZDAP.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("6ASl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ae62fd51c4538f$export$2e2bcd8739ae039);

var $3EtUb = parcelRequire("3EtUb");
function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $3EtUb.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $3EtUb.default)(date.day)}`;
}

});

parcelRegister("5wbTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dff1ed1384abe91$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $iioJV = parcelRequire("iioJV");

var $9Zmg7 = parcelRequire("9Zmg7");
function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $iioJV.daysPerWeek) - weekStartDay + firstDay) % (0, $iioJV.daysPerWeek));
    const lastDate = (0, $9Zmg7.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $iioJV.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9Zmg7.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $iioJV.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $iioJV.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $iioJV.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $iioJV.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $iioJV.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("9Zmg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $878800070b837d93$export$2e2bcd8739ae039);
function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("2TGJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caae4eff24f6e8d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $9Zmg7 = parcelRequire("9Zmg7");
const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $iioJV.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $iioJV.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $5uXOq.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $iioJV.daysPerWeek);
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $iioJV.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("f9D1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ec54640e7b9de4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");
function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $iioJV.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("9efze", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd6f430b06675a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7qZ1x = parcelRequire("7qZ1x");
function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $5uXOq.useMemo)(()=>(0, $7qZ1x.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("avHVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07968b7cb494a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $5owSH = parcelRequire("5owSH");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");

var $k5uoT = parcelRequire("k5uoT");
class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null);
        const divStyles = {
            background: 'transparent',
            position: 'absolute',
            top: 0,
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $5owSH.sizes).small.slice(0, -2)) - (0, $k5uoT.gridSize)()
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
			 * We need to set the intial top value to where the container is and zIndex so that it still
			 * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkD4s.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1V7PR.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oNEb.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: (0, $k5uoT.layers).dialog()
                },
                "data-testid": testId && `${testId}--popper--container`
            }, content);
        })));
    }
    constructor(...args){
        super(...args), this.update = (0, $eGmKJ.default);
    }
}

});


parcelRegister("6AqCE", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $caee16c105163c22$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $caee16c105163c22$export$ff525416014fb67d);

var $k7m40 = parcelRequire("k7m40");

var $2ucUe = parcelRequire("2ucUe");
function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
    return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)('YYYY-MM-DD'));
}
function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("dBs4v", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $9661917c82165ad2$export$6e30bf8cb1347b56);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue
        }, children);
    };

});


parcelRegister("jcbUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5b21daaca02ab$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $cTemL = parcelRequire("cTemL");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
function $48f5b21daaca02ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $48f5b21daaca02ab$var$packageName = "platform-pkg";
const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
const $48f5b21daaca02ab$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $48f5b21daaca02ab$var$packageName,
    packageVersion: $48f5b21daaca02ab$var$packageVersion
};
const $48f5b21daaca02ab$var$pickerContainerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $48f5b21daaca02ab$var$dropdownIndicatorStyles = (0, $8CUq3.xcss)({
    minWidth: "var(--ds-space-300, 24px)",
    minHeight: "var(--ds-space-300, 24px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $48f5b21daaca02ab$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '100%',
    position: 'absolute',
    alignItems: 'center',
    flexBasis: 'inherit',
    color: 'color.text.subtlest',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    transition: `color 150ms`,
    ':hover': {
        color: 'color.text.subtle'
    }
});
const $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.400'
});
const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.050'
});
const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles = (0, $8CUq3.xcss)({
    marginInlineEnd: 'space.025'
});
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $48f5b21daaca02ab$var$DatePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const calendarRef = (0, $5uXOq.useRef)(null);
    const calendarButtonRef = (0, $5uXOq.useRef)(null);
    const CalendarIcon = (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? (0, (/*@__PURE__*/$parcel$interopDefault($acknU))) : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    (0, (/*@__PURE__*/$parcel$interopDefault($cTemL)));
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$48f5b21daaca02ab$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $7qZ1x.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $5uXOq.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false);
            // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $5RLF6.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso);
        // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $5RLF6.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            });
            // Only try to set the date if we have month & day
            if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $6AqCE.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase();
        // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
        // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    };
    // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen(!isOpen);
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    };
    // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref;
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            xcss: $48f5b21daaca02ab$var$dropdownIndicatorStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, props));
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iaQLg.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gtijU.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay
    };
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $5RLF6.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null;
    // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $9KnKW.useId)()}`;
    return(// These event handlers must be on this element because the events come
    // from different child elements.
    // Until innerProps is removed, it must remain a div rather than a primitive component.
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...innerProps,
        css: $48f5b21daaca02ab$var$pickerContainerStyles,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        // Since the onclick, onfocus are passed down, adding role="presentation" prevents typecheck errors.
        role: "presentation"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        name: name,
        type: "hidden",
        value: getterValue,
        "data-testid": testId && `${testId}--input`
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7K5PP.default), {
        appearance: appearance,
        "aria-describedby": ariaDescribedBy,
        label: label || undefined,
        autoFocus: autoFocus,
        clearControlLabel: clearControlLabel,
        closeMenuOnSelect: true,
        // For some reason, this and the below `styles` type error _only_ show
        // up when you alter some of the properties in the `selectComponents`
        // object. These errors are still present, and I suspect have always
        // been present, without changing the unrelated code. Ignoring as the
        // component still works as expected despite this error. And also
        // because the select refresh team may solve it later.
        components: selectComponents,
        enableAnimation: false,
        inputId: id,
        inputValue: actualSelectInputValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        menuIsOpen: menuIsOpen,
        onBlur: onSelectBlur,
        onChange: onSelectChange,
        onFocus: onSelectFocus,
        onInputChange: handleSelectInputChange,
        placeholder: (0, $5RLF6.getPlaceholder)({
            placeholder: placeholder,
            l10n: l10n
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        styles: mergedStyles,
        value: initialValue,
        ...selectProps,
        // These are below the spread because I don't know what is in
        // selectProps or not and what wil be overwritten
        isClearable: true,
        isInvalid: isInvalid,
        spacing: spacing,
        testId: testId,
        // These aren't part of `Select`'s API, but we're using them here.
        // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
        calendarContainerRef: calendarProps.calendarContainerRef,
        calendarDisabled: calendarProps.calendarDisabled,
        calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
        calendarLocale: calendarProps.calendarLocale,
        calendarMaxDate: calendarProps.calendarMaxDate,
        calendarMinDate: calendarProps.calendarMinDate,
        calendarRef: calendarProps.calendarRef,
        calendarValue: calendarProps.calendarValue,
        calendarView: calendarProps.calendarView,
        calendarWeekStartDay: calendarProps.calendarWeekStartDay,
        nextMonthLabel: nextMonthLabel,
        onCalendarChange: calendarProps.onCalendarChange,
        onCalendarSelect: calendarProps.onCalendarSelect,
        previousMonthLabel: previousMonthLabel,
        shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
    }), shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: [
            $48f5b21daaca02ab$var$iconContainerStyles,
            value && !hideIcon ? $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles : // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew : $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
        appearance: "subtle",
        label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
        "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
        id: openCalendarLabelId,
        icon: (iconProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)(CalendarIcon, {
                ...iconProps,
                ...(0, $VSDnB.fg)('platform-visual-refresh-icon-ads-migration') ? {
                    color: "var(--ds-icon, #44546F)"
                } : {
                    primaryColor: "var(--ds-icon, #44546F)"
                }
            }),
        onClick: onCalendarButtonClick,
        onKeyDown: onCalendarButtonKeyDown,
        ref: calendarButtonRef,
        testId: testId && `${testId}--open-calendar-button`
    })) : null));
});
var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;

});


parcelRegister("6yeNV", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $e3b19be89da6c3f8$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $e3b19be89da6c3f8$export$93ff13646da25bd);

var $lzeFL = parcelRequire("lzeFL");

var $dJl1T = parcelRequire("dJl1T");
const $e3b19be89da6c3f8$export$95b7602913551865 = 'en-US';
const $e3b19be89da6c3f8$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$e3b19be89da6c3f8$export$95b7602913551865}.`);
        return $e3b19be89da6c3f8$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $lzeFL.default).includes(jiraLocale)) (0, $dJl1T.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $e3b19be89da6c3f8$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($e3b19be89da6c3f8$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});

parcelRegister("jLwXE", function(module, exports) {

$parcel$export(module.exports, "DateReadView", () => $31c6391c89861d0c$export$c663acc1a0b7c5a9);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cTemL = parcelRequire("cTemL");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $8tRRd = parcelRequire("8tRRd");

var $7hDf3 = parcelRequire("7hDf3");

var $j8mgt = parcelRequire("j8mgt");
const $31c6391c89861d0c$export$c663acc1a0b7c5a9 = ({ value: value, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatDateOnly: formatDateOnly } = (0, $8tRRd.useDateTimeFormatter)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const displayValue = value !== null && value !== '' ? formatDateOnly(value) : null;
    const placeholderText = showPlaceholderIfEmpty ? formatMessage((0, $7hDf3.default).placeholderNoneSelected) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: !displayValue
    }, displayValue !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31c6391c89861d0c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTemL))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $31c6391c89861d0c$var$textStyles
    }, displayValue)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.PlaceholderSpacer), null, placeholderText));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31c6391c89861d0c$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $31c6391c89861d0c$var$textStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("8tRRd", function(module, exports) {

$parcel$export(module.exports, "useDateTimeFormatter", () => $e6616d5994c4d841$export$163f492669f74d5b);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $cYlk7 = parcelRequire("cYlk7");

var $DVljb = parcelRequire("DVljb");

var $1YbNB = parcelRequire("1YbNB");

var $6yeNV = parcelRequire("6yeNV");
const $e6616d5994c4d841$export$163f492669f74d5b = (overrideTimeZone)=>{
    (0, $gKZoD.di)(Intl);
    const { data: { // @ts-expect-error - TS2339 - Property 'timeZone' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    user: { timeZone: timeZonePreference } } } = (0, $cYlk7.useCurrentUser)();
    const timeZone = overrideTimeZone ?? timeZonePreference;
    const jiraLocal = (0, $DVljb.useLocale)();
    const standardizedLocale = (0, $6yeNV.standardizeLocale)(jiraLocal);
    const verifiedTimeZone = (0, $6yeNV.verifyTimeZone)(timeZone);
    const dateTimeFormatter = (0, $5uXOq.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $1YbNB.longDateTimeFormat),
            timeZone: verifiedTimeZone
        }), [
        standardizedLocale,
        verifiedTimeZone
    ]);
    const dateOnlyFormatter = (0, $5uXOq.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $1YbNB.longDateOnlyFormat),
            timeZone: 'UTC'
        }), [
        standardizedLocale
    ]);
    const formatDateTime = (0, $5uXOq.useCallback)((date)=>{
        const rawValue = typeof date === 'string' ? new Date(date) : date;
        return dateTimeFormatter.format(rawValue);
    }, [
        dateTimeFormatter
    ]);
    const formatDateOnly = (0, $5uXOq.useCallback)((date)=>dateOnlyFormatter.format(new Date(date)), [
        dateOnlyFormatter
    ]);
    return {
        formatDateTime: /**
		 * Returns the long form of a date value with respect to the user's locale and timezone preferences
		 *
		 * @param {string|number|date} date Value as either an [ISO8601 string](https://www.w3.org/TR/NOTE-datetime) (eg `"1997-07-16T19:20:30.45+01:00"`), epoch number (eg `1615431020`), or vanilla `Date` object
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021, 1:11 PM
		 * formatDateTime(1611281490857) // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日 午後1:11
		 * formatDateTime(1611281490857) // where user locale is "ja-JP"
		 * ```
		 */ formatDateTime,
        formatDateOnly: /**
		 * Returns the long form of a date without time value with respect to the user's locale. Timezones do not apply to these dates.
		 *
		 * @param {string} date Value as a 'YYYY-MM-DD' string (eg `"1997-07-16"`)
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021
		 * formatDateOnly('2021-01-22') // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日
		 * formatDateOnly('2021-01-22') // where user locale is "ja-JP"
		 * ```
		 */ formatDateOnly
    };
};

});
parcelRegister("1YbNB", function(module, exports) {

$parcel$export(module.exports, "longDateTimeFormat", () => $71114821d9cd9835$export$f2f390060309965);
$parcel$export(module.exports, "longDateOnlyFormat", () => $71114821d9cd9835$export$51f819d50bcd4ae1);
/**
 * If this file gets changed, please update platform/packages/proforma/proforma-common-core/src/form-system/components/questions/common/defaultDateTimeFormats.tsx or let the owners know via #jsm-request-intake.
 *
 * Proforma wants to stay consistent with Jira date and time format options.
 *
 * Later on Proforma will introduce React Context to pass config props, and this will be removed.
 */ /**
 * Long format of a date time, eg "Jun 16, 1971, 2:34 AM" with 12h/24h formatting resolved from locale
 */ const $71114821d9cd9835$export$f2f390060309965 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $71114821d9cd9835$export$51f819d50bcd4ae1 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
};

});


parcelRegister("7hDf3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dfc7542ad737334$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6dfc7542ad737334$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholderNoneEntered: {
        "id": "servicedesk-insight-attribute-views.common.placeholder-none-entered",
        "defaultMessage": "None entered"
    },
    placeholderNoneSelected: {
        "id": "servicedesk-insight-attribute-views.common.placeholder-none-selected",
        "defaultMessage": "None selected"
    }
});

});



parcelRegister("3hJsw", function(module, exports) {

$parcel$export(module.exports, "DateTimeEditableAttribute", () => $5d6a043d93e6c5c6$export$f0142d1e1f538db7);

var $5uXOq = parcelRequire("5uXOq");

var $htnpT = parcelRequire("htnpT");

var $8C78M = parcelRequire("8C78M");

var $7CMCs = parcelRequire("7CMCs");

var $6yeNV = parcelRequire("6yeNV");

var $cYlk7 = parcelRequire("cYlk7");

var $j8mgt = parcelRequire("j8mgt");

var $5t6Kq = parcelRequire("5t6Kq");

var $2QgAn = parcelRequire("2QgAn");

var $581BZ = parcelRequire("581BZ");

var $hVdSz = parcelRequire("hVdSz");

var $DVljb = parcelRequire("DVljb");

var $e08Fw = parcelRequire("e08Fw");
const $5d6a043d93e6c5c6$export$658449cd23a1e455 = ()=>{
    const { data: data } = (0, $cYlk7.useCurrentUser)();
    const isFullUserData = (user)=>typeof user === 'object' && !!user && 'timeZone' in user;
    const timeZone = isFullUserData(data.user) ? data.user.timeZone : null;
    if (!timeZone) // This code path should never be evaluated as timeZone comes from
    // tenant user context. Flow sees the timezone value as nullable as it's
    // initialised from an empty sweet-state store, but that context comes
    // from meta tags embedded on the page that are populated into the store
    // at runtime.
    throw new Error('Timezone not found. Please mock useCurrentUserTimezone for storybooks/tests');
    return timeZone;
};
const $5d6a043d93e6c5c6$var$DateTimeAttribute = (props)=>{
    const { attributeType: attributeType, isEditable: isEditable } = props;
    const locale = (0, $DVljb.useLocale)();
    const standardizedLocale = (0, $6yeNV.standardizeLocale)(locale);
    const { parseDateTimeAttributeValue: parseDateTimeAttributeValue } = (0, $hVdSz.useParseDateTimeAttributeValue)();
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const [value, setValue] = (0, $2QgAn.useDefaultAttributeDateValue)(attribute);
    const onValueChange = (0, $5uXOq.useCallback)((val)=>{
        setValue(val);
    }, [
        setValue
    ]);
    const resetValue = (0, $5uXOq.useCallback)(()=>setValue((0, $2QgAn.getDefaultAttributeDateValue)(attribute)), [
        attribute,
        setValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.date-time-attribute",
        value: value,
        onChange: onValueChange,
        storedValue: (0, $2QgAn.getDefaultAttributeDateValue)(attribute),
        isEditable: isEditable,
        attributeType: attributeType,
        hideActionButtons: false,
        keepEditViewOpenOnBlur: true,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5t6Kq.DateTimeReadView), {
                value: value || null
            })),
        renderEditView: ({ hasValidationError: hasValidationError, onChange: onChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htnpT.default), {
                testId: "servicedesk-insight-inline-editable-attributes.ui.date-time-attribute.date-time-picker",
                autoFocus: true,
                value: value,
                locale: standardizedLocale,
                onChange: onChange,
                isInvalid: hasValidationError,
                // @ts-expect-error - TS2322 - Type '(fieldValue: string) => { dateValue: string; timeValue: string; zoneValue: string; } | undefined' is not assignable to type '(dateTimeValue: string, date: string, time: string, timezone: string) => { dateValue: string; timeValue: string; zoneValue: string; }'.
                parseValue: (fieldValue)=>fieldValue !== '' ? parseDateTimeAttributeValue(fieldValue) : undefined,
                timePickerProps: {
                    times: (0, $8C78M.default),
                    timeIsEditable: true
                }
            }),
        onResetValue: resetValue
    });
};
const $5d6a043d93e6c5c6$export$f0142d1e1f538db7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightInlineEditableDateAttribute",
        packageName: "jiraServicedeskInsightEditableDateTimeAttribute",
        teamName: "falcons",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5d6a043d93e6c5c6$var$DateTimeAttribute, props));

});
parcelRegister("htnpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2698ee0cdd579e$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cKsfY = parcelRequire("cKsfY");

var $9Lqvx = parcelRequire("9Lqvx");

var $hB1kl = parcelRequire("hB1kl");
const $fa2698ee0cdd579e$var$DateTimePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-time-picker-use-functional-component'), (0, $hB1kl.default), (0, $9Lqvx.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fa2698ee0cdd579e$export$2e2bcd8739ae039 = $fa2698ee0cdd579e$var$DateTimePicker;

});
parcelRegister("9Lqvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $597f1543018f8252$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $cQz2U = parcelRequire("cQz2U");

var $VSDnB = parcelRequire("VSDnB");

var $7VXAu = parcelRequire("7VXAu");


var $jHBnA = parcelRequire("jHBnA");

var $8JNJx = parcelRequire("8JNJx");

var $cKsfY = parcelRequire("cKsfY");

var $2ucUe = parcelRequire("2ucUe");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");

var $jdTq6 = parcelRequire("jdTq6");
function $597f1543018f8252$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $597f1543018f8252$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
const $597f1543018f8252$var$packageName = "platform-pkg";
const $597f1543018f8252$var$packageVersion = "0.0.0-use.local";
// Make DatePicker 50% the width of DateTimePicker
// If rendering an icon container, shrink the TimePicker
const $597f1543018f8252$var$datePickerContainerStyles = {
    name: "d1cmrh",
    styles: "flex-basis:50%;flex-grow:1;flex-shrink:0"
};
const $597f1543018f8252$var$timePickerContainerStyles = {
    name: "zwso5s",
    styles: "flex-basis:50%;flex-grow:1"
};
const $597f1543018f8252$var$iconContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: "var(--ds-border-width, 1px)",
    alignItems: 'center',
    flexBasis: 'inherit',
    backgroundColor: 'inherit',
    border: 'none',
    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    paddingBlockEnd: "var(--ds-space-075, 6px)",
    paddingBlockStart: "var(--ds-space-075, 6px)",
    paddingInlineEnd: "var(--ds-space-100, 8px)",
    paddingInlineStart: "var(--ds-space-050, 4px)",
    transition: `color 150ms`,
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    }
});
// react-select overrides (via @atlaskit/select).
const $597f1543018f8252$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $597f1543018f8252$var$dateTimePickerDefaultProps = {
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{}
};
const $597f1543018f8252$export$3b559a1219cb3c27 = 'Date';
const $597f1543018f8252$export$d82cc7e53d68a428 = 'Time';
class $597f1543018f8252$export$732a1726f0a3523b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = $597f1543018f8252$var$dateTimePickerDefaultProps;
    }
    parseValue(value, dateValue, timeValue, zoneValue) {
        if (this.props.parseValue) {
            const parsedFromFn = this.props.parseValue(value, dateValue, timeValue, zoneValue);
            // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: dateValue,
                timeValue: timeValue,
                zoneValue: zoneValue
            };
        }
        const parsed = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(parsed) ? {
            dateValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('HH:mm')),
            zoneValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }
    onValueChange({ dateValue: dateValue, timeValue: timeValue, zoneValue: zoneValue }) {
        this.setState({
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        });
        if (dateValue && timeValue) {
            const value = (0, $jHBnA.formatDateTimeZoneIntoIso)(dateValue, timeValue, zoneValue);
            const { zoneValue: parsedZone } = this.parseValue(value, dateValue, timeValue, zoneValue);
            const valueWithValidZone = (0, $jHBnA.formatDateTimeZoneIntoIso)(dateValue, timeValue, parsedZone);
            this.setState({
                value: valueWithValidZone
            });
            this.props.onChange?.(valueWithValidZone);
        // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (this.getValue()) {
            this.setState({
                value: ''
            });
            this.props.onChange?.('');
        }
    }
    render() {
        const { 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerProps = {}, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, locale: locale = 'en-US', name: name = '', spacing: spacing = 'default', testId: testId, timePickerProps: timePickerProps = {} } = this.props;
        const value = this.getValue();
        const { isFocused: isFocused } = this.state;
        const parsedValues = this.getParsedValues();
        const dateValue = parsedValues?.dateValue;
        const timeValue = parsedValues?.timeValue;
        const datePickerSelectProps = datePickerProps?.selectProps;
        const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
        const datePickerLabel = datePickerProps.label || $597f1543018f8252$export$3b559a1219cb3c27;
        const mergedDatePickerSelectProps = {
            ...datePickerSelectProps,
            styles: (0, $7VXAu.mergeStyles)($597f1543018f8252$var$styles, datePickerSelectProps?.styles)
        };
        const timePickerSelectProps = timePickerProps?.selectProps;
        const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
        const timePickerLabel = timePickerProps.label || $597f1543018f8252$export$d82cc7e53d68a428;
        const mergedTimePickerSelectProps = {
            ...timePickerSelectProps,
            styles: (0, $7VXAu.mergeStyles)($597f1543018f8252$var$styles, timePickerSelectProps?.styles)
        };
        // Render DateTimePicker's IconContainer when a value has been filled
        // Don't use Date or TimePicker's because they can't be customised
        const isClearable = Boolean(dateValue || timeValue);
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8JNJx.DateTimePickerContainer), {
            appearance: appearance,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInvalid: isInvalid,
            testId: testId,
            innerProps: innerProps
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $597f1543018f8252$var$datePickerContainerStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($597f1543018f8252$var$DatePicker, {
            appearance: appearance,
            "aria-describedby": datePickerAriaDescribedBy,
            autoFocus: datePickerProps.autoFocus || autoFocus,
            dateFormat: datePickerProps.dateFormat,
            defaultIsOpen: datePickerProps.defaultIsOpen,
            defaultValue: datePickerProps.defaultValue,
            disabled: datePickerProps.disabled,
            disabledDateFilter: datePickerProps.disabledDateFilter,
            formatDisplayLabel: datePickerProps.formatDisplayLabel,
            hideIcon: datePickerProps.hideIcon || true,
            icon: datePickerProps.icon,
            id: datePickerProps.id || id,
            innerProps: datePickerProps.innerProps,
            isDisabled: datePickerProps.isDisabled || isDisabled,
            isInvalid: datePickerProps.isInvalid || isInvalid,
            isRequired: datePickerProps.isRequired || isRequired,
            isOpen: datePickerProps.isOpen,
            label: datePickerLabel,
            locale: datePickerProps.locale || locale,
            maxDate: datePickerProps.maxDate,
            minDate: datePickerProps.minDate,
            name: datePickerProps.name,
            nextMonthLabel: datePickerProps.nextMonthLabel,
            onBlur: this.onDateBlur,
            onChange: this.onDateChange,
            onFocus: this.onDateFocus,
            parseInputValue: datePickerProps.parseInputValue,
            placeholder: datePickerProps.placeholder,
            previousMonthLabel: datePickerProps.previousMonthLabel,
            selectProps: mergedDatePickerSelectProps,
            shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
            spacing: datePickerProps.spacing || spacing,
            testId: testId && `${testId}--datepicker` || datePickerProps.testId,
            value: dateValue,
            weekStartDay: datePickerProps.weekStartDay
        })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $597f1543018f8252$var$timePickerContainerStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jdTq6.default), {
            appearance: timePickerProps.appearance || appearance,
            "aria-describedby": timePickerAriaDescribedBy,
            autoFocus: timePickerProps.autoFocus,
            defaultIsOpen: timePickerProps.defaultIsOpen,
            defaultValue: timePickerProps.defaultValue,
            formatDisplayLabel: timePickerProps.formatDisplayLabel,
            hideIcon: timePickerProps.hideIcon || true,
            id: timePickerProps.id,
            innerProps: timePickerProps.innerProps,
            isDisabled: timePickerProps.isDisabled || isDisabled,
            isInvalid: timePickerProps.isInvalid || isInvalid,
            isOpen: timePickerProps.isOpen,
            isRequired: timePickerProps.isRequired || isRequired,
            label: timePickerLabel,
            locale: timePickerProps.locale || locale,
            name: timePickerProps.name,
            onBlur: this.onTimeBlur,
            onChange: this.onTimeChange,
            onFocus: this.onTimeFocus,
            parseInputValue: timePickerProps.parseInputValue,
            placeholder: timePickerProps.placeholder,
            selectProps: mergedTimePickerSelectProps,
            spacing: timePickerProps.spacing || spacing,
            testId: timePickerProps.testId || testId && `${testId}--timepicker`,
            timeFormat: timePickerProps.timeFormat,
            timeIsEditable: timePickerProps.timeIsEditable,
            times: timePickerProps.times,
            value: timeValue
        })), isClearable && !isDisabled ? /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
            css: $597f1543018f8252$var$iconContainerStyles,
            onClick: this.onClear,
            "data-testid": testId && `${testId}--icon--container`,
            tabIndex: -1,
            type: "button"
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: clearControlLabel
        }), ' ') : null);
    }
    constructor(...args){
        super(...args), this.state = {
            dateValue: this.props.datePickerProps?.defaultValue || '',
            isFocused: false,
            timeValue: this.props.timePickerProps?.defaultValue || '',
            value: this.props.defaultValue || '',
            zoneValue: ''
        }, // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getParsedValues = ()=>this.parseValue(this.getValue(), this.state.dateValue, this.state.timeValue, this.state.zoneValue), this.getValue = ()=>this.props.value ?? this.state.value, this.onDateBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.datePickerProps?.onBlur) this.props.datePickerProps.onBlur(event);
        }, this.onTimeBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.timePickerProps?.onBlur) this.props.timePickerProps.onBlur(event);
        }, this.onDateFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.datePickerProps?.onFocus) this.props.datePickerProps.onFocus(event);
        }, this.onTimeFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.timePickerProps?.onFocus) this.props.timePickerProps.onFocus(event);
        }, this.onDateChange = (dateValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: dateValue,
                timeValue: parsedValues.timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange(dateValue);
        }, this.onTimeChange = (timeValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: parsedValues.dateValue,
                timeValue: timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange(timeValue);
        }, this.onClear = ()=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: '',
                timeValue: '',
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange('');
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange('');
        };
    }
}
/**
 * __Date time picker__
 *
 * A date time picker allows the user to select an associated date and time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/usage)
 */ const $597f1543018f8252$var$DateTimePicker = (0, $994MI.default)({
    componentName: 'dateTimePicker',
    packageName: $597f1543018f8252$var$packageName,
    packageVersion: $597f1543018f8252$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'changed',
        actionSubject: 'dateTimePicker',
        attributes: {
            componentName: 'dateTimePicker',
            packageName: $597f1543018f8252$var$packageName,
            packageVersion: $597f1543018f8252$var$packageVersion
        }
    })
})($597f1543018f8252$export$732a1726f0a3523b));
var $597f1543018f8252$export$2e2bcd8739ae039 = $597f1543018f8252$var$DateTimePicker;

});
parcelRegister("8JNJx", function(module, exports) {

$parcel$export(module.exports, "DateTimePickerContainer", () => $346cb403038f00ec$export$83034b1f07ab0b20);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

function $346cb403038f00ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $346cb403038f00ec$var$isInvalidBorderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderColor: `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
});
const $346cb403038f00ec$var$isFocusedBorderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
});
const $346cb403038f00ec$var$isFocusedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
});
const $346cb403038f00ec$var$subtleBgStyles = {
    name: "1wrome1",
    styles: "background-color:transparent;border-color:transparent"
};
const $346cb403038f00ec$var$subtleFocusedBgStyles = {
    name: "17swi1q",
    styles: "background-color:var(--ds-background-input-pressed, transparent);border-color:transparent"
};
const $346cb403038f00ec$var$noBgStyles = {
    name: "14n6qpm",
    styles: "background-color:transparent;border-color:transparent;&:hover{background-color:transparent;border-color:transparent;}"
};
const $346cb403038f00ec$var$hoverStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        borderColor: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
    }
});
const $346cb403038f00ec$var$isInvalidHoverStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
    }
});
const $346cb403038f00ec$var$isDisabledStyles = {
    name: "1xp4bos",
    styles: "&:hover{cursor:default;}"
};
const $346cb403038f00ec$var$newBorderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`}`
});
const $346cb403038f00ec$var$baseContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    backgroundColor: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    border: `2px solid ${`var(--ds-border-input, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`}`,
    borderRadius: "var(--ds-border-radius, 3px)",
    transition: 'background-color 200ms ease-in-out, border-color 200ms ease-in-out',
    '&:hover': {
        cursor: 'pointer'
    }
});
const $346cb403038f00ec$export$83034b1f07ab0b20 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId }, ref)=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    // we cannot use Box or Flex primitives because these do not allow ...innerProps to be passed
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $346cb403038f00ec$var$baseContainerStyles,
            $346cb403038f00ec$var$newBorderStyles,
            isDisabled && $346cb403038f00ec$var$isDisabledStyles,
            isFocused && $346cb403038f00ec$var$isFocusedStyles,
            appearance === 'subtle' && (isFocused ? $346cb403038f00ec$var$subtleFocusedBgStyles : $346cb403038f00ec$var$subtleBgStyles),
            isFocused && $346cb403038f00ec$var$isFocusedBorderStyles,
            isInvalid && $346cb403038f00ec$var$isInvalidBorderStyles,
            notFocusedOrIsDisabled && (isInvalid ? $346cb403038f00ec$var$isInvalidHoverStyles : $346cb403038f00ec$var$hoverStyles),
            appearance === 'none' && $346cb403038f00ec$var$noBgStyles
        ],
        ...innerProps,
        "data-testid": testId,
        ref: ref
    }, children);
});

});

parcelRegister("jdTq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $420c0ce16dc216b4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $7qZ1x = parcelRequire("7qZ1x");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $imOgG = parcelRequire("imOgG");

var $j537G = parcelRequire("j537G");

var $2ucUe = parcelRequire("2ucUe");

var $dBs4v = parcelRequire("dBs4v");
const $420c0ce16dc216b4$var$packageName = "platform-pkg";
const $420c0ce16dc216b4$var$packageVersion = "0.0.0-use.local";
const $420c0ce16dc216b4$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $420c0ce16dc216b4$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $420c0ce16dc216b4$var$packageName,
    packageVersion: $420c0ce16dc216b4$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $420c0ce16dc216b4$var$TimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $eGmKJ.default), onChange: providedOnChange = (0, $eGmKJ.default), onFocus: providedOnFocus = (0, $eGmKJ.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $j537G.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $jHBnA.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $5uXOq.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$420c0ce16dc216b4$var$analyticsAttributes
    });
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $jHBnA.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $k7m40.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $7qZ1x.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $iOwNT.default) : (0, $7K5PP.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $jHBnA.defaultTimeFormat));
        const date = (0, $j537G.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $jovBr.default)(date)) return time;
        if (timeFormat) return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $jHBnA.EmptyComponent),
        Menu: (0, $imOgG.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$420c0ce16dc216b4$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        name: name,
        type: "hidden",
        value: value,
        "data-testid": testId && `${testId}--input`,
        onKeyDown: onSelectKeyDown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
        "aria-describedby": ariaDescribedBy,
        "aria-label": label || undefined,
        appearance: appearance,
        autoFocus: autoFocus,
        clearControlLabel: clearControlLabel,
        components: selectComponents,
        inputId: id,
        isClearable: true,
        isDisabled: isDisabled,
        isRequired: isRequired,
        menuIsOpen: isOpen && !isDisabled,
        menuPlacement: "auto",
        openMenuOnFocus: true,
        onBlur: onBlur,
        onCreateOption: onCreateOption,
        onChange: onChange,
        options: options,
        onFocus: onFocus,
        onMenuOpen: onMenuOpen,
        onMenuClose: onMenuClose,
        placeholder: placeholder || l10n.formatTime((0, $jHBnA.placeholderDatetime)),
        styles: mergedStyles,
        value: initialValue,
        spacing: spacing,
        // We need this to get things to work, even though it's not supported.
        // @ts-ignore
        fixedLayerRef: containerRef,
        isInvalid: isInvalid,
        testId: testId,
        ...otherSelectProps
    }));
});
var $420c0ce16dc216b4$export$2e2bcd8739ae039 = $420c0ce16dc216b4$var$TimePicker;

});
parcelRegister("imOgG", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $cf860f703ecf4b3d$export$982ad994195b4356);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bChGW = parcelRequire("bChGW");

var $avHVh = parcelRequire("avHVh");
const $cf860f703ecf4b3d$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $avHVh.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bChGW.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue
        }, children),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});

parcelRegister("j537G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e493719c30ce57$export$2e2bcd8739ae039);
const $b5e493719c30ce57$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $b5e493719c30ce57$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $b5e493719c30ce57$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $b5e493719c30ce57$export$c38a243baf9c6083(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $b5e493719c30ce57$export$ed20539f7181c701(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $b5e493719c30ce57$var$map24[hour];
    return hour;
}
function $b5e493719c30ce57$export$4077529dfc44a251(value) {
    if (value > '59') return null;
    return value;
}
function $b5e493719c30ce57$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $b5e493719c30ce57$export$c38a243baf9c6083(timeArray[0].trim());
    const hour = $b5e493719c30ce57$export$ed20539f7181c701(semi24.substring(0, 2), meridiem);
    const minute = $b5e493719c30ce57$export$4077529dfc44a251(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $b5e493719c30ce57$export$4077529dfc44a251(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $b5e493719c30ce57$export$865db99128311580(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $b5e493719c30ce57$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$b5e493719c30ce57$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $b5e493719c30ce57$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $b5e493719c30ce57$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $b5e493719c30ce57$export$865db99128311580(time2);
}

});



parcelRegister("hB1kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d24b25c52c40a49$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $cQz2U = parcelRequire("cQz2U");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $8JNJx = parcelRequire("8JNJx");

var $cKsfY = parcelRequire("cKsfY");

var $2ucUe = parcelRequire("2ucUe");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");

var $jdTq6 = parcelRequire("jdTq6");
const $9d24b25c52c40a49$var$DatePicker = (0, $cKsfY.componentWithCondition)(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
const $9d24b25c52c40a49$var$packageName = "platform-pkg";
const $9d24b25c52c40a49$var$packageVersion = "0.0.0-use.local";
const $9d24b25c52c40a49$var$analyticsAttributes = {
    componentName: 'dateTimePicker',
    packageName: $9d24b25c52c40a49$var$packageName,
    packageVersion: $9d24b25c52c40a49$var$packageVersion
};
// Make DatePicker 50% the width of DateTimePicker
// If rendering an icon container, shrink the TimePicker
const $9d24b25c52c40a49$var$datePickerContainerStyles = (0, $8CUq3.xcss)({
    flexBasis: '50%',
    flexGrow: 1,
    flexShrink: 0
});
const $9d24b25c52c40a49$var$timePickerContainerStyles = (0, $8CUq3.xcss)({
    flexBasis: '50%',
    flexGrow: 1
});
const $9d24b25c52c40a49$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexBasis: 'inherit'
});
// react-select overrides (via @atlaskit/select).
const $9d24b25c52c40a49$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $9d24b25c52c40a49$export$3b559a1219cb3c27 = 'Date';
const $9d24b25c52c40a49$export$d82cc7e53d68a428 = 'Time';
/**
 * __Date time picker__
 *
 * A date time picker allows the user to select an associated date and time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/usage)
 */ const $9d24b25c52c40a49$var$DateTimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerPropsWithSelectProps = {}, defaultValue: defaultValue = '', id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, name: name = '', onBlur: // These disables are here for proper typing when used as defaults. They
// should *not* use the `noop` function.
/* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, /* eslint-enable @repo/internal/react/use-noop */ parseValue: providedParseValue, spacing: spacing = 'default', locale: locale = 'en-US', testId: testId, timePickerProps: timePickerPropsWithSelectProps = {}, value: providedValue }, ref)=>{
    const [dateValue, setDateValue] = (0, $5uXOq.useState)(datePickerPropsWithSelectProps?.defaultValue || '');
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [timeValue, setTimeValue] = (0, $5uXOq.useState)(timePickerPropsWithSelectProps?.defaultValue || '');
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue || '');
    const [zoneValue, setZoneValue] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    const parseValue = (0, $5uXOq.useCallback)((value, providedDateValue, providedTimeValue, providedZoneValue)=>{
        if (providedParseValue) {
            const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            };
        }
        const parsed = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(parsed) ? {
            dateValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('HH:mm')),
            zoneValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }, [
        providedParseValue,
        dateValue,
        timeValue,
        zoneValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        setDateValue(parsedValues.dateValue);
        setTimeValue(parsedValues.timeValue);
        setZoneValue(parsedValues.zoneValue);
    }, [
        value,
        dateValue,
        timeValue,
        zoneValue,
        parseValue
    ]);
    const onDateBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (datePickerPropsWithSelectProps?.onBlur) datePickerPropsWithSelectProps.onBlur(event);
    };
    const onTimeBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (timePickerPropsWithSelectProps?.onBlur) timePickerPropsWithSelectProps.onBlur(event);
    };
    const onDateFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (datePickerPropsWithSelectProps?.onFocus) datePickerPropsWithSelectProps.onFocus(event);
    };
    const onTimeFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (timePickerPropsWithSelectProps?.onFocus) timePickerPropsWithSelectProps.onFocus(event);
    };
    const onDateChange = (dateValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: dateValue,
            providedTimeValue: parsedValues.timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange(dateValue);
    };
    const onTimeChange = (timeValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: parsedValues.dateValue,
            providedTimeValue: timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange(timeValue);
    };
    const onClear = ()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: '',
            providedTimeValue: '',
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange('');
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange('');
    };
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$9d24b25c52c40a49$var$analyticsAttributes
    });
    const onValueChange = ({ providedDateValue: providedDateValue, providedTimeValue: providedTimeValue, providedZoneValue: providedZoneValue })=>{
        setDateValue(providedDateValue);
        setTimeValue(providedTimeValue);
        setZoneValue(providedZoneValue);
        if (providedDateValue && providedTimeValue) {
            const value = (0, $jHBnA.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, providedZoneValue);
            const { zoneValue: parsedZone } = parseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            const valueWithValidZone = (0, $jHBnA.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, parsedZone);
            setValue(valueWithValidZone);
            onChangePropWithAnalytics(valueWithValidZone);
        // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (value) {
            setValue('');
            onChangePropWithAnalytics('');
        }
    };
    const { selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps;
    const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
    const datePickerLabel = datePickerProps.label || $9d24b25c52c40a49$export$3b559a1219cb3c27;
    const mergedDatePickerSelectProps = {
        ...datePickerSelectProps,
        styles: (0, $7VXAu.mergeStyles)($9d24b25c52c40a49$var$styles, datePickerSelectProps?.styles)
    };
    const { selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps;
    const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
    const timePickerLabel = timePickerProps.label || $9d24b25c52c40a49$export$d82cc7e53d68a428;
    const mergedTimePickerSelectProps = {
        ...timePickerSelectProps,
        styles: (0, $7VXAu.mergeStyles)($9d24b25c52c40a49$var$styles, timePickerSelectProps?.styles)
    };
    // Render DateTimePicker's IconContainer when a value has been filled
    // Don't use Date or TimePicker's because they can't be customised
    const isClearable = Boolean(dateValue || timeValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8JNJx.DateTimePickerContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isInvalid: isInvalid,
        testId: testId,
        innerProps: innerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        name: name,
        type: "hidden",
        value: value,
        "data-testid": testId && `${testId}--input`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9d24b25c52c40a49$var$datePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9d24b25c52c40a49$var$DatePicker, {
        appearance: appearance,
        "aria-describedby": datePickerAriaDescribedBy,
        autoFocus: datePickerProps.autoFocus || autoFocus,
        dateFormat: datePickerProps.dateFormat,
        defaultIsOpen: datePickerProps.defaultIsOpen,
        defaultValue: datePickerProps.defaultValue,
        disabled: datePickerProps.disabled,
        disabledDateFilter: datePickerProps.disabledDateFilter,
        formatDisplayLabel: datePickerProps.formatDisplayLabel,
        hideIcon: datePickerProps.hideIcon || true,
        icon: datePickerProps.icon,
        id: datePickerProps.id || id,
        innerProps: datePickerProps.innerProps,
        inputLabel: datePickerProps.inputLabel,
        inputLabelId: datePickerProps.inputLabelId,
        isDisabled: datePickerProps.isDisabled || isDisabled,
        isInvalid: datePickerProps.isInvalid || isInvalid,
        isOpen: datePickerProps.isOpen,
        isRequired: datePickerProps.isRequired || isRequired,
        label: datePickerLabel,
        locale: datePickerProps.locale || locale,
        maxDate: datePickerProps.maxDate,
        minDate: datePickerProps.minDate,
        name: datePickerProps.name,
        nextMonthLabel: datePickerProps.nextMonthLabel,
        onBlur: onDateBlur,
        onChange: onDateChange,
        onFocus: onDateFocus,
        openCalendarLabel: datePickerProps.openCalendarLabel,
        parseInputValue: datePickerProps.parseInputValue,
        placeholder: datePickerProps.placeholder,
        previousMonthLabel: datePickerProps.previousMonthLabel,
        selectProps: mergedDatePickerSelectProps,
        shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
        spacing: datePickerProps.spacing || spacing,
        testId: testId && `${testId}--datepicker` || datePickerProps.testId,
        value: dateValue,
        weekStartDay: datePickerProps.weekStartDay
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9d24b25c52c40a49$var$timePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdTq6.default), {
        appearance: timePickerProps.appearance || appearance,
        "aria-describedby": timePickerAriaDescribedBy,
        autoFocus: timePickerProps.autoFocus,
        defaultIsOpen: timePickerProps.defaultIsOpen,
        defaultValue: timePickerProps.defaultValue,
        formatDisplayLabel: timePickerProps.formatDisplayLabel,
        hideIcon: timePickerProps.hideIcon || true,
        id: timePickerProps.id,
        innerProps: timePickerProps.innerProps,
        isDisabled: timePickerProps.isDisabled || isDisabled,
        isInvalid: timePickerProps.isInvalid || isInvalid,
        isOpen: timePickerProps.isOpen,
        isRequired: timePickerProps.isRequired || isRequired,
        label: timePickerLabel,
        locale: timePickerProps.locale || locale,
        name: timePickerProps.name,
        onBlur: onTimeBlur,
        onChange: onTimeChange,
        onFocus: onTimeFocus,
        parseInputValue: timePickerProps.parseInputValue,
        placeholder: timePickerProps.placeholder,
        selectProps: mergedTimePickerSelectProps,
        spacing: timePickerProps.spacing || spacing,
        testId: timePickerProps.testId || testId && `${testId}--timepicker`,
        timeFormat: timePickerProps.timeFormat,
        timeIsEditable: timePickerProps.timeIsEditable,
        times: timePickerProps.times,
        value: timeValue
    })), isClearable && !isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $9d24b25c52c40a49$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        label: clearControlLabel,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
                ...iconProps,
                color: "var(--ds-text-subtlest, #626F86)",
                LEGACY_size: "small"
            }),
        onClick: onClear,
        testId: testId && `${testId}--icon--container`,
        tabIndex: -1
    })) : null);
});
var $9d24b25c52c40a49$export$2e2bcd8739ae039 = $9d24b25c52c40a49$var$DateTimePicker;

});


parcelRegister("8C78M", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8375c0a150abd1f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $f8375c0a150abd1f$export$2e2bcd8739ae039 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});

parcelRegister("5t6Kq", function(module, exports) {

$parcel$export(module.exports, "DateTimeReadView", () => $c675ca77220d3d63$export$962e920a3f993096);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cTemL = parcelRequire("cTemL");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $8tRRd = parcelRequire("8tRRd");

var $7hDf3 = parcelRequire("7hDf3");

var $j8mgt = parcelRequire("j8mgt");
const $c675ca77220d3d63$export$962e920a3f993096 = ({ value: value, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatDateTime: formatDateTime } = (0, $8tRRd.useDateTimeFormatter)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const displayValue = value !== null ? formatDateTime(value) : null;
    const hasValue = value !== null;
    const placeholderText = showPlaceholderIfEmpty ? formatMessage((0, $7hDf3.default).placeholderNoneSelected) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: !hasValue
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c675ca77220d3d63$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTemL))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c675ca77220d3d63$var$textStyles
    }, displayValue)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.PlaceholderSpacer), null, placeholderText));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c675ca77220d3d63$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $c675ca77220d3d63$var$textStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});

});

parcelRegister("hVdSz", function(module, exports) {

$parcel$export(module.exports, "useParseDateTimeAttributeValue", () => $ec0e44d67c8cf489$export$7b006ed2c9e2a323);

var $5uXOq = parcelRequire("5uXOq");

var $jovBr = parcelRequire("jovBr");

var $f9ece = parcelRequire("f9ece");

var $xJtdX = parcelRequire("xJtdX");

var $cYlk7 = parcelRequire("cYlk7");

var $9E5cm = parcelRequire("9E5cm");

var $johYW = parcelRequire("johYW");
const $ec0e44d67c8cf489$export$7b006ed2c9e2a323 = ()=>{
    const { data: data } = (0, $cYlk7.useCurrentUser)();
    const timeZone = 'timeZone' in data.user && data.user.timeZone ? data.user.timeZone : (0, $9E5cm.getBrowserTimeZone)();
    const parseDateTimeAttributeValue = (0, $5uXOq.useCallback)((dateTimeValue)=>{
        const parsedDate = new Date(dateTimeValue);
        if (!(0, $jovBr.default)(parsedDate)) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                meta: {
                    id: 'insightInlineEditableDateTimeAttribute',
                    packageName: 'jiraServicedeskInsightSharedUtils',
                    teamName: 'falcons'
                },
                attributes: {
                    message: 'Expected to parse a valid date value but failed.'
                }
            });
            throw new Error('Received invalid datetime value in DateTimeEditableAttribute');
        }
        return {
            dateValue: (0, $f9ece.default)(parsedDate, timeZone, (0, $johYW.DATE_VALUE_FORMAT)),
            timeValue: (0, $f9ece.default)(parsedDate, timeZone, (0, $johYW.TIME_VALUE_FORMAT)),
            zoneValue: (0, $f9ece.default)(parsedDate, timeZone, (0, $johYW.ZONE_VALUE_FORMAT))
        };
    }, [
        timeZone
    ]);
    return {
        parseDateTimeAttributeValue: parseDateTimeAttributeValue
    };
};

});
parcelRegister("9E5cm", function(module, exports) {

$parcel$export(module.exports, "SYDNEY_TIMEZONE", () => $6bf10f6ede879313$export$1a022a080ce6c5bb);
$parcel$export(module.exports, "getBrowserTimeZone", () => $6bf10f6ede879313$export$efc596861aea1477);
const $6bf10f6ede879313$export$1a022a080ce6c5bb = 'Australia/Sydney';
const $6bf10f6ede879313$export$efc596861aea1477 = ()=>Intl.DateTimeFormat().resolvedOptions().timeZone || $6bf10f6ede879313$export$1a022a080ce6c5bb;

});



parcelRegister("g7MYF", function(module, exports) {

$parcel$export(module.exports, "GroupEditableAttribute", () => $12dea7fed0804719$export$cefdadd2fcef048e);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $j8mgt = parcelRequire("j8mgt");

var $9r3nA = parcelRequire("9r3nA");

var $5HN4G = parcelRequire("5HN4G");

var $fw0ia = parcelRequire("fw0ia");

var $581BZ = parcelRequire("581BZ");

var $8AFAN = parcelRequire("8AFAN");

var $e08Fw = parcelRequire("e08Fw");
const $12dea7fed0804719$var$toFieldValue = (values)=>values.map(({ name: name })=>name);
const $12dea7fed0804719$var$EditableGroupAttribute = (props)=>{
    const { attributeType: attributeType, isEditable: isEditable } = props;
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const [value, setValue] = (0, $fw0ia.useGroupValue)(attribute);
    const storedValue = $12dea7fed0804719$var$toFieldValue((0, $fw0ia.getGroupValues)(attribute));
    const isMultiPicker = attributeType.maximumCardinality !== 1;
    const setGroupValue = (0, $5uXOq.useCallback)((groups)=>{
        setValue(groups.filter(({ name: name })=>name != null));
    }, [
        setValue
    ]);
    const resetValue = (0, $5uXOq.useCallback)(()=>setValue((0, $fw0ia.getGroupValues)(attribute)), [
        attribute,
        setValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.group-attribute",
        value: $12dea7fed0804719$var$toFieldValue(value),
        onChange: setGroupValue,
        storedValue: storedValue,
        attributeType: attributeType,
        isEditable: isEditable,
        attributeValuesInfo: {
            type: 'group',
            attributeValues: value
        },
        scalingEnabled: true,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r3nA.GroupsReadView), {
                groups: value
            })),
        renderEditView: ({ errorMessage: errorMessage, hasValidationError: hasValidationError, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8AFAN.EditViewSpacers).GroupPicker, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HN4G.GroupsPicker), {
                ...fieldProps,
                autoFocus: true,
                defaultMenuIsOpen: true,
                value: value,
                isMulti: isMultiPicker,
                validationState: hasValidationError ? 'error' : 'default',
                classNamePrefix: "insight-object-attribute-group-select"
            })),
        onResetValue: resetValue
    });
};
const $12dea7fed0804719$export$cefdadd2fcef048e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightEditableGroupAttribute",
        packageName: "jiraServicedeskInsightEditableGroupAttribute",
        teamName: "falcons",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12dea7fed0804719$var$EditableGroupAttribute, props));

});
parcelRegister("9r3nA", function(module, exports) {

$parcel$export(module.exports, "GroupsReadView", () => $c52510520eca7143$export$3a2147dfab2e76f1);

var $5uXOq = parcelRequire("5uXOq");

var $kFO36 = parcelRequire("kFO36");

var $koVbs = parcelRequire("koVbs");

var $j8mgt = parcelRequire("j8mgt");

var $5mVOP = parcelRequire("5mVOP");
const $c52510520eca7143$var$GroupReadView = ({ displayName: displayName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.RoleContainer), {
        key: displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kFO36))), {
        size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.RoleDisplayName), null, displayName));
const $c52510520eca7143$export$3a2147dfab2e76f1 = ({ groups: groups, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (groups.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.PlaceholderSpacer), null, showPlaceholderIfEmpty ? formatMessage((0, $5mVOP.messages).placeholder) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.RoleList), null, groups.map(({ name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c52510520eca7143$var$GroupReadView, {
            key: name,
            displayName: name
        }))));
};

});
parcelRegister("5mVOP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d308fc8f10124670$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d308fc8f10124670$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "servicedesk-insight-attribute-views.group.placeholder",
        "defaultMessage": "No groups selected"
    }
});

});


parcelRegister("5HN4G", function(module, exports) {

$parcel$export(module.exports, "GroupsPicker", () => $21b83b2380d9c62e$export$7d46f7617de97eed);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $d7FF4 = parcelRequire("d7FF4");

var $pa9q9 = parcelRequire("pa9q9");

var $f3O7j = parcelRequire("f3O7j");

var $dBgOD = parcelRequire("dBgOD");

var $g6S7j = parcelRequire("g6S7j");

var $a4tU9 = parcelRequire("a4tU9");
const $21b83b2380d9c62e$export$7d46f7617de97eed = ({ onKeyDown: onKeyDown, isClearable: isClearable, shouldInputRenderValue: shouldInputRenderValue, stylesOverride: stylesOverride, ...props })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [{ error: error }, { searchGroups: searchGroups }] = (0, $dBgOD.useGroupsSearch)();
    (0, $5uXOq.useEffect)(()=>{
        if (error != null) showFlag({
            type: 'error',
            title: (0, $g6S7j.default).errorFlagTitle,
            description: (0, $g6S7j.default).errorFlagDescription
        });
    }, [
        error,
        showFlag
    ]);
    const loadOptions = (0, $5uXOq.useCallback)((query, cb)=>{
        searchGroups(query).then((groups)=>{
            const results = groups?.map((0, $a4tU9.transformGroupToSelectOption)) ?? [];
            cb(results);
        });
    }, [
        searchGroups
    ]);
    const debouncedLoadOptions = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(loadOptions, 300), [
        loadOptions
    ]);
    const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        "data-testid": "servicedesk-insight-groups-picker.ui.select",
        classNamePrefix: "cmdb-groups-picker",
        ...(0, $f3O7j.selectInAModalStyleFixProps),
        ...props,
        // @ts-expect-error - TS2322 - Type 'boolean' is not assignable to type 'false'.
        isMulti: props.isMulti,
        defaultOptions: true,
        menuPlacement: "auto",
        loadOptions: debouncedLoadOptions,
        value: props.value.map((0, $a4tU9.transformGroupToSelectOption)),
        validationState: props.validationState,
        onChange: (groupOptions)=>{
            // group options can be null when clearing a value/s from the group picker
            if (groupOptions === null) props.onChange([]);
            else {
                const value = props.isMulti ? groupOptions : [
                    groupOptions
                ];
                props.onChange(value.map((0, $a4tU9.transformOptionToGroup)));
            }
        },
        isClearable: isClearable,
        controlShouldRenderValue: shouldInputRenderValue,
        autoFocus: props.autoFocus,
        onKeyDown: (e)=>{
            if (!isMenuOpen && onKeyDown) onKeyDown(e);
        },
        onMenuOpen: ()=>setIsMenuOpen(true),
        onMenuClose: ()=>setIsMenuOpen(false),
        spacing: props.spacing,
        ...stylesOverride ? {
            styles: stylesOverride
        } : {}
    });
};
$21b83b2380d9c62e$export$7d46f7617de97eed.defaultProps = {
    isMulti: true,
    validationState: 'default',
    autoFocus: false,
    shouldInputRenderValue: true,
    isClearable: true
};

});
parcelRegister("dBgOD", function(module, exports) {

$parcel$export(module.exports, "useGroupsSearch", () => $f6bb963fbfe8b9ef$export$56b2bfddba354d65);

var $2NMNM = parcelRequire("2NMNM");

var $ld2hZ = parcelRequire("ld2hZ");

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");
const $f6bb963fbfe8b9ef$export$d2b3d1cf7cc2f701 = async (query)=>{
    const res = await (0, $4VpwK.performCmdbGetRequest)(`/rest/api/3/groups/picker?query=${query}`);
    return res.groups;
};
const $f6bb963fbfe8b9ef$export$56b2bfddba354d65 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const searchGroups = async (query)=>{
        try {
            const groups = await $f6bb963fbfe8b9ef$export$d2b3d1cf7cc2f701(query);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'insightSearchGroups succeeded');
            return groups;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'insightSearchGroups',
                    teamName: 'falcons',
                    packageName: 'jiraServicedeskInsightGroupsPicker'
                }
            });
            throw error;
        }
    };
    const { data: data, loading: loading, error: error, fetch: fetch } = (0, $ld2hZ.useService)(searchGroups);
    return [
        {
            data: data,
            loading: loading,
            error: error
        },
        {
            searchGroups: fetch
        }
    ];
};

});

parcelRegister("g6S7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4f3604ff3703026$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a4f3604ff3703026$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "servicedesk-insight-groups-picker.error-flag-title",
        "defaultMessage": "We couldn\u2019t load your groups"
    },
    errorFlagDescription: {
        "id": "servicedesk-insight-groups-picker.error-flag-description",
        "defaultMessage": "Please check your network and try again"
    }
});

});

parcelRegister("a4tU9", function(module, exports) {

$parcel$export(module.exports, "transformGroupToSelectOption", () => $d187fc14e6948b70$export$f9564725a6dc76f6);
$parcel$export(module.exports, "transformOptionToGroup", () => $d187fc14e6948b70$export$85a22cb9308cd070);
const $d187fc14e6948b70$export$f9564725a6dc76f6 = ({ groupId: groupId, name: name })=>({
        label: name,
        value: groupId ?? name
    });
const $d187fc14e6948b70$export$85a22cb9308cd070 = ({ value: value, label: label })=>({
        groupId: value,
        name: label
    });

});


parcelRegister("fw0ia", function(module, exports) {

$parcel$export(module.exports, "getGroupValues", () => $051dcb13d6ee2492$export$b5c077265f461cf2);
$parcel$export(module.exports, "getGroupValuesFromCmdbObjectAttribute", () => $051dcb13d6ee2492$export$e828405854937ae4);
$parcel$export(module.exports, "useGroupValue", () => $051dcb13d6ee2492$export$f91c652cc4689b20);

var $5uXOq = parcelRequire("5uXOq");

var $e5pww = parcelRequire("e5pww");
const $051dcb13d6ee2492$export$b5c077265f461cf2 = (attribute)=>{
    if (attribute && attribute.type === 'group') return attribute.groupTypeValues.map(({ group: group })=>({
            name: group.name
        }));
    return [];
};
const $051dcb13d6ee2492$export$e828405854937ae4 = (attribute)=>{
    if (attribute && attribute.type === (0, $e5pww.AttributeTypeMap).Group) return attribute.objectAttributeValues.map(({ group: group })=>({
            name: group.name
        }));
    return [];
};
const $051dcb13d6ee2492$export$f91c652cc4689b20 = (attribute)=>{
    const groups = $051dcb13d6ee2492$export$b5c077265f461cf2(attribute);
    const [value, setValue] = (0, $5uXOq.useState)(groups);
    (0, $5uXOq.useEffect)(()=>{
        setValue(()=>$051dcb13d6ee2492$export$b5c077265f461cf2(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};

});


parcelRegister("96xYc", function(module, exports) {

$parcel$export(module.exports, "OpsgenieTeamsAttribute", () => $c987d81cc564ed43$export$71236793cc86d4b6);

var $5uXOq = parcelRequire("5uXOq");

var $j8mgt = parcelRequire("j8mgt");

var $1syes = parcelRequire("1syes");

var $1srZ4 = parcelRequire("1srZ4");

var $581BZ = parcelRequire("581BZ");

var $e08Fw = parcelRequire("e08Fw");
const $c987d81cc564ed43$export$cf91ca817cb32469 = (repos)=>repos.map(({ id: id })=>id);
const $c987d81cc564ed43$export$71236793cc86d4b6 = (props)=>{
    const { attributeType: attributeType } = props;
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const value = (0, $1srZ4.getOpsgenieTeamValues)(attribute);
    const storedValue = $c987d81cc564ed43$export$cf91ca817cb32469((0, $1srZ4.getOpsgenieTeamValues)(attribute));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.opsgenie-team-attribute.opsgenie-team-attribute",
        value: $c987d81cc564ed43$export$cf91ca817cb32469(value),
        storedValue: storedValue,
        attributeType: props.attributeType,
        isEditable: props.isEditable,
        attributeValuesInfo: {
            type: 'opsgenieTeam',
            attributeValues: value
        },
        scalingEnabled: true,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1syes.OpsgenieTeamsReadView), {
                opsgenieTeams: value,
                showPlaceholderIfEmpty: true
            })),
        renderEditView: ()=>/* OpsGenie Team is only readonly at present */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onResetValue: ()=>{}
    });
};

});
parcelRegister("1syes", function(module, exports) {

$parcel$export(module.exports, "OpsgenieTeamReadView", () => $194fb1487b7b3012$export$7629e14a1f5315d6);
$parcel$export(module.exports, "OpsgenieTeamsReadView", () => $194fb1487b7b3012$export$829de5cf25cd0e9a);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $kFO36 = parcelRequire("kFO36");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $8J6rn = parcelRequire("8J6rn");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $2MTnd = parcelRequire("2MTnd");

var $hDzhb = parcelRequire("hDzhb");

var $j8mgt = parcelRequire("j8mgt");

var $lyMyT = parcelRequire("lyMyT");
const $194fb1487b7b3012$export$72a7ae4a1b14fd60 = ({ name: name, avatarUrl: avatarUrl, url: url })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($194fb1487b7b3012$var$OpsgenieTeamContainer, null, avatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "xsmall",
        src: avatarUrl
    }), !avatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kFO36))), {
        size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($194fb1487b7b3012$var$NeutralLink, {
        href: url
    }, name));
const $194fb1487b7b3012$export$7629e14a1f5315d6 = ({ id: id, name: name, avatarUrl: avatarUrl, url: url })=>{
    const { data: data, loading: teamLoading, error: error, fetchTeamInfo: fetchTeamInfo } = (0, $2MTnd.default)();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const platformTeamId = data?.platformTeamId;
    const teamUrl = shouldUseJSM ? `/jira/ops/teams/${platformTeamId}` : url;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldUseJSM) fetchTeamInfo(id);
    }, [
        id,
        fetchTeamInfo,
        shouldUseJSM
    ]);
    if (shouldUseJSM && teamLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $194fb1487b7b3012$var$loadingSpinnerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null));
    if (shouldUseJSM && error) {
        showFlag({
            type: 'error',
            title: (0, $lyMyT.messages).errorTitle,
            description: (0, $lyMyT.messages).errorMessage
        });
        return null;
    }
    if (shouldUseJSM && !teamLoading && !platformTeamId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($194fb1487b7b3012$var$OpsgenieTeamContainer, null, avatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "xsmall",
        src: avatarUrl
    }), !avatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kFO36))), {
        size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($194fb1487b7b3012$var$NeutralLink, {
        href: teamUrl
    }, name));
};
const $194fb1487b7b3012$export$829de5cf25cd0e9a = ({ opsgenieTeams: opsgenieTeams, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (opsgenieTeams && opsgenieTeams.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.PlaceholderSpacer), null, showPlaceholderIfEmpty ? formatMessage((0, $lyMyT.messages).placeholder) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($194fb1487b7b3012$var$OpsgenieTeamList, null, opsgenieTeams.map(({ id: id, name: name, url: url, avatarUrl: avatarUrl })=>(0, $4R6GH.fg)('enable_fix_code_for_opsgenie_to_jsm_customers') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($194fb1487b7b3012$export$7629e14a1f5315d6, {
            key: id,
            id: id,
            name: name,
            url: url,
            avatarUrl: avatarUrl
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($194fb1487b7b3012$export$72a7ae4a1b14fd60, {
            key: id,
            id: id,
            name: name,
            url: url,
            avatarUrl: avatarUrl
        }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $194fb1487b7b3012$var$OpsgenieTeamList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $194fb1487b7b3012$var$OpsgenieTeamContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _2rko1l7b _1e0c1txw _4cvr1h6o _bfhk1yrq _ca0qv77o _u5f3u2gc _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});
const $194fb1487b7b3012$var$NeutralLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hDzhb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1aqp _30l31aqp",
            __cmplp.className
        ])
    });
});
const $194fb1487b7b3012$var$loadingSpinnerStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'start'
});

});
parcelRegister("2MTnd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5d4cc4e51b61e55$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");

var $cIVSk = parcelRequire("cIVSk");
const $f5d4cc4e51b61e55$var$useGetTeamById = ()=>{
    const request = (0, $5uXOq.useCallback)((ogTeamId)=>(0, $eusud.performGetRequest)((0, $cIVSk.getJSDTeamByIdURL)(ogTeamId)), []);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(request, {
        loading: false
    });
    const memoisedData = (0, $5uXOq.useMemo)(()=>data, [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoisedData,
        fetchTeamInfo: fetch
    };
};
var $f5d4cc4e51b61e55$export$2e2bcd8739ae039 = $f5d4cc4e51b61e55$var$useGetTeamById;

});
parcelRegister("cIVSk", function(module, exports) {

$parcel$export(module.exports, "getJSDTeamByIdURL", () => $ce33c3bff08d7e1c$export$91d5f1626c213f57);
$parcel$export(module.exports, "getJiraOpsTeamUrl", () => $ce33c3bff08d7e1c$export$d9e125f82e12d02f);
const $ce33c3bff08d7e1c$export$91d5f1626c213f57 = (ogTeamId = '')=>`/jsd-escalator/api/teams/${ogTeamId}`;
const $ce33c3bff08d7e1c$export$d9e125f82e12d02f = (platformTeamId = '')=>`/jira/ops/teams/${platformTeamId}`;

});


parcelRegister("lyMyT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2d687da850ac7cad$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2d687da850ac7cad$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "servicedesk-insight-attribute-views.opsgenie-team.placeholder",
        "defaultMessage": "No Opsgenie Team selected"
    },
    errorTitle: {
        "id": "servicedesk-insight-attribute-views.opsgenie-team.error-title",
        "defaultMessage": "Failed to load Opsgenie Team"
    },
    errorMessage: {
        "id": "servicedesk-insight-attribute-views.opsgenie-team.error-message",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});


parcelRegister("1srZ4", function(module, exports) {

$parcel$export(module.exports, "getOpsgenieTeamValuesFromCmdbObjectAttribute", () => $41d289e51042eb79$export$9665db3b7d2d5476);
$parcel$export(module.exports, "getOpsgenieTeamValues", () => $41d289e51042eb79$export$b1f5d590ed42c101);

var $e5pww = parcelRequire("e5pww");
const $41d289e51042eb79$export$9665db3b7d2d5476 = (attribute)=>{
    if (attribute && attribute.type === (0, $e5pww.AttributeTypeMap).OpsgenieTeam) return attribute.objectAttributeValues.map(({ opsgenieTeam: { id: id, name: name, avatarUrl: avatarUrl, url: url } })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl,
            url: url
        }));
    return [];
};
const $41d289e51042eb79$export$b1f5d590ed42c101 = (attribute)=>{
    if (attribute && attribute.type === 'opsgenieTeam') return attribute.opsgenieTeamTypeValues.map(({ opsgenieTeam: { id: id, name: name, avatarUrl: avatarUrl, url: url } })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl,
            url: url
        }));
    return [];
};

});


parcelRegister("7eNFP", function(module, exports) {

$parcel$export(module.exports, "ProjectEditableAttribute", () => $ad30233a8009fc28$export$1b757a496c2b3c20);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $j8mgt = parcelRequire("j8mgt");

var $k2vGH = parcelRequire("k2vGH");

var $9lhJY = parcelRequire("9lhJY");

var $581BZ = parcelRequire("581BZ");

var $iMWSc = parcelRequire("iMWSc");

var $8AFAN = parcelRequire("8AFAN");

var $e08Fw = parcelRequire("e08Fw");
const $ad30233a8009fc28$var$toFieldValue = (projects)=>projects.map(({ id: id })=>id);
const $ad30233a8009fc28$export$a19d77d5e122dda = (props)=>{
    const { attributeType: attributeType, isEditable: isEditable } = props;
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const [value, setValue] = (0, $9lhJY.useProjectValue)(attribute);
    const storedValue = $ad30233a8009fc28$var$toFieldValue((0, $9lhJY.getProjectValues)(attribute));
    const setProjectValue = (0, $5uXOq.useCallback)((projects)=>{
        setValue(projects.filter(({ name: name })=>name != null));
    }, [
        setValue
    ]);
    const resetValue = (0, $5uXOq.useCallback)(()=>setValue((0, $9lhJY.getProjectValues)(attribute)), [
        attribute,
        setValue
    ]);
    const isMultiProjectPicker = attributeType.maximumCardinality !== 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.project-attribute",
        value: $ad30233a8009fc28$var$toFieldValue(value),
        onChange: setProjectValue,
        storedValue: storedValue,
        attributeType: attributeType,
        attributeValuesInfo: {
            type: 'project',
            attributeValues: value
        },
        scalingEnabled: true,
        isEditable: isEditable,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2vGH.ProjectsReadView), {
                projects: value
            })),
        renderEditView: ({ hasValidationError: hasValidationError, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8AFAN.EditViewSpacers).ProjectPicker, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMWSc.ProjectsPicker), {
                defaultMenuIsOpen: true,
                ...fieldProps,
                autoFocus: true,
                value: value,
                isMulti: isMultiProjectPicker,
                validationState: hasValidationError ? 'error' : 'default',
                classNamePrefix: "insight-object-attribute-project-select"
            })),
        onResetValue: resetValue
    });
};
const $ad30233a8009fc28$export$1b757a496c2b3c20 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightEditableProjectAttribute",
        packageName: "jiraServicedeskInsightEditableProjectAttribute",
        teamName: "falcons",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad30233a8009fc28$export$a19d77d5e122dda, props));

});
parcelRegister("k2vGH", function(module, exports) {

$parcel$export(module.exports, "ProjectReadView", () => $80e70ac094a4e35d$export$5c3359f22f4596bc);
$parcel$export(module.exports, "ProjectsReadView", () => $80e70ac094a4e35d$export$3b0257bc8aa1acd0);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $ujWmd = parcelRequire("ujWmd");


var $koVbs = parcelRequire("koVbs");

var $hDzhb = parcelRequire("hDzhb");

var $j8mgt = parcelRequire("j8mgt");

var $a6unS = parcelRequire("a6unS");
const $80e70ac094a4e35d$export$5c3359f22f4596bc = ({ avatarUrl: avatarUrl, displayName: displayName, projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80e70ac094a4e35d$var$ProjectContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "xsmall",
        src: avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80e70ac094a4e35d$var$NeutralLink, {
        href: `/browse/${projectKey}`
    }, displayName));
const $80e70ac094a4e35d$export$3b0257bc8aa1acd0 = ({ projects: projects, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (projects.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.PlaceholderSpacer), null, showPlaceholderIfEmpty ? formatMessage((0, $a6unS.messages).placeholder) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80e70ac094a4e35d$var$ProjectList, null, projects.map(({ id: id, avatarUrl: avatarUrl, name: name, key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80e70ac094a4e35d$export$5c3359f22f4596bc, {
            key: id,
            avatarUrl: avatarUrl,
            displayName: name,
            projectKey: key
        }))));
};
const $80e70ac094a4e35d$var$NeutralLink = /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
(0, $47bDC.default)((0, $hDzhb.default)).withConfig({
    componentId: "yo8gvf-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N800})`,
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N800})`
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $80e70ac094a4e35d$var$ProjectList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $80e70ac094a4e35d$var$ProjectContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _2rko1l7b _1e0c1txw _4cvr1h6o _bfhk1yrq _ca0qv77o _u5f3u2gc _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a6unS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $18c6112db3dd80b3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $18c6112db3dd80b3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "servicedesk-insight-attribute-views.project.placeholder",
        "defaultMessage": "No projects selected"
    }
});

});


parcelRegister("9lhJY", function(module, exports) {

$parcel$export(module.exports, "getProjectValuesFromCmdbObjectAttribute", () => $5bf9087a11eb6873$export$b02ff11409d66b40);
$parcel$export(module.exports, "getProjectValues", () => $5bf9087a11eb6873$export$7b4c1119513c4f04);
$parcel$export(module.exports, "useProjectValue", () => $5bf9087a11eb6873$export$3baa71aec6ee674f);

var $5uXOq = parcelRequire("5uXOq");

var $e5pww = parcelRequire("e5pww");
const $5bf9087a11eb6873$export$b02ff11409d66b40 = (attribute)=>{
    if (attribute && attribute.type === (0, $e5pww.AttributeTypeMap).Project) return attribute.objectAttributeValues.map(({ project: { id: id, name: name, avatarUrl: avatarUrl, key: key } })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl,
            key: key
        }));
    return [];
};
const $5bf9087a11eb6873$export$7b4c1119513c4f04 = (attribute)=>{
    if (attribute && attribute.type === 'project') return attribute.projectTypeValues.map(({ project: { id: id, name: name, avatarUrl: avatarUrl, key: key } })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl,
            key: key
        }));
    return [];
};
const $5bf9087a11eb6873$export$3baa71aec6ee674f = (attribute)=>{
    const projects = $5bf9087a11eb6873$export$7b4c1119513c4f04(attribute);
    const [value, setValue] = (0, $5uXOq.useState)(projects);
    (0, $5uXOq.useEffect)(()=>{
        setValue(()=>$5bf9087a11eb6873$export$7b4c1119513c4f04(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};

});

parcelRegister("iMWSc", function(module, exports) {

$parcel$export(module.exports, "ProjectsPicker", () => $c05528367c2a1a6c$export$372e42ffbb6c7264);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $d7FF4 = parcelRequire("d7FF4");
var $bChGW = parcelRequire("bChGW");

var $pa9q9 = parcelRequire("pa9q9");

var $f3O7j = parcelRequire("f3O7j");

var $kBHEO = parcelRequire("kBHEO");

var $b1prd = parcelRequire("b1prd");

var $3OXOY = parcelRequire("3OXOY");
const $c05528367c2a1a6c$export$372e42ffbb6c7264 = (props)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [{ error: error }, { searchProjects: searchProjects }] = (0, $kBHEO.useProjectsSearch)();
    (0, $5uXOq.useEffect)(()=>{
        if (error) showFlag({
            type: 'error',
            title: (0, $b1prd.default).errorFlagTitle,
            description: (0, $b1prd.default).errorFlagDescription
        });
    }, [
        error,
        showFlag
    ]);
    const loadOptions = (0, $5uXOq.useCallback)(async (query, cb)=>{
        searchProjects(query).then((detailedProjects)=>{
            const results = detailedProjects?.map(({ id: id, name: name, avatarUrls: avatarUrls, key: key })=>({
                    id: id,
                    name: name,
                    avatarUrl: avatarUrls['48x48'],
                    key: key
                })) ?? [];
            /**
				 * using promises in current version of async select is buggy
				 * therefore following react-select's approach
				 * {@link https://react-select.com/async}
				 */ cb(results);
        });
    }, [
        searchProjects
    ]);
    const debouncedLoadOptions = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(loadOptions, 300), [
        loadOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        classNamePrefix: "cmdb-project-picker",
        ...props,
        ...(0, $f3O7j.selectInAModalStyleFixProps),
        defaultOptions: true,
        isClearable: props.isClearable,
        controlShouldRenderValue: props.shouldInputRenderValue,
        isMulti: props.isMulti,
        loadOptions: debouncedLoadOptions,
        getOptionLabel: (projectOption)=>projectOption.name,
        getOptionValue: (projectOption)=>projectOption.id,
        value: props.value,
        validationState: props.validationState,
        onChange: (projectOptions)=>{
            // project options can be null when clearing a value/s from the project picker
            if (projectOptions == null) props.onChange([]);
            else {
                const selectedOptions = Array.isArray(projectOptions) ? projectOptions : [
                    projectOptions
                ];
                props.onChange(selectedOptions);
            }
        },
        components: {
            Option: (componentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, componentProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OXOY.SingleProjectOption), {
                    value: componentProps.data
                })),
            SingleValue: (componentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, componentProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OXOY.SingleProjectOption), {
                    value: componentProps.data
                })),
            MultiValue: (componentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MultiValue, componentProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OXOY.MultiProjectOption), {
                    value: componentProps.data
                }))
        }
    });
};
$c05528367c2a1a6c$export$372e42ffbb6c7264.defaultProps = {
    isMulti: true,
    validationState: 'default',
    autoFocus: false,
    shouldInputRenderValue: true,
    isClearable: true
};

});
parcelRegister("kBHEO", function(module, exports) {

$parcel$export(module.exports, "useProjectsSearch", () => $682ef7ebe6064684$export$8a15c67f23a68c31);

var $ebyGx = parcelRequire("ebyGx");

var $2NMNM = parcelRequire("2NMNM");

var $ld2hZ = parcelRequire("ld2hZ");

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

const $682ef7ebe6064684$export$bfd283b1e58f27c1 = (query, orderBy = 'NAME', startAt = '0')=>{
    const qs = {
        query: query,
        orderBy: orderBy,
        startAt: startAt,
        maxResults: (0, $e80b907421063ab8$export$7cedfe24511e36f6)
    };
    return `/rest/api/3/project/search?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(qs)}`;
};
const $682ef7ebe6064684$export$8a15c67f23a68c31 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const searchProjects = async (query)=>{
        try {
            const projects = await (0, $4VpwK.performCmdbGetRequest)($682ef7ebe6064684$export$bfd283b1e58f27c1(query));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'insightSearchProjects succeeded');
            return projects.values;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'insightSearchProjects',
                    teamName: 'falcons',
                    packageName: 'jiraServicedeskInsightProjectsPicker'
                }
            });
            throw error;
        }
    };
    const { data: data, loading: loading, error: error, fetch: fetch } = (0, $ld2hZ.useService)(searchProjects);
    return [
        {
            data: data,
            loading: loading,
            error: error
        },
        {
            searchProjects: fetch
        }
    ];
};

});
const $e80b907421063ab8$export$7cedfe24511e36f6 = '5';


parcelRegister("b1prd", function(module, exports) {

$parcel$export(module.exports, "default", () => $127a30d62810accf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $127a30d62810accf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "servicedesk-insight-projects-picker.error-flag-title",
        "defaultMessage": "We couldn\u2019t load your projects"
    },
    errorFlagDescription: {
        "id": "servicedesk-insight-projects-picker.error-flag-description",
        "defaultMessage": "Please check your network and try again"
    }
});

});

parcelRegister("3OXOY", function(module, exports) {

$parcel$export(module.exports, "SingleProjectOption", () => $5a5912ee635965d2$export$ac73154d500fa800);
$parcel$export(module.exports, "MultiProjectOption", () => $5a5912ee635965d2$export$25f6988cabb076d6);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");
const $5a5912ee635965d2$export$ac73154d500fa800 = ({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a5912ee635965d2$var$SingleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: value.avatarUrl,
        size: "small",
        appearance: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, value.name));
const $5a5912ee635965d2$export$25f6988cabb076d6 = ({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a5912ee635965d2$var$MultiWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: value.avatarUrl,
        size: "xsmall",
        appearance: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, value.name));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5a5912ee635965d2$var$SingleWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $5a5912ee635965d2$var$MultiWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});



parcelRegister("ee0Zu", function(module, exports) {

$parcel$export(module.exports, "ObjectEditableAttribute", () => $2de77192d41eb949$export$f0fe9f3c113347c5);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $j8mgt = parcelRequire("j8mgt");

var $gd5Xi = parcelRequire("gd5Xi");

var $6CHZP = parcelRequire("6CHZP");

var $f433j = parcelRequire("f433j");

var $2cDaR = parcelRequire("2cDaR");

var $66Vf6 = parcelRequire("66Vf6");

var $581BZ = parcelRequire("581BZ");

var $5Ny9E = parcelRequire("5Ny9E");

var $8AFAN = parcelRequire("8AFAN");

var $e08Fw = parcelRequire("e08Fw");
const $2de77192d41eb949$var$toFieldValue = (values)=>values.map(({ value: objectKey })=>objectKey);
const $2de77192d41eb949$var$getObjectProperties = (objectDetails)=>{
    const { editableAttributeTypes: editableAttributeTypes, attributes: attributes = [], objectType: objectType, hasAvatar: hasAvatar } = objectDetails ?? {};
    if (editableAttributeTypes) {
        const attributesMap = attributes.reduce((accumulator, attribute)=>Object.assign(accumulator, {
                [String(attribute.objectTypeAttributeId)]: attribute
            }), {});
        const attributesPayload = editableAttributeTypes.map(({ id: id })=>({
                objectTypeAttributeId: id,
                objectAttributeValues: (0, $2cDaR.getAttributeValuesPayload)(attributesMap?.[id])
            }));
        const keyAttribute = attributes.find((attribute)=>attribute.objectTypeAttribute.name === 'Key');
        if (keyAttribute) attributesPayload.push({
            objectTypeAttributeId: keyAttribute.objectTypeAttributeId,
            objectAttributeValues: (0, $2cDaR.getAttributeValuesPayload)(keyAttribute)
        });
        return {
            objectTypeId: (0, $5Ny9E.toCmdbObjectTypeId)(objectType?.id ?? ''),
            attributes: attributesPayload,
            hasAvatar: hasAvatar ?? false,
            avatarUUID: ''
        };
    }
    return undefined;
};
const $2de77192d41eb949$var$ObjectAttribute = ({ attributeType: attributeType, isEditable: isEditable, quickCreateObjects: quickCreateObjects = false })=>{
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const [referencedObjects, setReferencedObjects] = (0, $f433j.useReferencedObjects)(attribute);
    const [objectDetails] = (0, $66Vf6.useObjectDetails)();
    const objectProperties = (0, $5uXOq.useMemo)(()=>$2de77192d41eb949$var$getObjectProperties(objectDetails), [
        objectDetails
    ]);
    const isMultiObjectPicker = attributeType.maximumCardinality !== 1;
    const storedValue = $2de77192d41eb949$var$toFieldValue((0, $f433j.getObjectReferenceOptions)(attribute));
    const onValueChange = (0, $5uXOq.useCallback)((values)=>{
        setReferencedObjects(values);
    }, [
        setReferencedObjects
    ]);
    const resetValue = (0, $5uXOq.useCallback)(()=>{
        setReferencedObjects((0, $f433j.getObjectReferenceOptions)(attribute));
    }, [
        attribute,
        setReferencedObjects
    ]);
    const removedOptions = (0, $f433j.getObjectReferenceOptions)(attribute).filter((val)=>!$2de77192d41eb949$var$toFieldValue(referencedObjects).includes(val.objectKey));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.referenced-object-attribute",
        // Add a key to force a remount when attribute changes because when creating a new object
        // the objectKey value changes after update (CREATE: to XXX-XXXX) and because defaultValue
        // only specifies the value when the input is initially created
        key: $2de77192d41eb949$var$toFieldValue((0, $f433j.getObjectReferenceOptions)(attribute)).join('_'),
        value: $2de77192d41eb949$var$toFieldValue(referencedObjects),
        onChange: onValueChange,
        storedValue: storedValue,
        isEditable: isEditable,
        attributeValuesInfo: {
            type: 'object',
            attributeValues: referencedObjects
        },
        scalingEnabled: true,
        attributeType: attributeType,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gd5Xi.ReferencedObjectsReadView), {
                referencedObjects: referencedObjects.map((object)=>({
                        id: object.id,
                        objectKey: object.objectKey,
                        avatar: object.avatar,
                        label: object.label,
                        forceMaxWidth: false
                    }))
            })),
        renderEditView: ({ hasValidationError: hasValidationError, onChange: onChange, shouldInputRenderValue: shouldInputRenderValue, isClearable: isClearable })=>objectProperties ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8AFAN.EditViewSpacers).ReferencedObjectPicker, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6CHZP.ReferencedObjectPicker), {
                isClearable: isClearable,
                shouldInputRenderValue: shouldInputRenderValue,
                autoFocus: true,
                menuIsOpen: true,
                objectProperties: objectProperties,
                value: referencedObjects,
                isMultiSelect: isMultiObjectPicker,
                validationState: hasValidationError ? 'error' : 'default',
                attributeType: attributeType,
                onChange: onChange,
                removedOptions: !shouldInputRenderValue ? removedOptions : [],
                quickCreateObjects: quickCreateObjects
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        onResetValue: resetValue
    });
};
const $2de77192d41eb949$export$f0fe9f3c113347c5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightEditableObjectAttribute",
        packageName: "jiraServicedeskInsightEditableObjectAttribute",
        teamName: "falcons",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2de77192d41eb949$var$ObjectAttribute, props));

});
parcelRegister("gd5Xi", function(module, exports) {

$parcel$export(module.exports, "ReferencedObjectCreateView", () => $8ca12b6e5f53dda8$export$ea78f3bd97835b9f);
$parcel$export(module.exports, "ReferencedObjectReadView", () => $8ca12b6e5f53dda8$export$ae3e6ca9eba42ca);
$parcel$export(module.exports, "ReferencedObjectsReadView", () => $8ca12b6e5f53dda8$export$a03416ddf396563c);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");


var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $djSMm = parcelRequire("djSMm");

var $bUUmN = parcelRequire("bUUmN");

var $blEB6 = parcelRequire("blEB6");

var $hDzhb = parcelRequire("hDzhb");

var $7hDf3 = parcelRequire("7hDf3");

var $j8mgt = parcelRequire("j8mgt");
const $8ca12b6e5f53dda8$var$TooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $8ca12b6e5f53dda8$export$25bd2ea9110ffe38 = ({ label: label, avatar: avatar, icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUUmN.UnstyledInsightIcon), {
        iconUrl: (0, $djSMm.getUniqueIconUrl)(icon),
        size: "xsmall",
        label: label
    }), avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUUmN.UnstyledInsightIcon), {
        mediaClientConfig: avatar.mediaClientConfig,
        iconUrl: avatar.url48,
        size: "xsmall",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        tag: $8ca12b6e5f53dda8$var$TooltipTag,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$ReferencedObjectLabel, null, label)));
const $8ca12b6e5f53dda8$export$ea78f3bd97835b9f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$PlainText, {
        forceMaxWidth: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$export$25bd2ea9110ffe38, {
        label: props.label,
        icon: props.icon
    }));
const $8ca12b6e5f53dda8$var$DEFAULT_APPEARANCE = 'card';
const $8ca12b6e5f53dda8$export$ae3e6ca9eba42ca = ({ appearance: appearance = $8ca12b6e5f53dda8$var$DEFAULT_APPEARANCE, includeLink: includeLink = true, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), forceMaxWidth: forceMaxWidth = true, ...referencedObject })=>{
    const { id: id, label: label, avatar: avatar } = referencedObject;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$export$25bd2ea9110ffe38, {
        label: label,
        avatar: avatar
    });
    if (appearance === 'card') return includeLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$LozengeLink, {
        to: (0, $blEB6.createObjectDetailUrl)(id),
        onClick: onClick,
        forceMaxWidth: forceMaxWidth
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$LozengeText, {
        forceMaxWidth: forceMaxWidth
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$PlainText, {
        forceMaxWidth: forceMaxWidth
    }, content);
};
const $8ca12b6e5f53dda8$export$a03416ddf396563c = ({ referencedObjects: referencedObjects, appearance: appearance = $8ca12b6e5f53dda8$var$DEFAULT_APPEARANCE, includeLink: includeLink = true, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasValues = referencedObjects.length > 0;
    const placeholderText = showPlaceholderIfEmpty ? formatMessage((0, $7hDf3.default).placeholderNoneSelected) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: !hasValues
    }, hasValues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$var$ReferencedObjectsContainer, null, referencedObjects.map((referencedObject)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ca12b6e5f53dda8$export$ae3e6ca9eba42ca // This needs to be ID because when creating a new object the key is a blank string breaking the map
        , {
            key: referencedObject.id,
            ...referencedObject,
            includeLink: includeLink,
            appearance: appearance
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.PlaceholderSpacer), null, placeholderText));
};
const $8ca12b6e5f53dda8$var$ReferencedObjectsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _1n261g80 _p12f1osq",
            __cmplp.className
        ])
    });
});
const $8ca12b6e5f53dda8$var$ellipsesTruncation = /*#__PURE__*/ (0, $47bDC.css)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $8ca12b6e5f53dda8$var$maxWidth = /*#__PURE__*/ (0, $47bDC.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $gwIPs.gridSize) * 19}px`
});
const $8ca12b6e5f53dda8$var$lozengeStyles = /*#__PURE__*/ (0, $47bDC.css)({
    display: 'inline-flex',
    alignItems: 'center',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-surface-raised, ${(0, $829f609a65d26a98$exports).N0})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $gwIPs.borderRadius)}px`,
    marginRight: "var(--ds-space-050, 4px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.forceMaxWidth ? $8ca12b6e5f53dda8$var$maxWidth : null, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$8ca12b6e5f53dda8$var$ellipsesTruncation, {
    boxShadow: "var(--ds-shadow-raised, 0 1px 1px rgba(9,30,66,0.25),0 0 1px 1px rgba(9,30,66,0.13))"
}); // FIXME: type error passing result of `css` to `styled`
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ca12b6e5f53dda8$var$LozengeText = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "gcmv2o-0"
})`${$8ca12b6e5f53dda8$var$lozengeStyles};`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ca12b6e5f53dda8$var$ReferencedObjectLabel = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "gcmv2o-1"
})({
    marginLeft: "var(--ds-space-050, 4px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$8ca12b6e5f53dda8$var$ellipsesTruncation); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ca12b6e5f53dda8$var$PlainText = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "gcmv2o-2"
})({
    display: 'flex',
    alignItems: 'center',
    padding: `${"var(--ds-space-025, 2px)"} 0`,
    marginRight: "var(--ds-space-050, 4px)",
    backgroundColor: 'inherit',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.forceMaxWidth ? $8ca12b6e5f53dda8$var$maxWidth : null);
const $8ca12b6e5f53dda8$var$LozengeLink = /*#__PURE__*/ (0, $47bDC.default)((0, $hDzhb.default)).withConfig({
    componentId: "gcmv2o-3"
})`${$8ca12b6e5f53dda8$var$lozengeStyles};&:focus,&:hover{background-color:${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$exports).N20})`};color:${`var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`};text-decoration:none;}&:active{background-color:${`var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$exports).N30})`};}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ca12b6e5f53dda8$var$StyledTooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1ul9idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("djSMm", function(module, exports) {

$parcel$export(module.exports, "getUniqueIconUrl", () => $9d0363100cfab431$export$85a1f43e7ff44c3f);

var $xJtdX = parcelRequire("xJtdX");
const $9d0363100cfab431$export$85a1f43e7ff44c3f = (icon, options = {
    size: '48'
})=>{
    const sizeUrl = options.size === '48' ? icon.url48 : icon.url16;
    try {
        const url = new URL(sizeUrl);
        // Give each icon a unique URL by appending the iconId query param
        url.searchParams.append('iconId', icon.id);
        return url.toString();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $xJtdX.fireCmdbErrorAnalytics)({
            error: error,
            meta: {
                id: 'getUniqueIconUrl',
                packageName: 'jiraServicedeskInsightIcon',
                teamName: 'falcons'
            }
        });
        return sizeUrl;
    }
};

});

parcelRegister("bUUmN", function(module, exports) {

$parcel$export(module.exports, "InsightIcon", () => $91b4a14cfc200b23$export$4f72cced31fa9b94);
$parcel$export(module.exports, "MemoizedInsightIcon", () => $91b4a14cfc200b23$export$55641517b59933d7);
$parcel$export(module.exports, "UnstyledInsightIcon", () => $91b4a14cfc200b23$export$30c7947f25987be2);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $vIiRg = parcelRequire("vIiRg");
var $ujWmd = parcelRequire("ujWmd");
var $iDZjq = parcelRequire("iDZjq");

var $kOLg6 = parcelRequire("kOLg6");

var $xJtdX = parcelRequire("xJtdX");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");
const $91b4a14cfc200b23$export$d80733771196ad02 = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.clientId) && Boolean(mediaClientConfig.fileId);
const $91b4a14cfc200b23$var$DefaultIcon = ({ size: size, label: label })=>/*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
        appearance: "square",
        size: size,
        name: label
    });
const $91b4a14cfc200b23$export$a39db5532f57c7c2 = (clientAuth)=>Promise.resolve({
        clientId: clientAuth.clientId,
        token: clientAuth.mediaJwtToken,
        baseUrl: clientAuth.mediaBaseUrl
    });
const $91b4a14cfc200b23$export$3cac96b307c02149 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    if (!mediaClientConfig || $91b4a14cfc200b23$export$d80733771196ad02(mediaClientConfig) === false) {
        if (iconUrl) return /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
            src: iconUrl,
            appearance: "square",
            size: size,
            name: label
        });
        return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    const fileIdentifier = {
        id: mediaClientConfig.fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: (0, $vIiRg.AVATAR_SIZES)[size],
        height: (0, $vIiRg.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ $5uXOq.createElement((0, $kOLg6.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>$91b4a14cfc200b23$export$a39db5532f57c7c2(mediaClientConfig)
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ $5uXOq.createElement((0, $iDZjq.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'falcons'
                }
            });
            return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
        return /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
            src: data.src,
            appearance: "square",
            size: size,
            name: label
        });
    });
};
const $91b4a14cfc200b23$export$c9cbd60c1615f1b8 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    const sizeInPx = (0, $vIiRg.AVATAR_SIZES)[size];
    const renderAvatar = (src)=>/*#__PURE__*/ $5uXOq.createElement("img", {
            loading: "lazy",
            src: src,
            width: sizeInPx,
            height: sizeInPx,
            alt: ""
        });
    if (!mediaClientConfig || $91b4a14cfc200b23$export$d80733771196ad02(mediaClientConfig) === false) {
        if (iconUrl) return renderAvatar(iconUrl);
        return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    const fileIdentifier = {
        id: mediaClientConfig.fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: (0, $vIiRg.AVATAR_SIZES)[size],
        height: (0, $vIiRg.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ $5uXOq.createElement((0, $kOLg6.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>$91b4a14cfc200b23$export$a39db5532f57c7c2(mediaClientConfig)
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ $5uXOq.createElement((0, $iDZjq.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'falcons'
                }
            });
            return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$DefaultIcon, {
            size: size,
            label: label
        });
        return renderAvatar(data.src);
    });
};
const $91b4a14cfc200b23$export$4f72cced31fa9b94 = (0, $cSD7y.componentWithFG)('jsdcloud-14092-lazy-load-img', $91b4a14cfc200b23$export$c9cbd60c1615f1b8, $91b4a14cfc200b23$export$3cac96b307c02149);
const $91b4a14cfc200b23$export$55641517b59933d7 = /*#__PURE__*/ (0, $5uXOq.memo)($91b4a14cfc200b23$export$4f72cced31fa9b94);
const $91b4a14cfc200b23$export$30c7947f25987be2 = (props)=>/*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$var$UnstyledInsightIconWrapper, {
        isFGEnabled: (0, $4R6GH.fg)('jsdcloud-14092-lazy-load-img')
    }, /*#__PURE__*/ $5uXOq.createElement($91b4a14cfc200b23$export$55641517b59933d7, props));
/**
 * The reason for calling !important on display block is to ovveride the inherited
 * CSS from Avatar atlaskit component in order to centre the icon within the reference
 * object container.
 */ // Double check the shadow !
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91b4a14cfc200b23$var$UnstyledInsightIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFGEnabled: isFGEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1i6y _2hwx1i6y _otyr1i6y _18u01i6y _p7r1tcjq _1ugpglyw",
            __cmplp.isFGEnabled && "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iDZjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b6b09c530db49a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $vIiRg = parcelRequire("vIiRg");
function $31b6b09c530db49a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $31b6b09c530db49a$var$skeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $vIiRg.CSS_VAR_AVATAR_BGCOLOR)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    border: `${(0, $vIiRg.BORDER_WIDTH)}px solid transparent`
});
const $31b6b09c530db49a$var$sizeStyles = Object.entries((0, $vIiRg.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`
        })
    };
}, {});
const $31b6b09c530db49a$var$radiusStyles = Object.entries((0, $vIiRg.AVATAR_RADIUS)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderRadius: `${size}px`
        })
    };
}, {});
const $31b6b09c530db49a$var$defaultRadiusStyles = {
    name: "1by8p7f",
    styles: "border-radius:var(--ds-border-radius-circle, 50%)"
};
const $31b6b09c530db49a$var$strongOpacityStyles = {
    name: "19sqbed",
    styles: "opacity:0.3"
};
const $31b6b09c530db49a$var$defaultOpacityStyles = {
    name: "1rz7oiv",
    styles: "opacity:0.15"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $31b6b09c530db49a$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $31b6b09c530db49a$var$skeletonStyles,
            $31b6b09c530db49a$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' ? $31b6b09c530db49a$var$radiusStyles[size ?? 'medium'] : $31b6b09c530db49a$var$defaultRadiusStyles,
            weight === 'strong' ? $31b6b09c530db49a$var$strongOpacityStyles : $31b6b09c530db49a$var$defaultOpacityStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $vIiRg.CSS_VAR_AVATAR_BGCOLOR)]: color ?? 'currentColor'
        }
    });
var $31b6b09c530db49a$export$2e2bcd8739ae039 = $31b6b09c530db49a$var$Skeleton;

});

parcelRegister("kOLg6", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $27dd12b02502711d$export$758a2fef95a29ad0);

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $eYKm8 = parcelRequire("eYKm8");
const $27dd12b02502711d$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f4cXA.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children({
            loading: false,
            error: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYKm8.MediaImageWithMediaClient), props));

});
parcelRegister("eYKm8", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithMediaClient", () => $eecef2c1b93fb3db$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iArlU = parcelRequire("iArlU");

var $10b0h = parcelRequire("10b0h");

var $VSDnB = parcelRequire("VSDnB");
const $eecef2c1b93fb3db$var$copyDivStyles = null;
const $eecef2c1b93fb3db$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $10b0h.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ $5uXOq.createElement($5uXOq.Fragment, null, children({
        loading: status === 'loading',
        error: status === 'error',
        data: status === 'succeeded' ? {
            status: status,
            src: preview?.dataURI
        } : undefined
    }), (0, $VSDnB.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: copyNodeRef,
        className: (0, $bwpsq.default)([
            "_1e0cglyw"
        ])
    }), getSsrScriptProps && /*#__PURE__*/ $5uXOq.createElement("script", getSsrScriptProps()));
};
const $eecef2c1b93fb3db$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $5uXOq.useMemo)(()=>(0, $iArlU.withMediaClient)($eecef2c1b93fb3db$var$MediaImageBase), []);
    return /*#__PURE__*/ $5uXOq.createElement(MediaImageComponent, props);
};

});
parcelRegister("iArlU", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $104af301cec809a6$export$9f7977d4a2561bee);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");
const $104af301cec809a6$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEHh7.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                }))));

});

parcelRegister("10b0h", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $baceb2843b357d39$export$4eaebdef02112fe4);

var $5uXOq = parcelRequire("5uXOq");

var $1Pp1U = parcelRequire("1Pp1U");
var $gFZHi = parcelRequire("gFZHi");

var $93kaw = parcelRequire("93kaw");
var $24tOd = parcelRequire("24tOd");
var $cEHh7 = parcelRequire("cEHh7");

var $8GKRF = parcelRequire("8GKRF");

var $kGpuq = parcelRequire("kGpuq");

var $01sWe = parcelRequire("01sWe");

var $3JWNV = parcelRequire("3JWNV");
var $4n1NZ = parcelRequire("4n1NZ");
var $7xRaJ = parcelRequire("7xRaJ");

var $3JZCV = parcelRequire("3JZCV");
var $jR4hE = parcelRequire("jR4hE");

var $8Kbwv = parcelRequire("8Kbwv");
const $baceb2843b357d39$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const [status, setStatus] = (0, $5uXOq.useState)('loading');
    const [error, setError] = (0, $5uXOq.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $5uXOq.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $5uXOq.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $5uXOq.useState)('not-resolved');
    const ssrReliabilityRef = (0, $5uXOq.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $5uXOq.useMemo)(()=>dimensions ? (0, $8Kbwv.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $8Kbwv.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $jR4hE.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $3JWNV.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $kGpuq.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $5uXOq.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $24tOd.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $1Pp1U.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $5uXOq.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('metadata-fetch', (0, $gFZHi.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $8Kbwv.useCurrentValueRef)(()=>{
        return (0, $3JWNV.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $5uXOq.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $8Kbwv.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $8Kbwv.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $5uXOq.useEffect)(()=>{
        const cachedPreview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $8Kbwv.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $4n1NZ.isSupportedLocalPreview)(mediaType) && (0, $8GKRF.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $3JWNV.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $8Kbwv.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $3JWNV.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $01sWe.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $5uXOq.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $3JWNV.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $3JWNV.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $3JWNV.isLocalPreview)(failedPreview);
        const isRemote = (0, $3JWNV.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $01sWe.ImageLoadError)(failedPreview?.source);
            (0, $7xRaJ.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $5uXOq.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $3JWNV.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $3JWNV.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $3JZCV.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $93kaw.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("93kaw", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $d123d92fa0d5c1a9$export$46fd859414de9d62);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $cEHh7 = parcelRequire("cEHh7");

var $7wsJE = parcelRequire("7wsJE");

var $eaxUQ = parcelRequire("eaxUQ");
function $d123d92fa0d5c1a9$var$useCurrentValueRef(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}
const $d123d92fa0d5c1a9$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const innerRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const registerCopyIntentRef = $d123d92fa0d5c1a9$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $7wsJE.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $7wsJE.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $5uXOq.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $5uXOq.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) (0, $eaxUQ.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $eaxUQ.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("7wsJE", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $9a6af4835a9857e5$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $9a6af4835a9857e5$export$aacb463551da2e8f);

var $1As4I = parcelRequire("1As4I");
const $9a6af4835a9857e5$var$getRequestErrorDetails = (err)=>{
    if ((0, $1As4I.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $9a6af4835a9857e5$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $1As4I.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$9a6af4835a9857e5$var$getRequestErrorDetails(error)
        }
    };
};
const $9a6af4835a9857e5$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("eaxUQ", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $9ea95d3f3a6b1d04$export$f65ca476c09acec0);
const $9ea95d3f3a6b1d04$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("24tOd", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $768d10f5fd62ab89$export$90ff537b0999afb);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");

var $k4CmR = parcelRequire("k4CmR");
function $768d10f5fd62ab89$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const fileState = (0, $k4CmR.useMediaStore)((state)=>state.files[id]);
    (0, $5uXOq.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("k4CmR", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $a907ffa2ecfaf54d$export$8a9cc8c330400af8);

var $6esDR = parcelRequire("6esDR");

var $cEHh7 = parcelRequire("cEHh7");
const $a907ffa2ecfaf54d$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $6esDR.useStore)(store, selector, equals);
function $a907ffa2ecfaf54d$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $a907ffa2ecfaf54d$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("6esDR", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $489a4492a45245b1$export$6ccbb43953eebf8);

var $ee7sp = parcelRequire("ee7sp");

var $5uXOq = parcelRequire("5uXOq");

var $lNQti = parcelRequire("lNQti");
var $489a4492a45245b1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $489a4492a45245b1$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)));
const { useSyncExternalStoreWithSelector: $489a4492a45245b1$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($lNQti)));
let $489a4492a45245b1$var$didWarnAboutEqualityFn = false;
const $489a4492a45245b1$var$identity = (arg)=>arg;
function $489a4492a45245b1$export$6ccbb43953eebf8(api, selector = $489a4492a45245b1$var$identity, equalityFn) {
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$489a4492a45245b1$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $489a4492a45245b1$var$didWarnAboutEqualityFn = true;
    }
    const slice = $489a4492a45245b1$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $489a4492a45245b1$var$useDebugValue(slice);
    return slice;
}
const $489a4492a45245b1$var$createImpl = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $ee7sp.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$489a4492a45245b1$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $489a4492a45245b1$export$185802fd694ee1f5 = (createState)=>createState ? $489a4492a45245b1$var$createImpl(createState) : $489a4492a45245b1$var$createImpl;
var $489a4492a45245b1$export$2e2bcd8739ae039 = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $489a4492a45245b1$export$185802fd694ee1f5(createState);
};

});
parcelRegister("lNQti", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hUiTL"));

});
parcelRegister("hUiTL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d096537a1780f6c5$export$bf730a2d8bf68b42, (v) => $d096537a1780f6c5$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d096537a1780f6c5$export$bf730a2d8bf68b42;
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $goz36 = parcelRequire("goz36");
function $d096537a1780f6c5$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d096537a1780f6c5$var$q = "function" === typeof Object.is ? Object.is : $d096537a1780f6c5$var$p, $d096537a1780f6c5$var$r = $goz36.useSyncExternalStore, $d096537a1780f6c5$var$t = $5uXOq.useRef, $d096537a1780f6c5$var$u = $5uXOq.useEffect, $d096537a1780f6c5$var$v = $5uXOq.useMemo, $d096537a1780f6c5$var$w = $5uXOq.useDebugValue;
$d096537a1780f6c5$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $d096537a1780f6c5$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $d096537a1780f6c5$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($d096537a1780f6c5$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $d096537a1780f6c5$var$r(a, c[0], c[1]);
    $d096537a1780f6c5$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $d096537a1780f6c5$var$w(d);
    return d;
};

});
parcelRegister("goz36", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jcmQl"));

});
parcelRegister("jcmQl", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16, (v) => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dfa0db7ec3fca60b$export$306c0aa65ff9ec16;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $dfa0db7ec3fca60b$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $dfa0db7ec3fca60b$var$k = "function" === typeof Object.is ? Object.is : $dfa0db7ec3fca60b$var$h, $dfa0db7ec3fca60b$var$l = $5uXOq.useState, $dfa0db7ec3fca60b$var$m = $5uXOq.useEffect, $dfa0db7ec3fca60b$var$n = $5uXOq.useLayoutEffect, $dfa0db7ec3fca60b$var$p = $5uXOq.useDebugValue;
function $dfa0db7ec3fca60b$var$q(a, b) {
    var d = b(), f = $dfa0db7ec3fca60b$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $dfa0db7ec3fca60b$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $dfa0db7ec3fca60b$var$m(function() {
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $dfa0db7ec3fca60b$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $dfa0db7ec3fca60b$var$p(d);
    return d;
}
function $dfa0db7ec3fca60b$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$dfa0db7ec3fca60b$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $dfa0db7ec3fca60b$var$t(a, b) {
    return b();
}
var $dfa0db7ec3fca60b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dfa0db7ec3fca60b$var$t : $dfa0db7ec3fca60b$var$q;
$dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = void 0 !== $5uXOq.useSyncExternalStore ? $5uXOq.useSyncExternalStore : $dfa0db7ec3fca60b$var$u;

});







parcelRegister("kGpuq", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $d93d75d54376e990$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $d93d75d54376e990$export$768c370ed0dbaeb3);

var $gFZHi = parcelRequire("gFZHi");

var $01sWe = parcelRequire("01sWe");
const $d93d75d54376e990$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $d93d75d54376e990$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $d93d75d54376e990$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $d93d75d54376e990$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $d93d75d54376e990$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $d93d75d54376e990$export$4af9d71992e89714(error),
        error: $d93d75d54376e990$export$88c61dcad53762da(error),
        errorDetail: $d93d75d54376e990$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $d93d75d54376e990$export$29aa614726672b2e(error)
    };
};
const $d93d75d54376e990$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$d93d75d54376e990$export$74aaf4784c2edb2c(new (0, $01sWe.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("01sWe", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $fcceba16863dd854$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $fcceba16863dd854$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $fcceba16863dd854$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $fcceba16863dd854$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $fcceba16863dd854$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $fcceba16863dd854$export$7156ce7b78b49bd7);
class $fcceba16863dd854$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $fcceba16863dd854$export$2c035820a31723e extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$10ab445310d30114 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$18e89b7e50818288 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $fcceba16863dd854$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $fcceba16863dd854$export$d0a45ab59b4606b extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(source){
        super($fcceba16863dd854$var$getImageLoadPrimaryReason(source));
    }
}
function $fcceba16863dd854$export$553696a6e769784c(err) {
    return err instanceof $fcceba16863dd854$export$96e559194c287cf4;
}
const $fcceba16863dd854$export$b380593ba3516c6f = (err)=>err instanceof $fcceba16863dd854$export$2c035820a31723e;
const $fcceba16863dd854$export$e1d87830b3784f94 = (err)=>err instanceof $fcceba16863dd854$export$10ab445310d30114;
const $fcceba16863dd854$export$443aeb298d35d79d = (err)=>$fcceba16863dd854$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $fcceba16863dd854$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($fcceba16863dd854$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("3JWNV", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $609060e8f7210c63$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $609060e8f7210c63$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $609060e8f7210c63$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $609060e8f7210c63$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $609060e8f7210c63$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $609060e8f7210c63$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $609060e8f7210c63$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $609060e8f7210c63$export$98e935d981c884d);

var $9KG2L = parcelRequire("9KG2L");

var $01sWe = parcelRequire("01sWe");

var $7xRaJ = parcelRequire("7xRaJ");

var $4n1NZ = parcelRequire("4n1NZ");
const $609060e8f7210c63$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $7xRaJ.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $609060e8f7210c63$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $01sWe.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $609060e8f7210c63$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $609060e8f7210c63$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $609060e8f7210c63$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $609060e8f7210c63$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $609060e8f7210c63$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $609060e8f7210c63$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $4n1NZ.getRemotePreview)(mediaClient, id, params, traceContext);
    return $609060e8f7210c63$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $609060e8f7210c63$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $4n1NZ.getLocalPreview)(filePreview);
    return $609060e8f7210c63$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("9KG2L", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $3193ea5c2295e37f$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $3193ea5c2295e37f$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $3193ea5c2295e37f$export$e51a8146182600b8);
const $3193ea5c2295e37f$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $3193ea5c2295e37f$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$3193ea5c2295e37f$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $3193ea5c2295e37f$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $3193ea5c2295e37f$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $3193ea5c2295e37f$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $3193ea5c2295e37f$var$getStringFromParams(params, 'collection'),
        alt: $3193ea5c2295e37f$var$getStringFromParams(params, 'alt'),
        height: $3193ea5c2295e37f$var$getNumberFromParams(params, 'height'),
        width: $3193ea5c2295e37f$var$getNumberFromParams(params, 'width'),
        size: $3193ea5c2295e37f$var$getNumberFromParams(params, 'size'),
        name: $3193ea5c2295e37f$var$getStringFromParams(params, 'name'),
        mimeType: $3193ea5c2295e37f$var$getStringFromParams(params, 'mimeType')
    };
};
const $3193ea5c2295e37f$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $3193ea5c2295e37f$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$3193ea5c2295e37f$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $3193ea5c2295e37f$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("7xRaJ", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $abbc266dbfedc514$export$b7e8ee3f7a41459);

var $aAIop = parcelRequire("aAIop");
const $abbc266dbfedc514$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $abbc266dbfedc514$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $abbc266dbfedc514$export$b7e8ee3f7a41459 = new $abbc266dbfedc514$export$7b50526c091bb915((0, $aAIop.createObjectURLCache)());

});
parcelRegister("aAIop", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $0cfc22aea6c15367$export$ba71be67d5c32535);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $0cfc22aea6c15367$export$36d0f9859761643d = 50;
class $0cfc22aea6c15367$var$ExtendedLRUCache extends (0, $iwKVT.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $0cfc22aea6c15367$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $0cfc22aea6c15367$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $0cfc22aea6c15367$export$ba71be67d5c32535 = ()=>new $0cfc22aea6c15367$export$75d1c8c9ba1d0773($0cfc22aea6c15367$export$36d0f9859761643d);

});


parcelRegister("4n1NZ", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3b75ec6170865ae7$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3b75ec6170865ae7$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3b75ec6170865ae7$export$bfe20bd01db02b3);

var $jzW7G = parcelRequire("jzW7G");

var $48aIR = parcelRequire("48aIR");

var $01sWe = parcelRequire("01sWe");

var $Nl5sY = parcelRequire("Nl5sY");
const $3b75ec6170865ae7$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3b75ec6170865ae7$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $48aIR.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $Nl5sY.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $jzW7G.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3b75ec6170865ae7$var$getImageLocalPreview(value);
            case 'video':
                return $3b75ec6170865ae7$var$getVideoLocalPreview(value);
            default:
                throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
};
const $3b75ec6170865ae7$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $01sWe.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("48aIR", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $93f6c931eebc2be3$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $93f6c931eebc2be3$export$67689507e8404821);

var $k9Ch0 = parcelRequire("k9Ch0");

var $5m9mt = parcelRequire("5m9mt");

var $1xbJn = parcelRequire("1xbJn");

var $hNjKA = parcelRequire("hNjKA");
const { Orientation: $93f6c931eebc2be3$var$Orientation, XResolution: $93f6c931eebc2be3$var$XResolution } = (0, $k9Ch0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $93f6c931eebc2be3$var$DPI_WEB_BASELINE = 72;
async function $93f6c931eebc2be3$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $93f6c931eebc2be3$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $93f6c931eebc2be3$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $93f6c931eebc2be3$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
        else return $93f6c931eebc2be3$export$268f92356524130b(tags, $93f6c931eebc2be3$var$XResolution, $93f6c931eebc2be3$var$DPI_WEB_BASELINE) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $93f6c931eebc2be3$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$93f6c931eebc2be3$var$Orientation]) {
        const tagValue = tags[$93f6c931eebc2be3$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $k9Ch0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $93f6c931eebc2be3$export$67689507e8404821(file) {
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    return $93f6c931eebc2be3$var$getOrientationFromTags(tags);
}
function $93f6c931eebc2be3$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $93f6c931eebc2be3$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $1xbJn.loadImage)(src);
        const { width: width, height: height } = (0, $1xbJn.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("k9Ch0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $8ba626f637ae3df3$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $8ba626f637ae3df3$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $8ba626f637ae3df3$export$f6ea0c89fd7d156);
var $8ba626f637ae3df3$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $8ba626f637ae3df3$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $8ba626f637ae3df3$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("5m9mt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $6da5c9a89db4de84$export$41982b5c7acb23c4);

var $k9Ch0 = parcelRequire("k9Ch0");

var $jkveD = parcelRequire("jkveD");

var $kINoG = parcelRequire("kINoG");

var $2edT6 = parcelRequire("2edT6");
async function $6da5c9a89db4de84$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $k9Ch0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $kINoG.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $2edT6.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $k9Ch0.ImageType).JPEG) return await (0, $jkveD.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("jkveD", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $537aa8dc852a8555$export$556b2ccec62d7f2a);

var $k9Ch0 = parcelRequire("k9Ch0");
const { XResolution: $537aa8dc852a8555$var$XResolution, YResolution: $537aa8dc852a8555$var$YResolution } = (0, $k9Ch0.SupportedImageMetaTag);
let $537aa8dc852a8555$var$loadImage;

function $537aa8dc852a8555$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$537aa8dc852a8555$var$loadImage) {
            const module = await (parcelRequire("8iz07"));
            $537aa8dc852a8555$var$loadImage = module.default || module;
        }
        $537aa8dc852a8555$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $537aa8dc852a8555$var$XResolution || key === $537aa8dc852a8555$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("8iz07", function(module, exports) {

let $60ab27a2818ad2da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60ab27a2818ad2da$var$load("7lJbN").then(()=>parcelRequire('8aLn9'));

});


parcelRegister("kINoG", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $013315ab2d0cc3cf$export$5fb37736440fca6f);

var $1xbJn = parcelRequire("1xbJn");
let $013315ab2d0cc3cf$var$pngChunksExtract;

async function $013315ab2d0cc3cf$export$5fb37736440fca6f(file) {
    if (!$013315ab2d0cc3cf$var$pngChunksExtract) {
        const module = await (parcelRequire("8u6C4"));
        $013315ab2d0cc3cf$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $1xbJn.fileToArrayBuffer)(file);
    const chunks = $013315ab2d0cc3cf$var$pngChunksExtract(buffer);
    return await $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks);
}
async function $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("1xbJn", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $3c9a3ebb8ee397f0$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $3c9a3ebb8ee397f0$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $3c9a3ebb8ee397f0$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $3c9a3ebb8ee397f0$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $3c9a3ebb8ee397f0$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $3c9a3ebb8ee397f0$export$61a1de0822e2820);

var $2tm8x = parcelRequire("2tm8x");

var $RiK2l = parcelRequire("RiK2l");

var $cHwqN = parcelRequire("cHwqN");

var $2sfBf = parcelRequire("2sfBf");

var $iABw2 = parcelRequire("iABw2");

var $7hpMa = parcelRequire("7hpMa");

var $dGYEZ = parcelRequire("dGYEZ");

var $iBOon = parcelRequire("iBOon");

var $jdlqN = parcelRequire("jdlqN");

var $c70Lr = parcelRequire("c70Lr");

var $2osAJ = parcelRequire("2osAJ");

var $7zjHG = parcelRequire("7zjHG");

var $8SPcB = parcelRequire("8SPcB");

var $es8mD = parcelRequire("es8mD");

var $gYsK7 = parcelRequire("gYsK7");

var $8RqHP = parcelRequire("8RqHP");
function $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $3c9a3ebb8ee397f0$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $3c9a3ebb8ee397f0$export$849633012686f7ee(file)
    };
}
async function $3c9a3ebb8ee397f0$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $3c9a3ebb8ee397f0$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $3c9a3ebb8ee397f0$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $3c9a3ebb8ee397f0$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $3c9a3ebb8ee397f0$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tm8x)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2osAJ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c70Lr)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBOon)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2sfBf)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($es8mD)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHwqN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($RiK2l)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8SPcB)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7zjHG)))
    }
];
function $3c9a3ebb8ee397f0$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $3c9a3ebb8ee397f0$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $8RqHP.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gYsK7)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iABw2)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7hpMa)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dGYEZ)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("2tm8x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ccf7616b127308b$var$_react = $1ccf7616b127308b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1ccf7616b127308b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ccf7616b127308b$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $1ccf7616b127308b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1ccf7616b127308b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $1ccf7616b127308b$var$_default = module.exports.default = $1ccf7616b127308b$var$PdfDocument24Icon;

});

parcelRegister("RiK2l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0a037d07967bfa4f$var$_react = $0a037d07967bfa4f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $0a037d07967bfa4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0a037d07967bfa4f$var$Gif24Icon = (props)=>/*#__PURE__*/ $0a037d07967bfa4f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$0a037d07967bfa4f$var$Gif24Icon.displayName = 'Gif24Icon';
var $0a037d07967bfa4f$var$_default = module.exports.default = $0a037d07967bfa4f$var$Gif24Icon;

});

parcelRegister("cHwqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $93f2a85309224bbe$var$_react = $93f2a85309224bbe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $93f2a85309224bbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93f2a85309224bbe$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $93f2a85309224bbe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$93f2a85309224bbe$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $93f2a85309224bbe$var$_default = module.exports.default = $93f2a85309224bbe$var$PowerpointPresentation24Icon;

});

parcelRegister("2sfBf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c9a4c12d2fc4227$var$_react = $1c9a4c12d2fc4227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1c9a4c12d2fc4227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1c9a4c12d2fc4227$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $1c9a4c12d2fc4227$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c9a4c12d2fc4227$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $1c9a4c12d2fc4227$var$_default = module.exports.default = $1c9a4c12d2fc4227$var$WordDocument24Icon;

});

parcelRegister("iABw2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d888b0a1557aa645$var$_react = $d888b0a1557aa645$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d888b0a1557aa645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d888b0a1557aa645$var$Sketch24Icon = (props)=>/*#__PURE__*/ $d888b0a1557aa645$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d888b0a1557aa645$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $d888b0a1557aa645$var$_default = module.exports.default = $d888b0a1557aa645$var$Sketch24Icon;

});

parcelRegister("7hpMa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $54ce1d7bd56eb231$var$_react = $54ce1d7bd56eb231$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $54ce1d7bd56eb231$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $54ce1d7bd56eb231$var$Figma24Icon = (props)=>/*#__PURE__*/ $54ce1d7bd56eb231$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$54ce1d7bd56eb231$var$Figma24Icon.displayName = 'Figma24Icon';
var $54ce1d7bd56eb231$var$_default = module.exports.default = $54ce1d7bd56eb231$var$Figma24Icon;

});

parcelRegister("dGYEZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9f7e406d5bea49df$var$_react = $9f7e406d5bea49df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9f7e406d5bea49df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f7e406d5bea49df$var$Executable24Icon = (props)=>/*#__PURE__*/ $9f7e406d5bea49df$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9f7e406d5bea49df$var$Executable24Icon.displayName = 'Executable24Icon';
var $9f7e406d5bea49df$var$_default = module.exports.default = $9f7e406d5bea49df$var$Executable24Icon;

});

parcelRegister("iBOon", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d8c2c58dddf5fcc0$var$_react = $d8c2c58dddf5fcc0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d8c2c58dddf5fcc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d8c2c58dddf5fcc0$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d8c2c58dddf5fcc0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d8c2c58dddf5fcc0$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d8c2c58dddf5fcc0$var$_default = module.exports.default = $d8c2c58dddf5fcc0$var$GoogleDoc24Icon;

});

parcelRegister("jdlqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $dfcfdb061c664b77$var$_react = $dfcfdb061c664b77$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $dfcfdb061c664b77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfcfdb061c664b77$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $dfcfdb061c664b77$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$dfcfdb061c664b77$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $dfcfdb061c664b77$var$_default = module.exports.default = $dfcfdb061c664b77$var$GoogleForm24Icon;

});

parcelRegister("c70Lr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8d16bb363c31083e$var$_react = $8d16bb363c31083e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $8d16bb363c31083e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d16bb363c31083e$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $8d16bb363c31083e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8d16bb363c31083e$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $8d16bb363c31083e$var$_default = module.exports.default = $8d16bb363c31083e$var$GoogleSheet24Icon;

});

parcelRegister("2osAJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1be4005185ae78d9$var$_react = $1be4005185ae78d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1be4005185ae78d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1be4005185ae78d9$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $1be4005185ae78d9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1be4005185ae78d9$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $1be4005185ae78d9$var$_default = module.exports.default = $1be4005185ae78d9$var$GoogleSlide24Icon;

});

parcelRegister("7zjHG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $582b1603b710ea90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $582b1603b710ea90$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;

});

parcelRegister("8SPcB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $677b15938c7d624c$var$_react = $677b15938c7d624c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $677b15938c7d624c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $677b15938c7d624c$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $677b15938c7d624c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$677b15938c7d624c$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $677b15938c7d624c$var$_default = module.exports.default = $677b15938c7d624c$var$Spreadsheet24Icon;

});

parcelRegister("es8mD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a85a2b23143ceb75$var$_react = $a85a2b23143ceb75$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a85a2b23143ceb75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a85a2b23143ceb75$var$Presentation24Icon = (props)=>/*#__PURE__*/ $a85a2b23143ceb75$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a85a2b23143ceb75$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $a85a2b23143ceb75$var$_default = module.exports.default = $a85a2b23143ceb75$var$Presentation24Icon;

});

parcelRegister("gYsK7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c5b88baa981b1084$var$_react = $c5b88baa981b1084$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c5b88baa981b1084$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c5b88baa981b1084$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $c5b88baa981b1084$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c5b88baa981b1084$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $c5b88baa981b1084$var$_default = module.exports.default = $c5b88baa981b1084$var$SourceCode24Icon;

});

parcelRegister("8RqHP", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $60b93921782d6d1e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $60b93921782d6d1e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $60b93921782d6d1e$export$ba4368c844580f9e);
function $60b93921782d6d1e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $60b93921782d6d1e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $60b93921782d6d1e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $60b93921782d6d1e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $60b93921782d6d1e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("8u6C4", function(module, exports) {

let $019819d3d04dcea8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $019819d3d04dcea8$var$load("jODAF").then(()=>parcelRequire('eYIux'));

});


parcelRegister("2edT6", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $1cac606283e05089$export$55c3bc9841b19de2);
function $1cac606283e05089$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("hNjKA", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $81d3fceca65be0fc$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $81d3fceca65be0fc$export$43142f95b8de7a91);
const $81d3fceca65be0fc$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $81d3fceca65be0fc$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $81d3fceca65be0fc$export$43142f95b8de7a91 = (orientation)=>{
    return $81d3fceca65be0fc$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("Nl5sY", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $33ec34d1173165de$export$4269d30173168e5c);
const $33ec34d1173165de$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("3JZCV", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $293d53ca8ea6912a$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $293d53ca8ea6912a$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $293d53ca8ea6912a$export$de7c49925e44d75d);

var $1QRxp = parcelRequire("1QRxp");
const $293d53ca8ea6912a$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $293d53ca8ea6912a$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $293d53ca8ea6912a$var$dashed = (param)=>param ? `-${param}` : '';
const $293d53ca8ea6912a$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$293d53ca8ea6912a$var$dashed(collectionName)}${$293d53ca8ea6912a$var$dashed(occurrenceKey)}`;
const $293d53ca8ea6912a$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $293d53ca8ea6912a$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $1QRxp.printFunctionCall)($293d53ca8ea6912a$export$4310981e0aa4ce67, $293d53ca8ea6912a$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $1QRxp.printScript)([
        $293d53ca8ea6912a$export$ede93d4564eaa8da.toString(),
        $293d53ca8ea6912a$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $293d53ca8ea6912a$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $293d53ca8ea6912a$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("1QRxp", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $56ce1649d25a132b$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $56ce1649d25a132b$export$8b902fb69a2f17c1);
const $56ce1649d25a132b$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $56ce1649d25a132b$var$printParams = (args)=>args.map((arg)=>$56ce1649d25a132b$var$printParam(arg)).join(',');
const $56ce1649d25a132b$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$56ce1649d25a132b$var$printParams(args)});`;
const $56ce1649d25a132b$export$8b902fb69a2f17c1 = (statements)=>`(function(){
  ${statements.join(';')}
})();
`;

});


parcelRegister("jR4hE", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $815e3e27cebcb154$export$d3a890b0f7844b6f);

var $3JZCV = parcelRequire("3JZCV");
const $815e3e27cebcb154$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $3JZCV.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $3JZCV.getKey)(identifier)];
};

});

parcelRegister("8Kbwv", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $7b6d905fc3b6f0e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $7b6d905fc3b6f0e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db);

var $5uXOq = parcelRequire("5uXOq");
const $7b6d905fc3b6f0e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $7b6d905fc3b6f0e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $7b6d905fc3b6f0e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $7b6d905fc3b6f0e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}

});






parcelRegister("6CHZP", function(module, exports) {

$parcel$export(module.exports, "ReferencedObjectPicker", () => $4ee9ac5466eb9702$export$4c0c1eba5a1b0f52);

var $5uXOq = parcelRequire("5uXOq");

var $laWvb = parcelRequire("laWvb");

var $7Jxgt = parcelRequire("7Jxgt");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $1ZftP = parcelRequire("1ZftP");
var $d7FF4 = parcelRequire("d7FF4");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $gd5Xi = parcelRequire("gd5Xi");

var $5Ny9E = parcelRequire("5Ny9E");

var $f3O7j = parcelRequire("f3O7j");

var $51LLF = parcelRequire("51LLF");

var $gF8ay = parcelRequire("gF8ay");

var $esHev = parcelRequire("esHev");
const $4ee9ac5466eb9702$var$MAX_HEIGHT_MENU = 400;
const $4ee9ac5466eb9702$var$REMOVE_ACTION_META_TYPES = [
    'clear',
    'remove-value',
    'pop-value'
];
const $4ee9ac5466eb9702$export$4c0c1eba5a1b0f52 = ({ isMultiSelect: isMultiSelect, validationState: validationState = 'default', attributeType: attributeType, value: value, onChange: onChange, autoFocus: autoFocus = false, menuIsOpen: menuIsOpen, objectProperties: objectProperties, quickCreateObjects: quickCreateObjects = false, shouldInputRenderValue: shouldInputRenderValue = true, isClearable: isClearable = true, removedOptions: removedOptions = [], isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { loading: loading, data: searchData, error: searchError, fetch: searchReferencedObjects } = (0, $51LLF.useReferencedObjectsSearch)();
    const [defaultOptions, setDefaultOptions] = (0, $esHev.useObjectPickerState)(searchData);
    const selectWrapperRef = (0, $5uXOq.useRef)(null);
    const [closeToBottom, setCloseToBottom] = (0, $5uXOq.useState)(false);
    /*  Infer the menu position for asynchronously loaded options. menuPlacement="auto" doesn't work on initial load of
         options and appears below select causing an issue when the select is at the bottom of the window */ (0, $5uXOq.useEffect)(()=>{
        if (selectWrapperRef.current) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const distance = window.innerHeight - selectWrapperRef.current.getBoundingClientRect().bottom;
            setCloseToBottom(distance < $4ee9ac5466eb9702$var$MAX_HEIGHT_MENU);
        }
    }, [
        menuIsOpen
    ]);
    const loadPickerOptions = (0, $5uXOq.useCallback)(async (query, callback)=>{
        // Due to the way forms subscribe to changes we have to explicitly call getState() when we want the values
        // and can't call it in a parent and pass it down as objectProperties
        const objectPropertiesForSearch = objectProperties instanceof Function ? objectProperties() : objectProperties;
        const { avatarUUID: avatarUUID, hasAvatar: hasAvatar, objectTypeId: objectTypeId, attributes: attributes } = objectPropertiesForSearch;
        const result = await searchReferencedObjects({
            objectProperties: {
                attributes: attributes,
                avatarUUID: avatarUUID,
                hasAvatar: hasAvatar,
                objectTypeId: objectTypeId
            },
            attributeType: attributeType,
            query: query
        });
        const fetchedOptions = (0, $esHev.mapOptionsFromData)(result) ?? [];
        const currentOptions = (0, $4R6GH.fg)('ignore-removed-options-on-object-reference-attr') ? [] : // This allows removed options to also be searched as they are not returned from searchReferencedObjects due to objectProperties
        (defaultOptions ?? []).filter((option)=>option.label.toLowerCase().includes(query.toLowerCase()));
        const combinedObjects = (0, $4R6GH.fg)('ignore-removed-options-on-object-reference-attr') ? [
            ...currentOptions,
            ...fetchedOptions,
            ...removedOptions
        ].filter((option)=>option.label.toLowerCase().includes(query.toLowerCase())).sort((a, b)=>a.label.localeCompare(b.label)) : [
            ...currentOptions,
            ...fetchedOptions,
            ...removedOptions
        ].sort((a, b)=>a.label.localeCompare(b.label));
        callback?.(// Remove duplicate objects from list (id should be unique)
        combinedObjects.filter(({ id: id }, index, array)=>array.findIndex((object)=>object.id === id) === index));
    }, [
        objectProperties,
        searchReferencedObjects,
        attributeType,
        defaultOptions,
        removedOptions
    ]);
    const [debouncedLoadOptions] = (0, $laWvb.default)((query, callback)=>loadPickerOptions(query, callback), 400);
    const handleChange = (0, $5uXOq.useCallback)((values, meta)=>{
        const objects = values ?? [];
        onChange(Array.isArray(objects) ? objects : [
            objects
        ]);
        // Add removed option(s) back into the defaultOptions
        if (meta?.action && $4ee9ac5466eb9702$var$REMOVE_ACTION_META_TYPES.includes(meta.action)) {
            let removedValuesArray = [];
            if ((meta.action === 'remove-value' || meta.action === 'pop-value') && meta.removedValue && !Array.isArray(meta.removedValue)) removedValuesArray = [
                meta.removedValue
            ];
            if (meta.action === 'clear' && meta.removedValues && Array.isArray(meta.removedValues)) removedValuesArray = meta.removedValues;
            // Ignore newly created objects
            removedValuesArray = removedValuesArray.filter((removeValue)=>removeValue?.objectKey && removeValue.objectKey !== '');
            if (removedValuesArray.length) setDefaultOptions((prevState)=>{
                if (prevState) // Remove duplicate objects from list (id should be unique) and sort by label
                return [
                    ...prevState,
                    ...removedValuesArray
                ].filter(({ id: id }, index, array)=>array.findIndex((object)=>object.id === id) === index).sort((a, b)=>a.label.localeCompare(b.label));
                return [];
            });
        }
    }, [
        onChange,
        setDefaultOptions
    ]);
    const handleCreateOption = (0, $5uXOq.useCallback)((inputValue)=>{
        const options = defaultOptions ?? [];
        const inMemoryId = (0, $7Jxgt.v4)();
        const newOption = {
            id: (0, $5Ny9E.toCmdbObjectId)(inMemoryId),
            label: inputValue,
            value: `CREATE:${inputValue}`,
            icon: attributeType.referenceObjectType.icon,
            objectKey: ''
        };
        setDefaultOptions([
            ...options,
            newOption
        ].sort((a, b)=>a.label.localeCompare(b.label)));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        handleChange(isMultiSelect ? [
            ...value,
            newOption
        ] : newOption, {
            action: 'create-option'
        });
    }, [
        defaultOptions,
        setDefaultOptions,
        attributeType,
        handleChange,
        isMultiSelect,
        value
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (searchError) showFlag({
            type: 'error',
            title: (0, $gF8ay.messages).errorFlagTitle,
            description: (0, $gF8ay.messages).errorFlagDescription,
            isAutoDismiss: true
        });
    }, [
        searchError,
        showFlag
    ]);
    const AsyncSelectComponent = (0, $5uXOq.useMemo)(()=>quickCreateObjects ? (0, $1ZftP.default) : (0, $d7FF4.default), [
        quickCreateObjects
    ]);
    const formatOptionLabel = (0, $5uXOq.useCallback)(({ __isNew__: __isNew__ = false, ...option }, meta)=>{
        if (__isNew__) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gd5Xi.ReferencedObjectCreateView), {
            label: `${option.value} (${formatMessage((0, $gF8ay.messages).newObjectLabel)})`,
            icon: attributeType.referenceObjectType.icon
        });
        return option.icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gd5Xi.ReferencedObjectCreateView), {
            label: option.label,
            icon: option.icon
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gd5Xi.ReferencedObjectReadView), {
            id: option.id,
            objectKey: option.value,
            label: option.label,
            avatar: option.avatar,
            appearance: "plain",
            includeLink: false,
            // Don't add max-width for options shown in the dropdown.
            // This allows the dropdown to truncate available options
            // based on its own dynamic width.
            forceMaxWidth: isMultiSelect && meta.context !== 'menu'
        });
    }, [
        isMultiSelect,
        formatMessage,
        attributeType.referenceObjectType.icon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: selectWrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AsyncSelectComponent, {
        ...(0, $f3O7j.selectInAModalStyleFixProps),
        isDisabled: isDisabled,
        controlShouldRenderValue: shouldInputRenderValue,
        isClearable: isClearable,
        autoFocus: autoFocus,
        menuIsOpen: menuIsOpen,
        menuPlacement: closeToBottom ? 'top' : 'auto',
        defaultOptions: defaultOptions,
        hideSelectedOptions: true,
        value: value,
        isLoading: loading,
        isMulti: isMultiSelect,
        loadOptions: debouncedLoadOptions,
        formatOptionLabel: formatOptionLabel,
        validationState: validationState,
        onChange: handleChange,
        onCreateOption: handleCreateOption,
        // Need to always fetch incase objectProperties (other fields for the qlQuery) has changed
        onFocus: ()=>loadPickerOptions('', setDefaultOptions),
        components: {
            MultiValueContainer: $4ee9ac5466eb9702$var$MultiValueContainer
        },
        classNamePrefix: "insight-object-attribute-referenced-object-picker"
    }));
};
const $4ee9ac5466eb9702$var$MultiValueContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        xcss: $4ee9ac5466eb9702$var$multiValueContainerStyles
    }, children);
const $4ee9ac5466eb9702$var$multiValueContainerStyles = (0, $8CUq3.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderRadius: 'border.radius',
    marginRight: 'space.050',
    maxWidth: '100%'
});

});
parcelRegister("1ZftP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffe39b95a8bd43db$export$2e2bcd8739ae039);

var $isgat = parcelRequire("isgat");

var $3c98u = parcelRequire("3c98u");
const $ffe39b95a8bd43db$var$AsyncCreatableSelect = (0, $3c98u.default)((0, $isgat.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ffe39b95a8bd43db$export$2e2bcd8739ae039 = $ffe39b95a8bd43db$var$AsyncCreatableSelect;

});
parcelRegister("isgat", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ce0d05b9e97e68$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $iaInK = parcelRequire("iaInK");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $d6ce0d05b9e97e68$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iaInK.default)(props);
    const creatableProps = (0, $9uJ4X.default)(stateManagerProps);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d6ce0d05b9e97e68$export$2e2bcd8739ae039 = $d6ce0d05b9e97e68$var$AsyncCreatableSelect;

});


parcelRegister("51LLF", function(module, exports) {

$parcel$export(module.exports, "useReferencedObjectsSearch", () => $bea39c64ce407a82$export$513793886a687023);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $ld2hZ = parcelRequire("ld2hZ");

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $7T5mH = parcelRequire("7T5mH");

var $7DxXA = parcelRequire("7DxXA");

var $5Ny9E = parcelRequire("5Ny9E");

var $4R6GH = parcelRequire("4R6GH");
const $bea39c64ce407a82$export$513793886a687023 = ()=>{
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const request = (0, $5uXOq.useCallback)(async ({ objectProperties: objectProperties, attributeType: attributeType, query: query })=>{
        if (workspaceId) try {
            // Remove iql when cleaning up assets_object_reference_picker_bug
            const { id: id, iql: iql, qlQuery: qlQuery, includeChildObjectTypes: includeChildObjectTypes, referenceObjectType: referenceObjectType } = attributeType;
            const objectTypeId = (0, $5Ny9E.toCmdbObjectTypeId)(referenceObjectType.id);
            const payload = {
                objectInEntry: objectProperties,
                includeChildren: includeChildObjectTypes,
                selectedAttribute: id,
                query: query,
                ...(0, $4R6GH.fg)('assets_object_reference_picker_bug') ? {
                    qlQuery: qlQuery
                } : {
                    iql: iql
                }
            };
            const response = await (0, $4VpwK.performCmdbPostRequest)((0, $7T5mH.getCmdbObjectTypeByIdObjectsUrl)(workspaceId, objectTypeId), {
                body: JSON.stringify(payload)
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'insightSearchReferencedObjects succeeded');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'insightSearchReferencedObjects',
                    teamName: 'falcons',
                    packageName: 'jiraServicedeskInsightEditableReferencedObjectPicker'
                }
            });
            throw error;
        }
        return undefined;
    }, [
        workspaceId,
        createAnalyticsEvent
    ]);
    return (0, $ld2hZ.useService)(request);
};

});

parcelRegister("gF8ay", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8cda1738fded6f9b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8cda1738fded6f9b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    newObjectLabel: {
        "id": "servicedesk-insight-editable-referenced-object-picker.new-object-label",
        "defaultMessage": "New Object"
    },
    errorFlagTitle: {
        "id": "servicedesk-insight-editable-referenced-object-picker.error-flag-title",
        "defaultMessage": "We couldn't complete the search for your objects"
    },
    errorFlagDescription: {
        "id": "servicedesk-insight-editable-referenced-object-picker.error-flag-description",
        "defaultMessage": "Please refresh and try again"
    }
});

});

parcelRegister("esHev", function(module, exports) {

$parcel$export(module.exports, "mapOptionsFromData", () => $26d93ac04304b878$export$5fa25fde210ff2f4);
$parcel$export(module.exports, "useObjectPickerState", () => $26d93ac04304b878$export$c303b84040f6016a);

var $5uXOq = parcelRequire("5uXOq");

var $5Ny9E = parcelRequire("5Ny9E");
const $26d93ac04304b878$export$5fa25fde210ff2f4 = (response)=>response?.map(({ id: id, objectKey: objectKey, label: label, avatar: avatar })=>({
            id: (0, $5Ny9E.toCmdbObjectId)(id),
            label: label,
            value: objectKey,
            objectKey: objectKey,
            avatar: avatar
        }));
const $26d93ac04304b878$export$c303b84040f6016a = (searchData)=>{
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        if (defaultOptions === undefined) setDefaultOptions(()=>$26d93ac04304b878$export$5fa25fde210ff2f4(searchData));
    }, [
        defaultOptions,
        searchData
    ]);
    return [
        defaultOptions,
        setDefaultOptions
    ];
};

});


parcelRegister("f433j", function(module, exports) {

$parcel$export(module.exports, "getObjectReferenceOptions", () => $a42937d31528b4c0$export$1a06540ad3f2682a);
$parcel$export(module.exports, "getObjectReferenceOptionsFromCmdbObjectAttribute", () => $a42937d31528b4c0$export$9d12516ce595c9f4);
$parcel$export(module.exports, "useReferencedObjects", () => $a42937d31528b4c0$export$19cdd7dd858266);

var $5uXOq = parcelRequire("5uXOq");

var $e5pww = parcelRequire("e5pww");
const $a42937d31528b4c0$export$1a06540ad3f2682a = (attribute)=>{
    if (attribute && attribute.type === 'object') return attribute.objectTypeValues.map(({ referencedObject: { id: id, objectKey: objectKey, label: label, avatar: avatar } })=>({
            id: id,
            value: objectKey,
            label: label,
            avatar: avatar,
            objectKey: objectKey
        }));
    return [];
};
const $a42937d31528b4c0$export$9d12516ce595c9f4 = (attribute)=>{
    if (attribute && attribute.type === (0, $e5pww.AttributeTypeMap).Object) return attribute.objectAttributeValues.map(({ referencedObject: { objectKey: objectKey, label: label, avatar: avatar, objectId: objectId, workspaceId: workspaceId } })=>{
        const obejectOptionAvatar = {
            ...avatar,
            objectId: objectId,
            workspaceId: workspaceId
        };
        return {
            id: objectId,
            value: objectKey,
            label: label,
            avatar: obejectOptionAvatar,
            objectKey: objectKey
        };
    });
    return [];
};
const $a42937d31528b4c0$export$19cdd7dd858266 = (attribute)=>{
    const [value, setValue] = (0, $5uXOq.useState)($a42937d31528b4c0$export$1a06540ad3f2682a(attribute));
    (0, $5uXOq.useEffect)(()=>{
        setValue(()=>$a42937d31528b4c0$export$1a06540ad3f2682a(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};

});

parcelRegister("2cDaR", function(module, exports) {

$parcel$export(module.exports, "getAttributeValuesPayload", () => $96aba7ed1d1c6774$export$aa90a8b2c31899fa);

var $xJtdX = parcelRequire("xJtdX");
const $96aba7ed1d1c6774$var$getTransformedDefault = ({ defaultTypeValues: defaultTypeValues })=>defaultTypeValues.map((val)=>({
            value: val.value ?? null
        }));
const $96aba7ed1d1c6774$var$getTransformedObject = ({ objectTypeValues: objectTypeValues })=>objectTypeValues.map(({ referencedObject: referencedObject })=>({
            value: referencedObject.objectKey ?? null
        }));
const $96aba7ed1d1c6774$var$getTransformedUser = ({ userTypeValues: userTypeValues })=>userTypeValues.map(({ user: user })=>({
            value: user.key ?? null
        }));
const $96aba7ed1d1c6774$var$getTransformedGroup = ({ groupTypeValues: groupTypeValues })=>groupTypeValues.map(({ group: group })=>({
            value: group.name ?? null
        }));
const $96aba7ed1d1c6774$var$getTransformedStatus = ({ statusTypeValues: statusTypeValues })=>statusTypeValues.map(({ status: status })=>({
            value: status.id ?? null
        }));
const $96aba7ed1d1c6774$export$aa90a8b2c31899fa = (attribute)=>{
    if (attribute) {
        if (attribute.type === 'default') return $96aba7ed1d1c6774$var$getTransformedDefault(attribute);
        if (attribute.type === 'object') return $96aba7ed1d1c6774$var$getTransformedObject(attribute);
        if (attribute.type === 'user') return $96aba7ed1d1c6774$var$getTransformedUser(attribute);
        if (attribute.type === 'group') return $96aba7ed1d1c6774$var$getTransformedGroup(attribute);
        if (attribute.type === 'status') return $96aba7ed1d1c6774$var$getTransformedStatus(attribute);
    }
    (0, $xJtdX.fireCmdbErrorAnalytics)({
        meta: {
            id: 'invalid.attribute.type',
            packageName: 'jiraServicedeskInsightObjectDetailsStore'
        }
    });
    return [
        {
            value: null
        }
    ];
};

});


parcelRegister("jjGxH", function(module, exports) {

$parcel$export(module.exports, "SelectEditableAttribute", () => $20dadf2c15a38663$export$2959ce413a51f9d2);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $j8mgt = parcelRequire("j8mgt");

var $amV0U = parcelRequire("amV0U");

var $2QgAn = parcelRequire("2QgAn");

var $581BZ = parcelRequire("581BZ");

var $3yrM4 = parcelRequire("3yrM4");

var $5Ny9E = parcelRequire("5Ny9E");

var $8AFAN = parcelRequire("8AFAN");

var $e08Fw = parcelRequire("e08Fw");
const $20dadf2c15a38663$var$SelectAttribute = (props)=>{
    const { attributeType: attributeType, isEditable: isEditable } = props;
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const [value, setValue] = (0, $2QgAn.useDefaultAttributeArrayValue)(attribute);
    const storedValue = (0, $2QgAn.getDefaultAttributeArrayValue)(attribute);
    const onValueChange = (0, $5uXOq.useCallback)((values)=>{
        setValue(values.map(({ value: updatedValue })=>updatedValue));
    }, [
        setValue
    ]);
    const resetValue = (0, $5uXOq.useCallback)(()=>setValue((0, $2QgAn.getDefaultAttributeArrayValue)(attribute)), [
        attribute,
        setValue
    ]);
    const isMultiSelect = attributeType.maximumCardinality !== 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.select-attribute",
        value: value,
        onChange: onValueChange,
        storedValue: storedValue,
        attributeType: attributeType,
        isEditable: isEditable,
        attributeValuesInfo: {
            type: 'select',
            attributeValues: value
        },
        scalingEnabled: true,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $amV0U.SelectReadView), {
                value: value
            })),
        renderEditView: ({ hasValidationError: hasValidationError, onChange: onChange, isClearable: isClearable, shouldInputRenderValue: shouldInputRenderValue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8AFAN.EditViewSpacers).Select, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3yrM4.SelectAttributeOptionPicker), {
                isClearable: isClearable,
                shouldInputRenderValue: shouldInputRenderValue,
                autoFocus: true,
                menuIsOpen: true,
                objectTypeAttributeId: (0, $5Ny9E.toObjectTypeAttributeId)(attributeType.id),
                isMultiSelect: isMultiSelect,
                defaultSelectedValues: value,
                onChange: onChange,
                validationState: hasValidationError ? 'error' : 'default'
            })),
        onResetValue: resetValue
    });
};
const $20dadf2c15a38663$export$2959ce413a51f9d2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightInlineEditableSelectAttribute",
        packageName: "jiraServicedeskInsightEditableSelectAttribute",
        teamName: "falcons",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20dadf2c15a38663$var$SelectAttribute, props));

});
parcelRegister("amV0U", function(module, exports) {

$parcel$export(module.exports, "SelectReadView", () => $6ce4508fd7b8b79e$export$29081d16772ffc8d);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $d9xxV = parcelRequire("d9xxV");

var $koVbs = parcelRequire("koVbs");

var $7hDf3 = parcelRequire("7hDf3");

var $j8mgt = parcelRequire("j8mgt");
const $6ce4508fd7b8b79e$export$29081d16772ffc8d = ({ value: value, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasValue = value.length > 0;
    const placeholderText = showPlaceholderIfEmpty ? formatMessage((0, $7hDf3.default).placeholderNoneSelected) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: !hasValue
    }, hasValue ? value.map((val)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ce4508fd7b8b79e$var$Wrapper, {
            key: val
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
            text: val
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ce4508fd7b8b79e$var$PlaceholderSpacer, null, placeholderText));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ce4508fd7b8b79e$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0r5cr _2hwx1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ce4508fd7b8b79e$var$PlaceholderSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d9xxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87927dab24395a15$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");
const $87927dab24395a15$var$SimpleTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5oSQr.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aXLIT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $87927dab24395a15$var$SimpleTag = /*#__PURE__*/ (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;

});
parcelRegister("5oSQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35d9df42c66ff0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");

var $2hnSR = parcelRequire("2hnSR");
function $db35d9df42c66ff0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$baseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $e6s40.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $e6s40.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $e6s40.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $e6s40.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $e6s40.cssVar).color.text.default})`,
    cursor: 'default'
});
const $db35d9df42c66ff0$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $e6s40.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $e6s40.defaultMargin),
    position: 'relative',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
    border: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: `var(${(0, $e6s40.cssVar).color.borderColor})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 1px)",
    color: "var(--ds-text, #172B4D)",
    cursor: 'default',
    paddingInline: "var(--ds-space-050, 4px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$interactiveStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $e6s40.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $e6s40.cssVar).color.background.active})`
    }
});
const $db35d9df42c66ff0$var$interactiveStyles = {
    name: "jcdcgl",
    styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$focusRingStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $e6s40.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $db35d9df42c66ff0$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        outline: `2px solid ${$2hnSR.focusRingColors}`,
        outlineOffset: '2px '
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.text.active})`
    }
});
const $db35d9df42c66ff0$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $2hnSR.textColors['standardLink'] : $2hnSR.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $2hnSR.backgroundColors[color] : $2hnSR.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $2hnSR.backgroundColors[color] : $2hnSR.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$baseStyles : $db35d9df42c66ff0$var$baseStylesOld,
            isInteractive && ((0, $VSDnB.fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$focusRingStyles : $db35d9df42c66ff0$var$focusRingStylesOld),
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? isLink && $db35d9df42c66ff0$var$interactiveStyles : undefined,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $db35d9df42c66ff0$var$nonStandardLinkStyles,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isInteractive && $db35d9df42c66ff0$var$interactiveStylesOld
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.borderColor]: $2hnSR.borderColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.default]: $2hnSR.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.hover]: $2hnSR.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.active]: $2hnSR.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.background.default]: $2hnSR.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.focusRing]: $2hnSR.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.removeButton.default]: $2hnSR.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).color.removeButton.hover]: $2hnSR.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $e6s40.cssVar).borderRadius]: $2hnSR.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;

});
parcelRegister("e6s40", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $1dd8b7ac532261be$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $1dd8b7ac532261be$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $1dd8b7ac532261be$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $1dd8b7ac532261be$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $1dd8b7ac532261be$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $1dd8b7ac532261be$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $1dd8b7ac532261be$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $1dd8b7ac532261be$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $1dd8b7ac532261be$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $1dd8b7ac532261be$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $1dd8b7ac532261be$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $k5uoT = parcelRequire("k5uoT");
const $1dd8b7ac532261be$var$gridSizeValue = (0, $k5uoT.gridSize)();
const $1dd8b7ac532261be$var$borderRadiusValue = (0, $k5uoT.borderRadius)();
const $1dd8b7ac532261be$var$tagHeightUnitless = 2.5 * $1dd8b7ac532261be$var$gridSizeValue;
const $1dd8b7ac532261be$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$1dd8b7ac532261be$var$tagHeightUnitless}px`})`;
const $1dd8b7ac532261be$export$c6f3ea2b4cffd0ca = $1dd8b7ac532261be$var$tagHeightUnitless; // button should be square
const $1dd8b7ac532261be$var$maxWidthUnitless = 25 * $1dd8b7ac532261be$var$gridSizeValue;
const $1dd8b7ac532261be$export$2e3bcb01bf928995 = $1dd8b7ac532261be$var$maxWidthUnitless - $1dd8b7ac532261be$var$tagHeightUnitless;
const $1dd8b7ac532261be$export$982d4a1a6de11130 = `${$1dd8b7ac532261be$export$2e3bcb01bf928995}px`;
const $1dd8b7ac532261be$export$35d5d1e251b985cf = `${$1dd8b7ac532261be$var$borderRadiusValue}px`;
const $1dd8b7ac532261be$export$c49771100fee18c8 = `${$1dd8b7ac532261be$export$c6f3ea2b4cffd0ca / 2}px`;
const $1dd8b7ac532261be$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
const $1dd8b7ac532261be$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
const $1dd8b7ac532261be$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $1dd8b7ac532261be$var$gridSizeValue}px`})`;
const $1dd8b7ac532261be$export$b824cac86306f7a2 = $1dd8b7ac532261be$export$5b2b1030a679f37;
const $1dd8b7ac532261be$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("2hnSR", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $5b444d8505b9cc3c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $5b444d8505b9cc3c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $5b444d8505b9cc3c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $5b444d8505b9cc3c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $5b444d8505b9cc3c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $5b444d8505b9cc3c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $5b444d8505b9cc3c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $5b444d8505b9cc3c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $5b444d8505b9cc3c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $5b444d8505b9cc3c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $5b444d8505b9cc3c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $5b444d8505b9cc3c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $5b444d8505b9cc3c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $5b444d8505b9cc3c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 

var $e6s40 = parcelRequire("e6s40");
const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$829f609a65d26a98$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
    red: `var(--ds-background-accent-red-subtle, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
    green: `var(--ds-background-accent-green-subtle, ${$829f609a65d26a98$export$747d86715d4175de})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$829f609a65d26a98$export$6011520a64d9a187})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$829f609a65d26a98$export$b34b069eff244586})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$829f609a65d26a98$export$776c9c497ef08533})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
};
const $5b444d8505b9cc3c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$829f609a65d26a98$export$b34b069eff244586})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$829f609a65d26a98$export$776c9c497ef08533})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$829f609a65d26a98$export$eece5f492e429f08})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$829f609a65d26a98$export$226de0355ed012f8})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$829f609a65d26a98$export$363e4475840015bb})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
};
const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$829f609a65d26a98$export$226de0355ed012f8})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$829f609a65d26a98$export$363e4475840015bb})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$829f609a65d26a98$export$747d86715d4175de})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$829f609a65d26a98$export$6011520a64d9a187})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$829f609a65d26a98$export$8754fc7e6d8b3000})`
};
const $5b444d8505b9cc3c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`;
const $5b444d8505b9cc3c$export$7a57f79000377ca2 = {
    default: (0, $e6s40.defaultBorderRadius),
    rounded: (0, $e6s40.defaultRoundedBorderRadius)
};
const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
const $5b444d8505b9cc3c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
const $5b444d8505b9cc3c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`;
const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    limeLight: `var(--ds-text-accent-lime, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    orangeLight: `var(--ds-text-accent-orange, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};
const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-text-danger, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    red: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    green: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    lime: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    magenta: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    orange: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
    grey: `var(--ds-text-danger, ${$829f609a65d26a98$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    limeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    magentaLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    orangeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
    greyLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
};

});


parcelRegister("aXLIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b11e671062d0fc5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");
function $4b11e671062d0fc5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4b11e671062d0fc5$var$beforeElementStyles = {
    name: "cfjv6",
    styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4b11e671062d0fc5$var$beforeElementStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $e6s40.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $VSDnB.fg)('platform-component-visual-refresh') ? $4b11e671062d0fc5$var$beforeElementStyles : $4b11e671062d0fc5$var$beforeElementStylesOld
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;

});

parcelRegister("eYXIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b06918fbe54e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");
function $c46b06918fbe54e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$baseStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $e6s40.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $e6s40.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $e6s40.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $c46b06918fbe54e8$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $e6s40.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$linkStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $e6s40.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $c46b06918fbe54e8$var$linkStyles = {
    name: "1e5oc06",
    styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
};
const $c46b06918fbe54e8$var$hasAfterStylesOld = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $e6s40.maxTextWidthUnitless) - (0, $e6s40.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $e6s40.textPaddingRight)
});
const $c46b06918fbe54e8$var$hasAfterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $e6s40.maxTextWidthUnitless) - (0, $e6s40.buttonWidthUnitless)}px`
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$hasBeforeStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $e6s40.textMarginLeft)
});
const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $f8Sb3.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$linkStyles : $c46b06918fbe54e8$var$linkStylesOld,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
        ]
    }, text);
    else return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;

});



parcelRegister("3yrM4", function(module, exports) {

$parcel$export(module.exports, "SelectAttributeOptionPicker", () => $855c25e48fc06726$export$bf030d271a71239d);

var $5uXOq = parcelRequire("5uXOq");

var $laWvb = parcelRequire("laWvb");

var $d7FF4 = parcelRequire("d7FF4");

var $f3O7j = parcelRequire("f3O7j");

var $dZNzK = parcelRequire("dZNzK");
const $855c25e48fc06726$var$isSelectAttributeOption = (selectOption)=>typeof selectOption === 'object' && selectOption != null && 'value' in selectOption && 'label' in selectOption;
const $855c25e48fc06726$var$isSelectAttributeOptionArray = (selectOptions)=>selectOptions != null && Array.isArray(selectOptions) && selectOptions.length > 0 && $855c25e48fc06726$var$isSelectAttributeOption(selectOptions[0]);
const $855c25e48fc06726$export$bf030d271a71239d = (props)=>{
    const { objectTypeAttributeId: objectTypeAttributeId, isMultiSelect: isMultiSelect, onChange: onChange, defaultSelectedValues: defaultSelectedValues, validationState: validationState, autoFocus: autoFocus, menuIsOpen: menuIsOpen, value: value } = props;
    const { fetch: fetch } = (0, $dZNzK.useSelectAttributeOptionsSearch)();
    const loadOptions = (0, $5uXOq.useCallback)((query, cb)=>{
        fetch({
            objectTypeAttributeId: objectTypeAttributeId,
            query: query
        }).then((response)=>{
            cb(response?.map((optionValue)=>({
                    value: optionValue,
                    label: optionValue
                })) ?? []);
        });
    }, [
        fetch,
        objectTypeAttributeId
    ]);
    const [debouncedLoadOptions] = (0, $laWvb.default)((query, cb)=>loadOptions(query, cb), 400);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        ...(0, $f3O7j.selectInAModalStyleFixProps),
        isClearable: props.isClearable,
        controlShouldRenderValue: props.shouldInputRenderValue,
        defaultOptions: true,
        autoFocus: autoFocus,
        menuIsOpen: menuIsOpen,
        menuPlacement: "auto",
        value: value.length > 0 ? value.map((optionValue)=>({
                label: optionValue,
                value: optionValue
            })) : defaultSelectedValues.map((optionValue)=>({
                label: optionValue,
                value: optionValue
            })),
        isMulti: isMultiSelect,
        loadOptions: debouncedLoadOptions,
        onChange: (values)=>{
            if (!values || isMultiSelect && Array.isArray(values) && values.length === 0) onChange([]);
            else if (isMultiSelect && $855c25e48fc06726$var$isSelectAttributeOptionArray(values)) onChange(values);
            else if ($855c25e48fc06726$var$isSelectAttributeOption(values) || typeof values === 'string') onChange([
                values
            ]);
        },
        validationState: validationState,
        classNamePrefix: "insight-object-attribute-select",
        isDisabled: props.isDisabled
    });
};
$855c25e48fc06726$export$bf030d271a71239d.defaultProps = {
    defaultSelectedValues: [],
    value: [],
    validationState: 'default',
    autoFocus: false,
    isClearable: true,
    shouldInputRenderValue: true
};

});
parcelRegister("dZNzK", function(module, exports) {

$parcel$export(module.exports, "useSelectAttributeOptionsSearch", () => $013d47044d0fff1b$export$57ff3451ae8d51d0);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $ld2hZ = parcelRequire("ld2hZ");

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $56f5d = parcelRequire("56f5d");

var $7DxXA = parcelRequire("7DxXA");
const $013d47044d0fff1b$export$a14bb3b2614d5dd6 = async ({ workspaceId: workspaceId, objectTypeAttributeId: objectTypeAttributeId, query: query = '' })=>{
    const response = await (0, $4VpwK.performCmdbGetRequest)((0, $56f5d.getCmdbObjectTypeAttributeOptionsUrl)(workspaceId, objectTypeAttributeId, {
        query: query
    }));
    return response;
};
const $013d47044d0fff1b$export$57ff3451ae8d51d0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    const selectAttributeOptionsSearch = (0, $5uXOq.useCallback)(async ({ objectTypeAttributeId: objectTypeAttributeId, query: query })=>{
        if (workspaceId) try {
            const response = await $013d47044d0fff1b$export$a14bb3b2614d5dd6({
                workspaceId: workspaceId,
                objectTypeAttributeId: objectTypeAttributeId,
                query: query
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'insightSearchSelectAttributeOptions succeeded');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'insightSelectAttributeOptionPicker',
                    teamName: 'falcons',
                    packageName: 'jiraServicedeskInsightSelectAttributeOptionPicker'
                }
            });
            throw error;
        }
        return undefined;
    }, [
        createAnalyticsEvent,
        workspaceId
    ]);
    return (0, $ld2hZ.useService)(selectAttributeOptionsSearch);
};

});
parcelRegister("56f5d", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectTypeAttributeUrl", () => $68a9324954e64ae5$export$bbd1861f14973112);
$parcel$export(module.exports, "getCmdbObjectTypeAttributeConfigureUrl", () => $68a9324954e64ae5$export$d93ce0c252bdc9a4);
$parcel$export(module.exports, "getCmdbObjectTypeAttributeUpdateUrl", () => $68a9324954e64ae5$export$1e409becb5a44b7f);
$parcel$export(module.exports, "getCmdbObjectTypeAttributeMoveUrl", () => $68a9324954e64ae5$export$df634db00f0892d0);
$parcel$export(module.exports, "getCmdbObjectTypeAttributeOptionsUrl", () => $68a9324954e64ae5$export$4c47ba38ef1e9ac7);
$parcel$export(module.exports, "getCmdbObjectTypeAttributeParentImportUrl", () => $68a9324954e64ae5$export$7376c4b30b7fe2e1);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
const $68a9324954e64ae5$export$bbd1861f14973112 = (workspaceId, objectTypeAttributeId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objecttypeattribute/${objectTypeAttributeId}`;
const $68a9324954e64ae5$export$d93ce0c252bdc9a4 = (workspaceId, objectTypeAttributeId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objecttypeattribute/${objectTypeAttributeId}/configure`;
const $68a9324954e64ae5$export$1e409becb5a44b7f = (workspaceId, objectTypeId, objectTypeAttributeId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objecttypeattribute/${objectTypeId}/${objectTypeAttributeId}`;
const $68a9324954e64ae5$export$df634db00f0892d0 = (workspaceId, objectTypeId, objectTypeAttributeId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objecttypeattribute/${objectTypeId}/${objectTypeAttributeId}/move`;
const $68a9324954e64ae5$export$4c47ba38ef1e9ac7 = (workspaceId, objectTypeAttributeId, queryParams)=>`${$68a9324954e64ae5$export$bbd1861f14973112(workspaceId, objectTypeAttributeId)}/options?${(0, $ebyGx.stringify)(queryParams)}`;
const $68a9324954e64ae5$export$7376c4b30b7fe2e1 = (workspaceId, objectTypeId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objecttypeattribute/parentimport/${objectTypeId}`;

});




parcelRegister("llEjP", function(module, exports) {

$parcel$export(module.exports, "StatusEditableAttribute", () => $b086998488b52724$export$586510da6e787731);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $j8mgt = parcelRequire("j8mgt");

var $2CDrI = parcelRequire("2CDrI");

var $hVxVy = parcelRequire("hVxVy");

var $66Vf6 = parcelRequire("66Vf6");

var $581BZ = parcelRequire("581BZ");

var $FvOUN = parcelRequire("FvOUN");

var $8AFAN = parcelRequire("8AFAN");

var $e08Fw = parcelRequire("e08Fw");
const $b086998488b52724$var$EditableStatusAttribute = (props)=>{
    const { attributeType: attributeType, isEditable: isEditable } = props;
    const [objectSchemaId] = (0, $66Vf6.useObjectSchemaId)();
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const { typeValueMulti: typeValueMulti } = attributeType;
    const [statusValue, setStatusValue] = (0, $hVxVy.useStatusValue)(attribute);
    const resetValue = (0, $5uXOq.useCallback)(()=>{
        setStatusValue((0, $hVxVy.getStatusValue)(attribute));
    }, [
        attribute,
        setStatusValue
    ]);
    const statusForReadView = statusValue ? {
        id: statusValue.value,
        name: statusValue.label,
        category: statusValue.category
    } : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.status-attribute",
        // we keep the edit view mode open by default
        // this is to align with designs that break away from the regular inline edit pattern and display a custom status picker
        isEditingByDefault: false,
        attributeType: attributeType,
        isEditable: isEditable,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CDrI.StatusReadView), {
                status: statusForReadView
            })),
        readViewFitContainerWidth: true,
        renderEditView: ({ onConfirmChange: onConfirmChange, hasValidationError: hasValidationError })=>objectSchemaId !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8AFAN.EditViewSpacers).StatusPicker, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $FvOUN.StatusPicker), {
                menuIsOpen: true,
                autoFocus: true,
                value: statusValue,
                onChange: (statusOptions)=>{
                    const [statusOption] = statusOptions;
                    onConfirmChange?.(statusOption.value);
                    setStatusValue(statusOption);
                },
                isEditable: isEditable,
                objectSchemaId: objectSchemaId,
                objectTypeMultiValues: typeValueMulti,
                hasValidationError: hasValidationError
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        onResetValue: resetValue
    });
};
const $b086998488b52724$export$586510da6e787731 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightEditableStatusAttribute",
        packageName: "jiraServicedeskInsightEditableStatusAttribute",
        teamName: "falcons",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b086998488b52724$var$EditableStatusAttribute, props));

});
parcelRegister("2CDrI", function(module, exports) {

$parcel$export(module.exports, "StatusReadView", () => $90f0ac975bda1764$export$82fc58a40c5b3a52);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7hDf3 = parcelRequire("7hDf3");

var $j8mgt = parcelRequire("j8mgt");

var $4SY1K = parcelRequire("4SY1K");
const $90f0ac975bda1764$export$82fc58a40c5b3a52 = ({ status: status })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const placeholderText = formatMessage((0, $7hDf3.default).placeholderNoneSelected);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: !status
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.PlaceholderSpacer), null, status !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4SY1K.StatusLozenge), {
        ellipsis: true,
        isEditable: false,
        status: status
    }) : placeholderText));
};

});
parcelRegister("4SY1K", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $d11718ce78900c7e$export$f72db4ad1e9b3e6d);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $k4n86 = parcelRequire("k4n86");

var $lj8SI = parcelRequire("lj8SI");

const $d11718ce78900c7e$export$f72db4ad1e9b3e6d = ({ isEditable: isEditable, status: status, ellipsis: ellipsis })=>{
    const { name: name, category: category } = status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d11718ce78900c7e$var$LozengeOverrides, {
        // @ts-expect-error - TS2322: Type 'null' is not assignable to type '0 | 1 | 2 | null'.
        category: category,
        isEditable: isEditable,
        "data-testid": "servicedesk-insight-attribute-views.ui.status.status-lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d11718ce78900c7e$var$LozengeContent, null, isEditable || ellipsis ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d11718ce78900c7e$var$EllipsisOverflow, null, name) : name, isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k4n86))), {
        size: "small",
        label: ""
    }))));
};
const $d11718ce78900c7e$var$statusCategory = {
    '0': 'inactive',
    '1': 'active',
    '2': 'pending',
    null: 'none'
};
const $d11718ce78900c7e$var$statusBackground = {
    inactive: `var(--ds-background-danger, ${(0, $829f609a65d26a98$exports).R50})`,
    active: `var(--ds-background-success, ${(0, $829f609a65d26a98$exports).G50})`,
    pending: `var(--ds-background-warning, ${(0, $829f609a65d26a98$exports).Y75})`,
    none: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$exports).N40})`
};
const $d11718ce78900c7e$var$bgHoverColor = {
    inactive: `var(--ds-background-danger-hovered, ${(0, $829f609a65d26a98$exports).R75})`,
    active: `var(--ds-background-success-hovered, ${(0, $829f609a65d26a98$exports).G75})`,
    pending: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$exports).Y100})`,
    none: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$exports).N50})`
};
const $d11718ce78900c7e$var$textColor = {
    inactive: `var(--ds-text-danger, ${(0, $829f609a65d26a98$exports).R500})`,
    active: `var(--ds-text-success, ${(0, $829f609a65d26a98$exports).G500})`,
    pending: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`,
    none: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N500})`
};
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d11718ce78900c7e$var$LozengeOverrides = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6n5sz-0"
})`display:flex;align-items:center;> span{padding:${(props)=>props.isEditable ? '4px 6px' : '2px'};vertical-align:text-bottom;color:${(props)=>$d11718ce78900c7e$var$textColor[$d11718ce78900c7e$var$statusCategory[props.category]]};background-color:${(props)=>$d11718ce78900c7e$var$statusBackground[$d11718ce78900c7e$var$statusCategory[props.category]]};${(props)=>props.isEditable ? (0, $47bDC.css)({
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: `${$d11718ce78900c7e$var$bgHoverColor[$d11718ce78900c7e$var$statusCategory[props.category]]}`
        }
    }) : ''};}> span > span{text-overflow:clip;white-space:normal;}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d11718ce78900c7e$var$LozengeContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d11718ce78900c7e$var$EllipsisOverflow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hVxVy", function(module, exports) {

$parcel$export(module.exports, "getStatusValue", () => $c683f5ec43816ff1$export$a6584158f9e495c0);
$parcel$export(module.exports, "useStatusValue", () => $c683f5ec43816ff1$export$4bbbff6e1847850a);

var $5uXOq = parcelRequire("5uXOq");
const $c683f5ec43816ff1$export$a6584158f9e495c0 = (attribute)=>{
    if (attribute && attribute.type === 'status') {
        const [{ status: status }] = attribute.statusTypeValues;
        return {
            category: status.category,
            label: status.name,
            value: status.id
        };
    }
    return null;
};
const $c683f5ec43816ff1$export$4bbbff6e1847850a = (attribute)=>{
    const [value, setValue] = (0, $5uXOq.useState)($c683f5ec43816ff1$export$a6584158f9e495c0(attribute));
    (0, $5uXOq.useEffect)(()=>{
        setValue($c683f5ec43816ff1$export$a6584158f9e495c0(attribute));
    }, [
        attribute
    ]);
    const setStatusOption = (0, $5uXOq.useCallback)((statusOption)=>{
        const isNoneOption = statusOption?.category === null;
        if (isNoneOption) setValue(null);
        else setValue(statusOption);
    }, []);
    return [
        value,
        setStatusOption
    ];
};

});

parcelRegister("FvOUN", function(module, exports) {

$parcel$export(module.exports, "StatusPicker", () => $37133bfb2d75f747$export$39975ce689bf0105);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $1I7E8 = parcelRequire("1I7E8");

var $d7FF4 = parcelRequire("d7FF4");
var $7K5PP = parcelRequire("7K5PP");

var $gwIPs = parcelRequire("gwIPs");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $jDrwg = parcelRequire("jDrwg");

var $4SY1K = parcelRequire("4SY1K");

var $jIR1A = parcelRequire("jIR1A");

var $iBRjy = parcelRequire("iBRjy");

var $c22OI = parcelRequire("c22OI");

var $kYZBt = parcelRequire("kYZBt");

var $fWHd4 = parcelRequire("fWHd4");

var $8qJWv = parcelRequire("8qJWv");

var $gPt3X = parcelRequire("gPt3X");
const $37133bfb2d75f747$export$e392892edf036599 = (0, $gwIPs.layers).modal + 1;
const $37133bfb2d75f747$var$MAX_MENU_HEIGHT = 300;
// Minus control minus padding
const $37133bfb2d75f747$var$MAX_MENU_LIST_HEIGHT = $37133bfb2d75f747$var$MAX_MENU_HEIGHT - 60;
const $37133bfb2d75f747$var$REMOVE_ACTION_META_TYPES = [
    'clear',
    'remove-value',
    'pop-value'
];
const $37133bfb2d75f747$var$formatOptionLabel = ({ value: value, category: category, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4SY1K.StatusLozenge), {
        isEditable: false,
        ellipsis: true,
        status: {
            id: value,
            name: label,
            category: category
        }
    });
const $37133bfb2d75f747$export$39975ce689bf0105 = ({ onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), objectSchemaId: objectSchemaId, value: value, objectTypeMultiValues: objectTypeMultiValues, hasValidationError: hasValidationError, menuIsOpen: menuIsOpen = false, isDisabled: isDisabled, fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const popupTriggerRef = (0, $5uXOq.useRef)(null);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(null);
    const [popupOpen, setPopupOpen] = (0, $5uXOq.useState)(menuIsOpen);
    const [closeToBottom, setCloseToBottom] = (0, $5uXOq.useState)(false);
    const { error: error, loading: loading, fetch: searchStatuses } = (0, $fWHd4.useStatusesSearch)();
    /*  Infer the menu position for asynchronously loaded options. Popup update doesn't work when called after
         fetching options and appears below select causing an issue when the select is at the bottom of the window */ (0, $5uXOq.useEffect)(()=>{
        if (popupTriggerRef.current) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const distance = window.innerHeight - popupTriggerRef.current.getBoundingClientRect().bottom;
            setCloseToBottom(distance < $37133bfb2d75f747$var$MAX_MENU_HEIGHT);
        }
    }, [
        popupOpen
    ]);
    const onSearchStatuses = (0, $5uXOq.useCallback)((searchQuery, onStatusesLoaded)=>{
        searchStatuses({
            objectSchemaId: objectSchemaId,
            objectTypeMultiValues: objectTypeMultiValues,
            query: searchQuery ?? ''
        }).then((response)=>{
            if (response?.statuses) {
                const statusListOptions = response.statuses.map((0, $gPt3X.transformStatusToSelectOption));
                const groupedOptions = {
                    label: formatMessage((0, $8qJWv.default).groupHeader, {
                        numberOfStatuses: response.statuses.length,
                        totalStatuses: response.total
                    }),
                    options: statusListOptions
                };
                onStatusesLoaded?.([
                    groupedOptions
                ]);
            }
        });
    }, [
        formatMessage,
        objectSchemaId,
        objectTypeMultiValues,
        searchStatuses
    ]);
    const [debouncedLoadOptions] = (0, $jDrwg.default)((query, callback)=>onSearchStatuses(query, callback), 400);
    const onStatusSelected = (0, $5uXOq.useCallback)((newValues, meta)=>{
        setPopupOpen(false);
        if (meta?.action && meta?.action && $37133bfb2d75f747$var$REMOVE_ACTION_META_TYPES.includes(meta.action)) // When select is cleared set status to None
        onChange([
            {
                label: formatMessage((0, $kYZBt.default).noValue),
                value: '',
                category: null
            }
        ]);
        if (newValues) onChange([
            newValues
        ]);
    }, [
        formatMessage,
        onChange
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) showFlag({
            type: 'error',
            title: (0, $8qJWv.default).errorFlagTitle,
            description: (0, $8qJWv.default).errorFlagDescription
        });
    }, [
        error,
        showFlag
    ]);
    const validationState = hasValidationError === true ? 'error' : 'default';
    const togglePopupOpen = (0, $5uXOq.useCallback)(()=>{
        setPopupOpen((prevState)=>!prevState);
    }, []);
    // We need this due to calling close when inline editing is a noop due to component unmount
    const closePopup = (0, $5uXOq.useCallback)(()=>{
        menuIsOpen ? undefined : setPopupOpen(false);
    }, [
        menuIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        testId: "servicedesk-insight-status-picker.ui.popup",
        isOpen: popupOpen,
        autoFocus: false,
        placement: closeToBottom ? 'top-start' : 'bottom-start',
        zIndex: $37133bfb2d75f747$export$e392892edf036599,
        popupComponent: (0, $c22OI.default),
        onClose: closePopup,
        trigger: (triggerProps)=>// This is basically a dummy display component for the value and handles opening the select
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: popupTriggerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                isDisabled: isDisabled,
                inputId: fieldId,
                classNamePrefix: "insight-object-attribute-status-picker-value",
                value: value,
                onChange: onStatusSelected,
                isClearable: true,
                validationState: validationState,
                components: {
                    Menu: ()=>null,
                    MenuList: ()=>null
                },
                formatOptionLabel: $37133bfb2d75f747$var$formatOptionLabel,
                onMenuOpen: togglePopupOpen,
                isSearchable: false
            }))),
        content: ()=>// This is the search component to asynchronously call the API
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
                // Used for tests
                classNamePrefix: "insight-object-attribute-status-picker",
                value: value,
                onChange: onStatusSelected,
                placeholder: formatMessage((0, $8qJWv.default).searchPlaceholder),
                controlShouldRenderValue: false,
                isClearable: false,
                backspaceRemovesValue: false,
                hideSelectedOptions: false,
                tabSelectsValue: false,
                components: {
                    DropdownIndicator: $iBRjy.DropdownIndicator,
                    Control: (0, $jIR1A.ControlComponent)
                },
                defaultOptions: defaultOptions,
                formatOptionLabel: $37133bfb2d75f747$var$formatOptionLabel,
                isLoading: loading,
                loadOptions: debouncedLoadOptions,
                autoFocus: true,
                menuIsOpen: popupOpen,
                onFocus: ()=>{
                    if (defaultOptions === null) onSearchStatuses('', setDefaultOptions);
                },
                maxMenuHeight: $37133bfb2d75f747$var$MAX_MENU_LIST_HEIGHT,
                styles: {
                    menu: (base)=>({
                            ...base,
                            width: 'max-content',
                            minWidth: '100%',
                            position: 'relative',
                            boxShadow: 'none',
                            marginTop: 0,
                            marginBottom: 0
                        }),
                    placeholder: (base)=>({
                            ...base,
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            width: '100%',
                            overflow: 'hidden'
                        })
                }
            })
    });
};

});
parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("jIR1A", function(module, exports) {

$parcel$export(module.exports, "ControlComponent", () => $9baa7fe589f2f0d3$export$e6d4c454c2a23f81);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");
const $9baa7fe589f2f0d3$export$e6d4c454c2a23f81 = ({ innerProps: innerProps, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9baa7fe589f2f0d3$var$ControlComponentWrapper, {
        ref: innerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Control, {
        ...props,
        innerProps: innerProps
    }));
// Styles taken from PopupSelect/components.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9baa7fe589f2f0d3$var$ControlComponentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3u2gc _n3td1b66 _19bvu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iBRjy", function(module, exports) {

$parcel$export(module.exports, "DropdownIndicator", () => $9ac1e45997effb10$export$ec98719d3db7f2e4);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $tvuR8 = parcelRequire("tvuR8");
const $9ac1e45997effb10$export$ec98719d3db7f2e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac1e45997effb10$var$DropDownIndicatorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvuR8))), {
        label: ""
    }));
// Styles taken from PopupSelect/components.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ac1e45997effb10$var$DropDownIndicatorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxv77o _y3gn1h6o _1bsbzwfg",
            __cmplp.className
        ])
    });
});

});

parcelRegister("c22OI", function(module, exports) {

$parcel$export(module.exports, "default", () => $441a9fda2afe4beb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $k5uoT = parcelRequire("k5uoT");
const $441a9fda2afe4beb$var$PopupComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($441a9fda2afe4beb$var$PopupComponentContainer, {
        ...props,
        ref: ref
    }));
var $441a9fda2afe4beb$export$2e2bcd8739ae039 = $441a9fda2afe4beb$var$PopupComponent;
// Workaround for https://github.com/atlassian-labs/compiled/issues/1200
const $441a9fda2afe4beb$var$layerValue = (0, $k5uoT.layers).modal;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $441a9fda2afe4beb$var$PopupComponentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkosqtm _16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _bfhk1bhr _16qs1mxi _vchhusvi _1e0c1ule _1pbyaft6 _1ul9p3fh _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kYZBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e13995372cb398c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6e13995372cb398c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noValue: {
        "id": "servicedesk-insight-status-picker.common.status.no-value",
        "defaultMessage": "None"
    }
});

});

parcelRegister("fWHd4", function(module, exports) {

$parcel$export(module.exports, "useStatusesSearch", () => $30a3a2c3630da97d$export$5912e632b422560b);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $ld2hZ = parcelRequire("ld2hZ");

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $Zsxbh = parcelRequire("Zsxbh");

var $7DxXA = parcelRequire("7DxXA");
const $30a3a2c3630da97d$var$MAX_RESULTS = 10;
const $30a3a2c3630da97d$export$b93a2ecf1ef8861c = async ({ workspaceId: workspaceId, objectSchemaId: objectSchemaId, objectTypeMultiValues: objectTypeMultiValues, query: query })=>{
    const queryParams = {
        query: query,
        objectSchemaId: objectSchemaId,
        maxresult: $30a3a2c3630da97d$var$MAX_RESULTS,
        ids: objectTypeMultiValues ? objectTypeMultiValues.join(',') : ''
    };
    const { header: header, statuses: statuses, total: total } = await (0, $4VpwK.performCmdbGetRequest)((0, $Zsxbh.getCmdbConfigStatusTypePickerUrl)(workspaceId, queryParams));
    return {
        header: header,
        statuses: statuses,
        total: total
    };
};
const $30a3a2c3630da97d$export$5912e632b422560b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    const statusesSearch = (0, $5uXOq.useCallback)(async ({ objectSchemaId: objectSchemaId, objectTypeMultiValues: objectTypeMultiValues, query: query })=>{
        if (workspaceId) try {
            const response = await $30a3a2c3630da97d$export$b93a2ecf1ef8861c({
                workspaceId: workspaceId,
                objectSchemaId: objectSchemaId,
                objectTypeMultiValues: objectTypeMultiValues,
                query: query
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'insightSearchStatuses succeeded');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'insightSearchStatuses',
                    teamName: 'falcons',
                    packageName: 'jiraServicedeskInsightStatusPicker'
                }
            });
            throw error;
        }
        return undefined;
    }, [
        createAnalyticsEvent,
        workspaceId
    ]);
    return (0, $ld2hZ.useService)(statusesSearch);
};

});

parcelRegister("8qJWv", function(module, exports) {

$parcel$export(module.exports, "default", () => $96672548cae98db4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $96672548cae98db4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "servicedesk-insight-status-picker.error-flag-title",
        "defaultMessage": "We couldn\u2019t load your statuses"
    },
    errorFlagDescription: {
        "id": "servicedesk-insight-status-picker.error-flag-description",
        "defaultMessage": "Please check your network and try again"
    },
    searchPlaceholder: {
        "id": "servicedesk-insight-status-picker.search-placeholder",
        "defaultMessage": "Filter statuses\u2026"
    },
    groupHeader: {
        "id": "servicedesk-insight-status-picker.group-header",
        "defaultMessage": "Showing {numberOfStatuses} of {totalStatuses} statuses"
    }
});

});

parcelRegister("gPt3X", function(module, exports) {

$parcel$export(module.exports, "transformStatusToSelectOption", () => $46829ba4ebda8458$export$cb128eb846c4eeef);
const $46829ba4ebda8458$export$cb128eb846c4eeef = ({ name: name, id: id, category: category })=>({
        label: name,
        value: id,
        category: category
    });
const $46829ba4ebda8458$export$f4f0dd64a94b86d4 = ({ value: value })=>value;

});



parcelRegister("4DfBb", function(module, exports) {

$parcel$export(module.exports, "TextAreaEditableAttribute", () => $0f245ee4e5bea304$export$84bcb92182f61fe);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6LCpJ = parcelRequire("6LCpJ");

var $7CMCs = parcelRequire("7CMCs");

var $j8mgt = parcelRequire("j8mgt");

var $8j9Sh = parcelRequire("8j9Sh");

var $2QgAn = parcelRequire("2QgAn");

var $581BZ = parcelRequire("581BZ");

var $f3O7j = parcelRequire("f3O7j");

var $e08Fw = parcelRequire("e08Fw");
const $0f245ee4e5bea304$export$b0b3196356845bd2 = (props)=>{
    const { attributeType: attributeType, isEditable: isEditable } = props;
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const [value, setValue] = (0, $2QgAn.useDefaultAttributeValue)(attribute);
    const onChange = (0, $5uXOq.useCallback)((event)=>{
        setValue(event.target.value);
    }, [
        setValue
    ]);
    const resetValue = (0, $5uXOq.useCallback)(()=>{
        setValue((0, $2QgAn.getDefaultAttributeValue)(attribute));
    }, [
        attribute,
        setValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.text-area-attribute",
        value: value,
        onChange: onChange,
        storedValue: (0, $2QgAn.getDefaultAttributeValue)(attribute),
        isEditable: isEditable,
        attributeType: attributeType,
        hideActionButtons: false,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8j9Sh.TextAreaReadView), {
                value: value
            })),
        renderEditView: ({ hasValidationError: hasValidationError, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f245ee4e5bea304$var$EditViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6LCpJ.default), {
                ...fieldProps,
                ...(0, $f3O7j.textAreaAttributeProps),
                autoFocus: true,
                isInvalid: hasValidationError
            })),
        onResetValue: resetValue
    });
};
const $0f245ee4e5bea304$export$84bcb92182f61fe = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightInlineEditableTextAreaAttribute",
        packageName: "jiraServicedeskInsightEditableTextAreaAttribute",
        teamName: "falcons",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f245ee4e5bea304$export$b0b3196356845bd2, props));
// eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f245ee4e5bea304$var$EditViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f312x7 _n3tdu2gc _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6LCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $934f91ac04cc5aeb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $1qQmi = parcelRequire("1qQmi");
const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
const $934f91ac04cc5aeb$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $934f91ac04cc5aeb$var$packageName,
    packageVersion: $934f91ac04cc5aeb$var$packageVersion
};
const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $1qQmi.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $934f91ac04cc5aeb$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $5uXOq.useMemo)(()=>(0, $1qQmi.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)([
        baseStyles,
        (0, $1qQmi.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $934f91ac04cc5aeb$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;

});
parcelRegister("1qQmi", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $0f8aaecc0e682a20$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $0f8aaecc0e682a20$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $0f8aaecc0e682a20$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $iaE2J = parcelRequire("iaE2J");
function $0f8aaecc0e682a20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0f8aaecc0e682a20$var$disabledRules = {
    backgroundColor: $iaE2J.disabledBackground,
    backgroundColorFocus: $iaE2J.disabledBackground,
    backgroundColorHover: $iaE2J.disabledBackground,
    borderColor: $iaE2J.disabledBorder,
    borderColorFocus: $iaE2J.defaultBorderColorFocus,
    textColor: $iaE2J.disabledTextColor
};
const $0f8aaecc0e682a20$var$invalidRules = {
    borderColor: $iaE2J.invalidBorderColor,
    borderColorFocus: $iaE2J.defaultBorderColorFocus,
    backgroundColor: $iaE2J.defaultBackgroundColor,
    backgroundColorFocus: $iaE2J.defaultBackgroundColorFocus,
    backgroundColorHover: $iaE2J.defaultBackgroundColorHover
};
const $0f8aaecc0e682a20$var$backgroundColor = {
    standard: $iaE2J.defaultBackgroundColor,
    subtle: $iaE2J.transparent,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$backgroundColorFocus = {
    standard: $iaE2J.defaultBackgroundColorFocus,
    subtle: $iaE2J.defaultBackgroundColorFocus,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$backgroundColorHover = {
    standard: $iaE2J.defaultBackgroundColorHover,
    subtle: $iaE2J.defaultBackgroundColorHover,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$borderColor = {
    standard: $iaE2J.defaultBorderColor,
    subtle: $iaE2J.transparent,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$borderColorFocus = {
    standard: $iaE2J.defaultBorderColorFocus,
    subtle: $iaE2J.defaultBorderColorFocus,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$borderColorHover = {
    standard: $iaE2J.defaultBorderColor,
    subtle: $iaE2J.subtleBorderColorHover,
    none: $iaE2J.transparent
};
const $0f8aaecc0e682a20$var$lineHeightBase = 20;
const $0f8aaecc0e682a20$var$lineHeightCompact = 16;
const $0f8aaecc0e682a20$var$compactVerticalPadding = 2;
const $0f8aaecc0e682a20$var$verticalPadding = 6;
const $0f8aaecc0e682a20$var$horizontalPadding = 8;
const $0f8aaecc0e682a20$var$transitionDuration = '0.2s';
const $0f8aaecc0e682a20$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $0f8aaecc0e682a20$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $0f8aaecc0e682a20$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $0f8aaecc0e682a20$var$lineHeightBase * minimumRows;
    return contentHeight + $0f8aaecc0e682a20$var$verticalPadding * 2 + borderHeight * 2;
};
const $0f8aaecc0e682a20$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $0f8aaecc0e682a20$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $0f8aaecc0e682a20$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $0f8aaecc0e682a20$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $f8Sb3.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorFocus,
                borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColor,
                borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColor
            }
        } : {}
    });
const $0f8aaecc0e682a20$var$placeholderStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $iaE2J.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $0f8aaecc0e682a20$var$disabledRules.textColor
    }
});
const $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $0f8aaecc0e682a20$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $0f8aaecc0e682a20$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
            }
        }
    });
var $0f8aaecc0e682a20$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $0f8aaecc0e682a20$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $0f8aaecc0e682a20$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        resize: resize
    });
    if (resize === 'auto') return $0f8aaecc0e682a20$var$_ref2;
    return $0f8aaecc0e682a20$var$_ref;
};
const $0f8aaecc0e682a20$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $0f8aaecc0e682a20$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)" : "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
const $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $0f8aaecc0e682a20$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$0f8aaecc0e682a20$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
            lineHeight: $0f8aaecc0e682a20$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$0f8aaecc0e682a20$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
            lineHeight: $0f8aaecc0e682a20$var$lineHeightBase / 14
        }
    });
};
const $0f8aaecc0e682a20$var$staticStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out,
               border-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$0f8aaecc0e682a20$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
// suggestion: these two could be merged into cssMap during @compiled rewrite
const $0f8aaecc0e682a20$var$newFontStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    [(0, $h9kUS.media).above.xs]: {
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }
});
const $0f8aaecc0e682a20$var$monospacedFontFamilyStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    [(0, $h9kUS.media).above.xs]: {
        // Reapply the monospaced font family as the font declaration used in the breakpoint in newFontStyles overrides it otherwise
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
    }
});
const $0f8aaecc0e682a20$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$borderStyle(appearance), // @todo: remove in `platform_design_system_team_safari_input_fix` cleanup
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') ? $0f8aaecc0e682a20$var$newFontStyles : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    isMonospaced && (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') ? $0f8aaecc0e682a20$var$monospacedFontFamilyStyles : undefined, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $0f8aaecc0e682a20$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0f8aaecc0e682a20$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $iaE2J.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $0f8aaecc0e682a20$var$disabledRules.textColor
        }
    });

});
parcelRegister("iaE2J", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f788b902061573a8$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f788b902061573a8$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f788b902061573a8$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f788b902061573a8$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f788b902061573a8$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f788b902061573a8$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f788b902061573a8$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f788b902061573a8$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f788b902061573a8$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f788b902061573a8$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f788b902061573a8$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f788b902061573a8$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f788b902061573a8$export$f4d082c200a4b4b8);

const $f788b902061573a8$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
const $f788b902061573a8$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
const $f788b902061573a8$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`;
const $f788b902061573a8$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`;
const $f788b902061573a8$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`;
const $f788b902061573a8$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`;
const $f788b902061573a8$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
const $f788b902061573a8$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
const $f788b902061573a8$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f788b902061573a8$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
const $f788b902061573a8$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
const $f788b902061573a8$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`;
const $f788b902061573a8$export$f4d082c200a4b4b8 = 'transparent';

});



parcelRegister("8j9Sh", function(module, exports) {

$parcel$export(module.exports, "TextAreaReadView", () => $1e33e087e5da49b6$export$213c0592d08e5858);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hXLCJ = parcelRequire("hXLCJ");

var $koVbs = parcelRequire("koVbs");

var $johYW = parcelRequire("johYW");

var $7hDf3 = parcelRequire("7hDf3");

var $j8mgt = parcelRequire("j8mgt");
const $1e33e087e5da49b6$var$sanitize = (html)=>(0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(html, {
        // @ts-expect-error - TS2769 - No overload matches this call.
        ALLOWED_TAGS: (0, $johYW.ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS),
        ALLOWED_ATTR: [
            'role',
            'tabindex',
            'href',
            'target'
        ]
    });
const $1e33e087e5da49b6$export$213c0592d08e5858 = ({ value: value, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const nonNullValue = value ?? '';
    const hasValue = nonNullValue.length > 0;
    const placeholderText = showPlaceholderIfEmpty ? formatMessage((0, $7hDf3.default).placeholderNoneEntered) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: !hasValue
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e33e087e5da49b6$var$ReadOnlyView, {
        dangerouslySetInnerHTML: {
            __html: $1e33e087e5da49b6$var$sanitize(nonNullValue)
        }
    }) : placeholderText);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1e33e087e5da49b6$var$ReadOnlyView = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyru2gc _c71l1kdj _18m91wug _1i4q1hna _1nmz1hna _o5721jtm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hXLCJ", function(module, exports) {
/*! @license DOMPurify 2.5.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.7/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.7';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});



parcelRegister("aC7yQ", function(module, exports) {

$parcel$export(module.exports, "TextEditableAttribute", () => $4611de2a3c3ebb9b$export$dc8b2c2ad1c13586);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $fqhHE = parcelRequire("fqhHE");
const $4611de2a3c3ebb9b$export$dc8b2c2ad1c13586 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightInlineEditableTextAttribute",
        packageName: "jiraServicedeskInsightEditableTextAttribute",
        teamName: "falcons",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fqhHE.TextAttribute), props));

});
parcelRegister("fqhHE", function(module, exports) {

$parcel$export(module.exports, "TextAttribute", () => $45ffe95f7e775753$export$524ab8b6c1ca9de3);

var $5uXOq = parcelRequire("5uXOq");

var $kY99m = parcelRequire("kY99m");

var $j8mgt = parcelRequire("j8mgt");

var $1hVgu = parcelRequire("1hVgu");

var $2QgAn = parcelRequire("2QgAn");

var $5IVkq = parcelRequire("5IVkq");

var $581BZ = parcelRequire("581BZ");

var $kCYNT = parcelRequire("kCYNT");

var $e08Fw = parcelRequire("e08Fw");
const $45ffe95f7e775753$export$524ab8b6c1ca9de3 = (props)=>{
    const { attributeType: attributeType, isEditable: isEditable } = props;
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const [value, setValue] = (0, $2QgAn.useDefaultMultipleAttributeValuesAsString)(attribute);
    const resetValue = (0, $5uXOq.useCallback)(()=>{
        setValue((0, $2QgAn.getDefaultMultipleAttributeValuesAsString)(attribute));
    }, [
        attribute,
        setValue
    ]);
    const onValueChange = (0, $5uXOq.useCallback)((event)=>{
        setValue(event.target.value);
    }, [
        setValue
    ]);
    const defaultTypeId = attributeType.defaultType.id;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const defaultTypeName = (0, $kCYNT.defaultTypesById)[defaultTypeId];
    const transformValue = (0, $5uXOq.useCallback)((values)=>{
        if (defaultTypeName === 'url' || defaultTypeName === 'email') return (0, $5IVkq.splitValuesOnSpace)([
            values
        ]);
        return values;
    }, [
        defaultTypeName
    ]);
    const transformedValue = transformValue(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.text-attribute",
        value: transformedValue,
        onChange: onValueChange,
        storedValue: (0, $2QgAn.getDefaultMultipleAttributeValuesAsString)(attribute),
        isEditable: isEditable,
        attributeType: attributeType,
        hideActionButtons: false,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1hVgu.TextReadView), {
                value: transformedValue,
                defaultAttributeType: attributeType
            })),
        renderEditView: ({ onChange: onChange, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                value: value,
                autoFocus: true,
                onChange: onChange,
                ...fieldProps.hasValidationError ? {
                    'aria-describedby': (0, $e08Fw.InlineValidationErrorID)
                } : {},
                isInvalid: fieldProps.hasValidationError
            }),
        onResetValue: resetValue
    });
};

});
parcelRegister("1hVgu", function(module, exports) {

$parcel$export(module.exports, "TextReadView", () => $1e2a6edfeffa212c$export$ec510b523cd75479);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kVZJG = parcelRequire("kVZJG");
var $dn5wJ = parcelRequire("dn5wJ");

var $8dO33 = parcelRequire("8dO33");

var $koVbs = parcelRequire("koVbs");

var $kCYNT = parcelRequire("kCYNT");

var $7hDf3 = parcelRequire("7hDf3");

var $j8mgt = parcelRequire("j8mgt");
const $1e2a6edfeffa212c$var$renderUrlAnchor = (url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: url
    }, url);
const $1e2a6edfeffa212c$var$renderEmailReadView = (emails)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e2a6edfeffa212c$var$MultiTextContainer, {
        "data-testid": "servicedesk-insight-attribute-views.ui.text.multi-text-container"
    }, emails.map((email, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: `mailto:${email}`
        }, email))));
const $1e2a6edfeffa212c$export$ec510b523cd75479 = ({ value: value, defaultAttributeType: defaultAttributeType, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const renderSmartLink = (url)=>{
        const handleClick = (event)=>{
            event.preventDefault(); // Open smart link in new tab by default, as it takes the user out of Jira
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank', 'noopener');
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVZJG.Card), {
            url: url,
            appearance: "inline",
            fallbackComponent: ()=>$1e2a6edfeffa212c$var$renderUrlAnchor(url),
            onClick: handleClick,
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $dn5wJ.CardAction).ChangeStatusAction
                ]
            }
        });
    };
    const renderUrlReadViewWithSmartLinks = (urls)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e2a6edfeffa212c$var$MultiTextContainer, {
            "data-testid": "servicedesk-insight-attribute-views.ui.text.multi-text-container"
        }, urls.map((url, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                key: index
            }, renderSmartLink(url)))));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let readViewContent;
    const getValueAsArray = (v)=>{
        let unfilteredArray;
        if (typeof v === 'string') unfilteredArray = [
            v
        ];
        else unfilteredArray = v ?? [];
        return unfilteredArray.filter((val)=>val != null && val !== '');
    };
    const valuesAsArray = getValueAsArray(value);
    const hasValue = valuesAsArray.length > 0;
    if (hasValue) {
        const firstValue = valuesAsArray[0];
        const renderValue = ()=>firstValue;
        readViewContent = (0, $kCYNT.matchDefaultAttributeSubType)(defaultAttributeType.defaultType, {
            url: ()=>renderUrlReadViewWithSmartLinks(valuesAsArray),
            email: ()=>$1e2a6edfeffa212c$var$renderEmailReadView(valuesAsArray),
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            float: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            integer: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            ipAddress: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            text: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            textarea: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            select: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            boolean: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            date: renderValue,
            // @ts-expect-error - TS2322 - Type '() => ReactNode' is not assignable to type '() => Element | null | undefined'.
            datetime: renderValue
        });
    } else readViewContent = showPlaceholderIfEmpty ? formatMessage((0, $7hDf3.default).placeholderNoneEntered) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: !hasValue
    }, readViewContent, hasValue && defaultAttributeType.suffix !== undefined ? ` ${defaultAttributeType.suffix}` : null);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1e2a6edfeffa212c$var$MultiTextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_7yhbu2gc _1joi1tcg _mw6q1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kVZJG", function(module, exports) {

$parcel$export(module.exports, "Card", () => $fc8afc0c39cee453$export$60332b2344f7fe41);

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $fzJZi = parcelRequire("fzJZi");

var $lpxJ1 = parcelRequire("lpxJ1");
class $fc8afc0c39cee453$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpxJ1.CardWithURLRenderer), this.props);
        return this.props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i5FdW.default), {
            locale: "en"
        }, content);
    }
}
const $fc8afc0c39cee453$export$60332b2344f7fe41 = (0, $994MI.default)((0, $fzJZi.context))((0, $cb25w.default)()((0, $8RXs9.default)($fc8afc0c39cee453$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("fzJZi", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3b4d25437cc28513$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3b4d25437cc28513$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3b4d25437cc28513$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3b4d25437cc28513$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3b4d25437cc28513$export$b91e0203b928470c);
const $3b4d25437cc28513$export$85183a312807388d = 'media';
const $3b4d25437cc28513$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3b4d25437cc28513$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3b4d25437cc28513$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3b4d25437cc28513$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3b4d25437cc28513$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
};

});

parcelRegister("lpxJ1", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $422a0598dbbdc42a$export$e00a7788e30dc998);

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $gKZoD = parcelRequire("gKZoD");

var $7Jxgt = parcelRequire("7Jxgt");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $kxcRq = parcelRequire("kxcRq");

var $5igsJ = parcelRequire("5igsJ");

var $91tw3 = parcelRequire("91tw3");

var $5vDFA = parcelRequire("5vDFA");

var $i41Ob = parcelRequire("i41Ob");

const $422a0598dbbdc42a$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(0, $kxcRq.importWithRetry)(()=>(parcelRequire("5HNFf"))));
function $422a0598dbbdc42a$export$e00a7788e30dc998(props) {
    (0, $gKZoD.di)($422a0598dbbdc42a$export$a7690c318cd6a95e);
    const [id] = (0, $5uXOq.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $5vDFA.clearMarks)(id);
            (0, $5vDFA.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline } = props;
    const isFlexibleUi = (0, $91tw3.isFlexibleUiCard)(children);
    const analyticsContext = (0, $5igsJ.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $5uXOq.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $1VPdD.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1VPdD.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1VPdD.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FallbackComponent, null);
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f4cXA.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i41Ob.LoadingCardLink), cardWithUrlProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($422a0598dbbdc42a$export$a7690c318cd6a95e, cardWithUrlProps, children)));
}

});
parcelRegister("a1vqi", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $91130a451fd4887d$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");


var $1PQcU = parcelRequire("1PQcU");
const $91130a451fd4887d$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $1PQcU.default)(...params));
        event.fire((0, $37b399a913bad22b$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $37b399a913bad22b$export$3f072f06b90c3985 = 'media';

parcelRegister("1PQcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $539e70e97f68df84$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $539e70e97f68df84$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $539e70e97f68df84$export$2e2bcd8739ae039 = $539e70e97f68df84$var$createEventPayload;

});


parcelRegister("1VPdD", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $2308e6f5aae12b86$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $2308e6f5aae12b86$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $2308e6f5aae12b86$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $2308e6f5aae12b86$export$4084c0df4a03a6af);

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");
const $2308e6f5aae12b86$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Load,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad
};
const $2308e6f5aae12b86$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult
};
const $2308e6f5aae12b86$var$ufoExperiences = {
    'smart-link-rendered': new (0, $cBycP.ConcurrentExperience)('smart-link-rendered', $2308e6f5aae12b86$var$renderExperience),
    'smart-link-authenticated': new (0, $cBycP.ConcurrentExperience)('smart-link-authenticated', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-action-invocation': new (0, $cBycP.ConcurrentExperience)('smart-link-action-invocation', $2308e6f5aae12b86$var$inlineExperience),
    'smart-link-ai-summary': new (0, $cBycP.ConcurrentExperience)('smart-link-ai-summary', $2308e6f5aae12b86$var$aiExperience)
};
const $2308e6f5aae12b86$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $2308e6f5aae12b86$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $2308e6f5aae12b86$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("kxcRq", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $c53851cced73411d$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $c53851cced73411d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $c53851cced73411d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $c53851cced73411d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $c53851cced73411d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $c53851cced73411d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $c53851cced73411d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $c53851cced73411d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $c53851cced73411d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $c53851cced73411d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $c53851cced73411d$export$d2b8fb9e780e17e7);

var $5uXOq = parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $imVhc = parcelRequire("imVhc");

var $8dVIb = parcelRequire("8dVIb");

var $liAf6 = parcelRequire("liAf6");
const $c53851cced73411d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($c53851cced73411d$export$e6c5ffa684aac4d7() || $c53851cced73411d$export$d8de0cd37d316fdf(evt) || $c53851cced73411d$export$5b1771037ab7c451(evt));
const $c53851cced73411d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $c53851cced73411d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $VSDnB.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $c53851cced73411d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $c53851cced73411d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase()) : $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $c53851cced73411d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? $c53851cced73411d$var$getTypeToIconMap(fileMimeType.toLowerCase()) : $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label] = icon;
    return label;
};


















































const $c53851cced73411d$var$typeToIcon = {
    'text/plain': [
        'Document',
        ()=>Promise.resolve((parcelRequire("duwKf")))
    ],
    'application/vnd.oasis.opendocument.text': [
        'Document',
        ()=>Promise.resolve((parcelRequire("duwKf")))
    ],
    'application/vnd.apple.pages': [
        'Document',
        ()=>Promise.resolve((parcelRequire("duwKf")))
    ],
    'application/vnd.google-apps.document': [
        'Google Doc',
        ()=>(parcelRequire("6q8Pr"))
    ],
    'application/msword': [
        'Word document',
        ()=>(parcelRequire("e3PhT"))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        'Word document',
        ()=>(parcelRequire("e3PhT"))
    ],
    'application/pdf': [
        'PDF document',
        ()=>(parcelRequire("55TA3"))
    ],
    'application/vnd.oasis.opendocument.spreadsheet': [
        'Spreadsheet',
        ()=>(parcelRequire("lb4t9"))
    ],
    'application/vnd.apple.numbers': [
        'Spreadsheet',
        ()=>(parcelRequire("lb4t9"))
    ],
    'application/vnd.google-apps.spreadsheet': [
        'Google Sheet',
        ()=>(parcelRequire("bwXIZ"))
    ],
    'application/vnd.ms-excel': [
        'Excel spreadsheet',
        ()=>(parcelRequire("8vv4H"))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        'Excel spreadsheet',
        ()=>(parcelRequire("8vv4H"))
    ],
    'application/vnd.oasis.opendocument.presentation': [
        'Presentation',
        ()=>(parcelRequire("2t9Hh"))
    ],
    'application/vnd.apple.keynote': [
        'Presentation',
        ()=>(parcelRequire("2t9Hh"))
    ],
    'application/vnd.google-apps.presentation': [
        'Google Slide',
        ()=>(parcelRequire("6SoQO"))
    ],
    'application/vnd.ms-powerpoint': [
        'PowerPoint presentation',
        ()=>(parcelRequire("TZHl8"))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        'PowerPoint presentation',
        ()=>(parcelRequire("TZHl8"))
    ],
    'application/vnd.google-apps.form': [
        'Google Form',
        ()=>(parcelRequire("3VL73"))
    ],
    'image/png': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/jpeg': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/bmp': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/webp': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/svg+xml': [
        'Image',
        ()=>(parcelRequire("ifmtc"))
    ],
    'image/gif': [
        'GIF',
        ()=>(parcelRequire("eogSM"))
    ],
    'audio/midi': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/mpeg': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/webm': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/ogg': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'audio/wav': [
        'Audio',
        ()=>(parcelRequire("5nV2R"))
    ],
    'video/mp4': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/quicktime': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/mov': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/webm': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/ogg': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/x-ms-wmv': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'video/x-msvideo': [
        'Video',
        ()=>(parcelRequire("6Y2WT"))
    ],
    'application/zip': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-tar': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-gtar': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-7z-compressed': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/x-apple-diskimage': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/vnd.rar': [
        'Archive',
        ()=>(parcelRequire("4m4MY"))
    ],
    'application/dmg': [
        'Executable',
        ()=>(parcelRequire("gmDdF"))
    ],
    'text/css': [
        'Source Code',
        ()=>(parcelRequire("coOzc"))
    ],
    'text/html': [
        'Source Code',
        ()=>(parcelRequire("coOzc"))
    ],
    'application/javascript': [
        'Source Code',
        ()=>(parcelRequire("coOzc"))
    ],
    'application/octet-stream': [
        'Binary file',
        ()=>(parcelRequire("ldQLy"))
    ],
    'application/invision.prototype': [
        'Prototype',
        ()=>(parcelRequire("ldQLy"))
    ],
    // TODO: Figure a way to detect those
    'application/sketch': [
        'Sketch',
        ()=>(parcelRequire("4WgJk"))
    ],
    folder: [
        'Folder',
        ()=>(parcelRequire("fjtI4"))
    ]
};



































































const $c53851cced73411d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $8dVIb.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("94rku")))
        },
        [(0, $8dVIb.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("dVpJZ")))
        },
        [(0, $8dVIb.IconType).Audio]: {
            default: ()=>(parcelRequire("6ftoN"))
        },
        [(0, $8dVIb.IconType).Code]: {
            default: ()=>(parcelRequire("a0Blm"))
        },
        [(0, $8dVIb.IconType).File]: {
            default: ()=>(parcelRequire("gp1iV"))
        },
        [(0, $8dVIb.IconType).Folder]: {
            default: ()=>(parcelRequire("jJcF3"))
        },
        [(0, $8dVIb.IconType).Generic]: {
            default: ()=>(parcelRequire("gp1iV"))
        },
        [(0, $8dVIb.IconType).Image]: {
            default: ()=>(parcelRequire("eT6gz"))
        },
        [(0, $8dVIb.IconType).Presentation]: {
            default: ()=>(parcelRequire("fHKiX"))
        },
        [(0, $8dVIb.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("9ulvP"))
        },
        [(0, $8dVIb.IconType).Video]: {
            default: ()=>(parcelRequire("3K7kY"))
        },
        [(0, $8dVIb.IconType).Project]: {
            default: ()=>(parcelRequire("1mt5h"))
        },
        [(0, $8dVIb.IconType).Template]: {
            default: ()=>(parcelRequire("vxJ9s"))
        },
        [(0, $8dVIb.IconType).Forbidden]: {
            default: ()=>Promise.resolve((parcelRequire("a8hd9")))
        },
        [(0, $8dVIb.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("jOyH3")))
        },
        [(0, $8dVIb.IconType).Archive]: {
            default: ()=>(parcelRequire("4m4MY")),
            large: ()=>(parcelRequire("6jkTx"))
        },
        [(0, $8dVIb.IconType).Executable]: {
            default: ()=>(parcelRequire("gmDdF")),
            large: ()=>Promise.resolve((parcelRequire("dGYEZ")))
        },
        [(0, $8dVIb.IconType).GIF]: {
            default: ()=>(parcelRequire("eogSM")),
            large: ()=>Promise.resolve((parcelRequire("RiK2l")))
        },
        [(0, $8dVIb.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("6q8Pr")),
            large: ()=>Promise.resolve((parcelRequire("iBOon")))
        },
        [(0, $8dVIb.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("3VL73")),
            large: ()=>Promise.resolve((parcelRequire("jdlqN")))
        },
        [(0, $8dVIb.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("bwXIZ")),
            large: ()=>Promise.resolve((parcelRequire("c70Lr")))
        },
        [(0, $8dVIb.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("6SoQO")),
            large: ()=>Promise.resolve((parcelRequire("2osAJ")))
        },
        [(0, $8dVIb.IconType).MSExcel]: {
            default: ()=>(parcelRequire("8vv4H")),
            large: ()=>Promise.resolve((parcelRequire("7zjHG")))
        },
        [(0, $8dVIb.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("TZHl8")),
            large: ()=>Promise.resolve((parcelRequire("cHwqN")))
        },
        [(0, $8dVIb.IconType).MSWord]: {
            default: ()=>(parcelRequire("e3PhT")),
            large: ()=>Promise.resolve((parcelRequire("2sfBf")))
        },
        [(0, $8dVIb.IconType).PDF]: {
            default: ()=>(parcelRequire("55TA3")),
            large: ()=>Promise.resolve((parcelRequire("2tm8x")))
        },
        [(0, $8dVIb.IconType).Sketch]: {
            default: ()=>(parcelRequire("4WgJk")),
            large: ()=>Promise.resolve((parcelRequire("iABw2")))
        },
        // Bitbucket icons
        [(0, $8dVIb.IconType).Branch]: {
            default: ()=>(parcelRequire("cAU6j")),
            large: ()=>(parcelRequire("4rggH"))
        },
        [(0, $8dVIb.IconType).Commit]: {
            default: ()=>(parcelRequire("bn2CC")),
            large: ()=>(parcelRequire("2nXLN"))
        },
        [(0, $8dVIb.IconType).PullRequest]: {
            default: ()=>(parcelRequire("cIR4U")),
            large: ()=>(parcelRequire("d4Msz"))
        },
        [(0, $8dVIb.IconType).Repo]: {
            default: ()=>(parcelRequire("bbgWK")),
            large: ()=>(parcelRequire("4Z42j"))
        },
        // Jira icons
        [(0, $8dVIb.IconType).Bug]: {
            default: ()=>(parcelRequire("jNgVH")),
            large: ()=>(parcelRequire("9LCHw"))
        },
        [(0, $8dVIb.IconType).Change]: {
            default: ()=>(parcelRequire("hhL96")),
            large: ()=>(parcelRequire("tyrb0"))
        },
        [(0, $8dVIb.IconType).Epic]: {
            default: ()=>(parcelRequire("9q15g")),
            large: ()=>(parcelRequire("fwsJh"))
        },
        [(0, $8dVIb.IconType).Incident]: {
            default: ()=>(parcelRequire("14Fhu")),
            large: ()=>(parcelRequire("2EQdA"))
        },
        [(0, $8dVIb.IconType).Problem]: {
            default: ()=>(parcelRequire("3Qygt")),
            large: ()=>(parcelRequire("7GCAt"))
        },
        [(0, $8dVIb.IconType).ServiceRequest]: {
            default: ()=>(parcelRequire("7J5Ma")),
            large: ()=>(parcelRequire("akYbd"))
        },
        [(0, $8dVIb.IconType).Story]: {
            default: ()=>(parcelRequire("iErKi")),
            large: ()=>(parcelRequire("fuaYA"))
        },
        [(0, $8dVIb.IconType).SubTask]: {
            default: ()=>(parcelRequire("kBegL")),
            large: ()=>(parcelRequire("5sJWF"))
        },
        [(0, $8dVIb.IconType).Task]: {
            default: ()=>(parcelRequire("dqT3O")),
            large: ()=>(parcelRequire("gQ4Nj"))
        },
        // Provider icons
        [(0, $8dVIb.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $8dVIb.IconType).Jira]: {
            default: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        }
    };
};
const $c53851cced73411d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $liAf6.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $c53851cced73411d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $c53851cced73411d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $c53851cced73411d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $c53851cced73411d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $c53851cced73411d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $c53851cced73411d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $c53851cced73411d$export$e772c8ff12451969(interval);
            return $c53851cced73411d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $c53851cced73411d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $c53851cced73411d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $c53851cced73411d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $imVhc.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $c53851cced73411d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $8dVIb.SmartLinkSize).Large,
        (0, $8dVIb.SmartLinkSize).XLarge
    ].includes(size);

});
parcelRegister("8dVIb", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $ad6fd5c2f706e309$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $ad6fd5c2f706e309$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $ad6fd5c2f706e309$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $ad6fd5c2f706e309$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $ad6fd5c2f706e309$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $ad6fd5c2f706e309$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $ad6fd5c2f706e309$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $ad6fd5c2f706e309$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $ad6fd5c2f706e309$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $ad6fd5c2f706e309$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $ad6fd5c2f706e309$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $ad6fd5c2f706e309$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $ad6fd5c2f706e309$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $ad6fd5c2f706e309$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $ad6fd5c2f706e309$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $ad6fd5c2f706e309$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $ad6fd5c2f706e309$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $ad6fd5c2f706e309$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804);
const $ad6fd5c2f706e309$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $ad6fd5c2f706e309$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $ad6fd5c2f706e309$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $ad6fd5c2f706e309$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $ad6fd5c2f706e309$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $ad6fd5c2f706e309$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $ad6fd5c2f706e309$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $ad6fd5c2f706e309$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $ad6fd5c2f706e309$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $ad6fd5c2f706e309$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $ad6fd5c2f706e309$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $ad6fd5c2f706e309$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $ad6fd5c2f706e309$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $ad6fd5c2f706e309$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $ad6fd5c2f706e309$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $ad6fd5c2f706e309$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $ad6fd5c2f706e309$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $ad6fd5c2f706e309$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("liAf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67e22f2f57cb4a6$export$2e2bcd8739ae039);

var $8dVIb = parcelRequire("8dVIb");
const $d67e22f2f57cb4a6$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $8dVIb.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $8dVIb.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $8dVIb.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $8dVIb.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $8dVIb.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $8dVIb.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $8dVIb.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $8dVIb.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $8dVIb.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $8dVIb.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $8dVIb.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $8dVIb.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $8dVIb.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $8dVIb.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $8dVIb.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $8dVIb.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $8dVIb.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $8dVIb.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $8dVIb.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $8dVIb.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $8dVIb.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $d67e22f2f57cb4a6$export$2e2bcd8739ae039 = $d67e22f2f57cb4a6$var$extractFileFormatIcon;

});

parcelRegister("duwKf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9d277a30a5a98acd$var$_react = $9d277a30a5a98acd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9d277a30a5a98acd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d277a30a5a98acd$var$Document16Icon = (props)=>/*#__PURE__*/ $9d277a30a5a98acd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$9d277a30a5a98acd$var$Document16Icon.displayName = 'Document16Icon';
var $9d277a30a5a98acd$var$_default = module.exports.default = $9d277a30a5a98acd$var$Document16Icon;

});

parcelRegister("6q8Pr", function(module, exports) {

let $4acc04fa6828837e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4acc04fa6828837e$var$load("7EgS6").then(()=>parcelRequire('3KifV'));

});

parcelRegister("e3PhT", function(module, exports) {

let $a3c92121ff44871f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a3c92121ff44871f$var$load("erQ4S").then(()=>parcelRequire('im5Hg'));

});

parcelRegister("55TA3", function(module, exports) {

let $3b5888855c97ba42$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b5888855c97ba42$var$load("d767x").then(()=>parcelRequire('5m93C'));

});

parcelRegister("lb4t9", function(module, exports) {

let $f6ae178ddd88f3b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f6ae178ddd88f3b4$var$load("lQ9xE").then(()=>parcelRequire('2Bgv8'));

});

parcelRegister("bwXIZ", function(module, exports) {

let $865102f672a4212f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $865102f672a4212f$var$load("izomc").then(()=>parcelRequire('iByEQ'));

});

parcelRegister("8vv4H", function(module, exports) {

let $631952ccff1c149a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $631952ccff1c149a$var$load("5I4RC").then(()=>parcelRequire('eABwY'));

});

parcelRegister("2t9Hh", function(module, exports) {

let $1cc5cfd630a69c27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1cc5cfd630a69c27$var$load("iV5W6").then(()=>parcelRequire('h7zk4'));

});

parcelRegister("6SoQO", function(module, exports) {

let $501b100cfa76ff8e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $501b100cfa76ff8e$var$load("jepjM").then(()=>parcelRequire('F35X1'));

});

parcelRegister("TZHl8", function(module, exports) {

let $0a84ff1cb84378c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a84ff1cb84378c5$var$load("3YI2r").then(()=>parcelRequire('kKp2J'));

});

parcelRegister("3VL73", function(module, exports) {

let $2dcb3d9afd9c957a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2dcb3d9afd9c957a$var$load("cwkUf").then(()=>parcelRequire('j8IiS'));

});

parcelRegister("ifmtc", function(module, exports) {

let $d48b0ecc93ef9e55$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d48b0ecc93ef9e55$var$load("hVGrh").then(()=>parcelRequire('daL8e'));

});

parcelRegister("eogSM", function(module, exports) {

let $a7a0671937c9e1f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a7a0671937c9e1f3$var$load("aAton").then(()=>parcelRequire('96Idm'));

});

parcelRegister("5nV2R", function(module, exports) {

let $3ebb59b9b44ae7f7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ebb59b9b44ae7f7$var$load("iDnD4").then(()=>parcelRequire('dOkKo'));

});

parcelRegister("6Y2WT", function(module, exports) {

let $512aa2425db43ab6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $512aa2425db43ab6$var$load("dhQt8").then(()=>parcelRequire('lDRqn'));

});

parcelRegister("4m4MY", function(module, exports) {

let $32bcee7caa856311$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32bcee7caa856311$var$load("7QDLp").then(()=>parcelRequire('8njZH'));

});

parcelRegister("gmDdF", function(module, exports) {

let $be9d1f90638c1db6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be9d1f90638c1db6$var$load("b2yZA").then(()=>parcelRequire('lp0fk'));

});

parcelRegister("coOzc", function(module, exports) {

let $906ef36933b15f5b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $906ef36933b15f5b$var$load("5khw4").then(()=>parcelRequire('6cEsd'));

});

parcelRegister("ldQLy", function(module, exports) {

let $f733be138af3b35d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f733be138af3b35d$var$load("c1Yqk").then(()=>parcelRequire('7BHMh'));

});

parcelRegister("4WgJk", function(module, exports) {

let $39898e76c9d3a3c2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39898e76c9d3a3c2$var$load("a5lMy").then(()=>parcelRequire('lE6mu'));

});

parcelRegister("fjtI4", function(module, exports) {

let $b25fad1f7947bb8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b25fad1f7947bb8b$var$load("gaqBx").then(()=>parcelRequire('bBHpS'));

});

parcelRegister("94rku", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $56fb369bc3845a35$export$2e2bcd8739ae039);

var $duwKf = parcelRequire("duwKf");

var $kdfZa = parcelRequire("kdfZa");

var $50H21 = parcelRequire("50H21");
const $56fb369bc3845a35$var$PageIconWithColor = (0, $50H21.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), 'blueBold', (0, (/*@__PURE__*/$parcel$interopDefault($duwKf))));
$56fb369bc3845a35$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $56fb369bc3845a35$export$2e2bcd8739ae039 = $56fb369bc3845a35$var$PageIconWithColor;

});
parcelRegister("50H21", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $399bb260cc38f0bb$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $399bb260cc38f0bb$export$87c3646d0e299cfe);

var $5uXOq = parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");
const $399bb260cc38f0bb$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $399bb260cc38f0bb$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $kxcRq.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconLarge, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconSmall, props);
    };
};
const $399bb260cc38f0bb$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
            appearance: appearance,
            icon: Icon,
            size: $399bb260cc38f0bb$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LegacyIcon, props)
        });
    };
};

});


parcelRegister("dVpJZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5e665de7fe478f98$export$2e2bcd8739ae039);

var $iRZQl = parcelRequire("iRZQl");

var $7oCpB = parcelRequire("7oCpB");

var $50H21 = parcelRequire("50H21");
const $5e665de7fe478f98$var$BlogIconWithColor = (0, $50H21.renderIconPerSize)((0, $iRZQl.default), (0, $7oCpB.default));
$5e665de7fe478f98$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $5e665de7fe478f98$export$2e2bcd8739ae039 = $5e665de7fe478f98$var$BlogIconWithColor;

});
parcelRegister("iRZQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $24299d4e22463111$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845767e81b63ae055da0ba81295847f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $hZgcq = parcelRequire("hZgcq");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $24299d4e22463111$var$Blog16Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZgcq.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZgcq.default), {
        label: label,
        testId: testId
    });
};
$24299d4e22463111$var$Blog16Icon.displayName = 'Blog16Icon';
var $24299d4e22463111$export$2e2bcd8739ae039 = $24299d4e22463111$var$Blog16Icon;

});
parcelRegister("2UiHO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b40f413d9c2b5f3f2478820c1b2dc6e9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21df524c58bafc58$var$_react = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $21df524c58bafc58$var$_baseNew = $21df524c58bafc58$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $21df524c58bafc58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21df524c58bafc58$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $21df524c58bafc58$var$_react.default.createElement($21df524c58bafc58$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 13.25A3.25 3.25 0 0 0 6.25 10V8.25m0 0V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v3c0 .69.56 1.25 1.25 1.25zm9 0V4c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25zm0 0V10A3.25 3.25 0 0 1 12 13.25"/>`
    }, props));
$21df524c58bafc58$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $21df524c58bafc58$var$_default = module.exports.default = $21df524c58bafc58$var$QuotationMarkIcon;

});

parcelRegister("hZgcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $47749dc4aba4294e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $47749dc4aba4294e$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$47749dc4aba4294e$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$47749dc4aba4294e$export$2e2bcd8739ae039 = $47749dc4aba4294e$var$Blog16Icon;

});


parcelRegister("7oCpB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8806751d7f7ea905$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bba35c7457f1c82d9d31626969c259a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $cwmS5 = parcelRequire("cwmS5");

var $2UiHO = parcelRequire("2UiHO");

var $VSDnB = parcelRequire("VSDnB");

var $asoCt = parcelRequire("asoCt");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $8806751d7f7ea905$var$Blog24Icon = ({ label: label, testId: testId })=>{
    if ((0, $VSDnB.fg)('icon-object-migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cwmS5.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2UiHO))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $asoCt.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $asoCt.default), {
        label: label,
        testId: testId
    });
};
$8806751d7f7ea905$var$Blog24Icon.displayName = 'Blog24Icon';
var $8806751d7f7ea905$export$2e2bcd8739ae039 = $8806751d7f7ea905$var$Blog24Icon;

});
parcelRegister("asoCt", function(module, exports) {

$parcel$export(module.exports, "default", () => $158d85a5273c8dbb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7682b4d34bd2a783038ec83f3b47a94>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $c7fbr = parcelRequire("c7fbr");
const $158d85a5273c8dbb$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7fbr.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$158d85a5273c8dbb$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$158d85a5273c8dbb$export$2e2bcd8739ae039 = $158d85a5273c8dbb$var$Blog24Icon;

});



parcelRegister("6ftoN", function(module, exports) {

let $48caf2cb3a2b031c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48caf2cb3a2b031c$var$load("4AlWm").then(()=>parcelRequire('aQnRv'));

});

parcelRegister("a0Blm", function(module, exports) {

let $7496df20f241cc20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7496df20f241cc20$var$load("1oL5z").then(()=>parcelRequire('3WUNe'));

});

parcelRegister("gp1iV", function(module, exports) {

let $bf0ffe1d32436e05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bf0ffe1d32436e05$var$load("dBvdI").then(()=>parcelRequire('3vtQf'));

});

parcelRegister("jJcF3", function(module, exports) {

let $e5cc0a8e109344ba$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e5cc0a8e109344ba$var$load("h2MrD"),
    $e5cc0a8e109344ba$var$load("bYT2S"),
    $e5cc0a8e109344ba$var$load("947Ze")
]).then(()=>parcelRequire('ikced'));

});

parcelRegister("eT6gz", function(module, exports) {

let $ad6b101988e539b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad6b101988e539b4$var$load("9Rmva").then(()=>parcelRequire('aRGuz'));

});

parcelRegister("fHKiX", function(module, exports) {

let $b6eeca4f456dab34$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6eeca4f456dab34$var$load("4iYn6").then(()=>parcelRequire('gVXQp'));

});

parcelRegister("9ulvP", function(module, exports) {

let $6e879a4e86077e94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e879a4e86077e94$var$load("7tpZr").then(()=>parcelRequire('9bx9i'));

});

parcelRegister("3K7kY", function(module, exports) {

let $2b9b5c0158d75df8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2b9b5c0158d75df8$var$load("4OyEJ").then(()=>parcelRequire('T5PvZ'));

});

parcelRegister("1mt5h", function(module, exports) {

let $0fde680a0a439b5c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0fde680a0a439b5c$var$load("h2MrD"),
    $0fde680a0a439b5c$var$load("bYT2S"),
    $0fde680a0a439b5c$var$load("7aEUQ")
]).then(()=>parcelRequire('ckyDP'));

});

parcelRegister("vxJ9s", function(module, exports) {

let $05ed0ee4e8760d18$var$load = (parcelRequire("28QjX"))(4);
module.exports = $05ed0ee4e8760d18$var$load("a98CY").then(()=>parcelRequire('5mR3i'));

});

parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ba5c183c8a258f8be0ef328c0a8b726>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a87d743bb5f5b238079f9e871192b6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});


parcelRegister("6jkTx", function(module, exports) {

let $4984b9ac5dd985b2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4984b9ac5dd985b2$var$load("9HbdP").then(()=>parcelRequire('9CRO6'));

});

parcelRegister("cAU6j", function(module, exports) {

let $92b45d4aa046f329$var$load = (parcelRequire("28QjX"))(4);
module.exports = $92b45d4aa046f329$var$load("evpxF").then(()=>parcelRequire('4sBeG'));

});

parcelRegister("4rggH", function(module, exports) {

let $33b64d92455eac54$var$load = (parcelRequire("28QjX"))(4);
module.exports = $33b64d92455eac54$var$load("g985s").then(()=>parcelRequire('l04jD'));

});

parcelRegister("bn2CC", function(module, exports) {

let $8473e052ffb4388d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8473e052ffb4388d$var$load("kAF19").then(()=>parcelRequire('bPjbr'));

});

parcelRegister("2nXLN", function(module, exports) {

let $1bcc17d3fb7fe2fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1bcc17d3fb7fe2fd$var$load("16ic3").then(()=>parcelRequire('52A0r'));

});

parcelRegister("cIR4U", function(module, exports) {

let $9432c454ef92166f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9432c454ef92166f$var$load("7R5g7").then(()=>parcelRequire('6qWjs'));

});

parcelRegister("d4Msz", function(module, exports) {

let $98513d3325793783$var$load = (parcelRequire("28QjX"))(4);
module.exports = $98513d3325793783$var$load("gvHhR").then(()=>parcelRequire('c9Fqq'));

});

parcelRegister("bbgWK", function(module, exports) {

let $823dde017897a8a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $823dde017897a8a8$var$load("6TtDJ").then(()=>parcelRequire('ezu4w'));

});

parcelRegister("4Z42j", function(module, exports) {

let $3a0ffd720a4a477e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3a0ffd720a4a477e$var$load("1NHTB").then(()=>parcelRequire('6OpPE'));

});

parcelRegister("jNgVH", function(module, exports) {

let $e68fb9c58ac59414$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e68fb9c58ac59414$var$load("kgx4U").then(()=>parcelRequire('iAkpb'));

});

parcelRegister("9LCHw", function(module, exports) {

let $71c6860eabfcf304$var$load = (parcelRequire("28QjX"))(4);
module.exports = $71c6860eabfcf304$var$load("9PpGe").then(()=>parcelRequire('41M8N'));

});

parcelRegister("hhL96", function(module, exports) {

let $c958985d73c1112b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c958985d73c1112b$var$load("eSwNo").then(()=>parcelRequire('jnURg'));

});

parcelRegister("tyrb0", function(module, exports) {

let $058d6c15a4a2e74c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $058d6c15a4a2e74c$var$load("bSBaJ").then(()=>parcelRequire('4MX1d'));

});

parcelRegister("9q15g", function(module, exports) {

let $6db76207028d4cfd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6db76207028d4cfd$var$load("cUQWc").then(()=>parcelRequire('gAdQO'));

});

parcelRegister("fwsJh", function(module, exports) {

let $b4d021375f2ba907$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4d021375f2ba907$var$load("3w7tM").then(()=>parcelRequire('eHc1t'));

});

parcelRegister("14Fhu", function(module, exports) {

let $0c862fbc2ccb568d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c862fbc2ccb568d$var$load("j373d").then(()=>parcelRequire('6ClRv'));

});

parcelRegister("2EQdA", function(module, exports) {

let $1ef7d29d585441a3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1ef7d29d585441a3$var$load("hdkrH").then(()=>parcelRequire('529Ow'));

});

parcelRegister("3Qygt", function(module, exports) {

let $2cd0ceaab7b162da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2cd0ceaab7b162da$var$load("9HJjr").then(()=>parcelRequire('1ni2E'));

});

parcelRegister("7GCAt", function(module, exports) {

let $598a634b3bebd565$var$load = (parcelRequire("28QjX"))(4);
module.exports = $598a634b3bebd565$var$load("fcEu0").then(()=>parcelRequire('gaBfD'));

});

parcelRegister("7J5Ma", function(module, exports) {

let $5a013757451c6962$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a013757451c6962$var$load("jXTSM").then(()=>parcelRequire('kQSMP'));

});

parcelRegister("akYbd", function(module, exports) {

let $786a741696fc3955$var$load = (parcelRequire("28QjX"))(4);
module.exports = $786a741696fc3955$var$load("2nFSk").then(()=>parcelRequire('36Q2c'));

});

parcelRegister("iErKi", function(module, exports) {

let $d9417c2310d04e80$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d9417c2310d04e80$var$load("hU82q").then(()=>parcelRequire('kvhCa'));

});

parcelRegister("fuaYA", function(module, exports) {

let $b4622c006adc733a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4622c006adc733a$var$load("cVndS").then(()=>parcelRequire('21nCU'));

});

parcelRegister("kBegL", function(module, exports) {

let $eff254ee4c0946e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eff254ee4c0946e8$var$load("3YoR7").then(()=>parcelRequire('dvo9I'));

});

parcelRegister("5sJWF", function(module, exports) {

let $3fa33507f5ae198f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3fa33507f5ae198f$var$load("hYBCI").then(()=>parcelRequire('93zHH'));

});

parcelRegister("dqT3O", function(module, exports) {

let $9c7869f611584426$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9c7869f611584426$var$load("3dBSm").then(()=>parcelRequire('ercGv'));

});

parcelRegister("gQ4Nj", function(module, exports) {

let $c42538c02c4bc2c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c42538c02c4bc2c7$var$load("bG6hF").then(()=>parcelRequire('eFWxr'));

});

parcelRegister("7anl7", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $1c9c2365ff37a453$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $5uXOq = parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $lEsIP = parcelRequire("lEsIP");

var $6PPEt = parcelRequire("6PPEt");

var $iVs6J = parcelRequire("iVs6J");
const $1c9c2365ff37a453$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $6PPEt.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $1c9c2365ff37a453$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lEsIP.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lEsIP.defaultLogoParams).iconColor, textColor: textColor = (0, $lEsIP.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iVs6J.default), {
        appearance: appearance,
        label: label,
        svg: $1c9c2365ff37a453$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("5igsJ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $31931ec4ffeaf53a$export$eaff10f7ec59c455);

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $ffYTp = parcelRequire("ffYTp");

var $051X7 = parcelRequire("051X7");

var $cCcdH = parcelRequire("cCcdH");

var $hjhAz = parcelRequire("hjhAz");

var $fzJZi = parcelRequire("fzJZi");
const $31931ec4ffeaf53a$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $ffYTp.getResolvedAttributes)(linkDetails, details, linkStatus)
    });
const $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url })=>{
    const resolvedAttributes = $31931ec4ffeaf53a$var$getExtendedResolvedAttributes({
        url: url
    }, response, status);
    return {
        source: source,
        attributes: {
            ...(0, $fzJZi.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $31931ec4ffeaf53a$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const state = store ? (0, $cCcdH.getUrl)(store, url) : undefined;
    return (0, $5uXOq.useMemo)(()=>{
        return $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url
    ]);
};
const $31931ec4ffeaf53a$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status } = (0, $hjhAz.useSmartCardState)(url);
    const data = $31931ec4ffeaf53a$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
        data: data
    }, children);
};

});
parcelRegister("ffYTp", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $842bbc6d3f3b5d59$export$7243431f5325a7b);

var $fiKQs = parcelRequire("fiKQs");

var $iHcpV = parcelRequire("iHcpV");
const $842bbc6d3f3b5d59$export$7243431f5325a7b = (linkDetails, details, linkStatus)=>{
    const status = linkStatus ?? (details && (0, $fiKQs.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $iHcpV.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("fiKQs", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $5c2f531cb20db568$export$b70265791d2079d4);
const $5c2f531cb20db568$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $5c2f531cb20db568$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $5c2f531cb20db568$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("iHcpV", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $1a9daeca9ad503b7$export$28ddbae335bd80b5);
const $1a9daeca9ad503b7$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});


parcelRegister("051X7", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $b8de051ddcb2808f$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $b8de051ddcb2808f$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $b8de051ddcb2808f$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $b8de051ddcb2808f$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $b8de051ddcb2808f$export$2a29ca11e08dc129);

var $5uXOq = parcelRequire("5uXOq");

const $b8de051ddcb2808f$export$156b523e63b4f63a = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
function $b8de051ddcb2808f$export$e1d190b530cf0ee9() {
    const context = (0, $5uXOq.useContext)($b8de051ddcb2808f$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $b8de051ddcb2808f$export$10e9cca30e50f657 = ()=>$b8de051ddcb2808f$var$useContextMemoized($b8de051ddcb2808f$export$156b523e63b4f63a);
const $b8de051ddcb2808f$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $b8de051ddcb2808f$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
function $b8de051ddcb2808f$var$useContextMemoized(reactContext) {
    const value = (0, $5uXOq.useContext)(reactContext);
    const context = (0, $5uXOq.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $b8de051ddcb2808f$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $b8de051ddcb2808f$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Provider, {
        value: cardContext.value
    }, children);
};
var $b8de051ddcb2808f$export$2e2bcd8739ae039 = $b8de051ddcb2808f$export$156b523e63b4f63a;

});

parcelRegister("cCcdH", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $ca3b29c0c8dd3593$export$94df0e59ebebf4a7);
const $ca3b29c0c8dd3593$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("hjhAz", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $7fb324870ee27912$export$b0444d00ba7313c6);

var $bDWQ3 = parcelRequire("bDWQ3");

var $051X7 = parcelRequire("051X7");
const $7fb324870ee27912$var$PENDING_STATE = {
    status: 'pending'
};
function $7fb324870ee27912$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $051X7.useSmartLinkContext)();
    const cardState = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $7fb324870ee27912$var$PENDING_STATE;
}

});


parcelRegister("91tw3", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $f30ba994fabdf720$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $f30ba994fabdf720$export$df0092b19156b140);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $f30ba994fabdf720$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $f30ba994fabdf720$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $f30ba994fabdf720$export$c0547b4405cae584);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $66ZRy = parcelRequire("66ZRy");
var $buvhv = parcelRequire("buvhv");
var $hYQw7 = parcelRequire("hYQw7");
var $ietxm = parcelRequire("ietxm");

var $eqoQu = parcelRequire("eqoQu");
const $f30ba994fabdf720$export$3c94e0f4719f5c2a = (children)=>{
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).some((child)=>$f30ba994fabdf720$export$df0092b19156b140(child))) return true;
    return false;
};
const $f30ba994fabdf720$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!(0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && Object.values($66ZRy).some((type)=>type === node.type);
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider') {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!isChildrenValid) return;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($66ZRy).some((type)=>type === node.type)) return true;
    return false;
};
const $f30ba994fabdf720$export$d7fc505bb0bd5756 = (node)=>{
    if (!(0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && Object.values($eqoQu).some((type)=>type === node.type);
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (Object.values($eqoQu).some((type)=>type === node.type)) return true;
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!isChildrenValid) return;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$df0092b19156b140 = (node)=>{
    if (!(0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $buvhv.default);
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $buvhv.default)) return true;
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!isChildrenValid) return;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$c0547b4405cae584 = (node)=>{
    if (!(0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $hYQw7.default);
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $hYQw7.default)) return true;
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!isChildrenValid) return;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $f30ba994fabdf720$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $f30ba994fabdf720$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $ietxm.default);

});
parcelRegister("66ZRy", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("ietxm")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gg6Qm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("hYQw7")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("1JaZ4")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("buvhv")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("dghu0")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("5HrTg")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("1qDIM")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("85ffk")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("fh9qw")).default);

var $ietxm = parcelRequire("ietxm");

var $gg6Qm = parcelRequire("gg6Qm");

var $hYQw7 = parcelRequire("hYQw7");

var $1JaZ4 = parcelRequire("1JaZ4");

var $buvhv = parcelRequire("buvhv");

var $dghu0 = parcelRequire("dghu0");

var $5HrTg = parcelRequire("5HrTg");

var $1qDIM = parcelRequire("1qDIM");

var $85ffk = parcelRequire("85ffk");

var $fh9qw = parcelRequire("fh9qw");

});
parcelRegister("ietxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fcebb5ad9978d90$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $5HrTg = parcelRequire("5HrTg");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $3fcebb5ad9978d90$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HrTg.default), {
        ...props,
        testId: testId
    });
};
var $3fcebb5ad9978d90$export$2e2bcd8739ae039 = $3fcebb5ad9978d90$var$FooterBlock;

});
parcelRegister("5HrTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8eaafd3e75b73f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");

var $dEOWY = parcelRequire("dEOWY");
const $b8eaafd3e75b73f4$var$actionGroupStyles = null;
const $b8eaafd3e75b73f4$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $8dVIb.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const hasActions = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ $5uXOq.createElement((0, $eqoQu.Provider), {
        testId: `${testId}-provider`
    }), actions && hasActions ? /*#__PURE__*/ $5uXOq.createElement((0, $1BfaB.default), {
        testId: "smart-element-group-actions",
        align: (0, $8dVIb.SmartLinkAlignment).Right,
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
        width: (0, $8dVIb.SmartLinkWidth).Flexible,
        className: (0, $bwpsq.default)([
            size === (0, $8dVIb.SmartLinkSize).XLarge && "_c71lviql"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $bubxq.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: "default",
        size: size
    })) : null);
};
const $b8eaafd3e75b73f4$var$FooterBlockResolvedViewExported = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($b8eaafd3e75b73f4$var$FooterBlockResolvedView, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $dEOWY.default), props);
};
var $b8eaafd3e75b73f4$export$2e2bcd8739ae039 = $b8eaafd3e75b73f4$var$FooterBlockResolvedViewExported;

});
parcelRegister("Nh1XU", function(module, exports) {

$parcel$export(module.exports, "FlexibleUiContext", () => $79a38154bf117346$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $79a38154bf117346$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $79a38154bf117346$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $79a38154bf117346$export$e6b5ad18b56e8f51);

var $5uXOq = parcelRequire("5uXOq");
const $79a38154bf117346$export$ca70b164b615de47 = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$61d7957a243df7aa = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$ca70b164b615de47);
const $79a38154bf117346$export$f7433dbd6c50e26a = (0, $5uXOq.createContext)(undefined);
const $79a38154bf117346$export$e6b5ad18b56e8f51 = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$f7433dbd6c50e26a);

});

parcelRegister("eqoQu", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $ec376f2b71614cc0$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $ec376f2b71614cc0$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $ec376f2b71614cc0$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $ec376f2b71614cc0$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $ec376f2b71614cc0$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $ec376f2b71614cc0$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $ec376f2b71614cc0$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $ec376f2b71614cc0$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $ec376f2b71614cc0$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $ec376f2b71614cc0$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $ec376f2b71614cc0$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $ec376f2b71614cc0$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $ec376f2b71614cc0$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $ec376f2b71614cc0$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $ec376f2b71614cc0$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $ec376f2b71614cc0$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $ec376f2b71614cc0$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $ec376f2b71614cc0$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $ec376f2b71614cc0$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $ec376f2b71614cc0$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $ec376f2b71614cc0$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $ec376f2b71614cc0$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $ec376f2b71614cc0$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $ec376f2b71614cc0$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $ec376f2b71614cc0$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $ec376f2b71614cc0$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $ec376f2b71614cc0$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $ec376f2b71614cc0$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $ec376f2b71614cc0$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $ec376f2b71614cc0$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $ec376f2b71614cc0$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $ec376f2b71614cc0$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("kDhrr")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("kp8aU")).default);

var $8dVIb = parcelRequire("8dVIb");

var $eCsaJ = parcelRequire("eCsaJ");

var $kDhrr = parcelRequire("kDhrr");

var $kp8aU = parcelRequire("kp8aU");
const $ec376f2b71614cc0$export$d3af56c23f9e459b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedTo);
const $ec376f2b71614cc0$export$fbd18f11bf3a3444 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AssignedToGroup);
const $ec376f2b71614cc0$export$3bc3c9693a40aa = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AttachmentCount);
const $ec376f2b71614cc0$export$2ae2af4435dd6144 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).AuthorGroup);
const $ec376f2b71614cc0$export$5742b38fd5cfe410 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ChecklistProgress);
const $ec376f2b71614cc0$export$a1e647014985ddb9 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CollaboratorGroup);
const $ec376f2b71614cc0$export$f4c1466e6fdd07b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CommentCount);
const $ec376f2b71614cc0$export$53ced9403d373871 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedOn);
const $ec376f2b71614cc0$export$db468caedefbb630 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).CreatedBy);
const $ec376f2b71614cc0$export$fea59459cfa1625b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).DueOn);
const $ec376f2b71614cc0$export$2aa8c58ab6c8ae64 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LatestCommit);
const $ec376f2b71614cc0$export$69387b41dfc808f7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).LinkIcon);
const $ec376f2b71614cc0$export$18a2be9195644f38 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Location);
const $ec376f2b71614cc0$export$ebbbdcc68d717b7b = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedBy);
const $ec376f2b71614cc0$export$a6db3f4240728b58 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ModifiedOn);
const $ec376f2b71614cc0$export$fa04b1f8d953704f = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedBy);
const $ec376f2b71614cc0$export$90e81c873cca1e90 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).OwnedByGroup);
const $ec376f2b71614cc0$export$300334f671c43555 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Priority);
const $ec376f2b71614cc0$export$7904b5485bf997ea = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ProgrammingLanguage);
const $ec376f2b71614cc0$export$2881499e37b75b9a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Provider);
const $ec376f2b71614cc0$export$f69df2decd5f729e = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReactCount);
const $ec376f2b71614cc0$export$77dedcd16f070a20 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ReadTime);
const $ec376f2b71614cc0$export$897b145a1ed39fe5 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SentOn);
const $ec376f2b71614cc0$export$387c3264a8f67d61 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SourceBranch);
const $ec376f2b71614cc0$export$7254cc27399e90bd = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).State);
const $ec376f2b71614cc0$export$cfafe90bba8a54db = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubscriberCount);
const $ec376f2b71614cc0$export$d441f34e4c8dd9e7 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).SubTasksProgress);
const $ec376f2b71614cc0$export$634eef04d1a9a575 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).StoryPoints);
const $ec376f2b71614cc0$export$b5e4199e062b8f44 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).TargetBranch);
const $ec376f2b71614cc0$export$f99233281efd08a0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).Title);
const $ec376f2b71614cc0$export$ae2d8be089b6cfe0 = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).ViewCount);
const $ec376f2b71614cc0$export$b080bef6ed7fa75a = (0, $eCsaJ.createElement)((0, $8dVIb.ElementName).VoteCount);

});
parcelRegister("eCsaJ", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $3c92d860530d8c8b$export$c8a8987d4410bf2d);

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $9tslm = parcelRequire("9tslm");

var $4ZXUA = parcelRequire("4ZXUA");

var $7IZqM = parcelRequire("7IZqM");

var $bWpL0 = parcelRequire("bWpL0");

var $aWyvu = parcelRequire("aWyvu");

var $3dV67 = parcelRequire("3dV67");

var $cJxXG = parcelRequire("cJxXG");

var $77cM6 = parcelRequire("77cM6");

var $k39kU = parcelRequire("k39kU");
const $3c92d860530d8c8b$var$elementMappings = {
    [(0, $8dVIb.ElementName).AttachmentCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Attachment
        }
    },
    [(0, $8dVIb.ElementName).AuthorGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).ChecklistProgress]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).CheckItem
        }
    },
    [(0, $8dVIb.ElementName).CollaboratorGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).CommentCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Comment
        }
    },
    [(0, $8dVIb.ElementName).ViewCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).View
        }
    },
    [(0, $8dVIb.ElementName).ReactCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).React
        }
    },
    [(0, $8dVIb.ElementName).VoteCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Vote
        }
    },
    [(0, $8dVIb.ElementName).CreatedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).OwnedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).AssignedTo]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).AssignedToGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).OwnedByGroup]: {
        component: (0, $4ZXUA.default)
    },
    [(0, $8dVIb.ElementName).CreatedOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).DueOn]: {
        component: (0, $cJxXG.default)
    },
    [(0, $8dVIb.ElementName).LatestCommit]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Commit
        }
    },
    [(0, $8dVIb.ElementName).LinkIcon]: {
        component: (0, $aWyvu.default)
    },
    [(0, $8dVIb.ElementName).ModifiedBy]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).ModifiedOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).Preview]: {
        component: (0, $77cM6.default)
    },
    [(0, $8dVIb.ElementName).Priority]: {
        component: (0, $7IZqM.default)
    },
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).ProgrammingLanguage
        }
    },
    [(0, $8dVIb.ElementName).Provider]: {
        component: (0, $7IZqM.default)
    },
    [(0, $8dVIb.ElementName).ReadTime]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).SentOn]: {
        component: (0, $bWpL0.default)
    },
    [(0, $8dVIb.ElementName).SourceBranch]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).State]: {
        component: (0, $cJxXG.default)
    },
    [(0, $8dVIb.ElementName).SubscriberCount]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).Subscriber
        }
    },
    [(0, $8dVIb.ElementName).SubTasksProgress]: {
        component: (0, $7IZqM.default),
        props: {
            icon: (0, $8dVIb.IconType).SubTasksProgress
        }
    },
    [(0, $8dVIb.ElementName).StoryPoints]: {
        component: (0, $9tslm.default)
    },
    [(0, $8dVIb.ElementName).TargetBranch]: {
        component: (0, $k39kU.default)
    },
    [(0, $8dVIb.ElementName).Title]: {
        component: (0, $3dV67.default)
    },
    [(0, $8dVIb.ElementName).Location]: {
        component: (0, $3dV67.default),
        props: {
            theme: (0, $8dVIb.SmartLinkInternalTheme).Grey
        }
    }
};
const $3c92d860530d8c8b$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
const $3c92d860530d8c8b$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
        case (0, $8dVIb.ElementName).AuthorGroup:
        case (0, $8dVIb.ElementName).CollaboratorGroup:
        case (0, $8dVIb.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $8dVIb.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $3c92d860530d8c8b$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $8dVIb.ElementName).AttachmentCount:
        case (0, $8dVIb.ElementName).ChecklistProgress:
        case (0, $8dVIb.ElementName).CommentCount:
        case (0, $8dVIb.ElementName).ViewCount:
        case (0, $8dVIb.ElementName).ReactCount:
        case (0, $8dVIb.ElementName).VoteCount:
        case (0, $8dVIb.ElementName).ProgrammingLanguage:
        case (0, $8dVIb.ElementName).SubscriberCount:
        case (0, $8dVIb.ElementName).LatestCommit:
        case (0, $8dVIb.ElementName).SubTasksProgress:
            return $3c92d860530d8c8b$var$toBadgeProps(data);
        case (0, $8dVIb.ElementName).StoryPoints:
            return $3c92d860530d8c8b$var$toAtlaskitBadgeProps(data);
        case (0, $8dVIb.ElementName).CreatedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).created_by, context.createdBy);
        case (0, $8dVIb.ElementName).AssignedTo:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).assigned_to, context.assignedTo);
        case (0, $8dVIb.ElementName).OwnedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).owned_by, context.ownedBy);
        case (0, $8dVIb.ElementName).CreatedOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('created', context.createdOn);
        case (0, $8dVIb.ElementName).DueOn:
            return $3c92d860530d8c8b$var$toDateLozengeProps(context.dueOn);
        case (0, $8dVIb.ElementName).ModifiedBy:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).modified_by, context.modifiedBy);
        case (0, $8dVIb.ElementName).ModifiedOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $8dVIb.ElementName).SentOn:
            return $3c92d860530d8c8b$var$toDateTimeProps('sent', context.sentOn);
        case (0, $8dVIb.ElementName).ReadTime:
            return $3c92d860530d8c8b$var$toFormattedTextProps((0, $7zaVw.messages).read_time, data);
        case (0, $8dVIb.ElementName).SourceBranch:
        case (0, $8dVIb.ElementName).TargetBranch:
            return $3c92d860530d8c8b$var$toTextProps(data);
        case (0, $8dVIb.ElementName).Title:
            return $3c92d860530d8c8b$var$toLinkProps(context.title, context.url);
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $3c92d860530d8c8b$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $3c92d860530d8c8b$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $3c92d860530d8c8b$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $3c92d860530d8c8b$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7VHMR.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $3c92d860530d8c8b$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $3c92d860530d8c8b$var$toFormattedTextProps = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $3c92d860530d8c8b$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $3c92d860530d8c8b$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $3c92d860530d8c8b$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $3c92d860530d8c8b$var$elementMappings[name] || {};
    const contextKey = $3c92d860530d8c8b$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
        const data = $3c92d860530d8c8b$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("7zaVw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a298b78183f16654$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a298b78183f16654$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    }
});

});

parcelRegister("9tslm", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf2a1e857857107e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $VSDnB = parcelRequire("VSDnB");

var $enZzq = parcelRequire("enZzq");
const $bf2a1e857857107e$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $bf2a1e857857107e$var$AtlaskitBadgeNew = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c116y",
            className
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $16T6Y.default), null, value));
};
const $bf2a1e857857107e$var$AtlaskitBadge = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($bf2a1e857857107e$var$AtlaskitBadgeNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $enZzq.default), props);
};
var $bf2a1e857857107e$export$2e2bcd8739ae039 = $bf2a1e857857107e$var$AtlaskitBadge;

});
parcelRegister("enZzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $75cef1fb26f884a2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $16T6Y = parcelRequire("16T6Y");
function $75cef1fb26f884a2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $75cef1fb26f884a2$var$badgeStyles = {
    name: "qowjig",
    styles: "align-items:center;display:inline-flex"
};
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $75cef1fb26f884a2$var$AtlaskitBadgeOld = ({ value: value, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $75cef1fb26f884a2$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $16T6Y.default), null, value));
};
var $75cef1fb26f884a2$export$2e2bcd8739ae039 = $75cef1fb26f884a2$var$AtlaskitBadgeOld;

});


parcelRegister("4ZXUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e655d051c837701$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $jnhNB = parcelRequire("jnhNB");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $fpDmE = parcelRequire("fpDmE");

var $dHPsx = parcelRequire("dHPsx");
const $1e655d051c837701$var$MAX_COUNT = 4;
const $1e655d051c837701$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxcxkx _102oidpf",
    large: "_1e0c116y _1kvxcxkx _102oidpf",
    medium: "_1e0c116y _1kvxcxkx _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxcxkx _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $1e655d051c837701$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).assigned_to, personName);
        case (0, $8dVIb.ElementName).OwnedByGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).owned_by, personName);
        case (0, $8dVIb.ElementName).AuthorGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $1e655d051c837701$var$AvatarGroupNew = ({ items: items = [], maxCount: maxCount = $1e655d051c837701$var$MAX_COUNT, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $koVbs.default)();
    const data = (0, $5uXOq.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $8dVIb.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $1e655d051c837701$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $1e655d051c837701$var$stylesMap[size],
            className
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $jnhNB.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
const $1e655d051c837701$var$AvatarGroup = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($1e655d051c837701$var$AvatarGroupNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $dHPsx.default), props);
};
var $1e655d051c837701$export$2e2bcd8739ae039 = $1e655d051c837701$var$AvatarGroup;

});
parcelRegister("fpDmE", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $3ebf94f205ad0182$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $3ebf94f205ad0182$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $3ebf94f205ad0182$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconSizeStyles", () => $3ebf94f205ad0182$export$a5dfadfde90ee066);
$parcel$export(module.exports, "getIconWidthNew", () => $3ebf94f205ad0182$export$86b6226ea65a6ddf);
$parcel$export(module.exports, "getIconWidth", () => $3ebf94f205ad0182$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $3ebf94f205ad0182$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getLinkLineHeight", () => $3ebf94f205ad0182$export$1826e889cc97649);
$parcel$export(module.exports, "getLinkSizeStyles", () => $3ebf94f205ad0182$export$7c3a25542ae9da0e);
$parcel$export(module.exports, "getMaxLineHeight", () => $3ebf94f205ad0182$export$a681bd062fee88a5);
$parcel$export(module.exports, "getMaxLines", () => $3ebf94f205ad0182$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $3ebf94f205ad0182$export$475c391af8171fec);
$parcel$export(module.exports, "getPrimitivesPaddingSpaceBySize", () => $3ebf94f205ad0182$export$1af10e3728e3a644);
$parcel$export(module.exports, "getTruncateStyles", () => $3ebf94f205ad0182$export$8847c5561c06da49);
$parcel$export(module.exports, "hasWhiteSpace", () => $3ebf94f205ad0182$export$619e376a425cb759);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $4qBtX = parcelRequire("4qBtX");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");
const $3ebf94f205ad0182$export$9d642f65a919fb93 = {
    [(0, $8dVIb.SmartLinkSize).Small]: 'none',
    [(0, $8dVIb.SmartLinkSize).Medium]: 'compact',
    [(0, $8dVIb.SmartLinkSize).Large]: 'compact',
    [(0, $8dVIb.SmartLinkSize).XLarge]: 'default'
};
const $3ebf94f205ad0182$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...descriptor,
            values: values
        });
    }
};
const $3ebf94f205ad0182$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
/**
 * @deprecated remove on FF bandicoots-compiled-migration-smartcard clean up
 */ const $3ebf94f205ad0182$var$getIconDimensionStyles = (value)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: value
    });
const $3ebf94f205ad0182$export$a5dfadfde90ee066 = (width)=>{
    const sizeStyles = $3ebf94f205ad0182$var$getIconDimensionStyles(width);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)("flex:0 0 auto;", sizeStyles, " span,svg,img{", sizeStyles, ";}svg{padding:0;}");
};
const $3ebf94f205ad0182$export$ce56b6021549537 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return '2rem';
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return '1rem';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '.75rem';
    }
};
const $3ebf94f205ad0182$export$86b6226ea65a6ddf = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $3ebf94f205ad0182$export$fb10bc5609c6347e = (size)=>{
    return (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? $3ebf94f205ad0182$export$86b6226ea65a6ddf(size) : $3ebf94f205ad0182$export$ce56b6021549537(size);
};
const $3ebf94f205ad0182$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $3ebf94f205ad0182$export$1826e889cc97649 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Large:
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $3ebf94f205ad0182$export$7c3a25542ae9da0e = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return /*#__PURE__*/ (0, $f8Sb3.css)({
                font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                fontWeight: "var(--ds-font-weight-regular, 400)",
                lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
            });
        case (0, $8dVIb.SmartLinkSize).Large:
        case (0, $8dVIb.SmartLinkSize).Medium:
            return /*#__PURE__*/ (0, $f8Sb3.css)({
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                fontWeight: "var(--ds-font-weight-regular, 400)",
                lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
            });
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return /*#__PURE__*/ (0, $f8Sb3.css)({
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                fontWeight: "var(--ds-font-weight-regular, 400)",
                lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
            });
    }
};
const $3ebf94f205ad0182$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1.75;
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $3ebf94f205ad0182$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $3ebf94f205ad0182$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $8dVIb.SmartLinkSize).Large:
            return 'space.200';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $3ebf94f205ad0182$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 'space.300';
        case (0, $8dVIb.SmartLinkSize).Large:
            return 'space.250';
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 'space.200';
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 'space.100';
    }
};
const $3ebf94f205ad0182$export$8847c5561c06da49 = (maxLines, lineHeight = '1rem', wordBreak = 'break-word')=>/*#__PURE__*/ (0, $f8Sb3.css)({
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        wordBreak: wordBreak,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        '@supports not (-webkit-line-clamp: 1)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxHeight: `calc(${maxLines} * ${lineHeight})`
        }
    });
const $3ebf94f205ad0182$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});

parcelRegister("dHPsx", function(module, exports) {

$parcel$export(module.exports, "default", () => $75ab4e9bd388d553$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $koVbs = parcelRequire("koVbs");

var $jnhNB = parcelRequire("jnhNB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $fpDmE = parcelRequire("fpDmE");
function $75ab4e9bd388d553$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $75ab4e9bd388d553$var$MAX_COUNT = 4;
var $75ab4e9bd388d553$var$_ref = {
    name: "1brfzli",
    styles: "display:inline-flex;ul{margin-right:var(--ds-space-100, 0.5rem);margin-top:0;}"
};
const $75ab4e9bd388d553$var$getStyles = (size)=>{
    const styles = $75ab4e9bd388d553$var$_ref;
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            // Default AK small size
            return styles;
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
            return /*#__PURE__*/ (0, $f8Sb3.css)(styles, " li{span,svg{max-height:1.25rem;max-width:1.25rem;}}");
    }
};
const $75ab4e9bd388d553$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $8dVIb.ElementName).AssignedToGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).assigned_to, personName);
        case (0, $8dVIb.ElementName).OwnedByGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).owned_by, personName);
        case (0, $8dVIb.ElementName).AuthorGroup:
            return (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $75ab4e9bd388d553$var$AvatarGroupOld = ({ items: items = [], maxCount: maxCount = $75ab4e9bd388d553$var$MAX_COUNT, name: name, overrideCss: overrideCss, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $koVbs.default)();
    const data = (0, $5uXOq.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $8dVIb.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fpDmE.getFormattedMessageAsString)(intl, (0, $7zaVw.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $75ab4e9bd388d553$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $75ab4e9bd388d553$var$getStyles(size),
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jnhNB.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $75ab4e9bd388d553$export$2e2bcd8739ae039 = $75ab4e9bd388d553$var$AvatarGroupOld;

});


parcelRegister("7IZqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab9f19acb0d3ec1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");

var $1kJhy = parcelRequire("1kJhy");
const $aab9f19acb0d3ec1$var$badgeStyles = null;
const $aab9f19acb0d3ec1$var$iconStyles = null;
// ${getIconSizeStyles('1rem')}
const $aab9f19acb0d3ec1$var$labelStyles = null;
const $aab9f19acb0d3ec1$var$messageMapper = {
    [(0, $8dVIb.IconType).PriorityBlocker]: (0, $7zaVw.messages).priority_blocker,
    [(0, $8dVIb.IconType).PriorityCritical]: (0, $7zaVw.messages).priority_critical,
    [(0, $8dVIb.IconType).PriorityHigh]: (0, $7zaVw.messages).priority_high,
    [(0, $8dVIb.IconType).PriorityHighest]: (0, $7zaVw.messages).priority_highest,
    [(0, $8dVIb.IconType).PriorityLow]: (0, $7zaVw.messages).priority_low,
    [(0, $8dVIb.IconType).PriorityLowest]: (0, $7zaVw.messages).priority_lowest,
    [(0, $8dVIb.IconType).PriorityMajor]: (0, $7zaVw.messages).priority_major,
    [(0, $8dVIb.IconType).PriorityMedium]: (0, $7zaVw.messages).priority_medium,
    [(0, $8dVIb.IconType).PriorityMinor]: (0, $7zaVw.messages).priority_minor,
    [(0, $8dVIb.IconType).PriorityTrivial]: (0, $7zaVw.messages).priority_trivial,
    [(0, $8dVIb.IconType).PriorityUndefined]: (0, $7zaVw.messages).priority_undefined
};
const $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $aab9f19acb0d3ec1$var$messageMapper[icon];
        if (descriptor) return (0, $fpDmE.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $aab9f19acb0d3ec1$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Hdrc.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $aab9f19acb0d3ec1$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l5Xsv.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $aab9f19acb0d3ec1$var$BadgeNew = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, className: className, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $aab9f19acb0d3ec1$var$renderAtlaskitIcon(icon, testId) || $aab9f19acb0d3ec1$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ])
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1oju _vwz4idpf _s7n4nkob _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v _1jtnidpf _13t3idpf _rm9uidpf _rtqbnkob _e4kmnkob _z239nkob"
        ])
    }, badgeIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": `${testId}-label`,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _syaz131l _19bv1xvx _s7n4nkob"
        ])
    }, formattedMessageOrLabel));
};
const $aab9f19acb0d3ec1$var$Badge = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aab9f19acb0d3ec1$var$BadgeNew, props);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kJhy.default), props);
};
var $aab9f19acb0d3ec1$export$2e2bcd8739ae039 = $aab9f19acb0d3ec1$var$Badge;

});
parcelRegister("9Hdrc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1647af7fe5459c6c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $duwKf = parcelRequire("duwKf");

var $iRZQl = parcelRequire("iRZQl");

var $7anl7 = parcelRequire("7anl7");
var $29YN9 = parcelRequire("29YN9");

var $VSDnB = parcelRequire("VSDnB");


var $dVpJZ = parcelRequire("dVpJZ");

var $94rku = parcelRequire("94rku");

var $8dVIb = parcelRequire("8dVIb");

var $kxcRq = parcelRequire("kxcRq");





























































// prettier-ignore
const $1647af7fe5459c6c$var$importIconMapperOld = {
    [(0, $8dVIb.IconType).Archive]: ()=>(parcelRequire("4m4MY")),
    [(0, $8dVIb.IconType).Audio]: ()=>(parcelRequire("5nV2R")),
    [(0, $8dVIb.IconType).Code]: ()=>(parcelRequire("coOzc")),
    [(0, $8dVIb.IconType).Executable]: ()=>(parcelRequire("gmDdF")),
    [(0, $8dVIb.IconType).File]: ()=>(parcelRequire("ldQLy")),
    [(0, $8dVIb.IconType).Folder]: ()=>(parcelRequire("fjtI4")),
    [(0, $8dVIb.IconType).Generic]: ()=>(parcelRequire("ldQLy")),
    [(0, $8dVIb.IconType).GIF]: ()=>(parcelRequire("eogSM")),
    [(0, $8dVIb.IconType).GoogleDocs]: ()=>(parcelRequire("6q8Pr")),
    [(0, $8dVIb.IconType).GoogleForms]: ()=>(parcelRequire("3VL73")),
    [(0, $8dVIb.IconType).GoogleSheets]: ()=>(parcelRequire("bwXIZ")),
    [(0, $8dVIb.IconType).GoogleSlides]: ()=>(parcelRequire("6SoQO")),
    [(0, $8dVIb.IconType).Image]: ()=>(parcelRequire("ifmtc")),
    [(0, $8dVIb.IconType).MSExcel]: ()=>(parcelRequire("8vv4H")),
    [(0, $8dVIb.IconType).MSPowerpoint]: ()=>(parcelRequire("TZHl8")),
    [(0, $8dVIb.IconType).MSWord]: ()=>(parcelRequire("e3PhT")),
    [(0, $8dVIb.IconType).PDF]: ()=>(parcelRequire("55TA3")),
    [(0, $8dVIb.IconType).Presentation]: ()=>(parcelRequire("2t9Hh")),
    [(0, $8dVIb.IconType).Sketch]: ()=>(parcelRequire("4WgJk")),
    [(0, $8dVIb.IconType).Spreadsheet]: ()=>(parcelRequire("lb4t9")),
    [(0, $8dVIb.IconType).Template]: ()=>(parcelRequire("60qz8")),
    [(0, $8dVIb.IconType).Video]: ()=>(parcelRequire("6Y2WT")),
    // Bitbucket icons
    [(0, $8dVIb.IconType).Branch]: ()=>(parcelRequire("cAU6j")),
    [(0, $8dVIb.IconType).Commit]: ()=>(parcelRequire("bn2CC")),
    [(0, $8dVIb.IconType).Project]: ()=>Promise.resolve((parcelRequire("kFO36"))),
    [(0, $8dVIb.IconType).PullRequest]: ()=>(parcelRequire("cIR4U")),
    [(0, $8dVIb.IconType).Repo]: ()=>(parcelRequire("bbgWK")),
    // Jira icons
    [(0, $8dVIb.IconType).Bug]: ()=>(parcelRequire("jNgVH")),
    [(0, $8dVIb.IconType).Change]: ()=>(parcelRequire("hhL96")),
    [(0, $8dVIb.IconType).Epic]: ()=>(parcelRequire("9q15g")),
    [(0, $8dVIb.IconType).Incident]: ()=>(parcelRequire("14Fhu")),
    [(0, $8dVIb.IconType).Problem]: ()=>(parcelRequire("3Qygt")),
    [(0, $8dVIb.IconType).ServiceRequest]: ()=>(parcelRequire("7J5Ma")),
    [(0, $8dVIb.IconType).Story]: ()=>(parcelRequire("iErKi")),
    [(0, $8dVIb.IconType).SubTask]: ()=>(parcelRequire("kBegL")),
    [(0, $8dVIb.IconType).Task]: ()=>(parcelRequire("dqT3O")),
    // Provider icons
    [(0, $8dVIb.IconType).Confluence]: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                default: ConfluenceIcon
            })),
    [(0, $8dVIb.IconType).Jira]: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                default: JiraIcon
            })),
    // Fallback icons
    [(0, $8dVIb.IconType).Default]: ()=>Promise.resolve((parcelRequire("458iJ"))),
    [(0, $8dVIb.IconType).Error]: ()=>Promise.resolve((parcelRequire("7nnPp"))),
    [(0, $8dVIb.IconType).Forbidden]: ()=>Promise.resolve((parcelRequire("gs7PQ"))),
    // Badge
    [(0, $8dVIb.IconType).Attachment]: ()=>(parcelRequire("kbM6l")),
    [(0, $8dVIb.IconType).CheckItem]: ()=>(parcelRequire("iiba0")),
    [(0, $8dVIb.IconType).Comment]: ()=>(parcelRequire("etExZ")),
    [(0, $8dVIb.IconType).View]: ()=>(parcelRequire("hyIrG")),
    [(0, $8dVIb.IconType).React]: ()=>(parcelRequire("h8l0B")),
    [(0, $8dVIb.IconType).Vote]: ()=>(parcelRequire("4CGRY")),
    [(0, $8dVIb.IconType).PriorityBlocker]: ()=>(parcelRequire("gMDFI")),
    [(0, $8dVIb.IconType).PriorityCritical]: ()=>(parcelRequire("4fkVg")),
    [(0, $8dVIb.IconType).PriorityHigh]: ()=>(parcelRequire("fgN6p")),
    [(0, $8dVIb.IconType).PriorityHighest]: ()=>(parcelRequire("cV2N9")),
    [(0, $8dVIb.IconType).PriorityLow]: ()=>(parcelRequire("eVavM")),
    [(0, $8dVIb.IconType).PriorityLowest]: ()=>(parcelRequire("56RVo")),
    [(0, $8dVIb.IconType).PriorityMajor]: ()=>(parcelRequire("ktXnL")),
    [(0, $8dVIb.IconType).PriorityMedium]: ()=>(parcelRequire("9mM5H")),
    [(0, $8dVIb.IconType).PriorityMinor]: ()=>(parcelRequire("1O0Re")),
    [(0, $8dVIb.IconType).PriorityTrivial]: ()=>(parcelRequire("lGGho")),
    [(0, $8dVIb.IconType).PriorityUndefined]: ()=>Promise.resolve((parcelRequire("7QGmb"))),
    [(0, $8dVIb.IconType).ProgrammingLanguage]: ()=>(parcelRequire("7Hzmn")),
    [(0, $8dVIb.IconType).Subscriber]: ()=>Promise.resolve((parcelRequire("h8cgU"))),
    [(0, $8dVIb.IconType).SubTasksProgress]: ()=>(parcelRequire("jZ8wH"))
};
const $1647af7fe5459c6c$var$getIconImportFn = (icon, size)=>{
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) {
        const item = (0, $kxcRq.getLazyIcons)()[icon];
        if ((0, $kxcRq.isIconSizeLarge)(size) && item?.large) return item.large;
        return item?.default;
    }
    return $1647af7fe5459c6c$var$importIconMapperOld[icon];
};
const $1647af7fe5459c6c$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $1647af7fe5459c6c$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $8dVIb.SmartLinkSize).Medium })=>{
    const DocumentIcon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? (0, $94rku.default) : (0, (/*@__PURE__*/$parcel$interopDefault($duwKf)));
    const BlogIcon = (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? (0, $dVpJZ.default) : (0, $iRZQl.default);
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $8dVIb.IconType).Document:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DocumentIcon, {
                label: label || 'document',
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
        case (0, $8dVIb.IconType).Blog:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BlogIcon, {
                label: label || 'blog',
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
    }
    const importFn = $1647af7fe5459c6c$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $1647af7fe5459c6c$var$importIcon(importFn);
    switch(icon){
        case (0, $8dVIb.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7anl7.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size === (0, $8dVIb.SmartLinkSize).Large ? 'small' : 'xsmall'
                }
            });
        case (0, $8dVIb.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29YN9.JiraIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size === (0, $8dVIb.SmartLinkSize).Large ? 'small' : 'xsmall'
                }
            });
        case (0, $8dVIb.IconType).Error:
        case (0, $8dVIb.IconType).Forbidden:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') ? {
                    size: size,
                    color: "var(--ds-icon-danger, #C9372C)"
                } : {
                    primaryColor: `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`
                }
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
    }
};
var $1647af7fe5459c6c$export$2e2bcd8739ae039 = $1647af7fe5459c6c$var$AtlaskitIcon;

});
parcelRegister("60qz8", function(module, exports) {

let $45f7598832a79dac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $45f7598832a79dac$var$load("dtoNN").then(()=>parcelRequire('53J27'));

});

parcelRegister("kbM6l", function(module, exports) {

let $eb2a25a65dcb50b4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb2a25a65dcb50b4$var$load("gWXGh").then(()=>parcelRequire('j3Vfq'));

});

parcelRegister("iiba0", function(module, exports) {

let $d51290a7bc53dd95$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d51290a7bc53dd95$var$load("geqFV").then(()=>parcelRequire('imUQY'));

});

parcelRegister("etExZ", function(module, exports) {

let $a8a339f19c570aad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a8a339f19c570aad$var$load("a5nLi").then(()=>parcelRequire('DBbS0'));

});

parcelRegister("hyIrG", function(module, exports) {

let $cc881699a67c12c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc881699a67c12c9$var$load("97YHa").then(()=>parcelRequire('bH0nF'));

});

parcelRegister("h8l0B", function(module, exports) {

let $c7937af0943f4fdc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c7937af0943f4fdc$var$load("cj5mx").then(()=>parcelRequire('kxkv9'));

});

parcelRegister("4CGRY", function(module, exports) {

let $35dbf7027bf16f47$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35dbf7027bf16f47$var$load("7SKVs").then(()=>parcelRequire('kAObg'));

});

parcelRegister("gMDFI", function(module, exports) {

let $c37fe70f109b78ee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c37fe70f109b78ee$var$load("2JrEQ").then(()=>parcelRequire('jJL9z'));

});

parcelRegister("4fkVg", function(module, exports) {

let $3178caf18816bb57$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3178caf18816bb57$var$load("czPXX").then(()=>parcelRequire('3pKEh'));

});

parcelRegister("fgN6p", function(module, exports) {

let $b1de7052f50bfcad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b1de7052f50bfcad$var$load("bW2Ht").then(()=>parcelRequire('k7gBp'));

});

parcelRegister("cV2N9", function(module, exports) {

let $967cf94be8e9a9d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $967cf94be8e9a9d5$var$load("jlDVs").then(()=>parcelRequire('Le10t'));

});

parcelRegister("eVavM", function(module, exports) {

let $adce8af64095102c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $adce8af64095102c$var$load("9n8Rc").then(()=>parcelRequire('kc1MS'));

});

parcelRegister("56RVo", function(module, exports) {

let $3b87579a8c1c9c89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b87579a8c1c9c89$var$load("a0ALI").then(()=>parcelRequire('hfn9j'));

});

parcelRegister("ktXnL", function(module, exports) {

let $ee94942a5dcf51e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee94942a5dcf51e4$var$load("kFjg9").then(()=>parcelRequire('4zl0K'));

});

parcelRegister("9mM5H", function(module, exports) {

let $6d1b79007a44e718$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d1b79007a44e718$var$load("50gXn").then(()=>parcelRequire('cfbO3'));

});

parcelRegister("1O0Re", function(module, exports) {

let $150b203f6494e0b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $150b203f6494e0b7$var$load("1Bya1").then(()=>parcelRequire('jyFo7'));

});

parcelRegister("lGGho", function(module, exports) {

let $fc9e510f6e16a672$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc9e510f6e16a672$var$load("6xK7c").then(()=>parcelRequire('eJNZM'));

});

parcelRegister("7Hzmn", function(module, exports) {

let $59b7fa4a04481570$var$load = (parcelRequire("28QjX"))(4);
module.exports = $59b7fa4a04481570$var$load("iY2wN").then(()=>parcelRequire('c2JK5'));

});

parcelRegister("jZ8wH", function(module, exports) {

let $e8ca53f8b2e599bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e8ca53f8b2e599bd$var$load("10dT8").then(()=>parcelRequire('gKopa'));

});


parcelRegister("l5Xsv", function(module, exports) {

$parcel$export(module.exports, "default", () => $951590e808a48e01$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bmnhy = parcelRequire("bmnhy");

var $VSDnB = parcelRequire("VSDnB");

var $gU02S = parcelRequire("gU02S");
const $951590e808a48e01$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
        src: url,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') ? {
            loading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gU02S.LoadingSkeletonNew), {
                testId: `${testId}-loading`,
                width: width,
                height: height
            }),
            loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                src: url,
                "data-testid": `${testId}-image`,
                alt: "",
                style: {
                    width: width,
                    height: height
                }
            })
        } : {
            loading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gU02S.LoadingSkeletonOld), {
                testId: `${testId}-loading`
            }),
            // eslint-disable-next-line jsx-a11y/alt-text
            loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                src: url,
                "data-testid": `${testId}-image`
            })
        },
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $951590e808a48e01$export$2e2bcd8739ae039 = $951590e808a48e01$var$ImageIcon;

});
parcelRegister("bmnhy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8453cf1ee7ef4644$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8453cf1ee7ef4644$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $8453cf1ee7ef4644$var$loaded() {
    return {
        isLoaded: true
    };
}
function $8453cf1ee7ef4644$var$errored() {
    return {
        isErrored: true
    };
}
function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
    $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
    }
    $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($8453cf1ee7ef4644$var$React.Component);
module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;

});

parcelRegister("gU02S", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeletonNew", () => $880176eb12ae8419$export$4c64943f69fac55);
$parcel$export(module.exports, "LoadingSkeletonOld", () => $880176eb12ae8419$export$c2c783ba34989c94);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $3dyog = parcelRequire("3dyog");
const $880176eb12ae8419$var$animationNameStyles = null;
const $880176eb12ae8419$var$loadingSkeletonStyle = null;
const $880176eb12ae8419$export$4c64943f69fac55 = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};
const $880176eb12ae8419$export$c2c783ba34989c94 = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($880176eb12ae8419$export$4c64943f69fac55, {
        ...props,
        width: `${props.width}rem`,
        height: `${props.height}rem`
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $3dyog.default), props);
};

});
parcelRegister("3dyog", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24ff00886e1b58d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
const $d24ff00886e1b58d$var$LoadingSkeletonOld = ({ testId: testId, width: width, height: height })=>{
    const animationNameStyles = (0, $f8Sb3.keyframes)({
        '0%': {
            backgroundPosition: '50% 0'
        },
        '100%': {
            backgroundPosition: '-50% 0'
        }
    });
    const styles = /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${width}rem`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${height}rem`,
        borderRadius: '2px',
        userSelect: 'none',
        background: "var(--ds-skeleton-subtle, #f6f7f8)",
        backgroundImage: `linear-gradient( to right, transparent 0%, ${"var(--ds-skeleton, #edeef1)"} 20%, transparent 40%, transparent 100% )`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '280% 100%',
        display: 'inline-block',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        animationName: animationNameStyles,
        animationTimingFunction: 'linear'
    });
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: styles,
        "data-testid": testId
    });
};
var $d24ff00886e1b58d$export$2e2bcd8739ae039 = $d24ff00886e1b58d$var$LoadingSkeletonOld;

});



parcelRegister("1kJhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5b3b8cae34beeb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");
function $df5b3b8cae34beeb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $df5b3b8cae34beeb$var$badgeStyles = {
    name: "9qxyko",
    styles: "align-items:center;display:inline-flex;min-width:fit-content"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $df5b3b8cae34beeb$var$iconStyles = /*#__PURE__*/ (0, $f8Sb3.css)("color:var(--ds-icon-subtle, #626F86);line-height:0;vertical-align:middle;", (0, $fpDmE.getIconSizeStyles)('1rem'), " img,span,svg{line-height:0;vertical-align:middle;}");
const $df5b3b8cae34beeb$var$labelStyles = {
    name: "1nnoqpd",
    styles: "color:var(--ds-text-subtlest, #626F86);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-025, 0.125rem);vertical-align:middle"
};
const $df5b3b8cae34beeb$var$messageMapper = {
    [(0, $8dVIb.IconType).PriorityBlocker]: (0, $7zaVw.messages).priority_blocker,
    [(0, $8dVIb.IconType).PriorityCritical]: (0, $7zaVw.messages).priority_critical,
    [(0, $8dVIb.IconType).PriorityHigh]: (0, $7zaVw.messages).priority_high,
    [(0, $8dVIb.IconType).PriorityHighest]: (0, $7zaVw.messages).priority_highest,
    [(0, $8dVIb.IconType).PriorityLow]: (0, $7zaVw.messages).priority_low,
    [(0, $8dVIb.IconType).PriorityLowest]: (0, $7zaVw.messages).priority_lowest,
    [(0, $8dVIb.IconType).PriorityMajor]: (0, $7zaVw.messages).priority_major,
    [(0, $8dVIb.IconType).PriorityMedium]: (0, $7zaVw.messages).priority_medium,
    [(0, $8dVIb.IconType).PriorityMinor]: (0, $7zaVw.messages).priority_minor,
    [(0, $8dVIb.IconType).PriorityTrivial]: (0, $7zaVw.messages).priority_trivial,
    [(0, $8dVIb.IconType).PriorityUndefined]: (0, $7zaVw.messages).priority_undefined
};
const $df5b3b8cae34beeb$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $df5b3b8cae34beeb$var$messageMapper[icon];
        if (descriptor) return (0, $fpDmE.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $df5b3b8cae34beeb$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Hdrc.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $df5b3b8cae34beeb$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $l5Xsv.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $df5b3b8cae34beeb$var$BadgeOld = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $df5b3b8cae34beeb$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $df5b3b8cae34beeb$var$renderAtlaskitIcon(icon, testId) || $df5b3b8cae34beeb$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $df5b3b8cae34beeb$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId
    }, !hideIcon && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $df5b3b8cae34beeb$var$iconStyles
    }, badgeIcon), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $df5b3b8cae34beeb$var$labelStyles,
        "data-testid": `${testId}-label`
    }, formattedMessageOrLabel));
};
var $df5b3b8cae34beeb$export$2e2bcd8739ae039 = $df5b3b8cae34beeb$var$BadgeOld;

});


parcelRegister("bWpL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a4f7878d6976fe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7anB = parcelRequire("j7anB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $7zaVw = parcelRequire("7zaVw");

var $ZlqLB = parcelRequire("ZlqLB");
const $66a4f7878d6976fe$var$styles = null;
const $66a4f7878d6976fe$var$typeToDescriptorMap = {
    created: {
        relative: (0, $7zaVw.messages).created_on_relative,
        absolute: (0, $7zaVw.messages).created_on_absolute
    },
    modified: {
        relative: (0, $7zaVw.messages).modified_on_relative,
        absolute: (0, $7zaVw.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $7zaVw.messages).sent_on_relative,
        absolute: (0, $7zaVw.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $66a4f7878d6976fe$var$DateTimeNew = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $koVbs.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $j7anB.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_11c8qk37 _1reo15vq _18m915vq _syaz131l _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k1j6v",
            className
        ])
    }, text ? `${text} ${context}` : /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), {
        ...$66a4f7878d6976fe$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    }));
};
const $66a4f7878d6976fe$var$DateTime = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($66a4f7878d6976fe$var$DateTimeNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $ZlqLB.default), props);
};
var $66a4f7878d6976fe$export$2e2bcd8739ae039 = $66a4f7878d6976fe$var$DateTime;

});
parcelRegister("ZlqLB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a687fe7433e69a06$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $j7anB = parcelRequire("j7anB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $7zaVw = parcelRequire("7zaVw");

var $fpDmE = parcelRequire("fpDmE");
const $a687fe7433e69a06$var$styles = /*#__PURE__*/ (0, $f8Sb3.css)("color:var(--ds-text-subtlest, #626F86);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $fpDmE.getTruncateStyles)(1));
const $a687fe7433e69a06$var$typeToDescriptorMap = {
    created: {
        relative: (0, $7zaVw.messages).created_on_relative,
        absolute: (0, $7zaVw.messages).created_on_absolute
    },
    modified: {
        relative: (0, $7zaVw.messages).modified_on_relative,
        absolute: (0, $7zaVw.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $7zaVw.messages).sent_on_relative,
        absolute: (0, $7zaVw.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $a687fe7433e69a06$var$DateTimeOld = ({ date: date, name: name, overrideCss: overrideCss, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $koVbs.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $j7anB.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $a687fe7433e69a06$var$styles,
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId
    }, text ? `${text} ${context}` : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        ...$a687fe7433e69a06$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    }));
};
var $a687fe7433e69a06$export$2e2bcd8739ae039 = $a687fe7433e69a06$var$DateTimeOld;

});


parcelRegister("aWyvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6c193b1fc074556$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8dVIb = parcelRequire("8dVIb");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");

var $geoxn = parcelRequire("geoxn");
const $d6c193b1fc074556$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $d6c193b1fc074556$var$iconStylesMapOld = {
    xlarge: "_16jlidpf _1o9zidpf _i0dl1wug _4t3iviql _1tkeviql _c71lviql _1bsbviql _1ul9viql _p12fviql _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7viql _1xjxviql _1752viql _qci8viql _15izviql _erubviql _19l3viql _1pr2viql _1u5tviql _mezjviql _e2ooviql _w8l5viql _1rg2viql _q7cvviql _xwbjviql _rtysviql _b8nkviql _4x20viql",
    large: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    medium: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    small: "_16jlidpf _1o9zidpf _i0dl1wug _4t3ioqnp _1tkeoqnp _c71loqnp _1bsboqnp _1ul9oqnp _p12foqnp _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7oqnp _1xjxoqnp _1752oqnp _qci8oqnp _15izoqnp _eruboqnp _19l3oqnp _1pr2oqnp _1u5toqnp _mezjoqnp _e2oooqnp _w8l5oqnp _1rg2oqnp _q7cvoqnp _xwbjoqnp _rtysoqnp _b8nkoqnp _4x20oqnp"
};
const $d6c193b1fc074556$var$customRenderStyleMapOld = {
    xlarge: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz4viql _1wybviql _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kviql",
    large: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz41k8s _1wyb1k8s _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102k1k8s",
    medium: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz41j6v _1wyb1j6v _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102k1j6v",
    small: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz4oqnp _1wyboqnp _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102koqnp"
};
const $d6c193b1fc074556$var$customRenderStyleMapNew = {
    xlarge: "_1reo15vq _18m915vq _11c81p5s _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kz42d",
    large: "_1reo15vq _18m915vq _11c81p5s _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kz42d",
    medium: "_1reo15vq _18m915vq _11c81bk4 _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kptym",
    small: "_1reo15vq _18m915vq _11c81bk4 _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kptym"
};
const $d6c193b1fc074556$var$renderAtlaskitIcon = (icon, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Hdrc.default), {
        icon: icon,
        testId: `${testId}-icon`,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            size: size
        }
    });
};
const $d6c193b1fc074556$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $d6c193b1fc074556$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    const width = size === (0, $8dVIb.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l5Xsv.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            width: width,
            height: width
        }
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $d6c193b1fc074556$var$IconNew = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $8dVIb.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
    const element = (0, $5uXOq.useMemo)(()=>{
        const defaultIcon = $d6c193b1fc074556$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $d6c193b1fc074556$var$renderImageIcon(defaultIcon, url, testId, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? size : undefined) || $d6c193b1fc074556$var$renderAtlaskitIcon(icon, testId, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? size : undefined) || defaultIcon;
    }, [
        overrideIcon,
        icon,
        label,
        render,
        testId,
        url,
        size
    ]);
    const width = (0, $fpDmE.getIconWidth)(size);
    // const styles = getIconStyles(position, width);
    // const renderStyles = render ? getCustomRenderStyles(width) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$iconStylesMapOld[size],
            !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$positionStyleMap[position],
            render && !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$customRenderStyleMapOld[size],
            render && (0, $VSDnB.fg)('platform-smart-card-icon-migration') && $d6c193b1fc074556$var$customRenderStyleMapNew[size],
            className
        ])
    }, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d6c193b1fc074556$var$iconWrapperStyle,
        style: {
            width: width,
            height: width
        }
    }, element) : element);
};
const $d6c193b1fc074556$var$Icon = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d6c193b1fc074556$var$IconNew, props);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $geoxn.default), props);
};
const $d6c193b1fc074556$var$iconWrapperStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
var $d6c193b1fc074556$export$2e2bcd8739ae039 = $d6c193b1fc074556$var$Icon;

});
parcelRegister("geoxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c230573e4b66542a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $jOyH3 = parcelRequire("jOyH3");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8dVIb = parcelRequire("8dVIb");

var $9Hdrc = parcelRequire("9Hdrc");

var $l5Xsv = parcelRequire("l5Xsv");

var $fpDmE = parcelRequire("fpDmE");
function $c230573e4b66542a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c230573e4b66542a$var$_ref = {
    name: "1xpq7g4",
    styles: "align-self:flex-start;margin:0"
};
var $c230573e4b66542a$var$_ref2 = {
    name: "qbt5ty",
    styles: "align-self:center"
};
const $c230573e4b66542a$var$getPositionStyles = (position)=>{
    switch(position){
        case (0, $8dVIb.SmartLinkPosition).Center:
            return $c230573e4b66542a$var$_ref2;
        case (0, $8dVIb.SmartLinkPosition).Top:
        default:
            return $c230573e4b66542a$var$_ref;
    }
};
const $c230573e4b66542a$var$getIconStyles = (position, width)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $f8Sb3.css)($c230573e4b66542a$var$getPositionStyles(position), (0, $fpDmE.getIconSizeStyles)(width));
const $c230573e4b66542a$var$getCustomRenderStyles = (value)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $f8Sb3.css)((0, $fpDmE.getTruncateStyles)(1, value), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: value,
        textAlign: 'center',
        textOverflow: 'clip',
        WebkitBoxOrient: 'unset',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        span: {
            margin: 0,
            padding: 0,
            verticalAlign: 'baseline'
        }
    });
const $c230573e4b66542a$var$renderAtlaskitIcon = (icon, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9Hdrc.default), {
        icon: icon,
        testId: `${testId}-icon`,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            size: size
        }
    });
};
const $c230573e4b66542a$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $c230573e4b66542a$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $8dVIb.SmartLinkSize).Medium)=>{
    const width = size === (0, $8dVIb.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $l5Xsv.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            width: width,
            height: width
        }
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $c230573e4b66542a$var$IconOld = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $8dVIb.SmartLinkPosition).Top, overrideCss: overrideCss, render: render, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
    const element = (0, $5uXOq.useMemo)(()=>{
        const defaultIcon = $c230573e4b66542a$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $c230573e4b66542a$var$renderImageIcon(defaultIcon, url, testId, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? size : undefined) || $c230573e4b66542a$var$renderAtlaskitIcon(icon, testId, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? size : undefined) || defaultIcon;
    }, [
        overrideIcon,
        icon,
        label,
        render,
        testId,
        url,
        size
    ]);
    const width = (0, $fpDmE.getIconWidth)(size);
    const styles = $c230573e4b66542a$var$getIconStyles(position, width);
    const renderStyles = render ? $c230573e4b66542a$var$getCustomRenderStyles(width) : undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
            !(0, $VSDnB.fg)('platform-smart-card-icon-migration') && styles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
            renderStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId
    }, (0, $VSDnB.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        xcss: $c230573e4b66542a$var$iconWrapperStyle,
        style: {
            width: width,
            height: width
        }
    }, element) : element);
};
const $c230573e4b66542a$var$iconWrapperStyle = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
var $c230573e4b66542a$export$2e2bcd8739ae039 = $c230573e4b66542a$var$IconOld;

});


parcelRegister("3dV67", function(module, exports) {

$parcel$export(module.exports, "default", () => $b60bb11df77d728a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $fpDmE = parcelRequire("fpDmE");

var $4xtGh = parcelRequire("4xtGh");
const $b60bb11df77d728a$var$DEFAULT_MAX_LINES = 2;
const $b60bb11df77d728a$var$MAXIMUM_MAX_LINES = 2;
const $b60bb11df77d728a$var$MINIMUM_MAX_LINES = 1;
const $b60bb11df77d728a$var$containerStyles = null;
const $b60bb11df77d728a$var$getMaxLines = (maxLines)=>{
    if (maxLines > $b60bb11df77d728a$var$MAXIMUM_MAX_LINES) return $b60bb11df77d728a$var$DEFAULT_MAX_LINES;
    if (maxLines < $b60bb11df77d728a$var$MINIMUM_MAX_LINES) return $b60bb11df77d728a$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $b60bb11df77d728a$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
const $b60bb11df77d728a$var$linkStyleSizeMap = {
    xlarge: "_11c8o0gd _k48pi7a9 _vwz41k8s",
    large: "_11c81oud _k48pi7a9 _vwz41j6v",
    medium: "_11c81oud _k48pi7a9 _vwz41j6v",
    small: "_11c8qk37 _k48pi7a9 _vwz41j6v"
};
const $b60bb11df77d728a$var$baseAnchorStyle = null;
const $b60bb11df77d728a$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $b60bb11df77d728a$var$anchorConstantsStyles = null;
const $b60bb11df77d728a$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $b60bb11df77d728a$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $b60bb11df77d728a$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $b60bb11df77d728a$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10ueqk37 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $b60bb11df77d728a$var$LinkNew = ({ hideTooltip: hideTooltip, maxLines: maxLines = $b60bb11df77d728a$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $8dVIb.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, $fpDmE.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $b60bb11df77d728a$var$linkStyleSizeMap[size],
            $b60bb11df77d728a$var$anchorLineClampMap[$b60bb11df77d728a$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $b60bb11df77d728a$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $b60bb11df77d728a$var$getMaxLines(maxLines) === 1 && $b60bb11df77d728a$var$anchorLinkLineHeight1Map[size],
            $b60bb11df77d728a$var$getMaxLines(maxLines) === 2 && $b60bb11df77d728a$var$anchorLinkLineHeight2Map[size],
            $b60bb11df77d728a$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        }
    }, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ])
    }, hideTooltip || text === undefined ? anchor : $b60bb11df77d728a$var$withTooltip(anchor, text, testId));
};
const $b60bb11df77d728a$var$Link = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b60bb11df77d728a$var$LinkNew, props);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4xtGh.default), props);
};
var $b60bb11df77d728a$export$2e2bcd8739ae039 = $b60bb11df77d728a$var$Link;

});
parcelRegister("4URMI", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $0d5ea96be37e2b5d$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $0d5ea96be37e2b5d$export$df67f318ded0283c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $g2eZ6 = parcelRequire("g2eZ6");
var $0d5ea96be37e2b5d$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $g2eZ6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
    return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
};

});
parcelRegister("g2eZ6", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $473b45d487f9fd1b$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $473b45d487f9fd1b$export$263352d59c0c5966);

var $5uXOq = parcelRequire("5uXOq");

var $b6uPu = parcelRequire("b6uPu");

var $4URMI = parcelRequire("4URMI");

var $fzJZi = parcelRequire("fzJZi");
const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $b6uPu.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $fzJZi.ANALYTICS_CHANNEL));
    };
const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4URMI.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4URMI.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("b6uPu", function(module, exports) {

$parcel$export(module.exports, "browser", () => $7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
const $7f7209ce5c1e8d08$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
    return $7f7209ce5c1e8d08$var$result;
}

});



parcelRegister("4xtGh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0435f90475b2676b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $fpDmE = parcelRequire("fpDmE");
function $0435f90475b2676b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0435f90475b2676b$var$DEFAULT_MAX_LINES = 2;
const $0435f90475b2676b$var$MAXIMUM_MAX_LINES = 2;
const $0435f90475b2676b$var$MINIMUM_MAX_LINES = 1;
const $0435f90475b2676b$var$containerStyles = {
    name: "mkkf9p",
    styles: "flex:1 1 auto"
};
var $0435f90475b2676b$var$_ref = {
    name: "16ucc2m",
    styles: "color:var(--ds-link, #0C66E4);:active{color:var(--ds-link-pressed, #0055CC);}:hover{color:var(--ds-link, #0C66E4);text-decoration:underline;}"
};
var $0435f90475b2676b$var$_ref2 = {
    name: "1glvof",
    styles: "color:var(--ds-text-subtle, #44546F);:active{color:var(--ds-text, #172B4D);}:hover{color:var(--ds-text-subtle, #44546F);text-decoration:underline;}"
};
var $0435f90475b2676b$var$_ref3 = {
    name: "izk992",
    styles: "a&{color:var(--ds-text-subtlest, #626F86);&:active, &:visited, &:focus, &:hover{color:var(--ds-text-subtlest, #626F86);text-decoration:underline;}font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);}"
};
const $0435f90475b2676b$var$getThemeStyles = (theme)=>{
    switch(theme){
        case (0, $8dVIb.SmartLinkInternalTheme).Grey:
            // We are being specifc with the CSS selectors to ensure that Confluence overrides
            // do not affect our internal Smart Card styles
            return $0435f90475b2676b$var$_ref3;
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        case (0, $8dVIb.SmartLinkTheme).Black:
            return $0435f90475b2676b$var$_ref2;
        case (0, $8dVIb.SmartLinkTheme).Link:
        default:
            return $0435f90475b2676b$var$_ref;
    }
};
const $0435f90475b2676b$var$getAnchorStyles = (size, theme, maxLines, hasSpace)=>{
    const sizeStyles = (0, $fpDmE.getLinkSizeStyles)(size);
    return /*#__PURE__*/ (0, $f8Sb3.css)("flex:1 1 auto;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    sizeStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fpDmE.getTruncateStyles)(maxLines, (0, $fpDmE.getLinkLineHeight)(size), hasSpace ? 'break-word' : 'break-all'), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $0435f90475b2676b$var$getThemeStyles(theme));
};
const $0435f90475b2676b$var$getMaxLines = (maxLines)=>{
    if (maxLines > $0435f90475b2676b$var$MAXIMUM_MAX_LINES) return $0435f90475b2676b$var$DEFAULT_MAX_LINES;
    if (maxLines < $0435f90475b2676b$var$MINIMUM_MAX_LINES) return $0435f90475b2676b$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $0435f90475b2676b$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $0435f90475b2676b$var$LinkOld = ({ hideTooltip: hideTooltip, maxLines: maxLines = $0435f90475b2676b$var$DEFAULT_MAX_LINES, name: name, overrideCss: overrideCss, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $8dVIb.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, $fpDmE.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $f8Sb3.jsx)("a", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $0435f90475b2676b$var$getAnchorStyles(size, theme, $0435f90475b2676b$var$getMaxLines(maxLines), hasSpace),
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        ...target !== '_self' && {
            target: target
        }
    }, text);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $0435f90475b2676b$var$containerStyles
    }, hideTooltip || text === undefined ? anchor : $0435f90475b2676b$var$withTooltip(anchor, text, testId));
};
var $0435f90475b2676b$export$2e2bcd8739ae039 = $0435f90475b2676b$var$LinkOld;

});


parcelRegister("cJxXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $af9c30eaf441ad65$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lj8SI = parcelRequire("lj8SI");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $a4DH1 = parcelRequire("a4DH1");

var $8jSB6 = parcelRequire("8jSB6");
const $af9c30eaf441ad65$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $af9c30eaf441ad65$var$LozengeNew = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ $5uXOq.createElement((0, $a4DH1.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ $5uXOq.createElement((0, $lj8SI.default), {
        appearance: appearance,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`
    }, text);
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1e0c116y _vwz41kw7",
            className
        ])
    }, lozenge);
};
const $af9c30eaf441ad65$var$Lozenge = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($af9c30eaf441ad65$var$LozengeNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $8jSB6.default), props);
};
var $af9c30eaf441ad65$export$2e2bcd8739ae039 = $af9c30eaf441ad65$var$Lozenge;

});
parcelRegister("a4DH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $27ceba18caf6f022$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");

var $a1vqi = parcelRequire("a1vqi");

var $dlJZx = parcelRequire("dlJZx");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $gDUps = parcelRequire("gDUps");

var $fzJZi = parcelRequire("fzJZi");

var $cLKee = parcelRequire("cLKee");

var $dMzTJ = parcelRequire("dMzTJ");

var $j6VJk = parcelRequire("j6VJk");

var $1s0lY = parcelRequire("1s0lY");

var $kf01E = parcelRequire("kf01E");

var $4Dg4o = parcelRequire("4Dg4o");
const $27ceba18caf6f022$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $27ceba18caf6f022$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $5uXOq.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [items, setItems] = (0, $5uXOq.useState)();
    const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)();
    const reload = (0, $f22ja.default)();
    const invoke = (0, $3q2sI.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $5uXOq.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $dlJZx.default));
                const validItems = typeof text === 'string' ? $27ceba18caf6f022$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $1s0lY.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $1s0lY.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Dg4o.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $5uXOq.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $gDUps.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $fzJZi.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $euMlu.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $1s0lY.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $dMzTJ.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $5uXOq.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j6VJk.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kf01E.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex
    }, dropdownItemGroup);
};
var $27ceba18caf6f022$export$2e2bcd8739ae039 = (0, $cLKee.default)($27ceba18caf6f022$var$LozengeAction);

});
parcelRegister("dlJZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eaacaffc693a3ec$export$2e2bcd8739ae039);
const $6eaacaffc693a3ec$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $6eaacaffc693a3ec$export$2e2bcd8739ae039 = $6eaacaffc693a3ec$var$extractLozengeActionItems;

});

parcelRegister("3q2sI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a60e7c58b54588$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iiAnG = parcelRequire("iiAnG");

var $051X7 = parcelRequire("051X7");
const $f5a60e7c58b54588$var$useInvoke = ()=>{
    const { connections: connections } = (0, $051X7.useSmartLinkContext)();
    const clientExt = (0, $iiAnG.useSmartLinkClientExtension)(connections.client);
    return (0, $5uXOq.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $f5a60e7c58b54588$export$2e2bcd8739ae039 = $f5a60e7c58b54588$var$useInvoke;

});
parcelRegister("iiAnG", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $ffb669da1b6b71e8$export$303ede4eed148855);

var $5uXOq = parcelRequire("5uXOq");

var $dV0Jy = parcelRequire("dV0Jy");

var $T540Y = parcelRequire("T540Y");

var $3b94d = parcelRequire("3b94d");
const $ffb669da1b6b71e8$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $3b94d.useResolverUrl)(cardClient);
    const invoke = (0, $5uXOq.useCallback)(async (data)=>{
        try {
            return await (0, $dV0Jy.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $T540Y.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("dV0Jy", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $5576d4e9d0a3858d$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $5576d4e9d0a3858d$export$b5fe3f66a567bec0);
const $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $5576d4e9d0a3858d$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $5576d4e9d0a3858d$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $5576d4e9d0a3858d$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("T540Y", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $171ae91e706973ef$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $171ae91e706973ef$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $171ae91e706973ef$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $171ae91e706973ef$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("3b94d", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $eebf021c5f687360$export$d08617a365fbe694);

var $5uXOq = parcelRequire("5uXOq");

var $itO4f = parcelRequire("itO4f");
const $eebf021c5f687360$export$d08617a365fbe694 = (cardClient)=>(0, $5uXOq.useMemo)(()=>(0, $itO4f.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});
parcelRegister("itO4f", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $21a0efece812cd9a$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $21a0efece812cd9a$export$dc37652c1696f231);
const $21a0efece812cd9a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $21a0efece812cd9a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $21a0efece812cd9a$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $21a0efece812cd9a$export$e2b040f052407032 = {
    dev: $21a0efece812cd9a$var$devBaseUrl,
    development: $21a0efece812cd9a$var$devBaseUrl,
    stg: $21a0efece812cd9a$var$stgBaseUrl,
    staging: $21a0efece812cd9a$var$stgBaseUrl,
    prd: $21a0efece812cd9a$var$prodBaseUrl,
    prod: $21a0efece812cd9a$var$prodBaseUrl,
    production: $21a0efece812cd9a$var$prodBaseUrl
};
const $21a0efece812cd9a$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $21a0efece812cd9a$export$e2b040f052407032 ? $21a0efece812cd9a$export$e2b040f052407032[envKey] : $21a0efece812cd9a$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $21a0efece812cd9a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $21a0efece812cd9a$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $21a0efece812cd9a$export$2e2bcd8739ae039 = $21a0efece812cd9a$export$e2b040f052407032;

});




parcelRegister("euMlu", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $0ad6fedaface02c5$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $0ad6fedaface02c5$export$1694272377fa07d8);

var $fzJZi = parcelRequire("fzJZi");
const $0ad6fedaface02c5$export$65b3f792dff0bd60 = (err)=>{
    if (!$0ad6fedaface02c5$export$1694272377fa07d8(err)) return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $fzJZi.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $fzJZi.TrackQuickActionFailureReason).UnknownError;
    }
};
const $0ad6fedaface02c5$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("f22ja", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48b36e6e5cada34$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");

var $8dVIb = parcelRequire("8dVIb");

var $1VPdD = parcelRequire("1VPdD");

var $nb8r1 = parcelRequire("nb8r1");
const $f48b36e6e5cada34$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $nb8r1.default)();
    return (0, $5uXOq.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1VPdD.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $f48b36e6e5cada34$export$2e2bcd8739ae039 = $f48b36e6e5cada34$var$useResolve;

});
parcelRegister("nb8r1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09545a48e55da9e9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $051X7 = parcelRequire("051X7");

var $2yPrN = parcelRequire("2yPrN");
var $kDZ6Z = parcelRequire("kDZ6Z");
var $fiKQs = parcelRequire("fiKQs");

var $8dVIb = parcelRequire("8dVIb");

var $aOsut = parcelRequire("aOsut");

const $09545a48e55da9e9$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $051X7.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $5uXOq.useCallback)((url, metadataStatus)=>{
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $5uXOq.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $8dVIb.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: url
        }, (0, $aOsut.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $2yPrN.cardAction)((0, $2yPrN.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $fiKQs.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fallback', hostname, (0, $cc6a74b99a201fc4$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('fatal', hostname, (0, $cc6a74b99a201fc4$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $kDZ6Z.APIError)('error', hostname, (0, $cc6a74b99a201fc4$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $7nsd3.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $09545a48e55da9e9$export$2e2bcd8739ae039 = $09545a48e55da9e9$var$useResponse;

});
parcelRegister("2yPrN", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $23a1ee9f12bb755d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $23a1ee9f12bb755d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $23a1ee9f12bb755d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $23a1ee9f12bb755d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $23a1ee9f12bb755d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $23a1ee9f12bb755d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $23a1ee9f12bb755d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $23a1ee9f12bb755d$export$6e470aad5ba8952e = 'pending';
const $23a1ee9f12bb755d$export$9a6a932a0a39498e = 'resolving';
const $23a1ee9f12bb755d$export$63ec8bc7a8a75482 = 'resolved';
const $23a1ee9f12bb755d$export$b8cfaa842c9ab487 = 'reloading';
const $23a1ee9f12bb755d$export$6d8ed3f9433dd372 = 'errored';
const $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6 = 'fallback';
const $23a1ee9f12bb755d$export$76b5c1aca20759c6 = 'preload';
const $23a1ee9f12bb755d$export$2c5edb971b673330 = 'metadata';
const $23a1ee9f12bb755d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("kDZ6Z", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $8c263ecf028a2c14$export$3e5b797e39668f84);
class $8c263ecf028a2c14$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("aOsut", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $5dc57cbabb8840da$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $5dc57cbabb8840da$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $5dc57cbabb8840da$export$e32193033a594efb);
const $5dc57cbabb8840da$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $5dc57cbabb8840da$export$2796a804c6e44f63 = ()=>$5dc57cbabb8840da$var$emptyData;
const $5dc57cbabb8840da$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });
const $5dc57cbabb8840da$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$5dc57cbabb8840da$var$emptyData
        }
    });

});

const $cc6a74b99a201fc4$export$297c39c8b9bfca0 = 'resolving';
const $cc6a74b99a201fc4$export$b64a888338c24e0e = 'errored';
const $cc6a74b99a201fc4$export$677b6edfa0002c70 = 'fallback';
const $cc6a74b99a201fc4$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $cc6a74b99a201fc4$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $cc6a74b99a201fc4$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("gDUps", function(module, exports) {

$parcel$export(module.exports, "default", () => $66cd4b0a305f86bf$export$2e2bcd8739ae039);
const $66cd4b0a305f86bf$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $66cd4b0a305f86bf$export$2e2bcd8739ae039 = $66cd4b0a305f86bf$var$createStatusUpdateRequest;

});

parcelRegister("cLKee", function(module, exports) {

$parcel$export(module.exports, "default", () => $061d6f2e0c766414$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $lj8SI = parcelRequire("lj8SI");
const $061d6f2e0c766414$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
                appearance: props?.appearance,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`
            }, props?.text), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f4cXA.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
    };
var $061d6f2e0c766414$export$2e2bcd8739ae039 = $061d6f2e0c766414$var$withErrorBoundary;

});

parcelRegister("dMzTJ", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $bd6f9a689b54b40e$export$618660b8f2aa87e2);
const $bd6f9a689b54b40e$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $bd6f9a689b54b40e$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $bd6f9a689b54b40e$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $bd6f9a689b54b40e$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("j6VJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee1a9d5bb42f1de9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $dD7Zc = parcelRequire("dD7Zc");

var $VSDnB = parcelRequire("VSDnB");


var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $iPVbQ = parcelRequire("iPVbQ");

var $fpDmE = parcelRequire("fpDmE");

var $fI1Ph = parcelRequire("fI1Ph");
const $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER = 8;
const $ee1a9d5bb42f1de9$var$contentStyles = null;
const $ee1a9d5bb42f1de9$var$linkStyles = null;
const $ee1a9d5bb42f1de9$var$textStylesBase = null;
const $ee1a9d5bb42f1de9$var$dropdownItemGroupStyles = null;
const $ee1a9d5bb42f1de9$var$LozengeActionErrorNew = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const invoke = (0, $iPVbQ.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), null, /*#__PURE__*/ $5uXOq.createElement("div", {
            className: (0, $bwpsq.default)([
                "_zulpcxkx _11c81doa _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme1oud _102e1oud _ngc01fxt _1t4p1fxt"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            testId: `${testId}-icon`,
            LEGACY_size: "medium",
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ $5uXOq.createElement("span", {
            "data-testid": `${testId}-error-message`,
            className: (0, $bwpsq.default)([
                "_11c81doa _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
                "_1yyj1n6p _102k16q4"
            ]),
            style: {
                "--_t4prqe": (0, $lD23V.default)(maxLineNumber)
            }
        }, typeof errorMessage === 'string' ? errorMessage : (0, $fpDmE.getFormattedMessage)(errorMessage))), isPreviewAvailable ? /*#__PURE__*/ $5uXOq.createElement("div", {
            className: (0, $bwpsq.default)([
                "_zulpcxkx _1reo15vq _18m915vq _11c81oud _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement("a", {
            target: "_blank",
            "data-testid": `${testId}-open-embed`,
            onClick: handlePreviewOpen
        }, /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), (0, $7zaVw.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $bwpsq.default)([
            "_14hp1wdt _6pup1kw7 _1eo073ad"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $aRoVz.default), null, /*#__PURE__*/ $5uXOq.createElement((0, $6B7KL.default), {
        testId: `${testId}-error`
    }, content)));
};
const $ee1a9d5bb42f1de9$var$LozengeActionError = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($ee1a9d5bb42f1de9$var$LozengeActionErrorNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $fI1Ph.default), props);
};
var $ee1a9d5bb42f1de9$export$2e2bcd8739ae039 = $ee1a9d5bb42f1de9$var$LozengeActionError;

});
parcelRegister("iPVbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a560b45251b869c0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $a1vqi = parcelRequire("a1vqi");

var $5vDFA = parcelRequire("5vDFA");

var $1VPdD = parcelRequire("1VPdD");
const $a560b45251b869c0$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $a560b45251b869c0$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $5uXOq.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $5vDFA.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1VPdD.startUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $5vDFA.mark(markName, 'resolved');
            (0, $1VPdD.succeedUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $5vDFA.mark(markName, 'errored');
            (0, $1VPdD.failUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $5vDFA.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $a560b45251b869c0$export$2e2bcd8739ae039 = $a560b45251b869c0$var$useInvokeClientAction;

});
parcelRegister("5vDFA", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $483ef2a5b4b04745$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $483ef2a5b4b04745$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $483ef2a5b4b04745$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $483ef2a5b4b04745$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $483ef2a5b4b04745$export$185802fd694ee1f5);
const $483ef2a5b4b04745$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $483ef2a5b4b04745$var$hasPerformanceAPIAvailable = $483ef2a5b4b04745$var$isPerformanceAPIAvailable();
const $483ef2a5b4b04745$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $483ef2a5b4b04745$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $483ef2a5b4b04745$export$1a717feb4df1a945 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $483ef2a5b4b04745$export$de42547d395c8271 = (id)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $483ef2a5b4b04745$var$getMark = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $483ef2a5b4b04745$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $483ef2a5b4b04745$export$185802fd694ee1f5 = (id, status)=>{
    if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
        const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
        const measure = $483ef2a5b4b04745$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $483ef2a5b4b04745$var$getMark(id, 'pending');
            const endMark = $483ef2a5b4b04745$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});


parcelRegister("fI1Ph", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b39c30f413189ec$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $dD7Zc = parcelRequire("dD7Zc");


var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $iPVbQ = parcelRequire("iPVbQ");

var $fpDmE = parcelRequire("fpDmE");

var $ljnlf = parcelRequire("ljnlf");
const $8b39c30f413189ec$var$MAX_LINE_NUMBER = 8;
const $8b39c30f413189ec$var$LozengeActionErrorOld = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $8b39c30f413189ec$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const invoke = (0, $iPVbQ.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const content = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: (0, $ljnlf.contentStyles)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            testId: `${testId}-icon`,
            LEGACY_size: "medium",
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: (0, $ljnlf.textStyles)(maxLineNumber),
            "data-testid": `${testId}-error-message`
        }, typeof errorMessage === 'string' ? errorMessage : (0, $fpDmE.getFormattedMessage)(errorMessage))), isPreviewAvailable ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: (0, $ljnlf.linkStyles)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("a", {
            target: "_blank",
            "data-testid": `${testId}-open-embed`,
            onClick: handlePreviewOpen
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $7zaVw.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        maxLineNumber,
        testId
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $ljnlf.dropdownItemGroupStyles),
        "data-testid": `${testId}-error-item-group`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aRoVz.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6B7KL.default), {
        testId: `${testId}-error`
    }, content))));
};
var $8b39c30f413189ec$export$2e2bcd8739ae039 = $8b39c30f413189ec$var$LozengeActionErrorOld;

});
parcelRegister("ljnlf", function(module, exports) {

$parcel$export(module.exports, "dropdownItemGroupStyles", () => $83fdad0d8ffe5982$export$2c40d814aeff5db);
$parcel$export(module.exports, "contentStyles", () => $83fdad0d8ffe5982$export$a38ecc1ac2e6fba);
$parcel$export(module.exports, "linkStyles", () => $83fdad0d8ffe5982$export$4ea5976125a01ffa);
$parcel$export(module.exports, "textStyles", () => $83fdad0d8ffe5982$export$6a54c24d15b0f6ba);
/* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $fpDmE = parcelRequire("fpDmE");
function $83fdad0d8ffe5982$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $83fdad0d8ffe5982$export$2c40d814aeff5db = {
    name: "a7m7l8",
    styles: "button{width:220px;&:hover{background-color:inherit;cursor:default;}}"
};
const $83fdad0d8ffe5982$var$sharedBlockStyles = {
    name: "gx0rja",
    styles: "display:flex;gap:var(--ds-space-100, 0.5rem);line-height:1rem;min-width:0;overflow:hidden;flex-direction:row;align-items:center"
};
const $83fdad0d8ffe5982$export$a38ecc1ac2e6fba = /*#__PURE__*/ (0, $f8Sb3.css)($83fdad0d8ffe5982$var$sharedBlockStyles, {
    marginTop: "var(--ds-space-025, 2px)",
    alignItems: 'flex-start',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span, > div': {
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`
    }
});
const $83fdad0d8ffe5982$export$4ea5976125a01ffa = /*#__PURE__*/ (0, $f8Sb3.css)($83fdad0d8ffe5982$var$sharedBlockStyles, "cursor:pointer;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-top:var(--ds-space-100, 8px);margin-left:var(--ds-space-400, 32px);margin-bottom:var(--ds-space-025, 2px);");
const $83fdad0d8ffe5982$export$6a54c24d15b0f6ba = (maxLines)=>/*#__PURE__*/ (0, $f8Sb3.css)("line-height:1rem;white-space:normal;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fpDmE.getTruncateStyles)(maxLines));

});



parcelRegister("1s0lY", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $47c640bee30204cc$export$4f2e371a667ad688);

var $7zaVw = parcelRequire("7zaVw");
const $47c640bee30204cc$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $7zaVw.messages)['status_change_permission_error']
    },
    unknown: {
        descriptor: (0, $7zaVw.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $7zaVw.messages)['status_change_update_error']
    }
};

});

parcelRegister("kf01E", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a0af43cfe2e114d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aRoVz = parcelRequire("aRoVz");

var $VSDnB = parcelRequire("VSDnB");

var $hgsSZ = parcelRequire("hgsSZ");

var $aNsD1 = parcelRequire("aNsD1");
const $9a0af43cfe2e114d$var$dropdownItemGroupStyles = null;
const $9a0af43cfe2e114d$var$LozengeActionItemsGroupNew = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ $5uXOq.createElement("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $bwpsq.default)([
            "_c71l1mjv _18m91wug _kewe1ano _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _d4lf1f4h _14hp1wdt _6pup1kw7"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $aRoVz.default), null, items.map((item, idx)=>/*#__PURE__*/ $5uXOq.createElement((0, $hgsSZ.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
const $9a0af43cfe2e114d$var$LozengeActionItemsGroup = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($9a0af43cfe2e114d$var$LozengeActionItemsGroupNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $aNsD1.default), props);
};
var $9a0af43cfe2e114d$export$2e2bcd8739ae039 = $9a0af43cfe2e114d$var$LozengeActionItemsGroup;

});
parcelRegister("hgsSZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $419e60cbfb62c454$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $lj8SI = parcelRequire("lj8SI");
const $419e60cbfb62c454$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        onMouseEnter: handleMouseEnter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
        appearance: appearance
    }, text))));
};
var $419e60cbfb62c454$export$2e2bcd8739ae039 = $419e60cbfb62c454$var$LozengeActionItem;

});

parcelRegister("aNsD1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8780db38fed84f1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $aRoVz = parcelRequire("aRoVz");

var $hgsSZ = parcelRequire("hgsSZ");

var $3UpeD = parcelRequire("3UpeD");
const $b8780db38fed84f1$var$LozengeActionItemsGroupOld = ({ items: items, testId: testId, onClick: onClick })=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: (0, $3UpeD.dropdownItemGroupStyles),
        "data-testid": `${testId}-item-group`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aRoVz.default), null, items.map((item, idx)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hgsSZ.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $b8780db38fed84f1$export$2e2bcd8739ae039 = $b8780db38fed84f1$var$LozengeActionItemsGroupOld;

});
parcelRegister("3UpeD", function(module, exports) {

$parcel$export(module.exports, "triggerButtonStyles", () => $c3acfc8ed6aa38b4$export$ae858546f0bfd05c);
$parcel$export(module.exports, "triggerLozengeStyles", () => $c3acfc8ed6aa38b4$export$5717c7336384f3a6);
$parcel$export(module.exports, "dropdownItemGroupStyles", () => $c3acfc8ed6aa38b4$export$2c40d814aeff5db);
/* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $c3acfc8ed6aa38b4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c3acfc8ed6aa38b4$export$ae858546f0bfd05c = /*#__PURE__*/ (0, $f8Sb3.css)({
    all: 'unset',
    backgroundColor: 'transparent',
    color: 'unset',
    cursor: 'pointer',
    fontFamily: 'unset',
    fontSize: 'unset',
    fontStyle: 'unset',
    fontWeight: 'unset',
    fontVariant: 'unset',
    lineHeight: 0,
    padding: 0,
    textTransform: 'unset',
    border: '2px solid transparent',
    margin: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:focus-visible, &:focus-within, &[aria-expanded='true']": {
        outline: 'none',
        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`,
        borderRadius: '5px'
    }
});
const $c3acfc8ed6aa38b4$export$5717c7336384f3a6 = {
    name: "1vr7vmn",
    styles: "align-items:center;display:flex"
};
const $c3acfc8ed6aa38b4$export$2c40d814aeff5db = /*#__PURE__*/ (0, $f8Sb3.css)({
    maxHeight: '300px',
    overflowY: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        minHeight: '28px',
        width: '220px',
        '&:hover': {
            backgroundColor: 'inherit'
        },
        '&:focus, &:focus-visible': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            boxSizing: 'border-box',
            boxShadow: `inset 2px 0 0 ${"var(--ds-border-selected, #0C66E4)"}`,
            outline: 'none'
        }
    }
});

});



parcelRegister("4Dg4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $afa61527cd4f792e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c8Oei = parcelRequire("c8Oei");

var $lj8SI = parcelRequire("lj8SI");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gqJFZ = parcelRequire("gqJFZ");
const $afa61527cd4f792e$var$chevronDownStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.075',
    display: 'flex'
});
const $afa61527cd4f792e$var$triggerLozengeStyles = null;
const $afa61527cd4f792e$var$triggerButtonStyles = null;
const $afa61527cd4f792e$var$LozengeActionTriggerNew = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ $5uXOq.createElement((0, $lj8SI.default), {
            appearance: appearance,
            isBold: isBold
        }, /*#__PURE__*/ $5uXOq.createElement("span", {
            className: (0, $bwpsq.default)([
                "_4cvr1h6o _1e0c1txw"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement("span", null, text), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
            as: "span",
            xcss: $afa61527cd4f792e$var$chevronDownStyles
        }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            color: "currentColor",
            label: "options",
            LEGACY_size: "medium",
            LEGACY_margin: "-4px -8px -4px -7px"
        })))), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ $5uXOq.createElement("button", {
        type: "button",
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _18s8v77o _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ])
    }, lozenge);
};
const $afa61527cd4f792e$var$LozengeActionTrigger = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($afa61527cd4f792e$var$LozengeActionTriggerNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $gqJFZ.default), props);
};
var $afa61527cd4f792e$export$2e2bcd8739ae039 = $afa61527cd4f792e$var$LozengeActionTrigger;

});
parcelRegister("gqJFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1dd9ec02fe2ecb0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $c8Oei = parcelRequire("c8Oei");

var $lj8SI = parcelRequire("lj8SI");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3UpeD = parcelRequire("3UpeD");
const $c1dd9ec02fe2ecb0$var$chevronDownStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.075',
    display: 'flex'
});
const $c1dd9ec02fe2ecb0$var$LozengeActionTriggerOld = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lj8SI.default), {
            appearance: appearance,
            isBold: isBold
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
            css: (0, $3UpeD.triggerLozengeStyles)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, text), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
            as: "span",
            xcss: $c1dd9ec02fe2ecb0$var$chevronDownStyles
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            color: "currentColor",
            label: "options",
            LEGACY_size: "medium",
            LEGACY_margin: "-4px -8px -4px -7px"
        })))), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        type: "button",
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $3UpeD.triggerButtonStyles),
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef
    }, lozenge);
};
var $c1dd9ec02fe2ecb0$export$2e2bcd8739ae039 = $c1dd9ec02fe2ecb0$var$LozengeActionTriggerOld;

});



parcelRegister("8jSB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab09cc0f4f9f380e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $lj8SI = parcelRequire("lj8SI");

var $Nh1XU = parcelRequire("Nh1XU");

var $a4DH1 = parcelRequire("a4DH1");
function $ab09cc0f4f9f380e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ab09cc0f4f9f380e$var$styles = {
    name: "cvfhjc",
    styles: "display:inline-flex;line-height:inherit"
};
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $ab09cc0f4f9f380e$var$LozengeOld = ({ action: action, appearance: appearance = 'default', name: name, overrideCss: overrideCss, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $a4DH1.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lj8SI.default), {
        appearance: appearance,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`
    }, text);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $ab09cc0f4f9f380e$var$styles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId
    }, lozenge);
};
var $ab09cc0f4f9f380e$export$2e2bcd8739ae039 = $ab09cc0f4f9f380e$var$LozengeOld;

});


parcelRegister("77cM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a723b9f793426daa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $l5Xsv = parcelRequire("l5Xsv");

var $1cbPc = parcelRequire("1cbPc");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $a723b9f793426daa$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $a723b9f793426daa$var$MediaNew = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $l5Xsv.default), {
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
const $a723b9f793426daa$var$Media = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($a723b9f793426daa$var$MediaNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $1cbPc.default), props);
};
var $a723b9f793426daa$export$2e2bcd8739ae039 = $a723b9f793426daa$var$Media;

});
parcelRegister("1cbPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $251e79e250945c39$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $l5Xsv = parcelRequire("l5Xsv");
function $251e79e250945c39$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $251e79e250945c39$var$styles = {
    name: "a50hvv",
    styles: "aspect-ratio:16 / 9;display:flex;width:100%;height:fit-content;@supports not (aspect-ratio: auto){padding-top:56.25%;height:0;position:relative;overflow:hidden;}> img, > span{min-height:100%;min-width:100%;max-height:100%;max-width:100%;object-fit:cover;object-position:center center;@supports not (aspect-ratio: auto){position:absolute;transform:translate(-50%, -50%);left:50%;top:50%;width:auto;height:auto;}}"
};
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $251e79e250945c39$var$MediaOld = ({ name: name, overrideCss: overrideCss, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $251e79e250945c39$var$styles,
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $l5Xsv.default), {
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $251e79e250945c39$export$2e2bcd8739ae039 = $251e79e250945c39$var$MediaOld;

});


parcelRegister("k39kU", function(module, exports) {

$parcel$export(module.exports, "default", () => $af078338fe34f0f5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $VSDnB = parcelRequire("VSDnB");

var $fpDmE = parcelRequire("fpDmE");

var $8dVhN = parcelRequire("8dVhN");
const $af078338fe34f0f5$var$baseStyle = null;
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $af078338fe34f0f5$var$TextNew = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text' })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_11c8qk37 _1reo15vq _18m915vq _syaz131l _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            "--_1erfju8": (0, $lD23V.default)(maxLines)
        }
    }, (0, $fpDmE.getFormattedMessage)(message) || content);
};
const $af078338fe34f0f5$var$Text = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($af078338fe34f0f5$var$TextNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $8dVhN.default), props);
};
var $af078338fe34f0f5$export$2e2bcd8739ae039 = $af078338fe34f0f5$var$Text;

});
parcelRegister("8dVhN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b7388e8498db33$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $fpDmE = parcelRequire("fpDmE");
const $c8b7388e8498db33$var$getStyles = (maxLines)=>/*#__PURE__*/ (0, $f8Sb3.css)("color:var(--ds-text-subtlest, #626F86);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);white-space:normal;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fpDmE.getTruncateStyles)(maxLines));
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $c8b7388e8498db33$var$TextOld = ({ content: content, maxLines: maxLines = 1, message: message, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-text' })=>{
    if (!message && !content) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $c8b7388e8498db33$var$getStyles(maxLines),
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId
    }, (0, $fpDmE.getFormattedMessage)(message) || content);
};
var $c8b7388e8498db33$export$2e2bcd8739ae039 = $c8b7388e8498db33$var$TextOld;

});



parcelRegister("kDhrr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5972a7cc25546c87$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $77cM6 = parcelRequire("77cM6");
const $5972a7cc25546c87$var$Preview = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $8dVIb.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $77cM6.default), {
        ...rest,
        ...data
    });
};
var $5972a7cc25546c87$export$2e2bcd8739ae039 = $5972a7cc25546c87$var$Preview;

});

parcelRegister("kp8aU", function(module, exports) {

$parcel$export(module.exports, "default", () => $673e9555bded0d05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $Nh1XU = parcelRequire("Nh1XU");

var $k39kU = parcelRequire("k39kU");

var $jDX3T = parcelRequire("jDX3T");
const $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $673e9555bded0d05$var$snippetBaseStyle = null;
const $673e9555bded0d05$var$SnippetElementNew = ({ content: overrideContent, maxLines: maxLines = $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...props } = {})=>{
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    return /*#__PURE__*/ $5uXOq.createElement((0, $k39kU.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_syaz1fxt _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...props
    });
};
const $673e9555bded0d05$var$SnippetElement = (props = {})=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($673e9555bded0d05$var$SnippetElementNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $jDX3T.default), props);
};
var $673e9555bded0d05$export$2e2bcd8739ae039 = $673e9555bded0d05$var$SnippetElement;

});
parcelRegister("jDX3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $65dab0752ce7d537$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $Nh1XU = parcelRequire("Nh1XU");

var $k39kU = parcelRequire("k39kU");
const $65dab0752ce7d537$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $65dab0752ce7d537$var$getSnippetStyles = (overrideCss)=>/*#__PURE__*/ (0, $f8Sb3.css)("color:var(--ds-text, #172B4D);-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    overrideCss);
const $65dab0752ce7d537$var$SnippetElementOld = ({ content: overrideContent, maxLines: maxLines = $65dab0752ce7d537$var$SNIPPET_DEFAULT_MAX_LINES, overrideCss: overrideCss, ...props } = {})=>{
    const context = (0, $5uXOq.useContext)((0, $Nh1XU.FlexibleUiContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $k39kU.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        overrideCss: $65dab0752ce7d537$var$getSnippetStyles(overrideCss),
        ...props
    });
};
var $65dab0752ce7d537$export$2e2bcd8739ae039 = $65dab0752ce7d537$var$SnippetElementOld;

});



parcelRegister("bubxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $66554651c27d9387$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $ldJSL = parcelRequire("ldJSL");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $bJeNF = parcelRequire("bJeNF");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $akF1x = parcelRequire("akF1x");

var $3Zm9O = parcelRequire("3Zm9O");

var $fFcX8 = parcelRequire("fFcX8");
const $66554651c27d9387$var$styles = null;
const $66554651c27d9387$var$renderActionItems = (items = [], size = (0, $8dVIb.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ $5uXOq.createElement((0, $3Zm9O.default), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $66554651c27d9387$var$ActionGroupNew = ({ items: items = [], size: size = (0, $8dVIb.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gKZoD.di)((0, $BLPHT.default));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fpDmE.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ $5uXOq.createElement((0, $ousew.default), (0, $7zaVw.messages).more_actions);
            return /*#__PURE__*/ $5uXOq.createElement((0, $BLPHT.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ $5uXOq.createElement((0, $fVnbM.default), {
                        ...props,
                        spacing: spacing,
                        testId: "action-group-more-button",
                        iconBefore: moreIcon,
                        ref: triggerRef
                    })),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex
            }, $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ $5uXOq.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1e0c116y _vwz41j6v _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen
    }, /*#__PURE__*/ $5uXOq.createElement((0, $ldJSL.default), null, actionButtons, moreActionDropdown)) : null;
};
const $66554651c27d9387$var$ActionGroup = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($66554651c27d9387$var$ActionGroupNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $fFcX8.default), props);
};
var $66554651c27d9387$export$2e2bcd8739ae039 = $66554651c27d9387$var$ActionGroup;

});
parcelRegister("bJeNF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::384f31b6891d11603b1a7b84cc388cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $889f60aca54b55ef$var$_react = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $889f60aca54b55ef$var$_showMoreHorizontal = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("8U6zd")));

var $889f60aca54b55ef$var$_more = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("3oUqw")));
function $889f60aca54b55ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $889f60aca54b55ef$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $889f60aca54b55ef$var$_react.default.createElement($889f60aca54b55ef$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $889f60aca54b55ef$var$_more.default
    }, props));
$889f60aca54b55ef$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $889f60aca54b55ef$var$_default = module.exports.default = $889f60aca54b55ef$var$ShowMoreHorizontalIcon;

});

parcelRegister("akF1x", function(module, exports) {

$parcel$export(module.exports, "getGapSize", () => $8ba323b39584fd77$export$ff20be09ae01c52e);
$parcel$export(module.exports, "getBaseStyles", () => $8ba323b39584fd77$export$bff8031d86bb089);
$parcel$export(module.exports, "highlightRemoveStyles", () => $8ba323b39584fd77$export$1928241a6f267c0d);
$parcel$export(module.exports, "getActionGroupStyles", () => $8ba323b39584fd77$export$393b0054595c3748);
$parcel$export(module.exports, "filterActionItems", () => $8ba323b39584fd77$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $8ba323b39584fd77$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $8ba323b39584fd77$export$9678d3ca18bd7526);

var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $91tw3 = parcelRequire("91tw3");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $1BfaB = parcelRequire("1BfaB");
function $8ba323b39584fd77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ba323b39584fd77$export$f942619ce67b1a41 = {
    [(0, $8dVIb.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Location]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Preview]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).Priority]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Provider]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Snippet]: [
        'block'
    ],
    [(0, $8dVIb.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).State]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).Title]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $8dVIb.ElementName).VoteCount]: [
        'inline'
    ]
};
var $8ba323b39584fd77$var$_ref2 = {
    name: "2rtvke",
    styles: "flex-direction:row;align-items:center"
};
var $8ba323b39584fd77$var$_ref3 = {
    name: "1ejri1g",
    styles: "flex-direction:column;align-items:flex-start"
};
const $8ba323b39584fd77$var$getDirectionStyles = (direction)=>{
    switch(direction){
        case (0, $8dVIb.SmartLinkDirection).Vertical:
            return $8ba323b39584fd77$var$_ref3;
        case (0, $8dVIb.SmartLinkDirection).Horizontal:
        default:
            return $8ba323b39584fd77$var$_ref2;
    }
};
const $8ba323b39584fd77$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $8dVIb.SmartLinkSize).Large:
            return 1;
        case (0, $8dVIb.SmartLinkSize).Medium:
            return 0.5;
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $8ba323b39584fd77$export$bff8031d86bb089 = (direction, size)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        alignItems: 'center',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gap: `${$8ba323b39584fd77$export$ff20be09ae01c52e(size)}rem`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1rem',
        minWidth: 0,
        overflow: 'hidden'
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $8ba323b39584fd77$var$getDirectionStyles(direction), "&:empty{display:none;}& > *{min-width:0;}& > [data-fit-to-content]{min-width:fit-content;}");
const $8ba323b39584fd77$export$1928241a6f267c0d = {
    name: "1klm9nt",
    styles: "outline:none!important;outline-color:inherit;color:inherit;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none"
};
const $8ba323b39584fd77$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $bubxq.default);
const $8ba323b39584fd77$var$isElementDisplayValid = (name, display)=>{
    return $8ba323b39584fd77$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $8ba323b39584fd77$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $8ba323b39584fd77$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && ((0, $91tw3.isFlexibleUiElement)(node) || node.type === (0, $1BfaB.default));
var $8ba323b39584fd77$var$_ref = {
    name: "bceqwf",
    styles: "max-height:2rem"
};
const $8ba323b39584fd77$export$393b0054595c3748 = (size)=>{
    if (size === (0, $8dVIb.SmartLinkSize).XLarge) // The biggest height of the action button exceeds the max line-height
    // of the elements causing the action on the block with x-large size to
    // get cut at the bottom.
    return $8ba323b39584fd77$var$_ref;
};
const $8ba323b39584fd77$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $8dVIb.ActionName).DeleteAction:
            case (0, $8dVIb.ActionName).EditAction:
            case (0, $8dVIb.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $8dVIb.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $8ba323b39584fd77$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if ($8ba323b39584fd77$var$isElementOrElementGroup(child) || $8ba323b39584fd77$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $8ba323b39584fd77$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $eqoQu[name];
        const typedProps = props;
        if (Element && $8ba323b39584fd77$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Element, {
                key: idx,
                ...typedProps
            });
            if (!$8ba323b39584fd77$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("1BfaB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed56962f49dee3a8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");

var $6HeLP = parcelRequire("6HeLP");
const $ed56962f49dee3a8$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $ed56962f49dee3a8$var$baseStyleBySize = {
    xlarge: "_zulp147b _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    large: "_zulp1e9d _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    medium: "_zulpcxkx _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    small: "_zulppdf9 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v"
};
const $ed56962f49dee3a8$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $ed56962f49dee3a8$var$baseStyle = null;
const $ed56962f49dee3a8$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $ed56962f49dee3a8$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $ed56962f49dee3a8$var$horizontalStyleBase = null;
const $ed56962f49dee3a8$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k1m1q",
    large: "_1e0ccj1k _102k1m1q",
    medium: "_1e0ccj1k _102k1k8s",
    small: "_1e0ccj1k _102k1k8s"
};
const $ed56962f49dee3a8$var$gapStylesLeft = {
    xlarge: "_7yhb147b _m6ukidpf",
    large: "_7yhb1e9d _m6ukidpf",
    medium: "_7yhbcxkx _m6ukidpf",
    small: "_7yhbpdf9 _m6ukidpf"
};
const $ed56962f49dee3a8$var$gapStylesRight = {
    xlarge: "_24rc147b _3dveidpf",
    large: "_24rc1e9d _3dveidpf",
    medium: "_24rccxkx _3dveidpf",
    small: "_24rcpdf9 _3dveidpf"
};
const $ed56962f49dee3a8$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $ed56962f49dee3a8$var$ElementGroupNew = ({ align: align = (0, $8dVIb.SmartLinkAlignment).Left, children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $8dVIb.SmartLinkWidth).FitToContent, position: position = (0, $8dVIb.SmartLinkPosition).Center, className: className })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $ed56962f49dee3a8$var$baseStyleBySize[size],
            $ed56962f49dee3a8$var$baseStyleByDirection[direction],
            "_fiawglyw _1ouwidpf _f6ju1ns9",
            $ed56962f49dee3a8$var$alignmentStyleMap[align],
            "_1ul99by0",
            $ed56962f49dee3a8$var$widthStyle[width],
            direction === (0, $8dVIb.SmartLinkDirection).Horizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            direction === (0, $8dVIb.SmartLinkDirection).Horizontal && $ed56962f49dee3a8$var$horizontalStyleByHeight[size],
            direction === (0, $8dVIb.SmartLinkDirection).Horizontal && align === (0, $8dVIb.SmartLinkAlignment).Left && $ed56962f49dee3a8$var$gapStylesLeft[size],
            direction === (0, $8dVIb.SmartLinkDirection).Horizontal && align === (0, $8dVIb.SmartLinkAlignment).Right && $ed56962f49dee3a8$var$gapStylesRight[size],
            $ed56962f49dee3a8$var$positionStyle[position],
            className
        ])
    }, (0, $akF1x.renderChildren)(children, size));
};
const $ed56962f49dee3a8$var$ElementGroup = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($ed56962f49dee3a8$var$ElementGroupNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $6HeLP.default), props);
};
var $ed56962f49dee3a8$export$2e2bcd8739ae039 = $ed56962f49dee3a8$var$ElementGroup;

});
parcelRegister("6HeLP", function(module, exports) {

$parcel$export(module.exports, "default", () => $71938689e0d5e5c1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $fpDmE = parcelRequire("fpDmE");

var $akF1x = parcelRequire("akF1x");
function $71938689e0d5e5c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $71938689e0d5e5c1$var$_ref = {
    name: "3l7cjm",
    styles: "-webkit-box-align:start;-ms-flex-align:start;justify-content:flex-start;text-align:left"
};
var $71938689e0d5e5c1$var$_ref2 = {
    name: "1ofqdyp",
    styles: "-webkit-box-align:end;-ms-flex-align:end;justify-content:flex-end;text-align:right"
};
const $71938689e0d5e5c1$var$getAlignmentStyles = (align)=>{
    switch(align){
        case (0, $8dVIb.SmartLinkAlignment).Right:
            return $71938689e0d5e5c1$var$_ref2;
        case (0, $8dVIb.SmartLinkAlignment).Left:
        default:
            return $71938689e0d5e5c1$var$_ref;
    }
};
const $71938689e0d5e5c1$var$getGapStyles = (size, align)=>{
    const gap = (0, $akF1x.getGapSize)(size);
    if (align === (0, $8dVIb.SmartLinkAlignment).Right) return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginLeft: `${gap}rem`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> span:first-child': {
            marginLeft: 'initial'
        }
    });
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginRight: `${gap}rem`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:last-child': {
                marginRight: 'initial'
            }
        }
    });
};
const $71938689e0d5e5c1$var$getHorizontalDirectionStyles = (size, align)=>{
    const lineHeight = (0, $fpDmE.getMaxLineHeight)(size);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $f8Sb3.css)("display:block;vertical-align:middle;", (0, $fpDmE.getTruncateStyles)(1, lineHeight + 'rem'), ">span,>div{vertical-align:middle;&[data-smart-element-date-time],&[data-smart-element-text]{display:inline;}}", $71938689e0d5e5c1$var$getGapStyles(size, align), ";");
};
const $71938689e0d5e5c1$export$91d118d179d992a4 = (direction, size, align, width, position)=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $akF1x.getBaseStyles)(direction, size), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $71938689e0d5e5c1$var$getAlignmentStyles(align), "min-width:10%;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    width === (0, $8dVIb.SmartLinkWidth).Flexible ? `flex: 1 3;` : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    direction === (0, $8dVIb.SmartLinkDirection).Horizontal ? $71938689e0d5e5c1$var$getHorizontalDirectionStyles(size, align) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    position === (0, $8dVIb.SmartLinkPosition).Top ? 'align-self: flex-start;' : '');
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $71938689e0d5e5c1$var$ElementGroup = ({ align: align = (0, $8dVIb.SmartLinkAlignment).Left, children: children, overrideCss: overrideCss, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $8dVIb.SmartLinkWidth).FitToContent, position: position = (0, $8dVIb.SmartLinkPosition).Center })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $71938689e0d5e5c1$export$91d118d179d992a4(direction, size, align, width, position),
            overrideCss
        ],
        "data-smart-element-group": true,
        "data-testid": testId
    }, (0, $akF1x.renderChildren)(children, size));
var $71938689e0d5e5c1$export$2e2bcd8739ae039 = $71938689e0d5e5c1$var$ElementGroup;

});



parcelRegister("3Zm9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $70338cdeec0a99e7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jRHKj = parcelRequire("jRHKj");
const $70338cdeec0a99e7$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $jRHKj ? $jRHKj[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $70338cdeec0a99e7$export$2e2bcd8739ae039 = $70338cdeec0a99e7$var$ActionGroupItem;

});
parcelRegister("jRHKj", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("23vM5")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("96Kdz")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("fEhHT")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("g9G65")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("b6Mes")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("9mTP8")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("jep3X")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("ziZLe")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("5OUwn")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("faTeC")).default);

var $23vM5 = parcelRequire("23vM5");

var $96Kdz = parcelRequire("96Kdz");

var $fEhHT = parcelRequire("fEhHT");

var $g9G65 = parcelRequire("g9G65");

var $b6Mes = parcelRequire("b6Mes");

var $9mTP8 = parcelRequire("9mTP8");

var $jep3X = parcelRequire("jep3X");

var $ziZLe = parcelRequire("ziZLe");

var $5OUwn = parcelRequire("5OUwn");

var $faTeC = parcelRequire("faTeC");

});
parcelRegister("23vM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf7d27623ce3bf9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $f6kZQ = parcelRequire("f6kZQ");

var $kuVc8 = parcelRequire("kuVc8");

var $bhB72 = parcelRequire("bhB72");

var $1wpdl = parcelRequire("1wpdl");

var $5z2J4 = parcelRequire("5z2J4");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $1bf7d27623ce3bf9$var$ActionNew = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, xcss: xcss, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bhB72.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    });
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wpdl.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kuVc8.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f6kZQ.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, button) : button;
};
const $1bf7d27623ce3bf9$var$Action = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1bf7d27623ce3bf9$var$ActionNew, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5z2J4.default), props);
};
var $1bf7d27623ce3bf9$export$2e2bcd8739ae039 = $1bf7d27623ce3bf9$var$Action;

});
parcelRegister("f6kZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ee32ab04698fad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $VSDnB = parcelRequire("VSDnB");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $fpDmE = parcelRequire("fpDmE");

var $8SRO9 = parcelRequire("8SRO9");
const $b3ee32ab04698fad$var$IconOnlyLarge = null;
const $b3ee32ab04698fad$var$SizeSmall = null;
const $b3ee32ab04698fad$var$SizeSmallIconOnly = null;
const $b3ee32ab04698fad$var$SizeSmallNotIconOnly = null;
const $b3ee32ab04698fad$var$ActionButtonNew = ({ appearance: appearance, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            size === (0, $8dVIb.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $8dVIb.SmartLinkSize).Small && "_11c8qk37 _k48p1wq8",
            size === (0, $8dVIb.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $8dVIb.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $fpDmE.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
const $b3ee32ab04698fad$var$ActionButton = (props)=>{
    return (0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3ee32ab04698fad$var$ActionButtonNew, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8SRO9.default), props);
};
var $b3ee32ab04698fad$export$2e2bcd8739ae039 = $b3ee32ab04698fad$var$ActionButton;

});
parcelRegister("8SRO9", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e42979d79aef9f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2rqOp = parcelRequire("2rqOp");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $fpDmE = parcelRequire("fpDmE");
function $60e42979d79aef9f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $60e42979d79aef9f$var$_ref = {
    name: "kaj2cp",
    styles: "button, button:hover, button:focus, button:active{padding:0;> span{margin:0;}}"
};
const $60e42979d79aef9f$var$getButtonStyle = (size, iconOnly)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).Large:
            return iconOnly ? $60e42979d79aef9f$var$_ref : '';
        case (0, $8dVIb.SmartLinkSize).Small:
            return /*#__PURE__*/ (0, $f8Sb3.css)({
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                fontWeight: "var(--ds-font-weight-medium, 500)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                'button, button:hover, button:focus, button:active': [
                    {
                        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                        lineHeight: 'inherit'
                    },
                    iconOnly ? `
            padding: 0.125rem;
          ` : `
            padding-left: 0.25rem;
            padding-right: 0.25rem;
          `
                ]
            });
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Medium:
        default:
            return '';
    }
};
const $60e42979d79aef9f$var$ActionButtonOld = ({ appearance: appearance, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, overrideCss: overrideCss, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $60e42979d79aef9f$var$getButtonStyle(size, iconOnly),
            overrideCss
        ],
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2rqOp.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $fpDmE.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
var $60e42979d79aef9f$export$2e2bcd8739ae039 = $60e42979d79aef9f$var$ActionButtonOld;

});


parcelRegister("kuVc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e656bda53d041540$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $kxcRq = parcelRequire("kxcRq");
const $e656bda53d041540$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $kxcRq.handleOnClick)(onClick),
        testId: testId
    }, content);
var $e656bda53d041540$export$2e2bcd8739ae039 = $e656bda53d041540$var$ActionDropdownItem;

});

parcelRegister("bhB72", function(module, exports) {

$parcel$export(module.exports, "default", () => $345d01659b23eb38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $hpcQP = parcelRequire("hpcQP");
const $345d01659b23eb38$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $345d01659b23eb38$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
const $345d01659b23eb38$var$stackItemIconStyles = null;
const $345d01659b23eb38$var$newStackItemIconStyles = null;
const $345d01659b23eb38$var$iconStyleMap = {
    true: "_syaz2oi6",
    false: "_syazwdcn"
};
const $345d01659b23eb38$var$ActionIconNew = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ $5uXOq.createElement("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $345d01659b23eb38$var$iconSizeStyleMap[$345d01659b23eb38$var$getIconWidth(size)]
        ])
    }, icon);
    return /*#__PURE__*/ $5uXOq.createElement("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            $345d01659b23eb38$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            "_1e0c1o8l"
        ])
    }, icon);
};
const $345d01659b23eb38$var$ActionIcon = (props)=>{
    return (0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard') ? /*#__PURE__*/ $5uXOq.createElement($345d01659b23eb38$var$ActionIconNew, props) : /*#__PURE__*/ $5uXOq.createElement((0, $hpcQP.default), props);
};
var $345d01659b23eb38$export$2e2bcd8739ae039 = $345d01659b23eb38$var$ActionIcon;

});
parcelRegister("hpcQP", function(module, exports) {

$parcel$export(module.exports, "default", () => $eab4e6fe8ea1cad3$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/use-tokens-typography */ /**
                                                                    * @jsxRuntime classic
                                                                    * @jsx jsx
                                                                    */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $fpDmE = parcelRequire("fpDmE");
function $eab4e6fe8ea1cad3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $eab4e6fe8ea1cad3$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $8dVIb.SmartLinkSize).XLarge:
        case (0, $8dVIb.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $8dVIb.SmartLinkSize).Medium:
        case (0, $8dVIb.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $eab4e6fe8ea1cad3$var$getIconStyles = (isDisabled)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)"
    });
const $eab4e6fe8ea1cad3$var$stackItemIconSizeStyles = (0, $fpDmE.getIconSizeStyles)('20px');
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $eab4e6fe8ea1cad3$var$stackItemIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)($eab4e6fe8ea1cad3$var$stackItemIconSizeStyles, "display:inline-block;line-height:0;padding:var(--ds-space-025, 2px);span,svg,img{line-height:0;}");
const $eab4e6fe8ea1cad3$var$newStackItemIconStyles = {
    name: "1pelf5a",
    styles: "display:inline-block;line-height:0"
};
const $eab4e6fe8ea1cad3$var$ActionIconOld = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $eab4e6fe8ea1cad3$var$getIconStyles(isDisabled),
            !(0, $VSDnB.fg)('platform-visual-refresh-icons') ? asStackItemIcon ? $eab4e6fe8ea1cad3$var$stackItemIconStyles : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $fpDmE.getIconSizeStyles)($eab4e6fe8ea1cad3$var$getIconWidth(size)) : $eab4e6fe8ea1cad3$var$newStackItemIconStyles
        ],
        "data-testid": `${testId}-icon`
    }, icon);
var $eab4e6fe8ea1cad3$export$2e2bcd8739ae039 = $eab4e6fe8ea1cad3$var$ActionIconOld;

});


parcelRegister("1wpdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $5PILj = parcelRequire("5PILj");
const $c6ef8f3a6ac7d3ff$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5PILj.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5PILj.default), {
            ...props,
            content: content,
            tooltipProps: tooltipProps
        }));
var $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039 = $c6ef8f3a6ac7d3ff$var$ActionStackItem;

});
parcelRegister("5PILj", function(module, exports) {

$parcel$export(module.exports, "default", () => $222d00bebc6cbf68$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $fpDmE = parcelRequire("fpDmE");

var $bhB72 = parcelRequire("bhB72");
const $222d00bebc6cbf68$var$buttonStyles = (0, $8CUq3.xcss)({
    all: 'unset',
    padding: 'space.050',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $222d00bebc6cbf68$var$contentStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $222d00bebc6cbf68$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, xcss: xcss })=>{
    const space = spaceOption ?? (0, $fpDmE.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bhB72.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: [
            $222d00bebc6cbf68$var$buttonStyles,
            xcss
        ],
        ...tooltipProps,
        onClick: onClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        grow: "fill",
        space: space
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $222d00bebc6cbf68$var$contentStyles
    }, content))));
};
var $222d00bebc6cbf68$export$2e2bcd8739ae039 = $222d00bebc6cbf68$var$ActionButton;

});


parcelRegister("5z2J4", function(module, exports) {

$parcel$export(module.exports, "default", () => $50898b71f3262b17$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $f6kZQ = parcelRequire("f6kZQ");

var $kuVc8 = parcelRequire("kuVc8");

var $bhB72 = parcelRequire("bhB72");

var $1wpdl = parcelRequire("1wpdl");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $50898b71f3262b17$var$ActionOld = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, xcss: xcss, asDropDownItem: asDropDownItem, overrideCss: overrideCss, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bhB72.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    });
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1wpdl.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kuVc8.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f6kZQ.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        overrideCss: overrideCss,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $f8Sb3.jsx)(Wrapper, null, button) : button;
};
var $50898b71f3262b17$export$2e2bcd8739ae039 = $50898b71f3262b17$var$ActionOld;

});


parcelRegister("96Kdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddac835e19e975e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $84THj = parcelRequire("84THj");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $ddac835e19e975e0$var$DeleteAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).delete),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).delete),
        ...props
    });
var $ddac835e19e975e0$export$2e2bcd8739ae039 = $ddac835e19e975e0$var$DeleteAction;

});

parcelRegister("fEhHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $23e1c92ea69f35be$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4ChK1 = parcelRequire("4ChK1");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
const $23e1c92ea69f35be$var$EditAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).edit),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ChK1))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).edit),
        ...props
    });
var $23e1c92ea69f35be$export$2e2bcd8739ae039 = $23e1c92ea69f35be$var$EditAction;

});
parcelRegister("4ChK1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0bc716a0db7d939b06b255b25c2b388>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
function $35c87913ec905242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35c87913ec905242$var$EditIcon = (props)=>/*#__PURE__*/ $35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
    }, props));
$35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df0e46d6520ed0b12c088820aa4dca0e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("gsEeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfbe7921991bc4cb$var$EditIcon = (props)=>/*#__PURE__*/ $bfbe7921991bc4cb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $bfbe7921991bc4cb$var$_edit.default
    }));
$bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;

});



parcelRegister("g9G65", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fb79986052b65c1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $d4dv2 = parcelRequire("d4dv2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $4fb79986052b65c1$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).DownloadAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $7zaVw.messages).download_file : (0, $7zaVw.messages).download;
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).download_description : (0, $7zaVw.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), label),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4dv2))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), tooltipMessage),
        ...data,
        ...props
    }) : null;
};
var $4fb79986052b65c1$export$2e2bcd8739ae039 = $4fb79986052b65c1$var$DownloadAction;

});
parcelRegister("d4dv2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37f28b4661c3f10f3f040a6e37c48b91>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98361ed174bfbb2b$var$_react = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $98361ed174bfbb2b$var$_download = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("EOGIN")));

var $98361ed174bfbb2b$var$_download2 = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5krT5")));
function $98361ed174bfbb2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98361ed174bfbb2b$var$DownloadIcon = (props)=>/*#__PURE__*/ $98361ed174bfbb2b$var$_react.default.createElement($98361ed174bfbb2b$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $98361ed174bfbb2b$var$_download2.default
    }, props));
$98361ed174bfbb2b$var$DownloadIcon.Name = 'DownloadIconMigration';
var $98361ed174bfbb2b$var$_default = module.exports.default = $98361ed174bfbb2b$var$DownloadIcon;

});
parcelRegister("EOGIN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::234ef6d678f6eb4cd1fc902b5a2375a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07ab0e2228a1635e$var$_react = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $07ab0e2228a1635e$var$_baseNew = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $07ab0e2228a1635e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07ab0e2228a1635e$var$DownloadIcon = (props)=>/*#__PURE__*/ $07ab0e2228a1635e$var$_react.default.createElement($07ab0e2228a1635e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
    }, props));
$07ab0e2228a1635e$var$DownloadIcon.displayName = 'DownloadIcon';
var $07ab0e2228a1635e$var$_default = module.exports.default = $07ab0e2228a1635e$var$DownloadIcon;

});

parcelRegister("5krT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e1473e49ea22b68$var$_react = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3e1473e49ea22b68$var$_download = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("EOGIN")));
function $3e1473e49ea22b68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e1473e49ea22b68$var$DownloadIcon = (props)=>/*#__PURE__*/ $3e1473e49ea22b68$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $3e1473e49ea22b68$var$_download.default
    }));
$3e1473e49ea22b68$var$DownloadIcon.displayName = 'DownloadIcon';
var $3e1473e49ea22b68$var$_default = module.exports.default = $3e1473e49ea22b68$var$DownloadIcon;

});



parcelRegister("b6Mes", function(module, exports) {

$parcel$export(module.exports, "default", () => $879133cabfb6e190$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $3xnBw = parcelRequire("3xnBw");

var $itef5 = parcelRequire("itef5");


const $879133cabfb6e190$var$importIconMapper = {
    goal: ()=>(parcelRequire("82OF2")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("9yaZS")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $879133cabfb6e190$var$getIcon = (stackIconType)=>{
    const importFn = $879133cabfb6e190$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fpDmE.importIcon)(importFn);
};
const $879133cabfb6e190$var$FollowAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $7zaVw.messages).follow : (0, $7zaVw.messages).unfollow;
    const projectMessage = value ? (0, $7zaVw.messages).follow_project : (0, $7zaVw.messages).unfollow_project;
    const goalMessage = value ? (0, $7zaVw.messages).follow_goal : (0, $7zaVw.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $7zaVw.messages).follow_project_description : (0, $7zaVw.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $7zaVw.messages).follow_goal_description : (0, $7zaVw.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $879133cabfb6e190$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $itef5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3xnBw.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), label),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), tooltipMessage),
        ...data,
        ...props,
        onError: handleError
    });
};
var $879133cabfb6e190$export$2e2bcd8739ae039 = $879133cabfb6e190$var$FollowAction;

});
parcelRegister("3xnBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $35d557ed1ef6412d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");

var $3q2sI = parcelRequire("3q2sI");

var $euMlu = parcelRequire("euMlu");

var $f22ja = parcelRequire("f22ja");

var $69hr0 = parcelRequire("69hr0");

var $23vM5 = parcelRequire("23vM5");
const $35d557ed1ef6412d$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const invoke = (0, $3q2sI.default)();
    const reload = (0, $f22ja.default)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $69hr0.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $euMlu.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23vM5.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $35d557ed1ef6412d$export$2e2bcd8739ae039 = $35d557ed1ef6412d$var$ServerAction;

});
parcelRegister("69hr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d791805237a266$export$2e2bcd8739ae039);
const $22d791805237a266$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $22d791805237a266$export$2e2bcd8739ae039 = $22d791805237a266$var$createInvokeRequest;

});


parcelRegister("itef5", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $d31a392ae92ce299$export$49248678d3914625);

var $7zaVw = parcelRequire("7zaVw");
const $d31a392ae92ce299$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $7zaVw.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $7zaVw.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $7zaVw.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $7zaVw.messages).unfollow_goal_error;
    return (0, $7zaVw.messages).generic_error_message;
};

});

parcelRegister("82OF2", function(module, exports) {

let $5db5ced4f0000848$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5db5ced4f0000848$var$load("h2MrD"),
    $5db5ced4f0000848$var$load("bYT2S"),
    $5db5ced4f0000848$var$load("ftS7u")
]).then(()=>parcelRequire('5UxRR'));

});

parcelRegister("9yaZS", function(module, exports) {

let $01cb5a17f25affbd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $01cb5a17f25affbd$var$load("h2MrD"),
    $01cb5a17f25affbd$var$load("bYT2S"),
    $01cb5a17f25affbd$var$load("3uQsu")
]).then(()=>parcelRequire('gsEJ1'));

});


parcelRegister("9mTP8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ea9170f77974c10$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $5JpK2 = parcelRequire("5JpK2");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $3ea9170f77974c10$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).PreviewAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $7zaVw.messages).preview_description : (0, $7zaVw.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).preview_improved),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), tooltipMessage),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $3ea9170f77974c10$export$2e2bcd8739ae039 = $3ea9170f77974c10$var$PreviewAction;

});
parcelRegister("5JpK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a044223350e041031a35374685e9a4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));

var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
    }, props));
$42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;

});


parcelRegister("jep3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1e0763b6a84021$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jOyH3 = parcelRequire("jOyH3");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $iPVbQ = parcelRequire("iPVbQ");

var $23vM5 = parcelRequire("23vM5");
const $0d1e0763b6a84021$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const invoke = (0, $iPVbQ.default)({});
    const data = context?.actions?.[(0, $8dVIb.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_url_to_clipboard);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $7zaVw.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).copy_url_to_clipboard),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $0d1e0763b6a84021$export$2e2bcd8739ae039 = $0d1e0763b6a84021$var$CopyLinkAction;

});

parcelRegister("ziZLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b53b1e1aa704061$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $dgRei = parcelRequire("dgRei");
const $8b53b1e1aa704061$var$AISummaryAction = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dgRei.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $8b53b1e1aa704061$export$2e2bcd8739ae039 = $8b53b1e1aa704061$var$AISummaryAction;

});
parcelRegister("dgRei", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $a6e4dbdfe418b2c1$export$8eed96bc6d982595);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $1MeuC = parcelRequire("1MeuC");

var $8UCLX = parcelRequire("8UCLX");

var $jdA9V = parcelRequire("jdA9V");
const $a6e4dbdfe418b2c1$export$8eed96bc6d982595 = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $1MeuC.default)(url);
    (0, $5uXOq.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdA9V.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8UCLX.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("1MeuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $27e30e18347ce2a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hWyvy = parcelRequire("hWyvy");
var $8UXrm = parcelRequire("8UXrm");

var $a1vqi = parcelRequire("a1vqi");

var $1VPdD = parcelRequire("1VPdD");

var $hjhAz = parcelRequire("hjhAz");

var $kR87P = parcelRequire("kR87P");

var $anB5s = parcelRequire("anB5s");
const $27e30e18347ce2a0$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $27e30e18347ce2a0$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $anB5s.useAISummaryConfig)();
    const cardState = (0, $hjhAz.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $hWyvy.extractAri)(data);
    const dataUrl = data && (0, $8UXrm.extractLink)(data) || '';
    const onStart = (0, $5uXOq.useCallback)((id)=>{
        (0, $1VPdD.startUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $5uXOq.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1VPdD.succeedUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $5uXOq.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1VPdD.failUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $kR87P.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $27e30e18347ce2a0$export$2e2bcd8739ae039 = $27e30e18347ce2a0$var$useAISummaryAction;

});
parcelRegister("hWyvy", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $e72cc95d6d37b739$export$be18a6294fd426ec);
const $e72cc95d6d37b739$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("8UXrm", function(module, exports) {

$parcel$export(module.exports, "extractLink", () => $c7ac01b191c63203$export$63f54cf4c5883620);

var $7OmtM = parcelRequire("7OmtM");
const $c7ac01b191c63203$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $7OmtM.extractUrlFromLinkJsonLd)(url);
    }
};

});
parcelRegister("7OmtM", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $0784379594099aa0$export$396ba4ef2e37dc65);
const $0784379594099aa0$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $0784379594099aa0$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("kR87P", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $c5395471ca862cc2$export$becd8f2eba1bbd96);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $SrCME = parcelRequire("SrCME");

var $561ku = parcelRequire("561ku");
const $c5395471ca862cc2$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $5uXOq.useState)((0, $561ku.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $VSDnB.fg)('send_locale_to_summarize_in_assistance-service') ? (0, $koVbs.default)() : {
        locale: undefined
    };
    (0, $5uXOq.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $561ku.AISummariesStore).get(url)) (0, $561ku.AISummariesStore).set(url, new (0, $SrCME.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            ...(0, $VSDnB.fg)('send_locale_to_summarize_in_assistance-service') && {
                locale: locale
            },
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $561ku.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $561ku.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("SrCME", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $ad05438f1e08870b$export$73e4b807d5bd74b6);

var $7Jxgt = parcelRequire("7Jxgt");

var $itO4f = parcelRequire("itO4f");

var $VSDnB = parcelRequire("VSDnB");

var $9AA7J = parcelRequire("9AA7J");

var $c0Zwh = parcelRequire("c0Zwh");

var $ghXNq = parcelRequire("ghXNq");
class $ad05438f1e08870b$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $itO4f.getBaseUrl)(envKey);
                return (0, $ghXNq.addPath)(baseUrl, path);
            }
            return (0, $ghXNq.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    ...(0, $VSDnB.fg)('send_locale_to_summarize_in_assistance-service') && {
                        locale: this.locale
                    }
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $9AA7J.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $ghXNq.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $c0Zwh.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $c0Zwh.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("9AA7J", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $27dc203987154036$export$e45226161c660403);

var $ghXNq = parcelRequire("ghXNq");
async function* $27dc203987154036$export$e45226161c660403(response) {
    const reader = (0, $ghXNq.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("ghXNq", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $6c9c387ba5dd9d5b$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $6c9c387ba5dd9d5b$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $6c9c387ba5dd9d5b$export$ff2962de2b2c930f);
const $6c9c387ba5dd9d5b$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $6c9c387ba5dd9d5b$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $6c9c387ba5dd9d5b$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $6c9c387ba5dd9d5b$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $6c9c387ba5dd9d5b$export$ff2962de2b2c930f = (product)=>{
    if ($6c9c387ba5dd9d5b$var$isJiraProduct(product)) return $6c9c387ba5dd9d5b$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("c0Zwh", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $0e5f8d5a8019ed33$export$fcec967a4b7ebd84);
class $0e5f8d5a8019ed33$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $0e5f8d5a8019ed33$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("561ku", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $cc472589618fd980$export$6979339b6d41707e);

var $iwKVT = parcelRequire("iwKVT");
const $cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE = 100;
const $cc472589618fd980$export$6979339b6d41707e = new (0, $iwKVT.LRUMap)($cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("anB5s", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $cd0a62b074a064ce$export$4480af2c00aa7ebe);

var $5uXOq = parcelRequire("5uXOq");

var $051X7 = parcelRequire("051X7");
const $cd0a62b074a064ce$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $051X7.useSmartLinkContext)();
    return (0, $5uXOq.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("8UCLX", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $a2971ac1720627ee$export$75a19de44af58722);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $jps85 = parcelRequire("jps85");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $8z1HA = parcelRequire("8z1HA");

var $23vM5 = parcelRequire("23vM5");

var $blyr7 = parcelRequire("blyr7");
function $a2971ac1720627ee$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onCompleted = (0, $5uXOq.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $blyr7.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).ai_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $8z1HA.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).ai_summary_action_description),
        ...props
    });
}

});
parcelRegister("jps85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d5c19b91ac54d446fcaff0cc7653cf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2162c0618e136c6$var$_react = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e2162c0618e136c6$var$_baseNew = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e2162c0618e136c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2162c0618e136c6$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $e2162c0618e136c6$var$_react.default.createElement($e2162c0618e136c6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m2 2 4 4m8 8-4-4m4-8-4 4m-8 8 4-4m2-9v3m0 8v3m7-7h-3M4 8H1"/>`
    }, props));
$e2162c0618e136c6$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $e2162c0618e136c6$var$_default = module.exports.default = $e2162c0618e136c6$var$AtlassianIntelligenceIcon;

});

parcelRegister("8z1HA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8c2f1acb4b6b88$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $7f8c2f1acb4b6b88$var$AiIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dV6Te.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: "var(--ds-icon, #44546F)"
    })));
var $7f8c2f1acb4b6b88$export$2e2bcd8739ae039 = $7f8c2f1acb4b6b88$var$AiIcon;

});

parcelRegister("blyr7", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $2b1346f84062e88d$export$82f46aa4e6535a45);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $cnaAy = parcelRequire("cnaAy");

var $RbANO = parcelRequire("RbANO");

var $1r4gF = parcelRequire("1r4gF");
const $2b1346f84062e88d$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $cnaAy.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $RbANO.default), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...message,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1r4gF.default), {
                        href: url
                    }, chunks)
            }
        }))
    };
};

});
parcelRegister("cnaAy", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $3339f41fc1b0dac1$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $3339f41fc1b0dac1$export$cd2e891d7f87074d);

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");
const $3339f41fc1b0dac1$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $3339f41fc1b0dac1$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $8dVIb.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $7zaVw.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $7zaVw.messages).ai_summary_error_generic,
                url: (0, $8dVIb.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("RbANO", function(module, exports) {

$parcel$export(module.exports, "default", () => $402c39c7523f0dd1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $402c39c7523f0dd1$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $402c39c7523f0dd1$export$2e2bcd8739ae039 = $402c39c7523f0dd1$var$AIEventErrorViewed;

});

parcelRegister("1r4gF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8f369a3b340dfb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");
const $ff8f369a3b340dfb$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: (0, $8dVIb.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props
    }, children);
var $ff8f369a3b340dfb$export$2e2bcd8739ae039 = $ff8f369a3b340dfb$var$AILearnMoreAnchor;

});



parcelRegister("jdA9V", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $2e1357a85e616794$export$cfa1d3eed9a61059);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $3Fq5M = parcelRequire("3Fq5M");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $23vM5 = parcelRequire("23vM5");
function $2e1357a85e616794$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7zaVw.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $5uXOq.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $7zaVw.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).copy_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $7zaVw.messages).copy_summary_action_description),
        ...props
    });
}

});



parcelRegister("5OUwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd2a7343c5a2622$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $4ldhu = parcelRequire("4ldhu");

var $cgL5K = parcelRequire("cgL5K");

var $a1vqi = parcelRequire("a1vqi");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $e5vwM = parcelRequire("e5vwM");

var $3Lbo8 = parcelRequire("3Lbo8");

const $9fd2a7343c5a2622$var$AutomationModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("EjrMr")));
const $9fd2a7343c5a2622$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $8dVIb.ActionName).AutomationAction];
    const automationActionOnClick = (0, $5uXOq.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $3Lbo8.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), modalTitle) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "strong"
                    }, chunks),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null)
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9fd2a7343c5a2622$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $7zaVw.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23vM5.default), {
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, $e5vwM.default),
            color: "currentColor",
            label: automationActionIconLabel
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip,
        ...props,
        onClick: ()=>automationActionOnClick(automationActionData)
    }));
};
var $9fd2a7343c5a2622$export$2e2bcd8739ae039 = $9fd2a7343c5a2622$var$AutomationAction;

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f63c4f2736d56f4b2fa41b3195f28f63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6 15.25-.723-.2a.75.75 0 0 0 1.253.73zM13.25 8l.53.53a.75.75 0 0 0-.53-1.28zM10 .75l.723.2A.75.75 0 0 0 9.47.22zM2.75 8l-.53-.53a.75.75 0 0 0 .53 1.28zm3.78 7.78 7.25-7.25-1.06-1.06-7.25 7.25zm6.72-8.53H8v1.5h5.25zm-4.527.95 2-7.25-1.446-.4-2 7.25zM9.47.22 2.22 7.47l1.06 1.06 7.25-7.25zM2.75 8.75H8v-1.5H2.75zm4.527-.95-2 7.25 1.446.4 2-7.25z"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("7HAq8", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $bc735e1cde43eb76$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8);

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $lnPiq = parcelRequire("lnPiq");
const $bc735e1cde43eb76$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $bc735e1cde43eb76$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($bc735e1cde43eb76$var$FALLBACK_API);
const $bc735e1cde43eb76$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    const api = (0, $5uXOq.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lnPiq.StopPropagation), null, modal))),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $5uXOq.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $5uXOq.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc735e1cde43eb76$export$f4c0a0f23ba57f8c.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f4cXA.ErrorBoundary), {
        fallbackRender: fallbackRender,
        onReset: onReset
    }, element));
};
const $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8 = ()=>(0, $5uXOq.useContext)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c);

});
parcelRegister("lnPiq", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $a203465a8c9e0684$export$3e100bc08448f36c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $a203465a8c9e0684$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a203465a8c9e0684$var$styles = {
    name: "g32yti",
    styles: "max-height:0;max-width:0;position:absolute"
};
const $a203465a8c9e0684$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $a203465a8c9e0684$var$styles,
        onClick: onClick
    }, children));
};

});


parcelRegister("e5vwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $23884530c116b98b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $23884530c116b98b$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
var $23884530c116b98b$export$2e2bcd8739ae039 = $23884530c116b98b$var$AutomationManualTriggersGlyph;

});

parcelRegister("3Lbo8", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $6b74a4060fa13021$export$93e707b363eaf5c8);

var $7zaVw = parcelRequire("7zaVw");
const $6b74a4060fa13021$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $7zaVw.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $7zaVw.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("EjrMr", function(module, exports) {

let $0792d252ffbcd5aa$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $0792d252ffbcd5aa$var$load("hPzOn"),
    $0792d252ffbcd5aa$var$load("h2MrD"),
    $0792d252ffbcd5aa$var$load("bYT2S"),
    $0792d252ffbcd5aa$var$load("lchYl")
]).then(()=>parcelRequire('1Rjyb'));

});


parcelRegister("faTeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b95acafe5e8a7ba5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $a1vqi = parcelRequire("a1vqi");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $7HAq8 = parcelRequire("7HAq8");

var $23vM5 = parcelRequire("23vM5");

var $k98Kd = parcelRequire("k98Kd");

const $b95acafe5e8a7ba5$var$RelatedLinksModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("19m52")));
const $b95acafe5e8a7ba5$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $7HAq8.useSmartLinkModal)();
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b95acafe5e8a7ba5$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23vM5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).related_links_view_related_urls),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k98Kd.default), null),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $b95acafe5e8a7ba5$export$2e2bcd8739ae039 = $b95acafe5e8a7ba5$var$ViewRelatedLinksAction;

});
parcelRegister("k98Kd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9aac1bc71ae3e1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ehOs2 = parcelRequire("ehOs2");

var $VSDnB = parcelRequire("VSDnB");

var $cfYWA = parcelRequire("cfYWA");
const $7c9aac1bc71ae3e1$var$rotateSvg = null;
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $7c9aac1bc71ae3e1$var$RelatedLinksActionIconNew = ()=>/*#__PURE__*/ $5uXOq.createElement("span", {
        className: (0, $bwpsq.default)([
            "_t9ec1sub _1e0c1o8l"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ehOs2))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View recent links..."
    }));
const $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon = ()=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($7c9aac1bc71ae3e1$var$RelatedLinksActionIconNew, null);
    return /*#__PURE__*/ $5uXOq.createElement((0, $cfYWA.default), null);
};
var $7c9aac1bc71ae3e1$export$2e2bcd8739ae039 = $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon;

});
parcelRegister("ehOs2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7df931fb69dd4b6219148758c48ee3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a669c9c7dda1a2bd$var$_react = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a669c9c7dda1a2bd$var$_childIssues = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("a5U1O")));

var $a669c9c7dda1a2bd$var$_childIssues2 = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("hxodJ")));
function $a669c9c7dda1a2bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChildIssuesIcon.
 * This component is ChildIssuesIcon, with `UNSAFE_fallbackIcon` set to "ChildIssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a669c9c7dda1a2bd$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $a669c9c7dda1a2bd$var$_react.default.createElement($a669c9c7dda1a2bd$var$_childIssues.default, Object.assign({
        LEGACY_fallbackIcon: $a669c9c7dda1a2bd$var$_childIssues2.default
    }, props));
$a669c9c7dda1a2bd$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
var $a669c9c7dda1a2bd$var$_default = module.exports.default = $a669c9c7dda1a2bd$var$ChildIssuesIcon;

});
parcelRegister("a5U1O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a61c40139d910e35e43ae72e1295acfa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7595d510a7cf11ee$var$_react = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7595d510a7cf11ee$var$_baseNew = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7595d510a7cf11ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7595d510a7cf11ee$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $7595d510a7cf11ee$var$_react.default.createElement($7595d510a7cf11ee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 12.25v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0H3c-.69 0-1.25-.56-1.25-1.25V5.25m0-4.25v4.25m6 0v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0h-6"/>`
    }, props));
$7595d510a7cf11ee$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $7595d510a7cf11ee$var$_default = module.exports.default = $7595d510a7cf11ee$var$ChildIssuesIcon;

});

parcelRegister("hxodJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc484e6d94653edf$var$_react = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cc484e6d94653edf$var$_childIssues = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("a5U1O")));
function $cc484e6d94653edf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc484e6d94653edf$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $cc484e6d94653edf$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $cc484e6d94653edf$var$_childIssues.default
    }));
$cc484e6d94653edf$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $cc484e6d94653edf$var$_default = module.exports.default = $cc484e6d94653edf$var$ChildIssuesIcon;

});


parcelRegister("cfYWA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3775a8c9b9ec23c2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $ehOs2 = parcelRequire("ehOs2");
function $3775a8c9b9ec23c2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3775a8c9b9ec23c2$var$rotateSvg = {
    name: "9v7l5f",
    styles: "transform:rotate(180deg);display:inline-block"
};
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $3775a8c9b9ec23c2$var$RelatedLinksActionIconOld = ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $3775a8c9b9ec23c2$var$rotateSvg
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ehOs2))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View recent links..."
    }));
var $3775a8c9b9ec23c2$export$2e2bcd8739ae039 = $3775a8c9b9ec23c2$var$RelatedLinksActionIconOld;

});


parcelRegister("19m52", function(module, exports) {

let $0d67c25d523d11e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0d67c25d523d11e2$var$load("dXU8n").then(()=>parcelRequire('14MtF'));

});




parcelRegister("fFcX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f23c7150d4c586bb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $ldJSL = parcelRequire("ldJSL");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $bJeNF = parcelRequire("bJeNF");

var $3bDjY = parcelRequire("3bDjY");

var $8dVIb = parcelRequire("8dVIb");

var $7zaVw = parcelRequire("7zaVw");

var $Nh1XU = parcelRequire("Nh1XU");

var $fpDmE = parcelRequire("fpDmE");

var $akF1x = parcelRequire("akF1x");

var $3Zm9O = parcelRequire("3Zm9O");
function $f23c7150d4c586bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f23c7150d4c586bb$var$styles = {
    name: "inf63k",
    styles: "display:inline-flex;line-height:1rem;> div{align-items:center;button:focus-visible{outline-offset:var(--ds-space-negative-025, -2px);}}"
};
const $f23c7150d4c586bb$var$renderActionItems = (items = [], size = (0, $8dVIb.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3Zm9O.default), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $f23c7150d4c586bb$var$ActionGroupOld = ({ items: items = [], size: size = (0, $8dVIb.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gKZoD.di)((0, $BLPHT.default));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $f23c7150d4c586bb$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fpDmE.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $7zaVw.messages).more_actions);
            return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $BLPHT.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fVnbM.default), {
                        ...props,
                        spacing: spacing,
                        testId: "action-group-more-button",
                        iconBefore: moreIcon,
                        ref: triggerRef
                    })),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex
            }, $f23c7150d4c586bb$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $f23c7150d4c586bb$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "actions-button-group",
        "data-action-open": isOpen
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ldJSL.default), null, actionButtons, moreActionDropdown)) : null;
};
var $f23c7150d4c586bb$export$2e2bcd8739ae039 = $f23c7150d4c586bb$var$ActionGroupOld;

});


parcelRegister("dghu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a6d91fb5d77548$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");

var $3YqTr = parcelRequire("3YqTr");
const $96a6d91fb5d77548$var$BaseBlockStyles = null;
const $96a6d91fb5d77548$var$highlightRemoveStyles = null;
const $96a6d91fb5d77548$var$gapsStyles = {
    xlarge: "_zulp1k92 _1ljq1k92",
    large: "_zulp1j6v _1ljq1j6v",
    medium: "_zulp1kwk _1ljq1kwk",
    small: "_zulp6mu8 _1ljq6mu8"
};
const $96a6d91fb5d77548$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $96a6d91fb5d77548$var$BlockNew = ({ children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style })=>{
    (0, $5uXOq.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _vwz41j6v _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1ouwidpf _f6ju1ns9 _1uzp1mp2 _ytq1bjq5 _a7e8uxlv",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $96a6d91fb5d77548$var$directionStyles[direction],
            $96a6d91fb5d77548$var$gapsStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style
    }, (0, $akF1x.renderChildren)(children, size));
};
const $96a6d91fb5d77548$var$Block = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($96a6d91fb5d77548$var$BlockNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $3YqTr.default), props);
};
var $96a6d91fb5d77548$export$2e2bcd8739ae039 = $96a6d91fb5d77548$var$Block;

});
parcelRegister("3YqTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dbed1cfa38332fb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $akF1x = parcelRequire("akF1x");
const $4dbed1cfa38332fb$var$getBlockStyles = (direction, size)=>/*#__PURE__*/ (0, $f8Sb3.css)((0, $akF1x.getBaseStyles)(direction, size), " ", (0, $akF1x.highlightRemoveStyles), " justify-content:flex-start;[data-separator]+[data-separator]:before{content:'\u2022';margin-right:", (0, $akF1x.getGapSize)(size), "rem;}[data-smart-element='", (0, $8dVIb.ElementName).SourceBranch, "']+[data-smart-element='", (0, $8dVIb.ElementName).TargetBranch, "']:before{content:'\u2192';}[data-smart-element='", (0, $8dVIb.ElementName).TargetBranch, "']+[data-smart-element='", (0, $8dVIb.ElementName).SourceBranch, "']:before{content:'\u2190';}");
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $4dbed1cfa38332fb$var$Block = ({ children: children, direction: direction = (0, $8dVIb.SmartLinkDirection).Horizontal, size: size = (0, $8dVIb.SmartLinkSize).Medium, testId: testId = 'smart-block', overrideCss: overrideCss, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd })=>{
    (0, $5uXOq.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $4dbed1cfa38332fb$var$getBlockStyles(direction, size),
            overrideCss
        ],
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef
    }, (0, $akF1x.renderChildren)(children, size));
};
var $4dbed1cfa38332fb$export$2e2bcd8739ae039 = $4dbed1cfa38332fb$var$Block;

});


parcelRegister("dEOWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d7291a62484db7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $e3d7291a62484db7$var$FooterBlockResolvedViewOld = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $8dVIb.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const hasActions = (0, $5uXOq.useMemo)(()=>(0, $akF1x.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eqoQu.Provider), {
        testId: `${testId}-provider`
    }), actions && hasActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BfaB.default), {
        testId: "smart-element-group-actions",
        align: (0, $8dVIb.SmartLinkAlignment).Right,
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
        overrideCss: (0, $akF1x.getActionGroupStyles)(size),
        width: (0, $8dVIb.SmartLinkWidth).Flexible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bubxq.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: "default"
    })) : null);
};
var $e3d7291a62484db7$export$2e2bcd8739ae039 = $e3d7291a62484db7$var$FooterBlockResolvedViewOld;

});



parcelRegister("gg6Qm", function(module, exports) {

$parcel$export(module.exports, "default", () => $61dcf60a0013442f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");

var $3M28Q = parcelRequire("3M28Q");
const $61dcf60a0013442f$var$DEFAULT_MAX_LINES = 2;
const $61dcf60a0013442f$var$MAXIMUM_MAX_LINES = 2;
const $61dcf60a0013442f$var$MINIMUM_MAX_LINES = 1;
const $61dcf60a0013442f$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $61dcf60a0013442f$var$sizeStyles = {
    xlarge: "_vwz41m1q _102k1k7u",
    large: "_vwz41m1q _102k1k7u",
    medium: "_vwz41k8s _102k1wto",
    small: "_vwz41k8s _102k1wto"
};
const $61dcf60a0013442f$var$getMaxLines = (maxLines)=>{
    if (maxLines > $61dcf60a0013442f$var$MAXIMUM_MAX_LINES) return $61dcf60a0013442f$var$DEFAULT_MAX_LINES;
    if (maxLines < $61dcf60a0013442f$var$MINIMUM_MAX_LINES) return $61dcf60a0013442f$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $61dcf60a0013442f$var$MetadataBlock = ({ maxLines: maxLines = $61dcf60a0013442f$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $akF1x.renderElementItems)(primary);
    const secondaryElements = (0, $akF1x.renderElementItems)(secondary);
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const maxLinesTotal = $61dcf60a0013442f$var$getMaxLines(maxLines);
    return /*#__PURE__*/ $5uXOq.createElement((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, primaryElements && /*#__PURE__*/ $5uXOq.createElement((0, $1BfaB.default), {
        align: (0, $8dVIb.SmartLinkAlignment).Left,
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
        width: (0, $8dVIb.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $bwpsq.default)([
            $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
            $61dcf60a0013442f$var$sizeStyles[size]
        ])
    }, primaryElements), secondaryElements && /*#__PURE__*/ $5uXOq.createElement((0, $1BfaB.default), {
        align: (0, $8dVIb.SmartLinkAlignment).Right,
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
        width: (0, $8dVIb.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $bwpsq.default)([
            $61dcf60a0013442f$var$truncateStyles[maxLinesTotal],
            $61dcf60a0013442f$var$sizeStyles[size]
        ])
    }, secondaryElements));
};
const $61dcf60a0013442f$var$MetadataBlockExported = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($61dcf60a0013442f$var$MetadataBlock, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $3M28Q.default), props);
};
var $61dcf60a0013442f$export$2e2bcd8739ae039 = $61dcf60a0013442f$var$MetadataBlockExported;

});
parcelRegister("3M28Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7c294272d295a9c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
const $c7c294272d295a9c$var$DEFAULT_MAX_LINES = 2;
const $c7c294272d295a9c$var$MAXIMUM_MAX_LINES = 2;
const $c7c294272d295a9c$var$MINIMUM_MAX_LINES = 1;
const $c7c294272d295a9c$var$getElementGroupStyles = (size, maxLines)=>{
    // MetadataBlock allows metadata elements to be displayed in
    // multiple lines, with maximum of 2 lines.
    // We need the height of the line to be equal on both left and right
    // sides so they line up nicely.
    const lineHeight = (0, $fpDmE.getMaxLineHeight)(size);
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: `${lineHeight}rem`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fpDmE.getTruncateStyles)(maxLines, lineHeight + 'rem'));
};
const $c7c294272d295a9c$var$getMaxLines = (maxLines)=>{
    if (maxLines > $c7c294272d295a9c$var$MAXIMUM_MAX_LINES) return $c7c294272d295a9c$var$DEFAULT_MAX_LINES;
    if (maxLines < $c7c294272d295a9c$var$MINIMUM_MAX_LINES) return $c7c294272d295a9c$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $c7c294272d295a9c$var$MetadataBlockOld = ({ maxLines: maxLines = $c7c294272d295a9c$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $akF1x.renderElementItems)(primary);
    const secondaryElements = (0, $akF1x.renderElementItems)(secondary);
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const elementGroupStyles = $c7c294272d295a9c$var$getElementGroupStyles(size, $c7c294272d295a9c$var$getMaxLines(maxLines));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, primaryElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BfaB.default), {
        align: (0, $8dVIb.SmartLinkAlignment).Left,
        overrideCss: elementGroupStyles,
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
        width: (0, $8dVIb.SmartLinkWidth).Flexible
    }, primaryElements), secondaryElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BfaB.default), {
        align: (0, $8dVIb.SmartLinkAlignment).Right,
        overrideCss: elementGroupStyles,
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
        width: (0, $8dVIb.SmartLinkWidth).Flexible
    }, secondaryElements));
};
var $c7c294272d295a9c$export$2e2bcd8739ae039 = $c7c294272d295a9c$var$MetadataBlockOld;

});


parcelRegister("hYQw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $61b44b31e2da1312$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $lee4B = parcelRequire("lee4B");

var $cElbi = parcelRequire("cElbi");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $61b44b31e2da1312$var$PreviewBlock = ({ status: // eslint-disable-next-line @typescript-eslint/no-unused-vars
status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cElbi.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
const $61b44b31e2da1312$var$Exported = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61b44b31e2da1312$var$PreviewBlock, props);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lee4B.default), props);
};
var $61b44b31e2da1312$export$2e2bcd8739ae039 = $61b44b31e2da1312$var$Exported;

});
parcelRegister("lee4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b73d97a5b5ddede$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $8cCud = parcelRequire("8cCud");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $1b73d97a5b5ddede$var$PreviewBlock = ({ status: // eslint-disable-next-line @typescript-eslint/no-unused-vars
status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8cCud.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $1b73d97a5b5ddede$export$2e2bcd8739ae039 = $1b73d97a5b5ddede$var$PreviewBlock;

});
parcelRegister("8cCud", function(module, exports) {

$parcel$export(module.exports, "default", () => $85cff883015122f8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $kDhrr = parcelRequire("kDhrr");

var $dghu0 = parcelRequire("dghu0");
function $85cff883015122f8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Due to its placement on the left/right and ignoreContainerPadding prop
 * rely on its parent container styling, css variables are declared in
 * <Container /> to preset the base values for the preview block styling.
 *
 * `--container-padding` is the padding of the Container. This value is based
 *   on size and hidePadding.
 * `--container-gap-left` and `--container-gap-right` are the gap or padding of
 *   the Container depending on whether the container has other preview blocks
 *   with left/right positioning.
 * `--preview-block-width` is the size of the preview image in relation to
 *   the Container width when the placement is left/right.
 * @param placement
 * @param ignoreContainerPadding
 */ var $85cff883015122f8$var$_ref = {
    name: "ooh6hm",
    styles: "margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1);&:first-of-type{margin-top:calc(var(--container-padding) * -1);}&:last-of-type{margin-bottom:calc(var(--container-padding) * -1);}"
};
const $85cff883015122f8$var$getPreviewBlockStyles = (placement, ignoreContainerPadding)=>{
    if (placement === (0, $8dVIb.MediaPlacement).Left || placement === (0, $8dVIb.MediaPlacement).Right) {
        const containerPadding = ignoreContainerPadding ? '0rem' : 'var(--container-padding)';
        // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $f8Sb3.css)("position:absolute;top:", containerPadding, ";bottom:", containerPadding, ";width:calc(var(--preview-block-width) - ", containerPadding, ");", placement === (0, $8dVIb.MediaPlacement).Left ? `left: ${containerPadding};` : '', " ", placement === (0, $8dVIb.MediaPlacement).Right ? `right: ${containerPadding};` : '', " [data-smart-element-media='image']{aspect-ratio:unset;padding-top:unset;width:100%;height:100%;object-fit:cover;}");
    }
    if (ignoreContainerPadding) return $85cff883015122f8$var$_ref;
};
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $85cff883015122f8$var$PreviewBlockResolvedViewOld = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, overrideCss: overrideCss, placement: placement, testId: testId, overrideUrl: overrideUrl, ...blockProps })=>{
    const [styles, setStyles] = (0, $5uXOq.useState)(overrideCss);
    const updateStyles = (0, $5uXOq.useCallback)(()=>{
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        setStyles(/*#__PURE__*/ (0, $f8Sb3.css)($85cff883015122f8$var$getPreviewBlockStyles(placement, ignoreContainerPadding), overrideCss));
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement,
        updateStyles
    ]);
    const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $5uXOq.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dghu0.default), {
        ...blockProps,
        overrideCss: styles,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kDhrr.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $85cff883015122f8$export$2e2bcd8739ae039 = $85cff883015122f8$var$PreviewBlockResolvedViewOld;

});


parcelRegister("cElbi", function(module, exports) {

$parcel$export(module.exports, "default", () => $64981f7edc74268b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $kDhrr = parcelRequire("kDhrr");

var $dghu0 = parcelRequire("dghu0");

var $8cCud = parcelRequire("8cCud");
const $64981f7edc74268b$var$previewBlockStyleCommon = null;
const $64981f7edc74268b$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $64981f7edc74268b$var$PreviewBlockResolvedViewNew = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    // const [styles, setStyles] = useState<SerializedStyles | undefined>(overrideCss);
    const [dynamicStyles, setDynamicStyles] = (0, $5uXOq.useState)(style ?? {});
    const updateStyles = (0, $5uXOq.useCallback)(()=>{
        if (placement === (0, $8dVIb.MediaPlacement).Left || placement === (0, $8dVIb.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0rem' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $8dVIb.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $8dVIb.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $5uXOq.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $kDhrr.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
const $64981f7edc74268b$var$PreviewBlockResolvedView = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($64981f7edc74268b$var$PreviewBlockResolvedViewNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $8cCud.default), props);
};
var $64981f7edc74268b$export$2e2bcd8739ae039 = $64981f7edc74268b$var$PreviewBlockResolvedView;

});


parcelRegister("1JaZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c880264dd5ccb40b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $kp8aU = parcelRequire("kp8aU");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
const $c880264dd5ccb40b$var$DEFAULT_MAX_LINES = 3;
const $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES = 6;
const $c880264dd5ccb40b$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $c880264dd5ccb40b$var$SnippetBlock = ({ maxLines: maxLines = $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $fpDmE.getMaxLines)(maxLines, $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES, $c880264dd5ccb40b$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kp8aU.default), {
        maxLines: snippetMaxLines,
        content: text
    }));
};
var $c880264dd5ccb40b$export$2e2bcd8739ae039 = $c880264dd5ccb40b$var$SnippetBlock;

});

parcelRegister("buvhv", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b66054384f48ec$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $fkxMX = parcelRequire("fkxMX");

var $bXy5i = parcelRequire("bXy5i");

var $jHa2h = parcelRequire("jHa2h");

var $lVptR = parcelRequire("lVptR");
const $93b66054384f48ec$var$actionStyles = null;
const $93b66054384f48ec$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Pending:
        case (0, $8dVIb.SmartLinkStatus).Resolving:
            return 0, $jHa2h.default;
        case (0, $8dVIb.SmartLinkStatus).Resolved:
            return 0, $bXy5i.default;
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).NotFound:
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return 0, $fkxMX.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $93b66054384f48ec$var$TitleBlockNew = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, ...props })=>{
    if (hideRetry && props.retry) delete props.retry;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ $5uXOq.createElement((0, $bubxq.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const title = /*#__PURE__*/ $5uXOq.createElement((0, $eqoQu.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $93b66054384f48ec$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ $5uXOq.createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        icon: icon,
        size: props.size,
        theme: theme
    });
};
const $93b66054384f48ec$var$TitleBlock = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($93b66054384f48ec$var$TitleBlockNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $lVptR.default), props);
};
var $93b66054384f48ec$export$2e2bcd8739ae039 = $93b66054384f48ec$var$TitleBlock;

});
parcelRegister("fkxMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbea6814ca213c7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $4itqr = parcelRequire("4itqr");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $dcbea6814ca213c7$var$TitleBlockErroredViewNew = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const hasAction = onClick !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eqoQu.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), title, descriptor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BfaB.default), {
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
        align: (0, $8dVIb.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onClick: onClick,
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...descriptor,
        values: values
    }))), actionGroup);
};
const $dcbea6814ca213c7$var$TitleBlockErroredView = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dcbea6814ca213c7$var$TitleBlockErroredViewNew, props);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4itqr.default), props);
};
var $dcbea6814ca213c7$export$2e2bcd8739ae039 = $dcbea6814ca213c7$var$TitleBlockErroredView;

});
parcelRegister("4itqr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd5bf7c2b7a739e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $dC5iT = parcelRequire("dC5iT");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");
function $ccd5bf7c2b7a739e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ccd5bf7c2b7a739e$var$actionStyles = {
    name: "r982j0",
    styles: "cursor:pointer;:hover{color:var(--ds-text-subtle, #8993A4);text-decoration:underline;}"
};
const $ccd5bf7c2b7a739e$var$actionHoverStyles = {
    name: "y4wzay",
    styles: "position:relative;z-index:1;&:focus{outline-offset:var(--ds-space-negative-025, -2px);}"
};
/**
 * This function does not work in the component below as it needs to be xcss.
 * The component instead uses inherited styles
 */ const $ccd5bf7c2b7a739e$var$getMessageStyles = (size, hasAction)=>{
    const sizeStyles = (0, $fpDmE.getLinkSizeStyles)(size);
    return /*#__PURE__*/ (0, $f8Sb3.css)("flex:1 1 auto;justify-content:flex-end;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasAction ? $ccd5bf7c2b7a739e$var$actionStyles : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    sizeStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $fpDmE.getTruncateStyles)(1, (0, $fpDmE.getLinkLineHeight)(size)), {
        color: "var(--ds-text-disabled, #6B778C)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: `${"var(--ds-border-focused, #388BFF)"} solid 2px`
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasAction ? $ccd5bf7c2b7a739e$var$actionHoverStyles : '');
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $ccd5bf7c2b7a739e$var$TitleBlockErroredViewOld = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const hasAction = onClick !== undefined;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eqoQu.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), title, descriptor && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1BfaB.default), {
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
        align: (0, $8dVIb.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dC5iT.default), {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: $ccd5bf7c2b7a739e$var$getMessageStyles(size, hasAction),
        onClick: onClick,
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : -1
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        ...descriptor,
        values: values
    }))), actionGroup);
};
var $ccd5bf7c2b7a739e$export$2e2bcd8739ae039 = $ccd5bf7c2b7a739e$var$TitleBlockErroredViewOld;

});


parcelRegister("bXy5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2967317da51f9f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");

var $jSZrF = parcelRequire("jSZrF");
const $e2967317da51f9f7$var$style = null;
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $e2967317da51f9f7$var$TitleBlockResolvedViewNew = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $akF1x.renderElementItems)(metadata);
    const subtitleElements = (0, $akF1x.renderElementItems)(subtitle);
    return /*#__PURE__*/ $5uXOq.createElement((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ $5uXOq.createElement((0, $eqoQu.LinkIcon), {
        overrideIcon: icon,
        position: position,
        ...(0, $VSDnB.fg)('platform-smart-card-icon-migration') && {
            size: size
        }
    }), /*#__PURE__*/ $5uXOq.createElement((0, $1BfaB.default), {
        direction: (0, $8dVIb.SmartLinkDirection).Vertical,
        width: (0, $8dVIb.SmartLinkWidth).Flexible,
        size: blockProps.size,
        className: (0, $bwpsq.default)([
            "_zulppdf9"
        ])
    }, title, subtitleElements && /*#__PURE__*/ $5uXOq.createElement((0, $1BfaB.default), {
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ $5uXOq.createElement((0, $1BfaB.default), {
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
        align: (0, $8dVIb.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $8dVIb.SmartLinkPosition).Center,
        size: blockProps.size
    }, metadataElements), actionGroup);
};
const $e2967317da51f9f7$var$TitleBlockResolvedView = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($e2967317da51f9f7$var$TitleBlockResolvedViewNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $jSZrF.default), props);
};
var $e2967317da51f9f7$export$2e2bcd8739ae039 = $e2967317da51f9f7$var$TitleBlockResolvedView;

});
parcelRegister("jSZrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35b34f2fc5f736$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $1BfaB = parcelRequire("1BfaB");

var $akF1x = parcelRequire("akF1x");
function $db35b34f2fc5f736$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ var $db35b34f2fc5f736$var$_ref = {
    name: "v43pxc",
    styles: "gap:var(--ds-space-050, 0.25rem)"
};
const $db35b34f2fc5f736$var$TitleBlockResolvedViewOld = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const metadataElements = (0, $akF1x.renderElementItems)(metadata);
    const subtitleElements = (0, $akF1x.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eqoQu.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BfaB.default), {
        direction: (0, $8dVIb.SmartLinkDirection).Vertical,
        width: (0, $8dVIb.SmartLinkWidth).Flexible,
        overrideCss: $db35b34f2fc5f736$var$_ref
    }, title, subtitleElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BfaB.default), {
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BfaB.default), {
        direction: (0, $8dVIb.SmartLinkDirection).Horizontal,
        align: (0, $8dVIb.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $8dVIb.SmartLinkPosition).Center
    }, metadataElements), actionGroup);
};
var $db35b34f2fc5f736$export$2e2bcd8739ae039 = $db35b34f2fc5f736$var$TitleBlockResolvedViewOld;

});


parcelRegister("jHa2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $045d1b1e49cae759$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $gU02S = parcelRequire("gU02S");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");

var $iZ5Ns = parcelRequire("iZ5Ns");
const $045d1b1e49cae759$var$iconStyle = {
    xlarge: "_16jlidpf _1o9zidpf _i0dl1wug _4t3iviql _1tkeviql _c71lviql _1bsbviql _1ul9viql _p12fviql _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7viql _1xjxviql _1752viql _qci8viql _15izviql _erubviql _19l3viql _1pr2viql _1u5tviql _mezjviql _e2ooviql _w8l5viql _1rg2viql _q7cvviql _xwbjviql _rtysviql _b8nkviql _4x20viql",
    large: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    medium: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    small: "_16jlidpf _1o9zidpf _i0dl1wug _4t3ioqnp _1tkeoqnp _c71loqnp _1bsboqnp _1ul9oqnp _p12foqnp _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7oqnp _1xjxoqnp _1752oqnp _qci8oqnp _15izoqnp _eruboqnp _19l3oqnp _1pr2oqnp _1u5toqnp _mezjoqnp _e2oooqnp _w8l5oqnp _1rg2oqnp _q7cvoqnp _xwbjoqnp _rtysoqnp _b8nkoqnp _4x20oqnp"
};
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $045d1b1e49cae759$var$TitleBlockResolvingViewNew = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    if ((0, $VSDnB.fg)('platform-smart-card-icon-migration')) {
        const iconWidth = (0, $fpDmE.getIconWidthNew)(size);
        return /*#__PURE__*/ $5uXOq.createElement((0, $dghu0.default), {
            ...blockProps,
            testId: `${testId}-resolving-view`
        }, !hideIcon && /*#__PURE__*/ $5uXOq.createElement("span", {
            style: {
                width: iconWidth,
                height: iconWidth
            },
            "data-testid": `${testId}-icon`
        }, /*#__PURE__*/ $5uXOq.createElement((0, $gU02S.LoadingSkeletonNew), {
            width: iconWidth,
            height: iconWidth,
            testId: `${testId}-icon-loading`
        })), title, actionGroup);
    }
    return /*#__PURE__*/ $5uXOq.createElement((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && /*#__PURE__*/ $5uXOq.createElement("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            $045d1b1e49cae759$var$iconStyle[size]
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $gU02S.LoadingSkeletonOld), {
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
const $045d1b1e49cae759$var$TitleBlockResolvingView = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($045d1b1e49cae759$var$TitleBlockResolvingViewNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $iZ5Ns.default), props);
};
var $045d1b1e49cae759$export$2e2bcd8739ae039 = $045d1b1e49cae759$var$TitleBlockResolvingView;

});
parcelRegister("iZ5Ns", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6684130218aacb9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $gU02S = parcelRequire("gU02S");

var $fpDmE = parcelRequire("fpDmE");

var $dghu0 = parcelRequire("dghu0");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $a6684130218aacb9$var$TitleBlockResolvingViewOld = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $8dVIb.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $fpDmE.getIconWidth)(size);
    const iconStyles = (0, $fpDmE.getIconSizeStyles)(iconWidth);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dghu0.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: iconStyles,
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gU02S.LoadingSkeletonOld), {
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $a6684130218aacb9$export$2e2bcd8739ae039 = $a6684130218aacb9$var$TitleBlockResolvingViewOld;

});


parcelRegister("lVptR", function(module, exports) {

$parcel$export(module.exports, "default", () => $653ae9094f090b52$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8dVIb = parcelRequire("8dVIb");

var $4URMI = parcelRequire("4URMI");

var $eqoQu = parcelRequire("eqoQu");

var $bubxq = parcelRequire("bubxq");

var $fkxMX = parcelRequire("fkxMX");

var $bXy5i = parcelRequire("bXy5i");

var $jHa2h = parcelRequire("jHa2h");
function $653ae9094f090b52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $653ae9094f090b52$var$_ref = {
    name: "11eaz",
    styles: ".actions-button-group{opacity:0;}&:hover .actions-button-group, .actions-button-group:focus-within{opacity:1;}"
};
const $653ae9094f090b52$var$getActionStyles = (showOnHover, isOpen)=>{
    if (showOnHover && !isOpen) return $653ae9094f090b52$var$_ref;
};
const $653ae9094f090b52$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $8dVIb.SmartLinkStatus).Pending:
        case (0, $8dVIb.SmartLinkStatus).Resolving:
            return 0, $jHa2h.default;
        case (0, $8dVIb.SmartLinkStatus).Resolved:
            return 0, $bXy5i.default;
        case (0, $8dVIb.SmartLinkStatus).Unauthorized:
        case (0, $8dVIb.SmartLinkStatus).Forbidden:
        case (0, $8dVIb.SmartLinkStatus).NotFound:
        case (0, $8dVIb.SmartLinkStatus).Errored:
        case (0, $8dVIb.SmartLinkStatus).Fallback:
        default:
            return 0, $fkxMX.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingView
 * @see TitleBlockResolvedView
 * @see TitleBlockErroredView
 */ const $653ae9094f090b52$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, overrideCss: overrideCss, status: status = (0, $8dVIb.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, ...props })=>{
    if (hideRetry && props.retry) delete props.retry;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bubxq.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const actionStyles = $653ae9094f090b52$var$getActionStyles(showActionOnHover, actionDropdownOpen);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const combinedCss = /*#__PURE__*/ (0, $f8Sb3.css)(actionStyles, overrideCss);
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4URMI.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eqoQu.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $653ae9094f090b52$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        overrideCss: combinedCss,
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        icon: icon
    });
};
var $653ae9094f090b52$export$2e2bcd8739ae039 = $653ae9094f090b52$var$TitleBlock;

});


parcelRegister("1qDIM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dff75b4d7cc06d3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $4tgi5 = parcelRequire("4tgi5");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $5dff75b4d7cc06d3$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tgi5.default), {
        ...props,
        testId: testId,
        url: actionData.url
    });
};
var $5dff75b4d7cc06d3$export$2e2bcd8739ae039 = $5dff75b4d7cc06d3$var$AISummaryBlock;

});
parcelRegister("4tgi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $413bb2fab5c71807$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $8dVIb = parcelRequire("8dVIb");

var $1MeuC = parcelRequire("1MeuC");

var $bHeMs = parcelRequire("bHeMs");

var $aBTst = parcelRequire("aBTst");

var $dghu0 = parcelRequire("dghu0");

var $adeuB = parcelRequire("adeuB");

var $1n0HW = parcelRequire("1n0HW");
const $413bb2fab5c71807$var$styles = null;
const $413bb2fab5c71807$var$AISummaryBlockResolvedViewNew = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default), (0, $bHeMs.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $1MeuC.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ $5uXOq.createElement((0, $5uXOq.Fragment), null, placeholder);
    return /*#__PURE__*/ $5uXOq.createElement((0, $dghu0.default), {
        ...props,
        direction: (0, $8dVIb.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl"
        ])
    }, status === 'done' && /*#__PURE__*/ $5uXOq.createElement((0, $adeuB.default), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ $5uXOq.createElement((0, $aBTst.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ $5uXOq.createElement((0, $bHeMs.default), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    })));
};
const $413bb2fab5c71807$var$AISummaryBlockResolvedView = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($413bb2fab5c71807$var$AISummaryBlockResolvedViewNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $1n0HW.default), props);
};
var $413bb2fab5c71807$export$2e2bcd8739ae039 = $413bb2fab5c71807$var$AISummaryBlockResolvedView;

});
parcelRegister("bHeMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea67ef8b17402f34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $flpap = parcelRequire("flpap");

var $aRS1S = parcelRequire("aRS1S");
function $ea67ef8b17402f34$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ea67ef8b17402f34$var$AISummaryCSSStyles = {
    name: "gujpb9",
    styles: "font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);word-wrap:break-word;word-break:break-word;white-space:normal;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text"
};
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $ea67ef8b17402f34$var$AISummary = ({ content: content = '', overrideCss: overrideCss, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $flpap.default), {
        "data-testid": testId,
        css: [
            $ea67ef8b17402f34$var$AISummaryCSSStyles,
            overrideCss
        ],
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $aRS1S.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $ea67ef8b17402f34$export$2e2bcd8739ae039 = $ea67ef8b17402f34$var$AISummary;

});
parcelRegister("flpap", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2bc56c6c0b4e02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b2bc56c6c0b4e02e$var$t() {
    return $b2bc56c6c0b4e02e$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $b2bc56c6c0b4e02e$var$t.apply(this, arguments);
}
const $b2bc56c6c0b4e02e$var$n = [
    "children",
    "options"
], $b2bc56c6c0b4e02e$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $b2bc56c6c0b4e02e$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($b2bc56c6c0b4e02e$var$i || ($b2bc56c6c0b4e02e$var$i = {}));
const $b2bc56c6c0b4e02e$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $b2bc56c6c0b4e02e$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $b2bc56c6c0b4e02e$var$o = [
    "style",
    "script"
], $b2bc56c6c0b4e02e$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b2bc56c6c0b4e02e$var$s = /mailto:/i, $b2bc56c6c0b4e02e$var$d = /\n{2,}$/, $b2bc56c6c0b4e02e$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $b2bc56c6c0b4e02e$var$u = /^ *> ?/gm, $b2bc56c6c0b4e02e$var$f = /^ {2,}\n/, $b2bc56c6c0b4e02e$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $b2bc56c6c0b4e02e$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b2bc56c6c0b4e02e$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $b2bc56c6c0b4e02e$var$k = /^(?:\n *)*\n/, $b2bc56c6c0b4e02e$var$x = /\r\n?/g, $b2bc56c6c0b4e02e$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $b2bc56c6c0b4e02e$var$v = /^\[\^([^\]]+)]/, $b2bc56c6c0b4e02e$var$S = /\f/g, $b2bc56c6c0b4e02e$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b2bc56c6c0b4e02e$var$C = /^\s*?\[(x|\s)\]/, $b2bc56c6c0b4e02e$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $b2bc56c6c0b4e02e$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b2bc56c6c0b4e02e$var$T = /^<!--[\s\S]*?(?:-->)/, $b2bc56c6c0b4e02e$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b2bc56c6c0b4e02e$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b2bc56c6c0b4e02e$var$M = /^\{.*\}$/, $b2bc56c6c0b4e02e$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b2bc56c6c0b4e02e$var$I = /^<([^ >]+@[^ >]+)>/, $b2bc56c6c0b4e02e$var$U = /^<([^ >]+:\/[^ >]+)>/, $b2bc56c6c0b4e02e$var$D = /-([a-z])?/gi, $b2bc56c6c0b4e02e$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $b2bc56c6c0b4e02e$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b2bc56c6c0b4e02e$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b2bc56c6c0b4e02e$var$_ = /\t/g, $b2bc56c6c0b4e02e$var$G = /(^ *\||\| *$)/g, $b2bc56c6c0b4e02e$var$W = /^ *:-+: *$/, $b2bc56c6c0b4e02e$var$Z = /^ *:-+ *$/, $b2bc56c6c0b4e02e$var$q = /^ *-+: *$/, $b2bc56c6c0b4e02e$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $b2bc56c6c0b4e02e$var$V = new RegExp(`^([*_])\\1${$b2bc56c6c0b4e02e$var$Q}\\1\\1(?!\\1)`), $b2bc56c6c0b4e02e$var$X = new RegExp(`^([*_])${$b2bc56c6c0b4e02e$var$Q}\\1(?!\\1|\\w)`), $b2bc56c6c0b4e02e$var$J = new RegExp(`^==${$b2bc56c6c0b4e02e$var$Q}==`), $b2bc56c6c0b4e02e$var$K = new RegExp(`^~~${$b2bc56c6c0b4e02e$var$Q}~~`), $b2bc56c6c0b4e02e$var$Y = /^\\([^0-9A-Za-z\s])/, $b2bc56c6c0b4e02e$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $b2bc56c6c0b4e02e$var$te = /^\n+/, $b2bc56c6c0b4e02e$var$ne = /^([ \t]*)/, $b2bc56c6c0b4e02e$var$re = /\\([^\\])/g, $b2bc56c6c0b4e02e$var$ie = / *\n+$/, $b2bc56c6c0b4e02e$var$le = /(?:^|\n)( *)$/, $b2bc56c6c0b4e02e$var$ae = "(?:\\d+\\.)", $b2bc56c6c0b4e02e$var$oe = "(?:[*+-])";
function $b2bc56c6c0b4e02e$var$ce(e) {
    return "( *)(" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + ") +";
}
const $b2bc56c6c0b4e02e$var$se = $b2bc56c6c0b4e02e$var$ce(1), $b2bc56c6c0b4e02e$var$de = $b2bc56c6c0b4e02e$var$ce(2);
function $b2bc56c6c0b4e02e$var$pe(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de));
}
const $b2bc56c6c0b4e02e$var$ue = $b2bc56c6c0b4e02e$var$pe(1), $b2bc56c6c0b4e02e$var$fe = $b2bc56c6c0b4e02e$var$pe(2);
function $b2bc56c6c0b4e02e$var$he(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $b2bc56c6c0b4e02e$var$me = $b2bc56c6c0b4e02e$var$he(1), $b2bc56c6c0b4e02e$var$ge = $b2bc56c6c0b4e02e$var$he(2);
function $b2bc56c6c0b4e02e$var$ye(e) {
    const t = 1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $b2bc56c6c0b4e02e$var$ke = $b2bc56c6c0b4e02e$var$ye(1), $b2bc56c6c0b4e02e$var$xe = $b2bc56c6c0b4e02e$var$ye(2);
function $b2bc56c6c0b4e02e$var$be(e, t) {
    const n = 1 === t, i = n ? $b2bc56c6c0b4e02e$var$ke : $b2bc56c6c0b4e02e$var$xe, l = n ? $b2bc56c6c0b4e02e$var$me : $b2bc56c6c0b4e02e$var$ge, a = n ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$fe;
    return {
        match (e, t) {
            const n = $b2bc56c6c0b4e02e$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($b2bc56c6c0b4e02e$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($b2bc56c6c0b4e02e$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($b2bc56c6c0b4e02e$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $b2bc56c6c0b4e02e$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $b2bc56c6c0b4e02e$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$Ee = [
    $b2bc56c6c0b4e02e$var$p,
    $b2bc56c6c0b4e02e$var$m,
    $b2bc56c6c0b4e02e$var$g,
    $b2bc56c6c0b4e02e$var$$,
    $b2bc56c6c0b4e02e$var$z,
    $b2bc56c6c0b4e02e$var$w,
    $b2bc56c6c0b4e02e$var$T,
    $b2bc56c6c0b4e02e$var$j,
    $b2bc56c6c0b4e02e$var$me,
    $b2bc56c6c0b4e02e$var$ke,
    $b2bc56c6c0b4e02e$var$ge,
    $b2bc56c6c0b4e02e$var$xe
], $b2bc56c6c0b4e02e$var$Ce = [
    ...$b2bc56c6c0b4e02e$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $b2bc56c6c0b4e02e$var$L,
    $b2bc56c6c0b4e02e$var$B
];
function $b2bc56c6c0b4e02e$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $b2bc56c6c0b4e02e$var$we(e) {
    return $b2bc56c6c0b4e02e$var$q.test(e) ? "right" : $b2bc56c6c0b4e02e$var$W.test(e) ? "center" : $b2bc56c6c0b4e02e$var$Z.test(e) ? "left" : null;
}
function $b2bc56c6c0b4e02e$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $b2bc56c6c0b4e02e$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($b2bc56c6c0b4e02e$var$G, "").split("|").map($b2bc56c6c0b4e02e$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $b2bc56c6c0b4e02e$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $b2bc56c6c0b4e02e$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph
    };
}
function $b2bc56c6c0b4e02e$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $b2bc56c6c0b4e02e$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$b2bc56c6c0b4e02e$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $b2bc56c6c0b4e02e$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $b2bc56c6c0b4e02e$var$Ue(e) {
    return e.replace($b2bc56c6c0b4e02e$var$re, "$1");
}
function $b2bc56c6c0b4e02e$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $b2bc56c6c0b4e02e$var$He = (e, t, n)=>({
        children: $b2bc56c6c0b4e02e$var$De(t, e[1], n)
    });
function $b2bc56c6c0b4e02e$var$Fe() {
    return {};
}
function $b2bc56c6c0b4e02e$var$Pe() {
    return null;
}
function $b2bc56c6c0b4e02e$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $b2bc56c6c0b4e02e$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $b2bc56c6c0b4e02e$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $b2bc56c6c0b4e02e$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $b2bc56c6c0b4e02e$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $b2bc56c6c0b4e02e$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $b2bc56c6c0b4e02e$var$t({}, n, l, {
            className: $b2bc56c6c0b4e02e$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($b2bc56c6c0b4e02e$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $b2bc56c6c0b4e02e$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($b2bc56c6c0b4e02e$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $5uXOq.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($b2bc56c6c0b4e02e$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($b2bc56c6c0b4e02e$var$O) && (e = e.replace($b2bc56c6c0b4e02e$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $b2bc56c6c0b4e02e$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($b2bc56c6c0b4e02e$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($b2bc56c6c0b4e02e$var$L.test(p) || $b2bc56c6c0b4e02e$var$B.test(p)) && (n[d] = $5uXOq.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$b2bc56c6c0b4e02e$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $b2bc56c6c0b4e02e$export$3e2338ea76b578c9, i.slugify = i.slugify || $b2bc56c6c0b4e02e$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $b2bc56c6c0b4e02e$var$t({}, $b2bc56c6c0b4e02e$var$a, i.namedCodesToUnicode) : $b2bc56c6c0b4e02e$var$a, i.createElement = i.createElement || $5uXOq.createElement;
    const Z = [], q = {}, Q = {
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.blockQuote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($b2bc56c6c0b4e02e$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakLine]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$f),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakThematic]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$h),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeFenced]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeInline]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnoteReference]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $b2bc56c6c0b4e02e$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.gfmTask]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading]: {
            match: $b2bc56c6c0b4e02e$var$Be(i.enforceAtxHeadings ? $b2bc56c6c0b4e02e$var$w : $b2bc56c6c0b4e02e$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[2], n),
                    id: i.slugify(e[2], $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.headingSetext]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($b2bc56c6c0b4e02e$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $b2bc56c6c0b4e02e$var$Ce.some((e)=>e.test(c)) ? $b2bc56c6c0b4e02e$var$Ne : $b2bc56c6c0b4e02e$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $b2bc56c6c0b4e02e$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlComment]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$T),
            order: 1,
            parse: ()=>({}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.image]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$je(t, e[1], n),
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $b2bc56c6c0b4e02e$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                };
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList]: $b2bc56c6c0b4e02e$var$be(d, 1),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.unorderedList]: $b2bc56c6c0b4e02e$var$be(d, 2),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$k),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: ()=>"\n"
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph]: {
            match: $b2bc56c6c0b4e02e$var$Re,
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.ref]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refImage]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refLink]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$j),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($b2bc56c6c0b4e02e$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textBolded]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEmphasized]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEscaped]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textMarked]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$J),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$K),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock], delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($b2bc56c6c0b4e02e$var$x, "\n").replace($b2bc56c6c0b4e02e$var$S, "").replace($b2bc56c6c0b4e02e$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $b2bc56c6c0b4e02e$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $b2bc56c6c0b4e02e$var$n);
    return $5uXOq.cloneElement($b2bc56c6c0b4e02e$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("aRS1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $270fc2c4bbd80c91$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $270fc2c4bbd80c91$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $270fc2c4bbd80c91$var$listStyles = {
    name: "k4jzwf",
    styles: "padding-left:var(--ds-space-250, 20px);padding-inline-start:var(--ds-space-250, 20px)"
};
const $270fc2c4bbd80c91$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("ul", {
        css: $270fc2c4bbd80c91$var$listStyles,
        ...props
    }, children);
var $270fc2c4bbd80c91$export$2e2bcd8739ae039 = $270fc2c4bbd80c91$var$UList;

});


parcelRegister("aBTst", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8d8f80d50d9d1e4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
const $a8d8f80d50d9d1e4$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $5uXOq.useState)(0);
    const ref = (0, $5uXOq.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $5uXOq.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};
var $a8d8f80d50d9d1e4$export$2e2bcd8739ae039 = $a8d8f80d50d9d1e4$export$6118ed0013927eb2;

});

parcelRegister("adeuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $749bb6d43c83bff0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $a1vqi = parcelRequire("a1vqi");
const $749bb6d43c83bff0$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $a1vqi.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $749bb6d43c83bff0$export$2e2bcd8739ae039 = $749bb6d43c83bff0$var$AIEventSummaryViewed;

});

parcelRegister("1n0HW", function(module, exports) {

$parcel$export(module.exports, "default", () => $612fabb86adb8229$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gKZoD = parcelRequire("gKZoD");

var $8dVIb = parcelRequire("8dVIb");

var $1MeuC = parcelRequire("1MeuC");

var $bHeMs = parcelRequire("bHeMs");

var $aBTst = parcelRequire("aBTst");

var $dghu0 = parcelRequire("dghu0");

var $adeuB = parcelRequire("adeuB");
const $612fabb86adb8229$var$AISummaryBlockResolvedViewOld = (props)=>{
    (0, $gKZoD.di)((0, $1MeuC.default), (0, $bHeMs.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $1MeuC.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dghu0.default), {
        ...props,
        direction: (0, $8dVIb.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ overrideCss: (0, $f8Sb3.css)("overflow:visible;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.overrideCss)
    }, status === 'done' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $adeuB.default), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aBTst.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bHeMs.default), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    })));
};
var $612fabb86adb8229$export$2e2bcd8739ae039 = $612fabb86adb8229$var$AISummaryBlockResolvedViewOld;

});



parcelRegister("85ffk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cb2203e6787402$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $obtkX = parcelRequire("obtkX");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $d5cb2203e6787402$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $8dVIb.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $obtkX.default), {
        ...props,
        testId: testId
    });
};
var $d5cb2203e6787402$export$2e2bcd8739ae039 = $d5cb2203e6787402$var$AIFooterBlock;

});
parcelRegister("obtkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6b56bbc6d143050$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $eqoQu = parcelRequire("eqoQu");

var $dghu0 = parcelRequire("dghu0");

var $kBKwT = parcelRequire("kBKwT");
const $f6b56bbc6d143050$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $8dVIb.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dghu0.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eqoQu.Provider), {
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kBKwT.AIFooterMetadata), {
        ...actionData,
        testId: `${testId}-ai-metadata`
    }) : null);
};
var $f6b56bbc6d143050$export$2e2bcd8739ae039 = $f6b56bbc6d143050$var$AIFooterBlockResolvedView;

});
parcelRegister("kBKwT", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $84dc366e320e5880$export$175228cc2c92b3b6);

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $jps85 = parcelRequire("jps85");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");

var $3bDjY = parcelRequire("3bDjY");

var $7zaVw = parcelRequire("7zaVw");

var $1MeuC = parcelRequire("1MeuC");

var $8z1HA = parcelRequire("8z1HA");

var $c8Sqt = parcelRequire("c8Sqt");
const $84dc366e320e5880$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gKZoD.di)((0, $1MeuC.default));
    const { state: { status: status } } = (0, $1MeuC.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $7zaVw.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8Sqt.InfoIcon), {
            label: "Information",
            LEGACY_size: "small",
            color: "var(--ds-icon-subtle, #626F86)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
        label: "AI",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, $8z1HA.default),
        color: "var(--ds-icon-subtle, #626F86)"
    }));
};

});
parcelRegister("c8Sqt", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $a035773c38c242b5$export$2957fc44b3d2481);

var $5uXOq = parcelRequire("5uXOq");

var $2Yv61 = parcelRequire("2Yv61");

var $lqBg9 = parcelRequire("lqBg9");
const $a035773c38c242b5$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $lqBg9.default),
        ...props
    });

});
parcelRegister("lqBg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f1ed3211c768fe6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $4f1ed3211c768fe6$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
        fill: "currentColor"
    }));
/**
 * __InfoIcon__
 */ const $4f1ed3211c768fe6$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $4f1ed3211c768fe6$var$InfoIconGlyph
    });
var $4f1ed3211c768fe6$export$2e2bcd8739ae039 = $4f1ed3211c768fe6$var$InfoIcon;

});





parcelRegister("fh9qw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b695424587865b74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $VSDnB = parcelRequire("VSDnB");

var $8CUq3 = parcelRequire("8CUq3");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $jRHKj = parcelRequire("jRHKj");

var $fpDmE = parcelRequire("fpDmE");

var $s2ak7 = parcelRequire("s2ak7");

var $6GeXu = parcelRequire("6GeXu");
const $b695424587865b74$var$ignoreContainerPaddingStyles = null;
const $b695424587865b74$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $b695424587865b74$var$sort = (a, b)=>{
    let idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $b695424587865b74$var$ActionBlockNew = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, testId: testId = 'smart-block-action' })=>{
    (0, $gKZoD.di)((0, $s2ak7.ActionFooter));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? (0, $fpDmE.getPrimitivesPaddingSpaceBySize)(ui?.size || (0, $8dVIb.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $5uXOq.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($b695424587865b74$var$sort);
        return arr.map((name)=>{
            const Action = name in $jRHKj ? $jRHKj[name] : undefined;
            return Action ? /*#__PURE__*/ $5uXOq.createElement(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                xcss: (0, $8CUq3.xcss)({
                    paddingInline: padding
                }),
                hideTooltip: isLoading
            }) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: blockRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb1osq _18u01ivi _2hwxc10g"
        ])
    }, actions, /*#__PURE__*/ $5uXOq.createElement((0, $s2ak7.ActionFooter), {
        message: message,
        paddingInline: padding,
        testId: testId
    })) : null;
};
const $b695424587865b74$var$ActionBlock = (props)=>{
    if ((0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard')) return /*#__PURE__*/ $5uXOq.createElement($b695424587865b74$var$ActionBlockNew, props);
    else return /*#__PURE__*/ $5uXOq.createElement((0, $6GeXu.default), props);
};
var $b695424587865b74$export$2e2bcd8739ae039 = $b695424587865b74$var$ActionBlock;

});
parcelRegister("s2ak7", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $e384e6334b5a98a7$export$2d2b754ac238f9aa);

var $5uXOq = parcelRequire("5uXOq");

var $059q9 = parcelRequire("059q9");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $aBTst = parcelRequire("aBTst");
const $e384e6334b5a98a7$var$containerStyles = (0, $8CUq3.xcss)({
    all: 'unset',
    borderRadius: 'border.radius',
    margin: 'space.100',
    marginBottom: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    padding: 'space.075',
    paddingInline: 'space.100',
    width: '100%',
    ':empty': {
        display: 'none'
    }
});
const $e384e6334b5a98a7$var$errorStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.danger'
});
const $e384e6334b5a98a7$var$errorContentStyles = (0, $8CUq3.xcss)({
    paddingInlineStart: 'space.025'
});
const $e384e6334b5a98a7$var$titleStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $e384e6334b5a98a7$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
            });
        default:
            return null;
    }
};
const $e384e6334b5a98a7$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: `${testId}-footer`,
        xcss: [
            $e384e6334b5a98a7$var$containerStyles,
            message.appearance === 'error' && $e384e6334b5a98a7$var$errorStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aBTst.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "start",
        grow: "fill",
        space: "space.075",
        xcss: $e384e6334b5a98a7$var$errorContentStyles
    }, message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e384e6334b5a98a7$var$titleStyles
    }, message.title))));
};

});

parcelRegister("6GeXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d655c3cc6a66bae1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gKZoD = parcelRequire("gKZoD");

var $8CUq3 = parcelRequire("8CUq3");

var $8dVIb = parcelRequire("8dVIb");

var $Nh1XU = parcelRequire("Nh1XU");

var $jRHKj = parcelRequire("jRHKj");

var $fpDmE = parcelRequire("fpDmE");

var $s2ak7 = parcelRequire("s2ak7");
function $d655c3cc6a66bae1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d655c3cc6a66bae1$var$ignoreContainerPaddingStyles = {
    name: "19m4cma",
    styles: "display:flex;flex-direction:column;box-sizing:border-box;flex-grow:1;width:100%;margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1)"
};
const $d655c3cc6a66bae1$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $d655c3cc6a66bae1$var$sort = (a, b)=>{
    let idxA = $d655c3cc6a66bae1$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $d655c3cc6a66bae1$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $d655c3cc6a66bae1$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $d655c3cc6a66bae1$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $d655c3cc6a66bae1$var$ActionBlockOld = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, testId: testId = 'smart-block-action' })=>{
    (0, $gKZoD.di)((0, $s2ak7.ActionFooter));
    const context = (0, $Nh1XU.useFlexibleUiContext)();
    const ui = (0, $Nh1XU.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? (0, $fpDmE.getPrimitivesPaddingSpaceBySize)(ui?.size || (0, $8dVIb.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $5uXOq.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($d655c3cc6a66bae1$var$sort);
        return arr.map((name)=>{
            const Action = name in $jRHKj ? $jRHKj[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $f8Sb3.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                xcss: (0, $8CUq3.xcss)({
                    paddingInline: padding
                }),
                hideTooltip: isLoading
            }) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d655c3cc6a66bae1$var$ignoreContainerPaddingStyles,
        ref: blockRef,
        "data-testid": testId
    }, actions, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $s2ak7.ActionFooter), {
        message: message,
        paddingInline: padding,
        testId: testId
    })) : null;
};
var $d655c3cc6a66bae1$export$2e2bcd8739ae039 = $d655c3cc6a66bae1$var$ActionBlockOld;

});




parcelRegister("i41Ob", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $b4c0875f37c33ad9$export$1ca0544321134ad6);

var $5uXOq = parcelRequire("5uXOq");

var $bMldO = parcelRequire("bMldO");

const $b4c0875f37c33ad9$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMldO.CardLinkView), {
        key: 'lazy-render-key',
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $b18b5009ce608fe8$export$4b2b7d155f69aed4),
        placeholder: placeholder
    });
};

});
parcelRegister("bMldO", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $d0b446175f31475d$export$ce508304ed2dd145);

var $5uXOq = parcelRequire("5uXOq");

var $kkxZO = parcelRequire("kkxZO");
class $d0b446175f31475d$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkxZO.Frame), {
            withoutBackground: true,
            ...this.props
        }, this.props.placeholder || this.props.link);
    }
}

});
parcelRegister("kkxZO", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $2ed7f4f9fecd197d$export$b89a827e9254211a);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $4URMI = parcelRequire("4URMI");

var $8RHvB = parcelRequire("8RHvB");

var $7WNJh = parcelRequire("7WNJh");
const $2ed7f4f9fecd197d$export$b89a827e9254211a = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $4URMI.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = (0, $VSDnB.fg)('bandicoots-compiled-migration-smartcard') ? isAnchor ? (0, $8RHvB.WrapperAnchor) : (0, $8RHvB.WrapperSpan) : isAnchor ? (0, $7WNJh.WrapperAnchor) : (0, $7WNJh.WrapperSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        "aria-label": isAnchor ? link ?? 'Link' : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline
    }, children);
});

});
parcelRegister("8RHvB", function(module, exports) {

$parcel$export(module.exports, "WrapperSpan", () => $7f29852863f1f016$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $7f29852863f1f016$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $7f29852863f1f016$var$lineHeight = 22;
const $7f29852863f1f016$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ])
    }, props.children);
});
const $7f29852863f1f016$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ])
    }, props.children);
});
const $7f29852863f1f016$var$baseWrapperStyles = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $7f29852863f1f016$var$interactiveStyles = null;
const $7f29852863f1f016$var$hoveredStyles = null;
const $7f29852863f1f016$var$hoveredWithBackgroundStyles = null;
const $7f29852863f1f016$var$withoutBackgroundStyles = null;
const $7f29852863f1f016$var$withBackgroundStyles = null;
const $7f29852863f1f016$var$truncateStyles = null;
const $7f29852863f1f016$var$notSelectedStyle = null;
const $7f29852863f1f016$var$selectedStyles = null;

});

parcelRegister("7WNJh", function(module, exports) {

$parcel$export(module.exports, "WrapperAnchor", () => $65f1736df4b88c9b$export$6e4bde711df5c2ab);
$parcel$export(module.exports, "WrapperSpan", () => $65f1736df4b88c9b$export$8b5c95e985c4ec9a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $bWGt6 = parcelRequire("bWGt6");
const $65f1736df4b88c9b$var$lineHeight = 22;
const $65f1736df4b88c9b$var$selectedStyles = {
    cursor: 'pointer',
    boxShadow: `0 0 0 2px ${`var(--ds-border-selected, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
    outline: 'none',
    userSelect: 'none',
    '&, :hover, :focus, :active': {
        textDecoration: 'none'
    },
    '&:hover': {
        border: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`}`
    }
};
const $65f1736df4b88c9b$var$isInteractive = ({ isInteractive: isInteractive })=>{
    if (isInteractive) return {
        ':active': {
            backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`
        },
        ':focus': $65f1736df4b88c9b$var$selectedStyles
    };
    return undefined;
};
const $65f1736df4b88c9b$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $65f1736df4b88c9b$var$selectedStyles;
    else return {
        userSelect: 'text'
    };
};
const $65f1736df4b88c9b$var$hoveredStyles = {
    borderColor: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
};
const $65f1736df4b88c9b$var$activeHoveredFocusedStyles = (props)=>{
    if (props.withoutBackground) return undefined;
    return {
        textDecoration: 'none'
    };
};
const $65f1736df4b88c9b$var$hoveredWihBorderStyles = (props)=>({
        ...$65f1736df4b88c9b$var$hoveredStyles,
        ...$65f1736df4b88c9b$var$activeHoveredFocusedStyles(props)
    });
/*
  Inline smart cards should have the following layout:
  ------------------------------------
  | icon | title | action OR lozenge |
  ------------------------------------
  The aim is to ensure (1) all children are
  in line with each other, (2) are vertically
  centered.
*/ // NB: `padding` consistent with @mentions.
// NB: `display: inline` required for `box-decoration-break` to work.
// NB: `box-decoration-break` required for retaining properties (border-radius) on wrap.
const $65f1736df4b88c9b$var$baseWrapperStyles = (props)=>({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: `${$65f1736df4b88c9b$var$lineHeight}px`,
        padding: `${"var(--ds-space-025, 2px)"} 0px`,
        ...props.withoutBackground ? {
            paddingLeft: 0,
            marginLeft: "var(--ds-space-negative-025, -2px)"
        } : undefined,
        display: 'inline',
        boxDecorationBreak: 'clone',
        borderRadius: "var(--ds-border-radius-100, 4px)",
        color: `var(--ds-link, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`,
        ...props.withoutBackground ? undefined : {
            backgroundColor: "var(--ds-surface-raised, white)"
        },
        ...$65f1736df4b88c9b$var$isSelected(props),
        ...props.withoutBackground ? undefined : {
            border: `1px solid ${`var(--ds-border, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`}`
        },
        '&:hover': $65f1736df4b88c9b$var$hoveredStyles,
        '&, :hover, :focus, :active': $65f1736df4b88c9b$var$activeHoveredFocusedStyles(props),
        transition: '0.1s all ease-in-out',
        MozUserSelect: 'none',
        // -moz-user-select
        ...props.isHovered ? $65f1736df4b88c9b$var$hoveredWihBorderStyles(props) : undefined
    });
const $65f1736df4b88c9b$var$truncateStyles = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-all',
    // The height of a truncated card is 1px higher than that of a non-truncated card, so we subtract 1px from the line height.
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: `${$65f1736df4b88c9b$var$lineHeight - 1}px`,
    display: '-webkit-inline-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    // We need to remove the padding because display: -webkit-inline-box will cause any padding to be
    // added to the total height, causing truncated cards to have greater height than non-truncated cards which use display: inline.
    padding: 0,
    '@supports not (-webkit-line-clamp: 1)': {
        display: 'inline-block',
        maxHeight: `${$65f1736df4b88c9b$var$lineHeight}px`,
        // If the browser does not support webkit, we don't need to remove the padding
        padding: `${"var(--ds-space-025, 2px)"} 0px`
    }
};
const $65f1736df4b88c9b$var$isTruncated = ({ truncateInline: truncateInline })=>{
    if (truncateInline) return $65f1736df4b88c9b$var$truncateStyles;
    return undefined;
};
const $65f1736df4b88c9b$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $bWGt6.default)("a", {
    target: "ewuc7q31"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$65f1736df4b88c9b$var$baseWrapperStyles(props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$65f1736df4b88c9b$var$isInteractive(props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$65f1736df4b88c9b$var$isTruncated(props)
    }));
$65f1736df4b88c9b$export$6e4bde711df5c2ab.displayName = 'WrapperAnchor';
const $65f1736df4b88c9b$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ewuc7q30"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$65f1736df4b88c9b$var$baseWrapperStyles(props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$65f1736df4b88c9b$var$isTruncated(props)
    }));
$65f1736df4b88c9b$export$8b5c95e985c4ec9a.displayName = 'WrapperSpan';

});



const $b18b5009ce608fe8$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("5HNFf", function(module, exports) {

let $42777e3129bc7bce$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $42777e3129bc7bce$var$load("h2MrD"),
    $42777e3129bc7bce$var$load("bYT2S"),
    $42777e3129bc7bce$var$load("ij5kv")
]).then(()=>parcelRequire('6Of57'));

});



parcelRegister("dn5wJ", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $b402a0f22139e437$export$f40b7e0b762b928b);
var $b402a0f22139e437$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});

parcelRegister("8dO33", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $08b794feb02c83c1$export$497ecb0280204df4);

var $5uXOq = parcelRequire("5uXOq");

var $3f2cs = parcelRequire("3f2cs");

var $cCcdH = parcelRequire("cCcdH");

var $k9B19 = parcelRequire("k9B19");

var $8b7fu = parcelRequire("8b7fu");

var $051X7 = parcelRequire("051X7");

var $7cFR3 = parcelRequire("7cFR3");
function $08b794feb02c83c1$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $5uXOq.useContext)((0, $051X7.SmartCardContext));
    const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $5uXOq.useMemo)(()=>{
        return (0, $3f2cs.createStore)((0, $8b7fu.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>{
        const client = customClient || new (0, $7cFR3.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cCcdH.getUrl)(store, url);
            return cardState.details ? (0, $k9B19.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $051X7.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $08b794feb02c83c1$export$2e2bcd8739ae039 = $08b794feb02c83c1$export$497ecb0280204df4;

});
parcelRegister("k9B19", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $596309a7bcc79771$export$4b0d98b1b7f6d115);

var $TFljV = parcelRequire("TFljV");

var $7OmtM = parcelRequire("7OmtM");
const $596309a7bcc79771$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $TFljV.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $7OmtM.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $7OmtM.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("TFljV", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $f8cdc1e628cbc347$export$3e8ad908070b68b2);
const $f8cdc1e628cbc347$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});


parcelRegister("8b7fu", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $92a815d7e26b35c0$export$3c7c3113a97b6492);

var $2yPrN = parcelRequire("2yPrN");
var $fiKQs = parcelRequire("fiKQs");
const $92a815d7e26b35c0$var$isCardAction = (action)=>{
    return [
        (0, $2yPrN.ACTION_PENDING),
        (0, $2yPrN.ACTION_RESOLVING),
        (0, $2yPrN.ACTION_RESOLVED),
        (0, $2yPrN.ACTION_RELOADING),
        (0, $2yPrN.ACTION_ERROR),
        (0, $2yPrN.ACTION_ERROR_FALLBACK),
        (0, $2yPrN.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $92a815d7e26b35c0$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $fiKQs.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $92a815d7e26b35c0$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $2yPrN.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $2yPrN.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $2yPrN.ACTION_RESOLVED:
            return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $2yPrN.ACTION_RELOADING:
            return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $2yPrN.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $2yPrN.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $2yPrN.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $92a815d7e26b35c0$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$92a815d7e26b35c0$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $92a815d7e26b35c0$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});

parcelRegister("7cFR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d96ed473518bd99$export$2e2bcd8739ae039);

var $hhZW9 = parcelRequire("hhZW9");

var $hj8yn = parcelRequire("hj8yn");

var $hLXaJ = parcelRequire("hLXaJ");

var $kDZ6Z = parcelRequire("kDZ6Z");
var $itO4f = parcelRequire("itO4f");
var $fiKQs = parcelRequire("fiKQs");
var $dV0Jy = parcelRequire("dV0Jy");

var $4Bkrp = parcelRequire("4Bkrp");

var $iwKVT = parcelRequire("iwKVT");
const $8d96ed473518bd99$var$MAX_BATCH_SIZE = 50;
const $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE = 100;
const $8d96ed473518bd99$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE);
class $8d96ed473518bd99$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $4Bkrp.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $itO4f.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($hLXaJ)))({
            limit: 1,
            interval: $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $8d96ed473518bd99$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $8d96ed473518bd99$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $8d96ed473518bd99$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $4Bkrp.isSuccessfulResponse)(response) || (0, $fiKQs.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $4Bkrp.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $4Bkrp.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $4Bkrp.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $4Bkrp.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $dV0Jy.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $4Bkrp.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $dV0Jy.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $dV0Jy.NetworkError)) return new (0, $kDZ6Z.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $kDZ6Z.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $kDZ6Z.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $kDZ6Z.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $kDZ6Z.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $kDZ6Z.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("hj8yn", function(module, exports) {
// Packages

var $fGJx3 = parcelRequire("fGJx3");
function $c99ad890679d3578$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $fGJx3.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $c99ad890679d3578$var$retry;

});
parcelRegister("fGJx3", function(module, exports) {

module.exports = (parcelRequire("6Q6YB"));

});
parcelRegister("6Q6YB", function(module, exports) {

var $8vOLa = parcelRequire("8vOLa");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $8vOLa(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("8vOLa", function(module, exports) {
function $632897d2769f1314$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $632897d2769f1314$var$RetryOperation;
$632897d2769f1314$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$632897d2769f1314$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$632897d2769f1314$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$632897d2769f1314$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$632897d2769f1314$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$632897d2769f1314$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$632897d2769f1314$var$RetryOperation.prototype.start = $632897d2769f1314$var$RetryOperation.prototype.try;
$632897d2769f1314$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$632897d2769f1314$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$632897d2769f1314$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("hLXaJ", function(module, exports) {
'use strict';
class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;

});

parcelRegister("4Bkrp", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $1e00e4fd9b26eb0f$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52);
const $1e00e4fd9b26eb0f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});




parcelRegister("5IVkq", function(module, exports) {

$parcel$export(module.exports, "splitValuesOnSpace", () => $48aa7a748689865d$export$c1ff52d038bc06ee);
const $48aa7a748689865d$export$d6d3d836b995f04e = ({ isRequired: isRequired })=>({
        MIN: isRequired ? 1 : 0,
        MAX: 255
    });
const $48aa7a748689865d$export$c1ff52d038bc06ee = (values)=>values.flatMap((val)=>val.split(/[\s]/g).filter((fragment)=>fragment !== '') ?? []);

});



parcelRegister("gQHjy", function(module, exports) {

$parcel$export(module.exports, "UserEditableAttribute", () => $5d1544565ffb4e26$export$3ba8466ee3465e06);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $j8mgt = parcelRequire("j8mgt");

var $klGkl = parcelRequire("klGkl");

var $emsEK = parcelRequire("emsEK");

var $581BZ = parcelRequire("581BZ");

var $6GHX9 = parcelRequire("6GHX9");

var $e08Fw = parcelRequire("e08Fw");
const $5d1544565ffb4e26$var$toFieldValue = (users)=>users.map(({ accountId: accountId })=>accountId);
const $5d1544565ffb4e26$var$isUserInlineEditValue = (editValue)=>typeof editValue === 'object' && editValue != null && 'displayName' in editValue && 'accountId' in editValue && 'avatarUrl' in editValue;
const $5d1544565ffb4e26$var$isUserInlineEditValueArray = (editValues)=>editValues != null && Array.isArray(editValues) && editValues.length > 0 && $5d1544565ffb4e26$var$isUserInlineEditValue(editValues[0]);
const $5d1544565ffb4e26$var$EditableUserAttribute = (props)=>{
    const { attributeType: attributeType, isEditable: isEditable } = props;
    const [{ attribute: attribute }] = (0, $581BZ.useEditableAttribute)(attributeType);
    const [value, setValue] = (0, $emsEK.useUserValue)(attribute);
    const resetValue = (0, $5uXOq.useCallback)(()=>setValue((0, $emsEK.getUserValues)(attribute)), [
        attribute,
        setValue
    ]);
    const storedValue = $5d1544565ffb4e26$var$toFieldValue((0, $emsEK.getUserValues)(attribute));
    const onValueChange = (0, $5uXOq.useCallback)((newUsers)=>{
        if ($5d1544565ffb4e26$var$isUserInlineEditValueArray(newUsers) || Array.isArray(newUsers) && newUsers.length === 0) setValue(newUsers);
    }, [
        setValue
    ]);
    const isMultiPicker = attributeType.maximumCardinality !== 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e08Fw.InlineEditableAttribute), {
        testId: "servicedesk-insight-inline-editable-attributes.ui.user-attribute",
        value: $5d1544565ffb4e26$var$toFieldValue(value),
        onChange: onValueChange,
        storedValue: storedValue,
        attributeType: attributeType,
        attributeValuesInfo: {
            type: 'user',
            attributeValues: value
        },
        scalingEnabled: true,
        isEditable: isEditable,
        renderReadView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ObjectDetailsSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $klGkl.UsersReadView), {
                users: value.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>({
                        accountId: accountId,
                        avatarUrl: avatarUrl,
                        displayName: displayName
                    }))
            })),
        renderEditView: ({ hasValidationError: hasValidationError, onChange: onChange, isClearable: isClearable, shouldInputRenderValue: shouldInputRenderValue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GHX9.UserAttributeUserPicker), {
                isClearable: isClearable,
                shouldInputRenderValue: shouldInputRenderValue,
                autoFocus: true,
                value: value,
                isMultiUserPicker: isMultiPicker,
                scopedGroups: attributeType.typeValueMulti ?? [],
                onChange: onChange,
                hasValidationError: hasValidationError
            }),
        onResetValue: resetValue
    });
};
const $5d1544565ffb4e26$export$3ba8466ee3465e06 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightEditableUserAttribute",
        packageName: "jiraServicedeskInsightEditableUserAttribute",
        teamName: "falcons",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5d1544565ffb4e26$var$EditableUserAttribute, props));

});
parcelRegister("klGkl", function(module, exports) {

$parcel$export(module.exports, "UsersReadView", () => $f98c1077247b0d92$export$b734ed5017674c4e);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $kFO36 = parcelRequire("kFO36");

var $koVbs = parcelRequire("koVbs");

var $kYYfm = parcelRequire("kYYfm");


var $j8mgt = parcelRequire("j8mgt");

var $fsOak = parcelRequire("fsOak");
const $f98c1077247b0d92$var$UserReadViewWithProfileCard = ({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kYYfm.AsyncProfileCardNext), {
        accountId: accountId,
        actions: [
            (0, $e6a2e0952e4731b8$export$23cedd3261bd8015)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.RoleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.AvatarWrapper), null, avatarUrl !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "circle",
        size: "xsmall",
        src: avatarUrl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kFO36))), {
        size: "small",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.RoleDisplayName), null, displayName)));
const $f98c1077247b0d92$export$b734ed5017674c4e = ({ users: users, showPlaceholderIfEmpty: showPlaceholderIfEmpty = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (users.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.PlaceholderSpacer), null, showPlaceholderIfEmpty ? formatMessage((0, $fsOak.messages).placeholder) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.ReadViewContainer), {
        isPlaceholder: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8mgt.RoleList), null, users.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f98c1077247b0d92$var$UserReadViewWithProfileCard, {
            key: accountId,
            accountId: accountId,
            avatarUrl: avatarUrl,
            displayName: displayName
        }))));
};

});
parcelRegister("kYYfm", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $15521008cc986085$export$a3c0845f856d4292);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $gcl1l = parcelRequire("gcl1l");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $15521008cc986085$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("2RBpK")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/main.tsx"
});
const $15521008cc986085$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15521008cc986085$var$LazyComponent, props)));
var $15521008cc986085$export$2e2bcd8739ae039 = $15521008cc986085$export$a3c0845f856d4292;

});
parcelRegister("2RBpK", function(module, exports) {

let $215d8db980a3912e$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $215d8db980a3912e$var$load("cM9em"),
    $215d8db980a3912e$var$load("fr9NE"),
    $215d8db980a3912e$var$load("h2MrD"),
    $215d8db980a3912e$var$load("bYT2S"),
    $215d8db980a3912e$var$load("ek7ue")
]).then(()=>parcelRequire('jO6eK'));

});


const $e6a2e0952e4731b8$export$81319ffa9c0d18d7 = 'profileCardNext';
const $e6a2e0952e4731b8$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$50632e21ea714398 = 'profileCardNextLegacy';
const $e6a2e0952e4731b8$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $e6a2e0952e4731b8$export$2549357601611c61 = 'loadError';
const $e6a2e0952e4731b8$export$23cedd3261bd8015 = 'viewProfile';
const $e6a2e0952e4731b8$export$6bef782d14a92db8 = 'assignedIssues';
const $e6a2e0952e4731b8$export$6b36f20db7a18a86 = 'reportedIssues';
const $e6a2e0952e4731b8$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("fsOak", function(module, exports) {

$parcel$export(module.exports, "messages", () => $86f8b79f11af95c8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $86f8b79f11af95c8$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "servicedesk-insight-attribute-views.user.placeholder",
        "defaultMessage": "No users selected"
    }
});

});


parcelRegister("emsEK", function(module, exports) {

$parcel$export(module.exports, "getUserValues", () => $f8f60b64872df2f4$export$c130a1cb7abd7a89);
$parcel$export(module.exports, "getUserValuesFromCmdbObjectAttribute", () => $f8f60b64872df2f4$export$8fbf8e3b3db46a71);
$parcel$export(module.exports, "useUserValue", () => $f8f60b64872df2f4$export$eb6455c0215ac0a5);

var $5uXOq = parcelRequire("5uXOq");

var $e5pww = parcelRequire("e5pww");
const $f8f60b64872df2f4$export$c130a1cb7abd7a89 = (attribute)=>{
    if (attribute && attribute.type === 'user') return attribute.userTypeValues.map(({ user: user })=>({
            avatarUrl: user.avatarUrl,
            displayName: user.displayName,
            accountId: user.key
        }));
    return [];
};
const $f8f60b64872df2f4$export$8fbf8e3b3db46a71 = (attribute)=>{
    if (attribute && attribute.type === (0, $e5pww.AttributeTypeMap).User) return attribute.objectAttributeValues.filter(({ user: user })=>user.key).map(({ user: user })=>({
            avatarUrl: user.avatarUrl ?? '',
            displayName: user.displayName ?? '',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            accountId: user.key
        }));
    return [];
};
const $f8f60b64872df2f4$export$eb6455c0215ac0a5 = (attribute)=>{
    const users = $f8f60b64872df2f4$export$c130a1cb7abd7a89(attribute);
    const [value, setValue] = (0, $5uXOq.useState)(users);
    (0, $5uXOq.useEffect)(()=>{
        setValue(()=>$f8f60b64872df2f4$export$c130a1cb7abd7a89(attribute));
    }, [
        attribute
    ]);
    return [
        value,
        setValue
    ];
};

});

parcelRegister("6GHX9", function(module, exports) {

$parcel$export(module.exports, "UserAttributeUserPicker", () => $9e6d2084fd928709$export$c3e698f9ae24105d);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $kgoHi = parcelRequire("kgoHi");

var $d7FF4 = parcelRequire("d7FF4");

var $jDrwg = parcelRequire("jDrwg");

var $f3O7j = parcelRequire("f3O7j");

var $g5X3G = parcelRequire("g5X3G");

var $eniQz = parcelRequire("eniQz");
const $9e6d2084fd928709$export$c3e698f9ae24105d = (props)=>{
    const { menuIsOpen: menuIsOpen, isMultiUserPicker: isMultiUserPicker, value: value, scopedGroups: scopedGroups, hasValidationError: hasValidationError, onChange: onChange, autoFocus: autoFocus } = props;
    // selectedUsers is used by the created useUsers hook to ensure that the
    // currently selected options are always present in the available options of
    // the user picker component
    const selectedUsers = (0, $5uXOq.useMemo)(()=>value.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName, accountType: accountType })=>({
                avatarUrl: avatarUrl,
                fixed: false,
                id: accountId,
                key: accountId,
                name: displayName,
                type: 'user',
                accountType: accountType
            })), [
        value
    ]);
    const useUsers = (0, $eniQz.createUseUsersHook)({
        groups: scopedGroups,
        selectedUsers: selectedUsers
    });
    const [fetchData] = useUsers();
    const loadPickerOptions = (0, $5uXOq.useCallback)((query, cb)=>{
        fetchData({
            query: query
        }).then((response)=>{
            const fetchedOptions = response?.map(({ id: id, name: name, avatarUrl: avatarUrl })=>({
                    accountId: (0, $g5X3G.toAccountId)(id),
                    displayName: name,
                    avatarUrl: avatarUrl
                }));
            cb?.(fetchedOptions ?? []);
        });
    }, [
        fetchData
    ]);
    const [debouncedLoadOptions] = (0, $jDrwg.default)((query, callback)=>loadPickerOptions(query, callback), 400);
    const formatOptionLabel = ({ displayName: displayName, avatarUrl: avatarUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9e6d2084fd928709$var$OptionInnerWrapper, null, avatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            appearance: "circle",
            size: "xsmall",
            src: avatarUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9e6d2084fd928709$var$OptionName, null, displayName));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9e6d2084fd928709$var$UserPickerBorderOverride, {
        hasValidationError: hasValidationError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        ...(0, $f3O7j.selectInAModalStyleFixProps),
        isDisabled: props.isDisabled,
        isClearable: props.isClearable,
        controlShouldRenderValue: props.shouldInputRenderValue,
        defaultOptions: true,
        formatOptionLabel: formatOptionLabel,
        autoFocus: autoFocus,
        menuIsOpen: menuIsOpen,
        menuPlacement: "auto",
        value: value,
        getOptionLabel: (userOption)=>userOption.displayName,
        getOptionValue: (userOption)=>userOption.accountId,
        isMulti: isMultiUserPicker,
        loadOptions: debouncedLoadOptions,
        onChange: (newUsers)=>{
            if (newUsers == null) props.onChange([]);
            else {
                const users = Array.isArray(newUsers) ? newUsers : [
                    newUsers
                ];
                onChange(users);
            }
        },
        validationState: hasValidationError ? 'error' : 'default',
        classNamePrefix: "insight-user-attribute-select"
    }));
};
$9e6d2084fd928709$export$c3e698f9ae24105d.defaultProps = {
    hasValidationError: false,
    autoFocus: false,
    isClearable: true,
    shouldInputRenderValue: true
};
const $9e6d2084fd928709$var$redBorder = null;
const $9e6d2084fd928709$var$OptionInnerWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center"
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e6d2084fd928709$var$OptionName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wpz1h6o _10fp1h6o _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $9e6d2084fd928709$var$UserPickerBorderOverride = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasValidationError: hasValidationError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.hasValidationError && "_5lfe78r2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eniQz", function(module, exports) {

$parcel$export(module.exports, "createUseUsersHook", () => $8e33e351dac0750c$export$2e355967eaf3bf88);

var $5uXOq = parcelRequire("5uXOq");

var $3JOCw = parcelRequire("3JOCw");

var $2NMNM = parcelRequire("2NMNM");

var $xJtdX = parcelRequire("xJtdX");

var $8zOmE = parcelRequire("8zOmE");

var $4VpwK = parcelRequire("4VpwK");

var $bp0q2 = parcelRequire("bp0q2");

var $7DxXA = parcelRequire("7DxXA");
const $8e33e351dac0750c$export$71c8af1c1c6b598a = async ({ workspaceId: workspaceId, groups: groups, query: query = '', excludes: excludes })=>{
    const { users: users } = await (0, $4VpwK.performCmdbPostRequest)((0, $bp0q2.getCmdbUserPickerUrl)(workspaceId), {
        body: JSON.stringify({
            excludes: excludes.map((user)=>user.key).join(','),
            groups: groups.join(','),
            query: query
        })
    });
    return users.map(({ key: key, displayName: displayName, avatarUrl: avatarUrl, accountType: accountType })=>({
            key: key,
            avatarUrl: avatarUrl,
            id: key,
            type: 'user',
            name: displayName,
            fixed: false,
            accountType: accountType
        }));
};
const $8e33e351dac0750c$export$8d152cb5327870eb = ({ groups: groups, selectedUsers: selectedUsers })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    const [data, setDataInternal] = (0, $5uXOq.useState)([]);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    // Wrapper around setDataInternal that ensures that the current set of
    // 'selected' users is always accesible by the consuming component.
    const setData = (0, $5uXOq.useCallback)((newData)=>{
        const mergedAndDedupedWithSelectedUsers = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
            ...newData,
            ...selectedUsers
        ], 'id');
        setDataInternal(mergedAndDedupedWithSelectedUsers);
    }, [
        selectedUsers
    ]);
    const userSearch = (0, $5uXOq.useCallback)(async ({ query: query = '' })=>{
        if (workspaceId) {
            setLoading(true);
            try {
                const users = await $8e33e351dac0750c$export$71c8af1c1c6b598a({
                    workspaceId: workspaceId,
                    groups: groups,
                    query: query,
                    excludes: selectedUsers
                });
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'insightSearchUserAttribute succeeded');
                setData(users);
                return users;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $xJtdX.fireCmdbErrorAnalytics)({
                    error: err,
                    meta: {
                        id: 'insightSearchUserAttribute',
                        teamName: 'falcons',
                        packageName: 'jiraServicedeskInsightUserAttributePicker'
                    }
                });
                setError(error);
            } finally{
                setLoading(false);
            }
        }
        return undefined;
    }, [
        createAnalyticsEvent,
        error,
        groups,
        selectedUsers,
        setData,
        workspaceId
    ]);
    return [
        userSearch,
        {
            data: data ?? [],
            error: error,
            loading: loading
        }
    ];
};
const $8e33e351dac0750c$export$2e355967eaf3bf88 = ({ groups: groups, selectedUsers: selectedUsers })=>()=>$8e33e351dac0750c$export$8d152cb5327870eb({
            groups: groups,
            selectedUsers: selectedUsers
        });

});
parcelRegister("bp0q2", function(module, exports) {

$parcel$export(module.exports, "getCmdbUserKeysUrl", () => $8af105528c337784$export$73c0b81592096db0);
$parcel$export(module.exports, "getCmdbUserPickerUrl", () => $8af105528c337784$export$c06a6b781d4bd7);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/user
 */ const $8af105528c337784$var$getCmdbUserUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/user`;
const $8af105528c337784$export$73c0b81592096db0 = (workspaceId, queryParams)=>`${$8af105528c337784$var$getCmdbUserUrl(workspaceId)}/keys?${(0, $ebyGx.stringify)(queryParams)}`;
const $8af105528c337784$export$c06a6b781d4bd7 = (workspaceId)=>`${$8af105528c337784$var$getCmdbUserUrl(workspaceId)}/picker`;

});




parcelRegister("4fIgT", function(module, exports) {

$parcel$export(module.exports, "useObjectSchemaPropertyService", () => $a605373f6344e752$export$f29a9b3a45b07527);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $xJtdX = parcelRequire("xJtdX");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $7DxXA = parcelRequire("7DxXA");

var $iN6n9 = parcelRequire("iN6n9");
const $a605373f6344e752$export$f29a9b3a45b07527 = ({ objectSchemaId: objectSchemaId })=>{
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const request = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
    async (props)=>{
        if (workspaceId) try {
            const response = await (0, $eusud.performGetRequest)((0, $iN6n9.getObjectSchemaPropertyUrl)(workspaceId, props.objectSchemaId));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchObjectSchemaProperty succeeded');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'fetchObjectSchemaProperty',
                    packageName: 'jiraServicedeskInsightObjectServices',
                    teamName: 'falcons'
                }
            });
            throw error;
        }
        return undefined;
    }, [
        workspaceId,
        createAnalyticsEvent
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchObjectSchemaProperty } = (0, $ld2hZ.useService)(request);
    (0, $5uXOq.useEffect)(()=>{
        if (loading === false && error === undefined && data === undefined) fetchObjectSchemaProperty({
            objectSchemaId: objectSchemaId
        });
    }, [
        loading,
        error,
        data,
        fetchObjectSchemaProperty,
        objectSchemaId
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: data
        },
        {
            fetchObjectSchemaProperty: fetchObjectSchemaProperty
        }
    ];
};

});

parcelRegister("jn7Xc", function(module, exports) {

$parcel$export(module.exports, "EditableAttribute", () => $b9258f2bf1c5ebca$export$32fdc0828dd44664);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $66Vf6 = parcelRequire("66Vf6");

var $4R6GH = parcelRequire("4R6GH");

var $7XYc4 = parcelRequire("7XYc4");
const $b9258f2bf1c5ebca$export$32fdc0828dd44664 = (props)=>{
    const [{ hideEmptyAttributes: hideEmptyAttributes }] = (0, $66Vf6.useObjectStoreState)();
    const [attribute] = (0, $66Vf6.useAttribute)(props.attributeTypeId);
    // attribute will be undefined if the attribute is empty
    if (hideEmptyAttributes && attribute === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b9258f2bf1c5ebca$var$AttributeWrapperStyles,
            props.isColumn && $b9258f2bf1c5ebca$var$AttributeWrapperColumnStyles,
            props.isMultiSelect && $b9258f2bf1c5ebca$var$AttributeWrapperMultiSelectStyles
        ],
        testId: "servicedesk-insight-editable-attribute-list.ui.editable-attribute.attribute-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b9258f2bf1c5ebca$var$AttributeLabel, {
        isColumn: props.isColumn,
        label: props.label,
        icon: props.icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b9258f2bf1c5ebca$var$AttributeValue, {
        isColumn: props.isColumn,
        label: props.label
    }, props.children));
};
const $b9258f2bf1c5ebca$var$AttributeValueDiv = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "aria-label": props.label,
        xcss: [
            $b9258f2bf1c5ebca$var$AttributeContentStyles,
            props.isColumn && $b9258f2bf1c5ebca$var$AttributeContentColumnStyles
        ]
    }, props.children);
};
const $b9258f2bf1c5ebca$var$AttributeValueDD = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "dd",
        "aria-label": props.label,
        xcss: [
            $b9258f2bf1c5ebca$var$AttributeContentStyles,
            $b9258f2bf1c5ebca$var$AttributeContentNoLeftMarginStyle,
            props.isColumn && $b9258f2bf1c5ebca$var$AttributeContentColumnStyles
        ]
    }, props.children);
};
const $b9258f2bf1c5ebca$var$AttributeValue = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('assets-a11y-fix'), $b9258f2bf1c5ebca$var$AttributeValueDD, $b9258f2bf1c5ebca$var$AttributeValueDiv);
const $b9258f2bf1c5ebca$var$AttributeLabelDt = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $b9258f2bf1c5ebca$var$AttributeLabelStyles,
            props.isColumn && $b9258f2bf1c5ebca$var$AttributeLabelColumnStyles
        ],
        as: "dt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.025"
    }, props.icon, props.label));
};
const $b9258f2bf1c5ebca$var$AttributeLabelInline = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: [
            $b9258f2bf1c5ebca$var$AttributeLabelStyles,
            props.isColumn && $b9258f2bf1c5ebca$var$AttributeLabelColumnStyles
        ],
        space: "space.025"
    }, props.icon, props.label);
};
const $b9258f2bf1c5ebca$var$AttributeLabel = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('assets-a11y-fix'), $b9258f2bf1c5ebca$var$AttributeLabelDt, $b9258f2bf1c5ebca$var$AttributeLabelInline);
const $b9258f2bf1c5ebca$var$AttributeWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    wordBreak: 'break-word',
    alignItems: 'center',
    flexWrap: 'nowrap',
    flexDirection: 'row'
});
const $b9258f2bf1c5ebca$var$AttributeWrapperMultiSelectStyles = (0, $8CUq3.xcss)({
    flexWrap: 'wrap'
});
const $b9258f2bf1c5ebca$var$AttributeWrapperColumnStyles = (0, $8CUq3.xcss)({
    flexDirection: 'column',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $b9258f2bf1c5ebca$var$AttributeContentStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    flexBasis: '60%',
    boxSizing: 'border-box',
    maxWidth: '100%',
    overflowY: 'visible',
    overflowX: 'clip',
    marginLeft: '0'
});
const $b9258f2bf1c5ebca$var$AttributeContentNoLeftMarginStyle = (0, $8CUq3.xcss)({
    marginLeft: '0'
});
const $b9258f2bf1c5ebca$var$AttributeLabelStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    maxWidth: '170px',
    flexBasis: '40%',
    margin: 'space.0',
    paddingBlock: 'space.100',
    lineHeight: '24px',
    marginTop: 'space.100',
    marginRight: 'space.100'
});
const $b9258f2bf1c5ebca$var$AttributeLabelColumnStyles = (0, $8CUq3.xcss)({
    flexBasis: 'auto'
});
const $b9258f2bf1c5ebca$var$AttributeContentColumnStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});

parcelRegister("jHpBb", function(module, exports) {

$parcel$export(module.exports, "EmptyAttributesInformation", () => $762d1321b2b4a385$export$2d4e0b21a9e1d986);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $66Vf6 = parcelRequire("66Vf6");

var $JNLY0 = parcelRequire("JNLY0");
const $762d1321b2b4a385$export$2d4e0b21a9e1d986 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { setHideEmptyAttributesState: setHideEmptyAttributesState }] = (0, $66Vf6.useObjectStoreState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'panel displayed', 'hideEmptyCmdbObjectAttributesPanel');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($762d1321b2b4a385$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($762d1321b2b4a385$var$TextContainer, null, formatMessage((0, $JNLY0.messages).emptyAttributesHidden)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "primary"
    }, props.numHiddenAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        onClick: ()=>setHideEmptyAttributesState(false)
    }, formatMessage((0, $JNLY0.messages).show)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $762d1321b2b4a385$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _bfhk1cs6 _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $762d1321b2b4a385$var$TextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("JNLY0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c750c3b48034d494$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $c750c3b48034d494$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    emptyAttributesHidden: {
        "id": "servicedesk-insight-editable-attribute-list.empty-attributes-information.empty-attributes-hidden",
        "defaultMessage": "Empty attributes hidden"
    },
    show: {
        "id": "servicedesk-insight-editable-attribute-list.empty-attributes-information.show",
        "defaultMessage": "Show"
    }
});

});


parcelRegister("5D95s", function(module, exports) {

$parcel$export(module.exports, "RestrictedSchemaEditingInformation", () => $414e2cf140356f51$export$5029eb4e1895b0e1);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $cgL5K = parcelRequire("cgL5K");

var $92Z2l = parcelRequire("92Z2l");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $66Vf6 = parcelRequire("66Vf6");

var $hDzhb = parcelRequire("hDzhb");

var $d8kYE = parcelRequire("d8kYE");

var $hyBvb = parcelRequire("hyBvb");
const $414e2cf140356f51$var$Bold = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong"
    }, chunks);
const $414e2cf140356f51$export$5029eb4e1895b0e1 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [attributes] = (0, $66Vf6.useAttributes)();
    const encodedServiceId = (0, $5uXOq.useMemo)(()=>(0, $hyBvb.extractEncodedServiceId)(attributes), [
        attributes
    ]);
    if (encodedServiceId == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        title: formatMessage((0, $d8kYE.messages).title),
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                key: "edit",
                href: `/jira/servicedesk/service-modal/${encodedServiceId}`,
                appearance: "primary",
                component: (0, $hDzhb.default)
            }, formatMessage((0, $d8kYE.messages).edit))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $d8kYE.messages).description,
        values: {
            bold: $414e2cf140356f51$var$Bold
        }
    })));
};

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$containerStyles = (0, $8CUq3.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'border.radius'
});
const $a97355a0cc6aeb06$var$bleedStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    marginBlock: 'space.negative.025'
});
const $a97355a0cc6aeb06$var$contentStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    font: 'font.body'
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a97355a0cc6aeb06$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        // props for new icon
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100",
        testId: testId && `${testId}--content`
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a97355a0cc6aeb06$var$contentStyles
    }, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: "list"
    }, actionsArray.map((action, id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            role: "listitem",
            key: id
        }, action))))));
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $5uXOq = parcelRequire("5uXOq");

var $btivG = parcelRequire("btivG");

var $7nnPp = parcelRequire("7nnPp");

var $2hXfb = parcelRequire("2hXfb");

var $eJS47 = parcelRequire("eJS47");

var $gtreQ = parcelRequire("gtreQ");

const $d1d7dced94bb00f5$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($btivG))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eJS47))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$export$faa35441caff5bb6[appearance] || $d1d7dced94bb00f5$export$faa35441caff5bb6.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});


parcelRegister("d8kYE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a0977145201bf64f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $a0977145201bf64f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "servicedesk-insight-editable-attribute-list.restricted-schema-editing-information.title",
        "defaultMessage": "Inline editing is not available"
    },
    description: {
        "id": "servicedesk-insight-editable-attribute-list.restricted-schema-editing-information.description",
        "defaultMessage": "Select <bold>Edit</bold> to modify the attributes of this Service."
    },
    edit: {
        "id": "servicedesk-insight-editable-attribute-list.restricted-schema-editing-information.edit",
        "defaultMessage": "Edit"
    }
});

});

parcelRegister("hyBvb", function(module, exports) {

$parcel$export(module.exports, "extractEncodedServiceId", () => $a57e60c688ec0c55$export$ca8cf0db83892e5d);

var $kCYNT = parcelRequire("kCYNT");
const $a57e60c688ec0c55$var$SERVICE_ID_ATTRIBUTE_LABEL = 'Service ID';
const $a57e60c688ec0c55$export$ca8cf0db83892e5d = (attributes)=>{
    const serviceIdAttribute = attributes.find((att)=>(0, $kCYNT.matchInsightObjectAttribute)(att, {
            default: (defaultAttribute)=>defaultAttribute.objectTypeAttribute.name.toLowerCase() === $a57e60c688ec0c55$var$SERVICE_ID_ATTRIBUTE_LABEL.toLowerCase(),
            object: ()=>false,
            user: ()=>false,
            group: ()=>false,
            project: ()=>false,
            status: ()=>false,
            bitbucketRepo: ()=>false,
            opsgenieTeam: ()=>false
        }));
    const serviceId = serviceIdAttribute?.defaultTypeValues[0].displayValue;
    if (serviceId != null) return `b:${btoa(serviceId)}`;
    return undefined;
};

});


parcelRegister("9wsAH", function(module, exports) {

$parcel$export(module.exports, "AttributesSkeleton", () => $83b4f4ddc9199db7$export$eca894baf97c71ce);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eOE6A = parcelRequire("eOE6A");
const $83b4f4ddc9199db7$var$AttributeRow = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83b4f4ddc9199db7$var$FlexContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOE6A.Skeleton), {
        width: "30%",
        height: "24px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOE6A.Skeleton), {
        width: "70%",
        height: "24px"
    }));
const $83b4f4ddc9199db7$export$eca894baf97c71ce = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83b4f4ddc9199db7$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83b4f4ddc9199db7$var$AttributeRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83b4f4ddc9199db7$var$AttributeRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83b4f4ddc9199db7$var$AttributeRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83b4f4ddc9199db7$var$AttributeRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83b4f4ddc9199db7$var$AttributeRow, null));
const $83b4f4ddc9199db7$var$Wrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $83b4f4ddc9199db7$var$wrapperStyles
    }, children);
const $83b4f4ddc9199db7$var$FlexContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, children);
const $83b4f4ddc9199db7$var$wrapperStyles = (0, $8CUq3.xcss)({
    margin: 'space.negative.100'
});

});
parcelRegister("eOE6A", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $5634a37ca1c67903$export$8f31e4c4a37b8e9c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $gwIPs = parcelRequire("gwIPs");
const $5634a37ca1c67903$var$shimmer = /*#__PURE__*/ (0, $47bDC.keyframes)({
    '0%': {
        backgroundPosition: '-300px 0'
    },
    '100%': {
        backgroundPosition: '1000px 0'
    }
});
const $5634a37ca1c67903$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "rxdyef-0"
})(({ borderRadius: borderRadius = '4px', height: height = '32px', width: width = '100%', margin: margin = `${0, $gwIPs.gridSize}px` })=>({
        animationDuration: '1.2s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        animationName: $5634a37ca1c67903$var$shimmer,
        animationTimingFunction: 'linear',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N30})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $829f609a65d26a98$exports).N40})`} 20%, ${`var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N30})`} 30% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius,
        height: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height,
        width: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width,
        margin: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin
    }));

});


parcelRegister("9DpdN", function(module, exports) {

$parcel$export(module.exports, "isTextAreaAttribute", () => $9eff6ef8ee85e7e3$export$63ffb5947a2e9f9a);
$parcel$export(module.exports, "isMultiSelectAttribute", () => $9eff6ef8ee85e7e3$export$4313561c08fa5557);
const $9eff6ef8ee85e7e3$export$63ffb5947a2e9f9a = (attributeType)=>attributeType.type === 'default' && attributeType.defaultType.name.toLowerCase() === 'textarea';
const $9eff6ef8ee85e7e3$export$4313561c08fa5557 = (attributeType)=>attributeType.type !== 'default' && attributeType.maximumCardinality !== 1;

});



parcelRegister("9BNuU", function(module, exports) {

$parcel$export(module.exports, "AsyncInsightObjectTimeline", () => $69dbf31041ebefbc$export$f04b07d46964ffae);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $dQQtO = parcelRequire("dQQtO");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $69dbf31041ebefbc$var$LazyObjectTimeline = (0, $kxZPA.lazy)(()=>(parcelRequire("k6He8")), {
    moduleId: "./src/packages/servicedesk/insight-object/object-timeline/src/ui/index.tsx"
});
const $69dbf31041ebefbc$export$f04b07d46964ffae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "insight-object-timeline",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dQQtO.InsightObjectTimelineSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69dbf31041ebefbc$var$LazyObjectTimeline, null));

});
parcelRegister("dQQtO", function(module, exports) {

$parcel$export(module.exports, "InsightObjectTimelineSkeleton", () => $f060595122c61b35$export$5212e95e3cbb902f);
$parcel$export(module.exports, "InsightObjectTimelineNoFiltersSkeleton", () => $f060595122c61b35$export$4dec36c3db61fc7);
/* InsightObjectTimelineSkeleton.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $7HCH8 = parcelRequire("7HCH8");

var $lpL0p = parcelRequire("lpL0p");
const $f060595122c61b35$var$skeletonCssStyles = null;
const $f060595122c61b35$export$5212e95e3cbb902f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lpL0p))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });
const $f060595122c61b35$export$4dec36c3db61fc7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7HCH8))),
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("7HCH8", function(module, exports) {
module.exports = new URL("insight-object-timeline-no-filters-skeleton.tpl.4dc1ed7e.svg", import.meta.url).toString();

});

parcelRegister("lpL0p", function(module, exports) {
module.exports = new URL("insight-object-timeline-skeleton.tpl.f3773a50.svg", import.meta.url).toString();

});


parcelRegister("k6He8", function(module, exports) {

let $ea35e62ae73a6318$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ea35e62ae73a6318$var$load("h2MrD"),
    $ea35e62ae73a6318$var$load("bYT2S"),
    $ea35e62ae73a6318$var$load("hPzOn"),
    $ea35e62ae73a6318$var$load("2OyzL")
]).then(()=>parcelRequire('7xodO'));

});


parcelRegister("4IbhP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a25133a58457679$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4a25133a58457679$var$messages = (0, $7VHMR.defineMessages)({
    detailsTabTitle: {
        "id": "servicedesk-insight-object-details.details-tab-title",
        "defaultMessage": "Details"
    },
    activityTabTitle: {
        "id": "servicedesk-insight-object-details.activity-tab-title",
        "defaultMessage": "Activity"
    }
});
var $4a25133a58457679$export$2e2bcd8739ae039 = $4a25133a58457679$var$messages;

});


parcelRegister("24qlo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "InsightObjectGraph", () => $db8000536af368ec$export$df140f9d4d4d50d1);
$parcel$export(module.exports, "InsightObjectGraphOrNull", () => $db8000536af368ec$export$5ad8ce0659b457a3);
$parcel$export(module.exports, "InsightObjectGraphModal", () => $db8000536af368ec$export$1f487400bf99b836);
$parcel$export(module.exports, "default", () => $db8000536af368ec$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ahdj0 = parcelRequire("ahdj0");

var $8jMCF = parcelRequire("8jMCF");

var $a8hd9 = parcelRequire("a8hd9");

var $ebhXg = parcelRequire("ebhXg");

var $7DmSu = parcelRequire("7DmSu");

var $aRO6g = parcelRequire("aRO6g");

var $1R1Ge = parcelRequire("1R1Ge");
var $i8Qvm = parcelRequire("i8Qvm");

var $eZJjh = parcelRequire("eZJjh");

var $9fuVs = parcelRequire("9fuVs");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $7DxXA = parcelRequire("7DxXA");

var $kEqrP = parcelRequire("kEqrP");

var $5EBaG = parcelRequire("5EBaG");

var $fAOgz = parcelRequire("fAOgz");


var $3auAE = parcelRequire("3auAE");

var $akFOk = parcelRequire("akFOk");

var $aEMJe = parcelRequire("aEMJe");

var $1G6xC = parcelRequire("1G6xC");

var $5Ny9E = parcelRequire("5Ny9E");

var $dCm1o = parcelRequire("dCm1o");

var $jni3N = parcelRequire("jni3N");

var $cJWnf = parcelRequire("cJWnf");

var $jAGT1 = parcelRequire("jAGT1");

var $g245j = parcelRequire("g245j");

var $koaLx = parcelRequire("koaLx");

var $1vkRZ = parcelRequire("1vkRZ");

var $2SKu4 = parcelRequire("2SKu4");

var $3jZB1 = parcelRequire("3jZB1");

var $7Nkr2 = parcelRequire("7Nkr2");

var $e7PRu = parcelRequire("e7PRu");

var $3nJmO = parcelRequire("3nJmO");

var $a417P = parcelRequire("a417P");

var $bvAlP = parcelRequire("bvAlP");
const $db8000536af368ec$var$DIALOG_WIDTH = 1280;
const $db8000536af368ec$var$DIALOG_HEIGHT = 720;
const $db8000536af368ec$var$FADEIN_ANIMATION_DELAY = 500;
const $db8000536af368ec$export$df140f9d4d4d50d1 = ({ objectId: objectId, objectTypeId: objectTypeId, onClose: onClose, source: source })=>{
    const [selectedNode, { setSelectedObjectNode: setSelectedObjectNode, setSelectedObjectTypeNode: setSelectedObjectTypeNode }] = (0, $jAGT1.useSelectedNode)(objectId);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    const [sidebarState, sidebarActions] = (0, $3auAE.usePushingSidebar)({
        width: 480
    });
    const [isConfigPanelOpen, setIsConfigPanelOpen] = (0, $5uXOq.useState)(false);
    const [isGraphLayoutLocked, setIsGraphLayoutLocked] = (0, $5uXOq.useState)(true);
    const [{ data: objectDetailsData, loading: objectDetailsLoading, error: objectDetailsError }, fetchObjectDetails] = (0, $aEMJe.useObjectDetailsService)();
    const [{ data: objectGraphData, loading: graphLoading, error: graphError }, fetchObjectGraph] = (0, $1G6xC.useObjectGraphService)();
    const [{ referenceTypes: referenceTypes, maxOfSameType: maxOfSameType, referenceDepth: referenceDepth }, { updateReferenceDepth: updateReferenceDepth, updateMaxOfSameType: updateMaxOfSameType, updateReferenceTypes: updateReferenceTypes }] = (0, $cJWnf.useObjectGraphConfiguration)(objectGraphData, objectTypeId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fetchGraphData = (0, $5uXOq.useCallback)((objId)=>{
        if (workspaceId) fetchObjectGraph({
            workspaceId: workspaceId,
            objectId: (0, $5Ny9E.toCmdbObjectId)(objId),
            depth: referenceDepth,
            maxOfSameType: maxOfSameType
        });
    }, [
        fetchObjectGraph,
        maxOfSameType,
        referenceDepth,
        workspaceId
    ]);
    const transformedGraphData = (0, $5uXOq.useMemo)(()=>{
        // the initial graph data response goes through a series of transformations before it renders:
        // 1. we filter the nodes & edges based on the currently selected reference types in the object graph configuration panel
        // 2. we only show nodes that have a connection (either direct or indirect) to the currently selected object based on that filtering
        // 3. we then transform the result of that into a data shape the force graph library expects
        const filteredBySelectedReferenceTypes = (0, $bvAlP.getFilteredEdgesAndNodes)(objectGraphData, referenceTypes, selectedNode.referenceId);
        const nodesConnectedToSelectedNode = (0, $bvAlP.getConnectedNodesFromParent)(filteredBySelectedReferenceTypes, selectedNode.referenceId);
        return (0, $bvAlP.getNormalizedGraphData)(nodesConnectedToSelectedNode); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        objectGraphData,
        referenceTypes
    ]);
    // in this case we do want to explicity exclude the reference id here
    const handleFetchObjectDetails = (0, $5uXOq.useCallback)(()=>{
        if (workspaceId) fetchObjectDetails({
            objectId: (0, $5Ny9E.toCmdbObjectId)(selectedNode.referenceId),
            workspaceId: workspaceId
        });
    }, [
        fetchObjectDetails,
        selectedNode.referenceId,
        workspaceId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (workspaceId) fetchObjectDetails({
            objectId: (0, $5Ny9E.toCmdbObjectId)(selectedNode.referenceId),
            workspaceId: workspaceId
        });
    }, [
        fetchObjectDetails,
        selectedNode.referenceId,
        workspaceId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchGraphData(objectId);
    }, [
        fetchGraphData,
        fetchObjectGraph,
        objectId,
        workspaceId
    ]);
    const onNodeClicked = (0, $5uXOq.useCallback)((selectedObjectData)=>{
        const { data: data, dataType: dataType } = selectedObjectData;
        const { context: context } = data;
        if (dataType === (0, $50d8b5ecd71e7169$export$accaa52ddae3fe58) && context) {
            switch(context.type){
                case (0, $jni3N.GRAPH_NODE_TYPES).OBJECT:
                    setSelectedObjectNode(context.id);
                    break;
                case (0, $jni3N.GRAPH_NODE_TYPES).OBJECT_TYPE:
                    setSelectedObjectTypeNode(context);
                    break;
                default:
                    break;
            }
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightObjectGraphItem', {
                source: source
            });
        }
    }, [
        createAnalyticsEvent,
        setSelectedObjectNode,
        setSelectedObjectTypeNode,
        source
    ]);
    const onNodeDoubleClicked = (0, $5uXOq.useCallback)((selectedObjectData)=>{
        const { data: data, dataType: dataType } = selectedObjectData;
        const { context: context } = data;
        if (dataType === (0, $50d8b5ecd71e7169$export$accaa52ddae3fe58) && context?.type === (0, $jni3N.GRAPH_NODE_TYPES).OBJECT) fetchGraphData(context.id);
    }, [
        fetchGraphData
    ]);
    const onObjectAttributeClick = (0, $5uXOq.useCallback)((object)=>{
        const { nodes: nodes = [] } = transformedGraphData ?? {};
        const isNodeVisibleInGraph = nodes.some((n)=>n.context?.id === object.objectId);
        if (isNodeVisibleInGraph) setSelectedObjectNode(object.objectId);
        else {
            fetchGraphData(object.objectId);
            setSelectedObjectNode(object.objectId);
        }
    }, [
        fetchGraphData,
        setSelectedObjectNode,
        transformedGraphData
    ]);
    const onToggleLockedLayout = ()=>{
        const shouldLockGraph = !isGraphLayoutLocked;
        setIsGraphLayoutLocked(shouldLockGraph);
    };
    const HideObjectGraphDetailsIconComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, (/*@__PURE__*/$parcel$interopDefault($7DmSu))) : (0, $5EBaG.HideObjectGraphDetailsIcon);
    const ShowObjectGraphDetailsIconComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, (/*@__PURE__*/$parcel$interopDefault($aRO6g))) : (0, $5EBaG.ShowObjectGraphDetailsIcon);
    const actionButtons = [
        {
            Icon: isGraphLayoutLocked ? (0, (/*@__PURE__*/$parcel$interopDefault($a8hd9))) : (0, (/*@__PURE__*/$parcel$interopDefault($ebhXg))),
            label: formatMessage(isGraphLayoutLocked ? (0, $e7PRu.default).unlockLayout : (0, $e7PRu.default).lockLayout),
            onClick: onToggleLockedLayout,
            isSelected: isGraphLayoutLocked,
            iconSpacing: 'spacious'
        },
        {
            Icon: sidebarState.isOpen ? HideObjectGraphDetailsIconComponent : ShowObjectGraphDetailsIconComponent,
            testId: 'servicedesk-insight-object-graph.ui.graph-toggle-button',
            label: formatMessage(sidebarState.isOpen ? (0, $e7PRu.default).hideDetail : (0, $e7PRu.default).showDetail),
            onClick: (event, analyticsEvent)=>{
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'insightObjectGraphToggleDetailsPanel', {
                    action: sidebarState.isOpen ? 'hiding' : 'showing',
                    source: source
                });
                if (isConfigPanelOpen) setIsConfigPanelOpen(()=>false);
                sidebarActions.toggleSidebar();
            },
            iconSpacing: 'spacious'
        }
    ];
    const renderGraphError = ()=>{
        (0, $kEqrP.graphModalExperience).failure();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jZB1.GraphError), null);
    };
    const renderForceGraph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fAOgz.AsyncLazyForceGraph), {
            graphData: transformedGraphData,
            onNodeClick: onNodeClicked,
            onNodeDoubleClick: onNodeDoubleClicked,
            defaultSelectedNodeId: selectedNode.nodeId,
            isLayoutLocked: isGraphLayoutLocked
        });
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Nkr2.GraphHeader), {
        title: formatMessage((0, $e7PRu.default).title),
        onClose: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $akFOk.PushingSidebarContainer), sidebarState, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db8000536af368ec$var$GraphWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ahdj0.default), {
        timeout: {
            exit: $db8000536af368ec$var$FADEIN_ANIMATION_DELAY
        },
        in: graphLoading,
        unmountOnExit: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db8000536af368ec$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }))), !graphLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db8000536af368ec$var$FadeIn, null, graphError ? renderGraphError() : renderForceGraph()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g245j.Actions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koaLx.GraphConfigurationActionPanel), {
        isConfigPanelOpen: isConfigPanelOpen,
        onOpenChange: (isOpen)=>{
            // Only handle open events here. Close events are handled on the wrapper of this dialog because
            // otherwise clicks on the reference depth dropdown are considered "outside" this panel, and cause
            // the panel to close instead of updating the reference depth.
            isOpen && setIsConfigPanelOpen(true);
        },
        menuPosition: sidebarState.isOpen ? 'left' : 'right',
        renderActionButton: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g245j.ActionsButton), {
                ...triggerProps,
                onClick: (event)=>{
                    if (isConfigPanelOpen) setIsConfigPanelOpen(false);
                    triggerProps.onClick?.(event);
                },
                triggerRef: triggerRef,
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jMCF))),
                label: formatMessage(isConfigPanelOpen ? (0, $e7PRu.default).hideGraphConfigPanel : (0, $e7PRu.default).showGraphConfigPanel),
                iconSpacing: "spacious",
                testId: "servicedesk-insight-object-graph.ui.graph-config-button"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db8000536af368ec$var$ConfigPanelHeader, null, formatMessage((0, $e7PRu.default).graphConfigPanelHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vkRZ.ReferenceDepthConfigurationInputs), {
        maxOfSameType: maxOfSameType,
        referenceDepth: referenceDepth,
        onUpdateReferenceDepth: updateReferenceDepth,
        onUpdateMaxOfSameType: updateMaxOfSameType
    }), referenceTypes.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db8000536af368ec$var$ReferenceTypeListHeader, null, formatMessage((0, $e7PRu.default).referenceTypesHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2SKu4.ReferenceTypeToggleList), {
        referenceTypes: referenceTypes,
        onChange: updateReferenceTypes
    })) : null), actionButtons.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g245j.ActionsButton), {
            testId: `servicedesk-insight-object-graph.ui.button-${action.label}`,
            key: action.label,
            ...action
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $akFOk.PushingSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db8000536af368ec$var$ObjectViewWrapper, null, selectedNode.type === (0, $jni3N.GRAPH_NODE_TYPES).OBJECT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a417P.ObjectView), {
        objectDetails: objectDetailsData,
        objectDetailsLoading: objectDetailsLoading,
        objectDetailsError: objectDetailsError,
        onRefreshButtonClick: handleFetchObjectDetails,
        selectedObjectId: (0, $5Ny9E.toCmdbObjectId)(selectedNode.referenceId),
        onObjectAttributeClick: onObjectAttributeClick,
        source: source
    }), selectedNode.type === (0, $jni3N.GRAPH_NODE_TYPES).OBJECT_TYPE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3nJmO.ObjectTypeView), {
        objectTypeNode: selectedNode
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db8000536af368ec$var$Wrapper, {
        onClick: ()=>setIsConfigPanelOpen(false)
    }, content);
};
const $db8000536af368ec$export$5ad8ce0659b457a3 = (props)=>{
    if (props.objectId !== undefined && props.objectTypeId !== undefined) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db8000536af368ec$export$df140f9d4d4d50d1, props);
    return null;
};
const $db8000536af368ec$export$1f487400bf99b836 = ({ objectId: objectId, objectTypeId: objectTypeId, onClose: onClose, source: source, testId: testId, isObjectGraphOpen: isObjectGraphOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isObjectGraphOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "InsightObjectGraph",
        packageName: "jiraServiceDeskInsightObjectGraph",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), {
        width: $db8000536af368ec$var$DIALOG_WIDTH,
        height: $db8000536af368ec$var$DIALOG_HEIGHT,
        onClose: onClose,
        autoFocus: false,
        stackIndex: 1,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db8000536af368ec$export$5ad8ce0659b457a3, {
        objectId: objectId,
        objectTypeId: objectTypeId,
        onClose: onClose,
        source: source,
        isObjectGraphOpen: isObjectGraphOpen
    })))));
var $db8000536af368ec$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $db8000536af368ec$export$1f487400bf99b836;
const $db8000536af368ec$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1lxo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db8000536af368ec$var$ObjectViewWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1kl7h6cr _4t3i1osq _bfhkzxtc _18m91wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db8000536af368ec$var$GraphWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db8000536af368ec$var$SpinnerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $db8000536af368ec$var$fadeIn = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db8000536af368ec$var$FadeIn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_tzy4idpf _4t3i1osq _1bsb1osq _j7hq1wwu _tip8kb7n _ju251bs3 _5sag1doz _1o51q7pw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db8000536af368ec$var$ConfigPanelHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyr1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db8000536af368ec$var$ReferenceTypeListHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8jMCF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f0471165b1411c9e3d53c4e3bf136cbc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60e5d086aacc57a4$var$_react = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $60e5d086aacc57a4$var$_customize = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("4QAwn")));

var $60e5d086aacc57a4$var$_preferences = $60e5d086aacc57a4$var$_interopRequireDefault((parcelRequire("5KZxU")));
function $60e5d086aacc57a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CustomizeIcon.
 * This component is CustomizeIcon, with `UNSAFE_fallbackIcon` set to "PreferencesIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $60e5d086aacc57a4$var$CustomizeIcon = (props)=>/*#__PURE__*/ $60e5d086aacc57a4$var$_react.default.createElement($60e5d086aacc57a4$var$_customize.default, Object.assign({
        LEGACY_fallbackIcon: $60e5d086aacc57a4$var$_preferences.default
    }, props));
$60e5d086aacc57a4$var$CustomizeIcon.Name = 'CustomizeIconMigration';
var $60e5d086aacc57a4$var$_default = module.exports.default = $60e5d086aacc57a4$var$CustomizeIcon;

});
parcelRegister("4QAwn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0c649661159dc6f72b79c281c90c29e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3878591d802e976a$var$_react = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3878591d802e976a$var$_baseNew = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3878591d802e976a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3878591d802e976a$var$CustomizeIcon = (props)=>/*#__PURE__*/ $3878591d802e976a$var$_react.default.createElement($3878591d802e976a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.25 11.5V9.375a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625v4.25c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625zm0 0H16m-16 0h7.5m-3.75-7v2.125c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625v-4.25a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625zm0 0H0m16 0H8.5"/>`
    }, props));
$3878591d802e976a$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $3878591d802e976a$var$_default = module.exports.default = $3878591d802e976a$var$CustomizeIcon;

});

parcelRegister("5KZxU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4310fd5ff8fcaeb0$var$_react = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4310fd5ff8fcaeb0$var$_customize = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("4QAwn")));
function $4310fd5ff8fcaeb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4310fd5ff8fcaeb0$var$PreferencesIcon = (props)=>/*#__PURE__*/ $4310fd5ff8fcaeb0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props, {
        newIcon: $4310fd5ff8fcaeb0$var$_customize.default
    }));
$4310fd5ff8fcaeb0$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $4310fd5ff8fcaeb0$var$_default = module.exports.default = $4310fd5ff8fcaeb0$var$PreferencesIcon;

});


parcelRegister("a8hd9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eeba4aefb98c8fb975fb3f72e8129cdf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7608008571388d79$var$_react = $7608008571388d79$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7608008571388d79$var$_lockLocked = $7608008571388d79$var$_interopRequireDefault((parcelRequire("bwyQI")));

var $7608008571388d79$var$_lockFilled = $7608008571388d79$var$_interopRequireDefault((parcelRequire("gs7PQ")));
function $7608008571388d79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7608008571388d79$var$LockLockedIcon = (props)=>/*#__PURE__*/ $7608008571388d79$var$_react.default.createElement($7608008571388d79$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $7608008571388d79$var$_lockFilled.default
    }, props));
$7608008571388d79$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $7608008571388d79$var$_default = module.exports.default = $7608008571388d79$var$LockLockedIcon;

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::99280b1ea43458dc827592cb9abe9600>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("gs7PQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfa556ca72f8a34c$var$_react = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfa556ca72f8a34c$var$_lockLocked = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $bfa556ca72f8a34c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfa556ca72f8a34c$var$LockFilledIcon = (props)=>/*#__PURE__*/ $bfa556ca72f8a34c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $bfa556ca72f8a34c$var$_lockLocked.default
    }));
$bfa556ca72f8a34c$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $bfa556ca72f8a34c$var$_default = module.exports.default = $bfa556ca72f8a34c$var$LockFilledIcon;

});


parcelRegister("ebhXg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e729cff048265e2c05f037874b246efd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a530053fe4c2545b$var$_react = $a530053fe4c2545b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a530053fe4c2545b$var$_lockUnlocked = $a530053fe4c2545b$var$_interopRequireDefault((parcelRequire("jHgVl")));

var $a530053fe4c2545b$var$_unlockFilled = $a530053fe4c2545b$var$_interopRequireDefault((parcelRequire("9leAG")));
function $a530053fe4c2545b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LockUnlockedIcon.
 * This component is LockUnlockedIcon, with `UNSAFE_fallbackIcon` set to "UnlockFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a530053fe4c2545b$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $a530053fe4c2545b$var$_react.default.createElement($a530053fe4c2545b$var$_lockUnlocked.default, Object.assign({
        LEGACY_fallbackIcon: $a530053fe4c2545b$var$_unlockFilled.default
    }, props));
$a530053fe4c2545b$var$LockUnlockedIcon.Name = 'LockUnlockedIconMigration';
var $a530053fe4c2545b$var$_default = module.exports.default = $a530053fe4c2545b$var$LockUnlockedIcon;

});
parcelRegister("jHgVl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::50aef0ad3a10d16e5bbf02b14352c2db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e56f2934baaafa03$var$_react = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e56f2934baaafa03$var$_baseNew = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e56f2934baaafa03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e56f2934baaafa03$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $e56f2934baaafa03$var$_react.default.createElement($e56f2934baaafa03$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.25 4a3.25 3.25 0 1 0-6.5 0v3.75m0 0H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25z"/>`
    }, props));
$e56f2934baaafa03$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $e56f2934baaafa03$var$_default = module.exports.default = $e56f2934baaafa03$var$LockUnlockedIcon;

});

parcelRegister("9leAG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6cd1649e81d79beb$var$_react = $6cd1649e81d79beb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6cd1649e81d79beb$var$_lockUnlocked = $6cd1649e81d79beb$var$_interopRequireDefault((parcelRequire("jHgVl")));
function $6cd1649e81d79beb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6cd1649e81d79beb$var$UnlockFilledIcon = (props)=>/*#__PURE__*/ $6cd1649e81d79beb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 11.009C5 9.899 5.897 9 7.006 9h9.988A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991zM12 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/><path fill-rule="nonzero" d="M8 6.251v-.249A4.004 4.004 0 0 1 12 2a4 4 0 0 1 4 4.002V6.5h-2v-.498A2 2 0 0 0 12 4c-1.102 0-2 .898-2 2.002V11H8zm6 .249h2a1 1 0 0 1-2 0"/></g></svg>`
    }, props, {
        newIcon: $6cd1649e81d79beb$var$_lockUnlocked.default
    }));
$6cd1649e81d79beb$var$UnlockFilledIcon.displayName = 'UnlockFilledIcon';
var $6cd1649e81d79beb$var$_default = module.exports.default = $6cd1649e81d79beb$var$UnlockFilledIcon;

});


parcelRegister("aRO6g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daa753b85adf49eed16fb99089492eb3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e95b773b99220a6$var$_react = $7e95b773b99220a6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7e95b773b99220a6$var$_baseNew = $7e95b773b99220a6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7e95b773b99220a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a sidebar to the right of the viewport edge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e95b773b99220a6$var$SidebarRightIcon = (props)=>/*#__PURE__*/ $7e95b773b99220a6$var$_react.default.createElement($7e95b773b99220a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 2.75H14c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H7.75m0-10.5v10.5m0-10.5H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25h5.75M10 5.75h3m-3 3h3"/>`
    }, props));
$7e95b773b99220a6$var$SidebarRightIcon.displayName = 'SidebarRightIcon';
var $7e95b773b99220a6$var$_default = module.exports.default = $7e95b773b99220a6$var$SidebarRightIcon;

});

parcelRegister("5EBaG", function(module, exports) {

$parcel$export(module.exports, "ObjectSchemasIcon", () => $87a6e7030c6a3200$export$bea30a91ea911ed8);
$parcel$export(module.exports, "ObjectGraphGlyph", () => $87a6e7030c6a3200$export$fd4e4ffca6161634);
$parcel$export(module.exports, "ObjectGraphIcon", () => $87a6e7030c6a3200$export$7fd55e0f2e77172c);
$parcel$export(module.exports, "ShowObjectGraphDetailsIcon", () => $87a6e7030c6a3200$export$a96f5718ff672e9d);
$parcel$export(module.exports, "HideObjectGraphDetailsIcon", () => $87a6e7030c6a3200$export$cf601da3438765d9);
$parcel$export(module.exports, "SchemaIcon", () => $87a6e7030c6a3200$export$fc6a25a0b4021903);
$parcel$export(module.exports, "ColumnsIcon", () => $87a6e7030c6a3200$export$38f001d9cffdd080);
$parcel$export(module.exports, "QrCodeIcon", () => $87a6e7030c6a3200$export$33dd147542b2195b);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $iwxKK = parcelRequire("iwxKK");

var $apaik = parcelRequire("apaik");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $1aBwA = parcelRequire("1aBwA");
const $87a6e7030c6a3200$export$58cebcda192184d0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 8C14.8954 8 14 8.89543 14 10V12C14 13.1046 14.8954 14 16 14H18C19.1046 14 20 13.1046 20 12V10C20 8.89543 19.1046 8 18 8H16ZM18 10H16V12H18V10Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 16C14.8954 16 14 16.8954 14 18V20C14 21.1046 14.8954 22 16 22H18C19.1046 22 20 21.1046 20 20V18C20 16.8954 19.1046 16 18 16H16ZM18 18H16V20H18V18Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 2C4.89543 2 4 2.89543 4 4V6C4 7.10457 4.89543 8 6 8H8C9.10457 8 10 7.10457 10 6V4C10 2.89543 9.10457 2 8 2H6ZM8 4H6V6H8V4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "6",
        y: "7",
        width: "2",
        height: "11",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 18H15V20H8C6.89543 20 6 19.1046 6 18Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 10H15V12H8C6.89543 12 6 11.1046 6 10Z",
        fill: "currentColor"
    }));
const $87a6e7030c6a3200$export$bea30a91ea911ed8 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), (0, (/*@__PURE__*/$parcel$interopDefault($iwxKK))), (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$export$58cebcda192184d0));
const $87a6e7030c6a3200$export$fd4e4ffca6161634 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "4",
        cy: "4",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "6",
        cy: "18",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "20",
        cy: "6",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "18",
        cy: "19",
        r: "2",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 15a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 100-4 2 2 0 000 4z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4 4l6 5.5m9.5-3l-5 3m-8 8l4-4.5m8 6.5l-5-6",
        stroke: "currentColor",
        strokeWidth: "1.5"
    }));
const $87a6e7030c6a3200$export$7fd55e0f2e77172c = (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$export$fd4e4ffca6161634);
const $87a6e7030c6a3200$var$ShowObjectGraphDetailsGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M20 2H2V4H9V9H11V4H20V20H11V15H9V20H2V22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M2.47 12.8835C2.19 12.7165 2 12.3835 2 11.9995C2 11.6155 2.19 11.2825 2.47 11.1155L5.086 8.49946C5.2746 8.3173 5.5272 8.21651 5.7894 8.21879C6.0516 8.22107 6.30241 8.32623 6.48782 8.51164C6.67323 8.69705 6.7784 8.94786 6.78067 9.21006C6.78295 9.47226 6.68216 9.72486 6.5 9.91346L4.938 10.9995H10.118C10.605 10.9995 11 11.4475 11 11.9995C11 12.5515 10.605 12.9995 10.118 12.9995H4.938L6.5 14.0855C6.68216 14.2741 6.78295 14.5267 6.78067 14.7889C6.7784 15.0511 6.67323 15.3019 6.48782 15.4873C6.30241 15.6727 6.0516 15.7779 5.7894 15.7801C5.5272 15.7824 5.2746 15.6816 5.086 15.4995L2.47 12.8835Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13 7C13 6.44772 13.4477 6 14 6H17C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8H14C13.4477 8 13 7.55228 13 7Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13 11C13 10.4477 13.4477 10 14 10H17C17.5523 10 18 10.4477 18 11C18 11.5523 17.5523 12 17 12H14C13.4477 12 13 11.5523 13 11Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13 15C13 14.4477 13.4477 14 14 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H14C13.4477 16 13 15.5523 13 15Z",
        fill: "currentColor"
    }));
const $87a6e7030c6a3200$var$HideObjectGraphDetailsGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M19 2H2V4H14V9H16V4H19V20H16V15H14V20H2V22H19C20.1046 22 21 21.1046 21 20V4C21 2.89543 20.1046 2 19 2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.53 12.8835C12.81 12.7165 13 12.3835 13 11.9995C13 11.6155 12.81 11.2825 12.53 11.1155L9.914 8.49946C9.7254 8.3173 9.4728 8.21651 9.2106 8.21879C8.9484 8.22107 8.69759 8.32623 8.51218 8.51164C8.32677 8.69705 8.2216 8.94786 8.21933 9.21006C8.21705 9.47226 8.31784 9.72486 8.5 9.91346L10.062 10.9995H2.882C2.395 10.9995 2 11.4475 2 11.9995C2 12.5515 2.395 12.9995 2.882 12.9995H10.062L8.5 14.0855C8.31784 14.2741 8.21705 14.5267 8.21933 14.7889C8.2216 15.0511 8.32677 15.3019 8.51218 15.4873C8.69759 15.6727 8.9484 15.7779 9.2106 15.7801C9.4728 15.7824 9.7254 15.6816 9.914 15.4995L12.53 12.8835Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 9H16V15H14V9Z",
        fill: "currentColor"
    }));
const $87a6e7030c6a3200$export$a96f5718ff672e9d = (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$var$ShowObjectGraphDetailsGlyph);
const $87a6e7030c6a3200$export$cf601da3438765d9 = (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$var$HideObjectGraphDetailsGlyph);
const $87a6e7030c6a3200$var$SchemaGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "47",
        height: "47",
        rx: "4.5",
        fill: "white",
        stroke: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6665 18.6667C27.5619 18.6667 26.6665 19.5621 26.6665 20.6667V24.6667C26.6665 25.7713 27.5619 26.6667 28.6665 26.6667H32.6665C33.7711 26.6667 34.6665 25.7713 34.6665 24.6667V20.6667C34.6665 19.5621 33.7711 18.6667 32.6665 18.6667H28.6665ZM31.9998 21.3334H29.3331V24.0001H31.9998V21.3334Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6665 29.3333C27.5619 29.3333 26.6665 30.2287 26.6665 31.3333V35.3333C26.6665 36.4379 27.5619 37.3333 28.6665 37.3333H32.6665C33.7711 37.3333 34.6665 36.4379 34.6665 35.3333V31.3333C34.6665 30.2287 33.7711 29.3333 32.6665 29.3333H28.6665ZM31.9998 31.9999H29.3331V34.6666H31.9998V31.9999Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3335 10.6667C14.2289 10.6667 13.3335 11.5621 13.3335 12.6667V16.6667C13.3335 17.7713 14.2289 18.6667 15.3335 18.6667H19.3335C20.4381 18.6667 21.3335 17.7713 21.3335 16.6667V12.6667C21.3335 11.5621 20.4381 10.6667 19.3335 10.6667H15.3335ZM18.6669 13.3334H16.0002V16.0001H18.6669V13.3334Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "16",
        y: "17.3333",
        width: "2.66667",
        height: "14.6667",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 32H28V34.6667H18C16.8954 34.6667 16 33.7712 16 32.6667V32Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 21.3333H28V24H18C16.8954 24 16 23.1046 16 22V21.3333Z",
        fill: "#42526E"
    }));
const $87a6e7030c6a3200$export$fc6a25a0b4021903 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $87a6e7030c6a3200$var$iconBorder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwxKK))), props)), (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$var$SchemaGlyph));
const $87a6e7030c6a3200$var$ColumnsGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 6H2V8V20V22H4H7H9V20V19H7V20H4V8H5V6H4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 8H17V20H20V8ZM15 6V22H22V6H15Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 4H9V15H12V4ZM7 2V17H14V2H7Z",
        fill: "currentColor"
    }));
const $87a6e7030c6a3200$export$38f001d9cffdd080 = (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$var$ColumnsGlyph);
const $87a6e7030c6a3200$var$QrCodeGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 4V7H4V4H7V2H4H2V4ZM4 17H2V20V22H4H7V20H4V17ZM22 4V7H20V4H17V2H20H22V4ZM22 17H20V20H17V22H20H22V20V17ZM19 9H13V11H19V9ZM8 13H11V15H8V13ZM11 17H8V19H11V17ZM13 5H15V8H13V5ZM7 13H5V19H7V13ZM17 5H19V8H17V5ZM11 5H5V11H11V5ZM9 7H7V9H9V7ZM13 13H19V19H13V13ZM15 15H17V17H15V15Z",
        fill: "currentColor"
    }));
const $87a6e7030c6a3200$export$33dd147542b2195b = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($apaik))), {
        spacing: "spacious",
        ...props
    }), (0, $1aBwA.createCustomAKIcon)($87a6e7030c6a3200$var$QrCodeGlyph));
const $87a6e7030c6a3200$var$iconBorder = (0, $8CUq3.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'solid 1px',
    borderRadius: '3px',
    borderColor: 'color.border'
});

});
parcelRegister("iwxKK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2cf6d0b083efc7534cda00bbb519961>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7c565c5cbd5c490$var$_react = $d7c565c5cbd5c490$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d7c565c5cbd5c490$var$_baseNew = $d7c565c5cbd5c490$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d7c565c5cbd5c490$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for JSM Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d7c565c5cbd5c490$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $d7c565c5cbd5c490$var$_react.default.createElement($d7c565c5cbd5c490$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.25 7.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm0 0h-6m0-2.625v7c0 .69.56 1.25 1.25 1.25h4.75M5.75 3.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm7.5 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/>`
    }, props));
$d7c565c5cbd5c490$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $d7c565c5cbd5c490$var$_default = module.exports.default = $d7c565c5cbd5c490$var$AssetsSchemaIcon;

});

parcelRegister("apaik", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::065bae4da7c9b5223fe8a5a1ed3de3d0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79343976eae28bb9$var$_react = $79343976eae28bb9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $79343976eae28bb9$var$_baseNew = $79343976eae28bb9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $79343976eae28bb9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QrCode".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for QR code experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79343976eae28bb9$var$QrCodeIcon = (props)=>/*#__PURE__*/ $79343976eae28bb9$var$_react.default.createElement($79343976eae28bb9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 10h2v2h-2z"/><path stroke="currentcolor" stroke-width="1.5" d="M1.75 5.25V3c0-.69.56-1.25 1.25-1.25h2.25m9 3.5V3c0-.69-.56-1.25-1.25-1.25h-2.25m-9 9V13c0 .69.56 1.25 1.25 1.25h2.25m9-3.5V13c0 .69-.56 1.25-1.25 1.25h-2.25m-6.75-3h4M11.25 4v4m-6.5-3.25h3.5v3.5h-3.5z"/>`
    }, props));
$79343976eae28bb9$var$QrCodeIcon.displayName = 'QrCodeIcon';
var $79343976eae28bb9$var$_default = module.exports.default = $79343976eae28bb9$var$QrCodeIcon;

});

parcelRegister("1aBwA", function(module, exports) {

$parcel$export(module.exports, "createCustomAKIcon", () => $dfc3adae931a11a1$export$80e74912a0a07a42);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $dfc3adae931a11a1$export$80e74912a0a07a42 = (glyph)=>(props)=>// @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5LWLA.default), {
            glyph: glyph,
            ...props
        });

});


parcelRegister("fAOgz", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyForceGraph", () => $cb240ac26cab3a7b$export$786a65e3efaf54c3);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cb240ac26cab3a7b$var$LazyForceGraph = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("ke8JO")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/insight-common/insight-graphs/force-graph/src/ui/index.tsx"
});
const $cb240ac26cab3a7b$export$786a65e3efaf54c3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.jira-servicedesk-insight-graphs-force-graph",
        packageName: "atlassian/jira-servicedesk-insight-graphs-force-graph"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "iira-servicedesk-insight-graphs-force-graph",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb240ac26cab3a7b$var$LazyForceGraph, props)));

});
parcelRegister("ke8JO", function(module, exports) {

let $eb9be49b52839d3d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb9be49b52839d3d$var$load("10me3").then(()=>parcelRequire('3nx2S'));

});


const $50d8b5ecd71e7169$export$accaa52ddae3fe58 = 'node';
const $50d8b5ecd71e7169$export$7093ae9f18906e17 = 34;
const $50d8b5ecd71e7169$export$cf8a94c984678862 = 480;
const $50d8b5ecd71e7169$export$434d30b064b8d4cf = 120;

parcelRegister("3auAE", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SIDEBAR_WIDTH", () => $3b952ed34a08577d$export$444990cc7caeb4e0);
$parcel$export(module.exports, "usePushingSidebar", () => $3b952ed34a08577d$export$5ad0920cf30d9f08);

var $5uXOq = parcelRequire("5uXOq");
const $3b952ed34a08577d$export$444990cc7caeb4e0 = 300;
const $3b952ed34a08577d$export$5ad0920cf30d9f08 = ({ width: width = $3b952ed34a08577d$export$444990cc7caeb4e0, defaultIsOpen: defaultIsOpen = true })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const toggleSidebar = ()=>{
        setIsOpen((a)=>!a);
    };
    return [
        {
            isOpen: isOpen,
            sidebarWidth: width
        },
        {
            toggleSidebar: toggleSidebar
        }
    ];
};

});

parcelRegister("akFOk", function(module, exports) {

$parcel$export(module.exports, "PushingSidebarContainer", () => $3804a14defb30a65$export$7c3791d941a9e44f);
$parcel$export(module.exports, "PushingSidebar", () => $3804a14defb30a65$export$77de6aa1a2719891);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $itzrU = parcelRequire("itzrU");

var $lObw7 = parcelRequire("lObw7");

var $3auAE = parcelRequire("3auAE");
const $3804a14defb30a65$var$SidebarContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    sidebarWidth: 0,
    isOpen: true
});
const $3804a14defb30a65$export$7c3791d941a9e44f = ({ sidebarWidth: sidebarWidth = (0, $3auAE.DEFAULT_SIDEBAR_WIDTH), isOpen: isOpen, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3804a14defb30a65$var$SidebarContext.Provider, {
        value: {
            sidebarWidth: sidebarWidth,
            isOpen: isOpen
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3804a14defb30a65$var$SidebarContainerWrapper, {
        sidebarWidth: sidebarWidth,
        isOpen: isOpen
    }, props.children));
const $3804a14defb30a65$export$77de6aa1a2719891 = (props)=>{
    const { isOpen: isOpen, sidebarWidth: sidebarWidth } = (0, $5uXOq.useContext)($3804a14defb30a65$var$SidebarContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itzrU.default), {
        classNames: "pushing-sidebar-transition",
        in: isOpen,
        timeout: (0, $lObw7.mediumDurationMs),
        unmountOnExit: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3804a14defb30a65$var$SidebarWrapper, {
        width: sidebarWidth
    }, props.children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3804a14defb30a65$var$SidebarContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, sidebarWidth: sidebarWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1pe7rvv": (0, $lD23V.default)(__cmplp.sidebarWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _v564zzy9 _kqswh2mm _4t3i1osq _m6k4l4pu",
            __cmplp.isOpen && "_u5f3pybg",
            __cmplp.className
        ])
    });
});
const $3804a14defb30a65$var$SidebarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641y37 _4t3i1osq _kqswstnw _154iidpf _1xi2idpf _1bsb1efm _kxovxwn4 _1p92z12g _1sctz12g _ig7mxwn4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("aEMJe", function(module, exports) {

$parcel$export(module.exports, "useObjectDetailsService", () => $083a319ecc4621e5$export$3a033196e5926e63);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $xJtdX = parcelRequire("xJtdX");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iN6n9 = parcelRequire("iN6n9");

var $6LsTI = parcelRequire("6LsTI");
const $083a319ecc4621e5$export$3a033196e5926e63 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const request = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'objectId' implicitly has an 'any' type. | TS7031 - Binding element 'workspaceId' implicitly has an 'any' type.
    ({ objectId: objectId, workspaceId: workspaceId })=>(0, $eusud.performGetRequest)((0, $iN6n9.getObjectDetailsUrl)(workspaceId, objectId)).then((0, $6LsTI.transformInsightServiceObjectToCmdbObjectResponse)).then((0, $6LsTI.transformBackendValueToCmdbObject)).then((cmdbObject)=>{
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchObjectDetails succeeded');
            return cmdbObject;
        }).catch((error)=>{
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'fetchObjectDetails',
                    packageName: 'jiraServicedeskInsightObjectServices',
                    teamName: 'falcons'
                }
            });
            throw error;
        }), [
        createAnalyticsEvent
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchObjectDetails } = (0, $ld2hZ.useService)(request);
    return [
        {
            loading: loading,
            error: error,
            data: data
        },
        fetchObjectDetails
    ];
};

});
parcelRegister("6LsTI", function(module, exports) {

$parcel$export(module.exports, "transformInsightServiceObjectToCmdbObjectResponse", () => $5816d28f674c32a4$export$46b3c44950ea286c);
$parcel$export(module.exports, "transformBackendValueToCmdbObject", () => $5816d28f674c32a4$export$4fd59ae692c47f18);
$parcel$export(module.exports, "reduceObjectTypesByParentObjectTypeId", () => $5816d28f674c32a4$export$40eb52787b32816b);

var $aqMUn = parcelRequire("aqMUn");

var $5Ny9E = parcelRequire("5Ny9E");
const $5816d28f674c32a4$export$46b3c44950ea286c = (object)=>{
    const attributes = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    object?.attributes?.map((attribute)=>({
            ...attribute,
            objectAttributeValues: // eslint-disable-next-line @typescript-eslint/no-explicit-any
            attribute?.objectAttributeValues?.map((value)=>{
                // Remaps the keys used for IDs slightly in 'object' type attributes
                if (attribute?.objectTypeAttribute?.type === 1) return {
                    ...value,
                    referencedObject: {
                        ...value?.referencedObject,
                        objectId: value?.referencedObject?.id,
                        id: value?.referencedObject?.globalId
                    }
                };
                return value;
            }) ?? []
        })) ?? [];
    return {
        ...object,
        attributes: attributes
    };
};
const $5816d28f674c32a4$export$4fd59ae692c47f18 = (object)=>{
    const attributes = object.attributes.map((attribute)=>{
        const castAttr = (0, $aqMUn.toObjectTypeAttribute)(attribute);
        return {
            ...castAttr,
            type: castAttr.objectTypeAttribute.type
        };
    });
    return {
        ...object,
        attributes: // @ts-expect-error - TS2322 - Type '({ type: 0 | 1 | 2 | 4 | 7; id: string; objectTypeAttributeId: string; objectTypeAttribute: CmdbObjectTypeAttributeDefault; objectAttributeValues: CmdbObjectAttributeValueDefault[]; } | { ...; } | { ...; } | { ...; } | { ...; })[]' is not assignable to type 'CmdbObjectAttribute[]'.
        attributes
    };
};
const $5816d28f674c32a4$export$40eb52787b32816b = (objectTypes)=>objectTypes.sort((a, b)=>Number(a.id) > Number(b.id) ? 1 : -1).reduce((entries, { id: objectTypeId, name: name, icon: icon, position: position, parentObjectTypeId: parentObjectTypeId })=>{
        const objectType = {
            id: (0, $5Ny9E.toCmdbObjectTypeId)(objectTypeId),
            name: name,
            icon: icon,
            position: position,
            parentObjectTypeId: parentObjectTypeId ?? null
        };
        if (objectType.parentObjectTypeId == null) {
            entries.push(objectType);
            return entries;
        }
        const newEntries = [];
        const index = entries.findIndex(({ id: id })=>id === parentObjectTypeId);
        entries.slice(0, index + 1).forEach((entry)=>{
            newEntries.push(entry);
        });
        newEntries.push(objectType);
        entries.slice(index + 1).forEach((entry)=>{
            newEntries.push(entry);
        });
        return newEntries;
    }, []);

});
parcelRegister("aqMUn", function(module, exports) {

$parcel$export(module.exports, "toObjectTypeAttribute", () => $8050a58b407fa1d6$export$43d7501448d7c10);
const $8050a58b407fa1d6$export$43d7501448d7c10 = (attr)=>{
    switch(attr.type){
        case 0:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 1:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 2:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 4:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 6:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 7:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 8:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        case 9:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
        default:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return attr;
    }
};

});



parcelRegister("1G6xC", function(module, exports) {

$parcel$export(module.exports, "useObjectGraphService", () => $6da2bec970998c68$export$8c33c1bca444013f);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $xJtdX = parcelRequire("xJtdX");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gJYel = parcelRequire("gJYel");
const $6da2bec970998c68$var$getObjectGraphUrl = (workspaceId, objectId, depth, maxOfSameType)=>{
    if (depth !== undefined && maxOfSameType !== undefined) return (0, $gJYel.getCmdbGraphObjectUrl)(workspaceId, objectId, {
        depth: depth,
        maxOfSameType: maxOfSameType
    });
    return (0, $gJYel.getCmdbGraphObjectUrl)(workspaceId, objectId);
};
const $6da2bec970998c68$export$8c33c1bca444013f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const request = (0, $5uXOq.useCallback)(({ objectId: objectId, workspaceId: workspaceId, depth: depth, maxOfSameType: maxOfSameType })=>(0, $eusud.performGetRequest)($6da2bec970998c68$var$getObjectGraphUrl(workspaceId, objectId, depth, maxOfSameType)).then((res)=>{
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchObjectGraphData succeeded');
            return res;
        }).catch((error)=>{
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'fetchObjectGraphData',
                    packageName: 'jiraServicedeskInsightObjectServices',
                    teamName: 'falcons'
                }
            });
            throw error;
        }), [
        createAnalyticsEvent
    ]);
    const { loading: loading, error: error, data: data, fetch: fetchObjectGraph } = (0, $ld2hZ.useService)(request);
    return [
        {
            loading: loading,
            error: error,
            data: data
        },
        fetchObjectGraph
    ];
};

});
parcelRegister("gJYel", function(module, exports) {

$parcel$export(module.exports, "getCmdbGraphObjectUrl", () => $66d7a218b074aa12$export$e3a43687445755b9);
$parcel$export(module.exports, "getCmdbGraphObjectTypeUrl", () => $66d7a218b074aa12$export$2426d7acfd257162);
$parcel$export(module.exports, "getCmdbGraphSchemaUrl", () => $66d7a218b074aa12$export$78524cf396d011ad);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/graph
 */ const $66d7a218b074aa12$var$getCmdbGraphUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/graph`;
const $66d7a218b074aa12$export$e3a43687445755b9 = (workspaceId, objectId, queryParams)=>`${$66d7a218b074aa12$var$getCmdbGraphUrl(workspaceId)}/object/${objectId}${queryParams ? `?${(0, $ebyGx.stringify)(queryParams)}` : ''}`;
const $66d7a218b074aa12$export$2426d7acfd257162 = (workspaceId, objectId, queryParams)=>`${$66d7a218b074aa12$var$getCmdbGraphUrl(workspaceId)}/objecttype/${objectId}${queryParams ? `?${(0, $ebyGx.stringify)(queryParams)}` : ''}`;
const $66d7a218b074aa12$export$78524cf396d011ad = (workspaceId, schemaId)=>`${$66d7a218b074aa12$var$getCmdbGraphUrl(workspaceId)}/objectschema/${schemaId}`;

});


parcelRegister("jni3N", function(module, exports) {

$parcel$export(module.exports, "GRAPH_NODE_TYPES", () => $8bafd6a156ae9b74$export$172900d1bc4220d9);
const $8bafd6a156ae9b74$var$OBJECT_GRAPH_NODE_TYPE = 'O';
const $8bafd6a156ae9b74$var$OBJECT_TYPE_GRAPH_NODE_TYPE = 'T';
const $8bafd6a156ae9b74$export$172900d1bc4220d9 = Object.freeze({
    OBJECT: $8bafd6a156ae9b74$var$OBJECT_GRAPH_NODE_TYPE,
    OBJECT_TYPE: $8bafd6a156ae9b74$var$OBJECT_TYPE_GRAPH_NODE_TYPE
});

});

parcelRegister("cJWnf", function(module, exports) {

$parcel$export(module.exports, "useObjectGraphConfiguration", () => $91e9f26c72cad69a$export$7d92b63999f03c61);

var $5uXOq = parcelRequire("5uXOq");

var $68d8D = parcelRequire("68d8D");

var $8ncYk = parcelRequire("8ncYk");
const $91e9f26c72cad69a$var$getDefaultConfiguration = ()=>({
        // controls how many degrees of separation of nodes to show based on the initial object
        referenceDepth: 1,
        // controls the amount of inbound nodes of a particular object type before merging them as a single node
        maxOfSameType: 10
    });
const $91e9f26c72cad69a$var$getMaxReferenceDepth = ()=>5;
const $91e9f26c72cad69a$var$getMaxOfSameType = ()=>50;
const $91e9f26c72cad69a$export$7d92b63999f03c61 = (objectGraphData, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
initialObjectTypeId)=>{
    const [configuration, setConfiguration] = (0, $5uXOq.useState)(()=>({
            ...(0, $68d8D.getGraphConfigurationLocalStorage)() ?? $91e9f26c72cad69a$var$getDefaultConfiguration(),
            referenceTypes: []
        }));
    // re-generate the reference type filters whenever the graph data updates
    (0, $5uXOq.useEffect)(()=>{
        const { nodes: nodes = [], edges: edges = [] } = objectGraphData ?? {};
        const referenceTypes = (0, $8ncYk.getReferenceTypes)({
            nodes: // @ts-expect-error - TS2322 - Type 'Node[]' is not assignable to type 'ReactNode[]'.
            nodes,
            edges: edges,
            initialObjectTypeId: initialObjectTypeId,
            referenceDepth: configuration.referenceDepth
        });
        setConfiguration((config)=>({
                ...config,
                referenceTypes: referenceTypes
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        configuration.referenceDepth,
        objectGraphData
    ]); // we don't want to listen for changes to initialObjectTypeId here
    const updateReferenceTypes = (0, $5uXOq.useCallback)((updated)=>{
        (0, $68d8D.setReferenceCheckedLocalStorage)({
            objectTypeId: initialObjectTypeId,
            referenceLabel: updated.label,
            updatedValue: updated.checked
        });
        setConfiguration((config)=>({
                ...config,
                referenceTypes: config.referenceTypes.map((r)=>r.label === updated.label ? updated : r)
            }));
    }, [
        initialObjectTypeId
    ]);
    const updateReferenceDepth = (0, $5uXOq.useCallback)((updatedReferenceDepth)=>{
        if (updatedReferenceDepth >= 1 && updatedReferenceDepth <= $91e9f26c72cad69a$var$getMaxReferenceDepth()) {
            (0, $68d8D.setGraphConfigurationLocalStorage)({
                referenceDepth: updatedReferenceDepth,
                maxOfSameType: configuration.maxOfSameType
            });
            setConfiguration((config)=>({
                    ...config,
                    referenceDepth: updatedReferenceDepth
                }));
        }
    }, [
        configuration
    ]);
    const updateMaxOfSameType = (0, $5uXOq.useCallback)((updatedMaxOfSameType)=>{
        if (updatedMaxOfSameType >= 1 && updatedMaxOfSameType <= $91e9f26c72cad69a$var$getMaxOfSameType()) {
            (0, $68d8D.setGraphConfigurationLocalStorage)({
                referenceDepth: configuration.referenceDepth,
                maxOfSameType: updatedMaxOfSameType
            });
            setConfiguration((config)=>({
                    ...config,
                    maxOfSameType: updatedMaxOfSameType
                }));
        }
    }, [
        configuration
    ]);
    return [
        configuration,
        {
            updateReferenceDepth: updateReferenceDepth,
            updateMaxOfSameType: updateMaxOfSameType,
            updateReferenceTypes: updateReferenceTypes
        }
    ];
};

});
parcelRegister("68d8D", function(module, exports) {

$parcel$export(module.exports, "getGraphConfigurationLocalStorage", () => $68f54c83be3ed881$export$43af2d54030d43b1);
$parcel$export(module.exports, "setGraphConfigurationLocalStorage", () => $68f54c83be3ed881$export$957c0561e5b0dd2d);
$parcel$export(module.exports, "getReferenceCheckedLocalStorage", () => $68f54c83be3ed881$export$e2f6fac45be157c1);
$parcel$export(module.exports, "setReferenceCheckedLocalStorage", () => $68f54c83be3ed881$export$a6fb5b32429a9337);

var $dJl1T = parcelRequire("dJl1T");

var $4R6GH = parcelRequire("4R6GH");

var $bSSG7 = parcelRequire("bSSG7");
/**
 *
 * The legacy insight UI currently relies on localStorage to persist a lot of shared state
 * This module exists to be able to read that data to populate areas of the UI we have re-written in React.
 * We want to migrate away from the reliance on localStorage and over time we can delete the functions in this file.
 *
 */ const $68f54c83be3ed881$var$OBJECT_GRAPH_CONFIGURATION_KEY_OLD = 'rlabs.rlabs-graph-configuration-object';
const $68f54c83be3ed881$var$OBJECT_GRAPH_CONFIGURATION_KEY = 'objectGraphConfiguration';
const $68f54c83be3ed881$export$ddcffe0146c8f882 = (0, $bSSG7.createLocalStorageProvider)('jsm-cmdb-object-graph');
const $68f54c83be3ed881$var$getGraphConfigurationLocalStorageOld = ()=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.localStorage) {
            // this will be available if users configure the object graph via the legacy UI
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const graphConfig = window.localStorage.getItem($68f54c83be3ed881$var$OBJECT_GRAPH_CONFIGURATION_KEY_OLD);
            if (graphConfig) {
                const { referenceDepth: referenceDepth, maxOfSameType: maxOfSameType } = JSON.parse(graphConfig);
                return {
                    referenceDepth: referenceDepth,
                    maxOfSameType: maxOfSameType
                };
            }
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('rlabs.localStorage.error', `Unable to get rlabs graph configuration in localStorage with error: ${error.toString()}`);
    }
    return undefined;
};
const $68f54c83be3ed881$var$getGraphConfigurationLocalStorageNew = ()=>{
    try {
        const graphConfig = $68f54c83be3ed881$export$ddcffe0146c8f882.get($68f54c83be3ed881$var$OBJECT_GRAPH_CONFIGURATION_KEY);
        if (graphConfig) {
            const { referenceDepth: referenceDepth, maxOfSameType: maxOfSameType } = JSON.parse(graphConfig);
            return {
                referenceDepth: referenceDepth,
                maxOfSameType: maxOfSameType
            };
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
const $68f54c83be3ed881$export$43af2d54030d43b1 = ()=>(0, $4R6GH.fg)('assets_storage_migration') ? $68f54c83be3ed881$var$getGraphConfigurationLocalStorageNew() : $68f54c83be3ed881$var$getGraphConfigurationLocalStorageOld();
const $68f54c83be3ed881$var$setGraphConfigurationLocalStorageOld = (updatedConfig)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.localStorage) {
            const existingConfig = $68f54c83be3ed881$export$43af2d54030d43b1();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.localStorage.setItem($68f54c83be3ed881$var$OBJECT_GRAPH_CONFIGURATION_KEY_OLD, JSON.stringify({
                ...existingConfig,
                ...updatedConfig
            }));
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('rlabs.localStorage.error', `Unable to set rlabs graph configuration in localStorage with error: ${error.toString()}`);
    }
};
const $68f54c83be3ed881$var$setGraphConfigurationLocalStorageNew = (updatedConfig)=>{
    const existingConfig = $68f54c83be3ed881$export$43af2d54030d43b1();
    $68f54c83be3ed881$export$ddcffe0146c8f882.set($68f54c83be3ed881$var$OBJECT_GRAPH_CONFIGURATION_KEY, JSON.stringify({
        ...existingConfig,
        ...updatedConfig
    }));
};
const $68f54c83be3ed881$export$957c0561e5b0dd2d = (updatedConfig)=>(0, $4R6GH.fg)('assets_storage_migration') ? $68f54c83be3ed881$var$setGraphConfigurationLocalStorageNew(updatedConfig) : $68f54c83be3ed881$var$setGraphConfigurationLocalStorageOld(updatedConfig);
const $68f54c83be3ed881$var$getReferenceCheckedLocalStorageOld = ({ objectTypeId: objectTypeId, referenceLabel: referenceLabel })=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.localStorage) {
            const key = `rlabs.rlabs-graph-objectType${objectTypeId}-reference${referenceLabel}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const isChecked = window.localStorage.getItem(key);
            // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            return JSON.parse(isChecked);
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('rlabs.localStorage.error', `Unable to get rlabs graph configuration in localStorage with error: ${error.toString()}`);
    }
    return undefined;
};
const $68f54c83be3ed881$var$getReferenceCheckedLocalStorageNew = ({ objectTypeId: objectTypeId, referenceLabel: referenceLabel })=>{
    try {
        const isChecked = $68f54c83be3ed881$export$ddcffe0146c8f882.get(`objectType${objectTypeId}-reference${referenceLabel}`);
        return JSON.parse(isChecked);
    } catch (error) {
        return undefined;
    }
};
const $68f54c83be3ed881$export$e2f6fac45be157c1 = ({ objectTypeId: objectTypeId, referenceLabel: referenceLabel })=>(0, $4R6GH.fg)('assets_storage_migration') ? $68f54c83be3ed881$var$getReferenceCheckedLocalStorageNew({
        objectTypeId: objectTypeId,
        referenceLabel: referenceLabel
    }) : $68f54c83be3ed881$var$getReferenceCheckedLocalStorageOld({
        objectTypeId: objectTypeId,
        referenceLabel: referenceLabel
    });
const $68f54c83be3ed881$var$setReferenceCheckedLocalStorageOld = ({ objectTypeId: objectTypeId, referenceLabel: referenceLabel, updatedValue: updatedValue })=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.localStorage) {
            const key = `rlabs.rlabs-graph-objectType${objectTypeId}-reference${referenceLabel}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.localStorage.setItem(key, JSON.stringify(updatedValue));
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dJl1T.default).safeErrorWithoutCustomerData('rlabs.localStorage.error', `Unable to set rlabs graph configuration in localStorage with error: ${error.toString()}`);
    }
    return undefined;
};
const $68f54c83be3ed881$var$setReferenceCheckedLocalStorageNew = ({ objectTypeId: objectTypeId, referenceLabel: referenceLabel, updatedValue: updatedValue })=>{
    $68f54c83be3ed881$export$ddcffe0146c8f882.set(`objectType${objectTypeId}-reference${referenceLabel}`, JSON.stringify(updatedValue));
};
const $68f54c83be3ed881$export$a6fb5b32429a9337 = ({ objectTypeId: objectTypeId, referenceLabel: referenceLabel, updatedValue: updatedValue })=>(0, $4R6GH.fg)('assets_storage_migration') ? $68f54c83be3ed881$var$setReferenceCheckedLocalStorageNew({
        objectTypeId: objectTypeId,
        referenceLabel: referenceLabel,
        updatedValue: updatedValue
    }) : $68f54c83be3ed881$var$setReferenceCheckedLocalStorageOld({
        objectTypeId: objectTypeId,
        referenceLabel: referenceLabel,
        updatedValue: updatedValue
    });

});

parcelRegister("8ncYk", function(module, exports) {

$parcel$export(module.exports, "getReferenceTypes", () => $21f83f034c785a48$export$7cc38071d2ea10f2);

var $68d8D = parcelRequire("68d8D");
const $21f83f034c785a48$var$getReferenceCheckedState = (objectTypeId, referenceLabel, showByDefault)=>{
    const defaultCheckedState = showByDefault ?? true;
    return (0, $68d8D.getReferenceCheckedLocalStorage)({
        objectTypeId: objectTypeId,
        referenceLabel: referenceLabel
    }) ?? defaultCheckedState;
};
const $21f83f034c785a48$export$7cc38071d2ea10f2 = ({ nodes: nodes, edges: edges, referenceDepth: referenceDepth, initialObjectTypeId: initialObjectTypeId })=>{
    // we accumulate a set of reference types that store all edges between nodes that are associated with that reference
    // this is used render nodes / edges in the graph and to filter out nodes in the graph based on whether the reference type is checked or not
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const referenceTypes = edges.reduce((referenceTypeList, edge)=>{
        const reference = {
            label: edge.label,
            color: edge.color,
            from: [
                edge.from
            ],
            to: [
                edge.to
            ],
            checked: true,
            count: 1
        };
        // for each edge we validate the node/s it connects are valid before associating it with a reference
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'id' does not exist on type 'boolean | ReactChild | ReactFragment | ReactPortal'.
        const hasSourceNode = nodes.some((n)=>n.id === edge.from.slice(1));
        const hasDestinationNode = nodes.some(// @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'id' does not exist on type 'boolean | ReactChild | ReactFragment | ReactPortal'. | TS2533 - Object is possibly 'null' or 'undefined'. | TS2339 - Property 'depth' does not exist on type 'boolean | ReactChild | ReactFragment | ReactPortal'.
        (n)=>n.id === edge.to.slice(1) && n.depth <= referenceDepth);
        const isValidEdge = hasDestinationNode && hasSourceNode;
        const existingReference = referenceTypeList.find((r)=>r.label === reference.label);
        if (existingReference && isValidEdge) {
            existingReference.from.push(edge.from);
            existingReference.to.push(edge.to);
            existingReference.count += 1;
            existingReference.checked = $21f83f034c785a48$var$getReferenceCheckedState(initialObjectTypeId, edge.label, existingReference.count < 10);
        } else if (isValidEdge) {
            reference.checked = $21f83f034c785a48$var$getReferenceCheckedState(initialObjectTypeId, edge.label);
            referenceTypeList.push(reference);
        }
        return referenceTypeList;
    }, []);
    return referenceTypes;
};

});


parcelRegister("jAGT1", function(module, exports) {

$parcel$export(module.exports, "useSelectedNode", () => $1af90cda764f988b$export$aa8f1c72cfda8469);

var $5uXOq = parcelRequire("5uXOq");

var $jni3N = parcelRequire("jni3N");
const $1af90cda764f988b$export$aa8f1c72cfda8469 = (initialObjectId)=>{
    const [selectedNode, setSelectedNode] = (0, $5uXOq.useState)({
        type: (0, $jni3N.GRAPH_NODE_TYPES).OBJECT,
        nodeId: (0, $jni3N.GRAPH_NODE_TYPES).OBJECT + initialObjectId,
        referenceId: initialObjectId
    });
    const setSelectedObjectNode = (0, $5uXOq.useCallback)((objectId)=>{
        setSelectedNode({
            type: (0, $jni3N.GRAPH_NODE_TYPES).OBJECT,
            nodeId: (0, $jni3N.GRAPH_NODE_TYPES).OBJECT + objectId,
            referenceId: objectId
        });
    }, []);
    const setSelectedObjectTypeNode = (0, $5uXOq.useCallback)((node)=>{
        setSelectedNode({
            type: (0, $jni3N.GRAPH_NODE_TYPES).OBJECT_TYPE,
            nodeId: (0, $jni3N.GRAPH_NODE_TYPES).OBJECT_TYPE + node.id,
            referenceId: node.id,
            objectSchemaId: node.objectSchemaId ?? '',
            icon: node.icon,
            name: node.name
        });
    }, []);
    return [
        selectedNode,
        {
            setSelectedObjectNode: setSelectedObjectNode,
            setSelectedObjectTypeNode: setSelectedObjectTypeNode
        }
    ];
};

});

parcelRegister("g245j", function(module, exports) {

$parcel$export(module.exports, "ActionsButton", () => $45719431dbe8a4d5$export$548aa330bf01a877);
$parcel$export(module.exports, "Actions", () => $45719431dbe8a4d5$export$b52183d5cfb26dc9);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $3bDjY = parcelRequire("3bDjY");
const $45719431dbe8a4d5$export$548aa330bf01a877 = (props)=>{
    const { label: label, Icon: Icon, triggerRef: triggerRef, iconSpacing: iconSpacing, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: triggerRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            label: label,
            spacing: iconSpacing
        }),
        ...rest
    }));
};
const $45719431dbe8a4d5$export$b52183d5cfb26dc9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45719431dbe8a4d5$var$Wrapper, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45719431dbe8a4d5$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154ize3t _1xi2ze3t _1e0c1txw _19pkutpp _2hwxpxbi _otyrutpp _18u0pxbi _1yp8utpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("koaLx", function(module, exports) {

$parcel$export(module.exports, "GraphConfigurationActionPanel", () => $2de6361039029fc0$export$f028fcb976898610);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $BLPHT = parcelRequire("BLPHT");

var $7CMCs = parcelRequire("7CMCs");
const $2de6361039029fc0$export$f028fcb976898610 = ({ menuPosition: menuPosition, renderActionButton: renderActionButton, children: children, isConfigPanelOpen: isConfigPanelOpen, onOpenChange: onOpenChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "object-graph-configuration-panel",
        packageName: "jiraServicedeskInsightObjectGraph",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2de6361039029fc0$var$DropdownContainer, {
        onClick: (e)=>e.stopPropagation(),
        role: "button",
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isOpen: isConfigPanelOpen,
        onOpenChange: (args)=>{
            onOpenChange(args.isOpen);
        },
        zIndex: 1000,
        trigger: renderActionButton,
        shouldFlip: false,
        placement: `bottom-${menuPosition === 'left' ? 'start' : 'end'}`,
        appearance: "tall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2de6361039029fc0$var$ContentContainer, null, children))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2de6361039029fc0$var$DropdownContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1n1u1wug _nz6r1wug _1nyh1kdj",
            __cmplp.className
        ])
    });
});
const $2de6361039029fc0$var$ContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi _2hwxpxbi _otyrpxbi _18u0pxbi _p12f1b1j",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1vkRZ", function(module, exports) {

$parcel$export(module.exports, "ReferenceDepthConfigurationInputs", () => $19f33832cbe04605$export$1a7cfc9d06ab35e3);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $6Ingq = parcelRequire("6Ingq");

var $cgL5K = parcelRequire("cgL5K");

var $kY99m = parcelRequire("kY99m");

var $koVbs = parcelRequire("koVbs");

var $bsBRa = parcelRequire("bsBRa");
const $19f33832cbe04605$export$a77796dd088d9f7d = ({ value: value, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const referenceDepthOptions = Array.from(Array(5), (_, i)=>i + 1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        zIndex: 1000,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))), {
                    label: "down icon"
                }),
                testId: "servicedesk-insight-object-graph.ui.graph-config-panel.reference-depth-inputs.trigger-button"
            }, value),
        appearance: "tall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, referenceDepthOptions.map((depth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19f33832cbe04605$var$DropdownItemWrapper, {
            key: depth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: ()=>onChange(depth),
            testId: "servicedesk-insight-object-graph.ui.graph-config-panel.reference-depth-inputs.depth-option"
        }, formatMessage((0, $bsBRa.default)[depth]))))));
};
const $19f33832cbe04605$export$4b100b07e5f29926 = ({ value: value, onChange: onChange })=>{
    const [internalValue, setInternalValue] = (0, $5uXOq.useState)(value);
    const debouncedOnChange = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onChange, 200), [
        onChange
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setInternalValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        testId: "servicedesk-insight-object-graph.ui.graph-config-panel.reference-depth-inputs.max-of-same-type",
        type: "number",
        autoComplete: "off",
        min: 1,
        max: 50,
        value: internalValue,
        onChange: (event)=>{
            // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'EventTarget'.
            const { value: updated } = event.target;
            const newValue = Number(updated);
            setInternalValue(newValue);
            debouncedOnChange(newValue);
        }
    });
};
const $19f33832cbe04605$export$1a7cfc9d06ab35e3 = (props)=>{
    const { maxOfSameType: maxOfSameType, referenceDepth: referenceDepth, onUpdateReferenceDepth: onUpdateReferenceDepth, onUpdateMaxOfSameType: onUpdateMaxOfSameType } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19f33832cbe04605$var$InputContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19f33832cbe04605$var$LabelText, null, formatMessage((0, $bsBRa.default).referenceDepthLabel), ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19f33832cbe04605$export$a77796dd088d9f7d, {
        value: referenceDepth,
        onChange: onUpdateReferenceDepth
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19f33832cbe04605$var$InputContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19f33832cbe04605$var$LabelText, null, formatMessage((0, $bsBRa.default).inboundReferencesLabel), ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19f33832cbe04605$var$InboundReferencesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($19f33832cbe04605$export$4b100b07e5f29926, {
        value: maxOfSameType,
        onChange: onUpdateMaxOfSameType
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p",
        size: "UNSAFE_small"
    }, formatMessage((0, $bsBRa.default).helpText)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $19f33832cbe04605$var$InputContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _otyru2gc _p12fuuw1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $19f33832cbe04605$var$DropdownItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $19f33832cbe04605$var$LabelText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $19f33832cbe04605$var$InboundReferencesContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_rff01wqb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bsBRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a14c01d21c1a125$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5a14c01d21c1a125$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    referenceDepthLabel: {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.reference-depth-label",
        "defaultMessage": "Reference depth"
    },
    inboundReferencesLabel: {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.inbound-references-label",
        "defaultMessage": "Inbound references"
    },
    helpText: {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.help-text",
        "defaultMessage": "The maximum number of inbound references from the same object type, before grouping them as a single node."
    },
    '1': {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.1",
        "defaultMessage": "1"
    },
    '2': {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.2",
        "defaultMessage": "2"
    },
    '3': {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.3",
        "defaultMessage": "3"
    },
    '4': {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.4",
        "defaultMessage": "4"
    },
    '5': {
        "id": "servicedesk-insight-object-graph.graph-config-panel.reference-depth-inputs.5",
        "defaultMessage": "5"
    }
});

});


parcelRegister("2SKu4", function(module, exports) {

$parcel$export(module.exports, "ReferenceTypeToggleList", () => $da6639ffe7709ba4$export$aa0ca936e7260336);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kkJfY = parcelRequire("kkJfY");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $da6639ffe7709ba4$export$aa0ca936e7260336 = (props)=>{
    const { referenceTypes: referenceTypes, onChange: onChange } = props;
    const onToggleReferenceType = (referenceTypeToUpdate)=>{
        const updatedReferenceType = {
            ...referenceTypeToUpdate,
            checked: !referenceTypeToUpdate.checked
        };
        onChange(updatedReferenceType);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $da6639ffe7709ba4$var$containerStyles
    }, referenceTypes.map((rt)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da6639ffe7709ba4$var$InputContainer, {
            key: rt.label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
            isChecked: rt.checked,
            onChange: ()=>onToggleReferenceType(rt),
            testId: `servicedesk-insight-object-graph.ui.graph-config-panel.reference-types-toggle-list.checkbox-${rt.label}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da6639ffe7709ba4$var$ColorCircle, {
            color: rt.color
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($da6639ffe7709ba4$var$LabelText, null, rt.label))));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $da6639ffe7709ba4$var$ColorCircle = ({ color: color, children: children })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $da6639ffe7709ba4$var$colorCircleStyles,
            (0, $8CUq3.xcss)({
                backgroundColor: color
            })
        ]
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da6639ffe7709ba4$var$LabelText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $da6639ffe7709ba4$var$InputContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _otyru2gc _slp31hna _1i4q1hna _1nmz1hna",
            __cmplp.className
        ])
    });
});
const $da6639ffe7709ba4$var$containerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.200'
});
const $da6639ffe7709ba4$var$colorCircleStyles = (0, $8CUq3.xcss)({
    height: '28px',
    minWidth: '28px',
    borderRadius: 'border.radius.circle'
});
const $da6639ffe7709ba4$export$7ed12d2a5241e393 = {
    ColorCircle: $da6639ffe7709ba4$var$ColorCircle,
    LabelText: $da6639ffe7709ba4$var$LabelText
};

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");


var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $3106eb14f9b0a593$var$checkboxStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $3106eb14f9b0a593$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $kag1C.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hsLv2.default), null, label, isRequired && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $e62YQ.default), null)));
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $f8Sb3.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
    (0, $VSDnB.fg)('platform-visual-refresh-icons') && (0, $VSDnB.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5"
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $7b368d644c230660$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $7b368d644c230660$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $7b368d644c230660$var$disabledStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $7b368d644c230660$var$labelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $7b368d644c230660$var$baseStyles,
            label && $7b368d644c230660$var$textLabelLayoutStyles,
            isDisabled && $7b368d644c230660$var$disabledStyles,
            $7b368d644c230660$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ce636d67b4ff1120$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $ce636d67b4ff1120$var$labelTextStyles
    }, children);
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $d2156c28a3894cac$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $d2156c28a3894cac$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*"));
}

});



parcelRegister("3jZB1", function(module, exports) {

$parcel$export(module.exports, "GraphError", () => $c8bf7113631b1fbc$export$7314831ac2fea5d8);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hTEpF = parcelRequire("hTEpF");

var $bTyOW = parcelRequire("bTyOW");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $hkWca = parcelRequire("hkWca");
const $c8bf7113631b1fbc$export$7314831ac2fea5d8 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderImage = ()=>(0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default))({
            imageWidth: 120,
            maxImageWidth: 120,
            maxImageHeight: 212
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c8bf7113631b1fbc$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $hkWca.default).errorTitle),
        description: formatMessage((0, $hkWca.default).errorDescription),
        renderImage: renderImage
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8bf7113631b1fbc$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _j1pnusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hkWca", function(module, exports) {

$parcel$export(module.exports, "default", () => $17863dfcfd87d724$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $17863dfcfd87d724$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "servicedesk-insight-object-graph.graph-error.error-title",
        "defaultMessage": "Failed to load graph"
    },
    errorDescription: {
        "id": "servicedesk-insight-object-graph.graph-error.error-description",
        "defaultMessage": "Please refresh the page and try again."
    }
});

});


parcelRegister("7Nkr2", function(module, exports) {

$parcel$export(module.exports, "GraphHeader", () => $2b36a0ead2a19fe9$export$deaeec1bb8f9bce8);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $lLLkM = parcelRequire("lLLkM");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");


var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $7mJJY = parcelRequire("7mJJY");
const $2b36a0ead2a19fe9$var$HEADER_HEIGHT = (0, $gwIPs.gridSize) * 9; // 72px
const $2b36a0ead2a19fe9$export$deaeec1bb8f9bce8 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2b36a0ead2a19fe9$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2b36a0ead2a19fe9$var$Title, null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $7mJJY.default).closeLabel),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2b36a0ead2a19fe9$var$closeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))), {
            primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N500})`,
            label: formatMessage((0, $7mJJY.default).closeLabel)
        }),
        onClick: props.onClose,
        testId: "servicedesk-insight-object-graph.ui.graph-header.button-close"
    }))));
};
const $2b36a0ead2a19fe9$var$Wrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        xcss: $2b36a0ead2a19fe9$var$wrapperNewStyles
    }, children);
const $2b36a0ead2a19fe9$var$Title = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $2b36a0ead2a19fe9$var$titleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "medium",
        as: "h1"
    }, children));
const $2b36a0ead2a19fe9$var$closeButtonStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.200'
});
const $2b36a0ead2a19fe9$var$wrapperNewStyles = (0, $8CUq3.xcss)({
    boxSizing: 'border-box',
    padding: 'space.300',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `2px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$2b36a0ead2a19fe9$var$HEADER_HEIGHT}px`
});
const $2b36a0ead2a19fe9$var$titleStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    margin: 'space.0',
    flexGrow: '1',
    marginTop: 'space.050',
    paddingBottom: 'space.050',
    fontWeight: 'font.weight.regular'
});

});
parcelRegister("7mJJY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1700df0ffb73dce9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1700df0ffb73dce9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    closeLabel: {
        "id": "servicedesk-insight-object-graph.graph-header.close-label",
        "defaultMessage": "Close"
    }
});

});


parcelRegister("e7PRu", function(module, exports) {

$parcel$export(module.exports, "default", () => $38760d74fb1f9773$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $38760d74fb1f9773$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "servicedesk-insight-object-graph.title",
        "defaultMessage": "Object details"
    },
    showDetail: {
        "id": "servicedesk-insight-object-graph.show-detail",
        "defaultMessage": "Show object details panel"
    },
    hideDetail: {
        "id": "servicedesk-insight-object-graph.hide-detail",
        "defaultMessage": "Hide object details panel"
    },
    lockLayout: {
        "id": "servicedesk-insight-object-graph.lock-layout",
        "defaultMessage": "Lock node layout"
    },
    unlockLayout: {
        "id": "servicedesk-insight-object-graph.unlock-layout",
        "defaultMessage": "Unlock node layout"
    },
    showGraphConfigPanel: {
        "id": "servicedesk-insight-object-graph.show-graph-config-panel",
        "defaultMessage": "Show graph configuration"
    },
    hideGraphConfigPanel: {
        "id": "servicedesk-insight-object-graph.hide-graph-config-panel",
        "defaultMessage": "Hide graph configuration"
    },
    graphConfigPanelHeader: {
        "id": "servicedesk-insight-object-graph.graph-config-panel-header",
        "defaultMessage": "Graph configuration"
    },
    referenceTypesHeader: {
        "id": "servicedesk-insight-object-graph.reference-types-header",
        "defaultMessage": "Reference types"
    }
});

});

parcelRegister("3nJmO", function(module, exports) {

$parcel$export(module.exports, "ObjectTypeView", () => $648d031066c15d33$export$707a485e8827bede);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cgL5K = parcelRequire("cgL5K");

var $92Z2l = parcelRequire("92Z2l");

var $koVbs = parcelRequire("koVbs");

var $blEB6 = parcelRequire("blEB6");

var $2jQkk = parcelRequire("2jQkk");

var $66YVc = parcelRequire("66YVc");
const $648d031066c15d33$export$707a485e8827bede = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { objectTypeNode: objectTypeNode } = props;
    const { name: name, icon: icon, objectSchemaId: objectSchemaId, referenceId: referenceId } = objectTypeNode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($648d031066c15d33$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jQkk.SidebarHeader), {
        title: name,
        iconUrl: icon,
        tooltip: formatMessage((0, $66YVc.default).openObjectTypeDetails),
        link: (0, $blEB6.createObjectTypeUrl)(objectSchemaId, referenceId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "information"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $66YVc.default).maxOfTypeExceeded))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $648d031066c15d33$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $648d031066c15d33$export$7ed12d2a5241e393 = {
    Wrapper: $648d031066c15d33$var$Wrapper
};

});
parcelRegister("2jQkk", function(module, exports) {

$parcel$export(module.exports, "SidebarHeader", () => $0978f8caf439963e$export$e575a964a1fe8b0);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $17Ngn = parcelRequire("17Ngn");

var $dC5iT = parcelRequire("dC5iT");

var $3bDjY = parcelRequire("3bDjY");

var $hDzhb = parcelRequire("hDzhb");
const $0978f8caf439963e$var$CustomHeading = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h2",
        size: "small"
    }, props.children);
const $0978f8caf439963e$export$e575a964a1fe8b0 = ({ iconUrl: iconUrl, link: link, title: title, tooltip: tooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "data-testId": "object-name-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0978f8caf439963e$var$ObjectNameLink, {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0978f8caf439963e$var$ObjectIcon, {
        "data-testId": "object-name-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: iconUrl,
        key: iconUrl,
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0978f8caf439963e$var$ObjectName, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "data-testId": "object-name-tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "data-testId": "object-name-shortcut-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($17Ngn))), {
        label: ""
    }))))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $0978f8caf439963e$var$ObjectNameLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hDzhb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _otyrpxbi _l8ku23z3 _tf4iidpf _12hn1q5t _t7blu2gc _f8pj1y58 _30l31y58 _16xekb7n _1fmgkb7n _1n83z12g _12svz12g",
            __cmplp.className
        ])
    });
});
const $0978f8caf439963e$var$ObjectIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf _1bsb1ejb _4t3i1ejb _2hwxutpp _mezj1osq _bna71osq",
            __cmplp.className
        ])
    });
});
const $0978f8caf439963e$var$ObjectName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0978f8caf439963e$var$CustomHeading, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazc8hx _1i4q1hna _slp31hna _1nmz9jpi _30l31y58",
            __cmplp.className
        ])
    });
});

});

parcelRegister("66YVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5504144b4927cf35$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5504144b4927cf35$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openObjectTypeDetails: {
        "id": "servicedesk-insight-object-graph.object-type-view.open-object-type-details",
        "defaultMessage": "Open object type details page"
    },
    maxOfTypeExceeded: {
        "id": "servicedesk-insight-object-graph.object-type-view.max-of-type-exceeded",
        "defaultMessage": "The number of objects of this type were too many to be represented individually in the graph and have therefore been grouped together in a single node."
    }
});

});


parcelRegister("a417P", function(module, exports) {

$parcel$export(module.exports, "ObjectView", () => $4710961ff4dc923e$export$c93bdb9e9400c13c);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7qDUb = parcelRequire("7qDUb");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $fphHl = parcelRequire("fphHl");
var $jxIT3 = parcelRequire("jxIT3");
var $cte3m = parcelRequire("cte3m");
var $8TQB5 = parcelRequire("8TQB5");

var $4R6GH = parcelRequire("4R6GH");

var $bTyOW = parcelRequire("bTyOW");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $calCc = parcelRequire("calCc");

var $blEB6 = parcelRequire("blEB6");

var $e0RrL = parcelRequire("e0RrL");

var $2jQkk = parcelRequire("2jQkk");

var $iW9pT = parcelRequire("iW9pT");

var $YYjXA = parcelRequire("YYjXA");

var $gyiEG = parcelRequire("gyiEG");

var $joPHk = parcelRequire("joPHk");
const $4710961ff4dc923e$export$c93bdb9e9400c13c = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { objectDetails: objectDetails, objectDetailsError: objectDetailsError, objectDetailsLoading: objectDetailsLoading, onObjectAttributeClick: onObjectAttributeClick, onRefreshButtonClick: onRefreshButtonClick, selectedObjectId: selectedObjectId, source: source } = props;
    const memoizedObjectDetails = (0, $5uXOq.useMemo)(()=>{
        if (objectDetailsError) {
            const renderImage = ()=>(0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default))({
                    imageWidth: 120,
                    maxImageWidth: 120,
                    maxImageHeight: 212
                });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
                header: formatMessage((0, $gyiEG.default).errorTitle),
                description: formatMessage((0, $gyiEG.default).errorDescription),
                renderImage: renderImage
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4710961ff4dc923e$var$ObjectViewErrorRefreshButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "primary",
                onClick: onRefreshButtonClick
            }, formatMessage((0, $gyiEG.default).refreshButton))));
        }
        if (objectDetailsLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iW9pT.AttributesListSkeleton), null);
        return objectDetails !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $calCc.AttributesList), {
            attributes: (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(objectDetails.attributes, (attribute)=>(0, $joPHk.getPositionFromObjectAttribute)(attribute)),
            objectId: selectedObjectId,
            onObjectAttributeClick: onObjectAttributeClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0RrL.TrackObjectView), {
            id: selectedObjectId
        })) : null;
    }, [
        selectedObjectId,
        formatMessage,
        objectDetailsError,
        objectDetailsLoading,
        objectDetails,
        onObjectAttributeClick,
        onRefreshButtonClick
    ]);
    const memoizedTabs = (0, $5uXOq.useMemo)(()=>[
            {
                label: formatMessage((0, $gyiEG.default).objectDetails),
                content: memoizedObjectDetails,
                tabItemId: 'insightObjectGraphObjectDetails'
            },
            {
                label: formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $gyiEG.default).linkedIssuesIssueTermRefresh : (0, $gyiEG.default).linkedIssues),
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YYjXA.LinkedIssues), {
                    objectId: selectedObjectId
                }),
                tabItemId: 'insightObjectGraphLinkedIssues'
            }
        ], [
        formatMessage,
        memoizedObjectDetails,
        selectedObjectId
    ]);
    const onTabSelect = (selectedTab)=>{
        const id = selectedTab.tabItemId;
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'navigationItem clicked', id, {
            source: source
        });
    }; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChange = (index)=>{
        const selectedTab = memoizedTabs[index];
        onTabSelect(selectedTab);
    };
    const memoizedHeader = (0, $5uXOq.useMemo)(()=>{
        if (objectDetailsError) return null;
        if (objectDetailsLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iW9pT.TitleSkeleton), null);
        return objectDetails !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jQkk.SidebarHeader), {
            title: objectDetails.label,
            iconUrl: objectDetails.avatar.url48,
            link: (0, $blEB6.createObjectDetailUrl)(selectedObjectId),
            tooltip: formatMessage((0, $gyiEG.default).openObjectDetailsPage)
        }) : null;
    }, [
        formatMessage,
        selectedObjectId,
        objectDetailsError,
        objectDetailsLoading,
        objectDetails
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $4710961ff4dc923e$var$wrapperStyles
    }, memoizedHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fphHl.default), {
        onChange: handleChange,
        id: "object-view-tabs",
        shouldUnmountTabPanelOnChange: true,
        testId: "servicedesk-insight-object-graph.ui.object-view.tabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cte3m.default), null, memoizedTabs.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jxIT3.default), {
            key: tab.tabItemId
        }, tab.label))), memoizedTabs.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8TQB5.default), {
            key: tab.tabItemId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4710961ff4dc923e$var$TabContentWrapper, null, tab.content)))));
};
const $4710961ff4dc923e$var$wrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4710961ff4dc923e$var$ObjectViewErrorRefreshButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4710961ff4dc923e$var$TabContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _vchhusvi _19pkpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("calCc", function(module, exports) {

$parcel$export(module.exports, "AttributesList", () => $33913402c572d3b5$export$52e75d5e1ea61c64);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");

var $CskGx = parcelRequire("CskGx");


var $9ng36 = parcelRequire("9ng36");

var $2QgAn = parcelRequire("2QgAn");

var $fw0ia = parcelRequire("fw0ia");

var $1srZ4 = parcelRequire("1srZ4");

var $9lhJY = parcelRequire("9lhJY");

var $f433j = parcelRequire("f433j");

var $emsEK = parcelRequire("emsEK");

var $e5pww = parcelRequire("e5pww");

var $51S0R = parcelRequire("51S0R");

var $3JJuQ = parcelRequire("3JJuQ");

var $1cqxh = parcelRequire("1cqxh");

var $h8qml = parcelRequire("h8qml");

var $kotWP = parcelRequire("kotWP");

var $j5lRn = parcelRequire("j5lRn");

var $bvqUI = parcelRequire("bvqUI");

var $kWOjh = parcelRequire("kWOjh");

var $ifUD8 = parcelRequire("ifUD8");

var $cuLvU = parcelRequire("cuLvU");

var $eyzFm = parcelRequire("eyzFm");

var $kzvtR = parcelRequire("kzvtR");
const $33913402c572d3b5$export$52e75d5e1ea61c64 = ({ attributes: attributes, objectId: objectId, onObjectAttributeClick: onObjectAttributeClick })=>{
    const renderDefaultAttribute = (attribute)=>{
        switch(attribute.objectTypeAttribute.defaultType.id.toString()){
            case (0, $e5pww.DefaultAttributeSubtypeMap).Boolean:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3JJuQ.BooleanAttribute), {
                    attribute: attribute
                });
            case (0, $e5pww.DefaultAttributeSubtypeMap).URL:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyzFm.UrlAttribute), {
                    attribute: attribute
                });
            case (0, $e5pww.DefaultAttributeSubtypeMap).Email:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyzFm.EmailAttribute), {
                    attribute: attribute
                });
            case (0, $e5pww.DefaultAttributeSubtypeMap).Textarea:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifUD8.RichTextAttribute), {
                    attribute: attribute
                });
            case (0, $e5pww.DefaultAttributeSubtypeMap).Date:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h8qml.DateAttribute), {
                    attribute: attribute
                });
            case (0, $e5pww.DefaultAttributeSubtypeMap).DateTime:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h8qml.DateTimeAttribute), {
                    attribute: attribute
                });
            case (0, $e5pww.DefaultAttributeSubtypeMap).Select:
                return attribute.objectAttributeValues.length > (0, $ff24525054a08710$export$13bee158954a3882) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $CskGx.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'select',
                        attributeValues: (0, $2QgAn.getDefaultAttributeArrayValueFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.select-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifUD8.TextAttribute), {
                    attribute: attribute,
                    "data-testid": "servicedesk-insight-attribute-list.ui.select-attribute"
                });
            case (0, $e5pww.DefaultAttributeSubtypeMap).Text:
            case (0, $e5pww.DefaultAttributeSubtypeMap).Integer:
            case (0, $e5pww.DefaultAttributeSubtypeMap).Double:
            case (0, $e5pww.DefaultAttributeSubtypeMap).IPAddress:
            case (0, $e5pww.DefaultAttributeSubtypeMap).Time:
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifUD8.TextAttribute), {
                    attribute: attribute
                });
        }
    };
    const renderAttribute = (attribute)=>{
        const showScalableLozengeButton = attribute.objectAttributeValues.length > (0, $ff24525054a08710$export$13bee158954a3882);
        switch(attribute.type){
            case (0, $e5pww.AttributeTypeMap).Default:
                return renderDefaultAttribute(attribute);
            case (0, $e5pww.AttributeTypeMap).Group:
                return showScalableLozengeButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $CskGx.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'group',
                        attributeValues: (0, $fw0ia.getGroupValuesFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.group-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kotWP.GroupAttribute), {
                    attribute: attribute,
                    "data-testid": "servicedesk-insight-attribute-list.ui.group-attribute"
                });
            case (0, $e5pww.AttributeTypeMap).Status:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kWOjh.StatusAttribute), {
                    attribute: attribute
                });
            case (0, $e5pww.AttributeTypeMap).Object:
                return showScalableLozengeButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $CskGx.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'object',
                        attributeValues: (0, $f433j.getObjectReferenceOptionsFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.object-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1cqxh.ObjectAttribute), {
                    attribute: attribute,
                    onClick: onObjectAttributeClick,
                    "data-testid": "servicedesk-insight-attribute-list.ui.object-attribute"
                });
            case (0, $e5pww.AttributeTypeMap).User:
                return showScalableLozengeButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $CskGx.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'user',
                        attributeValues: (0, $emsEK.getUserValuesFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.user-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kzvtR.UserAttribute), {
                    attribute: attribute,
                    "data-testid": "servicedesk-insight-attribute-list.ui.user-attribute"
                });
            case (0, $e5pww.AttributeTypeMap).Project:
                return showScalableLozengeButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $CskGx.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'project',
                        attributeValues: (0, $9lhJY.getProjectValuesFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.project-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvqUI.ProjectAttribute), {
                    attribute: attribute,
                    "data-testid": "servicedesk-insight-attribute-list.ui.project-attribute"
                });
            case (0, $e5pww.AttributeTypeMap).BitbucketRepo:
                return showScalableLozengeButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $CskGx.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'bitbucket',
                        attributeValues: (0, $9ng36.getBBRepoValuesFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.bitbucket-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $51S0R.BitbucketRepoAttribute), {
                    attribute: attribute,
                    "data-testid": "servicedesk-insight-attribute-list.ui.bitbucket-attribute"
                });
            case (0, $e5pww.AttributeTypeMap).OpsgenieTeam:
                return showScalableLozengeButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $CskGx.LozengeAndAttributeValueModal), {
                    attributeValuesInfo: {
                        type: 'opsgenieTeam',
                        attributeValues: (0, $1srZ4.getOpsgenieTeamValuesFromCmdbObjectAttribute)(attribute)
                    },
                    attributeName: attribute.objectTypeAttribute.name ?? '',
                    "data-testid": "servicedesk-insight-attribute-list.ui.opsgenie-team-lozenge"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j5lRn.OpsgenieTeamAttribute), {
                    attribute: attribute,
                    "data-testid": "servicedesk-insight-attribute-list.ui.opsgenie-team-attribute"
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cuLvU.UnknownAttribute), {
                    attribute: attribute,
                    objectId: objectId
                });
        }
    };
    const isTextarea = (attribute)=>attribute.type === (0, $e5pww.AttributeTypeMap).Default && attribute.objectTypeAttribute.defaultType.id === (0, $e5pww.DefaultAttributeSubtypeMap).Textarea;
    const objectAttributeValuesAreNotEmpty = (values)=>values.every((value)=>Object.keys(value).length > 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($33913402c572d3b5$var$ListWrapper, null, attributes.map((attribute)=>objectAttributeValuesAreNotEmpty(attribute.objectAttributeValues) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($33913402c572d3b5$var$AttributeWrapper, {
            key: attribute.objectTypeAttributeId,
            isColumn: isTextarea(attribute),
            "data-testid": "servicedesk-insight-attribute-list.ui.attribute-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($33913402c572d3b5$var$AttributeLabel, {
            isColumn: isTextarea(attribute)
        }, attribute.objectTypeAttribute.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($33913402c572d3b5$var$AttributeValue, {
            isColumn: isTextarea(attribute)
        }, renderAttribute(attribute)))));
};
const $33913402c572d3b5$var$AttributeLabel = ({ isColumn: isColumn, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($33913402c572d3b5$var$AttributeLabelWrapper, {
        isColumn: isColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: (0, $bwpsq.default)([
            "_syazc8hx"
        ])
    }, children)));
// eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $33913402c572d3b5$var$ListWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkr5cr _2hwxxmi2 _otyrr5cr _18u0xmi2",
            __cmplp.className
        ])
    });
});
const $33913402c572d3b5$var$attributeLabelColour = null;
// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $33913402c572d3b5$var$AttributeLabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isColumn: isColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1tke1ejb _vwz41ejb _16jlkb7n",
            __cmplp.isColumn ? "_18s8gc1c" : "_18s81r6r",
            __cmplp.isColumn ? "_i0dl1wug" : "_i0dl15e7",
            __cmplp.className
        ])
    });
});
const $33913402c572d3b5$var$AttributeValue = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isColumn: isColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1i4q1hna _slp31hna _1nmz9jpi _syaz1fxt _19pk1b66 _2hwxutpp _otyr1b66 _18u0utpp _1tke1ejb _vwz41ejb _16jlkb7n",
            __cmplp.isColumn ? "_i0dl1wug" : "_i0dlnr97",
            __cmplp.className
        ])
    });
});
const $33913402c572d3b5$var$AttributeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isColumn: isColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80",
            __cmplp.isColumn ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("CskGx", function(module, exports) {

$parcel$export(module.exports, "ReadView", () => $36749f0a74ec22e4$export$a4b5824ec1e018e1);
$parcel$export(module.exports, "LozengeAndAttributeValueModal", () => $36749f0a74ec22e4$export$d24cde01c782e0df);
$parcel$export(module.exports, "ScalableReadView", () => $36749f0a74ec22e4$export$24ff8c6c49acd72);

var $5uXOq = parcelRequire("5uXOq");

var $1qjEp = parcelRequire("1qjEp");

var $9ng36 = parcelRequire("9ng36");

var $2QgAn = parcelRequire("2QgAn");

var $fw0ia = parcelRequire("fw0ia");

var $1srZ4 = parcelRequire("1srZ4");

var $9lhJY = parcelRequire("9lhJY");

var $f433j = parcelRequire("f433j");

var $emsEK = parcelRequire("emsEK");

var $kCYNT = parcelRequire("kCYNT");

var $ewpCb = parcelRequire("ewpCb");

var $1Bhsf = parcelRequire("1Bhsf");

var $2e6sm = parcelRequire("2e6sm");

var $5t6Kq = parcelRequire("5t6Kq");

var $jLwXE = parcelRequire("jLwXE");

var $9r3nA = parcelRequire("9r3nA");

var $1syes = parcelRequire("1syes");

var $k2vGH = parcelRequire("k2vGH");

var $gd5Xi = parcelRequire("gd5Xi");

var $amV0U = parcelRequire("amV0U");

var $2CDrI = parcelRequire("2CDrI");

var $8j9Sh = parcelRequire("8j9Sh");

var $1hVgu = parcelRequire("1hVgu");

var $klGkl = parcelRequire("klGkl");
const $36749f0a74ec22e4$var$renderDefaultAttribute = ({ defaultAttribute: defaultAttribute, showPlaceholderIfEmpty: showPlaceholderIfEmpty })=>{
    const commonProps = {
        showPlaceholderIfEmpty: showPlaceholderIfEmpty
    };
    const renderText = (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1hVgu.TextReadView), {
            ...commonProps,
            value: value,
            defaultAttributeType: defaultAttribute.objectTypeAttribute
        });
    const renderMultiText = (values)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1hVgu.TextReadView), {
            ...commonProps,
            value: values,
            defaultAttributeType: defaultAttribute.objectTypeAttribute
        });
    return (0, $kCYNT.matchDefaultAttribute)(defaultAttribute, {
        url: renderMultiText,
        email: renderMultiText,
        float: renderText,
        integer: renderText,
        ipAddress: renderText,
        text: renderText,
        textarea: (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8j9Sh.TextAreaReadView), {
                ...commonProps,
                value: value
            }),
        select: (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $amV0U.SelectReadView), {
                ...commonProps,
                value: value
            }),
        boolean: (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2e6sm.BooleanReadView), {
                value: value
            }),
        date: (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jLwXE.DateReadView), {
                ...commonProps,
                value: value
            }),
        datetime: (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5t6Kq.DateTimeReadView), {
                ...commonProps,
                value: value
            })
    });
};
const $36749f0a74ec22e4$export$a4b5824ec1e018e1 = ({ attribute: attribute, showPlaceholderIfEmpty: showPlaceholderIfEmpty })=>(0, $kCYNT.matchInsightObjectAttribute)(attribute, {
        default: (defaultAttribute)=>$36749f0a74ec22e4$var$renderDefaultAttribute({
                defaultAttribute: defaultAttribute,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            }),
        object: (objectAttribute)=>{
            const referencedObjects = objectAttribute.objectTypeValues.map(({ referencedObject: referencedObject })=>{
                const { id: id, objectKey: objectKey, label: label, avatar: avatar } = referencedObject;
                return {
                    id: id,
                    objectKey: objectKey,
                    label: label,
                    avatar: avatar
                };
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gd5Xi.ReferencedObjectsReadView), {
                referencedObjects: referencedObjects,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            });
        },
        user: (userAttribute)=>{
            const users = userAttribute.userTypeValues.map(({ user: user })=>{
                const { displayName: displayName, avatarUrl: avatarUrl, key: key } = user;
                return {
                    displayName: displayName,
                    avatarUrl: avatarUrl,
                    accountId: key
                };
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $klGkl.UsersReadView), {
                users: users,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            });
        },
        group: (groupAttribute)=>{
            const groups = groupAttribute.groupTypeValues.map((groupAttributeValue)=>({
                    name: groupAttributeValue.group.name
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r3nA.GroupsReadView), {
                groups: groups,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            });
        },
        project: (projectAttribute)=>{
            const projects = projectAttribute.projectTypeValues.map((projectAttributeValue)=>({
                    name: projectAttributeValue.project.name,
                    id: projectAttributeValue.project.id,
                    avatarUrl: projectAttributeValue.project.avatarUrl,
                    key: projectAttributeValue.project.key
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2vGH.ProjectsReadView), {
                projects: projects,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            });
        },
        bitbucketRepo: (bitbucketRepoAttribute)=>{
            const bitbucketRepos = bitbucketRepoAttribute.bitbucketRepoTypeValues.map((bitbucketRepoTypeValue)=>({
                    uuid: bitbucketRepoTypeValue.bitbucketRepo.uuid,
                    name: bitbucketRepoTypeValue.bitbucketRepo.name,
                    avatarUrl: bitbucketRepoTypeValue.bitbucketRepo.avatarUrl,
                    url: bitbucketRepoTypeValue.bitbucketRepo.url
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Bhsf.BitbucketReposReadView), {
                bitbucketRepos: bitbucketRepos,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            });
        },
        status: (statusAttribute)=>{
            const [status = null] = statusAttribute.statusTypeValues.map((statusAttributeValue)=>{
                const { id: id, name: name, category: category } = statusAttributeValue.status;
                return {
                    id: id,
                    name: name,
                    category: category
                };
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CDrI.StatusReadView), {
                status: status
            });
        },
        opsgenieTeam: (opsgenieTeamAttribute)=>{
            const opsgenieTeams = opsgenieTeamAttribute.opsgenieTeamTypeValues.map((opsgenieTeamTypeValue)=>({
                    id: opsgenieTeamTypeValue.opsgenieTeam.id,
                    name: opsgenieTeamTypeValue.opsgenieTeam.name,
                    avatarUrl: opsgenieTeamTypeValue.opsgenieTeam.avatarUrl,
                    url: opsgenieTeamTypeValue.opsgenieTeam.url
                }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1syes.OpsgenieTeamsReadView), {
                opsgenieTeams: opsgenieTeams,
                showPlaceholderIfEmpty: showPlaceholderIfEmpty
            });
        }
    });
const $36749f0a74ec22e4$export$d24cde01c782e0df = (props)=>{
    const { attributeValuesInfo: attributeValuesInfo, attributeName: attributeName } = props;
    const [isEditableAttributeModalOpen, setIsEditableAttributeModalOpen] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ewpCb.MultiValueLozenge), {
        attributeValueType: attributeValuesInfo.type,
        count: attributeValuesInfo.attributeValues.length,
        onClick: ()=>{
            setIsEditableAttributeModalOpen(true);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1qjEp.AsyncEditableAttributeModal), {
        isOpen: isEditableAttributeModalOpen,
        isEditable: false,
        onClose: ()=>{
            setIsEditableAttributeModalOpen(false);
        },
        attributeName: attributeName,
        attributeValuesInfo: attributeValuesInfo
    }));
};
const $36749f0a74ec22e4$export$24ff8c6c49acd72 = ({ attribute: attribute })=>(0, $kCYNT.matchInsightObjectAttribute)(attribute, {
        default: (defaultAttribute)=>{
            const selectOptionsValue = (0, $2QgAn.getDefaultAttributeArrayValue)(attribute);
            return defaultAttribute.objectTypeAttribute.defaultType.name === 'Select' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36749f0a74ec22e4$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'select',
                    attributeValues: selectOptionsValue
                },
                attributeName: attribute.objectTypeAttribute.name
            }) : $36749f0a74ec22e4$var$renderDefaultAttribute({
                defaultAttribute: defaultAttribute
            });
        },
        object: ()=>{
            const objectValue = (0, $f433j.getObjectReferenceOptions)(attribute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36749f0a74ec22e4$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'object',
                    attributeValues: objectValue
                },
                attributeName: attribute.objectTypeAttribute.name
            });
        },
        user: ()=>{
            const userValue = (0, $emsEK.getUserValues)(attribute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36749f0a74ec22e4$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'user',
                    attributeValues: userValue
                },
                attributeName: attribute.objectTypeAttribute.name
            });
        },
        group: ()=>{
            const groupValue = (0, $fw0ia.getGroupValues)(attribute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36749f0a74ec22e4$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'group',
                    attributeValues: groupValue
                },
                attributeName: attribute.objectTypeAttribute.name
            });
        },
        project: ()=>{
            const projectValue = (0, $9lhJY.getProjectValues)(attribute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36749f0a74ec22e4$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'project',
                    attributeValues: projectValue
                },
                attributeName: attribute.objectTypeAttribute.name
            });
        },
        bitbucketRepo: ()=>{
            const bitbucketRepoValue = (0, $9ng36.getBBRepoValues)(attribute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36749f0a74ec22e4$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'bitbucket',
                    attributeValues: bitbucketRepoValue
                },
                attributeName: attribute.objectTypeAttribute.name
            });
        },
        status: (statusAttribute)=>{
            const [status = null] = statusAttribute.statusTypeValues.map((statusAttributeValue)=>{
                const { id: id, name: name, category: category } = statusAttributeValue.status;
                return {
                    id: id,
                    name: name,
                    category: category
                };
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CDrI.StatusReadView), {
                status: status
            });
        },
        opsgenieTeam: ()=>{
            const opsgenieTeamValue = (0, $1srZ4.getOpsgenieTeamValues)(attribute);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36749f0a74ec22e4$export$d24cde01c782e0df, {
                attributeValuesInfo: {
                    type: 'opsgenieTeam',
                    attributeValues: opsgenieTeamValue
                },
                attributeName: attribute.objectTypeAttribute.name
            });
        }
    });

});

parcelRegister("51S0R", function(module, exports) {

$parcel$export(module.exports, "BitbucketRepoAttribute", () => $5f709f1245a77b21$export$3de3d466bca83769);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1Bhsf = parcelRequire("1Bhsf");
const $5f709f1245a77b21$export$3de3d466bca83769 = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f709f1245a77b21$var$Wrapper, null, attribute.objectAttributeValues.map(({ bitbucketRepo: { uuid: uuid, avatarUrl: avatarUrl, name: name, url: url } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Bhsf.BitbucketRepoReadView), {
            key: uuid,
            uuid: uuid,
            url: url,
            avatarUrl: avatarUrl,
            name: name
        })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f709f1245a77b21$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3JJuQ", function(module, exports) {

$parcel$export(module.exports, "BooleanAttribute", () => $2a097b91caebaa3a$export$9c894cb7469f1f94);

var $5uXOq = parcelRequire("5uXOq");
const $2a097b91caebaa3a$export$9c894cb7469f1f94 = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "servicedesk-insight-attribute-list.ui.boolean-attribute",
            key: index
        }, value.displayValue)));
};

});

parcelRegister("1cqxh", function(module, exports) {

$parcel$export(module.exports, "ObjectAttribute", () => $64ab383ede6f06e9$export$15d74c5a12ccc9b0);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $fVnbM = parcelRequire("fVnbM");

var $17Ngn = parcelRequire("17Ngn");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $7DxXA = parcelRequire("7DxXA");

var $bUUmN = parcelRequire("bUUmN");

var $blEB6 = parcelRequire("blEB6");

var $kfCQ9 = parcelRequire("kfCQ9");
const $64ab383ede6f06e9$var$RenderTooltipWhenTextOverflows = ({ children: children })=>{
    const [isTextWiderThanContainer, setIsTextWiderThanContainer] = (0, $5uXOq.useState)(false); /**
                                                                                    * This check will only run once when the component is initially rendered.
                                                                                    * Won't re-check when windows resize or text length changes without re-rendering.
                                                                                    */ 
    // @ts-expect-error - TS7006 - Parameter 'node' implicitly has an 'any' type.
    const checkTextWidth = (0, $5uXOq.useCallback)((node)=>{
        if (node != null) setIsTextWiderThanContainer(node.offsetWidth < node.scrollWidth);
    }, []);
    if (isTextWiderThanContainer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($64ab383ede6f06e9$var$TextWithEllipsis, null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($64ab383ede6f06e9$var$TextWithEllipsis, {
        ref: checkTextWidth
    }, children);
};
const $64ab383ede6f06e9$export$fd917fe393fd3fa9 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($64ab383ede6f06e9$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUUmN.MemoizedInsightIcon), {
        mediaClientConfig: props.mediaClientConfig,
        iconUrl: props.avatarUrl,
        label: props.label,
        size: "xsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        spacing: "none",
        onClick: (event)=>{
            event.stopPropagation();
            props.onClick();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($64ab383ede6f06e9$var$RenderTooltipWhenTextOverflows, null, props.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $kfCQ9.default).viewObjectDetails)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($64ab383ede6f06e9$var$ObjectAttributeLink, {
        appearance: "subtle-link",
        spacing: "compact",
        target: "_blank",
        href: (0, $blEB6.createObjectDetailUrl)(props.objectId),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($17Ngn))), {
            label: ""
        })
    })));
};
const $64ab383ede6f06e9$export$48542bae20cd03e9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($64ab383ede6f06e9$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUUmN.MemoizedInsightIcon), {
        mediaClientConfig: props.mediaClientConfig,
        iconUrl: props.avatarUrl,
        label: props.label,
        size: "xsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($64ab383ede6f06e9$var$RenderTooltipWhenTextOverflows, null, props.label));
const $64ab383ede6f06e9$export$15d74c5a12ccc9b0 = ({ attribute: attribute, onClick: onClick })=>{
    const isInsightVisible = (0, $7DxXA.useInsightVisibility)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>isInsightVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($64ab383ede6f06e9$export$fd917fe393fd3fa9, {
            key: index,
            avatarUrl: value.referencedObject.avatar.url48,
            mediaClientConfig: value.referencedObject.avatar.mediaClientConfig,
            label: value.displayValue,
            onClick: ()=>{
                onClick(value.referencedObject);
            },
            objectId: value.referencedObject.objectId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($64ab383ede6f06e9$export$48542bae20cd03e9, {
            key: index,
            avatarUrl: value.referencedObject.avatar.url48,
            mediaClientConfig: value.referencedObject.avatar.mediaClientConfig,
            label: value.displayValue
        })));
};
const $64ab383ede6f06e9$var$ObjectAttributeLink = /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
(0, $47bDC.default)((0, $fVnbM.default)).withConfig({
    componentId: "sc-1pcub2p-0"
})({
    opacity: 0,
    transform: 'translate(-8px, 0)',
    '&:focus': {
        opacity: 1,
        transform: 'translate(0, 0)'
    }
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64ab383ede6f06e9$var$Wrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1pcub2p-1"
})`display:flex;align-items:center;> div:first-child{margin-right:${"var(--ds-space-100, 8px)"};}${$64ab383ede6f06e9$var$ObjectAttributeLink}{transition:opacity 0.2s,transform 0.2s;}&:hover ${$64ab383ede6f06e9$var$ObjectAttributeLink}{opacity:1;transform:translate(0,0);}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64ab383ede6f06e9$var$TextWithEllipsis = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fd36x",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kfCQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b0fb40fcf07451e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5b0fb40fcf07451e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewObjectDetails: {
        "id": "servicedesk-insight-attribute-list.button-attribute-with-avatar.view-object-details",
        "defaultMessage": "View details"
    }
});

});


parcelRegister("h8qml", function(module, exports) {

$parcel$export(module.exports, "DateAttribute", () => $421349731f54e2de$export$1dfc6d6b778c012f);
$parcel$export(module.exports, "DateTimeAttribute", () => $421349731f54e2de$export$762339c6da2c8489);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cTemL = parcelRequire("cTemL");

var $8tRRd = parcelRequire("8tRRd");
const $421349731f54e2de$var$AttributeWithIcon = ({ formattedValue: formattedValue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($421349731f54e2de$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTemL))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, formattedValue));
const $421349731f54e2de$export$1dfc6d6b778c012f = ({ attribute: attribute })=>{
    const { formatDateOnly: formatDateOnly } = (0, $8tRRd.useDateTimeFormatter)();
    const [objectAttributeValue = null] = attribute.objectAttributeValues;
    if (objectAttributeValue === null || !objectAttributeValue.value) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($421349731f54e2de$var$AttributeWithIcon, {
        formattedValue: formatDateOnly(objectAttributeValue.value)
    });
};
const $421349731f54e2de$export$762339c6da2c8489 = ({ attribute: attribute })=>{
    const { formatDateTime: formatDateTime } = (0, $8tRRd.useDateTimeFormatter)();
    const [objectAttributeValue = null] = attribute.objectAttributeValues;
    if (objectAttributeValue === null || !objectAttributeValue.value) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($421349731f54e2de$var$AttributeWithIcon, {
        formattedValue: formatDateTime(objectAttributeValue.value)
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $421349731f54e2de$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kotWP", function(module, exports) {

$parcel$export(module.exports, "GroupAttribute", () => $b8212fe9043b7fcb$export$d98ccc7fb64ed0fe);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9laXL = parcelRequire("9laXL");

var $6UXEc = parcelRequire("6UXEc");
const $b8212fe9043b7fcb$export$d98ccc7fb64ed0fe = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8212fe9043b7fcb$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6UXEc.default), null, attribute.objectAttributeValues.map(({ group: { name: name } }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9laXL.default), {
            testId: "servicedesk-insight-attribute-list.ui.group-attribute.value",
            key: index,
            text: name,
            isRemovable: false
        }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8212fe9043b7fcb$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxr5cr _otyridpf _18u0r5cr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9laXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d63a49f20b6f0a05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $c543i = parcelRequire("c543i");

var $5JjdN = parcelRequire("5JjdN");

var $eGmKJ = parcelRequire("eGmKJ");

var $35XSW = parcelRequire("35XSW");
var $lM16U = parcelRequire("lM16U");

var $VSDnB = parcelRequire("VSDnB");

var $e6s40 = parcelRequire("e6s40");

var $2hnSR = parcelRequire("2hnSR");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");

var $frUcV = parcelRequire("frUcV");
var $d63a49f20b6f0a05$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($d63a49f20b6f0a05$var$TagStatus || {});
const $d63a49f20b6f0a05$var$packageName = "platform-pkg";
const $d63a49f20b6f0a05$var$packageVersion = "0.0.0-use.local";
const $d63a49f20b6f0a05$var$defaultBeforeRemoveAction = ()=>true;
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ const $d63a49f20b6f0a05$var$removingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus-within': {
        boxShadow: `0 0 0 2px transparent`,
        outline: 'none'
    }
});
const $d63a49f20b6f0a05$var$RemovableTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $d63a49f20b6f0a05$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $eGmKJ.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $5uXOq.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $5uXOq.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $c543i.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $d63a49f20b6f0a05$var$packageName,
            packageVersion: $d63a49f20b6f0a05$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $5uXOq.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $5uXOq.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $5uXOq.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $5uXOq.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $5uXOq.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $5uXOq.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $frUcV.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle, #00000000)" : undefined,
        // Tag background color on hover
        [(0, $e6s40.cssVar).color.background.hover]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : $2hnSR.removalHoverBackgroundColors,
        // Tag background color on press
        [(0, $e6s40.cssVar).color.background.active]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : $2hnSR.removalActiveBackgroundColors,
        // The tag text on hover of remove button
        [(0, $e6s40.cssVar).color.text.default]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : $2hnSR.removalTextColors,
        // 'elemBefore' text on press of remove button
        [(0, $e6s40.cssVar).color.text.active]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : $2hnSR.removalTextColors,
        // The tag link text on hover of remove button
        [(0, $e6s40.cssVar).color.text.link]: (0, $VSDnB.fg)('platform-component-visual-refresh') ? undefined : $2hnSR.removalTextColors
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $35XSW.default), null, !(status === "removed") && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lM16U.default), null, (motion)=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5oSQr.default), {
            ref: (0, $5JjdN.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            css: [
                status === "removing" && $d63a49f20b6f0a05$var$removingStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === "removing",
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aXLIT.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $d63a49f20b6f0a05$var$RemovableTag = /*#__PURE__*/ (0, $5uXOq.memo)($d63a49f20b6f0a05$var$RemovableTagComponent);
var $d63a49f20b6f0a05$export$2e2bcd8739ae039 = $d63a49f20b6f0a05$var$RemovableTag;

});
parcelRegister("lM16U", function(module, exports) {

$parcel$export(module.exports, "default", () => $c624c149830103aa$export$2e2bcd8739ae039);


var $lObw7 = parcelRequire("lObw7");

var $bh8Xz = parcelRequire("bh8Xz");

var $3GP8X = parcelRequire("3GP8X");

var $fsENI = parcelRequire("fsENI");

var $35XSW = parcelRequire("35XSW");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $c624c149830103aa$var$ShrinkOut = ({ children: children, duration: duration = (0, $lObw7.smallDurationMs), onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $3GP8X.useElementRef)();
    const exiting = (0, $35XSW.useExitingPersistence)();
    const requestAnimationFrame = (0, $bh8Xz.useRequestAnimationFrame)();
    const setTimeout = (0, $bh8Xz.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $fsENI.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: (0, $eba99f58997c09b3$export$929e5a82286172a6),
                        transitionDuration: `${duration}ms`,
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, duration);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $c624c149830103aa$export$2e2bcd8739ae039 = $c624c149830103aa$var$ShrinkOut;

});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("3GP8X", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $19cc13cbd0e78f53$export$ff879f35a69d56b7);

var $5uXOq = parcelRequire("5uXOq");
const $19cc13cbd0e78f53$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $5uXOq.useRef)(null);
    const setRef = (0, $5uXOq.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("frUcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $625906158e0f3c21$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $e6s40 = parcelRequire("e6s40");
const $625906158e0f3c21$var$removeButtonStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '16px',
    width: '16px',
    margin: 'space.0',
    padding: 'space.0',
    insetInlineEnd: 'space.0',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    appearance: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none',
    borderRadius: 'border.radius.050',
    color: 'color.text',
    cursor: 'pointer',
    pointerEvents: 'auto',
    marginInlineStart: 'space.negative.025',
    marginInlineEnd: 'space.negative.025',
    ':focus-visible': {
        outlineOffset: 'space.negative.025'
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $625906158e0f3c21$var$removeButtonStylesOld = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '16px',
    margin: 'space.0',
    padding: 'space.0',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    appearance: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none',
    // Once legacy theming is dropped, this can be changed to 'border.radius'
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $e6s40.cssVar).borderRadius})`,
    // Once legacy theming is dropped, this can be changed to 'inherit'
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $e6s40.cssVar).color.removeButton.default})`,
    cursor: 'pointer',
    pointerEvents: 'auto',
    ':focus-visible': {
        outlineOffset: 'space.0'
    },
    ':hover': {
        // Once legacy theming is dropped, this can be changed to 'cssVar.color.text.default'
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $e6s40.cssVar).color.removeButton.hover})`
    }
});
const $625906158e0f3c21$var$removeButtonStylesOldIcon = (0, $8CUq3.xcss)({
    insetInlineEnd: 'space.0'
});
const $625906158e0f3c21$var$removeButtonStylesNewIcon = (0, $8CUq3.xcss)({
    insetInlineEnd: 'space.025'
});
const $625906158e0f3c21$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: [
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? $625906158e0f3c21$var$removeButtonStyles : $625906158e0f3c21$var$removeButtonStylesOld,
            (0, $VSDnB.fg)('platform-visual-refresh-icons') ? $625906158e0f3c21$var$removeButtonStylesNewIcon : $625906158e0f3c21$var$removeButtonStylesOldIcon
        ],
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
        color: "currentColor",
        label: "",
        LEGACY_size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$625906158e0f3c21$export$2e2bcd8739ae039 = $625906158e0f3c21$var$RemoveButton;

});


parcelRegister("6UXEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c2d1dcb54418fac$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $2c2d1dcb54418fac$var$baseStyles = null;
const $2c2d1dcb54418fac$var$justifyStartStyles = null;
const $2c2d1dcb54418fac$var$justifyEndStyles = null;
/**
 * __Tag group__
 *
 * A tag group controls the layout and alignment for a collection of tags.
 *
 * - [Examples](https://atlassian.design/components/tag-group/examples)
 * - [Code](https://atlassian.design/components/tag-group/code)
 * - [Usage](https://atlassian.design/components/tag-group/usage)
 */ const $2c2d1dcb54418fac$var$TagGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ])
    }, children);
});
var $2c2d1dcb54418fac$export$2e2bcd8739ae039 = $2c2d1dcb54418fac$var$TagGroup;

});


parcelRegister("j5lRn", function(module, exports) {

$parcel$export(module.exports, "OpsgenieTeamAttribute", () => $9df8ac37bb7ad949$export$7b4e7461be2e2525);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1syes = parcelRequire("1syes");
const $9df8ac37bb7ad949$export$7b4e7461be2e2525 = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9df8ac37bb7ad949$var$Wrapper, null, attribute.objectAttributeValues.map(({ opsgenieTeam: { id: id, avatarUrl: avatarUrl, name: name, url: url } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1syes.OpsgenieTeamReadView), {
            key: id,
            id: id,
            url: url,
            avatarUrl: avatarUrl,
            name: name
        })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9df8ac37bb7ad949$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bvqUI", function(module, exports) {

$parcel$export(module.exports, "ProjectAttribute", () => $2d19124f50816652$export$c917b99594d44fb8);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k2vGH = parcelRequire("k2vGH");
const $2d19124f50816652$export$c917b99594d44fb8 = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2d19124f50816652$var$Wrapper, null, attribute.objectAttributeValues.map(({ project: { avatarUrl: avatarUrl, key: key, name: name, id: id } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2vGH.ProjectReadView), {
            key: id,
            projectKey: key,
            avatarUrl: avatarUrl,
            displayName: name
        })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2d19124f50816652$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kWOjh", function(module, exports) {

$parcel$export(module.exports, "StatusAttribute", () => $8f4c6feff502cbec$export$df9089d96a51b907);

var $5uXOq = parcelRequire("5uXOq");

var $lj8SI = parcelRequire("lj8SI");
const $8f4c6feff502cbec$export$b716aadee3b63550 = (category)=>{
    switch(category){
        case 0:
            return 'removed';
        case 1:
            return 'success';
        case 2:
            return 'moved';
        default:
            return 'default';
    }
};
const $8f4c6feff502cbec$export$df9089d96a51b907 = ({ attribute: attribute })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>{
        const appearance = $8f4c6feff502cbec$export$b716aadee3b63550(value.status.category);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lj8SI.default), {
            key: index,
            isBold: true,
            appearance: appearance
        }, value.displayValue);
    }));

});

parcelRegister("ifUD8", function(module, exports) {

$parcel$export(module.exports, "TextAttribute", () => $4443662e8c260f82$export$524ab8b6c1ca9de3);
$parcel$export(module.exports, "RichTextAttribute", () => $4443662e8c260f82$export$ad1e0393ba7fff77);

var $5uXOq = parcelRequire("5uXOq");

var $hXLCJ = parcelRequire("hXLCJ");

var $johYW = parcelRequire("johYW");
const $4443662e8c260f82$var$sanitize = (html)=>(0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(html, {
        // @ts-expect-error - TS2769 - No overload matches this call.
        ALLOWED_TAGS: (0, $johYW.ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS),
        ALLOWED_ATTR: [
            'role',
            'tabindex',
            'href',
            'target'
        ]
    });
const $4443662e8c260f82$var$GenericTextAttribute = (props)=>{
    const { attribute: attribute, isRichText: isRichText = false } = props;
    const renderText = (value, index)=>{
        if (isRichText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            key: index,
            "data-testId": "insight-attribute-list-text-attribute-text",
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: $4443662e8c260f82$var$sanitize(value.displayValue)
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            key: index
        }, value.value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, attribute.objectAttributeValues.map(renderText));
};
const $4443662e8c260f82$export$524ab8b6c1ca9de3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4443662e8c260f82$var$GenericTextAttribute, props);
const $4443662e8c260f82$export$ad1e0393ba7fff77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4443662e8c260f82$var$GenericTextAttribute, {
        ...props,
        isRichText: true
    });

});

parcelRegister("cuLvU", function(module, exports) {

$parcel$export(module.exports, "UnknownAttribute", () => $61daef9971fe0055$export$78a991caba2f3146);

var $5uXOq = parcelRequire("5uXOq");

var $xJtdX = parcelRequire("xJtdX");
const $61daef9971fe0055$export$78a991caba2f3146 = (props)=>{
    const { attribute: { objectTypeAttributeId: objectTypeAttributeId, type: type }, objectId: objectId } = props;
    (0, $5uXOq.useEffect)(()=>{
        (0, $xJtdX.fireCmdbErrorAnalytics)({
            meta: {
                id: 'attributesListRenderUnknownAttribute',
                packageName: 'jiraServicedeskInsightAttributeList',
                teamName: 'falcons'
            },
            error: new Error(`Unknown attribute type - object id: ${objectId}, object type attribute id: ${objectTypeAttributeId}, type: ${type}`)
        });
    }, [
        objectId,
        objectTypeAttributeId,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, "Unknown Attribute");
};

});

parcelRegister("eyzFm", function(module, exports) {

$parcel$export(module.exports, "EmailAttribute", () => $bbd334a6c2237c07$export$bed4cdeb189c2268);
$parcel$export(module.exports, "UrlAttribute", () => $bbd334a6c2237c07$export$ec066e79c9f40c37);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8dO33 = parcelRequire("8dO33");

var $kVZJG = parcelRequire("kVZJG");
var $dn5wJ = parcelRequire("dn5wJ");
const $bbd334a6c2237c07$export$bed4cdeb189c2268 = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bbd334a6c2237c07$var$StyledAnchor, {
            target: "_blank",
            key: index,
            href: `mailto:${value.displayValue}`
        }, value.displayValue)));
};
const $bbd334a6c2237c07$export$ec066e79c9f40c37 = ({ attribute: attribute })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8dO33.SmartCardProvider), null, attribute.objectAttributeValues.map((value, index)=>{
        const href = value.displayValue;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVZJG.Card), {
            key: index,
            url: href,
            appearance: "inline",
            fallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bbd334a6c2237c07$var$StyledAnchor, {
                    target: "_blank",
                    key: index,
                    href: href
                }, value.displayValue),
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $dn5wJ.CardAction).ChangeStatusAction
                ]
            }
        });
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bbd334a6c2237c07$var$StyledAnchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kzvtR", function(module, exports) {

$parcel$export(module.exports, "UserAttribute", () => $3d451eba4959fd57$export$734f569777cc0b79);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $dJl1T = parcelRequire("dJl1T");

var $kYYfm = parcelRequire("kYYfm");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");
const $3d451eba4959fd57$export$734f569777cc0b79 = (props)=>{
    const { attribute: attribute } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d451eba4959fd57$var$Wrapper, null, attribute.objectAttributeValues.map((value, index)=>{
        if (!value?.user) {
            /* Given we're in the user attribute the data structure expects user to be here,
         * but we're seeing instances where it's not. Logging here to keep track of it happening.
         * This can be removed if logs show this isn't happening anymore.
         * More Info: https://hello.jira.atlassian.cloud/browse/FLY-1871
         * */ (0, $dJl1T.default).safeErrorWithoutCustomerData('servicedesk.insight-common.insight-attribute-list.ui.user-attribute', `missing-user-attribute: ${attribute.objectAttributeValues.length}, valuePresent: ${!!value}`);
            return;
        }
        return value.user.key && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kYYfm.AsyncProfileCardNext), {
            key: index,
            accountId: value.user.key,
            TenantContextSubscriber: (0, $4R6GH.fg)('empanada_nin_concurrent_mode_fixes') ? undefined : (0, $9OXo1.TenantContextSubscriber)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d451eba4959fd57$var$UserWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            size: "small",
            src: value.user.avatarUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d451eba4959fd57$var$UserName, null, value.user.displayName)));
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3d451eba4959fd57$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1n261g80 _18u0x0bf",
            __cmplp.className
        ])
    });
});
const $3d451eba4959fd57$var$UserWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c1txw _4cvr1h6o _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc _syaz1fxt _80om73ad _irr31dko",
            __cmplp.className
        ])
    });
});
const $3d451eba4959fd57$var$UserName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});


parcelRegister("e0RrL", function(module, exports) {

$parcel$export(module.exports, "TrackObjectView", () => $eb6be37820a5b0a3$export$f3c0140e1e635e20);
$parcel$export(module.exports, "TrackObjectTypeView", () => $eb6be37820a5b0a3$export$db0346606e968cdc);
$parcel$export(module.exports, "TrackObjectSchemaView", () => $eb6be37820a5b0a3$export$a71b6a1bced1e79e);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $xJtdX = parcelRequire("xJtdX");

var $7DxXA = parcelRequire("7DxXA");

var $ieMtM = parcelRequire("ieMtM");
const $eb6be37820a5b0a3$var$TrackView = ({ id: id, entityType: entityType })=>{
    (0, $gKZoD.di)(clearTimeout, setTimeout);
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (!workspaceId) return ()=>undefined;
        // Delay the track request to avoid contention with other requests for initial loading
        const trackTimeoutId = setTimeout(()=>{
            (0, $ieMtM.trackView)({
                workspaceId: workspaceId,
                entityId: id,
                entityType: entityType
            }).catch((error)=>{
                (0, $xJtdX.fireCmdbErrorAnalytics)({
                    error: error,
                    meta: {
                        id: 'TrackView',
                        packageName: 'jiraServicedeskInsightUserHistoryTracker',
                        teamName: 'falcons'
                    },
                    attributes: {
                        entityId: id,
                        entityType: entityType
                    }
                });
            });
        }, 1000);
        return ()=>clearTimeout(trackTimeoutId);
    }, [
        workspaceId,
        id,
        entityType
    ]);
    return null;
};
const $eb6be37820a5b0a3$export$f3c0140e1e635e20 = ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eb6be37820a5b0a3$var$TrackView, {
        id: id,
        entityType: "object"
    });
const $eb6be37820a5b0a3$export$db0346606e968cdc = ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eb6be37820a5b0a3$var$TrackView, {
        id: id,
        entityType: "object-type"
    });
const $eb6be37820a5b0a3$export$a71b6a1bced1e79e = ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eb6be37820a5b0a3$var$TrackView, {
        id: id,
        entityType: "object-schema"
    });

});
parcelRegister("ieMtM", function(module, exports) {

$parcel$export(module.exports, "trackView", () => $4ae04f03820fb060$export$cf121cb4a790600a);

var $4VpwK = parcelRequire("4VpwK");

var $kFdaK = parcelRequire("kFdaK");
const $4ae04f03820fb060$export$cf121cb4a790600a = async ({ workspaceId: workspaceId, entityId: entityId, entityType: entityType })=>{
    await (0, $4VpwK.performCmdbPostRequest)((0, $kFdaK.getCmdbUserHistoryViewedUrl)(workspaceId), {
        body: JSON.stringify({
            entityId: entityId,
            entityType: entityType
        })
    });
};

});
parcelRegister("kFdaK", function(module, exports) {

$parcel$export(module.exports, "getCmdbUserHistoryViewedUrl", () => $f7394a0444173cc5$export$c31d4edf380c08d5);

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/user-history
 */ const $f7394a0444173cc5$var$getCmdbUserHistoryUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/user-history`;
const $f7394a0444173cc5$export$c31d4edf380c08d5 = (workspaceId)=>`${$f7394a0444173cc5$var$getCmdbUserHistoryUrl(workspaceId)}/viewed`;

});



parcelRegister("iW9pT", function(module, exports) {

$parcel$export(module.exports, "TitleSkeleton", () => $68c9b64b8f09f8f3$export$5992f258b912f234);
$parcel$export(module.exports, "AttributesListSkeleton", () => $68c9b64b8f09f8f3$export$1a33f1b535de2335);
$parcel$export(module.exports, "LinkedIssuesSkeleton", () => $68c9b64b8f09f8f3$export$7a6a12132903144d);

var $5uXOq = parcelRequire("5uXOq");

var $gwIPs = parcelRequire("gwIPs");

var $kUJ1p = parcelRequire("kUJ1p");
const $68c9b64b8f09f8f3$export$5992f258b912f234 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUJ1p.FlexContainer), {
        marginBottom: (0, $gwIPs.gridSize) * 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUJ1p.Avatar), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUJ1p.Title), null));
const $68c9b64b8f09f8f3$var$AttributesListItem = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUJ1p.FlexContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUJ1p.AttributeName), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUJ1p.AttributeValue), null));
const $68c9b64b8f09f8f3$export$1a33f1b535de2335 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68c9b64b8f09f8f3$var$AttributesListItem, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68c9b64b8f09f8f3$var$AttributesListItem, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68c9b64b8f09f8f3$var$AttributesListItem, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68c9b64b8f09f8f3$var$AttributesListItem, null));
const $68c9b64b8f09f8f3$export$7a6a12132903144d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUJ1p.LinkedIssueCard), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUJ1p.LinkedIssueCard), null));

});
parcelRegister("kUJ1p", function(module, exports) {

$parcel$export(module.exports, "FlexContainer", () => $efe2c0ff4cf562d0$export$124d4c7bf7db9715);
$parcel$export(module.exports, "Avatar", () => $efe2c0ff4cf562d0$export$e2255cf6045e8d47);
$parcel$export(module.exports, "Title", () => $efe2c0ff4cf562d0$export$f99233281efd08a0);
$parcel$export(module.exports, "AttributeName", () => $efe2c0ff4cf562d0$export$8b0888326e6c88ff);
$parcel$export(module.exports, "AttributeValue", () => $efe2c0ff4cf562d0$export$2a2a59a443c4e63e);
$parcel$export(module.exports, "LinkedIssueCard", () => $efe2c0ff4cf562d0$export$f27b9e35b8dd22a1);
/* styled.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $efe2c0ff4cf562d0$var$fromPositionX = -150;
const $efe2c0ff4cf562d0$var$toPositionX = 600;
const $efe2c0ff4cf562d0$var$shimmer = null;
const $efe2c0ff4cf562d0$export$c3b0ebed856b8b1a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rko1sit _5sag9cwz _1o51q7pw _tip812c5 _j7hq1id6 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk",
            __cmplp.className
        ])
    });
});
const $efe2c0ff4cf562d0$export$124d4c7bf7db9715 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginBottom: marginBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ik9eo": (0, $lD23V.default)(__cmplp.marginBottom ?? 0, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _otyrssky",
            __cmplp.className
        ])
    });
});
const $efe2c0ff4cf562d0$export$e2255cf6045e8d47 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $efe2c0ff4cf562d0$export$c3b0ebed856b8b1a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1bsb1ejb _4t3i1ejb _1o9zidpf _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $efe2c0ff4cf562d0$export$f99233281efd08a0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $efe2c0ff4cf562d0$export$c3b0ebed856b8b1a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1llu _4t3ipxbi",
            __cmplp.className
        ])
    });
});
const $efe2c0ff4cf562d0$export$8b0888326e6c88ff = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $efe2c0ff4cf562d0$export$c3b0ebed856b8b1a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _19pk1b66 _2hwxu2gc _otyr1b66 _18u0idpf _4t3ipxbi _1bsb93m8",
            __cmplp.className
        ])
    });
});
const $efe2c0ff4cf562d0$export$2a2a59a443c4e63e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $efe2c0ff4cf562d0$export$c3b0ebed856b8b1a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _19pk1b66 _2hwxidpf _otyr1b66 _18u0idpf _4t3ipxbi",
            __cmplp.className
        ])
    });
});
const $efe2c0ff4cf562d0$export$f27b9e35b8dd22a1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $efe2c0ff4cf562d0$export$c3b0ebed856b8b1a, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1b66 _2hwxu2gc _otyr1b66 _18u0idpf _4t3ixy5q",
            __cmplp.className
        ])
    });
});

});


parcelRegister("YYjXA", function(module, exports) {

$parcel$export(module.exports, "LinkedIssues", () => $56474e497218843a$export$22f152f6fc01fd93);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hTEpF = parcelRequire("hTEpF");

var $xBgAj = parcelRequire("xBgAj");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $bTyOW = parcelRequire("bTyOW");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $cTPVm = parcelRequire("cTPVm");

var $bMafH = parcelRequire("bMafH");

var $iW9pT = parcelRequire("iW9pT");

var $9k7Bb = parcelRequire("9k7Bb");
// @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
const $56474e497218843a$var$formatIssue = (issue)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const newIssue = {};
    newIssue.id = issue.id.toString();
    newIssue.isLoading = false;
    newIssue.issueSummary = issue.title;
    newIssue.issueKey = issue.key;
    newIssue.issueLink = `/browse/${issue.key || ''}`;
    newIssue.issueTypeName = issue.type.name;
    newIssue.issueTypeIconUrl = issue.type.iconUrl;
    newIssue.issuePriorityName = issue.priority ? issue.priority.name : '';
    newIssue.issuePriorityUrl = issue.priority ? issue.priority.iconUrl : '';
    newIssue.projectType = (0, $2vSU6.SERVICE_DESK_PROJECT);
    return newIssue;
};
const $56474e497218843a$var$ErrorState = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderImage = ()=>(0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $bTyOW.default))({
            imageWidth: 120,
            maxImageWidth: 120,
            maxImageHeight: 212
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        size: "wide",
        renderImage: renderImage,
        header: formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $9k7Bb.default).errorStateHeaderIssueTermRefresh : (0, $9k7Bb.default).errorStateHeader),
        description: formatMessage((0, $9k7Bb.default).errorStateDescription)
    });
};
const $56474e497218843a$export$22f152f6fc01fd93 = ({ objectId: objectId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ linkedIssues: linkedIssues, loading: loading, error: error, pages: pages, pageIndex: pageIndex }, { onPageChange: onPageChange }] = (0, $cTPVm.useObjectConnectedIssuesPaginated)(objectId);
    const linkedIssuesFormatted = (0, $5uXOq.useMemo)(()=>linkedIssues && linkedIssues.map((issue)=>$56474e497218843a$var$formatIssue(issue)), [
        linkedIssues
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iW9pT.LinkedIssuesSkeleton), null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($56474e497218843a$var$ErrorState, null);
    if (!linkedIssues || linkedIssues.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        "data-testid": "servicedesk-insight-object-graph.ui.object-view.linked-issues.empty-state"
    }, formatMessage((0, $4R6GH.fg)('itsm-issue-renaming') ? (0, $9k7Bb.default).noLinkedIssuesIssueTermRefresh : (0, $9k7Bb.default).noLinkedIssues));
    const handleClick = (event, page)=>{
        onPageChange(page);
    };
    return linkedIssuesFormatted && linkedIssuesFormatted.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($56474e497218843a$var$LinkedIssuesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bMafH.IssueLineCardGroup), {
        issues: linkedIssuesFormatted,
        groupId: "linked-issues-group"
    })), pages !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($56474e497218843a$var$PaginationWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xBgAj.default), {
        selectedIndex: pageIndex,
        pages: pages,
        onChange: handleClick
    }))) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $56474e497218843a$var$LinkedIssuesContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _n3tdu2gc _c71l1y37",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $56474e497218843a$var$PaginationWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("xBgAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaadfaafd170b3c$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $33etG = parcelRequire("33etG");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $5HBW9 = parcelRequire("5HBW9");

var $15F6T = parcelRequire("15F6T");

var $lmPue = parcelRequire("lmPue");

var $fc5SA = parcelRequire("fc5SA");

var $gRWrA = parcelRequire("gRWrA");
const $8aaadfaafd170b3c$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t",
    navigatorIconWrapper: "_18zr12x7"
};
const $8aaadfaafd170b3c$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))) : (0, (/*@__PURE__*/$parcel$interopDefault($6s76W)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        as: "span",
        xcss: $8aaadfaafd170b3c$var$styles.navigatorIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Chevron, {
        label: "",
        LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
        color: "currentColor"
    }));
}
function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, $fc5SA.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $fc5SA.emptyObject), max: max = 7, onChange: onChange = (0, $eGmKJ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $lmPue.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $33etG.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8aaadfaafd170b3c$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
            as: "li",
            xcss: $8aaadfaafd170b3c$var$styles.paginationMenuItem,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $15F6T.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBW9.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $8aaadfaafd170b3c$var$styles.paginationMenu
    }, (0, $gRWrA.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HBW9.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8aaadfaafd170b3c$var$Pagination = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;

});
parcelRegister("5HBW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $63acbbc2953d9b5a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("15F6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $097dd42f19f41562$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("lmPue", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d144cd0d91a90ab$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $jldZL = parcelRequire("jldZL");
const $3d144cd0d91a90ab$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $3d144cd0d91a90ab$var$styles.container,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("fc5SA", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $cbef1c2cfb373aca$export$3f860eba1218f8d3);
const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};

});

parcelRegister("gRWrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbac64848b775a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $8QpSo.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;

});


parcelRegister("cTPVm", function(module, exports) {

$parcel$export(module.exports, "useObjectConnectedIssuesPaginated", () => $53816a17def2d46f$export$94f8772416dd142f);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $xJtdX = parcelRequire("xJtdX");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3N1b3 = parcelRequire("3N1b3");

var $7DxXA = parcelRequire("7DxXA");

const $53816a17def2d46f$var$calculatePages = (data)=>{
    let pages;
    if (data && data.total > 0) pages = Array.from({
        length: Math.floor((data.total - 1) / (0, $697a794dbd3f059b$export$46c56510812d46b6)) + 1
    }, (_, i)=>i + 1);
    return pages;
};
const $53816a17def2d46f$export$94f8772416dd142f = (objectId, params)=>{
    const [selectedIndex, setSelectedIndex] = (0, $5uXOq.useState)(0);
    const { workspaceId: workspaceId } = (0, $7DxXA.useWorkspaceContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const request = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'startAt' implicitly has an 'any' type.
    ({ startAt: startAt })=>{
        if (!objectId) throw new Error('objectId undefined');
        if (!workspaceId) throw new Error('workspaceId undefined');
        return (0, $eusud.performGetRequest)((0, $3N1b3.getCmdbObjectConnectedTicketsPaginatedUrl)(workspaceId, objectId, {
            startAt: startAt,
            limit: (0, $697a794dbd3f059b$export$46c56510812d46b6),
            ...params?.filterId && {
                filterId: params.filterId
            },
            ...params?.textFilter && {
                textFilter: params.textFilter
            },
            hideResolved: params?.hideResolved
        })).then((res)=>{
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchObjectConnectedIssues succeeded');
            return res;
        }).catch((error)=>{
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'fetchObjectConnectedIssues',
                    packageName: 'jiraServicedeskInsightObjectServices',
                    teamName: 'falcons'
                }
            });
            throw error;
        });
    }, [
        createAnalyticsEvent,
        objectId,
        workspaceId,
        params?.filterId,
        params?.textFilter,
        params?.hideResolved
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(request);
    // Auto fetch connected issues when hook is called
    (0, $5uXOq.useEffect)(()=>{
        if (workspaceId) fetch({
            startAt: 0
        });
    }, [
        fetch,
        objectId,
        workspaceId
    ]);
    const onPageChange = (pageNumber)=>{
        const requestedPage = pageNumber >= 1 ? pageNumber : 1;
        setSelectedIndex(requestedPage - 1);
        fetch({
            startAt: (requestedPage - 1) * (0, $697a794dbd3f059b$export$46c56510812d46b6)
        });
    };
    return [
        {
            loading: loading,
            error: error,
            jqlString: data?.allTicketsQuery,
            linkedIssues: data?.values,
            pages: $53816a17def2d46f$var$calculatePages(data),
            pageIndex: selectedIndex
        },
        {
            onPageChange: onPageChange
        }
    ];
};

});
parcelRegister("3N1b3", function(module, exports) {

$parcel$export(module.exports, "getCmdbObjectConnectedTicketsPaginatedUrl", () => $5d44dc1937194796$export$d2e9d2efad0b629c);

var $ebyGx = parcelRequire("ebyGx");

var $klJ8b = parcelRequire("klJ8b");
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectconnectedtickets/${objectId}
 */ const $5d44dc1937194796$var$getCmdbObjectConnectedTicketsBaseUrl = (workspaceId, objectId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/objectconnectedtickets/${objectId}`;
const $5d44dc1937194796$export$d1579cbefb941ecf = (workspaceId, objectId, filterQueryParams = {})=>{
    const url = `${$5d44dc1937194796$var$getCmdbObjectConnectedTicketsBaseUrl(workspaceId, objectId)}/tickets`;
    const encodedQueryParams = (0, $ebyGx.stringify)(filterQueryParams);
    if (encodedQueryParams) return `${url}?${encodedQueryParams}`;
    return url;
};
const $5d44dc1937194796$export$d2e9d2efad0b629c = (workspaceId, objectId, queryParams)=>`${$5d44dc1937194796$var$getCmdbObjectConnectedTicketsBaseUrl(workspaceId, objectId)}/paginatedtickets?${(0, $ebyGx.stringify)(queryParams)}`;

});

const $697a794dbd3f059b$export$46c56510812d46b6 = 10;


parcelRegister("bMafH", function(module, exports) {

$parcel$export(module.exports, "IssueLineCardGroup", () => $157f36d255497673$export$32d4eb7126135529);

var $5uXOq = parcelRequire("5uXOq");

var $6nxs0 = parcelRequire("6nxs0");

var $c9mvf = parcelRequire("c9mvf");
class $157f36d255497673$export$32d4eb7126135529 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isReorderEnabled: false,
            isInteractive: true,
            projectType: null
        };
    }
    render() {
        const { issues: issues, onOrderChange: onOrderChange, groupId: groupId, isReorderEnabled: isReorderEnabled, isInteractive: isInteractive, projectType: projectType } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6nxs0.default), {
            items: issues,
            onOrderChange: onOrderChange,
            groupId: groupId,
            isReorderEnabled: isReorderEnabled,
            isInteractive: isInteractive,
            onClick: this.handleClick
        }, (isHovering, isActive, isFocused, issue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9mvf.default), {
                isHovering: isHovering,
                isActive: isActive,
                isFocused: isFocused,
                isDraggable: isReorderEnabled,
                isInteractive: isInteractive,
                issueId: issue.id,
                // @ts-expect-error - TS2783 - 'projectType' is specified more than once, so this usage will be overwritten.
                projectType: projectType,
                ...issue
            }));
    }
    constructor(...args){
        super(...args), this.handleClick = (issue)=>{
            if (issue.issueLink !== null && issue.issueLink !== undefined && issue.issueLink !== '') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(issue.issueLink, '_blank');
        };
    }
}

});
parcelRegister("6nxs0", function(module, exports) {

$parcel$export(module.exports, "default", () => $593710f92ed0421a$export$2e2bcd8739ae039);
/* item-line-card-group-view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2Zxiy = parcelRequire("2Zxiy");

var $b71gk = parcelRequire("b71gk");

var $2OMDV = parcelRequire("2OMDV");

var $jRpyT = parcelRequire("jRpyT");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $593710f92ed0421a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _2mzuglyw _16qs1os1 _bfhked01 _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf",
            __cmplp.className
        ])
    });
});
const $593710f92ed0421a$export$f27f87a07355c60b = (0, $2OMDV.AnalyticsEventToProps)('issueRank', {
    onDragEnd: 'updated'
})((0, $2Zxiy.DragDropContext));
class $593710f92ed0421a$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isReorderEnabled: false,
            isInteractive: true,
            isVariableHeightCards: false,
            onOrderChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    renderCards(cardsProps = {}) {
        const { isReorderEnabled: isReorderEnabled, isInteractive: isInteractive, isVariableHeightCards: isVariableHeightCards, onClick: onClick } = this.props;
        const { placeholder: placeholder, ...rest } = cardsProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($593710f92ed0421a$var$Container, rest, this.props.items.map((item, index)=>{
            const itemLineCardProps = {
                key: item.id,
                item: item,
                index: index,
                isReorderEnabled: isReorderEnabled,
                isInteractive: isInteractive,
                isVariableHeight: isVariableHeightCards,
                onClick: onClick,
                children: this.props.children
            };
            const itemLineCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
                key: item.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRpyT.default), itemLineCardProps));
            return itemLineCard;
        }), placeholder);
    }
    renderDraggableCards() {
        const dragDropContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($593710f92ed0421a$export$f27f87a07355c60b, {
            onDragEnd: this.onDragEnd
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Zxiy.Droppable), {
            droppableId: this.props.groupId
        }, (provided, snapshot)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, this.renderCards({
                isDraggingOver: snapshot.isDraggingOver,
                placeholder: provided.placeholder,
                ref: provided.innerRef
            }))));
        return dragDropContext;
    }
    render() {
        if (!this.props.isReorderEnabled) return this.renderCards();
        return this.renderDraggableCards();
    }
    constructor(...args){
        super(...args), this.onDragEnd = (result, provided, analyticsEvent)=>{
            const { source: source } = result;
            const { destination: destination } = result;
            if (!destination || source.droppableId !== destination.droppableId) return;
            const items = [
                ...this.props.items
            ];
            const target = items.find((item)=>item.id === result.draggableId);
            if (!target) return;
            // Move the dropped item into the correct spot
            items.splice(source.index, 1);
            items.splice(destination.index, 0, target);
            this.props.onOrderChange(items, target, source.index, destination.index, analyticsEvent);
        };
    }
}

});
parcelRegister("2Zxiy", function(module, exports) {

$parcel$export(module.exports, "DragDropContext", () => $22db1ba098eb3017$export$237bd83162c14364);
$parcel$export(module.exports, "Draggable", () => $22db1ba098eb3017$export$f2a139e5d18b9882);
$parcel$export(module.exports, "Droppable", () => $22db1ba098eb3017$export$423ec2075359570a);

var $5uXOq = parcelRequire("5uXOq");

var $3YMLK = parcelRequire("3YMLK");

var $1AwyE = parcelRequire("1AwyE");

var $gzM5u = parcelRequire("gzM5u");

var $22j3V = parcelRequire("22j3V");
parcelRequire("i6AsN");
var $AuRrZ = parcelRequire("AuRrZ");
var $9bdMd = parcelRequire("9bdMd");

var $3YKxB = parcelRequire("3YKxB");

var $g7psY = parcelRequire("g7psY");

var $i2aN7 = parcelRequire("i2aN7");

var $cs3hJ = parcelRequire("cs3hJ");

var $crAmF = parcelRequire("crAmF");

var $3BSY2 = parcelRequire("3BSY2");

var $4iZOV = parcelRequire("4iZOV");

var $7nsd3 = parcelRequire("7nsd3");

var $1DIXK = parcelRequire("1DIXK");
var $22db1ba098eb3017$var$isProduction = true;
var $22db1ba098eb3017$var$spacesAndTabs = /[ \t]{2,}/g;
var $22db1ba098eb3017$var$lineStartWithSpaces = /^[ \t]*/gm;
var $22db1ba098eb3017$var$clean = function clean(value) {
    return value.replace($22db1ba098eb3017$var$spacesAndTabs, ' ').replace($22db1ba098eb3017$var$lineStartWithSpaces, '').trim();
};
var $22db1ba098eb3017$var$getDevMessage = function getDevMessage(message) {
    return $22db1ba098eb3017$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $22db1ba098eb3017$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $22db1ba098eb3017$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $22db1ba098eb3017$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
};
var $22db1ba098eb3017$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function $22db1ba098eb3017$var$log(type, message) {
    var _console;
    if ($22db1ba098eb3017$var$isProduction) return;
    if (typeof window !== 'undefined' && window[$22db1ba098eb3017$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $22db1ba098eb3017$var$getFormattedMessage(message));
}
var $22db1ba098eb3017$var$warning = $22db1ba098eb3017$var$log.bind(null, 'warn');
var $22db1ba098eb3017$var$error = $22db1ba098eb3017$var$log.bind(null, 'error');
function $22db1ba098eb3017$var$noop() {}
function $22db1ba098eb3017$var$getOptions(shared, fromBinding) {
    return (0, $gzM5u.default)({}, shared, fromBinding);
}
function $22db1ba098eb3017$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $22db1ba098eb3017$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $22db1ba098eb3017$var$isProduction$1 = true;
var $22db1ba098eb3017$var$prefix = 'Invariant failed';
function $22db1ba098eb3017$var$RbdInvariant(message) {
    this.message = message;
}
$22db1ba098eb3017$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $22db1ba098eb3017$var$invariant(condition, message) {
    if (condition) return;
    if ($22db1ba098eb3017$var$isProduction$1) throw new $22db1ba098eb3017$var$RbdInvariant($22db1ba098eb3017$var$prefix);
    else throw new $22db1ba098eb3017$var$RbdInvariant($22db1ba098eb3017$var$prefix + ": " + (message || ''));
}
var $22db1ba098eb3017$var$ErrorBoundary = function(_React$Component) {
    (0, $1AwyE.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $22db1ba098eb3017$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $22db1ba098eb3017$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $22db1ba098eb3017$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $22db1ba098eb3017$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
var $22db1ba098eb3017$var$liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";
var $22db1ba098eb3017$var$position = function position(index) {
    return index + 1;
};
var $22db1ba098eb3017$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $22db1ba098eb3017$var$position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};
var $22db1ba098eb3017$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $22db1ba098eb3017$var$position(source.index);
    var endPosition = $22db1ba098eb3017$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $22db1ba098eb3017$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $22db1ba098eb3017$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $22db1ba098eb3017$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $22db1ba098eb3017$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
var $22db1ba098eb3017$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $22db1ba098eb3017$var$position(source.index) + "\n";
};
var $22db1ba098eb3017$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $22db1ba098eb3017$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $22db1ba098eb3017$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $22db1ba098eb3017$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $22db1ba098eb3017$var$returnedToStart(result.source) + "\n  ";
};
var $22db1ba098eb3017$var$preset = {
    liftInstruction: $22db1ba098eb3017$var$liftInstruction,
    onDragStart: $22db1ba098eb3017$var$onDragStart,
    onDragUpdate: $22db1ba098eb3017$var$onDragUpdate,
    onDragEnd: $22db1ba098eb3017$var$onDragEnd
};
var $22db1ba098eb3017$var$origin = {
    x: 0,
    y: 0
};
var $22db1ba098eb3017$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $22db1ba098eb3017$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $22db1ba098eb3017$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $22db1ba098eb3017$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $22db1ba098eb3017$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var $22db1ba098eb3017$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $22db1ba098eb3017$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $22db1ba098eb3017$var$distance(target, point);
    }));
};
var $22db1ba098eb3017$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $22db1ba098eb3017$var$executeClip = function(frame, subject) {
    var result = (0, $3YKxB.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $22db1ba098eb3017$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $22db1ba098eb3017$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $22db1ba098eb3017$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $22db1ba098eb3017$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $22db1ba098eb3017$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $22db1ba098eb3017$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $gzM5u.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $22db1ba098eb3017$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $22db1ba098eb3017$var$executeClip(frame.pageMarginBox, target);
    return (0, $3YKxB.getRect)(target);
};
var $22db1ba098eb3017$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $22db1ba098eb3017$var$scroll(page.marginBox, frame);
    var increased = $22db1ba098eb3017$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $22db1ba098eb3017$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $22db1ba098eb3017$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $22db1ba098eb3017$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $22db1ba098eb3017$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $22db1ba098eb3017$var$negate(scrollDiff);
    var frame = (0, $gzM5u.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $22db1ba098eb3017$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $gzM5u.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $22db1ba098eb3017$var$values(map) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($i2aN7)))(map);
}
function $22db1ba098eb3017$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $22db1ba098eb3017$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $22db1ba098eb3017$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $22db1ba098eb3017$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $22db1ba098eb3017$var$toDroppableMap = (0, $g7psY.default)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $22db1ba098eb3017$var$toDraggableMap = (0, $g7psY.default)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $22db1ba098eb3017$var$toDroppableList = (0, $g7psY.default)(function(droppables) {
    return $22db1ba098eb3017$var$values(droppables);
});
var $22db1ba098eb3017$var$toDraggableList = (0, $g7psY.default)(function(draggables) {
    return $22db1ba098eb3017$var$values(draggables);
});
var $22db1ba098eb3017$var$getDraggablesInsideDroppable = (0, $g7psY.default)(function(droppableId, draggables) {
    var result = $22db1ba098eb3017$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $22db1ba098eb3017$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $22db1ba098eb3017$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $22db1ba098eb3017$var$removeDraggableFromList = (0, $g7psY.default)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $22db1ba098eb3017$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $22db1ba098eb3017$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $gzM5u.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $22db1ba098eb3017$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $22db1ba098eb3017$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $22db1ba098eb3017$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $22db1ba098eb3017$var$noDisplacedBy = {
    point: $22db1ba098eb3017$var$origin,
    value: 0
};
var $22db1ba098eb3017$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $22db1ba098eb3017$var$noImpact = {
    displaced: $22db1ba098eb3017$var$emptyGroups,
    displacedBy: $22db1ba098eb3017$var$noDisplacedBy,
    at: null
};
var $22db1ba098eb3017$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $22db1ba098eb3017$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $22db1ba098eb3017$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $22db1ba098eb3017$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
var $22db1ba098eb3017$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $22db1ba098eb3017$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $22db1ba098eb3017$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $22db1ba098eb3017$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $22db1ba098eb3017$var$origin;
    return $22db1ba098eb3017$var$offsetByPosition(target, displacement);
};
var $22db1ba098eb3017$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $22db1ba098eb3017$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $22db1ba098eb3017$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $22db1ba098eb3017$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $22db1ba098eb3017$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $22db1ba098eb3017$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $22db1ba098eb3017$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $22db1ba098eb3017$var$isVisible((0, $gzM5u.default)({}, args, {
        isVisibleThroughFrameFn: $22db1ba098eb3017$var$isPartiallyVisibleThroughFrame
    }));
};
var $22db1ba098eb3017$var$isTotallyVisible = function isTotallyVisible(args) {
    return $22db1ba098eb3017$var$isVisible((0, $gzM5u.default)({}, args, {
        isVisibleThroughFrameFn: $22db1ba098eb3017$var$isTotallyVisibleThroughFrame
    }));
};
var $22db1ba098eb3017$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $22db1ba098eb3017$var$isVisible((0, $gzM5u.default)({}, args, {
        isVisibleThroughFrameFn: $22db1ba098eb3017$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $22db1ba098eb3017$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $22db1ba098eb3017$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $3YKxB.getRect)((0, $3YKxB.expand)(marginBox, expandBy));
}
function $22db1ba098eb3017$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $22db1ba098eb3017$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $22db1ba098eb3017$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $22db1ba098eb3017$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $22db1ba098eb3017$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $22db1ba098eb3017$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $22db1ba098eb3017$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $22db1ba098eb3017$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $22db1ba098eb3017$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $22db1ba098eb3017$var$isHomeOf(draggable, destination);
    if (index == null) return $22db1ba098eb3017$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $22db1ba098eb3017$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $22db1ba098eb3017$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $22db1ba098eb3017$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $22db1ba098eb3017$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $22db1ba098eb3017$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $22db1ba098eb3017$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $22db1ba098eb3017$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $22db1ba098eb3017$var$invariant(false);
    if (wasAt.type === 'REORDER') {
        var _newIndex = $22db1ba098eb3017$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $22db1ba098eb3017$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $22db1ba098eb3017$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $22db1ba098eb3017$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $22db1ba098eb3017$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($22db1ba098eb3017$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $22db1ba098eb3017$var$origin : $22db1ba098eb3017$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $22db1ba098eb3017$var$origin;
};
var $22db1ba098eb3017$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $22db1ba098eb3017$var$tryGetCombine(impact);
    !combine && $22db1ba098eb3017$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $22db1ba098eb3017$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $22db1ba098eb3017$var$add(center, displaceBy);
};
var $22db1ba098eb3017$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $22db1ba098eb3017$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $22db1ba098eb3017$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $22db1ba098eb3017$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $22db1ba098eb3017$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $22db1ba098eb3017$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $22db1ba098eb3017$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $22db1ba098eb3017$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $22db1ba098eb3017$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $22db1ba098eb3017$var$patch(axis.line, moveInto.contentBox[axis.start] + $22db1ba098eb3017$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $22db1ba098eb3017$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $22db1ba098eb3017$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $22db1ba098eb3017$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($22db1ba098eb3017$var$didStartAfterCritical(closestAfter, afterCritical)) return $22db1ba098eb3017$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $3YKxB.offset)(closest.page, displacedBy.point);
        return $22db1ba098eb3017$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($22db1ba098eb3017$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $3YKxB.offset)(last.page, $22db1ba098eb3017$var$negate(afterCritical.displacedBy.point));
        return $22db1ba098eb3017$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $22db1ba098eb3017$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $22db1ba098eb3017$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $22db1ba098eb3017$var$add(point, frame.scroll.diff.displacement);
};
var $22db1ba098eb3017$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $22db1ba098eb3017$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $22db1ba098eb3017$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $22db1ba098eb3017$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $22db1ba098eb3017$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $22db1ba098eb3017$var$scrollViewport = function(viewport, newScroll) {
    var diff = $22db1ba098eb3017$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $22db1ba098eb3017$var$negate(diff);
    var frame = (0, $3YKxB.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $22db1ba098eb3017$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $22db1ba098eb3017$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $22db1ba098eb3017$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $22db1ba098eb3017$var$scrollViewport(viewport, $22db1ba098eb3017$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $22db1ba098eb3017$var$scrollDroppable(destination, $22db1ba098eb3017$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: $22db1ba098eb3017$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: $22db1ba098eb3017$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $22db1ba098eb3017$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $gzM5u.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $22db1ba098eb3017$var$withViewportDisplacement = function(viewport, point) {
    return $22db1ba098eb3017$var$add(viewport.scroll.diff.displacement, point);
};
var $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $22db1ba098eb3017$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $22db1ba098eb3017$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $22db1ba098eb3017$var$add(draggable.client.borderBox.center, offset);
};
var $22db1ba098eb3017$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $22db1ba098eb3017$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $22db1ba098eb3017$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $22db1ba098eb3017$var$isTotallyVisibleOnAxis(args) : $22db1ba098eb3017$var$isTotallyVisible(args);
};
var $22db1ba098eb3017$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $22db1ba098eb3017$var$isHomeOf(draggable, destination);
    var impact = $22db1ba098eb3017$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $22db1ba098eb3017$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $22db1ba098eb3017$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $22db1ba098eb3017$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $22db1ba098eb3017$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $22db1ba098eb3017$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $22db1ba098eb3017$var$invariant(false);
    return rect;
};
var $22db1ba098eb3017$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $22db1ba098eb3017$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $22db1ba098eb3017$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $22db1ba098eb3017$var$isPartiallyVisibleThroughFrame(viewport.frame)($22db1ba098eb3017$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $22db1ba098eb3017$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $22db1ba098eb3017$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $22db1ba098eb3017$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $22db1ba098eb3017$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $22db1ba098eb3017$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $22db1ba098eb3017$var$getKnownActive(droppable)[axis.crossAxisStart] === $22db1ba098eb3017$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $22db1ba098eb3017$var$isWithin($22db1ba098eb3017$var$getKnownActive(droppable)[axis.start], $22db1ba098eb3017$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $22db1ba098eb3017$var$getKnownActive(a)[axis.start] - $22db1ba098eb3017$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $22db1ba098eb3017$var$closest(pageBorderBoxCenter, $22db1ba098eb3017$var$getCorners($22db1ba098eb3017$var$getKnownActive(a)));
        var second = $22db1ba098eb3017$var$closest(pageBorderBoxCenter, $22db1ba098eb3017$var$getCorners($22db1ba098eb3017$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $22db1ba098eb3017$var$getKnownActive(a)[axis.start] - $22db1ba098eb3017$var$getKnownActive(b)[axis.start];
    })[0];
};
var $22db1ba098eb3017$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $22db1ba098eb3017$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $22db1ba098eb3017$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $22db1ba098eb3017$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $22db1ba098eb3017$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $22db1ba098eb3017$var$offsetByPosition(original, $22db1ba098eb3017$var$negate(afterCritical.displacedBy.point)) : original;
};
var $22db1ba098eb3017$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $22db1ba098eb3017$var$isTotallyVisible({
            target: $22db1ba098eb3017$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $22db1ba098eb3017$var$distance(pageBorderBoxCenter, $22db1ba098eb3017$var$withDroppableDisplacement(destination, $22db1ba098eb3017$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $22db1ba098eb3017$var$distance(pageBorderBoxCenter, $22db1ba098eb3017$var$withDroppableDisplacement(destination, $22db1ba098eb3017$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $22db1ba098eb3017$var$getDisplacedBy = (0, $g7psY.default)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $22db1ba098eb3017$var$patch(axis.line, displacement)
    };
});
var $22db1ba098eb3017$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $22db1ba098eb3017$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $22db1ba098eb3017$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $22db1ba098eb3017$var$patch(axis.line, needsToGrowBy);
};
var $22db1ba098eb3017$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $gzM5u.default)({}, frame, {
        scroll: (0, $gzM5u.default)({}, frame.scroll, {
            max: max
        })
    });
};
var $22db1ba098eb3017$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$22db1ba098eb3017$var$isHomeOf(draggable, droppable) && $22db1ba098eb3017$var$invariant(false);
    !!droppable.subject.withPlaceholder && $22db1ba098eb3017$var$invariant(false);
    var placeholderSize = $22db1ba098eb3017$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $22db1ba098eb3017$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $22db1ba098eb3017$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $gzM5u.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $22db1ba098eb3017$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $22db1ba098eb3017$var$withMaxScroll(frame, maxScroll);
    var subject = $22db1ba098eb3017$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $gzM5u.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $22db1ba098eb3017$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $22db1ba098eb3017$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $22db1ba098eb3017$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $gzM5u.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $22db1ba098eb3017$var$invariant(false);
    var newFrame = $22db1ba098eb3017$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $22db1ba098eb3017$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $gzM5u.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $22db1ba098eb3017$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $22db1ba098eb3017$var$emptyGroups,
            displacedBy: $22db1ba098eb3017$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $22db1ba098eb3017$var$isHomeOf(draggable, destination) ? destination : $22db1ba098eb3017$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $22db1ba098eb3017$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $22db1ba098eb3017$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $22db1ba098eb3017$var$emptyGroups,
        index: proposedIndex
    });
};
var $22db1ba098eb3017$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $22db1ba098eb3017$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $22db1ba098eb3017$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $22db1ba098eb3017$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $22db1ba098eb3017$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
var $22db1ba098eb3017$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $22db1ba098eb3017$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $22db1ba098eb3017$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $22db1ba098eb3017$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $22db1ba098eb3017$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $22db1ba098eb3017$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $22db1ba098eb3017$var$isPositionInFrame(frame) {
    var isWithinVertical = $22db1ba098eb3017$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $22db1ba098eb3017$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $22db1ba098eb3017$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $22db1ba098eb3017$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $22db1ba098eb3017$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $22db1ba098eb3017$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $22db1ba098eb3017$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $22db1ba098eb3017$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$22db1ba098eb3017$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($22db1ba098eb3017$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $22db1ba098eb3017$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $22db1ba098eb3017$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $22db1ba098eb3017$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $3YKxB.getRect)($22db1ba098eb3017$var$offsetByPosition(rect, point));
};
var $22db1ba098eb3017$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $22db1ba098eb3017$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $22db1ba098eb3017$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $22db1ba098eb3017$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $22db1ba098eb3017$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $22db1ba098eb3017$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $22db1ba098eb3017$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $22db1ba098eb3017$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $22db1ba098eb3017$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $22db1ba098eb3017$var$isHomeOf(draggable, destination)
    });
    return $22db1ba098eb3017$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $22db1ba098eb3017$var$combineThresholdDivisor = 4;
var $22db1ba098eb3017$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $22db1ba098eb3017$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $22db1ba098eb3017$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $22db1ba098eb3017$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $22db1ba098eb3017$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $22db1ba098eb3017$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $22db1ba098eb3017$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $22db1ba098eb3017$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $22db1ba098eb3017$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $22db1ba098eb3017$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $22db1ba098eb3017$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $22db1ba098eb3017$var$withDroppableScroll(destination, pageBorderBox);
    return $22db1ba098eb3017$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $22db1ba098eb3017$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $22db1ba098eb3017$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $gzM5u.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $22db1ba098eb3017$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $22db1ba098eb3017$var$whatIsDraggedOver(previousImpact);
    var now = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $22db1ba098eb3017$var$removePlaceholder(lastDroppable);
    return $22db1ba098eb3017$var$patchDroppableMap(droppables, updated);
};
var $22db1ba098eb3017$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $22db1ba098eb3017$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($22db1ba098eb3017$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $22db1ba098eb3017$var$addPlaceholder(droppable, draggable, draggables);
    return $22db1ba098eb3017$var$patchDroppableMap(cleaned, patched);
};
var $22db1ba098eb3017$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $22db1ba098eb3017$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $22db1ba098eb3017$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $22db1ba098eb3017$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $22db1ba098eb3017$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return (0, $gzM5u.default)({
        phase: 'COLLECTING'
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $22db1ba098eb3017$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $22db1ba098eb3017$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $gzM5u.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $22db1ba098eb3017$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $22db1ba098eb3017$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $22db1ba098eb3017$var$getDraggables$1(last.all, draggables);
    var displaced = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $gzM5u.default)({}, impact, {
        displaced: displaced
    });
};
var $22db1ba098eb3017$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $22db1ba098eb3017$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $22db1ba098eb3017$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $22db1ba098eb3017$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === 'SNAP') && $22db1ba098eb3017$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $22db1ba098eb3017$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $22db1ba098eb3017$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $22db1ba098eb3017$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $22db1ba098eb3017$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $22db1ba098eb3017$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $22db1ba098eb3017$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $22db1ba098eb3017$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $22db1ba098eb3017$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $22db1ba098eb3017$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $22db1ba098eb3017$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $22db1ba098eb3017$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $22db1ba098eb3017$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $22db1ba098eb3017$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $22db1ba098eb3017$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $22db1ba098eb3017$var$records = {};
var $22db1ba098eb3017$var$isEnabled = false;
var $22db1ba098eb3017$var$isTimingsEnabled = function isTimingsEnabled() {
    return $22db1ba098eb3017$var$isEnabled;
};
var $22db1ba098eb3017$var$start = function start(key) {
    var now;
};
var $22db1ba098eb3017$var$finish = function finish(key) {
    var now, previous, result, rounded, style;
};
var $22db1ba098eb3017$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $3YKxB.offset)(draggable.client, offset$1);
    var page = (0, $3YKxB.withScroll)(client, initialWindowScroll);
    var moved = (0, $gzM5u.default)({}, draggable, {
        placeholder: (0, $gzM5u.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $22db1ba098eb3017$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $22db1ba098eb3017$var$invariant(false);
    return frame;
};
var $22db1ba098eb3017$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $22db1ba098eb3017$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $22db1ba098eb3017$var$add(windowScrollChange, droppableScrollChange);
        var moved = $22db1ba098eb3017$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $22db1ba098eb3017$var$timingsKey = 'Processing dynamic changes';
var $22db1ba098eb3017$var$publishWhileDraggingInVirtual = function(_ref) {
    var _extends2, _extends3;
    var state = _ref.state, published = _ref.published;
    $22db1ba098eb3017$var$start($22db1ba098eb3017$var$timingsKey);
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $22db1ba098eb3017$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $gzM5u.default)({}, state.dimensions.droppables, $22db1ba098eb3017$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $22db1ba098eb3017$var$toDraggableMap($22db1ba098eb3017$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $gzM5u.default)({}, state.dimensions.draggables, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $22db1ba098eb3017$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $22db1ba098eb3017$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $22db1ba098eb3017$var$finish($22db1ba098eb3017$var$timingsKey);
    var draggingState = (0, $gzM5u.default)({
        phase: 'DRAGGING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));
    if (state.phase === 'COLLECTING') return draggingState;
    var dropPending = (0, $gzM5u.default)({
        phase: 'DROP_PENDING'
    }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
    return dropPending;
};
var $22db1ba098eb3017$var$isSnapping = function isSnapping(state) {
    return state.movementMode === 'SNAP';
};
var $22db1ba098eb3017$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $22db1ba098eb3017$var$patchDimensionMap(state.dimensions, updated);
    if (!$22db1ba098eb3017$var$isSnapping(state) || isEnabledChanging) return $22db1ba098eb3017$var$update({
        state: state,
        dimensions: dimensions
    });
    return $22db1ba098eb3017$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $22db1ba098eb3017$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return (0, $gzM5u.default)({
        phase: 'DRAGGING'
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $22db1ba098eb3017$var$idle = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $22db1ba098eb3017$var$reducer = function(state, action) {
    if (state === void 0) state = $22db1ba098eb3017$var$idle;
    if (action.type === 'FLUSH') return (0, $gzM5u.default)({}, $22db1ba098eb3017$var$idle, {
        shouldFlush: true
    });
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $22db1ba098eb3017$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.initial),
                offset: $22db1ba098eb3017$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $22db1ba098eb3017$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $22db1ba098eb3017$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        var _extends2;
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $22db1ba098eb3017$var$invariant(false);
        var _result = (0, $gzM5u.default)({
            phase: 'COLLECTING'
        }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));
        return _result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $22db1ba098eb3017$var$invariant(false);
        return $22db1ba098eb3017$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($22db1ba098eb3017$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $22db1ba098eb3017$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $22db1ba098eb3017$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $22db1ba098eb3017$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $22db1ba098eb3017$var$removeScrollJumpRequest(state);
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $22db1ba098eb3017$var$scrollDroppable(target, newScroll);
        return $22db1ba098eb3017$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $22db1ba098eb3017$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $22db1ba098eb3017$var$invariant(false);
        var updated = (0, $gzM5u.default)({}, _target, {
            isEnabled: isEnabled
        });
        return $22db1ba098eb3017$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $22db1ba098eb3017$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $22db1ba098eb3017$var$invariant(false);
        var _updated = (0, $gzM5u.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $22db1ba098eb3017$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$22db1ba098eb3017$var$isMovementAllowed(state) && $22db1ba098eb3017$var$invariant(false);
        !state.isWindowScrollAllowed && $22db1ba098eb3017$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($22db1ba098eb3017$var$isEqual(state.viewport.scroll.current, _newScroll)) return $22db1ba098eb3017$var$removeScrollJumpRequest(state);
        var _viewport = $22db1ba098eb3017$var$scrollViewport(state.viewport, _newScroll);
        if ($22db1ba098eb3017$var$isSnapping(state)) return $22db1ba098eb3017$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $22db1ba098eb3017$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$22db1ba098eb3017$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($22db1ba098eb3017$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $gzM5u.default)({}, state.viewport, {
            scroll: (0, $gzM5u.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $gzM5u.default)({
            phase: 'DRAGGING'
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $22db1ba098eb3017$var$invariant(false);
        var _result2 = $22db1ba098eb3017$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $22db1ba098eb3017$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        var _extends3;
        var reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $22db1ba098eb3017$var$invariant(false);
        var newState = (0, $gzM5u.default)({
            phase: 'DROP_PENDING'
        }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $22db1ba098eb3017$var$invariant(false);
        var _result3 = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === 'DROP_COMPLETE') {
        var _completed = action.payload.completed;
        return {
            phase: 'IDLE',
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $22db1ba098eb3017$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    };
};
var $22db1ba098eb3017$var$lift = function lift(args) {
    return {
        type: 'LIFT',
        payload: args
    };
};
var $22db1ba098eb3017$var$initialPublish = function initialPublish(args) {
    return {
        type: 'INITIAL_PUBLISH',
        payload: args
    };
};
var $22db1ba098eb3017$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    };
};
var $22db1ba098eb3017$var$collectionStarting = function collectionStarting() {
    return {
        type: 'COLLECTION_STARTING',
        payload: null
    };
};
var $22db1ba098eb3017$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    };
};
var $22db1ba098eb3017$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    };
};
var $22db1ba098eb3017$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    };
};
var $22db1ba098eb3017$var$move = function move(args) {
    return {
        type: 'MOVE',
        payload: args
    };
};
var $22db1ba098eb3017$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    };
};
var $22db1ba098eb3017$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    };
};
var $22db1ba098eb3017$var$moveUp = function moveUp() {
    return {
        type: 'MOVE_UP',
        payload: null
    };
};
var $22db1ba098eb3017$var$moveDown = function moveDown() {
    return {
        type: 'MOVE_DOWN',
        payload: null
    };
};
var $22db1ba098eb3017$var$moveRight = function moveRight() {
    return {
        type: 'MOVE_RIGHT',
        payload: null
    };
};
var $22db1ba098eb3017$var$moveLeft = function moveLeft() {
    return {
        type: 'MOVE_LEFT',
        payload: null
    };
};
var $22db1ba098eb3017$var$flush = function flush() {
    return {
        type: 'FLUSH',
        payload: null
    };
};
var $22db1ba098eb3017$var$animateDrop = function animateDrop(args) {
    return {
        type: 'DROP_ANIMATE',
        payload: args
    };
};
var $22db1ba098eb3017$var$completeDrop = function completeDrop(args) {
    return {
        type: 'DROP_COMPLETE',
        payload: args
    };
};
var $22db1ba098eb3017$var$drop = function drop(args) {
    return {
        type: 'DROP',
        payload: args
    };
};
var $22db1ba098eb3017$var$dropPending = function dropPending(args) {
    return {
        type: 'DROP_PENDING',
        payload: args
    };
};
var $22db1ba098eb3017$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    };
};
function $22db1ba098eb3017$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cs3hJ)))(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(', ');
}
function $22db1ba098eb3017$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $22db1ba098eb3017$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($22db1ba098eb3017$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
                dispatch($22db1ba098eb3017$var$flush());
                dispatch($22db1ba098eb3017$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $22db1ba098eb3017$var$validateDimensions(critical, dimensions);
                dispatch($22db1ba098eb3017$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $22db1ba098eb3017$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
        };
    };
};
var $22db1ba098eb3017$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
var $22db1ba098eb3017$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $22db1ba098eb3017$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $22db1ba098eb3017$var$outOfTheWayTiming = $22db1ba098eb3017$var$timings.outOfTheWay + "s " + $22db1ba098eb3017$var$curves.outOfTheWay;
var $22db1ba098eb3017$var$transitions = {
    fluid: "opacity " + $22db1ba098eb3017$var$outOfTheWayTiming,
    snap: "transform " + $22db1ba098eb3017$var$outOfTheWayTiming + ", opacity " + $22db1ba098eb3017$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $22db1ba098eb3017$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $22db1ba098eb3017$var$outOfTheWayTiming,
    placeholder: "height " + $22db1ba098eb3017$var$outOfTheWayTiming + ", width " + $22db1ba098eb3017$var$outOfTheWayTiming + ", margin " + $22db1ba098eb3017$var$outOfTheWayTiming
};
var $22db1ba098eb3017$var$moveTo = function moveTo(offset) {
    return $22db1ba098eb3017$var$isEqual(offset, $22db1ba098eb3017$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $22db1ba098eb3017$var$transforms = {
    moveTo: $22db1ba098eb3017$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $22db1ba098eb3017$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $22db1ba098eb3017$var$combine.scale.drop + ")";
    }
};
var $22db1ba098eb3017$var$minDropTime = $22db1ba098eb3017$var$timings.minDropTime, $22db1ba098eb3017$var$maxDropTime = $22db1ba098eb3017$var$timings.maxDropTime;
var $22db1ba098eb3017$var$dropTimeRange = $22db1ba098eb3017$var$maxDropTime - $22db1ba098eb3017$var$minDropTime;
var $22db1ba098eb3017$var$maxDropTimeAtDistance = 1500;
var $22db1ba098eb3017$var$cancelDropModifier = 0.6;
var $22db1ba098eb3017$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $22db1ba098eb3017$var$distance(current, destination);
    if (distance$1 <= 0) return $22db1ba098eb3017$var$minDropTime;
    if (distance$1 >= $22db1ba098eb3017$var$maxDropTimeAtDistance) return $22db1ba098eb3017$var$maxDropTime;
    var percentage = distance$1 / $22db1ba098eb3017$var$maxDropTimeAtDistance;
    var duration = $22db1ba098eb3017$var$minDropTime + $22db1ba098eb3017$var$dropTimeRange * percentage;
    var withDuration = reason === 'CANCEL' ? duration * $22db1ba098eb3017$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $22db1ba098eb3017$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $22db1ba098eb3017$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $22db1ba098eb3017$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $22db1ba098eb3017$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $22db1ba098eb3017$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== 'DROP') {
        var recomputedHomeImpact = $22db1ba098eb3017$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $gzM5u.default)({}, lastImpact, {
        displaced: $22db1ba098eb3017$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $22db1ba098eb3017$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($22db1ba098eb3017$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $22db1ba098eb3017$var$invariant(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $22db1ba098eb3017$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $22db1ba098eb3017$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $22db1ba098eb3017$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $22db1ba098eb3017$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $22db1ba098eb3017$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$22db1ba098eb3017$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($22db1ba098eb3017$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $22db1ba098eb3017$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($22db1ba098eb3017$var$animateDrop(args));
        };
    };
};
var $22db1ba098eb3017$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $22db1ba098eb3017$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $22db1ba098eb3017$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($22db1ba098eb3017$var$getWindowScroll());
    }
    var scheduled = (0, $crAmF.default)(updateScroll);
    var binding = $22db1ba098eb3017$var$getWindowScrollBinding(scheduled);
    var unbind = $22db1ba098eb3017$var$noop;
    function isActive() {
        return unbind !== $22db1ba098eb3017$var$noop;
    }
    function start() {
        !!isActive() && $22db1ba098eb3017$var$invariant(false);
        unbind = $22db1ba098eb3017$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $22db1ba098eb3017$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $22db1ba098eb3017$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $22db1ba098eb3017$var$shouldEnd = function shouldEnd(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $22db1ba098eb3017$var$scrollListener = function(store) {
    var listener = $22db1ba098eb3017$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($22db1ba098eb3017$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
            if (listener.isActive() && $22db1ba098eb3017$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $22db1ba098eb3017$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $22db1ba098eb3017$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $22db1ba098eb3017$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $22db1ba098eb3017$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $22db1ba098eb3017$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $22db1ba098eb3017$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $22db1ba098eb3017$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $22db1ba098eb3017$var$withTimings = function withTimings(key, fn) {
    $22db1ba098eb3017$var$start(key);
    fn();
    $22db1ba098eb3017$var$finish(key);
};
var $22db1ba098eb3017$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $22db1ba098eb3017$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $22db1ba098eb3017$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $22db1ba098eb3017$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $22db1ba098eb3017$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $22db1ba098eb3017$var$invariant(false);
        $22db1ba098eb3017$var$withTimings('onBeforeCapture', function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $22db1ba098eb3017$var$invariant(false);
        $22db1ba098eb3017$var$withTimings('onBeforeDragStart', function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($22db1ba098eb3017$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $22db1ba098eb3017$var$invariant(false);
        var data = $22db1ba098eb3017$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $22db1ba098eb3017$var$withTimings('onDragStart', function() {
                return $22db1ba098eb3017$var$execute(getResponders().onDragStart, data, announce, $22db1ba098eb3017$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $22db1ba098eb3017$var$tryGetDestination(impact);
        var combine = $22db1ba098eb3017$var$tryGetCombine(impact);
        !dragging && $22db1ba098eb3017$var$invariant(false);
        var hasCriticalChanged = !$22db1ba098eb3017$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$22db1ba098eb3017$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$22db1ba098eb3017$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $gzM5u.default)({}, $22db1ba098eb3017$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $22db1ba098eb3017$var$withTimings('onDragUpdate', function() {
                return $22db1ba098eb3017$var$execute(getResponders().onDragUpdate, data, announce, $22db1ba098eb3017$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $22db1ba098eb3017$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $22db1ba098eb3017$var$invariant(false);
        dragging = null;
        $22db1ba098eb3017$var$withTimings('onDragEnd', function() {
            return $22db1ba098eb3017$var$execute(getResponders().onDragEnd, result, announce, $22db1ba098eb3017$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $gzM5u.default)({}, $22db1ba098eb3017$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: 'CANCEL'
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $22db1ba098eb3017$var$responders = function(getResponders, announce) {
    var publisher = $22db1ba098eb3017$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'FLUSH') {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $22db1ba098eb3017$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $22db1ba098eb3017$var$invariant(false);
            store.dispatch($22db1ba098eb3017$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $22db1ba098eb3017$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
            next(action);
            if (action.type !== 'DROP_ANIMATE') return;
            var binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($22db1ba098eb3017$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $22db1ba098eb3017$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $22db1ba098eb3017$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $22db1ba098eb3017$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === 'FLUSH') {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $22db1ba098eb3017$var$shouldStop = function shouldStop(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $22db1ba098eb3017$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($22db1ba098eb3017$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    var state = store.getState();
                    !(state.phase === 'DRAGGING') && $22db1ba098eb3017$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $22db1ba098eb3017$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            var postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($22db1ba098eb3017$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $22db1ba098eb3017$var$composeEnhancers = (0, $22j3V.compose);
var $22db1ba098eb3017$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $22j3V.createStore)($22db1ba098eb3017$var$reducer, $22db1ba098eb3017$var$composeEnhancers((0, $22j3V.applyMiddleware)($22db1ba098eb3017$var$style(styleMarshal), $22db1ba098eb3017$var$dimensionMarshalStopper(dimensionMarshal), $22db1ba098eb3017$var$lift$1(dimensionMarshal), $22db1ba098eb3017$var$drop$1, $22db1ba098eb3017$var$dropAnimationFinish, $22db1ba098eb3017$var$dropAnimationFlushOnScroll, $22db1ba098eb3017$var$pendingDrop, $22db1ba098eb3017$var$autoScroll(autoScroller), $22db1ba098eb3017$var$scrollListener, $22db1ba098eb3017$var$focus(focusMarshal), $22db1ba098eb3017$var$responders(getResponders, announce))));
};
var $22db1ba098eb3017$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
var $22db1ba098eb3017$var$timingKey = 'Publish collection from DOM';
function $22db1ba098eb3017$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $22db1ba098eb3017$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $22db1ba098eb3017$var$start($22db1ba098eb3017$var$timingKey);
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = (0, (/*@__PURE__*/$parcel$interopDefault($cs3hJ)))(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($22db1ba098eb3017$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = (0, (/*@__PURE__*/$parcel$interopDefault($cs3hJ)))(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: (0, (/*@__PURE__*/$parcel$interopDefault($cs3hJ)))(removals),
                modified: updated
            };
            staging = $22db1ba098eb3017$var$clean$1();
            $22db1ba098eb3017$var$finish($22db1ba098eb3017$var$timingKey);
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $22db1ba098eb3017$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $22db1ba098eb3017$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $22db1ba098eb3017$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $22db1ba098eb3017$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $22db1ba098eb3017$var$invariant(false);
    return doc;
};
var $22db1ba098eb3017$var$getMaxWindowScroll = function() {
    var doc = $22db1ba098eb3017$var$getDocumentElement();
    var maxScroll = $22db1ba098eb3017$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $22db1ba098eb3017$var$getViewport = function() {
    var scroll = $22db1ba098eb3017$var$getWindowScroll();
    var maxScroll = $22db1ba098eb3017$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $22db1ba098eb3017$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $3YKxB.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $22db1ba098eb3017$var$origin,
                displacement: $22db1ba098eb3017$var$origin
            }
        }
    };
    return viewport;
};
var $22db1ba098eb3017$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    var timingKey = 'Initial collection from DOM';
    $22db1ba098eb3017$var$start(timingKey);
    var viewport = $22db1ba098eb3017$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $22db1ba098eb3017$var$toDraggableMap(draggables),
        droppables: $22db1ba098eb3017$var$toDroppableMap(droppables)
    };
    $22db1ba098eb3017$var$finish(timingKey);
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $22db1ba098eb3017$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $22db1ba098eb3017$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $22db1ba098eb3017$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $22db1ba098eb3017$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $22db1ba098eb3017$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $22db1ba098eb3017$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $22db1ba098eb3017$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($22db1ba098eb3017$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($22db1ba098eb3017$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $22db1ba098eb3017$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $22db1ba098eb3017$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $22db1ba098eb3017$var$canStartDrag = function(state, id) {
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $22db1ba098eb3017$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $22db1ba098eb3017$var$getScrollableDroppables = (0, $g7psY.default)(function(droppables) {
    return $22db1ba098eb3017$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $22db1ba098eb3017$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $22db1ba098eb3017$var$find($22db1ba098eb3017$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $22db1ba098eb3017$var$invariant(false);
        return $22db1ba098eb3017$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $22db1ba098eb3017$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $22db1ba098eb3017$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $22db1ba098eb3017$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $22db1ba098eb3017$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $22db1ba098eb3017$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $22db1ba098eb3017$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $22db1ba098eb3017$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $22db1ba098eb3017$var$minScroll = 1;
var $22db1ba098eb3017$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $22db1ba098eb3017$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $22db1ba098eb3017$var$minScroll;
    var percentageFromMaxScrollValueAt = $22db1ba098eb3017$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $22db1ba098eb3017$var$config.maxPixelScroll * $22db1ba098eb3017$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $22db1ba098eb3017$var$accelerateAt = $22db1ba098eb3017$var$config.durationDampening.accelerateAt;
var $22db1ba098eb3017$var$stopAt = $22db1ba098eb3017$var$config.durationDampening.stopDampeningAt;
var $22db1ba098eb3017$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $22db1ba098eb3017$var$stopAt;
    var now = (0, (/*@__PURE__*/$parcel$interopDefault($3BSY2)))();
    var runTime = now - startOfRange;
    if (runTime >= $22db1ba098eb3017$var$stopAt) return proposedScroll;
    if (runTime < $22db1ba098eb3017$var$accelerateAt) return $22db1ba098eb3017$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $22db1ba098eb3017$var$getPercentage({
        startOfRange: $22db1ba098eb3017$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $22db1ba098eb3017$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $22db1ba098eb3017$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $22db1ba098eb3017$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($22db1ba098eb3017$var$dampenValueByTime(scroll, dragStartTime), $22db1ba098eb3017$var$minScroll);
};
var $22db1ba098eb3017$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $22db1ba098eb3017$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $22db1ba098eb3017$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $22db1ba098eb3017$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $22db1ba098eb3017$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $22db1ba098eb3017$var$clean$2 = $22db1ba098eb3017$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $22db1ba098eb3017$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $22db1ba098eb3017$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $22db1ba098eb3017$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $22db1ba098eb3017$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $22db1ba098eb3017$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $22db1ba098eb3017$var$clean$2({
        x: x,
        y: y
    });
    if ($22db1ba098eb3017$var$isEqual(required, $22db1ba098eb3017$var$origin)) return null;
    var limited = $22db1ba098eb3017$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $22db1ba098eb3017$var$isEqual(limited, $22db1ba098eb3017$var$origin) ? null : limited;
};
var $22db1ba098eb3017$var$smallestSigned = $22db1ba098eb3017$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $22db1ba098eb3017$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $22db1ba098eb3017$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($22db1ba098eb3017$var$isEqual(overlap, $22db1ba098eb3017$var$origin)) return null;
        return overlap;
    };
}();
var $22db1ba098eb3017$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $22db1ba098eb3017$var$smallestSigned(change);
    var overlap = $22db1ba098eb3017$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $22db1ba098eb3017$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $22db1ba098eb3017$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $22db1ba098eb3017$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$22db1ba098eb3017$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $22db1ba098eb3017$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $22db1ba098eb3017$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $22db1ba098eb3017$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $22db1ba098eb3017$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$22db1ba098eb3017$var$canScrollDroppable(droppable, change)) return null;
    return $22db1ba098eb3017$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $22db1ba098eb3017$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $22db1ba098eb3017$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $22db1ba098eb3017$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $22db1ba098eb3017$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $22db1ba098eb3017$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $22db1ba098eb3017$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $22db1ba098eb3017$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $22db1ba098eb3017$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $22db1ba098eb3017$var$getBestScrollableDroppable({
        center: center,
        destination: $22db1ba098eb3017$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $22db1ba098eb3017$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $22db1ba098eb3017$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $crAmF.default)(scrollWindow);
    var scheduleDroppableScroll = (0, $crAmF.default)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $22db1ba098eb3017$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $22db1ba098eb3017$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $22db1ba098eb3017$var$start('starting fluid scroller');
        !!dragging && $22db1ba098eb3017$var$invariant(false);
        var dragStartTime = (0, (/*@__PURE__*/$parcel$interopDefault($3BSY2)))();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $22db1ba098eb3017$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $22db1ba098eb3017$var$finish('starting fluid scroller');
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $22db1ba098eb3017$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $22db1ba098eb3017$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$22db1ba098eb3017$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $22db1ba098eb3017$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $22db1ba098eb3017$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $22db1ba098eb3017$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$22db1ba098eb3017$var$canScrollWindow(viewport, change)) return change;
        var overlap = $22db1ba098eb3017$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $22db1ba098eb3017$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $22db1ba098eb3017$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact);
        !destination && $22db1ba098eb3017$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $22db1ba098eb3017$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $22db1ba098eb3017$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $22db1ba098eb3017$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $22db1ba098eb3017$var$prefix$1 = 'data-rbd';
var $22db1ba098eb3017$var$dragHandle = function() {
    var base = $22db1ba098eb3017$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $22db1ba098eb3017$var$draggable = function() {
    var base = $22db1ba098eb3017$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $22db1ba098eb3017$var$droppable = function() {
    var base = $22db1ba098eb3017$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $22db1ba098eb3017$var$scrollContainer = {
    contextId: $22db1ba098eb3017$var$prefix$1 + "-scroll-container-context-id"
};
var $22db1ba098eb3017$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + "=\"" + context + "\"]";
    };
};
var $22db1ba098eb3017$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return '';
        return rule.selector + " { " + value + " }";
    }).join(' ');
};
var $22db1ba098eb3017$var$noPointerEvents = 'pointer-events: none;';
var $22db1ba098eb3017$var$getStyles$1 = function(contextId) {
    var getSelector = $22db1ba098eb3017$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($22db1ba098eb3017$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $22db1ba098eb3017$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $22db1ba098eb3017$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($22db1ba098eb3017$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($22db1ba098eb3017$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: 'body',
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $22db1ba098eb3017$var$getStyles(rules, 'always'),
        resting: $22db1ba098eb3017$var$getStyles(rules, 'resting'),
        dragging: $22db1ba098eb3017$var$getStyles(rules, 'dragging'),
        dropAnimating: $22db1ba098eb3017$var$getStyles(rules, 'dropAnimating'),
        userCancel: $22db1ba098eb3017$var$getStyles(rules, 'userCancel')
    };
};
var $22db1ba098eb3017$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $5uXOq.useLayoutEffect) : (0, $5uXOq.useEffect);
var $22db1ba098eb3017$var$getHead = function getHead() {
    var head = document.querySelector('head');
    !head && $22db1ba098eb3017$var$invariant(false);
    return head;
};
var $22db1ba098eb3017$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $22db1ba098eb3017$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $5uXOq.useRef)(null);
    var dynamicRef = (0, $5uXOq.useRef)(null);
    var setDynamicStyle = (0, $3YMLK.useCallback)((0, $g7psY.default)(function(proposed) {
        var el = dynamicRef.current;
        !el && $22db1ba098eb3017$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $3YMLK.useCallback)(function(proposed) {
        var el = alwaysRef.current;
        !el && $22db1ba098eb3017$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $22db1ba098eb3017$var$invariant(false);
        var always = $22db1ba098eb3017$var$createStyleEl(nonce);
        var dynamic = $22db1ba098eb3017$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($22db1ba098eb3017$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($22db1ba098eb3017$var$prefix$1 + "-dynamic", contextId);
        $22db1ba098eb3017$var$getHead().appendChild(always);
        $22db1ba098eb3017$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $22db1ba098eb3017$var$invariant(false);
                $22db1ba098eb3017$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $3YMLK.useCallback)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $3YMLK.useCallback)(function(reason) {
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $3YMLK.useCallback)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $3YMLK.useMemo)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $22db1ba098eb3017$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $22db1ba098eb3017$var$isHtmlElement(el) {
    return el instanceof $22db1ba098eb3017$var$getWindowFromEl(el).HTMLElement;
}
function $22db1ba098eb3017$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $22db1ba098eb3017$var$dragHandle.contextId + "=\"" + contextId + "\"]";
    var possible = $22db1ba098eb3017$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $22db1ba098eb3017$var$find(possible, function(el) {
        return el.getAttribute($22db1ba098eb3017$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$22db1ba098eb3017$var$isHtmlElement(handle)) return null;
    return handle;
}
function $22db1ba098eb3017$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $5uXOq.useRef)({});
    var recordRef = (0, $5uXOq.useRef)(null);
    var restoreFocusFrameRef = (0, $5uXOq.useRef)(null);
    var isMountedRef = (0, $5uXOq.useRef)(false);
    var register = (0, $3YMLK.useCallback)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $3YMLK.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $22db1ba098eb3017$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $3YMLK.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $3YMLK.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $3YMLK.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($22db1ba098eb3017$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $3YMLK.useMemo)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $22db1ba098eb3017$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $22db1ba098eb3017$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $22db1ba098eb3017$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $22db1ba098eb3017$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $22db1ba098eb3017$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $22db1ba098eb3017$var$useRegistry() {
    var registry = (0, $3YMLK.useMemo)($22db1ba098eb3017$var$createRegistry, []);
    (0, $5uXOq.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $22db1ba098eb3017$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
var $22db1ba098eb3017$var$getBodyElement = function() {
    var body = document.body;
    !body && $22db1ba098eb3017$var$invariant(false);
    return body;
};
var $22db1ba098eb3017$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $22db1ba098eb3017$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $22db1ba098eb3017$var$useAnnouncer(contextId) {
    var id = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(function setup() {
        var el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('role', 'log');
        el.setAttribute('aria-atomic', 'true');
        (0, (/*@__PURE__*/$parcel$interopDefault($4iZOV)))(el.style, $22db1ba098eb3017$var$visuallyHidden);
        $22db1ba098eb3017$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                $22db1ba098eb3017$var$getBodyElement().removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $3YMLK.useCallback)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $22db1ba098eb3017$var$getId$1 = function getId(contextId) {
    return "rbd-lift-instruction-" + contextId;
};
function $22db1ba098eb3017$var$useLiftInstruction(contextId, liftInstruction) {
    var id = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$getId$1(contextId);
    }, [
        contextId
    ]);
    (0, $5uXOq.useEffect)(function mount() {
        var el = document.createElement('div');
        el.id = id;
        el.textContent = liftInstruction;
        (0, (/*@__PURE__*/$parcel$interopDefault($4iZOV)))(el.style, {
            display: 'none'
        });
        $22db1ba098eb3017$var$getBodyElement().appendChild(el);
        return function unmount() {
            $22db1ba098eb3017$var$getBodyElement().removeChild(el);
        };
    }, [
        id,
        liftInstruction
    ]);
    return id;
}
var $22db1ba098eb3017$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
var $22db1ba098eb3017$var$peerDependencies = {
    react: "^16.8.5",
    "react-dom": "^16.8.5"
};
var $22db1ba098eb3017$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $22db1ba098eb3017$var$getVersion = function getVersion(value) {
    var result = $22db1ba098eb3017$var$semver.exec(value);
    !(result != null) && $22db1ba098eb3017$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $22db1ba098eb3017$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $22db1ba098eb3017$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $22db1ba098eb3017$var$getVersion(peerDepValue);
    var actual = $22db1ba098eb3017$var$getVersion(actualValue);
    if ($22db1ba098eb3017$var$isSatisfied(peerDep, actual)) return;
};
var $22db1ba098eb3017$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $22db1ba098eb3017$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $22db1ba098eb3017$var$useDev(useHook) {}
function $22db1ba098eb3017$var$useDevSetupWarning(fn, inputs) {
    $22db1ba098eb3017$var$useDev(function() {
        (0, $5uXOq.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $22db1ba098eb3017$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $22db1ba098eb3017$var$useStartupValidation() {
    $22db1ba098eb3017$var$useDevSetupWarning(function() {
        $22db1ba098eb3017$var$checkReactVersion($22db1ba098eb3017$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).version);
        $22db1ba098eb3017$var$checkDoctype(document);
    }, []);
}
function $22db1ba098eb3017$var$usePrevious(current) {
    var ref = (0, $5uXOq.useRef)(current);
    (0, $5uXOq.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $22db1ba098eb3017$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $22db1ba098eb3017$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $22db1ba098eb3017$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $22db1ba098eb3017$var$tab = 9;
var $22db1ba098eb3017$var$enter = 13;
var $22db1ba098eb3017$var$escape = 27;
var $22db1ba098eb3017$var$space = 32;
var $22db1ba098eb3017$var$pageUp = 33;
var $22db1ba098eb3017$var$pageDown = 34;
var $22db1ba098eb3017$var$end = 35;
var $22db1ba098eb3017$var$home = 36;
var $22db1ba098eb3017$var$arrowLeft = 37;
var $22db1ba098eb3017$var$arrowUp = 38;
var $22db1ba098eb3017$var$arrowRight = 39;
var $22db1ba098eb3017$var$arrowDown = 40;
var $22db1ba098eb3017$var$_preventedKeys;
var $22db1ba098eb3017$var$preventedKeys = ($22db1ba098eb3017$var$_preventedKeys = {}, $22db1ba098eb3017$var$_preventedKeys[$22db1ba098eb3017$var$enter] = true, $22db1ba098eb3017$var$_preventedKeys[$22db1ba098eb3017$var$tab] = true, $22db1ba098eb3017$var$_preventedKeys);
var $22db1ba098eb3017$var$preventStandardKeyEvents = function(event) {
    if ($22db1ba098eb3017$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $22db1ba098eb3017$var$supportedEventName = function() {
    var base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $22db1ba098eb3017$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $22db1ba098eb3017$var$primaryButton = 0;
var $22db1ba098eb3017$var$sloppyClickThreshold = 5;
function $22db1ba098eb3017$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $22db1ba098eb3017$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $22db1ba098eb3017$var$sloppyClickThreshold;
}
var $22db1ba098eb3017$var$idle$1 = {
    type: 'IDLE'
};
function $22db1ba098eb3017$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: 'mousemove',
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $22db1ba098eb3017$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $22db1ba098eb3017$var$invariant(false);
                var pending = phase.point;
                if (!$22db1ba098eb3017$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: function fn(event) {
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $22db1ba098eb3017$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $22db1ba098eb3017$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $22db1ba098eb3017$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $22db1ba098eb3017$var$useMouseSensor(api) {
    var phaseRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$idle$1);
    var unbindEventsRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$noop);
    var startCaptureBinding = (0, $3YMLK.useMemo)(function() {
        return {
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $22db1ba098eb3017$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $3YMLK.useMemo)(function() {
        return {
            eventName: 'webkitmouseforcewillbegin',
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $3YMLK.useCallback)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $3YMLK.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $22db1ba098eb3017$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $3YMLK.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $3YMLK.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $22db1ba098eb3017$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $3YMLK.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $22db1ba098eb3017$var$_scrollJumpKeys;
function $22db1ba098eb3017$var$noop$1() {}
var $22db1ba098eb3017$var$scrollJumpKeys = ($22db1ba098eb3017$var$_scrollJumpKeys = {}, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$pageDown] = true, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$pageUp] = true, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$home] = true, $22db1ba098eb3017$var$_scrollJumpKeys[$22db1ba098eb3017$var$end] = true, $22db1ba098eb3017$var$_scrollJumpKeys);
function $22db1ba098eb3017$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (event.keyCode === $22db1ba098eb3017$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($22db1ba098eb3017$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $22db1ba098eb3017$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $22db1ba098eb3017$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $22db1ba098eb3017$var$useKeyboardSensor(api) {
    var unbindEventsRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$noop$1);
    var startCaptureBinding = (0, $3YMLK.useMemo)(function() {
        return {
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $22db1ba098eb3017$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $22db1ba098eb3017$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, $22db1ba098eb3017$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $3YMLK.useCallback)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $22db1ba098eb3017$var$idle$2 = {
    type: 'IDLE'
};
var $22db1ba098eb3017$var$timeForLongPress = 120;
var $22db1ba098eb3017$var$forcePressThreshold = 0.15;
function $22db1ba098eb3017$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $22db1ba098eb3017$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $22db1ba098eb3017$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $22db1ba098eb3017$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $22db1ba098eb3017$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $22db1ba098eb3017$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $22db1ba098eb3017$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $22db1ba098eb3017$var$useMouseSensor$1(api) {
    var phaseRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$idle$2);
    var unbindEventsRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$noop);
    var getPhase = (0, $3YMLK.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $3YMLK.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $3YMLK.useMemo)(function() {
        return {
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $3YMLK.useCallback)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $22db1ba098eb3017$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $3YMLK.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($22db1ba098eb3017$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $3YMLK.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $3YMLK.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $22db1ba098eb3017$var$bindEvents(window, $22db1ba098eb3017$var$getHandleBindings(args), options);
        var unbindWindow = $22db1ba098eb3017$var$bindEvents(window, $22db1ba098eb3017$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $3YMLK.useCallback)(function startDragging() {
        var phase = getPhase();
        !(phase.type === 'PENDING') && $22db1ba098eb3017$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $3YMLK.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $22db1ba098eb3017$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $22db1ba098eb3017$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($22db1ba098eb3017$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $22db1ba098eb3017$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $22db1ba098eb3017$var$useValidateSensorHooks(sensorHooks) {
    $22db1ba098eb3017$var$useDev(function() {
        var previousRef = $22db1ba098eb3017$var$usePrevious(sensorHooks);
        $22db1ba098eb3017$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $22db1ba098eb3017$var$invariant(false);
        });
    });
}
var $22db1ba098eb3017$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $22db1ba098eb3017$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($22db1ba098eb3017$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $22db1ba098eb3017$var$isAnInteractiveElement(parent, current.parentElement);
}
function $22db1ba098eb3017$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$22db1ba098eb3017$var$isHtmlElement(target)) return false;
    return $22db1ba098eb3017$var$isAnInteractiveElement(draggable, target);
}
var $22db1ba098eb3017$var$getBorderBoxCenterPosition = function(el) {
    return (0, $3YKxB.getRect)(el.getBoundingClientRect()).center;
};
function $22db1ba098eb3017$var$isElement(el) {
    return el instanceof $22db1ba098eb3017$var$getWindowFromEl(el).Element;
}
var $22db1ba098eb3017$var$supportedMatchesName = function() {
    var base = 'matches';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    var value = $22db1ba098eb3017$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $22db1ba098eb3017$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$22db1ba098eb3017$var$supportedMatchesName](selector)) return el;
    return $22db1ba098eb3017$var$closestPonyfill(el.parentElement, selector);
}
function $22db1ba098eb3017$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $22db1ba098eb3017$var$closestPonyfill(el, selector);
}
function $22db1ba098eb3017$var$getSelector(contextId) {
    return "[" + $22db1ba098eb3017$var$dragHandle.contextId + "=\"" + contextId + "\"]";
}
function $22db1ba098eb3017$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$22db1ba098eb3017$var$isElement(target)) return null;
    var selector = $22db1ba098eb3017$var$getSelector(contextId);
    var handle = $22db1ba098eb3017$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$22db1ba098eb3017$var$isHtmlElement(handle)) return null;
    return handle;
}
function $22db1ba098eb3017$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $22db1ba098eb3017$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($22db1ba098eb3017$var$dragHandle.draggableId);
}
function $22db1ba098eb3017$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $22db1ba098eb3017$var$draggable.contextId + "=\"" + contextId + "\"]";
    var possible = $22db1ba098eb3017$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $22db1ba098eb3017$var$find(possible, function(el) {
        return el.getAttribute($22db1ba098eb3017$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$22db1ba098eb3017$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $22db1ba098eb3017$var$preventDefault(event) {
    event.preventDefault();
}
function $22db1ba098eb3017$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $22db1ba098eb3017$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$22db1ba098eb3017$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $22db1ba098eb3017$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $22db1ba098eb3017$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $22db1ba098eb3017$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $22db1ba098eb3017$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $22db1ba098eb3017$var$noop);
    var phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($22db1ba098eb3017$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(this, 'DRAGGING');
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            !(phase === 'PRE_DRAG') && $22db1ba098eb3017$var$invariant(false);
        }
        store.dispatch($22db1ba098eb3017$var$lift(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $22db1ba098eb3017$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $22db1ba098eb3017$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($22db1ba098eb3017$var$drop({
                reason: reason
            }));
        }
        return (0, $gzM5u.default)({
            isActive: function isActive() {
                return $22db1ba098eb3017$var$_isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish('DROP', options);
            },
            cancel: function cancel(options) {
                return finish('CANCEL', options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $crAmF.default)(function(client) {
            tryDispatchWhenDragging(function() {
                return $22db1ba098eb3017$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $gzM5u.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($22db1ba098eb3017$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($22db1ba098eb3017$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($22db1ba098eb3017$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($22db1ba098eb3017$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $22db1ba098eb3017$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $22db1ba098eb3017$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $22db1ba098eb3017$var$_isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $22db1ba098eb3017$var$_isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $22db1ba098eb3017$var$defaultSensors = [
    $22db1ba098eb3017$var$useMouseSensor,
    $22db1ba098eb3017$var$useKeyboardSensor,
    $22db1ba098eb3017$var$useMouseSensor$1
];
function $22db1ba098eb3017$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $22db1ba098eb3017$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $5uXOq.useState)(function() {
        return $22db1ba098eb3017$var$create();
    })[0];
    var tryAbandonLock = (0, $3YMLK.useCallback)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $3YMLK.useCallback)(function(draggableId) {
        return $22db1ba098eb3017$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $3YMLK.useCallback)(function(draggableId, forceStop, options) {
        return $22db1ba098eb3017$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $3YMLK.useCallback)(function(event) {
        return $22db1ba098eb3017$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $3YMLK.useCallback)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $3YMLK.useCallback)(lockAPI.tryAbandon, [
        lockAPI
    ]);
    var isLockClaimed = (0, $3YMLK.useCallback)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $3YMLK.useMemo)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $22db1ba098eb3017$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $22db1ba098eb3017$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $22db1ba098eb3017$var$getStore(lazyRef) {
    !lazyRef.current && $22db1ba098eb3017$var$invariant(false);
    return lazyRef.current;
}
function $22db1ba098eb3017$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, liftInstruction = props.liftInstruction;
    var lazyStoreRef = (0, $5uXOq.useRef)(null);
    $22db1ba098eb3017$var$useStartupValidation();
    var lastPropsRef = $22db1ba098eb3017$var$usePrevious(props);
    var getResponders = (0, $3YMLK.useCallback)(function() {
        return $22db1ba098eb3017$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $22db1ba098eb3017$var$useAnnouncer(contextId);
    var liftInstructionId = $22db1ba098eb3017$var$useLiftInstruction(contextId, liftInstruction);
    var styleMarshal = $22db1ba098eb3017$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $3YMLK.useCallback)(function(action) {
        $22db1ba098eb3017$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $3YMLK.useMemo)(function() {
        return (0, $22j3V.bindActionCreators)({
            publishWhileDragging: $22db1ba098eb3017$var$publishWhileDragging,
            updateDroppableScroll: $22db1ba098eb3017$var$updateDroppableScroll,
            updateDroppableIsEnabled: $22db1ba098eb3017$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $22db1ba098eb3017$var$updateDroppableIsCombineEnabled,
            collectionStarting: $22db1ba098eb3017$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $22db1ba098eb3017$var$useRegistry();
    var dimensionMarshal = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$createAutoScroller((0, $gzM5u.default)({
            scrollWindow: $22db1ba098eb3017$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $22j3V.bindActionCreators)({
            move: $22db1ba098eb3017$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $22db1ba098eb3017$var$useFocusMarshal(contextId);
    var store = (0, $3YMLK.useMemo)(function() {
        return $22db1ba098eb3017$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $3YMLK.useCallback)(function() {
        var current = $22db1ba098eb3017$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($22db1ba098eb3017$var$flush());
    }, []);
    var isDragging = (0, $3YMLK.useCallback)(function() {
        var state = $22db1ba098eb3017$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === 'DROP_ANIMATING';
    }, []);
    var appCallbacks = (0, $3YMLK.useMemo)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $3YMLK.useCallback)(function(id) {
        return $22db1ba098eb3017$var$canStartDrag($22db1ba098eb3017$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $3YMLK.useCallback)(function() {
        return $22db1ba098eb3017$var$isMovementAllowed($22db1ba098eb3017$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $3YMLK.useMemo)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            liftInstructionId: liftInstructionId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        liftInstructionId,
        registry
    ]);
    $22db1ba098eb3017$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $5uXOq.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9bdMd.default), {
        context: $22db1ba098eb3017$var$StoreContext,
        store: store
    }, props.children));
}
var $22db1ba098eb3017$var$instanceCount = 0;
function $22db1ba098eb3017$export$2bfe52350fc0150d() {
    $22db1ba098eb3017$var$instanceCount = 0;
}
function $22db1ba098eb3017$export$237bd83162c14364(props) {
    var contextId = (0, $3YMLK.useMemo)(function() {
        return "" + $22db1ba098eb3017$var$instanceCount++;
    }, []);
    var liftInstruction = props.liftInstruction || $22db1ba098eb3017$var$preset.liftInstruction;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            liftInstruction: liftInstruction,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $22db1ba098eb3017$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $22db1ba098eb3017$var$isScroll = $22db1ba098eb3017$var$isEqual$1('scroll');
var $22db1ba098eb3017$var$isAuto = $22db1ba098eb3017$var$isEqual$1('auto');
var $22db1ba098eb3017$var$isVisible$1 = $22db1ba098eb3017$var$isEqual$1('visible');
var $22db1ba098eb3017$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $22db1ba098eb3017$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $22db1ba098eb3017$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $22db1ba098eb3017$var$isEither(overflow, $22db1ba098eb3017$var$isScroll) || $22db1ba098eb3017$var$isEither(overflow, $22db1ba098eb3017$var$isAuto);
};
var $22db1ba098eb3017$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $22db1ba098eb3017$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $22db1ba098eb3017$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$22db1ba098eb3017$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $22db1ba098eb3017$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $22db1ba098eb3017$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $22db1ba098eb3017$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $22db1ba098eb3017$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var $22db1ba098eb3017$var$getEnv = function(start) {
    var closestScrollable = $22db1ba098eb3017$var$getClosestScrollable(start);
    var isFixedOnPage = $22db1ba098eb3017$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $22db1ba098eb3017$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $22db1ba098eb3017$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $22db1ba098eb3017$var$origin,
                    displacement: $22db1ba098eb3017$var$origin
                }
            }
        };
    }();
    var axis = direction === 'vertical' ? $22db1ba098eb3017$var$vertical : $22db1ba098eb3017$var$horizontal;
    var subject = $22db1ba098eb3017$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $22db1ba098eb3017$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $3YKxB.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $3YKxB.expand)(paddingBox, base.border);
    var client = (0, $3YKxB.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $22db1ba098eb3017$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $22db1ba098eb3017$var$getClient(ref, closestScrollable);
    var page = (0, $3YKxB.withScroll)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $3YKxB.getBox)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $3YKxB.withScroll)(frameClient, windowScroll),
            scroll: $22db1ba098eb3017$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $22db1ba098eb3017$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $22db1ba098eb3017$var$immediate = {
    passive: false
};
var $22db1ba098eb3017$var$delayed = {
    passive: true
};
var $22db1ba098eb3017$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $22db1ba098eb3017$var$immediate : $22db1ba098eb3017$var$delayed;
};
function $22db1ba098eb3017$var$useRequiredContext(Context) {
    var result = (0, $5uXOq.useContext)(Context);
    !result && $22db1ba098eb3017$var$invariant(false);
    return result;
}
var $22db1ba098eb3017$var$count = 0;
function $22db1ba098eb3017$var$useUniqueId(prefix) {
    var countRef = (0, $5uXOq.useRef)($22db1ba098eb3017$var$count++);
    return prefix + "::" + countRef.current;
}
var $22db1ba098eb3017$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $22db1ba098eb3017$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $5uXOq.useRef)(null);
    var appContext = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$AppContext);
    var uniqueId = $22db1ba098eb3017$var$useUniqueId('droppable');
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $22db1ba098eb3017$var$usePrevious(args);
    var descriptor = (0, $3YMLK.useMemo)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $5uXOq.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $3YMLK.useMemo)(function() {
        return (0, $g7psY.default)(function(x, y) {
            !whileDraggingRef.current && $22db1ba098eb3017$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $3YMLK.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $22db1ba098eb3017$var$origin;
        return $22db1ba098eb3017$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $3YMLK.useCallback)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $3YMLK.useMemo)(function() {
        return (0, $crAmF.default)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $3YMLK.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $22db1ba098eb3017$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $3YMLK.useCallback)(function(windowScroll, options) {
        !!whileDraggingRef.current && $22db1ba098eb3017$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $22db1ba098eb3017$var$invariant(false);
        var env = $22db1ba098eb3017$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $22db1ba098eb3017$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($22db1ba098eb3017$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $22db1ba098eb3017$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $3YMLK.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $22db1ba098eb3017$var$invariant(false);
        return $22db1ba098eb3017$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $3YMLK.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $22db1ba098eb3017$var$invariant(false);
        var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($22db1ba098eb3017$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $22db1ba098eb3017$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $3YMLK.useCallback)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $22db1ba098eb3017$var$invariant(false);
        var closest = $22db1ba098eb3017$var$getClosestScrollableFromDrag(dragging);
        !closest && $22db1ba098eb3017$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $3YMLK.useMemo)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $3YMLK.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $22db1ba098eb3017$var$noop$2() {}
var $22db1ba098eb3017$var$empty = {
    width: 0,
    height: 0,
    margin: $22db1ba098eb3017$var$noSpacing
};
var $22db1ba098eb3017$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $22db1ba098eb3017$var$empty;
    if (animate === 'close') return $22db1ba098eb3017$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $22db1ba098eb3017$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $22db1ba098eb3017$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $22db1ba098eb3017$var$transitions.placeholder : null
    };
};
function $22db1ba098eb3017$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $5uXOq.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $3YMLK.useCallback)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $5uXOq.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $5uXOq.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $22db1ba098eb3017$var$noop$2;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $22db1ba098eb3017$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $22db1ba098eb3017$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $3YMLK.useCallback)(function(event) {
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $22db1ba098eb3017$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rbd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $22db1ba098eb3017$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo($22db1ba098eb3017$var$Placeholder);
var $22db1ba098eb3017$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
function $22db1ba098eb3017$var$checkIsValidInnerRef(el) {
    !(el && $22db1ba098eb3017$var$isHtmlElement(el)) && $22db1ba098eb3017$var$invariant(false);
}
function $22db1ba098eb3017$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $22db1ba098eb3017$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $22db1ba098eb3017$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $22db1ba098eb3017$var$invariant(false);
        !(typeof props.droppableId === 'string') && $22db1ba098eb3017$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$22db1ba098eb3017$var$isBoolean(props.isDropDisabled) && $22db1ba098eb3017$var$invariant(false);
        !$22db1ba098eb3017$var$isBoolean(props.isCombineEnabled) && $22db1ba098eb3017$var$invariant(false);
        !$22db1ba098eb3017$var$isBoolean(props.ignoreContainerClipping) && $22db1ba098eb3017$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $22db1ba098eb3017$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $22db1ba098eb3017$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $22db1ba098eb3017$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $22db1ba098eb3017$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $22db1ba098eb3017$var$invariant(false);
    }
];
function $22db1ba098eb3017$var$useValidation(args) {
    $22db1ba098eb3017$var$useDevSetupWarning(function() {
        $22db1ba098eb3017$var$runChecks(args, $22db1ba098eb3017$var$shared);
        if (args.props.mode === 'standard') $22db1ba098eb3017$var$runChecks(args, $22db1ba098eb3017$var$standard);
        if (args.props.mode === 'virtual') $22db1ba098eb3017$var$runChecks(args, $22db1ba098eb3017$var$virtual);
    });
}
var $22db1ba098eb3017$var$AnimateInOut = function(_React$PureComponent) {
    (0, $1AwyE.default)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
        };
        _this.onClose = function() {
            if (_this.state.animate !== 'close') return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent);
var $22db1ba098eb3017$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $22db1ba098eb3017$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $22db1ba098eb3017$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $22db1ba098eb3017$var$transitions.snap;
    return $22db1ba098eb3017$var$transitions.fluid;
};
var $22db1ba098eb3017$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $22db1ba098eb3017$var$combine.opacity.drop : $22db1ba098eb3017$var$combine.opacity.combining;
};
var $22db1ba098eb3017$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $22db1ba098eb3017$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $22db1ba098eb3017$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $22db1ba098eb3017$var$transforms.drop(offset, isCombining) : $22db1ba098eb3017$var$transforms.moveTo(offset);
    var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $22db1ba098eb3017$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $22db1ba098eb3017$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $22db1ba098eb3017$var$zIndexOptions.dropAnimating : $22db1ba098eb3017$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $22db1ba098eb3017$var$getSecondaryStyle(secondary) {
    return {
        transform: $22db1ba098eb3017$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : 'none'
    };
}
function $22db1ba098eb3017$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $22db1ba098eb3017$var$getDraggingStyle(mapped) : $22db1ba098eb3017$var$getSecondaryStyle(mapped);
}
function $22db1ba098eb3017$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $22db1ba098eb3017$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $3YKxB.calculateBox)(borderBox, computedStyles);
    var page = (0, $3YKxB.withScroll)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $22db1ba098eb3017$var$useDraggablePublisher(args) {
    var uniqueId = $22db1ba098eb3017$var$useUniqueId('draggable');
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $3YMLK.useMemo)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $3YMLK.useCallback)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $22db1ba098eb3017$var$invariant(false);
        return $22db1ba098eb3017$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $3YMLK.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $5uXOq.useRef)(entry);
    var isFirstPublishRef = (0, $5uXOq.useRef)(true);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $22db1ba098eb3017$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $22db1ba098eb3017$var$useValidation$1(props, contextId, getRef) {
    $22db1ba098eb3017$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $22db1ba098eb3017$var$invariant(false);
        !(typeof id === 'string') && $22db1ba098eb3017$var$invariant(false);
        !(0, (/*@__PURE__*/$parcel$interopDefault($1DIXK)))(props.index) && $22db1ba098eb3017$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $22db1ba098eb3017$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$22db1ba098eb3017$var$findDragHandle(contextId, id) && $22db1ba098eb3017$var$invariant(false);
    });
}
function $22db1ba098eb3017$var$useClonePropValidation(isClone) {
    $22db1ba098eb3017$var$useDev(function() {
        var initialRef = (0, $5uXOq.useRef)(isClone);
        $22db1ba098eb3017$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $22db1ba098eb3017$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $22db1ba098eb3017$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $22db1ba098eb3017$var$Draggable(props) {
    var ref = (0, $5uXOq.useRef)(null);
    var setRef = (0, $3YMLK.useCallback)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $3YMLK.useCallback)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$AppContext), contextId = _useRequiredContext.contextId, liftInstructionId = _useRequiredContext.liftInstructionId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $3YMLK.useMemo)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $22db1ba098eb3017$var$useValidation$1(props, contextId, getRef);
    $22db1ba098eb3017$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $3YMLK.useMemo)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $22db1ba098eb3017$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $3YMLK.useMemo)(function() {
        return isEnabled ? {
            tabIndex: 0,
            'data-rbd-drag-handle-draggable-id': draggableId,
            'data-rbd-drag-handle-context-id': contextId,
            'aria-labelledby': liftInstructionId,
            draggable: false,
            onDragStart: $22db1ba098eb3017$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        draggableId,
        isEnabled,
        liftInstructionId
    ]);
    var onMoveEnd = (0, $3YMLK.useCallback)(function(event) {
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $3YMLK.useMemo)(function() {
        var style = $22db1ba098eb3017$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                'data-rbd-draggable-context-id': contextId,
                'data-rbd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $3YMLK.useMemo)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $22db1ba098eb3017$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $22db1ba098eb3017$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $22db1ba098eb3017$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $22db1ba098eb3017$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $22db1ba098eb3017$var$getDraggableSelector() {
    var memoizedOffset = (0, $g7psY.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $g7psY.default)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $g7psY.default)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact);
            var combineWith = $22db1ba098eb3017$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $22db1ba098eb3017$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $22db1ba098eb3017$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $22db1ba098eb3017$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $22db1ba098eb3017$var$combine.opacity.drop : null,
                scale: _combineWith ? $22db1ba098eb3017$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $22db1ba098eb3017$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $22db1ba098eb3017$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $22db1ba098eb3017$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $22db1ba098eb3017$var$getSecondarySnapshot(null)
    }
};
function $22db1ba098eb3017$var$getSecondarySelector() {
    var memoizedOffset = (0, $g7psY.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $g7psY.default)($22db1ba098eb3017$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $g7psY.default)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($22db1ba098eb3017$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $22db1ba098eb3017$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $22db1ba098eb3017$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $22db1ba098eb3017$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $22db1ba098eb3017$var$getDraggableSelector();
    var secondarySelector = $22db1ba098eb3017$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $22db1ba098eb3017$var$atRest;
    };
    return selector;
};
var $22db1ba098eb3017$var$mapDispatchToProps = {
    dropAnimationFinished: $22db1ba098eb3017$var$dropAnimationFinished
};
var $22db1ba098eb3017$var$ConnectedDraggable = (0, $AuRrZ.default)($22db1ba098eb3017$var$makeMapStateToProps, $22db1ba098eb3017$var$mapDispatchToProps, null, {
    context: $22db1ba098eb3017$var$StoreContext,
    pure: true,
    areStatePropsEqual: $22db1ba098eb3017$var$isStrictEqual
})($22db1ba098eb3017$var$Draggable);
function $22db1ba098eb3017$var$PrivateDraggable(props) {
    var droppableContext = $22db1ba098eb3017$var$useRequiredContext($22db1ba098eb3017$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$ConnectedDraggable, props);
}
function $22db1ba098eb3017$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$PrivateDraggable, (0, $gzM5u.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $22db1ba098eb3017$var$Droppable(props) {
    var appContext = (0, $5uXOq.useContext)($22db1ba098eb3017$var$AppContext);
    !appContext && $22db1ba098eb3017$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $5uXOq.useRef)(null);
    var placeholderRef = (0, $5uXOq.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $3YMLK.useCallback)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $3YMLK.useCallback)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $3YMLK.useCallback)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $3YMLK.useCallback)(function(value) {
        placeholderRef.current = value;
    }, []);
    $22db1ba098eb3017$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $3YMLK.useCallback)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $22db1ba098eb3017$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $22db1ba098eb3017$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $3YMLK.useMemo)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rbd-droppable-id': droppableId,
                'data-rbd-droppable-context-id': contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $3YMLK.useMemo)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($22db1ba098eb3017$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $22db1ba098eb3017$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $22db1ba098eb3017$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $22db1ba098eb3017$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $gzM5u.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $g7psY.default)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $g7psY.default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$22db1ba098eb3017$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $22db1ba098eb3017$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $22db1ba098eb3017$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (!$22db1ba098eb3017$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $22db1ba098eb3017$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $22db1ba098eb3017$var$whatIsDraggedOverFromResult(completed.result) === id, $22db1ba098eb3017$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$22db1ba098eb3017$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $22db1ba098eb3017$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $22db1ba098eb3017$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $22db1ba098eb3017$var$updateViewportMaxScroll
};
function $22db1ba098eb3017$var$getBody() {
    !document.body && $22db1ba098eb3017$var$invariant(false);
    return document.body;
}
var $22db1ba098eb3017$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $22db1ba098eb3017$var$getBody
};
var $22db1ba098eb3017$export$423ec2075359570a = (0, $AuRrZ.default)($22db1ba098eb3017$var$makeMapStateToProps$1, $22db1ba098eb3017$var$mapDispatchToProps$1, null, {
    context: $22db1ba098eb3017$var$StoreContext,
    pure: true,
    areStatePropsEqual: $22db1ba098eb3017$var$isStrictEqual
})($22db1ba098eb3017$var$Droppable);
$22db1ba098eb3017$export$423ec2075359570a.defaultProps = $22db1ba098eb3017$var$defaultProps;

});
parcelRegister("1AwyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $128268946ec0acb0$export$2e2bcd8739ae039);

var $gIDtq = parcelRequire("gIDtq");

var $blzS6 = parcelRequire("blzS6");
function $128268946ec0acb0$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = (0, (/*@__PURE__*/$parcel$interopDefault($gIDtq)))(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $blzS6.default)(subClass, superClass);
}

});
parcelRegister("gIDtq", function(module, exports) {

module.exports = (parcelRequire("dG4Ay"));

});
parcelRegister("dG4Ay", function(module, exports) {
parcelRequire("bAALv");

var $4KXzV = parcelRequire("4KXzV");
var $9f52c1cdbf61a0ea$require$$Object = $4KXzV.Object;
module.exports = function create(P, D) {
    return $9f52c1cdbf61a0ea$require$$Object.create(P, D);
};

});
parcelRegister("bAALv", function(module, exports) {

var $fNMIk = parcelRequire("fNMIk");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$fNMIk($fNMIk.S, 'Object', {
    create: (parcelRequire("221nn"))
});

});
parcelRegister("fNMIk", function(module, exports) {

var $4tgdI = parcelRequire("4tgdI");

var $4KXzV = parcelRequire("4KXzV");

var $85v89 = parcelRequire("85v89");

var $9TfYC = parcelRequire("9TfYC");

var $8cV4K = parcelRequire("8cV4K");
var $b811382cedb7c9d6$var$PROTOTYPE = 'prototype';
var $b811382cedb7c9d6$var$$export = function(type, name, source) {
    var IS_FORCED = type & $b811382cedb7c9d6$var$$export.F;
    var IS_GLOBAL = type & $b811382cedb7c9d6$var$$export.G;
    var IS_STATIC = type & $b811382cedb7c9d6$var$$export.S;
    var IS_PROTO = type & $b811382cedb7c9d6$var$$export.P;
    var IS_BIND = type & $b811382cedb7c9d6$var$$export.B;
    var IS_WRAP = type & $b811382cedb7c9d6$var$$export.W;
    var exports = IS_GLOBAL ? $4KXzV : $4KXzV[name] || ($4KXzV[name] = {});
    var expProto = exports[$b811382cedb7c9d6$var$PROTOTYPE];
    var target = IS_GLOBAL ? $4tgdI : IS_STATIC ? $4tgdI[name] : ($4tgdI[name] || {})[$b811382cedb7c9d6$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $8cV4K(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $85v89(out, $4tgdI) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$b811382cedb7c9d6$var$PROTOTYPE] = C[$b811382cedb7c9d6$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $85v89(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $b811382cedb7c9d6$var$$export.R && expProto && !expProto[key]) $9TfYC(expProto, key, out);
        }
    }
};
// type bitmap
$b811382cedb7c9d6$var$$export.F = 1; // forced
$b811382cedb7c9d6$var$$export.G = 2; // global
$b811382cedb7c9d6$var$$export.S = 4; // static
$b811382cedb7c9d6$var$$export.P = 8; // proto
$b811382cedb7c9d6$var$$export.B = 16; // bind
$b811382cedb7c9d6$var$$export.W = 32; // wrap
$b811382cedb7c9d6$var$$export.U = 64; // safe
$b811382cedb7c9d6$var$$export.R = 128; // real proto method for `library`
module.exports = $b811382cedb7c9d6$var$$export;

});
parcelRegister("4tgdI", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $341673df947a4fac$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $341673df947a4fac$var$global; // eslint-disable-line no-undef

});

parcelRegister("4KXzV", function(module, exports) {
var $3769ac535e8faf09$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $3769ac535e8faf09$var$core; // eslint-disable-line no-undef

});

parcelRegister("85v89", function(module, exports) {
// optional / simple context binding

var $6fe4N = parcelRequire("6fe4N");
module.exports = function(fn, that, length) {
    $6fe4N(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("6fe4N", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("9TfYC", function(module, exports) {

var $2J4Nu = parcelRequire("2J4Nu");

var $azl1x = parcelRequire("azl1x");

module.exports = (parcelRequire("aPbfY")) ? function(object, key, value) {
    return $2J4Nu.f(object, key, $azl1x(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("2J4Nu", function(module, exports) {

$parcel$export(module.exports, "f", () => $1fc38158650d0be0$export$2d1720544b23b823, (v) => $1fc38158650d0be0$export$2d1720544b23b823 = v);
var $1fc38158650d0be0$export$2d1720544b23b823;

var $1J67F = parcelRequire("1J67F");

var $7fdxi = parcelRequire("7fdxi");

var $feF34 = parcelRequire("feF34");
var $1fc38158650d0be0$var$dP = Object.defineProperty;

$1fc38158650d0be0$export$2d1720544b23b823 = (parcelRequire("aPbfY")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $1J67F(O);
    P = $feF34(P, true);
    $1J67F(Attributes);
    if ($7fdxi) try {
        return $1fc38158650d0be0$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("1J67F", function(module, exports) {

var $dxLeJ = parcelRequire("dxLeJ");
module.exports = function(it) {
    if (!$dxLeJ(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("dxLeJ", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("7fdxi", function(module, exports) {



module.exports = !(parcelRequire("aPbfY")) && !(parcelRequire("cKvWG"))(function() {
    return Object.defineProperty((parcelRequire("8IahC"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("aPbfY", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("cKvWG"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("cKvWG", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("8IahC", function(module, exports) {

var $dxLeJ = parcelRequire("dxLeJ");

var $4tgdI = parcelRequire("4tgdI");
var $657a68d5e7e8fca9$require$document = $4tgdI.document;
// typeof document.createElement is 'object' in old IE
var $657a68d5e7e8fca9$var$is = $dxLeJ($657a68d5e7e8fca9$require$document) && $dxLeJ($657a68d5e7e8fca9$require$document.createElement);
module.exports = function(it) {
    return $657a68d5e7e8fca9$var$is ? $657a68d5e7e8fca9$require$document.createElement(it) : {};
};

});


parcelRegister("feF34", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $dxLeJ = parcelRequire("dxLeJ");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$dxLeJ(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$dxLeJ(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$dxLeJ(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$dxLeJ(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("azl1x", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("8cV4K", function(module, exports) {
var $5f9bb7be8775a474$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $5f9bb7be8775a474$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("221nn", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $1J67F = parcelRequire("1J67F");

var $aRCm2 = parcelRequire("aRCm2");

var $8LIl9 = parcelRequire("8LIl9");

var $17acd5ea8a458e2a$var$IE_PROTO = (parcelRequire("fZhMi"))('IE_PROTO');
var $17acd5ea8a458e2a$var$Empty = function() {};
var $17acd5ea8a458e2a$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $17acd5ea8a458e2a$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("8IahC"))('iframe');
    var i = $8LIl9.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("jcava")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $17acd5ea8a458e2a$var$createDict = iframeDocument.F;
    while(i--)delete $17acd5ea8a458e2a$var$createDict[$17acd5ea8a458e2a$var$PROTOTYPE][$8LIl9[i]];
    return $17acd5ea8a458e2a$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $17acd5ea8a458e2a$var$Empty[$17acd5ea8a458e2a$var$PROTOTYPE] = $1J67F(O);
        result = new $17acd5ea8a458e2a$var$Empty();
        $17acd5ea8a458e2a$var$Empty[$17acd5ea8a458e2a$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$17acd5ea8a458e2a$var$IE_PROTO] = O;
    } else result = $17acd5ea8a458e2a$var$createDict();
    return Properties === undefined ? result : $aRCm2(result, Properties);
};

});
parcelRegister("aRCm2", function(module, exports) {

var $2J4Nu = parcelRequire("2J4Nu");

var $1J67F = parcelRequire("1J67F");

var $iTod0 = parcelRequire("iTod0");

module.exports = (parcelRequire("aPbfY")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $1J67F(O);
    var keys = $iTod0(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$2J4Nu.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("iTod0", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $vYsY4 = parcelRequire("vYsY4");

var $8LIl9 = parcelRequire("8LIl9");
module.exports = Object.keys || function keys(O) {
    return $vYsY4(O, $8LIl9);
};

});
parcelRegister("vYsY4", function(module, exports) {

var $8cV4K = parcelRequire("8cV4K");

var $ehxEQ = parcelRequire("ehxEQ");

var $0601ccb297d1ed28$var$arrayIndexOf = (parcelRequire("80pUB"))(false);

var $0601ccb297d1ed28$var$IE_PROTO = (parcelRequire("fZhMi"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $ehxEQ(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $0601ccb297d1ed28$var$IE_PROTO) $8cV4K(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8cV4K(O, key = names[i++])) ~$0601ccb297d1ed28$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("ehxEQ", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $45UmF = parcelRequire("45UmF");

var $3BBLi = parcelRequire("3BBLi");
module.exports = function(it) {
    return $45UmF($3BBLi(it));
};

});
parcelRegister("45UmF", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $g8809 = parcelRequire("g8809");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $g8809(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("g8809", function(module, exports) {
var $bbe399a4209a50a6$var$toString = {}.toString;
module.exports = function(it) {
    return $bbe399a4209a50a6$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("3BBLi", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("80pUB", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $ehxEQ = parcelRequire("ehxEQ");

var $fVjkK = parcelRequire("fVjkK");

var $eh5pH = parcelRequire("eh5pH");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $ehxEQ($this);
        var length = $fVjkK(O.length);
        var index = $eh5pH(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("fVjkK", function(module, exports) {
// 7.1.15 ToLength

var $9E260 = parcelRequire("9E260");
var $b97b2d25065ac7b9$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $b97b2d25065ac7b9$var$min($9E260(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("9E260", function(module, exports) {
// 7.1.4 ToInteger
var $705979a7eeb2722c$var$ceil = Math.ceil;
var $705979a7eeb2722c$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $705979a7eeb2722c$var$floor : $705979a7eeb2722c$var$ceil)(it);
};

});


parcelRegister("eh5pH", function(module, exports) {

var $9E260 = parcelRequire("9E260");
var $a646da372e065330$var$max = Math.max;
var $a646da372e065330$var$min = Math.min;
module.exports = function(index, length) {
    index = $9E260(index);
    return index < 0 ? $a646da372e065330$var$max(index + length, 0) : $a646da372e065330$var$min(index, length);
};

});


parcelRegister("fZhMi", function(module, exports) {

var $ba3a57d696ea3f5e$var$shared = (parcelRequire("51eCU"))('keys');

var $6oFvJ = parcelRequire("6oFvJ");
module.exports = function(key) {
    return $ba3a57d696ea3f5e$var$shared[key] || ($ba3a57d696ea3f5e$var$shared[key] = $6oFvJ(key));
};

});
parcelRegister("51eCU", function(module, exports) {

var $4KXzV = parcelRequire("4KXzV");

var $4tgdI = parcelRequire("4tgdI");
var $3a78644a27e09ff7$var$SHARED = '__core-js_shared__';
var $3a78644a27e09ff7$var$store = $4tgdI[$3a78644a27e09ff7$var$SHARED] || ($4tgdI[$3a78644a27e09ff7$var$SHARED] = {});

(module.exports = function(key, value) {
    return $3a78644a27e09ff7$var$store[key] || ($3a78644a27e09ff7$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $4KXzV.version,
    mode: (parcelRequire("fQqAk")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("fQqAk", function(module, exports) {
module.exports = true;

});


parcelRegister("6oFvJ", function(module, exports) {
var $4a852f27f31a7144$var$id = 0;
var $4a852f27f31a7144$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$4a852f27f31a7144$var$id + $4a852f27f31a7144$var$px).toString(36));
};

});



parcelRegister("8LIl9", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("jcava", function(module, exports) {

var $4tgdI = parcelRequire("4tgdI");
var $df9748b6b5115090$require$document = $4tgdI.document;
module.exports = $df9748b6b5115090$require$document && $df9748b6b5115090$require$document.documentElement;

});





parcelRegister("blzS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0221c40d50c91a18$export$2e2bcd8739ae039);

var $XfZ8C = parcelRequire("XfZ8C");
function $0221c40d50c91a18$export$2e2bcd8739ae039(o, p) {
    $0221c40d50c91a18$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($XfZ8C))) ? (0, (/*@__PURE__*/$parcel$interopDefault($XfZ8C))).bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0221c40d50c91a18$export$2e2bcd8739ae039(o, p);
}

});
parcelRegister("XfZ8C", function(module, exports) {

module.exports = (parcelRequire("54tg9"));

});
parcelRegister("54tg9", function(module, exports) {
parcelRequire("lLIVa");

module.exports = (parcelRequire("4KXzV")).Object.setPrototypeOf;

});
parcelRegister("lLIVa", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $fNMIk = parcelRequire("fNMIk");

$fNMIk($fNMIk.S, 'Object', {
    setPrototypeOf: (parcelRequire("j14FP")).set
});

});
parcelRegister("j14FP", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $dxLeJ = parcelRequire("dxLeJ");

var $1J67F = parcelRequire("1J67F");
var $dd81bc62c5518cb8$var$check = function(O, proto) {
    $1J67F(O);
    if (!$dxLeJ(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("85v89"))(Function.call, (parcelRequire("fZ4ki")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $dd81bc62c5518cb8$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $dd81bc62c5518cb8$var$check
};

});
parcelRegister("fZ4ki", function(module, exports) {

$parcel$export(module.exports, "f", () => $ba2fe8a7b47b04c8$export$2d1720544b23b823, (v) => $ba2fe8a7b47b04c8$export$2d1720544b23b823 = v);
var $ba2fe8a7b47b04c8$export$2d1720544b23b823;

var $1paSc = parcelRequire("1paSc");

var $azl1x = parcelRequire("azl1x");

var $ehxEQ = parcelRequire("ehxEQ");

var $feF34 = parcelRequire("feF34");

var $8cV4K = parcelRequire("8cV4K");

var $7fdxi = parcelRequire("7fdxi");
var $ba2fe8a7b47b04c8$var$gOPD = Object.getOwnPropertyDescriptor;

$ba2fe8a7b47b04c8$export$2d1720544b23b823 = (parcelRequire("aPbfY")) ? $ba2fe8a7b47b04c8$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $ehxEQ(O);
    P = $feF34(P, true);
    if ($7fdxi) try {
        return $ba2fe8a7b47b04c8$var$gOPD(O, P);
    } catch (e) {}
    if ($8cV4K(O, P)) return $azl1x(!$1paSc.f.call(O, P), O[P]);
};

});
parcelRegister("1paSc", function(module, exports) {

$parcel$export(module.exports, "f", () => $10608f6e292983ab$export$2d1720544b23b823, (v) => $10608f6e292983ab$export$2d1720544b23b823 = v);
var $10608f6e292983ab$export$2d1720544b23b823;
$10608f6e292983ab$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});








parcelRegister("gzM5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $c115376b03ce6805$export$2e2bcd8739ae039);

var $4iZOV = parcelRequire("4iZOV");
function $c115376b03ce6805$export$2e2bcd8739ae039() {
    $c115376b03ce6805$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4iZOV))) ? (0, (/*@__PURE__*/$parcel$interopDefault($4iZOV))).bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c115376b03ce6805$export$2e2bcd8739ae039.apply(this, arguments);
}

});
parcelRegister("4iZOV", function(module, exports) {

module.exports = (parcelRequire("jSAle"));

});
parcelRegister("jSAle", function(module, exports) {
parcelRequire("gGoAI");

module.exports = (parcelRequire("4KXzV")).Object.assign;

});
parcelRegister("gGoAI", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $fNMIk = parcelRequire("fNMIk");

$fNMIk($fNMIk.S + $fNMIk.F, 'Object', {
    assign: (parcelRequire("f40xK"))
});

});
parcelRegister("f40xK", function(module, exports) {
'use strict';

var $aPbfY = parcelRequire("aPbfY");

var $iTod0 = parcelRequire("iTod0");

var $8SJ8c = parcelRequire("8SJ8c");

var $1paSc = parcelRequire("1paSc");

var $llAOy = parcelRequire("llAOy");

var $45UmF = parcelRequire("45UmF");
var $af77a69d8871d271$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$af77a69d8871d271$var$$assign || (parcelRequire("cKvWG"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $af77a69d8871d271$var$$assign({}, A)[S] != 7 || Object.keys($af77a69d8871d271$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $llAOy(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $8SJ8c.f;
    var isEnum = $1paSc.f;
    while(aLen > index){
        var S = $45UmF(arguments[index++]);
        var keys = getSymbols ? $iTod0(S).concat(getSymbols(S)) : $iTod0(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$aPbfY || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $af77a69d8871d271$var$$assign;

});
parcelRegister("8SJ8c", function(module, exports) {

$parcel$export(module.exports, "f", () => $67765ffbebba3db3$export$2d1720544b23b823, (v) => $67765ffbebba3db3$export$2d1720544b23b823 = v);
var $67765ffbebba3db3$export$2d1720544b23b823;
$67765ffbebba3db3$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("llAOy", function(module, exports) {
// 7.1.13 ToObject(argument)

var $3BBLi = parcelRequire("3BBLi");
module.exports = function(it) {
    return Object($3BBLi(it));
};

});






parcelRegister("22j3V", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $17ba8e0cb3c50187$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $17ba8e0cb3c50187$export$66e4520cdb265d18);
$parcel$export(module.exports, "bindActionCreators", () => $17ba8e0cb3c50187$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $17ba8e0cb3c50187$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $17ba8e0cb3c50187$export$9ff26e0402cc7b7);

var $d56Hw = parcelRequire("d56Hw");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $17ba8e0cb3c50187$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $17ba8e0cb3c50187$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $17ba8e0cb3c50187$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $17ba8e0cb3c50187$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $17ba8e0cb3c50187$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $17ba8e0cb3c50187$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $17ba8e0cb3c50187$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $17ba8e0cb3c50187$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $17ba8e0cb3c50187$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($17ba8e0cb3c50187$var$isDate(val)) return 'date';
    if ($17ba8e0cb3c50187$var$isError(val)) return 'error';
    var constructorName = $17ba8e0cb3c50187$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $17ba8e0cb3c50187$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $17ba8e0cb3c50187$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $17ba8e0cb3c50187$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $17ba8e0cb3c50187$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $17ba8e0cb3c50187$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(1));
        return enhancer($17ba8e0cb3c50187$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$17ba8e0cb3c50187$var$isPlainObject(action)) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $17ba8e0cb3c50187$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$17ba8e0cb3c50187$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $17ba8e0cb3c50187$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$17ba8e0cb3c50187$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $17ba8e0cb3c50187$export$8928921ea2d3b126 = $17ba8e0cb3c50187$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $17ba8e0cb3c50187$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $17ba8e0cb3c50187$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $17ba8e0cb3c50187$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$17ba8e0cb3c50187$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $17ba8e0cb3c50187$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $17ba8e0cb3c50187$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $17ba8e0cb3c50187$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $17ba8e0cb3c50187$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $17ba8e0cb3c50187$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $17ba8e0cb3c50187$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $17ba8e0cb3c50187$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $17ba8e0cb3c50187$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $17ba8e0cb3c50187$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $17ba8e0cb3c50187$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $17ba8e0cb3c50187$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $17ba8e0cb3c50187$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $17ba8e0cb3c50187$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($17ba8e0cb3c50187$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $17ba8e0cb3c50187$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $d56Hw.default)((0, $d56Hw.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("d56Hw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9860f0a512598bc6$export$2e2bcd8739ae039);

var $eHiP8 = parcelRequire("eHiP8");
function $9860f0a512598bc6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9860f0a512598bc6$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9860f0a512598bc6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $eHiP8.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9860f0a512598bc6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});


parcelRegister("i6AsN", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("AuRrZ")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("9bdMd")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("616sH")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("6S8MB")).useSelector);
parcelRequire("dDvQ8");
parcelRequire("8mhVE");
var $7nsd3 = parcelRequire("7nsd3");

var $297cv = parcelRequire("297cv");
// with standard React renderers (ReactDOM, React Native)
(0, $297cv.setBatch)((0, $7nsd3.unstable_batchedUpdates));

});
parcelRegister("dDvQ8", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("9bdMd")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("AuRrZ")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("616sH")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("6S8MB")).useSelector);

var $9bdMd = parcelRequire("9bdMd");

var $evQWN = parcelRequire("evQWN");

var $eZhPT = parcelRequire("eZhPT");

var $AuRrZ = parcelRequire("AuRrZ");

var $616sH = parcelRequire("616sH");

var $6S8MB = parcelRequire("6S8MB");

var $5sekt = parcelRequire("5sekt");

var $ggTLx = parcelRequire("ggTLx");

});
parcelRegister("9bdMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aefd3e4140316d1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $eZhPT = parcelRequire("eZhPT");

var $arhzp = parcelRequire("arhzp");

var $gneWW = parcelRequire("gneWW");
function $6aefd3e4140316d1$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $5uXOq.useMemo)(function() {
        var subscription = (0, $arhzp.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $5uXOq.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $gneWW.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $eZhPT.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $6aefd3e4140316d1$export$2e2bcd8739ae039 = $6aefd3e4140316d1$var$Provider;

});
parcelRegister("eZhPT", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $ae9499069f1e06d6$export$cc80c08dc91f1c00);

var $5uXOq = parcelRequire("5uXOq");
var $ae9499069f1e06d6$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
var $ae9499069f1e06d6$export$2e2bcd8739ae039 = $ae9499069f1e06d6$export$cc80c08dc91f1c00;

});

parcelRegister("arhzp", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $799a0e0be31b1662$export$d567d2b9af322f8f);

var $297cv = parcelRequire("297cv");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $799a0e0be31b1662$var$createListenerCollection() {
    var batch = (0, $297cv.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $799a0e0be31b1662$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $799a0e0be31b1662$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $799a0e0be31b1662$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $799a0e0be31b1662$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $799a0e0be31b1662$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("297cv", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $190201f2d37d6502$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $190201f2d37d6502$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $190201f2d37d6502$var$defaultNoopBatch(callback) {
    callback();
}
var $190201f2d37d6502$var$batch = $190201f2d37d6502$var$defaultNoopBatch; // Allow injecting another batching function later
var $190201f2d37d6502$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $190201f2d37d6502$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $190201f2d37d6502$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $190201f2d37d6502$var$batch;
};

});


parcelRegister("gneWW", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $beba64068692f8ee$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $beba64068692f8ee$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $5uXOq.useLayoutEffect) : (0, $5uXOq.useEffect);

});


parcelRegister("evQWN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a90d08332793f660$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");

var $dY8Js = parcelRequire("dY8Js");

var $5uXOq = parcelRequire("5uXOq");

var $bCzx0 = parcelRequire("bCzx0");

var $arhzp = parcelRequire("arhzp");

var $gneWW = parcelRequire("gneWW");

var $eZhPT = parcelRequire("eZhPT");
var $a90d08332793f660$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $a90d08332793f660$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $a90d08332793f660$var$EMPTY_ARRAY = [];
var $a90d08332793f660$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $a90d08332793f660$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $a90d08332793f660$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $a90d08332793f660$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $gneWW.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $a90d08332793f660$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $a90d08332793f660$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $a90d08332793f660$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $a90d08332793f660$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $eZhPT.ReactReduxContext) : _ref2$context, connectOptions = (0, $ddEsc.default)(_ref2, $a90d08332793f660$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $bS32t.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $5uXOq.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $5uXOq.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $ddEsc.default)(props, $a90d08332793f660$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $5uXOq.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $bCzx0.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $5uXOq.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $5uXOq.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $5uXOq.useMemo)(function() {
                if (!shouldHandleStateChanges) return $a90d08332793f660$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $arhzp.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $5uXOq.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $bS32t.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $5uXOq.useReducer)($a90d08332793f660$var$storeStateUpdatesReducer, $a90d08332793f660$var$EMPTY_ARRAY, $a90d08332793f660$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $5uXOq.useRef)();
            var lastWrapperProps = (0, $5uXOq.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $5uXOq.useRef)();
            var renderIsScheduled = (0, $5uXOq.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $a90d08332793f660$var$useIsomorphicLayoutEffectWithArgs($a90d08332793f660$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $a90d08332793f660$var$useIsomorphicLayoutEffectWithArgs($a90d08332793f660$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $5uXOq.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, (0, $bS32t.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $5uXOq.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Connect, (0, $bS32t.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("bCzx0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dJaa4"));

});
parcelRegister("dJaa4", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $9fe75c2c5f477da2$export$a7c73072b1a182ae, (v) => $9fe75c2c5f477da2$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9fe75c2c5f477da2$export$9f27bc3417b4524d, (v) => $9fe75c2c5f477da2$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9fe75c2c5f477da2$export$db77ccec0bb4ccac, (v) => $9fe75c2c5f477da2$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9fe75c2c5f477da2$export$8392c0c9d3dcbd35, (v) => $9fe75c2c5f477da2$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9fe75c2c5f477da2$export$ffb0004e005737fa, (v) => $9fe75c2c5f477da2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9fe75c2c5f477da2$export$b624eff549462981, (v) => $9fe75c2c5f477da2$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9fe75c2c5f477da2$export$7897aa7841a5380c, (v) => $9fe75c2c5f477da2$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9fe75c2c5f477da2$export$602eac185826482c, (v) => $9fe75c2c5f477da2$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9fe75c2c5f477da2$export$e2c29f18771995cb, (v) => $9fe75c2c5f477da2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9fe75c2c5f477da2$export$5f8d39834fd61797, (v) => $9fe75c2c5f477da2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9fe75c2c5f477da2$export$74bf444e3cd11ea5, (v) => $9fe75c2c5f477da2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9fe75c2c5f477da2$export$92387174baf9b227, (v) => $9fe75c2c5f477da2$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9fe75c2c5f477da2$export$ec112efeb987d9c6, (v) => $9fe75c2c5f477da2$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9fe75c2c5f477da2$export$b706b080d889d2c9, (v) => $9fe75c2c5f477da2$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9fe75c2c5f477da2$export$5be5a87408f70ddc, (v) => $9fe75c2c5f477da2$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9fe75c2c5f477da2$export$45a5e7f76e0caa8d, (v) => $9fe75c2c5f477da2$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9fe75c2c5f477da2$export$455c2e768291efa6, (v) => $9fe75c2c5f477da2$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9fe75c2c5f477da2$export$9522e17588c12572, (v) => $9fe75c2c5f477da2$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9fe75c2c5f477da2$export$2110ac352bb060b9, (v) => $9fe75c2c5f477da2$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9fe75c2c5f477da2$export$56885ab8b9c456ab, (v) => $9fe75c2c5f477da2$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9fe75c2c5f477da2$export$d927fcb6adf8f9de, (v) => $9fe75c2c5f477da2$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9fe75c2c5f477da2$export$b82d16f27459e05a, (v) => $9fe75c2c5f477da2$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9fe75c2c5f477da2$export$522c17b4f5e123e8, (v) => $9fe75c2c5f477da2$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9fe75c2c5f477da2$export$1aabd8a0274ecfd6, (v) => $9fe75c2c5f477da2$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9fe75c2c5f477da2$export$9b621391a187a31a, (v) => $9fe75c2c5f477da2$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9fe75c2c5f477da2$export$f5bbd400c2f4426f, (v) => $9fe75c2c5f477da2$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9fe75c2c5f477da2$export$a7c73072b1a182ae;
var $9fe75c2c5f477da2$export$9f27bc3417b4524d;
var $9fe75c2c5f477da2$export$db77ccec0bb4ccac;
var $9fe75c2c5f477da2$export$8392c0c9d3dcbd35;
var $9fe75c2c5f477da2$export$ffb0004e005737fa;
var $9fe75c2c5f477da2$export$b624eff549462981;
var $9fe75c2c5f477da2$export$7897aa7841a5380c;
var $9fe75c2c5f477da2$export$602eac185826482c;
var $9fe75c2c5f477da2$export$e2c29f18771995cb;
var $9fe75c2c5f477da2$export$5f8d39834fd61797;
var $9fe75c2c5f477da2$export$74bf444e3cd11ea5;
var $9fe75c2c5f477da2$export$92387174baf9b227;
var $9fe75c2c5f477da2$export$ec112efeb987d9c6;
var $9fe75c2c5f477da2$export$b706b080d889d2c9;
var $9fe75c2c5f477da2$export$5be5a87408f70ddc;
var $9fe75c2c5f477da2$export$45a5e7f76e0caa8d;
var $9fe75c2c5f477da2$export$455c2e768291efa6;
var $9fe75c2c5f477da2$export$9522e17588c12572;
var $9fe75c2c5f477da2$export$2110ac352bb060b9;
var $9fe75c2c5f477da2$export$56885ab8b9c456ab;
var $9fe75c2c5f477da2$export$d927fcb6adf8f9de;
var $9fe75c2c5f477da2$export$b82d16f27459e05a;
var $9fe75c2c5f477da2$export$522c17b4f5e123e8;
var $9fe75c2c5f477da2$export$1aabd8a0274ecfd6;
var $9fe75c2c5f477da2$export$9b621391a187a31a;
var $9fe75c2c5f477da2$export$f5bbd400c2f4426f;
'use strict';
var $9fe75c2c5f477da2$var$b = 60103, $9fe75c2c5f477da2$var$c = 60106, $9fe75c2c5f477da2$var$d = 60107, $9fe75c2c5f477da2$var$e = 60108, $9fe75c2c5f477da2$var$f = 60114, $9fe75c2c5f477da2$var$g = 60109, $9fe75c2c5f477da2$var$h = 60110, $9fe75c2c5f477da2$var$k = 60112, $9fe75c2c5f477da2$var$l = 60113, $9fe75c2c5f477da2$var$m = 60120, $9fe75c2c5f477da2$var$n = 60115, $9fe75c2c5f477da2$var$p = 60116, $9fe75c2c5f477da2$var$q = 60121, $9fe75c2c5f477da2$var$r = 60122, $9fe75c2c5f477da2$var$u = 60117, $9fe75c2c5f477da2$var$v = 60129, $9fe75c2c5f477da2$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $9fe75c2c5f477da2$var$x = Symbol.for;
    $9fe75c2c5f477da2$var$b = $9fe75c2c5f477da2$var$x("react.element");
    $9fe75c2c5f477da2$var$c = $9fe75c2c5f477da2$var$x("react.portal");
    $9fe75c2c5f477da2$var$d = $9fe75c2c5f477da2$var$x("react.fragment");
    $9fe75c2c5f477da2$var$e = $9fe75c2c5f477da2$var$x("react.strict_mode");
    $9fe75c2c5f477da2$var$f = $9fe75c2c5f477da2$var$x("react.profiler");
    $9fe75c2c5f477da2$var$g = $9fe75c2c5f477da2$var$x("react.provider");
    $9fe75c2c5f477da2$var$h = $9fe75c2c5f477da2$var$x("react.context");
    $9fe75c2c5f477da2$var$k = $9fe75c2c5f477da2$var$x("react.forward_ref");
    $9fe75c2c5f477da2$var$l = $9fe75c2c5f477da2$var$x("react.suspense");
    $9fe75c2c5f477da2$var$m = $9fe75c2c5f477da2$var$x("react.suspense_list");
    $9fe75c2c5f477da2$var$n = $9fe75c2c5f477da2$var$x("react.memo");
    $9fe75c2c5f477da2$var$p = $9fe75c2c5f477da2$var$x("react.lazy");
    $9fe75c2c5f477da2$var$q = $9fe75c2c5f477da2$var$x("react.block");
    $9fe75c2c5f477da2$var$r = $9fe75c2c5f477da2$var$x("react.server.block");
    $9fe75c2c5f477da2$var$u = $9fe75c2c5f477da2$var$x("react.fundamental");
    $9fe75c2c5f477da2$var$v = $9fe75c2c5f477da2$var$x("react.debug_trace_mode");
    $9fe75c2c5f477da2$var$w = $9fe75c2c5f477da2$var$x("react.legacy_hidden");
}
function $9fe75c2c5f477da2$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $9fe75c2c5f477da2$var$b:
                switch(a = a.type, a){
                    case $9fe75c2c5f477da2$var$d:
                    case $9fe75c2c5f477da2$var$f:
                    case $9fe75c2c5f477da2$var$e:
                    case $9fe75c2c5f477da2$var$l:
                    case $9fe75c2c5f477da2$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9fe75c2c5f477da2$var$h:
                            case $9fe75c2c5f477da2$var$k:
                            case $9fe75c2c5f477da2$var$p:
                            case $9fe75c2c5f477da2$var$n:
                            case $9fe75c2c5f477da2$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $9fe75c2c5f477da2$var$c:
                return t;
        }
    }
}
var $9fe75c2c5f477da2$var$z = $9fe75c2c5f477da2$var$g, $9fe75c2c5f477da2$var$A = $9fe75c2c5f477da2$var$b, $9fe75c2c5f477da2$var$B = $9fe75c2c5f477da2$var$k, $9fe75c2c5f477da2$var$C = $9fe75c2c5f477da2$var$d, $9fe75c2c5f477da2$var$D = $9fe75c2c5f477da2$var$p, $9fe75c2c5f477da2$var$E = $9fe75c2c5f477da2$var$n, $9fe75c2c5f477da2$var$F = $9fe75c2c5f477da2$var$c, $9fe75c2c5f477da2$var$G = $9fe75c2c5f477da2$var$f, $9fe75c2c5f477da2$var$H = $9fe75c2c5f477da2$var$e, $9fe75c2c5f477da2$var$I = $9fe75c2c5f477da2$var$l;
$9fe75c2c5f477da2$export$a7c73072b1a182ae = $9fe75c2c5f477da2$var$h;
$9fe75c2c5f477da2$export$9f27bc3417b4524d = $9fe75c2c5f477da2$var$z;
$9fe75c2c5f477da2$export$db77ccec0bb4ccac = $9fe75c2c5f477da2$var$A;
$9fe75c2c5f477da2$export$8392c0c9d3dcbd35 = $9fe75c2c5f477da2$var$B;
$9fe75c2c5f477da2$export$ffb0004e005737fa = $9fe75c2c5f477da2$var$C;
$9fe75c2c5f477da2$export$b624eff549462981 = $9fe75c2c5f477da2$var$D;
$9fe75c2c5f477da2$export$7897aa7841a5380c = $9fe75c2c5f477da2$var$E;
$9fe75c2c5f477da2$export$602eac185826482c = $9fe75c2c5f477da2$var$F;
$9fe75c2c5f477da2$export$e2c29f18771995cb = $9fe75c2c5f477da2$var$G;
$9fe75c2c5f477da2$export$5f8d39834fd61797 = $9fe75c2c5f477da2$var$H;
$9fe75c2c5f477da2$export$74bf444e3cd11ea5 = $9fe75c2c5f477da2$var$I;
$9fe75c2c5f477da2$export$92387174baf9b227 = function() {
    return !1;
};
$9fe75c2c5f477da2$export$ec112efeb987d9c6 = function() {
    return !1;
};
$9fe75c2c5f477da2$export$b706b080d889d2c9 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$h;
};
$9fe75c2c5f477da2$export$5be5a87408f70ddc = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$g;
};
$9fe75c2c5f477da2$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9fe75c2c5f477da2$var$b;
};
$9fe75c2c5f477da2$export$455c2e768291efa6 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$k;
};
$9fe75c2c5f477da2$export$9522e17588c12572 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$d;
};
$9fe75c2c5f477da2$export$2110ac352bb060b9 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$p;
};
$9fe75c2c5f477da2$export$56885ab8b9c456ab = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$n;
};
$9fe75c2c5f477da2$export$d927fcb6adf8f9de = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$c;
};
$9fe75c2c5f477da2$export$b82d16f27459e05a = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$f;
};
$9fe75c2c5f477da2$export$522c17b4f5e123e8 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$e;
};
$9fe75c2c5f477da2$export$1aabd8a0274ecfd6 = function(a) {
    return $9fe75c2c5f477da2$var$y(a) === $9fe75c2c5f477da2$var$l;
};
$9fe75c2c5f477da2$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9fe75c2c5f477da2$var$d || a === $9fe75c2c5f477da2$var$f || a === $9fe75c2c5f477da2$var$v || a === $9fe75c2c5f477da2$var$e || a === $9fe75c2c5f477da2$var$l || a === $9fe75c2c5f477da2$var$m || a === $9fe75c2c5f477da2$var$w || "object" === typeof a && null !== a && (a.$$typeof === $9fe75c2c5f477da2$var$p || a.$$typeof === $9fe75c2c5f477da2$var$n || a.$$typeof === $9fe75c2c5f477da2$var$g || a.$$typeof === $9fe75c2c5f477da2$var$h || a.$$typeof === $9fe75c2c5f477da2$var$k || a.$$typeof === $9fe75c2c5f477da2$var$u || a.$$typeof === $9fe75c2c5f477da2$var$q || a[0] === $9fe75c2c5f477da2$var$r) ? !0 : !1;
};
$9fe75c2c5f477da2$export$f5bbd400c2f4426f = $9fe75c2c5f477da2$var$y;

});



parcelRegister("AuRrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $06db4d47a421a2eb$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");

var $evQWN = parcelRequire("evQWN");

var $ggTLx = parcelRequire("ggTLx");

var $aRR2I = parcelRequire("aRR2I");

var $li0D7 = parcelRequire("li0D7");

var $3zSL8 = parcelRequire("3zSL8");

var $aQWN9 = parcelRequire("aQWN9");
var $06db4d47a421a2eb$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $06db4d47a421a2eb$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $06db4d47a421a2eb$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $06db4d47a421a2eb$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $evQWN.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $li0D7.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $aRR2I.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $3zSL8.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $aQWN9.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $06db4d47a421a2eb$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $ggTLx.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $ggTLx.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $ggTLx.default) : _ref3$areMergedPropsE, extraOptions = (0, $ddEsc.default)(_ref3, $06db4d47a421a2eb$var$_excluded);
        var initMapStateToProps = $06db4d47a421a2eb$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $06db4d47a421a2eb$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $06db4d47a421a2eb$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $bS32t.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $06db4d47a421a2eb$export$2e2bcd8739ae039 = /*#__PURE__*/ $06db4d47a421a2eb$export$9f9feb656dec1fc4();

});
parcelRegister("ggTLx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd8965e05453892e$export$2e2bcd8739ae039);
function $bd8965e05453892e$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $bd8965e05453892e$export$2e2bcd8739ae039(objA, objB) {
    if ($bd8965e05453892e$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$bd8965e05453892e$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("aRR2I", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e97ffd151087114$export$2e2bcd8739ae039);

var $a37gJ = parcelRequire("a37gJ");

var $8EqLJ = parcelRequire("8EqLJ");
function $7e97ffd151087114$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $8EqLJ.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $7e97ffd151087114$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $8EqLJ.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $7e97ffd151087114$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $8EqLJ.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $a37gJ.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $7e97ffd151087114$export$2e2bcd8739ae039 = [
    $7e97ffd151087114$export$a9f27b4b187c1166,
    $7e97ffd151087114$export$ba20d1a7aa0c4a90,
    $7e97ffd151087114$export$94a6e55709d4d961
];

});
parcelRegister("a37gJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $750fd2a673ba963c$export$2e2bcd8739ae039);
function $750fd2a673ba963c$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("8EqLJ", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $64c6d2e3c8e9f263$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $64c6d2e3c8e9f263$export$8d46c7f53c8c602f);
parcelRequire("1prLO");
function $64c6d2e3c8e9f263$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $64c6d2e3c8e9f263$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $64c6d2e3c8e9f263$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $64c6d2e3c8e9f263$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $64c6d2e3c8e9f263$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("1prLO", function(module, exports) {

var $im3MO = parcelRequire("im3MO");

var $kb4xC = parcelRequire("kb4xC");
function $106daad597fc23e6$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $im3MO.default)(value)) (0, $kb4xC.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("im3MO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cd37f6759c7272$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $d5cd37f6759c7272$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("kb4xC", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb085b81b2733980$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $eb085b81b2733980$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("li0D7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7fbc484b4e9d2ee$export$2e2bcd8739ae039);

var $8EqLJ = parcelRequire("8EqLJ");
function $f7fbc484b4e9d2ee$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $8EqLJ.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $f7fbc484b4e9d2ee$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $8EqLJ.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $f7fbc484b4e9d2ee$export$2e2bcd8739ae039 = [
    $f7fbc484b4e9d2ee$export$23fc470827b14aa,
    $f7fbc484b4e9d2ee$export$514bc8c1a53c1d66
];

});

parcelRegister("3zSL8", function(module, exports) {

$parcel$export(module.exports, "default", () => $29af1e0b3bc3959e$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");
parcelRequire("1prLO");
function $29af1e0b3bc3959e$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $bS32t.default)({}, ownProps, stateProps, dispatchProps);
}
function $29af1e0b3bc3959e$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $29af1e0b3bc3959e$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $29af1e0b3bc3959e$export$5b105939c84b5234(mergeProps) : undefined;
}
function $29af1e0b3bc3959e$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $29af1e0b3bc3959e$export$691c327fc30bc857;
    } : undefined;
}
var $29af1e0b3bc3959e$export$2e2bcd8739ae039 = [
    $29af1e0b3bc3959e$export$d61b680184bc3f00,
    $29af1e0b3bc3959e$export$a13ba70ef50dda6d
];

});

parcelRegister("aQWN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e6c5d8bc061ff2f$export$2e2bcd8739ae039);

var $ddEsc = parcelRequire("ddEsc");
parcelRequire("8XVVW");
var $7e6c5d8bc061ff2f$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $7e6c5d8bc061ff2f$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $7e6c5d8bc061ff2f$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $7e6c5d8bc061ff2f$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $ddEsc.default)(_ref2, $7e6c5d8bc061ff2f$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $7e6c5d8bc061ff2f$export$d20c0c2ca6eb2b6f : $7e6c5d8bc061ff2f$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("8XVVW", function(module, exports) {

var $kb4xC = parcelRequire("kb4xC");
function $6870c5d2f9dd91da$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $kb4xC.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $6870c5d2f9dd91da$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $6870c5d2f9dd91da$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $6870c5d2f9dd91da$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $6870c5d2f9dd91da$var$verify(mergeProps, 'mergeProps', displayName);
}

});



parcelRegister("616sH", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $4617d947d89cb783$export$8ad76b76a4c905f8);

var $eZhPT = parcelRequire("eZhPT");

var $5sekt = parcelRequire("5sekt");
function $4617d947d89cb783$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $eZhPT.ReactReduxContext);
    var useStore = context === (0, $eZhPT.ReactReduxContext) ? (0, $5sekt.useStore) : (0, $5sekt.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $4617d947d89cb783$export$8ad76b76a4c905f8 = /*#__PURE__*/ $4617d947d89cb783$export$bc9b55530897c558();

});
parcelRegister("5sekt", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $3f8aaec7bfa91a5f$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $3f8aaec7bfa91a5f$export$6ccbb43953eebf8);

var $5uXOq = parcelRequire("5uXOq");

var $eZhPT = parcelRequire("eZhPT");

var $i2tgo = parcelRequire("i2tgo");
function $3f8aaec7bfa91a5f$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $eZhPT.ReactReduxContext);
    var useReduxContext = context === (0, $eZhPT.ReactReduxContext) ? (0, $i2tgo.useReduxContext) : function() {
        return (0, $5uXOq.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $3f8aaec7bfa91a5f$export$6ccbb43953eebf8 = /*#__PURE__*/ $3f8aaec7bfa91a5f$export$671dba69185d0304();

});
parcelRegister("i2tgo", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $d21f1d0198d74b68$export$c1275ca9a6fd3ec5);

var $5uXOq = parcelRequire("5uXOq");

var $eZhPT = parcelRequire("eZhPT");
function $d21f1d0198d74b68$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $5uXOq.useContext)((0, $eZhPT.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("6S8MB", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $500e9950191b49f8$export$2105062e25df4afe);

var $5uXOq = parcelRequire("5uXOq");

var $i2tgo = parcelRequire("i2tgo");

var $arhzp = parcelRequire("arhzp");

var $gneWW = parcelRequire("gneWW");

var $eZhPT = parcelRequire("eZhPT");
var $500e9950191b49f8$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $500e9950191b49f8$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $5uXOq.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $5uXOq.useMemo)(function() {
        return (0, $arhzp.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $5uXOq.useRef)();
    var latestSelector = (0, $5uXOq.useRef)();
    var latestStoreState = (0, $5uXOq.useRef)();
    var latestSelectedState = (0, $5uXOq.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $gneWW.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $gneWW.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $500e9950191b49f8$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $eZhPT.ReactReduxContext);
    var useReduxContext = context === (0, $eZhPT.ReactReduxContext) ? (0, $i2tgo.useReduxContext) : function() {
        return (0, $5uXOq.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $500e9950191b49f8$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $500e9950191b49f8$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $5uXOq.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $500e9950191b49f8$export$2105062e25df4afe = /*#__PURE__*/ $500e9950191b49f8$export$2b53f90d2bd1cbfb();

});


parcelRegister("8mhVE", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("7nsd3")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $7nsd3 = parcelRequire("7nsd3");

});


parcelRegister("3YKxB", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $2e5b13c1f6ee9f8a$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $2e5b13c1f6ee9f8a$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $2e5b13c1f6ee9f8a$export$34928e660d2a8702);

var $3joPi = parcelRequire("3joPi");
var $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $2e5b13c1f6ee9f8a$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $2e5b13c1f6ee9f8a$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $2e5b13c1f6ee9f8a$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $2e5b13c1f6ee9f8a$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$padding;
    var marginBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $2e5b13c1f6ee9f8a$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $3joPi.default)(false);
    return result;
};
var $2e5b13c1f6ee9f8a$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $2e5b13c1f6ee9f8a$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $2e5b13c1f6ee9f8a$var$shift(borderBox, change);
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $2e5b13c1f6ee9f8a$var$getWindowScroll();
    return $2e5b13c1f6ee9f8a$export$cc800923e997bb8(original, scroll);
};
var $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.marginTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.marginRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.marginBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.paddingTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.paddingRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.paddingBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.borderTopWidth),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.borderRightWidth),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.borderBottomWidth),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.borderLeftWidth)
    };
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $2e5b13c1f6ee9f8a$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});

parcelRegister("g7psY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bbc10ddfc67bca56$export$2e2bcd8739ae039);
var $bbc10ddfc67bca56$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $bbc10ddfc67bca56$var$isEqual(first, second) {
    if (first === second) return true;
    if ($bbc10ddfc67bca56$var$safeIsNaN(first) && $bbc10ddfc67bca56$var$safeIsNaN(second)) return true;
    return false;
}
function $bbc10ddfc67bca56$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$bbc10ddfc67bca56$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $bbc10ddfc67bca56$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $bbc10ddfc67bca56$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $bbc10ddfc67bca56$export$2e2bcd8739ae039 = $bbc10ddfc67bca56$var$memoizeOne;

});

parcelRegister("i2aN7", function(module, exports) {

module.exports = (parcelRequire("jptOl"));

});
parcelRegister("jptOl", function(module, exports) {
parcelRequire("a0Ixs");

module.exports = (parcelRequire("4KXzV")).Object.values;

});
parcelRegister("a0Ixs", function(module, exports) {
// https://github.com/tc39/proposal-object-values-entries

var $fNMIk = parcelRequire("fNMIk");

var $749c73ef0828bdd4$var$$values = (parcelRequire("kQXku"))(false);
$fNMIk($fNMIk.S, 'Object', {
    values: function values(it) {
        return $749c73ef0828bdd4$var$$values(it);
    }
});

});
parcelRegister("kQXku", function(module, exports) {

var $aPbfY = parcelRequire("aPbfY");

var $iTod0 = parcelRequire("iTod0");

var $ehxEQ = parcelRequire("ehxEQ");

var $1paSc = parcelRequire("1paSc");
var $f2e6af8f0a9cbb36$require$isEnum = $1paSc.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $ehxEQ(it);
        var keys = $iTod0(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$aPbfY || $f2e6af8f0a9cbb36$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});




parcelRegister("cs3hJ", function(module, exports) {

module.exports = (parcelRequire("gtqo2"));

});
parcelRegister("gtqo2", function(module, exports) {
parcelRequire("jgnqd");

module.exports = (parcelRequire("4KXzV")).Object.keys;

});
parcelRegister("jgnqd", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $llAOy = parcelRequire("llAOy");

var $iTod0 = parcelRequire("iTod0");

(parcelRequire("4BA40"))('keys', function() {
    return function keys(it) {
        return $iTod0($llAOy(it));
    };
});

});
parcelRegister("4BA40", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $fNMIk = parcelRequire("fNMIk");

var $4KXzV = parcelRequire("4KXzV");

var $cKvWG = parcelRequire("cKvWG");
module.exports = function(KEY, exec) {
    var fn = ($4KXzV.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $fNMIk($fNMIk.S + $fNMIk.F * $cKvWG(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("crAmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f436e32f3db886$export$2e2bcd8739ae039);
var $90f436e32f3db886$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $90f436e32f3db886$export$2e2bcd8739ae039 = $90f436e32f3db886$var$rafSchd;

});

parcelRegister("3BSY2", function(module, exports) {

module.exports = (parcelRequire("4JOv4"));

});
parcelRegister("4JOv4", function(module, exports) {
parcelRequire("ixUy6");

module.exports = (parcelRequire("4KXzV")).Date.now;

});
parcelRegister("ixUy6", function(module, exports) {
// 20.3.3.1 / 15.9.4.4 Date.now()

var $fNMIk = parcelRequire("fNMIk");
$fNMIk($fNMIk.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});

});



parcelRegister("1DIXK", function(module, exports) {

module.exports = (parcelRequire("izccK"));

});
parcelRegister("izccK", function(module, exports) {
parcelRequire("bwyHq");

module.exports = (parcelRequire("4KXzV")).Number.isInteger;

});
parcelRegister("bwyHq", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $fNMIk = parcelRequire("fNMIk");

$fNMIk($fNMIk.S, 'Number', {
    isInteger: (parcelRequire("dFLKl"))
});

});
parcelRegister("dFLKl", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $dxLeJ = parcelRequire("dxLeJ");
var $9f4424297502c7e8$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$dxLeJ(it) && isFinite(it) && $9f4424297502c7e8$var$floor(it) === it;
};

});





parcelRegister("jRpyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $587ebd2bf67b6044$export$2e2bcd8739ae039);
/* item-line-card-view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8rCP3 = parcelRequire("8rCP3");

var $8Rkzz = parcelRequire("8Rkzz");

var $2Zxiy = parcelRequire("2Zxiy");


var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-compiled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $587ebd2bf67b6044$var$CardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _gfdrglyw _uxit3acm",
            __cmplp.className
        ])
    });
});
const $587ebd2bf67b6044$var$DraggableCardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_gfdrglyw _uxit3acm",
            __cmplp.className
        ])
    });
});
const $587ebd2bf67b6044$var$clearBorderMixin = null;
const $587ebd2bf67b6044$var$withFixedHeight = null;
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-compiled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $587ebd2bf67b6044$var$CardOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInteractive: isInteractive, isDragging: isDragging, isVariableHeight: isVariableHeight, isDraggable: isDraggable, isHovering: isHovering, isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_lk280q": (0, $lD23V.default)((()=>{
                if (__cmplp.isInteractive) return __cmplp.isDragging ? 'grabbing' : 'pointer';
                return 'auto';
            })()),
            "--_ntqkox": (0, $lD23V.default)(__cmplp.isDragging ? `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$exports).B50})` : `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$exports).B50})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7txrc _2rko1wrm _1yt41cy0 _18s81nxw _80oma357 _1e0c1txw _kqswh2mm _nt751r31 _49pcglyw _1hvw1o36 _rk8tkb7n _7ehiq1pr",
            !__cmplp.isVariableHeight && "_4t3i1ylp",
            __cmplp.isDragging ? "_n7zl1e2h" : "_n7zl1l7n",
            !__cmplp.isDraggable && "_13jwglyw _y7iw3acm",
            __cmplp.isHovering && "_4bfu18uv _1hmsglyw _ajmmnqa1 _bfhk14ae",
            __cmplp.isActive && "_11q7qits _16qs1kfg",
            __cmplp.className
        ])
    });
});
const $587ebd2bf67b6044$var$CardNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInteractive: isInteractive, isDragging: isDragging, isVariableHeight: isVariableHeight, isHovering: isHovering, isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_lk280q": (0, $lD23V.default)((()=>{
                if (__cmplp.isInteractive) return __cmplp.isDragging ? 'grabbing' : 'pointer';
                return 'auto';
            })()),
            "--_ntqkox": (0, $lD23V.default)(__cmplp.isDragging ? `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$exports).B50})` : `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$exports).B50})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7txrc _2rko1wrm _1yt41cy0 _18s81nxw _80oma357 _1e0c1txw _kqswh2mm _nt751r31 _49pcglyw _1hvw1o36 _rk8tkb7n _7ehiq1pr",
            !__cmplp.isVariableHeight && "_4t3i1ylp",
            __cmplp.isDragging ? "_n7zl1e2h" : "_n7zl1l7n",
            __cmplp.isHovering && "_4bfu18uv _1hmsglyw _ajmmnqa1 _bfhk14ae",
            __cmplp.isActive && "_11q7qits _16qs1kfg",
            __cmplp.className
        ])
    });
});
const $587ebd2bf67b6044$var$Card = (0, $cSD7y.componentWithFG)('issue-view_item-line-card-a11y-clone', $587ebd2bf67b6044$var$CardNew, $587ebd2bf67b6044$var$CardOld);
const $587ebd2bf67b6044$var$isMiddleClick = (event)=>event.button === 1;
class $587ebd2bf67b6044$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.propTypes = {
            item: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired,
            index: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).number.isRequired,
            isReorderEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
            isInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
            isVariableHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func.isRequired,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
        };
    }
    static{
        this.defaultProps = {
            isReorderEnabled: false,
            isInteractive: true,
            isVariableHeight: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    renderDraggableCard() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Zxiy.Draggable), {
            draggableId: this.props.item.id,
            index: this.props.index
        }, (provided, snapshot)=>{
            const cardJSX = this.renderCard({
                ref: provided.innerRef,
                isDraggable: true,
                isDragging: snapshot.isDragging,
                ...provided.draggableProps,
                ...this.patchedHandlers(provided.dragHandleProps, snapshot)
            });
            return (0, $4R6GH.fg)('issue-view_item-line-card-a11y-clone') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($587ebd2bf67b6044$var$CardContainer, null, cardJSX) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($587ebd2bf67b6044$var$DraggableCardContainer, null, cardJSX);
        });
    }
    render() {
        if (this.props.isReorderEnabled) return this.renderDraggableCard();
        if ((0, $4R6GH.fg)('issue-view_item-line-card-a11y-clone')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($587ebd2bf67b6044$var$CardContainer, null, this.renderCard({
            ...this.eventHandlers
        }));
        return this.renderCard({
            ...this.eventHandlers
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isHovering: false,
            isActive: false,
            isFocused: false
        }, this.eventHandlers = {
            onBlur: ()=>{
                this.setState({
                    isFocused: false
                });
            },
            onClick: (event)=>{
                // best practice to use for react-beautiful-dnd (https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-use-dom-events.md)
                if (event.defaultPrevented === true) return;
                // Middle clicks are handled in onMouseDown for cross browser support.
                if (!$587ebd2bf67b6044$var$isMiddleClick(event)) this.propagateClick(event);
            },
            onDragEnd: ()=>this.setState({
                    isActive: false
                }),
            onFocus: ()=>{
                this.setState({
                    isFocused: true
                });
            },
            onMouseEnter: ()=>this.setState({
                    isHovering: true
                }),
            onMouseLeave: ()=>this.setState({
                    isHovering: false,
                    isActive: false
                }),
            onMouseDown: (event)=>{
                if ($587ebd2bf67b6044$var$isMiddleClick(event)) this.propagateClick(event);
                this.setState({
                    isActive: true
                });
            },
            onMouseUp: ()=>this.setState({
                    isActive: false
                })
        }, this.propagateClick = (event)=>{
            this.props.onClick(this.props.item, event);
        }, this.patchedHandlers = (dragHandleProps, snapshot)=>{
            /* The 'isActive' state is determined by the draggable state,
             i.e. if isDragging then the state is considered active. */ const onMouseDown = (event)=>{
                if ($587ebd2bf67b6044$var$isMiddleClick(event)) this.propagateClick(event);
            };
            const onClick = !dragHandleProps ? this.eventHandlers.onClick : (event)=>{
                if (!snapshot.isDragging) this.eventHandlers.onClick(event);
            };
            return {
                ...dragHandleProps,
                ...this.eventHandlers,
                onClick: onClick,
                onMouseDown: onMouseDown
            };
        }, this.renderCard = (cardProps)=>{
            const { isInteractive: isInteractive, item: item, isVariableHeight: isVariableHeight } = this.props;
            const { isHovering: isHovering, isFocused: isFocused } = this.state;
            const isActive = Boolean(cardProps.isDragging) || this.state.isActive;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($587ebd2bf67b6044$var$Card, {
                ...cardProps,
                ...this.state,
                isInteractive: isInteractive,
                isActive: isActive,
                isVariableHeight: isVariableHeight
            }, this.props.children(isHovering, isActive, isFocused, item));
        };
    }
}

});


parcelRegister("c9mvf", function(module, exports) {

$parcel$export(module.exports, "default", () => $290bf46ff2727f04$export$2e2bcd8739ae039);
/* issue-line-card-view.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3bDjY = parcelRequire("3bDjY");

var $jjlQu = parcelRequire("jjlQu");

var $gULOk = parcelRequire("gULOk");

var $7VHMR = parcelRequire("7VHMR");
var $8RXs9 = parcelRequire("8RXs9");

var $2eMTS = parcelRequire("2eMTS");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");
const $290bf46ff2727f04$var$messages = (0, $7VHMR.defineMessages)({
    issueTypeTitle: {
        "id": "servicedesk-issue-line-card-group.common.utils.issue-line-card.issue-line-card-view.issue-type-title",
        "defaultMessage": "Issue type: {issueTypeName}"
    },
    issuePriorityTitle: {
        "id": "servicedesk-issue-line-card-group.common.utils.issue-line-card.issue-line-card-view.issue-priority-title",
        "defaultMessage": "Priority: {issuePriorityName}"
    }
});
const { DONE: $290bf46ff2727f04$var$DONE } = (0, $gULOk);
const $290bf46ff2727f04$var$priorityIconSize = 20;
class $290bf46ff2727f04$export$647087a665973f7e extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isHovering: false,
            isActive: false,
            isFocused: false,
            hasError: false,
            onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    shouldRenderKey() {
        return !!this.props.issueKey;
    }
    isActionVisible() {
        return this.props.isActive !== true && (this.props.isHovering === true || this.props.isFocused === true);
    }
    deleteButtonAction(e) {
        e.stopPropagation();
        if (this.props.issueKey) this.props.onDelete(this.props.issueKey);
    }
    renderAssigneeInteractive() {
        const { issueKey: issueKey } = this.props;
        if (issueKey === undefined) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($290bf46ff2727f04$var$PaddedFlexContainer, {
            role: "button",
            onClick: (e)=>e.preventDefault(),
            onFocus: (e)=>e.stopPropagation(),
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && e.stopPropagation(),
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2eMTS.AsyncIssueAssigneeField), {
            issueKey: (0, $g5X3G.toIssueKey)(issueKey)
        }));
    }
    renderPriority() {
        const { intl: intl, issuePriorityUrl: issuePriorityUrl, issuePriorityName: issuePriorityName } = this.props;
        if (issuePriorityUrl === null || issuePriorityUrl === undefined || !issuePriorityUrl.length) return null;
        const title = intl.formatMessage($290bf46ff2727f04$var$messages.issuePriorityTitle, {
            issuePriorityName: issuePriorityName
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: issuePriorityName || '',
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
            alt: title,
            url: issuePriorityUrl,
            width: $290bf46ff2727f04$var$priorityIconSize,
            height: $290bf46ff2727f04$var$priorityIconSize
        }));
    }
    renderError() {
        if (this.props.hasError !== true && !this.props.errorInlineMessage) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($290bf46ff2727f04$var$PaddedFlexContainer, {
            onClick: this.handleErrorDialogClick,
            onMouseDown: this.handleErrorDialogMouseDown,
            role: "button",
            tabIndex: 0,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && this.handleErrorDialogClick
        }, this.props.errorInlineMessage);
    }
    renderSummary() {
        const { isActive: isActive, issueSummary: issueSummary } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($290bf46ff2727f04$var$Summary // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue.issue-view.views.common.issue-line-card.issue-line-card-view.summary" // @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
            ,
            isActive: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: issueSummary,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($290bf46ff2727f04$export$35cd4d671a6f3dc7, null, issueSummary)));
    }
    renderKey() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($290bf46ff2727f04$var$Key // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue.issue-view.views.common.issue-line-card.issue-line-card-view.key",
            href: this.props.issueLink,
            isActive: this.props.isActive,
            isDone: this.props.statusCategory === $290bf46ff2727f04$var$DONE,
            onClick: this.handleLinkKeyClick
        }, this.props.issueKey);
    }
    renderType() {
        const { intl: intl, issueTypeIconUrl: issueTypeIconUrl, issueTypeName: issueTypeName } = this.props;
        if (issueTypeName === null || issueTypeName === undefined || !issueTypeName.length) return null;
        const title = intl.formatMessage($290bf46ff2727f04$var$messages.issueTypeTitle, {
            issueTypeName: issueTypeName
        }); // Using an intermediate div since AKTooltip needs an element to bind to
        // We aren't wrapping just ListIcon or AsyncIcon since AKTooltip is stateful
        // and we don't want it to unmount as the mouseHover changes
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: issueTypeName,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($290bf46ff2727f04$var$FlexContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
            alt: title,
            url: issueTypeIconUrl
        }))));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($290bf46ff2727f04$var$Card, null, this.renderType(), this.shouldRenderKey() && this.renderKey(), this.renderSummary(), this.renderPriority(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($290bf46ff2727f04$var$ConnectedIssueAssigneeContainer, null, this.renderAssigneeInteractive()), this.renderError());
    }
    constructor(...args){
        super(...args), this.handleErrorDialogClick = (e)=>{
            e.stopPropagation();
        }, this.handleErrorDialogMouseDown = (e)=>{
            e.preventDefault();
            e.stopPropagation();
        }, this.handleLinkKeyClick = (e)=>{
            e.preventDefault();
            if (this.props.issueLink !== undefined && this.props.issueLink !== null && this.props.issueLink.length) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(this.props.issueLink, '_blank');
        };
    }
}
// DO NOT MODIFY THIS. TODO FLY-448 - consider changing this to use @atlassian/jira-issue-line-card instead
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $290bf46ff2727f04$var$IssueLineCardWithHooks = (props)=>{
    // tipying this causes a ripple effect everywhere else
    const { issueKey: issueKey = (0, $g5X3G.toIssueKey)('') } = props;
    const [assignee] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $5fc53.ASSIGNEE_TYPE)
    });
    const shouldShowInteractiveAssignee = assignee !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($290bf46ff2727f04$export$647087a665973f7e, {
        shouldShowInteractiveAssignee: shouldShowInteractiveAssignee,
        ...props
    });
}; // eslint-disable-next-line jira/js/no-inject-intl-if-functional-component
var $290bf46ff2727f04$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
 = (0, $8RXs9.default)($290bf46ff2727f04$var$IssueLineCardWithHooks);
const $290bf46ff2727f04$var$FlexContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $290bf46ff2727f04$var$ConnectedIssueAssigneeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxvglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $290bf46ff2727f04$var$Card = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $290bf46ff2727f04$var$FlexContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $290bf46ff2727f04$var$PaddedFlexContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $290bf46ff2727f04$var$FlexContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-html-anchor -- To migrate as part of go/ui-styling-standard
const $290bf46ff2727f04$var$Key = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, isDone: isDone, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _11c8qk37 _18u0u2gc _k48p1pd9 _o5721q9c _1q5t1r31 _1dit1r31 _q1at1r31 _9nxe1r31 _1ohyglyw _ksodglyw _q4asglyw _tpgfglyw _1r9x1o36 _4hz81o36 _dlvh1o36 _12gr1o36",
            __cmplp.isActive ? "_syaz1ldt" : "_syaz1ifp",
            __cmplp.isDone ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.isActive ? "_9h8h1ldt _30l31ldt _ysv71ldt _10531ldt" : "_9h8h1ifp _30l31ifp _ysv71ifp _10531ifp",
            __cmplp.isDone ? "_1nrm18uv _9oik18uv _5bd618uv _1ydc18uv _c2wa1911 _1bnx1911 _13jx1911 _1x281911 _1iohnqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1" : "_1nrm18uv _9oik18uv _5bd618uv _1ydc18uv _c2waglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $290bf46ff2727f04$var$Summary = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _19bvu2gc _o5721q9c _1bto1l2s",
            __cmplp.isActive && "_syaz1ldt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $290bf46ff2727f04$export$35cd4d671a6f3dc7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jjlQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f7206d8a029d15$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.35.0 */ /* eslint-disable jira/react/handler-naming */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");
const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, $gwIPs.gridSize) * 2;
class $e7f7206d8a029d15$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width);
        const height = this.convertSize(this.props.height);
        if (this.state.isBroken && fallback) return fallback();
        if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            /**
       * Disabling dragging so drags happen on the parent instead of this icon.
       */ draggable: false,
            "data-vc": "common-components-async-icon"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $e7f7206d8a029d15$var$placeholderStyles,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                height: height,
                width: width
            },
            backgroundColor: "color.background.input.hovered",
            testId: "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isBroken: false
        }, this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        }, this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
const $e7f7206d8a029d15$var$placeholderStyles = (0, $8CUq3.xcss)({
    borderRadius: '3px',
    display: 'flex',
    flex: 'none'
});
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f7206d8a029d15$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gULOk", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e77315bf13f8b83b$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e77315bf13f8b83b$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e77315bf13f8b83b$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e77315bf13f8b83b$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e77315bf13f8b83b$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e77315bf13f8b83b$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e77315bf13f8b83b$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e77315bf13f8b83b$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e77315bf13f8b83b$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e77315bf13f8b83b$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e77315bf13f8b83b$export$d928f247c903643a);
const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
    $e77315bf13f8b83b$export$6db089fe7b26f5b6,
    $e77315bf13f8b83b$export$aa456a5030160740,
    $e77315bf13f8b83b$export$5a9ac66c2785cc13,
    $e77315bf13f8b83b$export$71efb3495f6084f2
];
const $e77315bf13f8b83b$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
    }
];
const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
};
const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});

parcelRegister("2eMTS", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyIssueAssigneeField", () => $40ac4b7314747a71$export$3eed76542de607d2);
$parcel$export(module.exports, "AsyncIssueAssigneeField", () => $40ac4b7314747a71$export$5cdab73b9e0803a1);
$parcel$export(module.exports, "IssueAssigneeFieldBoundary", () => $40ac4b7314747a71$export$9b541007f4ef3ffe);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $fE0Ry = parcelRequire("fE0Ry");

const $40ac4b7314747a71$export$3eed76542de607d2 = (0, $kxZPA.lazy)(()=>(parcelRequire("k5sKN")), {
    moduleId: "./src/packages/issue/fields/assignee/src/ui/popover/index.tsx"
});
const $40ac4b7314747a71$export$5cdab73b9e0803a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-field-assignee",
        packageName: "jira-issue-field-assignee",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fE0Ry.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-assignee-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fE0Ry.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40ac4b7314747a71$export$3eed76542de607d2, props)));
const $40ac4b7314747a71$export$9b541007f4ef3ffe = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "issue-assignee-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-assignee-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("fE0Ry", function(module, exports) {

$parcel$export(module.exports, "AssigneePickerView", () => $7dd7529f3295a136$export$7df43f1214c1ab94);
$parcel$export(module.exports, "AvatarWrapper", () => $7dd7529f3295a136$export$f7513421c53ce141);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $3bDjY = parcelRequire("3bDjY");

var $aWse0 = parcelRequire("aWse0");

var $50XJX = parcelRequire("50XJX");

var $6s1PB = parcelRequire("6s1PB");


var $fhSLy = parcelRequire("fhSLy");

var $evUrF = parcelRequire("evUrF");
const $7dd7529f3295a136$export$7df43f1214c1ab94 = ({ value: value, isOpen: isOpen })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const unassigned = (0, $fhSLy.getUnassignedUser)(intl);
    const user = value || unassigned;
    const assigneeName = user.accountId === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) ? user.displayName : intl.formatMessage((0, $evUrF.default).assigneeTooltip, {
        name: user.displayName
    });
    const avatarUrl = (0, $fhSLy.getUserAvatarUrl)(user);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7dd7529f3295a136$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: assigneeName
    }, user === unassigned && (0, $6s1PB.expVal)('thor_unassigned_icon_update_milestone1_experiment', 'isUnassignedIconUpdated', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50XJX.UnassignedAvatar), {
        testId: "issue-field-assignee.common.ui.read-view.popover.avatar",
        size: "small",
        isSelected: isOpen,
        name: assigneeName,
        borderColor: "transparent"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        testId: "issue-field-assignee.common.ui.read-view.popover.avatar",
        size: "small",
        src: avatarUrl,
        name: assigneeName,
        borderColor: "transparent"
    })));
};
var $7dd7529f3295a136$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $7dd7529f3295a136$export$7df43f1214c1ab94;
const $7dd7529f3295a136$export$f7513421c53ce141 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1f4h _4t3i1f4h _vchhusvi _80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("50XJX", function(module, exports) {

$parcel$export(module.exports, "UnassignedAvatar", () => $57eaa8bd14ba9db4$export$7348d55d91bdac19);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $1bKdn = parcelRequire("1bKdn");

var $koVbs = parcelRequire("koVbs");
const $57eaa8bd14ba9db4$var$selectedStyles = null;
const $57eaa8bd14ba9db4$var$unSelectedStyles = null;
const $57eaa8bd14ba9db4$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l5ckbl _1752ckbl",
    xxlarge: "_w8l58vuz _17528vuz"
};
const $57eaa8bd14ba9db4$var$baseStyles = null;
const $57eaa8bd14ba9db4$export$7348d55d91bdac19 = ({ isSelected: isSelected = false, size: size = 'medium', ...avatarProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), avatarProps, ({ ...props })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            ...props,
            className: (0, $bwpsq.default)([
                "_2rko1ssb _1h6d1r31 _1dqogq9o _189et94y _1e0c116y _1bah1h6o _4cvr1h6o _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _16qs10ak _syaz1t05",
                isSelected ? "_1h6d1yqz _syaz1qo3" : "_30l31a2l",
                $57eaa8bd14ba9db4$var$nestedSvgStylesMap[size]
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bKdn))), {
            label: formatMessage({
                id: 'unassigned',
                defaultMessage: 'unassigned'
            }),
            color: "currentColor",
            testId: props.testId && `${props.testId}--person`,
            spacing: "spacious"
        }));
    });
};

});

const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';

parcelRegister("fhSLy", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $bdabf260f25df73f$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $bdabf260f25df73f$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $bdabf260f25df73f$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $bdabf260f25df73f$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $bdabf260f25df73f$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $bdabf260f25df73f$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $bdabf260f25df73f$export$322b6ab8c29a006e);

var $5i5DK = parcelRequire("5i5DK");

var $6s1PB = parcelRequire("6s1PB");

var $7lGt2 = parcelRequire("7lGt2");

var $12ZsE = parcelRequire("12ZsE");

const $bdabf260f25df73f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>{
    const avatarUrls = (0, $6s1PB.expVal)('thor_unassigned_icon_update_milestone1_experiment', 'isUnassignedIconUpdated', false) ? {
        '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($5i5DK)))
    } : {};
    return {
        accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
        displayName: formatMessage((0, $7lGt2.default).unassignedOption),
        avatarUrls: avatarUrls
    };
};
const $bdabf260f25df73f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $7lGt2.default).automaticOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $7lGt2.default).invitePeopleOptionAdmin : (0, $7lGt2.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($12ZsE)))
        }
    });
const $bdabf260f25df73f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $bdabf260f25df73f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $bdabf260f25df73f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $bdabf260f25df73f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("5i5DK", function(module, exports) {
module.exports = new URL("unassignedAvatar.299fb7bf.svg", import.meta.url).toString();

});

parcelRegister("7lGt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2aaed3328149e1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("12ZsE", function(module, exports) {
module.exports = new URL("add.b8fea212.png", import.meta.url).toString();

});


parcelRegister("evUrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $027660e13143d610$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $027660e13143d610$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assigneeTooltip: {
        "id": "issue-field-assignee.common.read-view.popover.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    }
});

});


parcelRegister("k5sKN", function(module, exports) {

let $e9fa942d9048a977$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e9fa942d9048a977$var$load("amJuG").then(()=>parcelRequire('278RC'));

});


parcelRegister("3fAi8", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $ddbc380ab4ee430c$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $ddbc380ab4ee430c$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $ddbc380ab4ee430c$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $ddbc380ab4ee430c$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $ddbc380ab4ee430c$export$612d9bcb0c9d8976);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
        });
    };
const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $ddbc380ab4ee430c$var$actions = {
    setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
    getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
    setIssue: $ddbc380ab4ee430c$var$setIssue,
    mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
    setIssues: $ddbc380ab4ee430c$var$setIssues,
    mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
};
// this is a global store
const $ddbc380ab4ee430c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $ddbc380ab4ee430c$var$actions
});
const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getAllFields
});
const $ddbc380ab4ee430c$export$ac289b84121829df = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, $51nlc.createSubscriber)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: null
});
const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});



parcelRegister("9k7Bb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cde2f4909b224aa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7cde2f4909b224aa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorStateHeader: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues.error-state-header",
        "defaultMessage": "We couldn't fetch the linked issues for this object"
    },
    errorStateHeaderIssueTermRefresh: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues.error-state-header-issue-term-refresh",
        "defaultMessage": "We couldn't fetch the linked work items for this object"
    },
    errorStateDescription: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues.error-state-description",
        "defaultMessage": "Try reloading the page."
    },
    noLinkedIssues: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues.no-linked-issues",
        "defaultMessage": "No linked issues"
    },
    noLinkedIssuesIssueTermRefresh: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues.no-linked-issues-issue-term-refresh",
        "defaultMessage": "No linked work items"
    }
});

});


parcelRegister("gyiEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $85dcc294c0ab271a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $85dcc294c0ab271a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    objectDetails: {
        "id": "servicedesk-insight-object-graph.object-view.object-details",
        "defaultMessage": "Object details"
    },
    linkedIssues: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues",
        "defaultMessage": "Linked issues"
    },
    linkedIssuesIssueTermRefresh: {
        "id": "servicedesk-insight-object-graph.object-view.linked-issues-issue-term-refresh",
        "defaultMessage": "Linked work items"
    },
    linkedPages: {
        "id": "servicedesk-insight-object-graph.object-view.linked-pages",
        "defaultMessage": "Linked pages"
    },
    openObjectDetailsPage: {
        "id": "servicedesk-insight-object-graph.object-view.open-object-details-page",
        "defaultMessage": "Open in object details page"
    },
    refreshButton: {
        "id": "servicedesk-insight-object-graph.object-view.refresh-button",
        "defaultMessage": "Refresh"
    },
    errorTitle: {
        "id": "servicedesk-insight-object-graph.object-view.error-title",
        "defaultMessage": "We couldn't display this object."
    },
    errorDescription: {
        "id": "servicedesk-insight-object-graph.object-view.error-description",
        "defaultMessage": "Refresh the page and try again."
    }
});

});

parcelRegister("joPHk", function(module, exports) {

$parcel$export(module.exports, "getPositionFromObjectAttribute", () => $720ac966daf4a49c$export$181ea8d28ce9cd35);
const $720ac966daf4a49c$export$181ea8d28ce9cd35 = (attribute)=>attribute.objectTypeAttribute?.position ?? Infinity;

});


parcelRegister("bvAlP", function(module, exports) {

$parcel$export(module.exports, "getNormalizedGraphData", () => $74735fd5fd8617c7$export$34e9eaff58eacd53);
$parcel$export(module.exports, "getFilteredEdgesAndNodes", () => $74735fd5fd8617c7$export$24f0dc2bbb91dd1a);
$parcel$export(module.exports, "getConnectedNodesFromParent", () => $74735fd5fd8617c7$export$3c9910179eb68b3b);


var $aSVvk = parcelRequire("aSVvk");
const $74735fd5fd8617c7$var$normalizeNode = (n)=>({
        id: `${n.type}${n.id}`,
        value: n.id,
        /**
	 * TODO We should consider that 'Object Type' and 'Object' nodes are
	 * visually identical but behave differently when clicked. The server
	 * version of the graph gets around this by appending (Type) to 'Object
	 * Type' node names. However that approach would require injecting intl
	 * functions into this transformer function which isn't ideal in this case.
	 */ name: n.name,
        draggable: true,
        symbol: `image://${n.icon}`,
        symbolSize: (0, $50d8b5ecd71e7169$export$7093ae9f18906e17),
        context: {
            type: n.type,
            name: n.name,
            id: n.id,
            icon: n.icon,
            objectSchemaId: n.objectSchemaId
        }
    });
const $74735fd5fd8617c7$var$normalizeEdge = (e)=>({
        name: e.label,
        source: e.from,
        target: e.to,
        lineStyle: {
            color: e.color,
            ...(0, $aSVvk.DEFAULT_LINE_STYLE)
        },
        symbolSize: 8
    });
const $74735fd5fd8617c7$export$34e9eaff58eacd53 = (insightGraphData)=>{
    const { nodes: nodes = [], edges: edges = [] } = insightGraphData ?? {};
    const normalizedEdges = edges.map($74735fd5fd8617c7$var$normalizeEdge);
    const normalizedNodes = nodes.map($74735fd5fd8617c7$var$normalizeNode);
    return {
        nodes: normalizedNodes,
        edges: normalizedEdges
    };
};
const $74735fd5fd8617c7$export$24f0dc2bbb91dd1a = (objectGraphData, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
referenceTypes, selectedObjectId)=>{
    const { nodes: nodes = [], edges: edges = [] } = objectGraphData ?? {};
    const enabledReferenceTypes = referenceTypes.filter((r)=>r.checked === true);
    const updatedEdges = edges.filter((edge)=>enabledReferenceTypes.some((r)=>r.to.includes(edge.to)) && enabledReferenceTypes.some((r)=>r.from.includes(edge.from)));
    const updatedNodes = nodes.filter((node)=>// always include the currently selected node (even with no outgoing edges)
        node.id === selectedObjectId || updatedEdges.find((e)=>e.to.slice(1) === node.id) || updatedEdges.find((e)=>e.from.slice(1) === node.id));
    return {
        nodes: updatedNodes,
        edges: updatedEdges
    };
};
const $74735fd5fd8617c7$export$3c9910179eb68b3b = (objectGraphData, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
parentObjectId)=>{
    const { nodes: nodes = [], edges: edges = [] } = objectGraphData ?? {};
    const parentObject = nodes.find((n)=>n.id === parentObjectId);
    const updatedNodes = parentObject ? [
        parentObject
    ] : [];
    const updatedEdges = [];
    // TODO: can potentially refactor the way this logic works to be more efficient
    // every time we add a new connection, we want to re-iterate to ensure we add additional valid connections to those new nodes we added in the previous iteration
    let shouldTraverseEdges = true;
    while(shouldTraverseEdges){
        shouldTraverseEdges = false;
        for (const edge of edges){
            const isAlreadyAdded = updatedEdges.some((existingEdge)=>existingEdge === edge);
            const hasValidConnection = updatedNodes.filter(Boolean).some((n)=>n.id === edge.to.slice(1) || n.id === edge.from.slice(1));
            if (!isAlreadyAdded && hasValidConnection) {
                shouldTraverseEdges = true;
                updatedEdges.push(edge);
                // whenever we add a valid edge we go through the existing nodes and add those that are connected via the edge to the result
                nodes.forEach((node)=>{
                    if (!updatedNodes.includes(node) && (node.id === edge.to.slice(1) || node.id === edge.from.slice(1))) updatedNodes.push(node);
                });
            }
        }
    }
    return {
        nodes: updatedNodes,
        edges: updatedEdges
    };
};

});
parcelRegister("aSVvk", function(module, exports) {

$parcel$export(module.exports, "getDefaultSeriesConfig", () => $86b003861c5932f3$export$ed50ab7344ba4db3);
$parcel$export(module.exports, "DEFAULT_GRAPH_OPTIONS", () => $86b003861c5932f3$export$8e4937d7b59cfae5);
$parcel$export(module.exports, "SELECTED_NODE_OPTIONS", () => $86b003861c5932f3$export$156ec5ad21e61a8d);
$parcel$export(module.exports, "getDefaultNodeOptions", () => $86b003861c5932f3$export$326c176f3724490d);
$parcel$export(module.exports, "DEFAULT_LINE_STYLE", () => $86b003861c5932f3$export$e70fad7f87c3cb26);
$parcel$export(module.exports, "FIXED_NODE", () => $86b003861c5932f3$export$4453bb392d3bb402);
$parcel$export(module.exports, "UNFIXED_NODE", () => $86b003861c5932f3$export$3f07a18bcac46f86);
$parcel$export(module.exports, "DEFAULT_STYLES", () => $86b003861c5932f3$export$e0faacd43528e300);


var $kTHGn = parcelRequire("kTHGn");

const $86b003861c5932f3$var$defaultNodeLabelOverflow = {
    overflow: 'breakAll',
    width: 150
};
const $86b003861c5932f3$var$DARK_MODE_TEXT_COLOR = '#9fadbc';
const $86b003861c5932f3$var$DEFAULT_NODE_LABEL_LIGHT_MODE = {
    fontFamily: (0, $kTHGn.default)('font.family.body', "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"),
    show: true,
    position: 'bottom',
    // Can't convert this to tokens/css-vars as it ends up in a 'canvas' context
    color: (0, $829f609a65d26a98$exports).N700,
    fontSize: 10.5,
    ...$86b003861c5932f3$var$defaultNodeLabelOverflow
};
const $86b003861c5932f3$var$DEFAULT_NODE_LABEL_DARK_MODE = {
    ...$86b003861c5932f3$var$DEFAULT_NODE_LABEL_LIGHT_MODE,
    color: $86b003861c5932f3$var$DARK_MODE_TEXT_COLOR
};
const $86b003861c5932f3$export$719f6bf66d1dcb28 = (enableAnimation)=>({
        initLayout: 'circular',
        repulsion: (0, $50d8b5ecd71e7169$export$cf8a94c984678862),
        edgeLength: (0, $50d8b5ecd71e7169$export$434d30b064b8d4cf),
        friction: 1,
        layoutAnimation: enableAnimation
    });
const $86b003861c5932f3$export$ed50ab7344ba4db3 = (enableAnimation, isDarkMode)=>({
        type: 'graph',
        layout: 'force',
        roam: 'move',
        label: isDarkMode ? $86b003861c5932f3$var$DEFAULT_NODE_LABEL_DARK_MODE : $86b003861c5932f3$var$DEFAULT_NODE_LABEL_LIGHT_MODE,
        edgeSymbol: [
            'none',
            'arrow'
        ],
        symbolSize: (0, $50d8b5ecd71e7169$export$7093ae9f18906e17),
        force: $86b003861c5932f3$export$719f6bf66d1dcb28(enableAnimation),
        emphasis: {
            scale: false
        },
        animation: enableAnimation
    });
const $86b003861c5932f3$var$escapeHtml = (unsafe)=>unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
const $86b003861c5932f3$export$8e4937d7b59cfae5 = {
    tooltip: {
        padding: 4,
        // Can't convert this to tokens/css-vars as it ends up in a 'canvas' context
        backgroundColor: (0, $829f609a65d26a98$exports).N800,
        borderColor: '#333333',
        textStyle: {
            // Can't convert this to tokens/css-vars as it ends up in a 'canvas' context
            color: (0, $829f609a65d26a98$exports).N0,
            fontFamily: (0, $kTHGn.default)('font.family.body', "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"),
            // Can't convert this to tokens/css-vars as it ends up in a 'canvas' context
            fontSize: 11
        },
        formatter: ({ data: data })=>{
            // @ts-expect-error - TS2339 - Property 'label' does not exist on type 'EchartsGraphNode'.
            const { name: name = '', label: label = '' } = data ?? {};
            return $86b003861c5932f3$var$escapeHtml(name ?? label);
        }
    }
};
const $86b003861c5932f3$export$156ec5ad21e61a8d = {
    label: {
        fontFamily: (0, $kTHGn.default)('font.family.body', "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"),
        fontWeight: (0, $kTHGn.default)('font.weight.bold', '700'),
        fontSize: 13,
        // don't truncate label when node is selected
        formatter: ({ name: name })=>name
    }
};
const $86b003861c5932f3$export$326c176f3724490d = (isDarkMode)=>({
        label: isDarkMode ? $86b003861c5932f3$var$DEFAULT_NODE_LABEL_DARK_MODE : $86b003861c5932f3$var$DEFAULT_NODE_LABEL_LIGHT_MODE
    });
const $86b003861c5932f3$export$e70fad7f87c3cb26 = {
    width: 0.8,
    opacity: 1,
    type: 'solid',
    curveness: 0.1
};
const $86b003861c5932f3$export$4453bb392d3bb402 = {
    fixed: true
};
const $86b003861c5932f3$export$3f07a18bcac46f86 = {
    fixed: false
};
const $86b003861c5932f3$export$e0faacd43528e300 = {
    height: '100%',
    width: '100%'
};

});



parcelRegister("absV2", function(module, exports) {

$parcel$export(module.exports, "InsightObjectViewLayout", () => $0cf3c291d7a4c90b$export$d8b7d9392c0c1fd9);

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $gJlZe = parcelRequire("gJlZe");

var $gwIPs = parcelRequire("gwIPs");
const $0cf3c291d7a4c90b$export$d8b7d9392c0c1fd9 = (props)=>{
    const { renderHeader: renderHeader, renderPrimary: renderPrimary, renderSecondary: renderSecondary } = props;
    const [width, setWidth] = (0, $5uXOq.useState)($0cf3c291d7a4c90b$var$MIN_COLUMN_WIDTH_FOR_MULTI_COLUMN_PRIMARY);
    const throttledSetWidth = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, 250), []);
    const primaryAndSecondaryAreMultiColumn = width >= $0cf3c291d7a4c90b$var$MIN_MULTI_COLUMN_WIDTH;
    const isPrimaryContentMultiColumn = width >= $0cf3c291d7a4c90b$var$MIN_COLUMN_WIDTH_FOR_MULTI_COLUMN_PRIMARY || width < $0cf3c291d7a4c90b$var$MIN_MULTI_COLUMN_WIDTH;
    const isSecondaryContentCompact = width <= $0cf3c291d7a4c90b$var$MIN_COLUMN_WIDTH_FOR_COMPACT_SECONDARY && primaryAndSecondaryAreMultiColumn;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cf3c291d7a4c90b$var$Wrapper, null, renderHeader(primaryAndSecondaryAreMultiColumn), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cf3c291d7a4c90b$var$GridWrapper, {
        isMultiColumn: primaryAndSecondaryAreMultiColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cf3c291d7a4c90b$var$PrimaryContent, {
        isMultiColumn: primaryAndSecondaryAreMultiColumn
    }, renderPrimary(isPrimaryContentMultiColumn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0cf3c291d7a4c90b$var$SecondaryContent, {
        isMultiColumn: primaryAndSecondaryAreMultiColumn
    }, renderSecondary(isSecondaryContentCompact))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJlZe.WidthObserver), {
        setWidth: throttledSetWidth,
        offscreen: true
    }));
};
// The minimum width required before displaying content in columns
const $0cf3c291d7a4c90b$var$MIN_MULTI_COLUMN_WIDTH = 584;
// The minimum width required before displaying the primary content in columns
const $0cf3c291d7a4c90b$var$MIN_COLUMN_WIDTH_FOR_MULTI_COLUMN_PRIMARY = 664;
// The minimum column width before displaying the secondary content in compact mode
const $0cf3c291d7a4c90b$var$MIN_COLUMN_WIDTH_FOR_COMPACT_SECONDARY = 824;
const $0cf3c291d7a4c90b$export$857c8a9506276cf0 = (0, $gwIPs.gridSize) * 5;
// Multipliers used to determine minimum column widths
const $0cf3c291d7a4c90b$var$PRIMARY_CONTENT_PROPORTION = 7;
const $0cf3c291d7a4c90b$var$SECONDARY_CONTENT_PROPORTION = 5;
// Calculated widths based on proportions above
const $0cf3c291d7a4c90b$var$COLUMN_COUNT = $0cf3c291d7a4c90b$var$PRIMARY_CONTENT_PROPORTION + $0cf3c291d7a4c90b$var$SECONDARY_CONTENT_PROPORTION;
const $0cf3c291d7a4c90b$export$8f3531880df5efaa = `${$0cf3c291d7a4c90b$var$PRIMARY_CONTENT_PROPORTION / $0cf3c291d7a4c90b$var$COLUMN_COUNT * 100}%`;
const $0cf3c291d7a4c90b$export$3b3d369a338e13a8 = `${$0cf3c291d7a4c90b$var$SECONDARY_CONTENT_PROPORTION / $0cf3c291d7a4c90b$var$COLUMN_COUNT * 100}%`;
const $0cf3c291d7a4c90b$var$GridWrapper = ({ isMultiColumn: isMultiColumn, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: isMultiColumn ? 'row' : 'column',
        gap: "space.500",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $8CUq3.xcss)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: isMultiColumn ? '100%' : undefined
        })
    }, children);
const $0cf3c291d7a4c90b$var$Wrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $8CUq3.xcss)({
            position: 'relative',
            overflowX: 'auto',
            marginBottom: 'space.600',
            minWidth: '355px'
        })
    }, children);
const $0cf3c291d7a4c90b$var$PrimaryContent = ({ isMultiColumn: isMultiColumn, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $8CUq3.xcss)({
                width: '100%'
            }),
            isMultiColumn && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $8CUq3.xcss)({
                // need to account for the COLUMN_GUTTER in max width to avoid pushing
                // the secondary content out of the container
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                maxWidth: `calc(${$0cf3c291d7a4c90b$export$8f3531880df5efaa} - ${$0cf3c291d7a4c90b$export$857c8a9506276cf0}px)`
            })
        ]
    }, children);
const $0cf3c291d7a4c90b$var$SecondaryContent = ({ isMultiColumn: isMultiColumn, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: isMultiColumn ? {
            /* Offset the secondary column by the height of atlaskit tabs */ paddingTop: '33px'
        } : {},
        xcss: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $8CUq3.xcss)({
                width: '100%'
            }),
            isMultiColumn && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $8CUq3.xcss)({
                maxWidth: $0cf3c291d7a4c90b$export$3b3d369a338e13a8
            })
        ]
    }, children);

});

parcelRegister("lEF8G", function(module, exports) {

$parcel$export(module.exports, "AvatarPanel", () => $2b22937f2fa676cd$export$1237341e0773842f);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $66Vf6 = parcelRequire("66Vf6");

var $9kTJJ = parcelRequire("9kTJJ");

var $cPB2u = parcelRequire("cPB2u");

var $dhyTw = parcelRequire("dhyTw");

var $3BWwx = parcelRequire("3BWwx");
const $2b22937f2fa676cd$export$1237341e0773842f = ()=>{
    const [{ objectDetails: objectDetails }] = (0, $66Vf6.useObjectStoreState)();
    const [imageLoading, setImageLoading] = (0, $5uXOq.useState)(false);
    const avatarUrl288 = objectDetails?.avatar.url288;
    const avatarUUID = objectDetails?.avatar.avatarUUID;
    // adding avatarUUID as query params to disable browser caching for when avatar gets updated
    const avatarUrl = `${avatarUrl288}${avatarUUID ? `?avatarUUID=${avatarUUID}` : ''}`;
    (0, $5uXOq.useEffect)(()=>{
        if (avatarUrl) {
            setImageLoading(true);
            (0, $dhyTw.preloadImg)(avatarUrl).then(()=>{
                setImageLoading(false);
            });
        }
    }, [
        avatarUrl
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!objectDetails?.hasAvatar) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kTJJ.CollapsibleGroup), {
        title: formatMessage((0, $3BWwx.default).panelTitle),
        testId: "servicedesk-insight-object-view.ui.avatar-panel",
        headingLevel: "h2"
    }, imageLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPB2u.InsightObjectViewPanelSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2b22937f2fa676cd$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2b22937f2fa676cd$var$Image, {
        src: avatarUrl,
        alt: formatMessage((0, $3BWwx.default).avatarImageAlt)
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b22937f2fa676cd$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b22937f2fa676cd$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _i0dl1ns9",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9kTJJ", function(module, exports) {

$parcel$export(module.exports, "CollapsibleGroup", () => $3cca5ded2632dfb4$export$36287b0242004a4d);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $k4n86 = parcelRequire("k4n86");

var $cLqLT = parcelRequire("cLqLT");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");
const $3cca5ded2632dfb4$export$36287b0242004a4d = (props)=>{
    const { children: children, title: title, headerItem: headerItem, isDefaultCollapsed: isDefaultCollapsed, showHeaderItemWhenOpen: showHeaderItemWhenOpen, testId: testId, titleCanWrap: titleCanWrap = false, headingLevel: headingLevel = 'h3' } = props;
    const bodyTestId = testId != null && `${testId}.body`;
    const headerTestId = testId != null && `${testId}.header`;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(!isDefaultCollapsed);
    const shouldRenderHeaderItem = headerItem != null && (showHeaderItemWhenOpen || !isOpen);
    const toggleIsOpen = ()=>setIsOpen((open)=>!open);
    if ((0, $4R6GH.fg)('jsm_cmdb_import_options_return_focus_on_cancel')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": props.testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: headingLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3cca5ded2632dfb4$var$Header, {
        "data-testid": headerTestId,
        isOpen: isOpen,
        onClick: toggleIsOpen,
        onKeyDown: (event)=>{
            if (event.key === 'Enter') toggleIsOpen();
        },
        "aria-expanded": isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: titleCanWrap ? $3cca5ded2632dfb4$var$headingTitleWrapStyle : $3cca5ded2632dfb4$var$headingTitleNoWrapStyle
    }, title), shouldRenderHeaderItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $3cca5ded2632dfb4$var$headerItemStyles,
        testId: "servicedesk-insight-shared-ui.ui.collapsible-group.header-item"
    }, headerItem), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cLqLT))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k4n86))), {
        label: ""
    }))), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3cca5ded2632dfb4$var$bodyStyles,
        testId: bodyTestId || 'servicedesk-insight-shared-ui.ui.collapsible-group.body'
    }, children) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": props.testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3cca5ded2632dfb4$var$Header, {
        "data-testid": headerTestId,
        isOpen: isOpen,
        onClick: toggleIsOpen,
        onKeyDown: (event)=>{
            if (event.key === 'Enter') toggleIsOpen();
        },
        "aria-expanded": isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3cca5ded2632dfb4$var$Title, {
        canWrap: titleCanWrap || false
    }, title), shouldRenderHeaderItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3cca5ded2632dfb4$var$HeaderItem, {
        "data-testid": "servicedesk-insight-shared-ui.ui.collapsible-group.header-item"
    }, headerItem), isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cLqLT))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k4n86))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3cca5ded2632dfb4$var$Body, {
        "data-testid": bodyTestId,
        isOpen: isOpen
    }, children));
};
$3cca5ded2632dfb4$export$36287b0242004a4d.defaultProps = {
    isDefaultCollapsed: false,
    showHeaderItemWhenOpen: false
};
const $3cca5ded2632dfb4$var$textOverflow = /*#__PURE__*/ (0, $47bDC.css)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cca5ded2632dfb4$var$Body = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "rxmqi4-0"
})({
    padding: "var(--ds-space-200, 16px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isOpen: isOpen })=>isOpen ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $47bDC.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        border: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`,
        borderTop: 0
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $47bDC.css)({
        display: 'none'
    }));
const $3cca5ded2632dfb4$var$bodyStyles = (0, $8CUq3.xcss)({
    padding: 'space.200',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderTop: 'none'
});
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cca5ded2632dfb4$var$Title = /*#__PURE__*/ (0, $47bDC.default).strong.withConfig({
    componentId: "rxmqi4-1"
})`${(props)=>props.canWrap ? '' : $3cca5ded2632dfb4$var$textOverflow // eslint-disable-line @typescript-eslint/no-explicit-any
};color:${`var(--ds-text, ${(0, $829f609a65d26a98$exports).N800})`};padding-right:${"var(--ds-space-050, 4px)"};font-size:16px;max-width:60%;font-weight:${"var(--ds-font-weight-semibold, 600)"};flex-shrink:0;`;
// FIXME: type error passing result of `css` to `styled`
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cca5ded2632dfb4$var$HeaderItem = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "rxmqi4-2"
})`${$3cca5ded2632dfb4$var$textOverflow};margin-left:auto;color:${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N90})`};padding:${"var(--ds-space-050, 4px)"};margin-right:${"var(--ds-space-100, 8px)"};`;
const $3cca5ded2632dfb4$var$headerItemStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: 'color.text.subtlest',
    padding: 'space.050',
    marginRight: 'space.100',
    font: 'font.body',
    marginLeft: 'auto'
});
// Using a div[role=button] instead of an actual button element so that we don't
// end up with nested buttons when injecting a button as a headerItem prop
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3cca5ded2632dfb4$var$Header = /*#__PURE__*/ (0, $47bDC.default).div.attrs({
    role: 'button',
    tabIndex: 0
}).withConfig({
    componentId: "rxmqi4-3"
})`display:flex;align-items:center;justify-content:space-between;height:${(0, $gwIPs.gridSize) * 7}px;padding:0 ${(0, $gwIPs.gridSize) * 2}px;border-radius:${(0, $gwIPs.borderRadius)}px;border:1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`};&:hover{background:${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$exports).N20})`};cursor:pointer;}&:focus{outline:none;box-shadow:none;border-color:${`var(--ds-border-selected, ${(0, $829f609a65d26a98$exports).B300})`};background:${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$exports).N20})`};}&:active{background-color:${`var(--ds-background-selected, ${(0, $829f609a65d26a98$exports).B50})`};border-color:${`var(--ds-border-selected, ${(0, $829f609a65d26a98$exports).B300})`};}${({ isOpen: isOpen })=>isOpen ? (0, $47bDC.css)({
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
    }) : ''}`;
const $3cca5ded2632dfb4$var$headingTitleWrapStyle = (0, $8CUq3.xcss)({
    color: 'color.text',
    font: 'font.heading.small',
    paddingRight: 'space.050',
    width: '100%',
    maxWidth: '60%',
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    flexShrink: '0'
});
const $3cca5ded2632dfb4$var$headingTitleNoWrapStyle = (0, $8CUq3.xcss)({
    color: 'color.text',
    paddingRight: 'space.050',
    font: 'font.heading.small',
    width: '100%',
    maxWidth: '60%',
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    flexShrink: '0',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});

});

parcelRegister("dhyTw", function(module, exports) {

$parcel$export(module.exports, "preloadImg", () => $c17a8438f656864f$export$438d6a5f3d4a4660);
const $c17a8438f656864f$export$438d6a5f3d4a4660 = (src)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    new Promise((resolve, reject)=>{
        const img = new Image();
        // @ts-expect-error - TS2322 - Type '(result: Promise<never>) => void' is not assignable to type '(this: GlobalEventHandlers, ev: Event) => any'.
        img.onload = resolve;
        img.onerror = reject;
        img.src = src;
    });

});

parcelRegister("3BWwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $94d5837eebc5c1f0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $94d5837eebc5c1f0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    panelTitle: {
        "id": "servicedesk-insight-object-view.avatar-panel.panel-title",
        "defaultMessage": "Avatar"
    },
    avatarImageAlt: {
        "id": "servicedesk-insight-object-view.avatar-panel.avatar-image-alt",
        "defaultMessage": "Avatar"
    }
});

});


parcelRegister("3WieA", function(module, exports) {

$parcel$export(module.exports, "ObjectViewHeader", () => $8496fe993f40a15f$export$228788278548aa21);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $6B7KL = parcelRequire("6B7KL");

var $3g1Fk = parcelRequire("3g1Fk");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8xIjP = parcelRequire("8xIjP");

var $5EBaG = parcelRequire("5EBaG");

var $7B3Ta = parcelRequire("7B3Ta");

var $a8YnH = parcelRequire("a8YnH");

var $66Vf6 = parcelRequire("66Vf6");

var $2Fp7A = parcelRequire("2Fp7A");

var $5Ny9E = parcelRequire("5Ny9E");

var $2wDb6 = parcelRequire("2wDb6");

var $eEA1w = parcelRequire("eEA1w");

var $blEB6 = parcelRequire("blEB6");

var $cPB2u = parcelRequire("cPB2u");

var $4R6GH = parcelRequire("4R6GH");

var $h5d36 = parcelRequire("h5d36");

var $9v7hU = parcelRequire("9v7hU");

var $iUsZj = parcelRequire("iUsZj");

var $90c3i = parcelRequire("90c3i");
const $8496fe993f40a15f$export$228788278548aa21 = (props)=>{
    const { canEdit: canEdit, canDelete: canDelete, backButton: backButton, isMultiColumn: isMultiColumn, onDelete: onDelete, onClone: onClone, redirectOnDelete: redirectOnDelete, showFullBreadcrumbTrail: showFullBreadcrumbTrail = true } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ loading: loading, objectDetails: objectDetails, hideEmptyAttributes: hideEmptyAttributes }, { setHideEmptyAttributesState: setHideEmptyAttributesState }] = (0, $66Vf6.useObjectStoreState)();
    const [objectSchemaId] = (0, $66Vf6.useObjectSchemaId)();
    const [isDeleteModalOpen, setDeleteModalOpen] = (0, $5uXOq.useState)(false);
    const [isCloneModalOpen, setCloneModalOpen] = (0, $5uXOq.useState)(false);
    const [isQrCodeModalOpen, setQrCodeModalOpen] = (0, $5uXOq.useState)(false);
    const returnFocusRef = (0, $5uXOq.useRef)(null);
    const showFullTrail = backButton === undefined ? showFullBreadcrumbTrail : !backButton;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { openFeedbackDialog: openFeedbackDialog } = (0, $8xIjP.useInsightFeedbackCollector)((0, $8xIjP.OBJECT_VIEW_LOCATION));
    if (loading || !objectDetails || !objectSchemaId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPB2u.InsightObjectViewHeaderSkeleton), null);
    const renderHideEmptyAttributesMeatballs = ()=>{
        if (hideEmptyAttributes === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: ()=>{
                setHideEmptyAttributesState(false);
            }
        }, formatMessage((0, $iUsZj.default).showEmptyAttributes));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            onClick: ()=>{
                setHideEmptyAttributesState(true);
            }
        }, formatMessage((0, $iUsZj.default).hideEmptyAttributes));
    };
    const MenuContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderHideEmptyAttributesMeatballs(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testId": "servicedesk-insight-object-view.ui.header.meatballs-menu-clone",
        "data-test-id": "servicedesk-insight-object-view.ui.header.meatballs-menu-clone",
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'openInsightObjectCloneModal');
            setCloneModalOpen(true);
        }
    }, formatMessage((0, $iUsZj.default).clone)), canDelete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testId": "servicedesk-insight-object-view.ui.header.meatballs-menu-delete",
        "data-test-id": "servicedesk-insight-object-view.ui.header.meatballs-menu-delete",
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'openInsightObjectDeleteModal');
            setDeleteModalOpen(true);
        }
    }, formatMessage((0, $iUsZj.default).delete)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulppxbi _1e0c1txw _4cvr1h6o _19bvu2gc _1tkexy5q"
        ])
    }, backButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2wDb6.BackLink), {
        to: backButton.to,
        onClick: backButton.onClick
    }, backButton.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5d36.Breadcrumbs), {
        showFullTrail: showFullTrail
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_zulppxbi _1e0c1txw _4cvr1h6o _19pkpxbi _2hwxidpf _otyrpxbi _18u0idpf _ca0qu2gc _19bvu2gc _1n261g80",
            isMultiColumn && "_zulp1jfw _1n261q9c _ca0qidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8496fe993f40a15f$var$ObjectNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _2hwxu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9v7hU.IconEditDialog), {
        canEdit: canEdit,
        avatar: objectDetails.avatar
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _d8r5idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $90c3i.ObjectNameInlineEdit), {
        canEdit: canEdit
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
        className: (0, $bwpsq.default)([
            "_zulppxbi _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1bahesu3 _vchhusvi _1o9zidpf _19bvidpf _2mzuglyw _1pyaidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        "aria-label": "header-feedback",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3g1Fk))), {
            label: formatMessage((0, $iUsZj.default).giveFeedbackLabel)
        }),
        onClick: ()=>openFeedbackDialog(),
        testId: "servicedesk-insight-object-view.ui.header.feedback-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        "aria-label": "qrcode-button",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5EBaG.QrCodeIcon), {
            label: formatMessage((0, $iUsZj.default).printQrCodeLabel)
        }),
        onClick: ()=>setQrCodeModalOpen(true),
        testId: "servicedesk-insight-object-view.ui.header.qrcode-button"
    })), canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, (0, $4R6GH.fg)('assets-a11y-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eEA1w.MeatballsMenu), {
        moreIconLabel: formatMessage((0, $iUsZj.default).moreActions),
        testId: "servicedesk-insight-object-view.ui.header.meatballs-menu",
        ref: returnFocusRef
    }, MenuContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eEA1w.MeatballsMenu), {
        moreIconLabel: formatMessage((0, $iUsZj.default).moreActions),
        testId: "servicedesk-insight-object-view.ui.header.meatballs-menu"
    }, MenuContent)) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a8YnH.AsyncDeleteObjectModal), {
        returnFocusRef: returnFocusRef,
        objectId: objectDetails.id,
        objectLabel: objectDetails.label,
        onSuccessRedirectUrl: redirectOnDelete ? (0, $blEB6.createObjectSchemaUrl)((0, $5Ny9E.toSchemaId)(objectSchemaId)) : undefined,
        onSuccess: onDelete,
        onClose: ()=>setDeleteModalOpen(false),
        isDeleteModalOpen: isDeleteModalOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7B3Ta.AsyncCloneObjectModal), {
        returnFocusRef: returnFocusRef,
        objectId: objectDetails.id,
        objectDetails: objectDetails,
        objectSchemaId: (0, $5Ny9E.toSchemaId)(objectSchemaId),
        objectTypeId: (0, $5Ny9E.toCmdbObjectTypeId)(objectDetails.objectType.id),
        onSuccess: onClone,
        onClose: ()=>setCloneModalOpen(false),
        isCloneModalOpen: isCloneModalOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Fp7A.AsyncSingleQrCodeModal), {
        objectId: objectDetails.id,
        objectSchemaId: (0, $5Ny9E.toSchemaId)(objectSchemaId),
        objectTypeId: (0, $5Ny9E.toCmdbObjectTypeId)(objectDetails.objectType.id),
        onClose: ()=>setQrCodeModalOpen(false),
        isQrCodeModalOpen: isQrCodeModalOpen
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8496fe993f40a15f$var$ObjectNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vchhusvi _1e0c1txw _1bsb1osq _1nmz9jpi",
            __cmplp.className
        ])
    });
});
const $8496fe993f40a15f$var$actionContainerBaseStyle = null;
const $8496fe993f40a15f$var$headerContainerBaseStyle = null;
const $8496fe993f40a15f$var$headerContainerMultiColumnStyle = null;
const $8496fe993f40a15f$var$inlineEditContainerStyle = null;
const $8496fe993f40a15f$var$iconContainerStyle = null;
const $8496fe993f40a15f$var$preHeaderContainerStyle = null;

});
parcelRegister("3g1Fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $25f4287f17f73dc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $25f4287f17f73dc4$var$_feedback.default
    }));
$25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cdeb4e8fedeb21cdc8d38f736eb852b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});


parcelRegister("8xIjP", function(module, exports) {

$parcel$export(module.exports, "OBJECT_VIEW_LOCATION", () => $807c2e7b0ca8c5fd$export$5228616e8f4b09d1);
$parcel$export(module.exports, "GETTING_STARTED_LOCATION", () => $807c2e7b0ca8c5fd$export$70a59307d63b6dc7);
$parcel$export(module.exports, "useInsightFeedbackCollector", () => $807c2e7b0ca8c5fd$export$a570eefef84905c5);

var $5uXOq = parcelRequire("5uXOq");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");
const $807c2e7b0ca8c5fd$export$14b33d63628336c2 = 'jsm-insight-new-object-view';
const $807c2e7b0ca8c5fd$export$5228616e8f4b09d1 = 'new-insight-object-view';
const $807c2e7b0ca8c5fd$export$528df1129445c08 = 'new-schema-page-view';
const $807c2e7b0ca8c5fd$export$70a59307d63b6dc7 = 'cmdb-getting-started';
const $807c2e7b0ca8c5fd$export$a570eefef84905c5 = (location)=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const openFeedbackDialog = (0, $5uXOq.useCallback)((options)=>{
        openFeedbackCollector({
            feedbackGroupId: $807c2e7b0ca8c5fd$export$14b33d63628336c2,
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB),
            ...options,
            feedbackContext: [
                {
                    id: (0, $7iULw.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
                    value: location
                },
                ...options?.feedbackContext ?? []
            ]
        });
    }, [
        location,
        openFeedbackCollector
    ]);
    return {
        openFeedbackDialog: openFeedbackDialog
    };
};

});

parcelRegister("7B3Ta", function(module, exports) {

$parcel$export(module.exports, "AsyncCloneObjectModal", () => $a84a52a294ce02da$export$66890d09070128d9);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a84a52a294ce02da$var$LazyCloneObjectModal = (0, $kxZPA.lazy)(()=>(parcelRequire("jleGO")), {
    moduleId: "./src/packages/servicedesk/insight-object/object-clone-modal/src/ui/index.tsx"
});
const $a84a52a294ce02da$export$66890d09070128d9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "insight-clone-object-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a84a52a294ce02da$var$LazyCloneObjectModal, props));

});
parcelRegister("jleGO", function(module, exports) {

let $e14b5f80e60d228a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e14b5f80e60d228a$var$load("1kk2N").then(()=>parcelRequire('44m1y'));

});


parcelRegister("a8YnH", function(module, exports) {

$parcel$export(module.exports, "AsyncDeleteObjectModal", () => $9799cf0f8f103b82$export$bf07b66f9e99709b);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9799cf0f8f103b82$var$LazyDeleteObjectModal = (0, $kxZPA.lazy)(()=>(parcelRequire("3IatW")), {
    moduleId: "./src/packages/servicedesk/insight-object/object-delete-modal/src/ui/index.tsx"
});
const $9799cf0f8f103b82$export$bf07b66f9e99709b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "insight-delete-object-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9799cf0f8f103b82$var$LazyDeleteObjectModal, props));

});
parcelRegister("3IatW", function(module, exports) {

let $2b3d9ca228345555$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2b3d9ca228345555$var$load("g33bs").then(()=>parcelRequire('sc4JP'));

});


parcelRegister("2Fp7A", function(module, exports) {

$parcel$export(module.exports, "AsyncQrCodeModal", () => $d8d3ed5b3ae1614e$export$836f2b1eee2c3e38);
$parcel$export(module.exports, "AsyncSingleQrCodeModal", () => $d8d3ed5b3ae1614e$export$af30ceade8709e79);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d8d3ed5b3ae1614e$var$LazyQrCodeModal = (0, $kxZPA.lazy)(()=>(parcelRequire("fW6y8")), {
    moduleId: "./src/packages/servicedesk/insight-common/insight-qr-code-modal/src/ui/index.tsx"
});
const $d8d3ed5b3ae1614e$export$836f2b1eee2c3e38 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "insight-object-qr-code-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8d3ed5b3ae1614e$var$LazyQrCodeModal, props));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d8d3ed5b3ae1614e$var$LazySingleQrCodeModal = (0, $kxZPA.lazy)(()=>(parcelRequire("fW6y8")).then((module)=>module.SingleQrCodeModal), {
    moduleId: "./src/packages/servicedesk/insight-common/insight-qr-code-modal/src/ui/index.tsx"
});
const $d8d3ed5b3ae1614e$export$af30ceade8709e79 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "insight-object-single-qr-code-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8d3ed5b3ae1614e$var$LazySingleQrCodeModal, props));

});
parcelRegister("fW6y8", function(module, exports) {

let $b9a15a62474a5fae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b9a15a62474a5fae$var$load("fB7Y7").then(()=>parcelRequire('gpkXt'));

});


parcelRegister("2wDb6", function(module, exports) {

$parcel$export(module.exports, "BackLink", () => $65988b95165e189a$export$a4b666110a3a853f);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $g9uZe = parcelRequire("g9uZe");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hDzhb = parcelRequire("hDzhb");
const $65988b95165e189a$export$a4b666110a3a853f = ({ children: children, onClick: onClick, testId: testId, to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $65988b95165e189a$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        href: to,
        component: (0, $hDzhb.default),
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9uZe))), {
            label: ""
        }),
        onClick: (event, analyticsEvent)=>{
            onClick?.(analyticsEvent);
        },
        testId: testId
    }, children));
const $65988b95165e189a$var$wrapperStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.150'
});

});
parcelRegister("g9uZe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc2585eb44f99538$var$_react = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bc2585eb44f99538$var$_arrowLeft = $bc2585eb44f99538$var$_interopRequireDefault((parcelRequire("ctqwA")));
function $bc2585eb44f99538$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bc2585eb44f99538$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $bc2585eb44f99538$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $bc2585eb44f99538$var$_arrowLeft.default
    }));
$bc2585eb44f99538$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $bc2585eb44f99538$var$_default = module.exports.default = $bc2585eb44f99538$var$ArrowLeftCircleIcon;

});


parcelRegister("eEA1w", function(module, exports) {

$parcel$export(module.exports, "MeatballsMenu", () => $913eeded142cf2a7$export$cdd8c33ef508c851);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $aRoVz = parcelRequire("aRoVz");

var $3oUqw = parcelRequire("3oUqw");

var $7mPT9 = parcelRequire("7mPT9");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");
const $913eeded142cf2a7$var$MeatballsMenuNoRef = ({ id: id, tabIndex: tabIndex, onKeyDown: onKeyDown, moreIconLabel: moreIconLabel, children: children, isDisabled: isDisabled = false, testId: testId, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                id: id,
                testId: testId,
                tabIndex: tabIndex,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))), {
                    label: moreIconLabel,
                    size: "medium"
                }),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled,
                onKeyDown: onKeyDown
            }),
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, children));
const $913eeded142cf2a7$var$MeatballsMenuForwardRef = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ id: id, tabIndex: tabIndex, onKeyDown: onKeyDown, moreIconLabel: moreIconLabel, children: children, isDisabled: isDisabled = false, testId: testId, ...restProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                id: id,
                testId: testId,
                tabIndex: tabIndex,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))), {
                    label: moreIconLabel,
                    size: "medium"
                }),
                ref: (0, $7mPT9.mergeRefs)(triggerRef, ref),
                appearance: "subtle",
                isDisabled: isDisabled,
                onKeyDown: onKeyDown
            }),
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, children)));
const $913eeded142cf2a7$export$cdd8c33ef508c851 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('assets-a11y-fix'), $913eeded142cf2a7$var$MeatballsMenuForwardRef, $913eeded142cf2a7$var$MeatballsMenuNoRef);

});

parcelRegister("h5d36", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $20aab12bc4a9051d$export$2dc68d50d56fbbd);

var $5uXOq = parcelRequire("5uXOq");

var $fuUnn = parcelRequire("fuUnn");
var $jbeEq = parcelRequire("jbeEq");

var $66Vf6 = parcelRequire("66Vf6");

var $5Ny9E = parcelRequire("5Ny9E");

var $eOE6A = parcelRequire("eOE6A");

var $blEB6 = parcelRequire("blEB6");
const $20aab12bc4a9051d$export$2dc68d50d56fbbd = (props)=>{
    const [{ objectDetails: objectDetails }] = (0, $66Vf6.useObjectStoreState)();
    const [objectSchemaId] = (0, $66Vf6.useObjectSchemaId)();
    const [objectSchemaName] = (0, $66Vf6.useObjectSchemaName)();
    if (!objectDetails || objectSchemaId == null || objectSchemaName == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20aab12bc4a9051d$export$2f27434fd92a1003, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbeEq.default), null, props.showFullTrail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        href: (0, $blEB6.createObjectSchemaUrl)((0, $5Ny9E.toSchemaId)(objectSchemaId)),
        text: objectSchemaName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        href: (0, $blEB6.createObjectTypeUrl)((0, $5Ny9E.toSchemaId)(objectSchemaId), (0, $5Ny9E.toCmdbObjectTypeId)(objectDetails.objectType.id)),
        text: objectDetails.objectType.name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        href: (0, $blEB6.createObjectDetailUrl)(objectDetails.id),
        text: objectDetails.objectKey
    }));
};
const $20aab12bc4a9051d$export$2f27434fd92a1003 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOE6A.Skeleton), {
        margin: "0",
        width: "100px",
        height: "24px"
    });

});

parcelRegister("9v7hU", function(module, exports) {

$parcel$export(module.exports, "IconEditDialog", () => $e080308536727e9e$export$b1ae20b9d5fc5f2f);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2NMNM = parcelRequire("2NMNM");

var $ujWmd = parcelRequire("ujWmd");

var $2rqOp = parcelRequire("2rqOp");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $bUUmN = parcelRequire("bUUmN");

var $66Vf6 = parcelRequire("66Vf6");

var $5Ny9E = parcelRequire("5Ny9E");

var $4AZGm = parcelRequire("4AZGm");

var $cN3jb = parcelRequire("cN3jb");
const $e080308536727e9e$export$b1ae20b9d5fc5f2f = (props)=>{
    const { canEdit: canEdit, avatar: avatar, initialIsOpen: initialIsOpen } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [{ objectDetails: objectDetails }, { deleteObjectAvatar: deleteObjectAvatar }] = (0, $66Vf6.useObjectStoreState)();
    const [, { updateObjectAvatar: updateObjectAvatar }] = (0, $66Vf6.useObjectActions)();
    const [objectTypeId] = (0, $66Vf6.useObjectTypeId)();
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasAvatar = Boolean(objectDetails?.hasAvatar);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const avatarIconProps = {
        mediaClientConfig: avatar.mediaClientConfig,
        iconUrl: avatar.url72,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        size: 'large',
        label: ''
    };
    const iconUrl = `${avatarIconProps.iconUrl}${hasAvatar && avatar?.avatarUUID ? `?avatarUUID=${avatar.avatarUUID}` : ''}`;
    const handleAddAvatar = ()=>{
        setIsOpen(true);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'insightObjectEditObjectIcon clicked');
    };
    const onImagePicked = (files)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'insightObjectEditObjectIconConfirmUpload');
        setLoading(true);
        updateObjectAvatar({
            selectedImageFile: files[0],
            onError: ()=>{
                setLoading(false);
                showFlag({
                    type: 'error',
                    title: (0, $cN3jb.default).genericErrorMessageTitle,
                    description: (0, $cN3jb.default).genericErrorMessageDescription,
                    isAutoDismiss: true
                });
            },
            onSuccess: ()=>{
                setIsOpen(false);
                setLoading(false);
                showFlag({
                    type: 'success',
                    title: (0, $cN3jb.default).successFlagTitle,
                    isAutoDismiss: true
                });
            },
            objectTypeId: (0, $5Ny9E.toCmdbObjectTypeId)(objectTypeId)
        });
        return undefined;
    };
    const handleDeleteAvatar = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'insightObjectRemoveObjectIcon clicked');
        setLoading(true);
        deleteObjectAvatar({
            onSuccess: ()=>{
                setLoading(false);
                showFlag({
                    type: 'success',
                    title: (0, $cN3jb.default).removeSuccessFlagTitle,
                    isAutoDismiss: true
                });
            },
            onFailure: ()=>{
                setLoading(false);
                showFlag({
                    type: 'error',
                    title: (0, $cN3jb.default).removeFailFlagTitle,
                    description: (0, $cN3jb.default).removeFailFlagDescription,
                    isAutoDismiss: true
                });
            }
        });
    };
    if (canEdit === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUUmN.InsightIcon), avatarIconProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e080308536727e9e$var$DummyLoadingAvatar, {
        appearance: "primary",
        isDisabled: true,
        isLoading: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                ...triggerProps,
                testId: "servicedesk-insight-object-view.ui.header.icon-edit-dialog.object-avatar",
                appearance: "square",
                size: avatarIconProps.size,
                src: iconUrl,
                ref: triggerRef,
                label: formatMessage((0, $cN3jb.default).avatarLabel)
            }),
        isOpen: initialIsOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleAddAvatar,
        testId: "servicedesk-insight-object-view.ui.header.icon-edit-dialog.add-avatar"
    }, formatMessage(hasAvatar ? (0, $cN3jb.default).editAvatar : (0, $cN3jb.default).addAvatar)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isDisabled: !hasAvatar,
        onClick: handleDeleteAvatar,
        testId: "servicedesk-insight-object-view.ui.header.icon-edit-dialog.remove-avatar"
    }, formatMessage((0, $cN3jb.default).removeAvatar)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4AZGm.FileBrowser), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        onReceiveFiles: onImagePicked,
        accept: "image/*",
        multiple: false,
        testId: "servicedesk-insight-object-view.ui.header.icon-edit-dialog.object-avatar-input"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e080308536727e9e$var$DummyLoadingAvatar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2rqOp.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_15s31ylp _kcon1ylp _1kibv77o _1laev77o _1f5yv77o _kq8jv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4AZGm", function(module, exports) {

$parcel$export(module.exports, "FileBrowser", () => $b5ccc83f3a1ff56f$export$4ea4bb501c053712);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $b5ccc83f3a1ff56f$export$4ea4bb501c053712 = ({ isOpen: isOpen, onClose: onClose, onReceiveFiles: onReceiveFiles, accept: accept, multiple: multiple, testId: testId, ariaLabel: ariaLabel })=>{
    const inputRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (isOpen) {
            if (inputRef.current) // Click the input to open the file browser
            inputRef.current.click();
            // No browser API to know when file upload is closed, so we call
            // onClose immediately after opening
            onClose();
        }
    }, [
        isOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b5ccc83f3a1ff56f$var$HiddenInput, {
        type: "file",
        ref: inputRef,
        multiple: multiple,
        accept: accept,
        onChange: (event)=>{
            onReceiveFiles(Array.from(event.target.files ?? []));
            // Reset file input after sending file to parent
            const inputEl = event.target;
            inputEl.value = '';
        },
        "data-testId": testId,
        "aria-label": ariaLabel
    });
};
$b5ccc83f3a1ff56f$export$4ea4bb501c053712.defaultProps = {
    multiple: true
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5ccc83f3a1ff56f$var$HiddenInput = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_3um015vq _kqswstnw _1pby1mrw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cN3jb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ef814c6b0c23049$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7ef814c6b0c23049$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addAvatar: {
        "id": "servicedesk-insight-object-view.header.icon-edit-dialog.add-avatar",
        "defaultMessage": "Add avatar"
    },
    editAvatar: {
        "id": "servicedesk-insight-object-view.header.icon-edit-dialog.edit-avatar",
        "defaultMessage": "Edit avatar"
    },
    removeAvatar: {
        "id": "servicedesk-insight-object-view.header.icon-edit-dialog.remove-avatar",
        "defaultMessage": "Remove avatar"
    },
    removeSuccessFlagTitle: {
        "id": "servicedesk-insight-object-view.header.icon-edit-dialog.remove-success-flag-title",
        "defaultMessage": "Avatar removed"
    },
    removeFailFlagTitle: {
        "id": "servicedesk-insight-object-view.header.icon-edit-dialog.remove-fail-flag-title",
        "defaultMessage": "Failed to remove avatar"
    },
    removeFailFlagDescription: {
        "id": "servicedesk-insight-object-view.header.icon-edit-dialog.remove-fail-flag-description",
        "defaultMessage": "Please check your connection and try again"
    },
    genericErrorMessageTitle: {
        "id": "servicedesk-insight-object-view.header.icon-edit-dialog.generic-error-message-title",
        "defaultMessage": "We couldn't upload the image"
    },
    genericErrorMessageDescription: {
        "id": "servicedesk-insight-object-view.header.icon-edit-dialog.generic-error-message-description",
        "defaultMessage": "Refresh the page and try again"
    },
    successFlagTitle: {
        "id": "servicedesk-insight-object-view.header.icon-edit-dialog.success-flag-title",
        "defaultMessage": "Avatar added"
    },
    avatarLabel: {
        "id": "servicedesk-insight-object-view.header.icon-edit-dialog.avatar-label",
        "defaultMessage": "Object avatar"
    }
});

});


parcelRegister("iUsZj", function(module, exports) {

$parcel$export(module.exports, "default", () => $891278c54e284140$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $891278c54e284140$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    clone: {
        "id": "servicedesk-insight-object-view.header.clone",
        "defaultMessage": "Clone"
    },
    delete: {
        "id": "servicedesk-insight-object-view.header.delete",
        "defaultMessage": "Delete"
    },
    printQrCodeLabel: {
        "id": "servicedesk-insight-object-view.header.print-qr-code-label",
        "defaultMessage": "Print QR code"
    },
    giveFeedbackLabel: {
        "id": "servicedesk-insight-object-view.header.give-feedback-label",
        "defaultMessage": "Give feedback"
    },
    graphViewLabel: {
        "id": "servicedesk-insight-object-view.header.graph-view-label",
        "defaultMessage": "Graph view"
    },
    objectLabelValidation: {
        "id": "servicedesk-insight-object-view.header.object-label-validation",
        "defaultMessage": "Object label can't be blank"
    },
    hideEmptyAttributes: {
        "id": "servicedesk-insight-object-view.header.hide-empty-attributes",
        "defaultMessage": "Hide empty attributes"
    },
    showEmptyAttributes: {
        "id": "servicedesk-insight-object-view.header.show-empty-attributes",
        "defaultMessage": "Show empty attributes"
    },
    moreActions: {
        "id": "servicedesk-insight-object-view.header.more-actions",
        "defaultMessage": "More actions"
    }
});

});

parcelRegister("90c3i", function(module, exports) {

$parcel$export(module.exports, "ObjectNameInlineEdit", () => $9ce556d4e8ee279b$export$c37eab49cef59895);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $ctg8C = parcelRequire("ctg8C");

var $bopR4 = parcelRequire("bopR4");

var $iO5uh = parcelRequire("iO5uh");

var $koVbs = parcelRequire("koVbs");

var $2QgAn = parcelRequire("2QgAn");

var $66Vf6 = parcelRequire("66Vf6");

var $581BZ = parcelRequire("581BZ");

var $gRt7E = parcelRequire("gRt7E");

var $lgs0l = parcelRequire("lgs0l");

var $5MMGL = parcelRequire("5MMGL");
const $9ce556d4e8ee279b$export$c37eab49cef59895 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { canEdit: canEdit } = props;
    const [labelAttribute] = (0, $66Vf6.useLabelAttribute)();
    const [, { update: update }] = (0, $581BZ.useEditableAttribute)(labelAttribute.objectTypeAttribute);
    const [value, setValue] = (0, $2QgAn.useDefaultAttributeValue)(labelAttribute);
    const { handleEmptyStringValidation: handleEmptyStringValidation } = (0, $lgs0l.useStringLengthValidation)();
    const [isEditing, setIsEditing] = (0, $5uXOq.useState)(false);
    const [serverError, setServerError] = (0, $5uXOq.useState)(null);
    const [originalValue, setOriginalValue] = (0, $5uXOq.useState)(value);
    const onConfirm = (0, $5uXOq.useCallback)((updatedLabel)=>{
        const updated = updatedLabel.trim();
        setValue(updated);
        setServerError(null);
        if (updated !== originalValue) update({
            updatedValues: [
                {
                    value: updated
                }
            ],
            onError: (error)=>{
                setIsEditing(true);
                const errorMessage = (0, $gRt7E.getFirstValidationErrorMessage)(error) ?? formatMessage((0, $5MMGL.default).unknownError);
                setServerError(errorMessage);
            }
        });
        setIsEditing(false);
    }, [
        formatMessage,
        originalValue,
        setValue,
        update
    ]);
    const onEdit = ()=>{
        setServerError(null);
        setOriginalValue(value);
        setIsEditing(true);
    };
    const onCancel = ()=>{
        setServerError(null);
        setValue(originalValue);
        setIsEditing(false);
    };
    const createOnKeyDown = (0, $5uXOq.useCallback)((currentValue)=>(event)=>{
            // Prevents 'enter' from inserting a newline character, and instead
            // 'submits' the inline edit. Note that this could be achieved ootb
            // with an atlaskit TextField (instead of TextArea), however there
            // are stricter styling contraints on that component which makes
            // matching the design spec impossible.
            if (event.key === 'Enter') {
                event.preventDefault();
                if (currentValue != null && currentValue !== '') onConfirm(currentValue);
                else setIsEditing(false);
            }
        }, [
        onConfirm
    ]);
    if (canEdit === false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _1pnf15vq _1kvn15vq _kmu51l2s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "large",
        as: "h1"
    }, value));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        isEditing: isEditing,
        onEdit: onEdit,
        onConfirm: onConfirm,
        onCancel: onCancel,
        editButtonLabel: formatMessage((0, $5MMGL.default).editButtonLabel),
        defaultValue: value,
        readViewFitContainerWidth: true,
        readView: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, $bwpsq.default)([
                    "_19pkidpf _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _1pnf15vq _1kvn15vq _kmu51l2s"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
                size: "large",
                as: "h1",
                testId: "servicedesk-insight-object-view.ui.header.name-inline-edit.page-title"
            }, value));
        },
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>{
            const error = serverError ?? errorMessage;
            const isInvalid = error !== undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), {
                content: error,
                isOpen: error !== undefined,
                placement: "right"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, $bwpsq.default)([
                    "_l6x2thzt _19331l7b _1pnf1wug _1kvn1wug _99npnqa1 _1xggyh40 _1z0h13er _rzbyidpf _zo1a12x7 _1j1w12x7 _1fiv12x7 _h2wr12x7 _bwzo1hna _1o4musvi",
                    isInvalid && "_1z0h1bqt"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
                size: "large",
                as: "h1"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iO5uh.default), {
                ...fieldProps,
                isRequired: true,
                shouldAutoFocus: true,
                onKeyDown: createOnKeyDown(fieldProps.value),
                "aria-label": formatMessage((0, $5MMGL.default).inlineEditLabel)
            }))));
        },
        validate: handleEmptyStringValidation(formatMessage((0, $5MMGL.default).objectLabel))
    });
};
const $9ce556d4e8ee279b$var$readViewStyle = null;
const $9ce556d4e8ee279b$var$editViewContainerStyle = null;
const $9ce556d4e8ee279b$var$editViewContainerInvalidBorderStyle = null;

});
parcelRegister("iO5uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f309ca7ac5d4198f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $cQ8XU = parcelRequire("cQ8XU");
const $f309ca7ac5d4198f$var$TextAreaWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_z88midpf _1jo5idpf _1piwidpf _qbmfidpf _ji25idpf _1mh7idpf _hjmjidpf _m9wmidpf _12usglyw _ie9q1wug _htxo1wug _katv1r31 _158bglyw _q1co1o36 _ktqf18uv _1xqm1kw7 _1xlz1ule _uxa81osq _1qfsglyw _tcp41hna _17ocglyw _3il51kw7"
        ])
    }, children);
};
const $f309ca7ac5d4198f$var$containerStyles = null;
class $f309ca7ac5d4198f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDisabled: false,
            shouldAutoFocus: false,
            onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(...args){
        super(...args), this.onChange = (event)=>this.props.onChange(event.target.value), this.render = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f309ca7ac5d4198f$var$TextAreaWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cQ8XU.default), {
                ...this.props,
                value: this.props.value,
                // @ts-expect-error - TS2769 - No overload matches this call.
                onChange: this.onChange,
                onKeyDown: this.props.onKeyDown,
                disabled: this.props.isDisabled,
                autoFocus: this.props.shouldAutoFocus,
                ...this.props.isRequired ? {
                    'aria-required': 'true'
                } : {}
            }));
    }
}

});
parcelRegister("cQ8XU", function(module, exports) {

$parcel$export(module.exports, "default", () => $95914bb3405216db$export$2e2bcd8739ae039, (v) => $95914bb3405216db$export$2e2bcd8739ae039 = v);
var $95914bb3405216db$export$1e511d4a378977f5;
var $95914bb3405216db$export$2e2bcd8739ae039;
"use strict";
$95914bb3405216db$export$1e511d4a378977f5 = true;

var $2V0Qs = parcelRequire("2V0Qs");
$95914bb3405216db$export$2e2bcd8739ae039 = $2V0Qs.default;

});
parcelRegister("2V0Qs", function(module, exports) {
"use strict";
var $22018f79a5082642$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $22018f79a5082642$var$__assign = module.exports && module.exports.__assign || Object.assign || function(t) {
    for(var s, i = 1, n = arguments.length; i < n; i++){
        s = arguments[i];
        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};
var $22018f79a5082642$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
};
module.exports.__esModule = true;

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $4O2yR = parcelRequire("4O2yR");

var $s1LpX = parcelRequire("s1LpX");
var $22018f79a5082642$var$getLineHeight = $s1LpX;
var $22018f79a5082642$var$UPDATE = 'autosize:update';
var $22018f79a5082642$var$DESTROY = 'autosize:destroy';
var $22018f79a5082642$var$RESIZED = 'autosize:resized';
/**
 * A light replacement for built-in textarea component
 * which automaticaly adjusts its height to match the content
 */ var $22018f79a5082642$var$TextareaAutosize = /** @class */ function(_super) {
    $22018f79a5082642$var$__extends(TextareaAutosize, _super);
    function TextareaAutosize() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            lineHeight: null
        };
        _this.dispatchEvent = function(EVENT_TYPE) {
            var event = document.createEvent('Event');
            event.initEvent(EVENT_TYPE, true, false);
            _this.textarea.dispatchEvent(event);
        };
        _this.updateLineHeight = function() {
            _this.setState({
                lineHeight: $22018f79a5082642$var$getLineHeight(_this.textarea)
            });
        };
        _this.onChange = function(e) {
            var onChange = _this.props.onChange;
            _this.currentValue = e.currentTarget.value;
            onChange && onChange(e);
        };
        _this.saveDOMNodeRef = function(ref) {
            var innerRef = _this.props.innerRef;
            if (innerRef) innerRef(ref);
            _this.textarea = ref;
        };
        _this.getLocals = function() {
            var _a = _this, _b = _a.props, onResize = _b.onResize, maxRows = _b.maxRows, onChange = _b.onChange, style = _b.style, innerRef = _b.innerRef, props = $22018f79a5082642$var$__rest(_b, [
                "onResize",
                "maxRows",
                "onChange",
                "style",
                "innerRef"
            ]), lineHeight = _a.state.lineHeight, saveDOMNodeRef = _a.saveDOMNodeRef;
            var maxHeight = maxRows && lineHeight ? lineHeight * maxRows : null;
            return $22018f79a5082642$var$__assign({}, props, {
                saveDOMNodeRef: saveDOMNodeRef,
                style: maxHeight ? $22018f79a5082642$var$__assign({}, style, {
                    maxHeight: maxHeight
                }) : style,
                onChange: _this.onChange
            });
        };
        return _this;
    }
    TextareaAutosize.prototype.componentDidMount = function() {
        var _this = this;
        var _a = this.props, onResize = _a.onResize, maxRows = _a.maxRows, async = _a.async;
        if (typeof maxRows === 'number') this.updateLineHeight();
        if (typeof maxRows === "number" || async) /*
              the defer is needed to:
                - force "autosize" to activate the scrollbar when this.props.maxRows is passed
                - support StyledComponents (see #71)
            */ setTimeout(function() {
            return $4O2yR(_this.textarea);
        });
        else $4O2yR(this.textarea);
        if (onResize) this.textarea.addEventListener($22018f79a5082642$var$RESIZED, onResize);
    };
    TextareaAutosize.prototype.componentWillUnmount = function() {
        var onResize = this.props.onResize;
        if (onResize) this.textarea.removeEventListener($22018f79a5082642$var$RESIZED, onResize);
        this.dispatchEvent($22018f79a5082642$var$DESTROY);
    };
    TextareaAutosize.prototype.render = function() {
        var _a = this.getLocals(), children = _a.children, saveDOMNodeRef = _a.saveDOMNodeRef, locals = $22018f79a5082642$var$__rest(_a, [
            "children",
            "saveDOMNodeRef"
        ]);
        return $5uXOq.createElement("textarea", $22018f79a5082642$var$__assign({}, locals, {
            ref: saveDOMNodeRef
        }), children);
    };
    TextareaAutosize.prototype.componentDidUpdate = function(prevProps) {
        if (this.props.value !== this.currentValue || this.props.rows !== prevProps.rows) this.dispatchEvent($22018f79a5082642$var$UPDATE);
    };
    TextareaAutosize.defaultProps = {
        rows: 1,
        async: false
    };
    TextareaAutosize.propTypes = {
        rows: $8rCP3.number,
        maxRows: $8rCP3.number,
        onResize: $8rCP3.func,
        innerRef: $8rCP3.func,
        async: $8rCP3.bool
    };
    return TextareaAutosize;
}($5uXOq.Component);
module.exports["default"] = $22018f79a5082642$var$TextareaAutosize;

});
parcelRegister("4O2yR", function(module, exports) {
/*!
	autosize 4.0.2
	license: MIT
	http://www.jacklmoore.com/autosize
*/ (function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        'module',
        'exports'
    ], factory);
    else {
        var mod;
        factory(module, exports);
    }
})(this, function(module1, exports1) {
    'use strict';
    var map = typeof Map === "function" ? new Map() : function() {
        var keys = [];
        var values = [];
        return {
            has: function has(key) {
                return keys.indexOf(key) > -1;
            },
            get: function get(key) {
                return values[keys.indexOf(key)];
            },
            set: function set(key, value) {
                if (keys.indexOf(key) === -1) {
                    keys.push(key);
                    values.push(value);
                }
            },
            delete: function _delete(key) {
                var index = keys.indexOf(key);
                if (index > -1) {
                    keys.splice(index, 1);
                    values.splice(index, 1);
                }
            }
        };
    }();
    var createEvent = function createEvent(name) {
        return new Event(name, {
            bubbles: true
        });
    };
    try {
        new Event('test');
    } catch (e) {
        // IE does not support `new Event()`
        createEvent = function createEvent(name) {
            var evt = document.createEvent('Event');
            evt.initEvent(name, true, false);
            return evt;
        };
    }
    function assign(ta) {
        if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;
        var heightOffset = null;
        var clientWidth = null;
        var cachedHeight = null;
        function init() {
            var style = window.getComputedStyle(ta, null);
            if (style.resize === 'vertical') ta.style.resize = 'none';
            else if (style.resize === 'both') ta.style.resize = 'horizontal';
            if (style.boxSizing === 'content-box') heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
            else heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
            // Fix when a textarea is not on document body and heightOffset is Not a Number
            if (isNaN(heightOffset)) heightOffset = 0;
            update();
        }
        function changeOverflow(value) {
            // Chrome/Safari-specific fix:
            // When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
            // made available by removing the scrollbar. The following forces the necessary text reflow.
            var width = ta.style.width;
            ta.style.width = '0px';
            // Force reflow:
            /* jshint ignore:start */ ta.offsetWidth;
            /* jshint ignore:end */ ta.style.width = width;
            ta.style.overflowY = value;
        }
        function getParentOverflows(el) {
            var arr = [];
            while(el && el.parentNode && el.parentNode instanceof Element){
                if (el.parentNode.scrollTop) arr.push({
                    node: el.parentNode,
                    scrollTop: el.parentNode.scrollTop
                });
                el = el.parentNode;
            }
            return arr;
        }
        function resize() {
            if (ta.scrollHeight === 0) // If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
            return;
            var overflows = getParentOverflows(ta);
            var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)
            ta.style.height = '';
            ta.style.height = ta.scrollHeight + heightOffset + 'px';
            // used to check if an update is actually necessary on window.resize
            clientWidth = ta.clientWidth;
            // prevents scroll-position jumping
            overflows.forEach(function(el) {
                el.node.scrollTop = el.scrollTop;
            });
            if (docTop) document.documentElement.scrollTop = docTop;
        }
        function update() {
            resize();
            var styleHeight = Math.round(parseFloat(ta.style.height));
            var computed = window.getComputedStyle(ta, null);
            // Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
            var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;
            // The actual height not matching the style height (set via the resize method) indicates that 
            // the max-height has been exceeded, in which case the overflow should be allowed.
            if (actualHeight < styleHeight) {
                if (computed.overflowY === 'hidden') {
                    changeOverflow('scroll');
                    resize();
                    actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
                }
            } else // Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
            if (computed.overflowY !== 'hidden') {
                changeOverflow('hidden');
                resize();
                actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
            }
            if (cachedHeight !== actualHeight) {
                cachedHeight = actualHeight;
                var evt = createEvent('autosize:resized');
                try {
                    ta.dispatchEvent(evt);
                } catch (err) {
                // Firefox will throw an error on dispatchEvent for a detached element
                // https://bugzilla.mozilla.org/show_bug.cgi?id=889376
                }
            }
        }
        var pageResize = function pageResize() {
            if (ta.clientWidth !== clientWidth) update();
        };
        var destroy = (function(style) {
            window.removeEventListener('resize', pageResize, false);
            ta.removeEventListener('input', update, false);
            ta.removeEventListener('keyup', update, false);
            ta.removeEventListener('autosize:destroy', destroy, false);
            ta.removeEventListener('autosize:update', update, false);
            Object.keys(style).forEach(function(key) {
                ta.style[key] = style[key];
            });
            map.delete(ta);
        }).bind(ta, {
            height: ta.style.height,
            resize: ta.style.resize,
            overflowY: ta.style.overflowY,
            overflowX: ta.style.overflowX,
            wordWrap: ta.style.wordWrap
        });
        ta.addEventListener('autosize:destroy', destroy, false);
        // IE9 does not fire onpropertychange or oninput for deletions,
        // so binding to onkeyup to catch most of those events.
        // There is no way that I know of to detect something like 'cut' in IE9.
        if ('onpropertychange' in ta && 'oninput' in ta) ta.addEventListener('keyup', update, false);
        window.addEventListener('resize', pageResize, false);
        ta.addEventListener('input', update, false);
        ta.addEventListener('autosize:update', update, false);
        ta.style.overflowX = 'hidden';
        ta.style.wordWrap = 'break-word';
        map.set(ta, {
            destroy: destroy,
            update: update
        });
        init();
    }
    function destroy(ta) {
        var methods = map.get(ta);
        if (methods) methods.destroy();
    }
    function update(ta) {
        var methods = map.get(ta);
        if (methods) methods.update();
    }
    var autosize = null;
    // Do nothing in Node.js environment and IE8 (or lower)
    if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
        autosize = function autosize(el) {
            return el;
        };
        autosize.destroy = function(el) {
            return el;
        };
        autosize.update = function(el) {
            return el;
        };
    } else {
        autosize = function autosize(el, options) {
            if (el) Array.prototype.forEach.call(el.length ? el : [
                el
            ], function(x) {
                return assign(x, options);
            });
            return el;
        };
        autosize.destroy = function(el) {
            if (el) Array.prototype.forEach.call(el.length ? el : [
                el
            ], destroy);
            return el;
        };
        autosize.update = function(el) {
            if (el) Array.prototype.forEach.call(el.length ? el : [
                el
            ], update);
            return el;
        };
    }
    exports1.default = autosize;
    module1.exports = exports1['default'];
});

});

parcelRegister("s1LpX", function(module, exports) {
// Load in dependencies

var $642E5 = parcelRequire("642E5");
/**
 * Calculate the `line-height` of a given node
 * @param {HTMLElement} node Element to calculate line height of. Must be in the DOM.
 * @returns {Number} `line-height` of the element in pixels
 */ function $0543fbe4e13ddefd$var$lineHeight(node) {
    // Grab the line-height via style
    var lnHeightStr = $642E5(node, 'line-height');
    var lnHeight = parseFloat(lnHeightStr, 10);
    // If the lineHeight did not contain a unit (i.e. it was numeric), convert it to ems (e.g. '2.3' === '2.3em')
    if (lnHeightStr === lnHeight + '') {
        // Save the old lineHeight style and update the em unit to the element
        var _lnHeightStyle = node.style.lineHeight;
        node.style.lineHeight = lnHeightStr + 'em';
        // Calculate the em based height
        lnHeightStr = $642E5(node, 'line-height');
        lnHeight = parseFloat(lnHeightStr, 10);
        // Revert the lineHeight style
        if (_lnHeightStyle) node.style.lineHeight = _lnHeightStyle;
        else delete node.style.lineHeight;
    }
    // If the lineHeight is in `pt`, convert it to pixels (4px for 3pt)
    // DEV: `em` units are converted to `pt` in IE6
    // Conversion ratio from https://developer.mozilla.org/en-US/docs/Web/CSS/length
    if (lnHeightStr.indexOf('pt') !== -1) {
        lnHeight *= 4;
        lnHeight /= 3;
    // Otherwise, if the lineHeight is in `mm`, convert it to pixels (96px for 25.4mm)
    } else if (lnHeightStr.indexOf('mm') !== -1) {
        lnHeight *= 96;
        lnHeight /= 25.4;
    // Otherwise, if the lineHeight is in `cm`, convert it to pixels (96px for 2.54cm)
    } else if (lnHeightStr.indexOf('cm') !== -1) {
        lnHeight *= 96;
        lnHeight /= 2.54;
    // Otherwise, if the lineHeight is in `in`, convert it to pixels (96px for 1in)
    } else if (lnHeightStr.indexOf('in') !== -1) lnHeight *= 96;
    else if (lnHeightStr.indexOf('pc') !== -1) lnHeight *= 16;
    // Continue our computation
    lnHeight = Math.round(lnHeight);
    // If the line-height is "normal", calculate by font-size
    if (lnHeightStr === 'normal') {
        // Create a temporary node
        var nodeName = node.nodeName;
        var _node = document.createElement(nodeName);
        _node.innerHTML = '&nbsp;';
        // If we have a text area, reset it to only 1 row
        // https://github.com/twolfson/line-height/issues/4
        if (nodeName.toUpperCase() === 'TEXTAREA') _node.setAttribute('rows', '1');
        // Set the font-size of the element
        var fontSizeStr = $642E5(node, 'font-size');
        _node.style.fontSize = fontSizeStr;
        // Remove default padding/border which can affect offset height
        // https://github.com/twolfson/line-height/issues/4
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetHeight
        _node.style.padding = '0px';
        _node.style.border = '0px';
        // Append it to the body
        var body = document.body;
        body.appendChild(_node);
        // Assume the line height of the element is the height
        var height = _node.offsetHeight;
        lnHeight = height;
        // Remove our child from the DOM
        body.removeChild(_node);
    }
    // Return the calculated height
    return lnHeight;
}
// Export lineHeight
module.exports = $0543fbe4e13ddefd$var$lineHeight;

});
parcelRegister("642E5", function(module, exports) {
// This code has been refactored for 140 bytes
// You can see the original here: https://github.com/twolfson/computedStyle/blob/04cd1da2e30fa45844f95f5cb1ac898e9b9ef050/lib/computedStyle.js
var $46a52b2828d41a59$var$computedStyle = function(el, prop, getComputedStyle) {
    getComputedStyle = window.getComputedStyle;
    // In one fell swoop
    return(// If we have getComputedStyle
    (getComputedStyle ? // Query it
    // TODO: From CSS-Query notes, we might need (node, null) for FF
    getComputedStyle(el) : // Otherwise, we are in IE and use currentStyle
    el.currentStyle)[// Switch to camelCase for CSSOM
    // DEV: Grabbed from jQuery
    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
    prop.replace(/-(\w)/gi, function(word, letter) {
        return letter.toUpperCase();
    })]);
};
module.exports = $46a52b2828d41a59$var$computedStyle;

});





parcelRegister("lgs0l", function(module, exports) {

$parcel$export(module.exports, "useStringLengthValidation", () => $0563588428011d8d$export$bcc66e2427e1a1ba);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $31OTh = parcelRequire("31OTh");
const $0563588428011d8d$export$bcc66e2427e1a1ba = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleEmptyStringValidation = (0, $5uXOq.useCallback)((fieldLabel)=>(value = '')=>{
            const { length: length } = value.trim();
            return length === 0 ? formatMessage((0, $31OTh.messages).missingValidation, {
                fieldLabel: fieldLabel
            }) : undefined;
        }, [
        formatMessage
    ]);
    const handleStringLengthLimitValidation = (0, $5uXOq.useCallback)((fieldLabel, fieldLimit)=>(value = '')=>{
            if (fieldLimit !== undefined && fieldLimit !== undefined) {
                const { length: length } = value.trim();
                if (fieldLimit.MIN !== undefined && fieldLimit.MIN > length) return formatMessage((0, $31OTh.messages).minValidation, {
                    fieldLabel: fieldLabel,
                    min: fieldLimit.MIN
                });
                if (fieldLimit.MAX < length) return formatMessage((0, $31OTh.messages).maxValidation, {
                    fieldLabel: fieldLabel,
                    max: fieldLimit.MAX
                });
            }
            return undefined;
        }, [
        formatMessage
    ]);
    return {
        handleEmptyStringValidation: handleEmptyStringValidation,
        handleStringLengthLimitValidation: handleStringLengthLimitValidation
    };
};

});
parcelRegister("31OTh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7d293b706a3adb67$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7d293b706a3adb67$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    minValidation: {
        "id": "servicedesk-insight-shared-utils.common.utils.string-length-validation.min-validation",
        "defaultMessage": "{fieldLabel} must contain at least {min, plural, one {# character} other {# characters}}"
    },
    maxValidation: {
        "id": "servicedesk-insight-shared-utils.common.utils.string-length-validation.max-validation",
        "defaultMessage": "{fieldLabel} must contain less than {max, plural, one {# character} other {# characters}}"
    },
    missingValidation: {
        "id": "servicedesk-insight-shared-utils.common.utils.string-length-validation.missing-validation",
        "defaultMessage": "{fieldLabel} is required"
    }
});

});


parcelRegister("5MMGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4013cc5300f6c2ef$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4013cc5300f6c2ef$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    objectLabel: {
        "id": "servicedesk-insight-object-view.header.name-inline-edit.object-label",
        "defaultMessage": "Object label"
    },
    unknownError: {
        "id": "servicedesk-insight-object-view.header.name-inline-edit.unknown-error",
        "defaultMessage": "Unknown error"
    },
    inlineEditLabel: {
        "id": "servicedesk-insight-object-view.header.name-inline-edit.inline-edit-label",
        "defaultMessage": "Enter object label"
    },
    editButtonLabel: {
        "id": "servicedesk-insight-object-view.header.name-inline-edit.edit-button-label",
        "defaultMessage": "Edit object label"
    }
});

});



parcelRegister("as7ha", function(module, exports) {

$parcel$export(module.exports, "ObjectDates", () => $f018eaf0acfb8b6f$export$7201838dbef8e81);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lzeFL = parcelRequire("lzeFL");

var $koVbs = parcelRequire("koVbs");

var $cYlk7 = parcelRequire("cYlk7");

var $1p96B = parcelRequire("1p96B");

var $66Vf6 = parcelRequire("66Vf6");

var $fDMAc = parcelRequire("fDMAc");
const $f018eaf0acfb8b6f$var$TIMESTAMP_FORMAT = 'MMMM d, yyyy, p';
const $f018eaf0acfb8b6f$var$DEFAULT_TIME_ZONE = 'UTC';
const $f018eaf0acfb8b6f$export$7201838dbef8e81 = ()=>{
    const [{ objectDetails: objectDetails }] = (0, $66Vf6.useObjectStoreState)();
    const { data: data } = (0, $cYlk7.useCurrentUser)();
    const locale = data.user.locale ?? (0, $lzeFL.defaultLocale);
    const timeZone = ('timeZone' in data.user ? data.user.timeZone : $f018eaf0acfb8b6f$var$DEFAULT_TIME_ZONE) || $f018eaf0acfb8b6f$var$DEFAULT_TIME_ZONE;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formatDate = (0, $5uXOq.useCallback)((timestamp)=>(0, $1p96B.formatTimezonedWithLocale)(new Date(timestamp), $f018eaf0acfb8b6f$var$TIMESTAMP_FORMAT, locale, timeZone), [
        locale,
        timeZone
    ]);
    if (!objectDetails) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f018eaf0acfb8b6f$var$DateLine, null, formatMessage((0, $fDMAc.default).objectCreatedLabel, {
        date: formatDate(objectDetails.created)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f018eaf0acfb8b6f$var$DateLine, null, formatMessage((0, $fDMAc.default).objectModifiedLabel, {
        date: formatDate(objectDetails.updated)
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f018eaf0acfb8b6f$var$DateLine = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8qk37 _vwz41tcg _syaz1fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fDMAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2d65255e63719e2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c2d65255e63719e2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    objectCreatedLabel: {
        "id": "servicedesk-insight-object-view.object-dates.object-created-label",
        "defaultMessage": "Created {date}"
    },
    objectModifiedLabel: {
        "id": "servicedesk-insight-object-view.object-dates.object-modified-label",
        "defaultMessage": "Modified {date}"
    }
});

});




parcelRegister("6GLlD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1e4a0c92f65aa33$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $9noxX = parcelRequire("9noxX");

var $e9YVH = parcelRequire("e9YVH");

var $9dbF6 = parcelRequire("9dbF6");

var $9NiTW = parcelRequire("9NiTW");

var $cYaqS = parcelRequire("cYaqS");
const $b1e4a0c92f65aa33$var$ServiceDeskAppBase = ({ appName: appName, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9NiTW.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cYaqS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9noxX.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $e9YVH.toPackageName)(appName),
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, children))));
var $b1e4a0c92f65aa33$export$2e2bcd8739ae039 = $b1e4a0c92f65aa33$var$ServiceDeskAppBase;

});
parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $dJl1T = parcelRequire("dJl1T");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $dJl1T.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $dJl1T = parcelRequire("dJl1T");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $dJl1T.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("cYaqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72fff5a1e4c8937$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $aTz47 = parcelRequire("aTz47");


var $4UFLs = parcelRequire("4UFLs");

var $g3A84 = parcelRequire("g3A84");
const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $6jY6G.useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
    const Gate = isSettingsRoute || isHelpCenterSettingsRoute ? (0, $g3A84.default) : (0, $4UFLs.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
};
var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;

});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
const $7c914880cb332728$export$16a37d277dff22d6 = '/jira/helpcenter/projects';

parcelRegister("4UFLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9befbeaff9f5385d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $daoB1 = parcelRequire("daoB1");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $iDvG9 = parcelRequire("iDvG9");
const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $daoB1.useApplicationPermissions)();
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDvG9.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira"
    });
};
var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;

});
parcelRegister("iDvG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $34dd3dc578b1a167$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $bmKPg = parcelRequire("bmKPg");

var $dFOAR = parcelRequire("dFOAR");


var $fhAnU = parcelRequire("fhAnU");
const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $bmKPg.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $dFOAR.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $fhAnU.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;

});
parcelRegister("dFOAR", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $6c09349e97fba749$export$712ead87353ac687);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $cAofY = parcelRequire("cAofY");
const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, $cAofY.serviceDeskContextResource);
const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $324W5.useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
    (0, $5uXOq.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});

parcelRegister("fhAnU", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $1a790f4bb1355504$export$ddaebe4928e793cb);

const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
    (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
    (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
    (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
];
const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;




parcelRegister("g3A84", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e7d6646168c089$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aTz47 = parcelRequire("aTz47");

var $8pMQX = parcelRequire("8pMQX");

var $dFOAR = parcelRequire("dFOAR");

var $fhAnU = parcelRequire("fhAnU");
const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $dFOAR.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $fhAnU.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) {
        const isHelpCenterSettingsRoute = (0, $aTz47.isHelpCenterSettingsPath)();
        if (isHelpCenterSettingsRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ServiceHubNotFound), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.ProjectNotFound), null);
    }
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null);
    return null;
};
var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;

});



parcelRegister("ivzw9", function(module, exports) {

$parcel$export(module.exports, "InsightAppBaseV2", () => $24af6a5656140d82$export$c9b1085d6a7138ac);

var $5uXOq = parcelRequire("5uXOq");

var $85JfV = parcelRequire("85JfV");

var $beRD7 = parcelRequire("beRD7");

var $ktP1V = parcelRequire("ktP1V");

var $7DxXA = parcelRequire("7DxXA");

var $ahEft = parcelRequire("ahEft");

var $4S0uJ = parcelRequire("4S0uJ");

var $9OXo1 = parcelRequire("9OXo1");

var $3hqfY = parcelRequire("3hqfY");
const $24af6a5656140d82$export$c9b1085d6a7138ac = ({ children: children })=>{
    const { workspaceId: workspaceId, error: error, loading: loading } = (0, $7DxXA.useWorkspaceContext)();
    const hasInsightPermission = (0, $7DxXA.useInsightVisibility)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    if (!(0, $ktP1V.isCMDBEnabledInEnvironment)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null);
    if (!(0, $ahEft.isLicensedPremiumUser)(tenantContext)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85JfV.AsyncCmdbUpsellPage), null);
    if (workspaceId == null) return !loading && !error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.NotFoundErrorPageAsync), null) : null;
    if (hasInsightPermission === false || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.GenericPermissionErrorPageAsync), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4S0uJ.PageStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3hqfY.CmdbArchitectureContainer), {
        workspaceId: workspaceId
    }, children({
        workspaceId: workspaceId
    })));
};

});
parcelRegister("4S0uJ", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $7307247c9fc02c84$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.35.0 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bAkIV = parcelRequire("bAkIV");
const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page = (0, $bAkIV.default), children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Page, null, children));
var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7307247c9fc02c84$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1jfw _otyridpf _18u01jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bAkIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e769a1b108c1b03$export$2e2bcd8739ae039);

var $cE92Q = parcelRequire("cE92Q");

var $bJcWY = parcelRequire("bJcWY");

var $aZdfU = parcelRequire("aZdfU");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$5e769a1b108c1b03$export$2e2bcd8739ae039 = (0, $cE92Q.default);

});
parcelRegister("cE92Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f4d1a89146de6ed$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");
function $2f4d1a89146de6ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2f4d1a89146de6ed$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $2f4d1a89146de6ed$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $2f4d1a89146de6ed$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $2f4d1a89146de6ed$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $2f4d1a89146de6ed$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $2f4d1a89146de6ed$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $2f4d1a89146de6ed$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $f1WIN.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$pageContentStyles
    }, children)));
};
var $2f4d1a89146de6ed$export$2e2bcd8739ae039 = $2f4d1a89146de6ed$var$Page;

});
parcelRegister("f1WIN", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $196a11a7b8c2fbef$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $196a11a7b8c2fbef$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $196a11a7b8c2fbef$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $196a11a7b8c2fbef$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $196a11a7b8c2fbef$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $196a11a7b8c2fbef$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $196a11a7b8c2fbef$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $196a11a7b8c2fbef$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $196a11a7b8c2fbef$export$936829b4511db3e4);
const $196a11a7b8c2fbef$export$3aaf3a78c909ea56 = 8;
const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 10;
const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
    comfortable: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 5,
    cosy: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 2,
    compact: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 0.5
};
const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("bJcWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fe944bdcd177c2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");

var $itnZ9 = parcelRequire("itnZ9");

var $aZdfU = parcelRequire("aZdfU");

var $ephoW = parcelRequire("ephoW");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $aZdfU.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $f1WIN.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $f1WIN.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ephoW.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itnZ9.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;

});
parcelRegister("itnZ9", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $92e4fcbfc398e3a4$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
function $92e4fcbfc398e3a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92e4fcbfc398e3a4$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $92e4fcbfc398e3a4$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $f1WIN.varColumnsNum)}) * ${(0, $f1WIN.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $92e4fcbfc398e3a4$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $f1WIN.varGridSpacing)}))`
});
const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, $f1WIN.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $92e4fcbfc398e3a4$var$gridStyles,
            $92e4fcbfc398e3a4$var$gridLayoutStyles[layout],
            isNested && $92e4fcbfc398e3a4$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varGridSpacing)]: `${(0, $f1WIN.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("ephoW", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $529bf77650fbff0f$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");
const $529bf77650fbff0f$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $f1WIN.defaultSpacing),
    columns: (0, $f1WIN.defaultGridColumns)
});

});


parcelRegister("aZdfU", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $11b791725219e059$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $11b791725219e059$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
/**
 * Determines the method by which column width is calculated.
 */ var $11b791725219e059$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($11b791725219e059$var$ColumnVariant || {});
const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $f1WIN.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $11b791725219e059$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $11b791725219e059$var$singleColumnWidth = `(${$11b791725219e059$var$availableWidth} / var(${(0, $f1WIN.varColumnsNum)}))`;
const $11b791725219e059$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$11b791725219e059$var$singleColumnWidth} - var(${(0, $f1WIN.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $11b791725219e059$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$11b791725219e059$var$singleColumnWidth} *  var(${(0, $f1WIN.varColumnSpan)}) - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $11b791725219e059$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $f1WIN.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, $f1WIN.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $11b791725219e059$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $11b791725219e059$var$gridColumnStyles,
            $11b791725219e059$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;

});




parcelRegister("3hqfY", function(module, exports) {

$parcel$export(module.exports, "CmdbArchitectureContainer", () => $4fa0d536b0129dcf$export$9f2b76d50d1e5752);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $beRD7 = parcelRequire("beRD7");

var $4R6GH = parcelRequire("4R6GH");

var $lQlqY = parcelRequire("lQlqY");

var $6aAM3 = parcelRequire("6aAM3");
const $4fa0d536b0129dcf$export$9f2b76d50d1e5752 = ({ workspaceId: workspaceId, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $4R6GH.fg)('assets_rearch_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6aAM3.CmdbArchitectureStoreContainer), {
        isGlobal: true,
        workspaceId: workspaceId,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4fa0d536b0129dcf$export$a94168bcf4c80e75, null, children)) : children;
};
const $4fa0d536b0129dcf$export$a94168bcf4c80e75 = ({ children: children })=>{
    const { loading: loading, error: error, migrationStatus: migrationStatus } = (0, $6aAM3.useCmdbArchitectureStore)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $beRD7.JSErrorPageAsync), null);
    if (loading || !migrationStatus) return null;
    if (migrationStatus.blockWriteTraffic) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lQlqY.MaintenanceModePage), null);
    return children;
};

});
parcelRegister("lQlqY", function(module, exports) {

$parcel$export(module.exports, "MaintenanceModePage", () => $0103f3a948bc61e0$export$407ffafe578d3c20);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $hTEpF = parcelRequire("hTEpF");

var $9b6hG = parcelRequire("9b6hG");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $4xzBL = parcelRequire("4xzBL");
const $0103f3a948bc61e0$var$contactSupportLink = 'https://support.atlassian.com/contact/#/';
const $0103f3a948bc61e0$export$407ffafe578d3c20 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderImage = ()=>(0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $9b6hG.default))({
            imageWidth: 275,
            maxImageWidth: 275,
            maxImageHeight: 275
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        width: "wide",
        renderImage: renderImage,
        header: formatMessage((0, $4xzBL.messages).errorTitle),
        description: formatMessage((0, $4xzBL.messages).errorDescription, {
            break: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null)
        }),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: $0103f3a948bc61e0$var$contactSupportLink,
            target: "_blank"
        }, formatMessage((0, $4xzBL.messages).contactMessage)),
        testId: "cmdb-maintenance-page.ui.cmdb-maintenance-page"
    });
};

});
parcelRegister("9b6hG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5f2d5726428324$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $5nu4I = parcelRequire("5nu4I");
const $1e5f2d5726428324$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5nu4I)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($5nu4I))
});
var $1e5f2d5726428324$export$2e2bcd8739ae039 = $1e5f2d5726428324$var$Illustration;
const $1e5f2d5726428324$export$a179c88182cb9d56 = [
    0,
    0,
    276,
    276
];

});
parcelRegister("5nu4I", function(module, exports) {
module.exports = new URL("infrastructure-crane.3c8e069d.svg", import.meta.url).toString();

});


parcelRegister("4xzBL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b0feb3bc732f19e3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b0feb3bc732f19e3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "servicedesk-cmdb-cmdb-maintenance-page.maintenance-error.error-title",
        "defaultMessage": "Be right back"
    },
    errorDescription: {
        "id": "servicedesk-cmdb-cmdb-maintenance-page.maintenance-error.error-description",
        "defaultMessage": "Assets is currently under maintenance and will return shortly. <break></break> Please try again later."
    },
    contactMessage: {
        "id": "servicedesk-cmdb-cmdb-maintenance-page.maintenance-error.contact-message",
        "defaultMessage": "Contact support"
    }
});

});


parcelRegister("6aAM3", function(module, exports) {

$parcel$export(module.exports, "CmdbArchitectureStoreContainer", () => $19939ed91be7a6ca$export$3e99e0b586e9bd20);
$parcel$export(module.exports, "useCmdbArchitectureStore", () => $19939ed91be7a6ca$export$cb0396e44d69a170);
$parcel$export(module.exports, "useIsNewCmdbArchitecture", () => $19939ed91be7a6ca$export$cb6873bd1bfb6e11);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $5p97Y = parcelRequire("5p97Y");
const $19939ed91be7a6ca$export$d4c72bab9d6cc13a = {
    loading: false,
    error: undefined,
    migrationStatus: undefined
};
const $19939ed91be7a6ca$var$store = (0, $iXqE5.createStore)({
    initialState: $19939ed91be7a6ca$export$d4c72bab9d6cc13a,
    actions: {}
});
const $19939ed91be7a6ca$export$3e99e0b586e9bd20 = (0, $gg7kZ.createContainer)($19939ed91be7a6ca$var$store, {
    onInit: (0, $5p97Y.fetchInitialStatus)
});
const $19939ed91be7a6ca$export$cb0396e44d69a170 = (0, $3sQ5x.createStateHook)($19939ed91be7a6ca$var$store);
const $19939ed91be7a6ca$export$cb6873bd1bfb6e11 = (0, $3sQ5x.createStateHook)($19939ed91be7a6ca$var$store, {
    selector: ({ migrationStatus: migrationStatus })=>migrationStatus?.routeToTempeh ?? (0, $4R6GH.fg)('assets_reach_async_actions')
});

});
parcelRegister("5p97Y", function(module, exports) {

$parcel$export(module.exports, "fetchInitialStatus", () => $39f40488e196f050$export$888156f6db906499);

var $4SVEx = parcelRequire("4SVEx");
const $39f40488e196f050$export$888156f6db906499 = ()=>({ getState: getState, dispatch: dispatch })=>{
        if (!getState().loading && !getState().migrationStatus) dispatch((0, $4SVEx.fetchMigrationStatus)());
    };

});
parcelRegister("4SVEx", function(module, exports) {

$parcel$export(module.exports, "fetchMigrationStatus", () => $ed6f775339eeb639$export$7edd275ea1b9d090);

var $4VpwK = parcelRequire("4VpwK");

var $7GWvT = parcelRequire("7GWvT");

var $8zOmE = parcelRequire("8zOmE");

var $jcw0u = parcelRequire("jcw0u");
const $ed6f775339eeb639$export$f955a5fc47a6bbba = async (workspaceId)=>(0, $4VpwK.performCmdbGetRequest)((0, $7GWvT.getCmdbTempehMigrationUrl)(workspaceId));
const $ed6f775339eeb639$export$7edd275ea1b9d090 = ()=>async ({ setState: setState, getState: getState }, { workspaceId: workspaceId, createAnalyticsEvent: createAnalyticsEvent })=>{
        if (getState().loading) return;
        setState({
            loading: true
        });
        try {
            const { blockWriteTraffic: blockWriteTraffic, routeToTempeh: routeToTempeh } = await $ed6f775339eeb639$export$f955a5fc47a6bbba(workspaceId);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchMigrationStatus succeeded');
            setState({
                loading: false,
                migrationStatus: {
                    blockWriteTraffic: blockWriteTraffic,
                    routeToTempeh: routeToTempeh
                }
            });
        } catch (error) {
            const typedError = error instanceof Error ? error : undefined;
            // We intentionally don't use fireCmdbErrorAnalytics because it's dependent on this store
            (0, $jcw0u.default)({
                error: typedError,
                meta: {
                    id: 'fetchMigrationStatus',
                    packageName: 'jiraServicedeskCmdbArchitecture',
                    teamName: 'falcons'
                }
            });
            setState({
                loading: false,
                error: typedError
            });
        }
    };

});
parcelRegister("7GWvT", function(module, exports) {

$parcel$export(module.exports, "getCmdbTempehMigrationUrl", () => $41e879a212060f75$export$4699309ef0b4ff76);

var $klJ8b = parcelRequire("klJ8b");
const $41e879a212060f75$export$af33bbc68a181bd6 = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/tempeh`;
const $41e879a212060f75$export$4699309ef0b4ff76 = (workspaceId)=>`${$41e879a212060f75$export$af33bbc68a181bd6(workspaceId)}/migration`;

});






parcelRegister("6vorJ", function(module, exports) {

$parcel$export(module.exports, "InsightObjectViewPageContainer", () => $b02e6690ab3d160e$export$563df34e390de4da);

var $5uXOq = parcelRequire("5uXOq");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $8naTI = parcelRequire("8naTI");

var $5Ny9E = parcelRequire("5Ny9E");

var $8pMQX = parcelRequire("8pMQX");

var $cPB2u = parcelRequire("cPB2u");

var $bmKPg = parcelRequire("bmKPg");
var $2YP9W = parcelRequire("2YP9W");

var $5AkQz = parcelRequire("5AkQz");

const $b02e6690ab3d160e$export$563df34e390de4da = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: objectDetails, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $8naTI.insightObjectResource));
    const [objectId] = (0, $bmKPg.usePathParam)('objectId');
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPB2u.InsightObjectViewSkeleton), null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8pMQX.GenericError), null);
    return objectDetails && objectId != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $5AkQz.default).documentTitleCmdbAssets, {
            objectKey: objectDetails.objectKey,
            objectName: objectDetails.label
        })
    }), props.children({
        prefetchData: objectDetails,
        objectId: (0, $5Ny9E.toCmdbObjectId)(objectId)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPB2u.InsightObjectViewSkeleton), null);
};

});
parcelRegister("5AkQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed60758d5b76bc5f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ed60758d5b76bc5f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    documentTitleCmdbAssets: {
        "id": "spa-apps-servicedesk-cmdb-object-v2.document-title-cmdb-assets",
        "defaultMessage": "[{objectKey}] {objectName} - Assets"
    }
});

});


parcelRegister("9OmMD", function(module, exports) {

$parcel$export(module.exports, "FullPageObjectViewWrapper", () => $0ea0746b40b92356$export$600741490caab3b0);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $0ea0746b40b92356$var$fullPageObjectViewWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.200',
    marginRight: 'auto',
    marginBottom: 'space.0',
    marginLeft: 'auto'
});
const $0ea0746b40b92356$export$600741490caab3b0 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0ea0746b40b92356$var$fullPageObjectViewWrapperStyles
    }, children);

});



//# sourceMappingURL=async-assets-object-view-entrypoint.21f3af7a.js.map
